
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("38rnw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $da25534ccaede695$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5CSWr = parcelRequire("5CSWr");

var $gODaL = parcelRequire("gODaL");
var $b4Uvk = parcelRequire("b4Uvk");
var $aSTVt = parcelRequire("aSTVt");

var $c4MCf = parcelRequire("c4MCf");

var $eGLgs = parcelRequire("eGLgs");

var $2WDJ4 = parcelRequire("2WDJ4");

var $dF4Di = parcelRequire("dF4Di");

var $7CMCs = parcelRequire("7CMCs");

var $id7K0 = parcelRequire("id7K0");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $9NiTW = parcelRequire("9NiTW");

var $dZw8H = parcelRequire("dZw8H");

var $kB0io = parcelRequire("kB0io");

var $6Zx3E = parcelRequire("6Zx3E");

var $fqpSv = parcelRequire("fqpSv");

var $faEY1 = parcelRequire("faEY1");

var $7mFD7 = parcelRequire("7mFD7");

var $9H0Tc = parcelRequire("9H0Tc");

var $2iuw3 = parcelRequire("2iuw3");

var $ksftx = parcelRequire("ksftx");
const $da25534ccaede695$var$OnCallPage = ()=>{
    const helpPanelLink = (0, $5Zxxp.useHelpPanelLink)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [renderGetStartedTour, setRenderGetStartedTour] = (0, $5uXOq.useState)(false);
    const [renderRoutingRuleTour, setRenderRoutingRuleTour] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "eoc.on-call",
        packageName: "jiraEocOnCall",
        teamName: "tardis"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2WDJ4.GlobalContextContainer), {
        teamName: "tardis",
        packageName: "jiraEocOnCall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $6Zx3E.messages).title)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF4Di.ConsolidatedStateWrapper), {
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b4Uvk.Loading), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CSWr.Container), {
        clickHandler: helpPanelLink,
        links: (0, $kB0io.onCallLinks)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gODaL.OnCall), {
        onReady: ()=>setRenderGetStartedTour(true),
        onRoutingRuleModalOpen: ()=>setRenderRoutingRuleTour(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null), renderGetStartedTour && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_on_call_onboarding",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $faEY1.default), null)), renderRoutingRuleTour && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_on_call_routing_rules",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9H0Tc.RoutingRuleTour), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4MCf.SpotlightTrigger), {
        id: (0, $aSTVt.SPOTLIGHT_TOURS).rotationList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_on_call_schedule_list_rotation",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mFD7.ListRotationTour), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4MCf.SpotlightTrigger), {
        id: (0, $aSTVt.SPOTLIGHT_TOURS).rotationEdit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_on_call_schedule_rotation_edit",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqpSv.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4MCf.SpotlightTrigger), {
        id: (0, $aSTVt.SPOTLIGHT_TOURS).shiftTile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_on_call_schedule_tile_shift",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksftx.ShiftTileTour), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4MCf.SpotlightTrigger), {
        id: (0, $aSTVt.SPOTLIGHT_TOURS).scheduleActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_on_call_schedule_actions",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iuw3.ScheduleActionsTour), null))))))));
};
var $da25534ccaede695$export$2e2bcd8739ae039 = $da25534ccaede695$var$OnCallPage;

});
parcelRegister("5CSWr", function(module, exports) {

$parcel$export(module.exports, "Container", () => $ed5d957c8094ea69$export$42a852a2b6b56249);
$parcel$export(module.exports, "useActions", () => $ed5d957c8094ea69$export$bc923229a7fa61e7);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $5WwZV = parcelRequire("5WwZV");
const $ed5d957c8094ea69$var$Store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $5WwZV.actions
});
const $ed5d957c8094ea69$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($ed5d957c8094ea69$var$Store);
const $ed5d957c8094ea69$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($ed5d957c8094ea69$var$Store);

});
parcelRegister("eW6Xc", function(module, exports) {

$parcel$export(module.exports, "createDefaultEocWrapper", () => $479853350fd92f18$export$a9264953429b0df);
$parcel$export(module.exports, "createContainer", () => $479853350fd92f18$export$26ae5ca175b4ec5a);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
/**
 * This component runs the useContainerHook with props that are sent from useSyncContainerProps.
 * We can use all features of react hooks inside here. Also, we created this component outside of
 * the createDefaultEocWrapper due to if we use this inside of the createDefaultEocWrapper,
 * it'll re-render on every child have changed.
 */ function $479853350fd92f18$var$InnerElement({ children: children, useContainerHook: useContainerHook, containerProps: containerProps }) {
    useContainerHook?.(containerProps);
    return children;
}
function $479853350fd92f18$export$a9264953429b0df({ useSyncContainerProps: useSyncContainerProps, useContainerHook: useContainerHook }) {
    return ({ children: children })=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(children)) {
            const containerProps = useSyncContainerProps ? useSyncContainerProps(children.props) : {};
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(children, {
                ...children.props,
                ...containerProps
            }, useContainerHook ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($479853350fd92f18$var$InnerElement, {
                useContainerHook: useContainerHook,
                containerProps: containerProps
            }, children.props.children) : children.props.children);
        }
        return null;
    };
}
const $479853350fd92f18$export$26ae5ca175b4ec5a = (store, options)=>{
    const OriginalContainer = (0, $gg7kZ.createContainer)(store, {
        ...options
    });
    const HOC = ({ ...props })=>{
        return options?.Wrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(options.Wrapper, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OriginalContainer, props, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OriginalContainer, props, props.children);
    };
    HOC.displayName = OriginalContainer.displayName + '-HOC'; // To track if error occure because of HOC
    return HOC;
};

});

parcelRegister("5WwZV", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f8f2b378390bc8e0$export$e324594224ef24da);
const $f8f2b378390bc8e0$var$handleClick = (id)=>({}, { clickHandler: clickHandler, links: links })=>{
        if (!links[id]) return;
        const { iphId: iphId, sacUrl: sacUrl } = links[id];
        if (typeof clickHandler !== 'undefined') return clickHandler(iphId);
        window.open(sacUrl, '_blank');
    };
const $f8f2b378390bc8e0$export$e324594224ef24da = {
    handleClick: $f8f2b378390bc8e0$var$handleClick
};

});


parcelRegister("gODaL", function(module, exports) {

$parcel$export(module.exports, "OnCall", () => $005cd675c133733f$export$8a0b8259c9559485);

var $5uXOq = parcelRequire("5uXOq");

var $gIuON = parcelRequire("gIuON");

var $jxRF2 = parcelRequire("jxRF2");

var $8SpRt = parcelRequire("8SpRt");

var $hem2I = parcelRequire("hem2I");

var $dmLt8 = parcelRequire("dmLt8");

var $6RRyp = parcelRequire("6RRyp");

var $iufIe = parcelRequire("iufIe");

var $5b0RU = parcelRequire("5b0RU");

var $b4Uvk = parcelRequire("b4Uvk");

var $3551N = parcelRequire("3551N");
const $005cd675c133733f$export$8a0b8259c9559485 = ({ onReady: onReady, onRoutingRuleModalOpen: onRoutingRuleModalOpen })=>{
    const { loading: getTeamLoading, error: getTeamError } = (0, $hem2I.default)((0, $iufIe.getTeamResource));
    const { loading: getScheduleRightsLoading, error: getScheduleRightsError } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const { loading: getSchedulesLoading, error: getSchedulesError } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { loading: getUiPreferencesLoading, error: getUiPreferencesError } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { loading: getScheduleTimeTemplatesLoading, error: getScheduleTimeTemplatesError } = (0, $hem2I.default)((0, $6RRyp.getScheduleTimeTemplatesResource));
    const { loading: eocUserLoading, error: eocUserError } = (0, $hem2I.default)((0, $jxRF2.eocUserResource));
    const { loading: routingRulesLoading, error: routingRulesError } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    const { loading: getTimezonesLoading, error: getTimezonesError } = (0, $hem2I.default)((0, $dmLt8.getTimezonesResource));
    const isError = getTeamError || getScheduleRightsError || getSchedulesError || getUiPreferencesError || getScheduleTimeTemplatesError || eocUserError || routingRulesError || getTimezonesError;
    const isLoading = getTeamLoading || getScheduleRightsLoading || getSchedulesLoading || getUiPreferencesLoading || getScheduleTimeTemplatesLoading || eocUserLoading || routingRulesLoading || getTimezonesLoading;
    if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5b0RU.Error), null);
    if (isLoading || (0, $gIuON.isServer)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b4Uvk.Loading), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3551N.OnCallPage), {
        onReady: onReady,
        onRoutingRuleModalOpen: onRoutingRuleModalOpen
    });
};

});
parcelRegister("hem2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0b5f2d38c9a8bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");

var $gIuON = parcelRequire("gIuON");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
const $bf0b5f2d38c9a8bd$var$useEocResource = (routeResource, options)=>{
    const reporter = (0, $cQDa6.useReportError)();
    const resource = (0, $2YP9W.useResource)(routeResource, options);
    const { error: error } = resource;
    (0, $5uXOq.useEffect)(()=>{
        if (!error) return;
        const id = routeResource.type;
        if ((0, $gIuON.isServer)() || (0, $aI12f.isNetworkError)(error)) reporter(id, error);
        else throw new (0, $8tpNZ.EocError)(id, error);
    }, [
        error,
        reporter,
        routeResource.type
    ]);
    // User always responsible for rendering an appropriate error view on jsx.
    // Thus, we return RouteResource at the end.
    // Also, it is default behaviour if there is no error.
    return resource;
};
var $bf0b5f2d38c9a8bd$export$2e2bcd8739ae039 = $bf0b5f2d38c9a8bd$var$useEocResource;

});
parcelRegister("8tpNZ", function(module, exports) {

$parcel$export(module.exports, "EocError", () => $d534eb2e187b068b$export$e76fc0e0bc06f4df);
function $d534eb2e187b068b$var$hasMessage(cause) {
    return typeof cause === 'object' && cause !== null && 'message' in cause;
}
class $d534eb2e187b068b$export$e76fc0e0bc06f4df extends Error {
    constructor(id, cause){
        super(`[${id}] ${$d534eb2e187b068b$var$hasMessage(cause) ? cause.message : cause}`), this.id = id, this.cause = cause;
        this.name = 'EocError';
    }
}

});

parcelRegister("cQDa6", function(module, exports) {

$parcel$export(module.exports, "useReportError", () => $c58a665a3c6a26b3$export$5a5695b638d078e7);

var $5uXOq = parcelRequire("5uXOq");

var $aI12f = parcelRequire("aI12f");

var $74BDp = parcelRequire("74BDp");
function $c58a665a3c6a26b3$export$cad78388f408899e(error) {
    if (!(0, $aI12f.isNetworkError)(error)) return true;
    return !(0, $aI12f.isHTTPError)(error);
}
const $c58a665a3c6a26b3$export$5a5695b638d078e7 = ()=>{
    const { reporterAction: reporterAction } = (0, $74BDp.useGlobalContextActions)();
    return (0, $5uXOq.useMemo)(()=>(id, error, attributes)=>{
            if (!$c58a665a3c6a26b3$export$cad78388f408899e(error)) return;
            reporterAction({
                id: id,
                error: error,
                attributes: attributes
            });
        }, [
        reporterAction
    ]);
};

});
parcelRegister("74BDp", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $aca7a4d9aea0d818$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $aca7a4d9aea0d818$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useSendMessage", () => $aca7a4d9aea0d818$export$fe8707b58c509543);
$parcel$export(module.exports, "useGlobalContextActions", () => $aca7a4d9aea0d818$export$8a9eff51cb8da29e);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $bMb9B = parcelRequire("bMb9B");
const $aca7a4d9aea0d818$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $bMb9B
});
const $aca7a4d9aea0d818$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca7a4d9aea0d818$var$OriginalGlobalContextContainer, {
        config: config,
        reporter: reporter,
        isGlobal: true,
        flagService: flagService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        locale: locale,
        messages: messages && messages[locale]
    }, children));
};
const $aca7a4d9aea0d818$var$OriginalGlobalContextContainer = (0, $gg7kZ.createContainer)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        },
    onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        }
});
const $aca7a4d9aea0d818$export$2041a7a7b51b1fce = (0, $51nlc.createSubscriber)($aca7a4d9aea0d818$export$390f32400eaf98c9);
const $aca7a4d9aea0d818$export$6b9ad8a324c94098 = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $aca7a4d9aea0d818$export$fe8707b58c509543 = (handlerClass)=>{
    const [{ handler: handler, context: context }] = $aca7a4d9aea0d818$var$useSendMessageInternal(handlerClass);
    return (params)=>{
        return handler(params, context);
    };
};
const $aca7a4d9aea0d818$var$useSendMessageInternal = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state, arg)=>{
        if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
            handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
            context: state.config.context
        };
        throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
    }
});
const $aca7a4d9aea0d818$export$8a9eff51cb8da29e = (0, $3sQ5x.createActionsHook)($aca7a4d9aea0d818$export$390f32400eaf98c9);

});
parcelRegister("bMb9B", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $3a0e18e647f4c498$export$f3910000817a36c2);
$parcel$export(module.exports, "getHorizontalNav", () => $3a0e18e647f4c498$export$7c79a3553de2e8e7);
const $3a0e18e647f4c498$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };
const $3a0e18e647f4c498$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
        return config?.isNewNavigation || false;
    };

});




parcelRegister("5b0RU", function(module, exports) {

$parcel$export(module.exports, "Error", () => $4a756314d7eb06cc$export$edf27be85e5f6da0);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $jxRF2 = parcelRequire("jxRF2");

var $8SpRt = parcelRequire("8SpRt");

var $hem2I = parcelRequire("hem2I");

var $6RRyp = parcelRequire("6RRyp");

var $iufIe = parcelRequire("iufIe");

var $9ho7j = parcelRequire("9ho7j");

var $gfPCm = parcelRequire("gfPCm");
const $4a756314d7eb06cc$export$edf27be85e5f6da0 = ()=>{
    const intlApi = (0, $koVbs.default)();
    const { refresh: getTeamRefresh, error: getTeamError } = (0, $hem2I.default)((0, $iufIe.getTeamResource));
    const { refresh: getScheduleTimeTemplatesRefresh, error: getScheduleTimeTemplatesError } = (0, $hem2I.default)((0, $6RRyp.getScheduleTimeTemplatesResource));
    const { refresh: getScheduleRightsRefresh, error: getScheduleRightsError } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const { refresh: getSchedulesRefresh, error: getSchedulesError } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { refresh: getUiPreferencesRefresh, error: getUiPreferencesError } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { refresh: eocUserRefresh, error: eocUserError } = (0, $hem2I.default)((0, $jxRF2.eocUserResource));
    const { refresh: routingRulesRefresh, error: routingRulesError } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        description: intlApi.formatMessage((0, $gfPCm.messages).errorDescription),
        header: intlApi.formatMessage((0, $gfPCm.messages).errorTitle),
        imageHeight: 250,
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ho7j.ErrorImage), null),
        imageWidth: 250,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            onClick: ()=>{
                getTeamError && getTeamRefresh();
                getScheduleRightsError && getScheduleRightsRefresh();
                getSchedulesError && getSchedulesRefresh();
                getUiPreferencesError && getUiPreferencesRefresh();
                getScheduleTimeTemplatesError && getScheduleTimeTemplatesRefresh();
                eocUserError && eocUserRefresh();
                routingRulesError && routingRulesRefresh();
            }
        }, intlApi.formatMessage((0, $gfPCm.messages).tryAgain))
    });
};

});
parcelRegister("9ho7j", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", () => $2d4fe4ffddc933f1$export$7326e6d938a8137b);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");
const $2d4fe4ffddc933f1$export$7326e6d938a8137b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        fill: "none",
        viewBox: ".02 0 234.96 210.11",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: '230px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        transform: "translate(.024902)",
        width: "234.95",
        height: "210.11",
        fill: "#fff",
        fillOpacity: ".01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m179.68 165.78v-13.28h23.37v-13.29h26.21v-13.29h-26.21v-87.18h-38.73v-38.74h-123.72v44.85h28.74v13.29h-65.16v13.29h22.32v13.29h32.67v13.28h-59.14v13.29h40.57v98.82h162.45v-17.75h-48.22v-13.29h80.16v-13.29h-55.31zm-60.81-108.43c6.29 0 11.31 5.27 11 11.55l-2.53 51.01c-0.22 4.51-3.95 8.06-8.47 8.06s-8.24-3.54-8.47-8.06l-2.53-51.01c-0.31-6.28 4.7-11.55 11-11.55zm0 98.33c-5.72 0-10.36-4.64-10.36-10.36s4.64-10.36 10.36-10.36 10.36 4.64 10.36 10.36-4.64 10.36-10.36 10.36z",
        fill: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m164.58 59.32 38.2-20.58h-38.2v20.58z",
        fill: "url(#a)",
        opacity: ".6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m203.04 38.71h-0.03l0.03 0.03v-0.03z",
        fill: "#E7E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m164.58 59.32 38.2-20.58h-38.2v20.58z",
        fill: "url(#a)",
        opacity: ".6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m164.58 38.74h38.47l-38.74-38.74v38.74h0.27z",
        fill: "#EBECF0",
        opacity: ".2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "b",
        x1: "28.905",
        x2: "195.81",
        y1: "198.42",
        y2: "31.511",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#C1C7D0",
        offset: ".0977"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#EBECF0",
        stopOpacity: ".5",
        offset: "1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "a",
        x1: "163.84",
        x2: "204.24",
        y1: "58.581",
        y2: "18.173",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#A5ADBA",
        stopOpacity: "0",
        offset: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#A5ADBA",
        offset: "1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        transform: "translate(.024902)",
        width: "234.95",
        height: "210.11",
        fill: "#fff"
    }))));
};

});

parcelRegister("gfPCm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6c0dee5197d1e2e7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6c0dee5197d1e2e7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tryAgain: {
        id: 'eoc-on-call.ui.error.try-again',
        defaultMessage: 'Try again',
        description: 'Try again button.'
    },
    errorTitle: {
        id: 'eoc-on-call.ui.error.error-title',
        defaultMessage: "We're having some problem",
        description: 'On-call error title.'
    },
    errorDescription: {
        id: 'eoc-on-call.ui.error.error-description',
        defaultMessage: 'We are unable to fetch your team at this time.',
        description: 'On-call error description.'
    }
});

});


parcelRegister("b4Uvk", function(module, exports) {

$parcel$export(module.exports, "Loading", () => $9c6e8c4afb3dc20b$export$669f6ea7d267feaf);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $1JB21 = parcelRequire("1JB21");

var $8icyj = parcelRequire("8icyj");
const $9c6e8c4afb3dc20b$var$items = [
    {
        key: 'routing-rules',
        headerWidth: 22,
        sectionHeight: 8
    },
    {
        key: 'escalation-policies',
        headerWidth: 28,
        sectionHeight: 12.5
    },
    {
        key: 'schedule',
        headerWidth: 18,
        sectionHeight: 17.5
    }
];
const $9c6e8c4afb3dc20b$var$oldContainerStyles = (0, $8CUq3.xcss)({
    margin: '0 auto',
    maxWidth: '1280px',
    padding: 'space.300'
});
const $9c6e8c4afb3dc20b$var$containerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300'
});
const $9c6e8c4afb3dc20b$export$669f6ea7d267feaf = ()=>{
    const isHorizontalNav = (0, $1JB21.useIsNewNavigation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            isHorizontalNav ? $9c6e8c4afb3dc20b$var$containerStyles : $9c6e8c4afb3dc20b$var$oldContainerStyles
        ],
        direction: "column",
        rowGap: "space.600"
    }, $9c6e8c4afb3dc20b$var$items.map(({ key: key, headerWidth: headerWidth, sectionHeight: sectionHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            key: key,
            direction: "column",
            rowGap: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            columnGap: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            variant: "line",
            height: 3,
            width: headerWidth
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            variant: "circle",
            height: 3,
            width: 3
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            variant: "square",
            height: 3,
            width: 3
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            variant: "line",
            height: sectionHeight,
            width: "100%"
        }))));
};

});
parcelRegister("1JB21", function(module, exports) {

$parcel$export(module.exports, "useIsNewNavigation", () => $8a123ed33d4d2eb9$export$b78431fea1079e74);

var $74BDp = parcelRequire("74BDp");
const $8a123ed33d4d2eb9$export$b78431fea1079e74 = ()=>{
    const { getHorizontalNav: getHorizontalNav } = (0, $74BDp.useGlobalContextActions)();
    return getHorizontalNav?.() || false;
};

});

parcelRegister("8icyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c1f30f978a2dd2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $66W34 = parcelRequire("66W34");
const $35c1f30f978a2dd2$var$defaultDimensions = {
    line: [
        24,
        1.5
    ],
    circle: [
        3,
        3
    ],
    square: [
        3,
        3
    ]
};
const $35c1f30f978a2dd2$var$Skeleton = ({ width: width, height: height, variant: variant = 'line' })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $66W34.StyledWrapper), {
        variant: variant,
        dimensions: {
            width: width ?? $35c1f30f978a2dd2$var$defaultDimensions[variant][0],
            height: height ?? $35c1f30f978a2dd2$var$defaultDimensions[variant][1]
        },
        "data-testid": "eoc-skeleton"
    });
var $35c1f30f978a2dd2$export$2e2bcd8739ae039 = $35c1f30f978a2dd2$var$Skeleton;

});
parcelRegister("66W34", function(module, exports) {

$parcel$export(module.exports, "StyledWrapper", () => $9529eb8091350071$export$1f99da106a398c44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $9529eb8091350071$var$colors = {
    base: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
    shimmer: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`
};
/**
 * @param val specifies the dimension value before conversion
 * @returns the CSS value for dimension
 */ const $9529eb8091350071$var$getDimensionValue = (val)=>{
    return typeof val === 'string' ? val : `${(0, $k5uoT.gridSize)() * val}px`;
};
const $9529eb8091350071$var$waveKeyframes = (0, $f8Sb3.keyframes)({
    '0%': {
        backgroundPosition: '-400px 0'
    },
    '100%': {
        backgroundPosition: '400px 0'
    }
});
const $9529eb8091350071$export$1f99da106a398c44 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1s9j7ip0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ dimensions: dimensions })=>{
    return {
        display: 'block',
        backgroundColor: $9529eb8091350071$var$colors.base,
        background: `linear-gradient(to right, ${$9529eb8091350071$var$colors.base} 10%, ${$9529eb8091350071$var$colors.shimmer} 25%, ${$9529eb8091350071$var$colors.base} 40%)`,
        backgroundSize: '800px 64px',
        width: $9529eb8091350071$var$getDimensionValue(dimensions.width),
        height: $9529eb8091350071$var$getDimensionValue(dimensions.height),
        animation: `${$9529eb8091350071$var$waveKeyframes} 1.25s linear infinite forwards`,
        borderRadius: '4px',
        flexShrink: 0
    };
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ variant: variant })=>{
    if (variant === 'line') return {
        flexShrink: 1
    };
    if (variant === 'circle') return {
        borderRadius: '100%'
    };
});

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';




parcelRegister("3551N", function(module, exports) {

$parcel$export(module.exports, "OnCallPage", () => $e02765d29ff05f90$export$465872b10cb08e64);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ujWmd = parcelRequire("ujWmd");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $257hY = parcelRequire("257hY");

var $1JB21 = parcelRequire("1JB21");

var $deiCC = parcelRequire("deiCC");

var $hem2I = parcelRequire("hem2I");

var $jZP9x = parcelRequire("jZP9x");
var $aSTVt = parcelRequire("aSTVt");

var $6RRyp = parcelRequire("6RRyp");

var $j0DLp = parcelRequire("j0DLp");

var $iufIe = parcelRequire("iufIe");

var $1Nrg3 = parcelRequire("1Nrg3");
const $e02765d29ff05f90$var$DEFAULT_HEIGHT_OFFSET = 80;
const $e02765d29ff05f90$var$oldContainerStyles = (0, $8CUq3.xcss)({
    margin: '0 auto',
    maxWidth: '1280px',
    padding: 'space.300'
});
const $e02765d29ff05f90$var$containerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300'
});
const $e02765d29ff05f90$var$innerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.400'
});
const $e02765d29ff05f90$export$465872b10cb08e64 = ({ onReady: onReady, onRoutingRuleModalOpen: onRoutingRuleModalOpen })=>{
    const intlApi = (0, $koVbs.default)();
    const { data: team } = (0, $hem2I.default)((0, $iufIe.getTeamResource));
    const { data: getSchedulesData } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { trigger: trigger } = (0, $j0DLp.useActions)();
    const teamName = team?.values[0]?.name || '';
    const teamId = team?.values[0]?.atlassianIdentifier || '';
    const teamAvatar = team?.values[0]?.avatarUrl || undefined;
    (0, $5uXOq.useEffect)(()=>{
        if (onReady) onReady();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        trigger((0, $aSTVt.SPOTLIGHT_TOURS).scheduleActions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollToSchedule = (0, $5uXOq.useCallback)(()=>{
        const schedule = document.getElementById(location.hash.substring(1));
        if (schedule) {
            schedule.focus();
            window.scrollTo({
                behavior: 'auto',
                top: schedule.getBoundingClientRect().top - document.body.getBoundingClientRect().top - $e02765d29ff05f90$var$DEFAULT_HEIGHT_OFFSET
            });
        }
    }, []);
    const isHorizontalNav = (0, $1JB21.useIsNewNavigation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: isHorizontalNav ? $e02765d29ff05f90$var$containerStyles : $e02765d29ff05f90$var$oldContainerStyles
    }, !isHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: intlApi.formatMessage((0, $1Nrg3.messages).teams),
        href: "/jira/people/search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineEnd: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            appearance: "square",
            borderColor: "transparent",
            size: "xsmall",
            src: teamAvatar
        })),
        text: teamName,
        href: `/jira/people/team/${teamId}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h1",
        size: "large"
    }, intlApi.formatMessage((0, $1Nrg3.messages).onCall))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: !isHorizontalNav && $e02765d29ff05f90$var$innerStyles,
        direction: "column",
        rowGap: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $deiCC.default), {
        onRoutingRuleModalOpen: onRoutingRuleModalOpen,
        schedules: getSchedulesData?.schedules || []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $257hY.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZP9x.SchedulePage), {
        onSchedulesReady: scrollToSchedule
    })));
};

});
parcelRegister("257hY", function(module, exports) {

$parcel$export(module.exports, "default", () => $07ec9f3a18f68d46$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bmKPg = parcelRequire("bmKPg");

var $fNobW = parcelRequire("fNobW");

var $jkADf = parcelRequire("jkADf");

var $eoC0M = parcelRequire("eoC0M");

var $8SpRt = parcelRequire("8SpRt");

var $hem2I = parcelRequire("hem2I");

var $3tv2f = parcelRequire("3tv2f");
function $07ec9f3a18f68d46$export$2e2bcd8739ae039() {
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const { loading: loading, error: error } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "eoc-escalation-policies-loading"
    });
    if (error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jkADf.ContextWrapper), {
        tags: [
            'on-call',
            'escalation-policy',
            'team-escalations'
        ],
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        sourceName: "OnCall",
        objectId: teamId,
        objectType: "escalationPolicy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eoC0M.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tv2f.default), null)));
}

});
parcelRegister("jkADf", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $e64f0f96877c6709$export$34282a1f95511a11);

var $5uXOq = parcelRequire("5uXOq");

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");

var $daJ0i = parcelRequire("daJ0i");
const $e64f0f96877c6709$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $e64f0f96877c6709$export$34282a1f95511a11 = (props)=>{
    const data = $e64f0f96877c6709$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children));
};

});

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("eoC0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $7feb9746acf3ea52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $2tKfK = parcelRequire("2tKfK");

var $hEySk = parcelRequire("hEySk");
/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */ const $7feb9746acf3ea52$var$ResponderNamesWrapper = ({ scope: scope, isGlobal: isGlobal = true, children: children })=>{
    const flagApi = (0, $2tKfK.default)();
    const intl = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    if (scope) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEySk.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        scope: scope,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEySk.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        isGlobal: isGlobal,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper"
    }, children);
};
var $7feb9746acf3ea52$export$2e2bcd8739ae039 = $7feb9746acf3ea52$var$ResponderNamesWrapper;

});
parcelRegister("2VYEV", function(module, exports) {

$parcel$export(module.exports, "useDefaultCatch", () => $06138e726543d489$export$3ab31fcc1d7c2589);

var $5uXOq = parcelRequire("5uXOq");

var $kmpOn = parcelRequire("kmpOn");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
function $06138e726543d489$export$3ab31fcc1d7c2589() {
    const reportError = (0, $cQDa6.useReportError)();
    const [error, setError] = (0, $5uXOq.useState)();
    if (error) throw error;
    return (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kmpOn)))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
            if (!(0, $aI12f.isNetworkError)(error)) return setError(new (0, $8tpNZ.EocError)(id, error));
            if (customReporter !== null) {
                const reporter = customReporter ?? reportError;
                reporter(id, error, attributes);
            }
            try {
                return httpErrorHandler?.(error);
            } catch (handlerError) {
                if (!(0, $aI12f.isNetworkError)(handlerError)) setError(new (0, $8tpNZ.EocError)(id, handlerError));
                throw handlerError;
            }
        }), [
        reportError
    ]);
}

});
parcelRegister("kmpOn", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $g7JQw = parcelRequire("g7JQw");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $ed29e25cf476d3b2$var$curry = /*#__PURE__*/ $6CA7f(function curry(fn) {
    return $g7JQw(fn.length, fn);
});
module.exports = $ed29e25cf476d3b2$var$curry;

});
parcelRegister("6CA7f", function(module, exports) {

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $4d224e922cc0a345$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $dtL0L(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $4d224e922cc0a345$var$_curry1;

});
parcelRegister("dtL0L", function(module, exports) {
function $9d027343e6afec73$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $9d027343e6afec73$var$_isPlaceholder;

});


parcelRegister("g7JQw", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $6CA7f = parcelRequire("6CA7f");

var $18myW = parcelRequire("18myW");

var $90GZI = parcelRequire("90GZI");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $bbd0dce5f5e12876$var$curryN = /*#__PURE__*/ $18myW(function curryN(length, fn) {
    if (length === 1) return $6CA7f(fn);
    return $dxgtl(length, $90GZI(length, [], fn));
});
module.exports = $bbd0dce5f5e12876$var$curryN;

});
parcelRegister("dxgtl", function(module, exports) {
function $9dab227b64b88e13$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $9dab227b64b88e13$var$_arity;

});

parcelRegister("18myW", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $0d380a4094fa43af$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $dtL0L(a) ? f2 : $6CA7f(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $dtL0L(a) && $dtL0L(b) ? f2 : $dtL0L(a) ? $6CA7f(function(_a) {
                    return fn(_a, b);
                }) : $dtL0L(b) ? $6CA7f(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $0d380a4094fa43af$var$_curry2;

});

parcelRegister("90GZI", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $01b160e2e45af68a$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$dtL0L(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$dtL0L(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $dxgtl(left, $01b160e2e45af68a$var$_curryN(length, combined, fn));
    };
}
module.exports = $01b160e2e45af68a$var$_curryN;

});




parcelRegister("2tKfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c357df09fe3f96fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");
var $bKCvK = parcelRequire("bKCvK");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $74BDp = parcelRequire("74BDp");
const $c357df09fe3f96fe$var$useFlags = ()=>{
    const [flagService] = (0, $74BDp.useExternalFlagService)();
    const serviceRef = (0, $5uXOq.useRef)(flagService);
    (0, $hmVmJ.assert)(!serviceRef.current || !!flagService, new (0, $dH6Pi.AssertionError)('GlobalContext', 'flagService was destroyed.'));
    return serviceRef.current !== undefined ? {
        showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
            const Component = ({ id: id, onDismissed: onDismissed })=>{
                if (isAutoDismiss) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWXJB.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epfFv.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
            };
            const id = (0, $7Jxgt.v4)();
            Component.id = id;
            serviceRef.current.showFlag(Component);
            return ()=>{
                serviceRef.current.dismissFlag({
                    id: id,
                    command: 'DISMISS'
                });
            };
        }
    } : //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bKCvK.useFlags)();
};
var $c357df09fe3f96fe$export$2e2bcd8739ae039 = $c357df09fe3f96fe$var$useFlags;

});

parcelRegister("hEySk", function(module, exports) {

$parcel$export(module.exports, "ResponderNamesContainer", () => $6d57183bc999b4da$export$ae46960d51ae2b7);
$parcel$export(module.exports, "useResponderNamesStore", () => $6d57183bc999b4da$export$d2c212d52c0e4d25);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $eIMZo = parcelRequire("eIMZo");

var $jF6Os = parcelRequire("jF6Os");
const $6d57183bc999b4da$export$cd391a137954b857 = (0, $iXqE5.createStore)({
    initialState: (0, $jF6Os.initialState),
    actions: $eIMZo.actions,
    name: 'ResponderNamesStore'
});
const $6d57183bc999b4da$export$ae46960d51ae2b7 = (0, $gg7kZ.createContainer)($6d57183bc999b4da$export$cd391a137954b857);
const $6d57183bc999b4da$export$d2c212d52c0e4d25 = (0, $3sQ5x.createHook)($6d57183bc999b4da$export$cd391a137954b857);

});
parcelRegister("eIMZo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $00dbd40d3cd5db38$export$e324594224ef24da);

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $c3dSt = parcelRequire("c3dSt");

var $6DiJG = parcelRequire("6DiJG");

var $c8qzg = parcelRequire("c8qzg");
const $00dbd40d3cd5db38$var$fetchResponders = (missingResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        const { responders: responders } = getState();
        if (!Object.keys(missingResponders).length) return Promise.resolve();
        const errorItems = (0, $c3dSt.mapErrorForResponder)(missingResponders);
        setState({
            responders: {
                ...responders,
                ...missingResponders
            }
        });
        //TODO: How to handle if BE returns [], what will be the behaviour?
        return (0, $6DiJG.getResponderNames)(Object.values(missingResponders).map(({ id: id, type: type })=>({
                id: id,
                type: type
            }))).then((response)=>{
            const responseMap = response.values.map((r)=>({
                    isError: false,
                    isLoading: false,
                    acknowledged: true,
                    ...r
                })).reduce((acc, r)=>{
                acc[r.id] = r;
                return acc;
            }, {});
            const responderItemMap = Object.keys(missingResponders).reduce((acc, key)=>{
                const itemByEmail = Object.values(responseMap).find((res)=>res.email === key);
                if (itemByEmail) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByEmail
                    };
                    return acc;
                }
                const itemByAtlassianIdentifier = Object.values(responseMap).find((res)=>res.atlassianIdentifier === key);
                if (itemByAtlassianIdentifier) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByAtlassianIdentifier
                    };
                    return acc;
                }
                acc[key] = {
                    ...errorItems[key],
                    ...responseMap[key]
                };
                return acc;
            }, {});
            setState({
                responders: {
                    ...getState().responders,
                    ...responderItemMap
                }
            });
        }).catch(defaultCatch({
            id: 'fetchResponders',
            httpErrorHandler: ()=>{
                //Retry will be shown on the toast message
                const dismiss = flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    title: intlApi.formatMessage((0, $c8qzg.messages).fetchError),
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: intlApi.formatMessage((0, $c8qzg.messages).retry),
                            onClick: ()=>{
                                dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
                                dismiss();
                            }
                        }
                    ]
                });
                const responders = Object.assign({}, getState().responders, errorItems);
                setState({
                    responders: responders
                });
            }
        }));
    };
/**
 * It takes missingResponders and updates the store with additional parameters
 * when it is called on the useResponderNames() hook.
 * It sets isLoading to true for every responder item.
 * This function is implemented to batch requests coming from different components.
 */ const $00dbd40d3cd5db38$var$batchResponders = (requestedResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { displayName: displayName })=>{
        (0, $hmVmJ.assert)(displayName === 'ResponderNamesWrapper', new (0, $dH6Pi.AssertionError)('useResponderNames', 'Unable to find ResponderNamesWrapper'));
        const missingResponders = requestedResponders.filter((responder)=>!getState().responders[responder.id]);
        if (!missingResponders.length) return;
        const requestedRespondersMap = requestedResponders.reduce((acc, r)=>{
            acc[r.id] = {
                id: r.id,
                type: r.type,
                acknowledged: false,
                isError: false,
                isLoading: true
            };
            return acc;
        }, {});
        const existingResponders = getState().responders;
        const allResponderIds = [
            ...Object.keys(existingResponders),
            ...Object.keys(requestedRespondersMap)
        ];
        const allResponders = allResponderIds.reduce((acc, key)=>{
            acc[key] = {
                ...requestedRespondersMap[key],
                ...existingResponders[key]
            };
            return acc;
        }, {});
        setState({
            responders: allResponders
        });
        const timeoutState = getState().timeout;
        if (timeoutState !== undefined) clearTimeout(timeoutState);
        //It debounces the requested responders(batching)
        const timeout = setTimeout(()=>{
            const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value])=>(0, $c3dSt.isNotLoaded)(value)).map(([key, value])=>[
                    key,
                    {
                        ...value,
                        acknowledged: true
                    }
                ]));
            if (Object.keys(missingResponders).length) dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
        }, 10);
        setState({
            timeout: timeout
        });
    };
const $00dbd40d3cd5db38$export$e324594224ef24da = {
    fetchResponders: $00dbd40d3cd5db38$var$fetchResponders,
    batchResponders: $00dbd40d3cd5db38$var$batchResponders
};

});
parcelRegister("8eCQi", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $06a51a880a3faae2$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $06a51a880a3faae2$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $06a51a880a3faae2$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $06a51a880a3faae2$export$b56198a940066d8f);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");


var $2bUsm = parcelRequire("2bUsm");
const $06a51a880a3faae2$var$ErrorWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).error)
    }));
const $06a51a880a3faae2$var$WarningWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).warning)
    }));
const $06a51a880a3faae2$var$InfoWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).info)
    }));
const $06a51a880a3faae2$var$SuccessWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).success)
    }));
const $06a51a880a3faae2$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$WarningWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$InfoWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
parcelRegister("1jWct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f64b62884a9bedb$var$InformationIcon = (props)=>/*#__PURE__*/ $0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
    }, props));
$0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;

});

parcelRegister("c2i4s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c33b074f80a91d5$var$SuccessIcon = (props)=>/*#__PURE__*/ $8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
    }, props));
$8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;

});

parcelRegister("2bUsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7145ce6f0cfaef60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7145ce6f0cfaef60$var$messages = (0, $7VHMR.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $7145ce6f0cfaef60$export$2e2bcd8739ae039 = $7145ce6f0cfaef60$var$messages;

});


parcelRegister("c3dSt", function(module, exports) {

$parcel$export(module.exports, "mapErrorForResponder", () => $f99f931354012934$export$245cebe8a9527ff0);
$parcel$export(module.exports, "isNotLoaded", () => $f99f931354012934$export$ea78f980ad0c92fe);
const $f99f931354012934$export$245cebe8a9527ff0 = (requestedResponders)=>Object.entries(requestedResponders).reduce((acc, [key, value])=>{
        acc[key] = {
            id: value.id,
            type: value.type,
            isError: true,
            acknowledged: true,
            isLoading: false
        };
        return acc;
    }, {});
const $f99f931354012934$export$ea78f980ad0c92fe = (responder)=>!Boolean(responder?.isError) && !Boolean(responder?.acknowledged);

});

parcelRegister("6DiJG", function(module, exports) {

$parcel$export(module.exports, "getResponderNames", () => $721598a63b2bde28$export$7345ec3bad54e226);

var $j74qU = parcelRequire("j74qU");
const $721598a63b2bde28$export$7345ec3bad54e226 = (requestedResponders)=>{
    const responders = requestedResponders.reduce((acc, curr)=>{
        // any is intentional here we don't want to add
        // unknown to the ResponderType because we don't want it to be public
        if (curr.type === 'unknown') return [
            ...acc,
            {
                id: curr.id,
                type: 'schedule'
            },
            {
                id: curr.id,
                type: 'user'
            },
            {
                id: curr.id,
                type: 'team'
            },
            {
                id: curr.id,
                type: 'escalation'
            }
        ];
        return [
            ...acc,
            curr
        ];
    }, []);
    return (0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: responders
        }
    });
};

});

parcelRegister("c8qzg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $43634ee9e12c5e07$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $43634ee9e12c5e07$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fetchError: {
        id: `eoc.responder-names-fetch-error`,
        defaultMessage: "We couldn't fetch the responder names.",
        description: 'The text will be displayed when there is error'
    },
    retry: {
        id: `eoc.responder-names-retry`,
        defaultMessage: 'Retry',
        description: 'The title for retry as a single word.'
    }
});

});


parcelRegister("jF6Os", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f657b42bad68e54a$export$d4c72bab9d6cc13a);
const $f657b42bad68e54a$export$d4c72bab9d6cc13a = {
    responders: {}
};

});



parcelRegister("3tv2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c240d8e101882299$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $16T6Y = parcelRequire("16T6Y");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $faod6 = parcelRequire("faod6");

var $6tRzQ = parcelRequire("6tRzQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $92Z2l = parcelRequire("92Z2l");

var $3bDjY = parcelRequire("3bDjY");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $dY87H = parcelRequire("dY87H");

var $fXc9u = parcelRequire("fXc9u");

var $8SpRt = parcelRequire("8SpRt");

var $hem2I = parcelRequire("hem2I");

var $k97LS = parcelRequire("k97LS");

var $kugKu = parcelRequire("kugKu");

var $ce4pa = parcelRequire("ce4pa");
var $dnjeJ = parcelRequire("dnjeJ");

var $cBr4z = parcelRequire("cBr4z");

var $2oYbN = parcelRequire("2oYbN");

var $dliR8 = parcelRequire("dliR8");

var $kGpyt = parcelRequire("kGpyt");

var $awRwA = parcelRequire("awRwA");

var $aLwrv = parcelRequire("aLwrv");

var $hCQkL = parcelRequire("hCQkL");

var $jdfFk = parcelRequire("jdfFk");

var $iUMPA = parcelRequire("iUMPA");
const $c240d8e101882299$var$FirstEntitySpotlight = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $cBr4z.SPOTLIGHT_NAMES).firstEntity
    }, children);
function $c240d8e101882299$export$2e2bcd8739ae039() {
    (0, $dnjeJ.useUFOComponentExperience)((0, $2oYbN.escalationPoliciesLoadExperience));
    const { data: data } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('EscalationPolicies', 'data should be fetched if there is no loading and error'));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { editingData: editingData, editingId: editingId, isChangeStateModalOpen: isChangeStateModalOpen, isCloning: isCloning, isCreating: isCreating, isDeleteModalOpen: isDeleteModalOpen, isDeleting: isDeleting, isEscalationPolicyModalOpen: isEscalationPolicyModalOpen, isUpdating: isUpdating, isPartiallyUpdating: isPartiallyUpdating, closeDeleteModal: closeDeleteModal, closeEscalationPolicyModal: closeEscalationPolicyModal, closeChangeStateModal: closeChangeStateModal, handleChangeStateClick: handleChangeStateClick, handleChangeState: handleChangeState, handleCollapseStatusChange: handleCollapseStatusChange, handleCloneClick: handleCloneClick, handleDeleteClick: handleDeleteClick, handleDelete: handleDelete, handleEditClick: handleEditClick, handleFormSubmit: handleFormSubmit, handleOrderChange: handleOrderChange, openEscalationPolicyModal: openEscalationPolicyModal, toggleSection: toggleSection } = (0, $aLwrv.useTeamEscalationsController)();
    const { escalations: { collapsed: collapsed, entities: entities, availableNotifyTypes: availableNotifyTypes, hasEditRight: hasEditRight, hasDeleteRight: hasDeleteRight, hasRepeatRight: hasRepeatRight } } = data;
    const requestedResponders = entities.flatMap((entity)=>entity.rules).map((rule)=>({
            id: rule.notifyId,
            type: rule.type
        })).filter((v, i, a)=>a.findIndex((v2)=>v2.id === v.id) === i);
    const escalationNames = [
        ...new Set(entities.map(({ name: name })=>name))
    ];
    (0, $fXc9u.useResponderNames)(requestedResponders);
    const isLimit = entities.length === 300;
    const isEmpty = entities.length === 0;
    (0, $k97LS.useMonitorRuleCards)({
        droppableId: 'escalation-policies',
        data: entities,
        onComplete: ({ updatedValue: updatedValue, targetIndex: targetIndex, sourceId: sourceId })=>handleOrderChange(updatedValue, targetIndex, sourceId)
    });
    const createPolicyButtonRef = (0, $5uXOq.useRef)(null);
    const createPolicyEmptyStateButtonRef = (0, $5uXOq.useRef)(null);
    const ruleActionButtonRefs = (0, $5uXOq.useRef)({});
    const [returnFocusRef, setReturnFocusRef] = (0, $5uXOq.useState)(undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce4pa.ExperienceSuccess), {
        experience: (0, $2oYbN.escalationPoliciesLoadExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kugKu.Section), {
        isOpen: !collapsed,
        onClick: toggleSection,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUMPA.TitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            as: "h2",
            size: "medium"
        }, formatMessage((0, $jdfFk.default).title)), data.escalations.entities.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            testId: "escalation-policies-entity-count-badge",
            max: 300
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "aria-hidden": "true"
        }, data.escalations.entities.length)), isLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $jdfFk.default).maxPolicy)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
            color: "currentColor",
            spacing: "spacious",
            label: formatMessage((0, $jdfFk.default).maxPolicy)
        })))),
        actions: hasEditRight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $jdfFk.default).add)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: formatMessage((0, $jdfFk.default).add),
            onClick: (e)=>{
                setReturnFocusRef(createPolicyButtonRef);
                e.stopPropagation();
                openEscalationPolicyModal();
            },
            isDisabled: isLimit,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($faod6))),
            ref: createPolicyButtonRef
        })) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUMPA.SectionContent), null, isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        // SectionMessageAction doesn't accept a ref prop. Therefore, we use a button directly.
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
                // https://product-fabric.atlassian.net/browse/DSP-19033
                appearance: "link",
                spacing: "none",
                onClick: ()=>{
                    setReturnFocusRef(createPolicyEmptyStateButtonRef);
                    return openEscalationPolicyModal();
                },
                ref: createPolicyEmptyStateButtonRef
            }, formatMessage((0, $jdfFk.default).emptyAdd))
        ]
    }, formatMessage((0, $jdfFk.default).empty)), !isEmpty && entities.map((entity, i)=>{
        const Wrapper = i === 0 ? $c240d8e101882299$var$FirstEntitySpotlight : (0, $5uXOq.Fragment);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            key: entity.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUMPA.RuleCardContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCQkL.EscalationRules), {
            entity: entity,
            shouldShowSpinner: editingId === entity.id && (isPartiallyUpdating || isDeleting),
            hasDeleteRight: hasDeleteRight,
            hasEditRight: hasEditRight,
            onClone: ()=>{
                setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                return handleCloneClick(entity);
            },
            onDelete: ()=>{
                setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                return handleDeleteClick(entity);
            },
            onEdit: ()=>{
                setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                return handleEditClick(entity);
            },
            onStateChange: ()=>{
                setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                handleChangeStateClick(entity);
            },
            onUpdateCollapseStatus: ()=>handleCollapseStatusChange(entity),
            ref: (el)=>{
                ruleActionButtonRefs.current[entity.id] = el?.getActionButtonRef();
            }
        })));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $awRwA.EscalationPolicyModal), {
        isOpen: isEscalationPolicyModalOpen,
        onClose: closeEscalationPolicyModal,
        notifyTypes: availableNotifyTypes,
        escalation: editingData,
        isCloning: isCloning,
        escalationNames: escalationNames,
        onSubmit: handleFormSubmit,
        isLoading: isUpdating || isCreating,
        hasRepeatRight: hasRepeatRight,
        returnFocusRef: returnFocusRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kGpyt.DeleteModal), {
        isOpen: isDeleteModalOpen,
        onClose: closeDeleteModal,
        onConfirm: handleDelete,
        name: editingData?.name || '',
        returnFocusRef: returnFocusRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dliR8.ChangeStateModal), {
        isOpen: isChangeStateModalOpen,
        onClose: closeChangeStateModal,
        onConfirm: handleChangeState,
        name: editingData?.name || '',
        isEnabled: editingData?.enabled || false,
        returnFocusRef: returnFocusRef
    }));
}

});
parcelRegister("6tRzQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c6b74e06cb85eac4ec854db73dcebe6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b7f02ca64f03771$var$_react = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b7f02ca64f03771$var$_information = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $4b7f02ca64f03771$var$_panel = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $4b7f02ca64f03771$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b7f02ca64f03771$var$InformationIcon = (props)=>/*#__PURE__*/ $4b7f02ca64f03771$var$_react.default.createElement($4b7f02ca64f03771$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $4b7f02ca64f03771$var$_panel.default
    }, props));
$4b7f02ca64f03771$var$InformationIcon.Name = 'InformationIconMigration';
var $4b7f02ca64f03771$var$_default = module.exports.default = $4b7f02ca64f03771$var$InformationIcon;

});

parcelRegister("dY87H", function(module, exports) {

$parcel$export(module.exports, "Flex", () => $2ce7fa80ca46705d$export$f51f4c4ede09e011);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $2ce7fa80ca46705d$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e18obzhx0"
})("display:flex;flex:", ({ flex: flex })=>flex, ";flex-basis:", ({ flexBasis: flexBasis })=>flexBasis, ";flex-direction:", ({ flexDirection: flexDirection })=>flexDirection, ";flex-flow:", ({ flexFlow: flexFlow })=>flexFlow, ";flex-grow:", ({ flexGrow: flexGrow })=>flexGrow, ";flex-shrink:", ({ flexShrink: flexShrink })=>flexShrink, ";flex-wrap:", ({ flexWrap: flexWrap })=>flexWrap, ";align-content:", ({ alignContent: alignContent })=>alignContent, ";align-items:", ({ alignItems: alignItems })=>alignItems, ";align-self:", ({ alignSelf: alignSelf })=>alignSelf, ";justify-content:", ({ justifyContent: justifyContent })=>justifyContent, ";order:", ({ order: order })=>order, ";place-items:", ({ placeItems: placeItems })=>placeItems, ";place-self:", ({ placeSelf: placeSelf })=>placeSelf, ";place-content:", ({ placeContent: placeContent })=>placeContent, ";row-gap:", ({ rowGap: rowGap })=>typeof rowGap === 'number' ? `${rowGap * (0, $k5uoT.gridSize)()}px` : rowGap, ";column-gap:", ({ columnGap: columnGap })=>typeof columnGap === 'number' ? `${columnGap * (0, $k5uoT.gridSize)()}px` : columnGap, ";");

});

parcelRegister("fXc9u", function(module, exports) {

$parcel$export(module.exports, "useResponderNames", () => $e8e4422ea9190968$export$26c3076cb2234d56);

var $5uXOq = parcelRequire("5uXOq");

var $hEySk = parcelRequire("hEySk");
const $e8e4422ea9190968$export$26c3076cb2234d56 = (requestedResponders)=>{
    const [{ responders: responders }, { batchResponders: batchResponders }] = (0, $hEySk.useResponderNamesStore)();
    const memoizedResponders = (0, $5uXOq.useMemo)(()=>{
        return requestedResponders.map((responder)=>{
            return responders[responder.id] ?? {
                acknowledged: false,
                isError: false,
                isLoading: true,
                name: '',
                ...responder
            };
        });
    }, [
        responders,
        requestedResponders
    ]);
    (0, $5uXOq.useEffect)(()=>{
        batchResponders(requestedResponders);
    }, [
        requestedResponders,
        batchResponders
    ]);
    return memoizedResponders;
};

});

parcelRegister("k97LS", function(module, exports) {

$parcel$export(module.exports, "useMonitorRuleCards", () => $ea3004dd2cd12ec4$export$98a326c6134ca371);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $3m5yC = parcelRequire("3m5yC");

var $7gWdR = parcelRequire("7gWdR");
function $ea3004dd2cd12ec4$export$98a326c6134ca371({ droppableId: droppableId, data: data, onComplete: onComplete }) {
    (0, $5uXOq.useEffect)(()=>{
        return (0, $7gWdR.monitorForElements)({
            canMonitor: ({ initial: { dropTargets: dropTargets } })=>{
                if (!data || !dropTargets.length) return false;
                const id = dropTargets[0].data.droppableId;
                return id === droppableId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const destinationId = destination.data.value;
                const sourceId = source.data.value;
                if (typeof destinationId !== 'string' || typeof sourceId !== 'string') return;
                const startIndex = data.findIndex((item)=>item.id === sourceId);
                const indexOfTarget = data.findIndex((item)=>item.id === destinationId);
                const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destination.data);
                const updated = (0, $3m5yC.reorderWithEdge)({
                    list: data,
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    axis: 'vertical'
                });
                onComplete({
                    updatedValue: updated,
                    startIndex: startIndex,
                    targetIndex: indexOfTarget,
                    sourceId: sourceId,
                    destinationId: destinationId
                });
            }
        });
    }, [
        data,
        droppableId,
        onComplete
    ]);
}

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("3m5yC", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $503dd84564f0390c$export$d0bc664d2812b3ba);
parcelRequire("ii3zs");
var $a44uV = parcelRequire("a44uV");

var $9EGGH = parcelRequire("9EGGH");
function $503dd84564f0390c$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $a44uV.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $9EGGH.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("ii3zs", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("a44uV")).reorder);

var $a44uV = parcelRequire("a44uV");

});
parcelRegister("a44uV", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $921c81942b5fc66a$export$fc77a6137e3f91c);
/**
 * Reorder a provided `list`
 * Returns a new array and does not modify the original array
 */ function $921c81942b5fc66a$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) return list;
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("9EGGH", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $178b6900979d74e0$export$846f792f51b92b6e);
function $178b6900979d74e0$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});



parcelRegister("kugKu", function(module, exports) {

$parcel$export(module.exports, "Section", () => $9e61b360cb4bd65a$export$6e2c8f0811a474ce);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dY87H = parcelRequire("dY87H");

var $cBYaP = parcelRequire("cBYaP");

var $ctlOM = parcelRequire("ctlOM");
const $9e61b360cb4bd65a$var$hiddenContentStyles = (0, $8CUq3.xcss)({
    display: 'none'
});
const $9e61b360cb4bd65a$export$6e2c8f0811a474ce = ({ children: children, className: className, ...props })=>{
    const id = (0, $5uXOq.useMemo)((0, $cBYaP.getNextId), []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctlOM.Header), {
        ...props,
        sectionId: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        id: `${id}-content`,
        xcss: props.isOpen === false && $9e61b360cb4bd65a$var$hiddenContentStyles,
        role: "region",
        "aria-labelledby": `${id}-header`
    }, children)));
};

});
parcelRegister("cBYaP", function(module, exports) {

$parcel$export(module.exports, "getNextId", () => $a83b9c01083da39e$export$bfc4ad7c1c5887fd);
let $a83b9c01083da39e$var$idCounter = 0;
function $a83b9c01083da39e$export$bfc4ad7c1c5887fd() {
    return `section-${++$a83b9c01083da39e$var$idCounter}`;
}

});

parcelRegister("ctlOM", function(module, exports) {

$parcel$export(module.exports, "Header", () => $09de9357ccbb472b$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $dY87H = parcelRequire("dY87H");

var $cHv2c = parcelRequire("cHv2c");
const $09de9357ccbb472b$export$8b251419efc915eb = ({ sectionId: sectionId, isOpen: isOpen, title: title, actions: actions, info: info, alignTitleToContainer: alignTitleToContainer, alignHeaderItems: alignHeaderItems = 'center', sectionDirection: sectionDirection, onClick: onClick, className: className, headerRole: headerRole })=>{
    const isCollapsible = (0, $5uXOq.useMemo)(()=>typeof isOpen !== 'undefined', [
        isOpen
    ]);
    const ChevronWrapper = alignTitleToContainer ? (0, $cHv2c.StyledChevronWrapper) : (0, $5uXOq.Fragment);
    const InfoWrapper = sectionDirection === 'column' ? (0, $5uXOq.Fragment) : (0, $cHv2c.SectionInfo);
    const handleKeyDown = (event)=>{
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            onClick?.();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: sectionDirection,
        flexGrow: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHv2c.SectionHeader), {
        alignItems: alignHeaderItems,
        onClick: onClick,
        columnGap: alignTitleToContainer ? 0 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        isCollapsible: isCollapsible,
        "aria-expanded": !headerRole ? isOpen : undefined,
        role: headerRole ?? 'button',
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        id: `${sectionId}-header`,
        "aria-controls": `${sectionId}-content`
    }, isCollapsible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronWrapper, null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        spacing: "spacious",
        testId: "opened-section-chevron",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        color: "currentColor",
        spacing: "spacious",
        testId: "closed-section-chevron",
        label: ""
    })), typeof title === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHv2c.SectionTitle), null, title) : title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InfoWrapper, null, info)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center"
    }, actions));
};

});
parcelRegister("cHv2c", function(module, exports) {

$parcel$export(module.exports, "StyledChevronWrapper", () => $8232d529454e7b1e$export$4ea0afaee716a881);
$parcel$export(module.exports, "SectionTitle", () => $8232d529454e7b1e$export$69bc41ee738923ec);
$parcel$export(module.exports, "SectionHeader", () => $8232d529454e7b1e$export$8adb256d999cd5a0);
$parcel$export(module.exports, "SectionInfo", () => $8232d529454e7b1e$export$3cc22bc1e76aaeab);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $8232d529454e7b1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8232d529454e7b1e$export$4ea0afaee716a881 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqlwngz3"
})({
    name: "z6azkj",
    styles: "width:24px;height:24px;margin-left:var(--ds-space-negative-300, -24px)"
});
const $8232d529454e7b1e$export$69bc41ee738923ec = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqlwngz2"
})({
    name: "1paz1du",
    styles: "font:var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});
const $8232d529454e7b1e$export$8adb256d999cd5a0 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "eqlwngz1"
})("width:100%;flex-basis:content;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isCollapsible: isCollapsible })=>isCollapsible && 'cursor: pointer;');
const $8232d529454e7b1e$export$3cc22bc1e76aaeab = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqlwngz0"
})({
    name: "1ncdxoc",
    styles: "align-self:center;margin-left:var(--ds-space-100, 8px)"
});

});



parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("cBr4z", function(module, exports) {

$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $79d0c5946511711e$export$a7c923252528b255);
const $79d0c5946511711e$export$a7c923252528b255 = {
    firstEntity: 'eoc-escalation-policies_first_entity'
};

});

parcelRegister("2oYbN", function(module, exports) {

$parcel$export(module.exports, "escalationPoliciesLoadExperience", () => $b4c21e64c1052023$export$978dc48b5416b9c3);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $b4c21e64c1052023$export$978dc48b5416b9c3 = new (0, $duUGa.UFOExperience)('eoc-escalation-policies-load', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load
});

});

parcelRegister("dliR8", function(module, exports) {

$parcel$export(module.exports, "ChangeStateModal", () => $001ef9c46061c157$export$3d4881bcb55920cd);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $1uKNE = parcelRequire("1uKNE");
const $001ef9c46061c157$export$3d4881bcb55920cd = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, name: name, isEnabled: isEnabled, returnFocusRef: returnFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        width: "small",
        onClose: onClose,
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $1uKNE.messages).title, {
        isEnabled: isEnabled
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $1uKNE.messages).description, {
        name: name,
        isEnabled: isEnabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $1uKNE.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onConfirm
    }, formatMessage((0, $1uKNE.messages).confirmButton, {
        isEnabled: isEnabled
    })))));
};

});
parcelRegister("1uKNE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1ef9dbfebcff1e76$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1ef9dbfebcff1e76$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.escalation-policies.change-state-modal.title.no-translate',
        defaultMessage: `{isEnabled, select,
      true {Turn off}
      other {Turn on}
    } escalation policy?`,
        description: 'The text will be displayed in the change state modal title.'
    },
    description: {
        id: 'eoc.escalation-policies.change-state-modal.description.no-translate',
        defaultMessage: `This will {isEnabled, select,
        true {turn off}
        other {turn on}
      } the escalation policy "{name}". You can turn it {isEnabled, select,
        true {on}
        other {off}
      } again or edit it at any time`,
        description: 'The text will be displayed in the change state modal description.'
    },
    cancelButton: {
        id: 'eoc.escalation-policies.change-state-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the change state modal footer for cancel button.'
    },
    confirmButton: {
        id: 'eoc.escalation-policies.change-state-modal.delete-button.no-translate',
        defaultMessage: `{isEnabled, select,
      true {Turn off}
      other {Turn on}
    }`,
        description: 'The text will be displayed in the change state modal footer for delete button.'
    }
});

});


parcelRegister("kGpyt", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $14ad133edd7700e2$export$73392e09138fecd6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $cgL5K = parcelRequire("cgL5K");

var $dc01y = parcelRequire("dc01y");
const $14ad133edd7700e2$export$73392e09138fecd6 = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, name: name, returnFocusRef: returnFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        width: "small",
        onClose: onClose,
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $dc01y.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $dc01y.messages).description, {
        name: name,
        strong: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                weight: "bold"
            }, children)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $dc01y.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "warning",
        onClick: onConfirm
    }, formatMessage((0, $dc01y.messages).deleteButton)))));
};

});
parcelRegister("dc01y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c93f712c47353e2f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c93f712c47353e2f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.escalation-policies.delete-modal.title.no-translate',
        defaultMessage: 'Delete escalation policy?',
        description: 'The text will be displayed in the delete modal title.'
    },
    description: {
        id: 'eoc.escalation-policies.delete-modal.description.no-translate',
        defaultMessage: `This action will permanently remove the escalation policy <strong>{name}</strong> and its rules. This can't be undone.`,
        description: 'The text will be displayed in the delete modal description.'
    },
    cancelButton: {
        id: 'eoc.escalation-policies.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.escalation-policies.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("awRwA", function(module, exports) {

$parcel$export(module.exports, "EscalationPolicyModal", () => $1ab78c35da01f673$export$f0eaad3663526e72);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $efXp3 = parcelRequire("efXp3");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $cgL5K = parcelRequire("cgL5K");

var $92Z2l = parcelRequire("92Z2l");

var $h8yj2 = parcelRequire("h8yj2");

var $dY87H = parcelRequire("dY87H");

var $fXc9u = parcelRequire("fXc9u");

var $lsh84 = parcelRequire("lsh84");

var $3oT7n = parcelRequire("3oT7n");

var $3FaMt = parcelRequire("3FaMt");

var $4n1CW = parcelRequire("4n1CW");

var $iLe3F = parcelRequire("iLe3F");

var $54wAN = parcelRequire("54wAN");

var $hUXm0 = parcelRequire("hUXm0");
const $1ab78c35da01f673$export$f0eaad3663526e72 = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, notifyTypes: notifyTypes, escalation: escalation, isCloning: isCloning, escalationNames: escalationNames, hasRepeatRight: hasRepeatRight, isLoading: isLoading, returnFocusRef: returnFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    // We need deleted entity count since there can be same deleted responders for different rules.
    const [deletedEntityCount, setDeletedEntityCount] = (0, $5uXOq.useState)(0);
    const [isProcessing, setIsProcessing] = (0, $5uXOq.useState)(false);
    const requestedResponders = escalation?.rules.map((rule)=>({
            id: rule.notifyId,
            type: rule.type
        })).filter((v, i, a)=>a.findIndex((v2)=>v2.id === v.id) === i);
    const responders = (0, $fXc9u.useResponderNames)(requestedResponders ?? []);
    const InitialDeletedResponders = responders.filter((0, $lsh84.isResponderDeleted));
    const InitialDeletedEntities = escalation?.rules.filter((rule)=>InitialDeletedResponders.findIndex((responder)=>responder.id === rule.notifyId) !== -1) ?? [];
    // escalations is undefined in the inial render, it is set when edit/clone modal is opened.
    (0, $5uXOq.useEffect)(()=>{
        setDeletedEntityCount(InitialDeletedEntities.length);
    }, [
        InitialDeletedEntities.length
    ]);
    const getModalTitle = ()=>{
        if (isCloning) return formatMessage((0, $3FaMt.default).cloneTitle);
        if (escalation) return formatMessage((0, $3FaMt.default).editTitle);
        return formatMessage((0, $3FaMt.default).createTitle);
    };
    const handleClose = (analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'closeEscalationPolicyModal');
        if (onClose) onClose();
    };
    const handleSubmit = ({ team: team, ...values })=>{
        if (isProcessing) return {
            rules: 'is-processing'
        };
        if (values.rules.length === 0) return {
            rules: 'required'
        };
        values.teamId = teamId || team?.atlassianIdentifier;
        onSubmit(values);
    };
    const checkRule = (rule)=>{
        if (InitialDeletedEntities.includes(rule)) setDeletedEntityCount((prev)=>prev - 1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: (_, analyticEvent)=>handleClose(analyticEvent),
        width: "large",
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            id: "escalation-policy",
            ...formProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, getModalTitle())), deletedEntityCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54wAN.SectionMessageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong"
        }, formatMessage((0, $3FaMt.default).infoSection, {
            deletedEntityCount: deletedEntityCount
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            flexDirection: "column",
            rowGap: 3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            flexDirection: "column",
            rowGap: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4n1CW.NameInputs), {
            name: escalation?.name,
            description: escalation?.description,
            isCloning: isCloning,
            escalationNames: escalationNames
        }), !teamId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hUXm0.TeamInput), {
            teamId: escalation?.teamId
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oT7n.EscalationRulesInputs), {
            rules: escalation?.rules,
            notifyTypes: notifyTypes,
            onChange: checkRule,
            onDelete: checkRule,
            onProcess: (isProcessing)=>setIsProcessing(isProcessing)
        }), hasRepeatRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iLe3F.RepeatEscalationInputs), {
            repeat: escalation?.repeat,
            maxRepeatCount: escalation?.maxRepeatCount,
            closeAlertWhenRepeatsCompleted: escalation?.closeAlertWhenRepeatsCompleted,
            unAckWhileRepeating: escalation?.unAckWhileRepeating
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>handleClose(analyticsEvent)
        }, formatMessage((0, $3FaMt.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
            isLoading: isLoading,
            type: "submit",
            appearance: "primary"
        }, isCloning ? formatMessage((0, $3FaMt.default).clone) : formatMessage(escalation ? (0, $3FaMt.default).update : (0, $3FaMt.default).create)))))));
};

});
parcelRegister("h8yj2", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b264de6d6a035739$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b264de6d6a035739$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b264de6d6a035739$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b264de6d6a035739$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b264de6d6a035739$export$6f46fb37ad7d962b);

var $hYfgW = parcelRequire("hYfgW");


var $4zfLY = parcelRequire("4zfLY");
const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
};
const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
parcelRegister("4zfLY", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $ccaec2c661eabde7$export$e6baab532ef8c6bf);
const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});


parcelRegister("lsh84", function(module, exports) {

$parcel$export(module.exports, "generateMinuteOptions", () => $890cf90058681939$export$d9fc003438cb53df);
$parcel$export(module.exports, "isResponderDeleted", () => $890cf90058681939$export$f91b67bda827028d);
const $890cf90058681939$export$d9fc003438cb53df = ()=>{
    return Array.from({
        length: 20
    }, (_, i)=>({
            label: `${i + 1}`,
            value: i + 1
        }));
};
const $890cf90058681939$export$f91b67bda827028d = (responder)=>responder && !responder.isLoading && !responder.isError && responder.deleted;

});

parcelRegister("3oT7n", function(module, exports) {

$parcel$export(module.exports, "EscalationRulesInputs", () => $662a2f6d6b2a8790$export$dc183d2a06b2e906);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $l1N8i = parcelRequire("l1N8i");

var $faod6 = parcelRequire("faod6");

var $96UJI = parcelRequire("96UJI");

var $1jWct = parcelRequire("1jWct");


var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $dY87H = parcelRequire("dY87H");

var $1aMzM = parcelRequire("1aMzM");

var $f21RM = parcelRequire("f21RM");

var $cCZJW = parcelRequire("cCZJW");

var $ibfj9 = parcelRequire("ibfj9");

var $h830V = parcelRequire("h830V");

var $1Ukfy = parcelRequire("1Ukfy");
const $662a2f6d6b2a8790$export$dc183d2a06b2e906 = ({ notifyTypes: notifyTypes, rules: rules, onDelete: onDelete, onChange: onChange, onProcess: onProcess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isAdding, setIsAdding] = (0, $5uXOq.useState)(false);
    const [editingIndex, setEditingIndex] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (onProcess) {
            if (isAdding || editingIndex) {
                onProcess(true);
                return;
            }
            onProcess(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAdding,
        editingIndex
    ]);
    const isProcessing = isAdding || editingIndex !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center",
        columnGap: 0.5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage((0, $h830V.default).escalationRules)), (!rules || rules?.length === 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $h830V.default).escalationRulesTooltip),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)",
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "rules",
        defaultValue: rules || []
    }, ({ fieldProps: fieldProps, error: error })=>{
        const rulesCount = fieldProps.value.length;
        if (rulesCount === 50) {
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'escalationPolicyRuleLimit reached');
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            flexDirection: "column"
        }, fieldProps.value.map((rule, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f21RM.EditableRule), {
                key: i,
                isEditing: editingIndex === i,
                shouldHideEditButton: isAdding,
                shouldHideDeleteButton: isAdding || editingIndex !== undefined,
                onEdit: ()=>setEditingIndex(i),
                rule: rule,
                notifyTypes: notifyTypes,
                onCancel: ()=>setEditingIndex(undefined),
                onDelete: (value)=>{
                    const copiedValues = [
                        ...fieldProps.value
                    ];
                    const newValues = copiedValues.filter((_, deletingIndex)=>i !== deletingIndex);
                    fieldProps.onChange(newValues);
                    if (onDelete) onDelete(value);
                },
                onChange: (value)=>{
                    const copiedValues = [
                        ...fieldProps.value
                    ];
                    copiedValues[i] = value;
                    fieldProps.onChange(copiedValues);
                    setEditingIndex(undefined);
                    if (onChange) onChange(rule);
                }
            })), isAdding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cCZJW.RuleInput), {
            onChange: (value)=>{
                const copiedValues = [
                    ...fieldProps.value
                ];
                copiedValues.push(value);
                fieldProps.onChange(copiedValues);
                setIsAdding(false);
            },
            onCancel: ()=>setIsAdding(false),
            notifyTypes: notifyTypes,
            warningMessage: rulesCount === 49 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96UJI))), {
                spacing: "spacious",
                color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
                label: ""
            }), formatMessage((0, $h830V.default).lastRule))
        }), rulesCount === 50 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Ukfy.WarningWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96UJI))), {
            spacing: "spacious",
            color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
            label: ""
        }), formatMessage((0, $h830V.default).ruleLimit)) : !isAdding && editingIndex === undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Ukfy.StyledButton), {
            spacing: "none",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            appearance: "link",
            onClick: ()=>{
                setIsAdding(true);
                fieldProps.onBlur();
            }
        }, formatMessage((0, $h830V.default).addRule))), error === 'required' && !isProcessing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $1aMzM.default).fieldRequired)), error === 'is-processing' && isProcessing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $h830V.default).isProcessing)));
    }))));
};

});
parcelRegister("96UJI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1024a19411feb917e1461158c5c654bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a20af3e274078d5$var$_react = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6a20af3e274078d5$var$_information = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $6a20af3e274078d5$var$_info = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("iRH6p")));
function $6a20af3e274078d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a20af3e274078d5$var$InformationIcon = (props)=>/*#__PURE__*/ $6a20af3e274078d5$var$_react.default.createElement($6a20af3e274078d5$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $6a20af3e274078d5$var$_info.default
    }, props));
$6a20af3e274078d5$var$InformationIcon.Name = 'InformationIconMigration';
var $6a20af3e274078d5$var$_default = module.exports.default = $6a20af3e274078d5$var$InformationIcon;

});
parcelRegister("iRH6p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbbe9c7ad934f1e0$var$_react = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $dbbe9c7ad934f1e0$var$_information = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("2Yv61")));
function $dbbe9c7ad934f1e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dbbe9c7ad934f1e0$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $dbbe9c7ad934f1e0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $dbbe9c7ad934f1e0$var$_information.default
    }));
$dbbe9c7ad934f1e0$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $dbbe9c7ad934f1e0$var$_default = module.exports.default = $dbbe9c7ad934f1e0$var$EditorInfoIcon;

});


parcelRegister("1aMzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a032f682ce78bbe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2a032f682ce78bbe$var$commonMessages = (0, $7VHMR.defineMessages)({
    fieldRequired: {
        id: 'eoc.escalation-policies.ui.common.required.no-translate',
        defaultMessage: 'This field is required',
        description: 'Error message that shown required input is empty'
    },
    alreadyExist: {
        id: 'eoc.escalation-policies.ui.common.already-exist.no-translate',
        defaultMessage: 'Escalation with this name {name} already exists.',
        description: 'Error message that shown if escalation policy exist with same name'
    },
    errorTitle: {
        id: 'eoc.escalation-policies.flag.error-title.no-translate',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    },
    successTitle: {
        id: 'eoc.escalation-policies.flag.success-title.no-translate',
        defaultMessage: 'Success',
        description: 'Title of success message that will be displayed in the flag'
    },
    enabled: {
        id: 'eoc.global-escalations.status.on.no-translate',
        defaultMessage: 'On',
        description: 'The label of enabled status'
    },
    disabled: {
        id: 'eoc.global-escalations.status.off.no-translate',
        defaultMessage: 'Off',
        description: 'The label of disabled status'
    },
    edit: {
        id: 'eoc.escalation-policies.ui.actions.edit.no-translate',
        defaultMessage: 'Edit',
        description: 'Label of edit button'
    },
    clone: {
        id: 'eoc.escalation-policies.ui.actions.clone.no-translate',
        defaultMessage: 'Duplicate',
        description: 'Label of clone button'
    },
    disable: {
        id: 'eoc.escalation-policies.ui.actions.disable.no-translate',
        defaultMessage: 'Turn off',
        description: 'Label of disable button'
    },
    enable: {
        id: 'eoc.escalation-policies.ui.actions.enable.no-translate',
        defaultMessage: 'Turn on',
        description: 'Label of enable button'
    },
    delete: {
        id: 'eoc.escalation-policies.ui.actions.delete.no-translate',
        defaultMessage: 'Delete',
        description: 'Label of delete button'
    },
    showMore: {
        id: 'eoc.escalation-policies.ui.actions.show-more.no-translate',
        defaultMessage: 'Show Actions of {name}',
        description: 'Label of show more button'
    },
    title: {
        id: 'eoc.global-escalations.header.title.no-translate',
        defaultMessage: 'Escalation policies',
        description: 'The title of global escalations'
    }
});
var $2a032f682ce78bbe$export$2e2bcd8739ae039 = $2a032f682ce78bbe$var$commonMessages;

});

parcelRegister("f21RM", function(module, exports) {

$parcel$export(module.exports, "EditableRule", () => $238e78db93ea5259$export$4d86f33bd68c0d19);

var $5uXOq = parcelRequire("5uXOq");

var $85HaG = parcelRequire("85HaG");

var $cCZJW = parcelRequire("cCZJW");
const $238e78db93ea5259$export$4d86f33bd68c0d19 = (props)=>{
    if (props.isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cCZJW.RuleInput), {
        value: props.rule,
        notifyTypes: props.notifyTypes,
        onCancel: props.onCancel,
        onChange: props.onChange
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85HaG.Rule), {
        data: props.rule,
        onEdit: props.onEdit,
        onDelete: props.onDelete,
        inlineResponder: props.rule.inlineResponder,
        shouldHideEditButton: props.shouldHideEditButton,
        shouldHideDeleteButton: props.shouldHideDeleteButton
    });
};

});
parcelRegister("85HaG", function(module, exports) {

$parcel$export(module.exports, "Rule", () => $b805ca954acb13cf$export$f1ff2a90c38ff669);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $42CjB = parcelRequire("42CjB");

var $5Fuj0 = parcelRequire("5Fuj0");

var $5gR1R = parcelRequire("5gR1R");

var $lj8SI = parcelRequire("lj8SI");

var $cgL5K = parcelRequire("cgL5K");

var $hkH3Y = parcelRequire("hkH3Y");
var $jj11s = parcelRequire("jj11s");

var $fXc9u = parcelRequire("fXc9u");

var $8J1d6 = parcelRequire("8J1d6");

var $jM77t = parcelRequire("jM77t");

var $kF43x = parcelRequire("kF43x");

var $i43ks = parcelRequire("i43ks");
const $b805ca954acb13cf$export$f1ff2a90c38ff669 = ({ data: data, inlineResponder: inlineResponder, onEdit: onEdit, onDelete: onDelete, shouldHideEditButton: shouldHideEditButton, shouldHideDeleteButton: shouldHideDeleteButton })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [responder] = (0, $fXc9u.useResponderNames)(inlineResponder ? [] : [
        {
            id: data.notifyId,
            type: data.type
        }
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8J1d6.RuleCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i43ks.StyledFlex), {
        tabIndex: 0,
        flexDirection: "column",
        rowGap: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkH3Y.RuleItemGroup), {
        left: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i43ks.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: "inprogress"
        }, formatMessage((0, $kF43x.default).if)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jj11s.RuleItemRow), null, `${formatMessage((0, $kF43x.default)[data.notifyCondition])}, `)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkH3Y.RuleItemGroup), {
        left: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i43ks.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            style: (0, $i43ks.transparentLozengeStyle)
        }, formatMessage((0, $kF43x.default).then)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jj11s.RuleItemRow), null, formatMessage((0, $kF43x.default)['branchVerbalForm'], {
        time: data.time,
        type: data.type,
        notifyType: data.notifyType,
        strong: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "span"
            }, s),
        responder: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jM77t.Responder), {
                data: responder,
                inlineResponder: inlineResponder
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i43ks.ActionButtons), {
        className: "eoc-escalation-policies-common-rule-action-buttons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, !shouldHideEditButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        label: formatMessage((0, $kF43x.default).edit),
        appearance: "subtle",
        onClick: onEdit,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5gR1R)))
    }), !shouldHideDeleteButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        label: formatMessage((0, $kF43x.default).delete),
        onClick: ()=>{
            if (onDelete) onDelete(data);
        },
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Fuj0)))
    })))));
};

});
parcelRegister("5Fuj0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdbc673522c6bc8690e33483f21d93d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42084a291eb7f82a$var$_react = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42084a291eb7f82a$var$_delete = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("4IrpZ")));

var $42084a291eb7f82a$var$_remove = $42084a291eb7f82a$var$_interopRequireDefault((parcelRequire("f5BqX")));
function $42084a291eb7f82a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42084a291eb7f82a$var$DeleteIcon = (props)=>/*#__PURE__*/ $42084a291eb7f82a$var$_react.default.createElement($42084a291eb7f82a$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $42084a291eb7f82a$var$_remove.default
    }, props));
$42084a291eb7f82a$var$DeleteIcon.Name = 'DeleteIconMigration';
var $42084a291eb7f82a$var$_default = module.exports.default = $42084a291eb7f82a$var$DeleteIcon;

});
parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4d83f5979cfae4264098ab1c131716f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("f5BqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afc45c3418436f46$var$_react = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $afc45c3418436f46$var$_delete = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("4IrpZ")));
function $afc45c3418436f46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $afc45c3418436f46$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $afc45c3418436f46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $afc45c3418436f46$var$_delete.default
    }));
$afc45c3418436f46$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $afc45c3418436f46$var$_default = module.exports.default = $afc45c3418436f46$var$EditorRemoveIcon;

});


parcelRegister("5gR1R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c89dacddc30135ba9d9ccb353790663>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d6794d2f296ea70$var$_react = $3d6794d2f296ea70$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3d6794d2f296ea70$var$_edit = $3d6794d2f296ea70$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $3d6794d2f296ea70$var$_edit2 = $3d6794d2f296ea70$var$_interopRequireDefault((parcelRequire("gjM4I")));
function $3d6794d2f296ea70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditorEditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d6794d2f296ea70$var$EditIcon = (props)=>/*#__PURE__*/ $3d6794d2f296ea70$var$_react.default.createElement($3d6794d2f296ea70$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $3d6794d2f296ea70$var$_edit2.default
    }, props));
$3d6794d2f296ea70$var$EditIcon.Name = 'EditIconMigration';
var $3d6794d2f296ea70$var$_default = module.exports.default = $3d6794d2f296ea70$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df0e46d6520ed0b12c088820aa4dca0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gjM4I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be13b660d6f77686$var$_react = $be13b660d6f77686$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $be13b660d6f77686$var$_edit = $be13b660d6f77686$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $be13b660d6f77686$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be13b660d6f77686$var$EditorEditIcon = (props)=>/*#__PURE__*/ $be13b660d6f77686$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
    }, props, {
        newIcon: $be13b660d6f77686$var$_edit.default
    }));
$be13b660d6f77686$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $be13b660d6f77686$var$_default = module.exports.default = $be13b660d6f77686$var$EditorEditIcon;

});


parcelRegister("hkH3Y", function(module, exports) {

$parcel$export(module.exports, "RuleItemGroup", () => $43b49dc2ee0db26b$export$580a9a0153ad4d7e);

var $5uXOq = parcelRequire("5uXOq");

var $e2j4W = parcelRequire("e2j4W");
const $43b49dc2ee0db26b$export$580a9a0153ad4d7e = ({ left: left, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2j4W.OgItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2j4W.LeftSide), null, left), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2j4W.RightSide), null, children));
};

});
parcelRegister("e2j4W", function(module, exports) {

$parcel$export(module.exports, "OgItemWrapper", () => $0bbaf3afeea88115$export$92760fa8caf29e00);
$parcel$export(module.exports, "LeftSide", () => $0bbaf3afeea88115$export$a4bd770249c02afb);
$parcel$export(module.exports, "RightSide", () => $0bbaf3afeea88115$export$7a04404a7e0d1404);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $0bbaf3afeea88115$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0bbaf3afeea88115$export$92760fa8caf29e00 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1dxirh02"
})({
    name: "ho1qnd",
    styles: "display:flex;flex-direction:row"
});
const $0bbaf3afeea88115$export$a4bd770249c02afb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1dxirh01"
})({
    name: "1cu4gac",
    styles: "display:flex;flex-direction:column;justify-content:flex-start;align-items:center;padding-right:var(--ds-space-100, 8px);min-width:50px;span{width:100%;text-align:center;}"
});
const $0bbaf3afeea88115$export$7a04404a7e0d1404 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1dxirh00"
})({
    display: 'flex',
    flexDirection: 'column',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    gap: "var(--ds-space-050, 4px)",
    minWidth: 0
});

});


parcelRegister("jj11s", function(module, exports) {

$parcel$export(module.exports, "RuleItemRow", () => $e7a6907b6357e684$export$cdfdc7f96ab3f5e1);

var $5uXOq = parcelRequire("5uXOq");

var $9hsAH = parcelRequire("9hsAH");
const $e7a6907b6357e684$export$cdfdc7f96ab3f5e1 = ({ children: children, className: className })=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hsAH.RowWrapper), {
        className: className
    }, children);
};

});
parcelRegister("9hsAH", function(module, exports) {

$parcel$export(module.exports, "RowWrapper", () => $2bdf6f79cb6450fc$export$bc7adc8ef74607f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $2bdf6f79cb6450fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2bdf6f79cb6450fc$export$bc7adc8ef74607f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1vo4axt0"
})({
    name: "1x8tk8v",
    styles: "display:flex;align-items:center;gap:var(--ds-space-050, 4px)"
});

});


parcelRegister("8J1d6", function(module, exports) {

$parcel$export(module.exports, "RuleCard", () => $cf10590f4cff1a2c$export$9fcc7972f6cd3650);

var $5uXOq = parcelRequire("5uXOq");

var $lHrkK = parcelRequire("lHrkK");

var $cahRV = parcelRequire("cahRV");

var $biEfA = parcelRequire("biEfA");

var $i9j7E = parcelRequire("i9j7E");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("7R0nZ");
var $kWQ6T = parcelRequire("kWQ6T");

var $3bDjY = parcelRequire("3bDjY");

var $aNwnZ = parcelRequire("aNwnZ");
const $cf10590f4cff1a2c$export$9fcc7972f6cd3650 = ({ className: className, title: title, actions: actions, children: children, value: value, droppableId: droppableId, gap: gap = '0px', description: description, headingAs: headingAs = 'h4', contentSpacing: contentSpacing = 'normal' })=>{
    const titleRef = (0, $5uXOq.useRef)(null);
    const ruleCardRef = (0, $5uXOq.useRef)(null);
    const handlerRef = (0, $5uXOq.useRef)(null);
    const [isEllipsis, setIsEllipsis] = (0, $5uXOq.useState)(false);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [dragState, setDragState] = (0, $5uXOq.useState)('idle');
    (0, $5uXOq.useEffect)(()=>{
        if (!titleRef.current) return;
        const el = titleRef.current;
        setIsEllipsis(el.offsetHeight < el.scrollHeight || el.offsetWidth < el.scrollWidth);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!ruleCardRef.current || !handlerRef.current || !droppableId) return;
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: ruleCardRef.current,
            dragHandle: handlerRef.current,
            getInitialData: ()=>({
                    value: value,
                    droppableId: droppableId
                }),
            onGenerateDragPreview: ({ source: source })=>{
                (0, $kWQ6T.scrollJustEnoughIntoView)({
                    element: source.element
                });
                setDragState('generate-preview');
            },
            onDragStart: ()=>setDragState('dragging'),
            onDrop: ()=>setDragState('idle')
        }), (0, $7gWdR.dropTargetForElements)({
            element: ruleCardRef.current,
            canDrop: ({ source: { data: data } })=>data.droppableId === droppableId,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const data = {
                    value: value,
                    droppableId: droppableId
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrop: (args)=>{
                setClosestEdge(null);
            },
            onDragEnter: (args)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(args.self.data.value, args.source.data.value)) setClosestEdge((0, $biEfA.extractClosestEdge)(args.self.data));
            },
            onDragLeave: (args)=>{
                setClosestEdge(null);
            },
            onDrag: (args)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(args.self.data.value, args.source.data.value)) setClosestEdge((0, $biEfA.extractClosestEdge)(args.self.data));
            }
        }));
    }, [
        droppableId,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.Card), {
        state: dragState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.Container), {
        ref: ruleCardRef,
        className: className
    }, (title || droppableId || actions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.Header), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.TitleContainer), null, droppableId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.DragHandlerWrapper), {
        "data-testid": "rule-card-drag-handler",
        ref: handlerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cahRV))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.TitleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isEllipsis ? title : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.Title), {
        as: headingAs,
        ref: titleRef
    }, title))), description), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.ActionsWrapper), null, actions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNwnZ.Content), {
        contentSpacing: contentSpacing
    }, children)), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9j7E.DropIndicator), {
        edge: closestEdge,
        gap: gap
    }));
};
var $cf10590f4cff1a2c$export$2e2bcd8739ae039 = $cf10590f4cff1a2c$export$9fcc7972f6cd3650;

});
parcelRegister("cahRV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1f020b52f532dd63303bdd95008cda2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8db4479073176ad4$var$_react = $8db4479073176ad4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8db4479073176ad4$var$_dragHandle = $8db4479073176ad4$var$_interopRequireDefault((parcelRequire("idRxN")));

var $8db4479073176ad4$var$_dragHandler = $8db4479073176ad4$var$_interopRequireDefault((parcelRequire("78tet")));
function $8db4479073176ad4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DragHandleIcon.
 * This component is DragHandleIcon, with `UNSAFE_fallbackIcon` set to "DragHandlerIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for draggable elements.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8db4479073176ad4$var$DragHandleIcon = (props)=>/*#__PURE__*/ $8db4479073176ad4$var$_react.default.createElement($8db4479073176ad4$var$_dragHandle.default, Object.assign({
        LEGACY_fallbackIcon: $8db4479073176ad4$var$_dragHandler.default
    }, props));
$8db4479073176ad4$var$DragHandleIcon.Name = 'DragHandleIconMigration';
var $8db4479073176ad4$var$_default = module.exports.default = $8db4479073176ad4$var$DragHandleIcon;

});
parcelRegister("idRxN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3181b9cde7676d7293ffd42729a41788>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d442f9a78d3217d7$var$_react = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d442f9a78d3217d7$var$_baseNew = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d442f9a78d3217d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "DragHandle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for draggable elements.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d442f9a78d3217d7$var$DragHandleIcon = (props)=>/*#__PURE__*/ $d442f9a78d3217d7$var$_react.default.createElement($d442f9a78d3217d7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$d442f9a78d3217d7$var$DragHandleIcon.displayName = 'DragHandleIcon';
var $d442f9a78d3217d7$var$_default = module.exports.default = $d442f9a78d3217d7$var$DragHandleIcon;

});

parcelRegister("78tet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $531ff4bbcd008815$var$_dragHandle = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("idRxN")));
function $531ff4bbcd008815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $531ff4bbcd008815$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $531ff4bbcd008815$var$_dragHandle.default
    }));
$531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;

});


parcelRegister("i9j7E", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $e2ea2483ebbe0d5a$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $e2ea2483ebbe0d5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $5rg5B = parcelRequire("5rg5B");
const $e2ea2483ebbe0d5a$var$lineStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $5rg5B.line).backgroundColor,
    content: '""',
    pointerEvents: 'none'
});
const $e2ea2483ebbe0d5a$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $5rg5B.line).thickness,
        top: 'var(--local-line-offset)',
        right: 0,
        left: 0
    }),
    right: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $5rg5B.line).thickness,
        top: 0,
        right: 'var(--local-line-offset)',
        bottom: 0
    }),
    bottom: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $5rg5B.line).thickness,
        right: 0,
        bottom: 'var(--local-line-offset)',
        left: 0
    }),
    left: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $5rg5B.line).thickness,
        top: 0,
        bottom: 0,
        left: 'var(--local-line-offset)'
    })
};
function $e2ea2483ebbe0d5a$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $5rg5B.line).thickness}px))`;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $e2ea2483ebbe0d5a$var$lineStyles,
            edge && $e2ea2483ebbe0d5a$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$e2ea2483ebbe0d5a$export$2e2bcd8739ae039 = $e2ea2483ebbe0d5a$export$62ed72bc21f6b8a6;

});
parcelRegister("5rg5B", function(module, exports) {

$parcel$export(module.exports, "line", () => $5fa9eeeb39a80f61$export$53f1d5ea8de3d7c);
/**
 * Design decisions for the drop indicator's main line
 */ const $5fa9eeeb39a80f61$export$53f1d5ea8de3d7c = {
    borderRadius: 0,
    thickness: 2,
    backgroundColor: "var(--ds-border-selected, #0C66E4)"
};

});


parcelRegister("7R0nZ", function(module, exports) {

$parcel$export(module.exports, "scrollJustEnoughIntoView", () => (parcelRequire("kWQ6T")).scrollJustEnoughIntoView);

var $kWQ6T = parcelRequire("kWQ6T");

});
parcelRegister("kWQ6T", function(module, exports) {

$parcel$export(module.exports, "scrollJustEnoughIntoView", () => $94fed264c1231342$export$2725ea6c83710b1f);
/**
 * Scroll an `element` just enough into view so that the element becomes totally visible.
 * If the element is already totally visible then no scrolling will occur.
 */ function $94fed264c1231342$export$2725ea6c83710b1f({ element: element }) {
    element.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
    });
}

});


parcelRegister("aNwnZ", function(module, exports) {

$parcel$export(module.exports, "Container", () => $66d22c526bfd8eed$export$42a852a2b6b56249);
$parcel$export(module.exports, "Title", () => $66d22c526bfd8eed$export$f99233281efd08a0);
$parcel$export(module.exports, "DragHandlerWrapper", () => $66d22c526bfd8eed$export$5761cab24db81fb9);
$parcel$export(module.exports, "Header", () => $66d22c526bfd8eed$export$8b251419efc915eb);
$parcel$export(module.exports, "TitleContainer", () => $66d22c526bfd8eed$export$35e09ba17cc51c69);
$parcel$export(module.exports, "TitleWrapper", () => $66d22c526bfd8eed$export$585a3b23e887288b);
$parcel$export(module.exports, "ActionsWrapper", () => $66d22c526bfd8eed$export$c8223871eecc8f3a);
$parcel$export(module.exports, "Card", () => $66d22c526bfd8eed$export$60332b2344f7fe41);
$parcel$export(module.exports, "Content", () => $66d22c526bfd8eed$export$7c6e2c02157bb7d2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
function $66d22c526bfd8eed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $66d22c526bfd8eed$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn8"
})({
    background: "var(--ds-surface, #FFF)",
    boxShadow: "var(--ds-shadow-raised, 0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $k5uoT.borderRadius)()}px`,
    userSelect: 'auto'
});
const $66d22c526bfd8eed$export$f99233281efd08a0 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn7"
})({
    name: "3x6vn2",
    styles: "font:var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-left:var(--ds-space-100, 8px)"
});
const $66d22c526bfd8eed$export$5761cab24db81fb9 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn6"
})({
    name: "10888ex",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);flex-shrink:0;cursor:grab"
});
const $66d22c526bfd8eed$export$8b251419efc915eb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn5"
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`,
    paddingBottom: 0
});
const $66d22c526bfd8eed$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn4"
})({
    name: "srrf61",
    styles: "min-width:0;display:flex;align-items:center"
});
const $66d22c526bfd8eed$export$585a3b23e887288b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn3"
})({
    name: "ovk77c",
    styles: "min-width:0"
});
const $66d22c526bfd8eed$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn2"
})({
    name: "pbds0y",
    styles: "margin-left:var(--ds-space-200, 16px)"
});
const $66d22c526bfd8eed$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn1"
})((props)=>({
        position: 'relative',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.state === 'dragging' ? '0.6' : '1'
    }));
const $66d22c526bfd8eed$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1o1srgn0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.contentSpacing === 'normal' && `padding-left: ${"var(--ds-space-100, 8px)"};
    padding-right: ${"var(--ds-space-100, 8px)"};
    padding-bottom: ${"var(--ds-space-150, 12px)"};`);

});


parcelRegister("jM77t", function(module, exports) {

$parcel$export(module.exports, "Responder", () => $f4fa2f856ec285f5$export$f24e448a6c8c00a7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $8icyj = parcelRequire("8icyj");

var $9rJpK = parcelRequire("9rJpK");

var $4zKzm = parcelRequire("4zKzm");
const $f4fa2f856ec285f5$export$f24e448a6c8c00a7 = ({ data: data, inlineResponder: inlineResponder })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (inlineResponder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, inlineResponder.label);
    if (data.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: 5
    });
    if (data.isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zKzm.IdText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top-start",
        content: data.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, data.id)));
    if (data.deleted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zKzm.DeletedEntity), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span"
    }, formatMessage((0, $9rJpK.default).deletedEntity)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zKzm.ResponderName), null, data.name);
};

});
parcelRegister("9rJpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $df453d30335acd92$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $df453d30335acd92$var$messages = (0, $7VHMR.defineMessages)({
    deletedEntity: {
        id: 'eoc.escalation-policies.common.ui.responder-names.deleted-responder.no-translate',
        defaultMessage: 'Deleted responder',
        description: 'The text to display if the responder is deleted'
    }
});
var $df453d30335acd92$export$2e2bcd8739ae039 = $df453d30335acd92$var$messages;

});

parcelRegister("4zKzm", function(module, exports) {

$parcel$export(module.exports, "IdText", () => $dd798db6a8b7ccd9$export$696700b026eb1781);
$parcel$export(module.exports, "DeletedEntity", () => $dd798db6a8b7ccd9$export$abdea9409f350649);
$parcel$export(module.exports, "ResponderName", () => $dd798db6a8b7ccd9$export$e92149f4e6fa94f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $dd798db6a8b7ccd9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd798db6a8b7ccd9$export$696700b026eb1781 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ecjdpxw2"
})({
    name: "1fzmqzp",
    styles: "display:inline-flex;div{display:inline-block;font-weight:var(--ds-font-weight-bold, 700);max-width:90px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;span{max-width:90px;}}"
});
const $dd798db6a8b7ccd9$export$abdea9409f350649 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "ecjdpxw1"
})({
    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        fontWeight: "var(--ds-font-weight-semibold, 600)"
    }
});
const $dd798db6a8b7ccd9$export$e92149f4e6fa94f = /*#__PURE__*/ (0, $bWGt6.default)("strong", {
    target: "ecjdpxw0"
})({
    name: "ny2cg7",
    styles: "max-width:300px;overflow:hidden;text-overflow:ellipsis"
});

});


parcelRegister("kF43x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d033dd3416c66da5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $d033dd3416c66da5$var$messages = (0, $7VHMR.defineMessages)({
    if: {
        id: 'eoc.escalation-policies.common.rule.if.no-translate',
        defaultMessage: 'IF',
        description: 'Label of first rule condition'
    },
    then: {
        id: 'eoc.escalation-policies.common.rule.then.no-translate',
        defaultMessage: 'THEN',
        description: 'The indicator of what gonna happen after conditions end'
    },
    'if-not-acked': {
        id: 'eoc.escalation-policies.common.rule.if-not-acked.no-translate',
        defaultMessage: 'Alert is not acknowledged',
        description: 'The indicator of rule when if-not-acked option is selected'
    },
    'if-not-closed': {
        id: 'eoc.escalation-policies.common.rule.if-not-closed.no-translate',
        defaultMessage: 'Alert is not closed',
        description: 'The indicator of rule when if-not-closed option is selected'
    },
    edit: {
        id: 'eoc.escalation-policies.common.rule.edit.no-translate',
        defaultMessage: 'Edit Escalation Rule',
        description: 'The label of edit escalation icon button'
    },
    delete: {
        id: 'eoc.escalation-policies.common.rule.delete.no-translate',
        defaultMessage: 'Delete Escalation Rule',
        description: 'The label of delete escalation icon button'
    },
    branchVerbalForm: {
        id: 'eoc.escalation-policies.common.rule.branch-verbal-form.no-translate',
        defaultMessage: `<strong>
    {time, plural,
      =0 {immediately}
      other {{time} min}
    }
    </strong>
    {time, select,
      0 {}
      other {after creation, }
    }
    {type, select,
      user {notify}
      schedule {
        {notifyType, select,
          default {notify on call users in }
          next {notify next user (in rotation) for }
          previous {notify previous user (in rotation) for }
          other {}
        }
      }
      team {
        {notifyType, select,
          all {notify all members of }
          users {notify users of }
          admins {notify admins of }
          default {route to team }
          random {notify a random member of }
          other {}
        }
      }
      other {after creation, }
    }
    <responder></responder>
    `,
        description: 'Full message of then statement. Example: 10 min after creation, notify previous user (in rotation) for <responder></responder>'
    }
});
var $d033dd3416c66da5$export$2e2bcd8739ae039 = $d033dd3416c66da5$var$messages;

});

parcelRegister("i43ks", function(module, exports) {

$parcel$export(module.exports, "transparentLozengeStyle", () => $be9e6d986b8eb923$export$8380a4df11e1761e);
$parcel$export(module.exports, "LozengeWrapper", () => $be9e6d986b8eb923$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "ActionButtons", () => $be9e6d986b8eb923$export$88c65d2d98aab183);
$parcel$export(module.exports, "StyledFlex", () => $be9e6d986b8eb923$export$a55749bd318314a5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $be9e6d986b8eb923$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $be9e6d986b8eb923$export$8380a4df11e1761e = {
    backgroundColor: 'transparent',
    color: "var(--ds-text-subtlest, #626F86)"
};
const $be9e6d986b8eb923$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gd28ew2"
})({
    name: "17j5deh",
    styles: "display:flex;align-items:center;height:21px;width:100%;flex-grow:0"
});
const $be9e6d986b8eb923$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1gd28ew1"
})({
    name: "14nrdl8",
    styles: "position:absolute;right:0;top:0"
});
const $be9e6d986b8eb923$export$a55749bd318314a5 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1gd28ew0"
})({
    name: "174290m",
    styles: "position:relative;padding-top:var(--ds-space-100, 8px);&:not(:hover, :focus, :active, :focus-visible, :focus-within){.eoc-escalation-policies-common-rule-action-buttons{visibility:hidden;}}"
});

});


parcelRegister("cCZJW", function(module, exports) {

$parcel$export(module.exports, "RuleInput", () => $4b5a33a9a683172d$export$7c680b50d89e62f7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $qfj8c = parcelRequire("qfj8c");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");

var $koJmi = parcelRequire("koJmi");
var $6TYWC = parcelRequire("6TYWC");

var $fXc9u = parcelRequire("fXc9u");

var $lsh84 = parcelRequire("lsh84");

var $lwUwi = parcelRequire("lwUwi");

var $b5104 = parcelRequire("b5104");
const $4b5a33a9a683172d$export$7c680b50d89e62f7 = ({ value: value, onChange: onChange, onCancel: onCancel, notifyTypes: notifyTypes, warningMessage: warningMessage })=>{
    const [responder] = (0, $fXc9u.useResponderNames)(value && !value.inlineResponder ? [
        {
            id: value.notifyId,
            type: value.type
        }
    ] : []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const notifyConditions = [
        {
            value: 'if-not-acked',
            label: formatMessage((0, $lwUwi.default).notAcknowledged)
        },
        {
            value: 'if-not-closed',
            label: formatMessage((0, $lwUwi.default).notClosed)
        }
    ];
    const [notifyCondition, setNotifyCondition] = (0, $5uXOq.useState)(notifyConditions[0]);
    const [notifyType, setNotifyType] = (0, $5uXOq.useState)(notifyTypes.find((type)=>!type.disabled));
    const [time, setTime] = (0, $5uXOq.useState)('0');
    const [selectedResponder, setSelectedResponder] = (0, $5uXOq.useState)();
    const [isSelectedResponderChanged, setIsSelectedResponderChanged] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (value) {
            setNotifyCondition(notifyConditions.find((condition)=>condition.value === value.notifyCondition));
            setNotifyType(notifyTypes.find((notifyType)=>notifyType?.value === value.notifyType && notifyType?.type === value.type));
            setTime(value.time.toString());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (value) {
            if (value.inlineResponder) {
                setSelectedResponder(value.inlineResponder);
                setIsSelectedResponderChanged(true);
                return;
            }
            if ((0, $lsh84.isResponderDeleted)(responder)) {
                setSelectedResponder(null);
                return;
            }
            if (responder && !responder.isLoading && !responder.isError) {
                setSelectedResponder({
                    label: responder.name,
                    value: responder.id,
                    type: responder.type
                });
                setIsSelectedResponderChanged(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        responder
    ]);
    const handleNotifyConditionChange = (selectedOption)=>{
        setNotifyCondition(selectedOption);
    };
    const handleTimeChange = (value)=>{
        if (value.startsWith('0') && value.length > 1) {
            const newValue = value.replace(/^0+/, '');
            setTime(newValue);
            return;
        }
        setTime(value);
    };
    const handleNotifyTypeChange = (selectedOption)=>{
        setNotifyType(selectedOption);
        const hasNewType = selectedOption.type !== notifyType?.type;
        if (hasNewType) {
            setIsSelectedResponderChanged(false);
            setSelectedResponder(null);
        }
    };
    const handleResponderChange = (selectedOption)=>{
        setIsSelectedResponderChanged(true);
        setSelectedResponder(selectedOption);
    };
    const validateTimeInput = ()=>{
        if (time) {
            if (!/^(|-?\d+)$/.test(time)) return formatMessage((0, $lwUwi.default).validNumber);
        }
        const timeInt = parseInt(time, 10);
        if (timeInt !== 0 && !time) return formatMessage((0, $lwUwi.default).fieldRequired);
        if (timeInt > 1440) return formatMessage((0, $lwUwi.default).timeMaxLimit);
        if (timeInt < 0) return formatMessage((0, $lwUwi.default).timeMinLimit);
        return '';
    };
    const validateResponderInput = (fromSave)=>{
        if (fromSave && !selectedResponder) {
            setIsSelectedResponderChanged(true);
            return formatMessage((0, $lwUwi.default).fieldRequired);
        }
        if (!selectedResponder && isSelectedResponderChanged && (0, $lsh84.isResponderDeleted)(responder)) return formatMessage((0, $lwUwi.default).deletedFieldRequired);
        if (isSelectedResponderChanged && !selectedResponder) return formatMessage((0, $lwUwi.default).fieldRequired);
        return '';
    };
    const handleSave = ()=>{
        const isTimeInvalid = validateTimeInput();
        const isResponderInvalid = validateResponderInput(true);
        if (!!isTimeInvalid || !!isResponderInvalid) return;
        if (!isTimeInvalid || !isResponderInvalid) {
            const values = {
                notifyCondition: notifyCondition.value,
                type: notifyType.type,
                notifyType: notifyType.value,
                time: parseInt(time, 10),
                notifyId: selectedResponder.value,
                inlineResponder: selectedResponder
            };
            if (onChange) onChange(values);
        }
    };
    const getAutoCompleteEndpoint = ()=>{
        if (notifyType?.type === 'escalation') return [
            (0, $6TYWC.getEscalations)
        ];
        if (notifyType?.type === 'schedule') return [
            (0, $6TYWC.getSchedules)
        ];
        if (notifyType?.type === 'team') return [
            (0, $6TYWC.getTeams)
        ];
        return [
            (0, $6TYWC.getUsers)
        ];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.Text), null, formatMessage((0, $lwUwi.default).ifTheAlertIs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        options: notifyConditions,
        value: notifyCondition,
        onChange: handleNotifyConditionChange,
        menuPosition: "fixed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.MinuteContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        name: "time",
        "aria-label": "time",
        value: time,
        onKeyPress: (e)=>{
            if (e.key === '.' || e.key === ',' || e.key === 'e') e.preventDefault();
        },
        onChange: (e)=>handleTimeChange(e.currentTarget.value),
        type: "number",
        min: "0",
        max: "1440",
        step: "1",
        isInvalid: !!validateTimeInput()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.Text), null, formatMessage((0, $lwUwi.default).minutesAfterCreation)), validateTimeInput() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.ErrorMessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, validateTimeInput())))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.Text), null, formatMessage((0, $lwUwi.default).then)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        options: notifyTypes,
        value: notifyType,
        isOptionSelected: (option, [selectedOption])=>option.value === selectedOption.value && option.type === selectedOption.type,
        onChange: handleNotifyTypeChange,
        isMulti: false,
        isOptionDisabled: (option)=>option.disabled,
        menuPosition: "fixed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koJmi.AutoComplete), {
        endpoints: getAutoCompleteEndpoint(),
        placeholder: (0, $lsh84.isResponderDeleted)(responder) ? formatMessage((0, $lwUwi.default).deletedResponder) : formatMessage((0, $lwUwi.default).searchFor, {
            type: notifyType.type
        }),
        onChange: handleResponderChange,
        isInvalid: !!validateResponderInput(),
        isLoading: responder?.isLoading,
        value: selectedResponder,
        menuPosition: "fixed"
    }), validateResponderInput() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.ErrorMessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, validateResponderInput()))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.ActionButtons), null, warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5104.WarningMessageWrapper), null, warningMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $lwUwi.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: handleSave
    }, formatMessage((0, $lwUwi.default).save)))));
};

});
parcelRegister("koJmi", function(module, exports) {

$parcel$export(module.exports, "AutoComplete", () => $7c56771a8e963d5b$export$6b41f50dc0c59fb3);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $jZpi1 = parcelRequire("jZpi1");

var $5IIdi = parcelRequire("5IIdi");
const $7c56771a8e963d5b$export$6b41f50dc0c59fb3 = (props)=>{
    const getAutoCompleteOptions = (0, $5IIdi.useAutoCompleteOptions)(props.endpoints);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        menuPosition: "absolute",
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        loadOptions: getAutoCompleteOptions,
        ...props,
        components: {
            Option: (0, $jZpi1.AutoCompleteCustomOption),
            ...props.components
        }
    });
};

});
parcelRegister("jZpi1", function(module, exports) {

$parcel$export(module.exports, "AutoCompleteCustomOption", () => $2379c76481a40a8a$export$1af480cd27f881cb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7sUFC = parcelRequire("7sUFC");
var $ujWmd = parcelRequire("ujWmd");

var $fTQ6p = parcelRequire("fTQ6p");

var $bZNwM = parcelRequire("bZNwM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $bChGW = parcelRequire("bChGW");

var $liax7 = parcelRequire("liax7");
const $2379c76481a40a8a$export$1af480cd27f881cb = (props)=>{
    const { data: data } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const responderOption = (0, $5uXOq.useMemo)(()=>{
        let defaultConfig = {
            primaryText: data.label
        };
        switch(data.type){
            case 'user':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        src: data.avatarUrl
                    }),
                    secondaryText: data.email
                };
            case 'escalation':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
                        color: "currentColor",
                        label: formatMessage((0, $liax7.messages).escalation),
                        spacing: "spacious"
                    })
                };
            case 'schedule':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fTQ6p))), {
                        label: formatMessage((0, $liax7.messages).schedule),
                        spacing: "spacious"
                    })
                };
            case 'group':
            case 'team':
                return {
                    ...defaultConfig,
                    avatar: data.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        src: data.avatarUrl
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                        label: formatMessage((0, $liax7.messages).team),
                        spacing: "spacious"
                    })
                };
            default:
                throw new Error('Incorrect data type is provided or it is missing!');
        }
    }, [
        data.avatarUrl,
        data.email,
        data.label,
        data.type,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
        avatar: responderOption.avatar,
        primaryText: responderOption.primaryText,
        secondaryText: responderOption.secondaryText
    }));
};

});
parcelRegister("fTQ6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cac5a72d7466b1013dda7da8cfdf1ce3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9346889cb60921a$var$_react = $b9346889cb60921a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b9346889cb60921a$var$_calendar = $b9346889cb60921a$var$_interopRequireDefault((parcelRequire("3fesp")));

var $b9346889cb60921a$var$_calendarFilled = $b9346889cb60921a$var$_interopRequireDefault((parcelRequire("bm9C8")));
function $b9346889cb60921a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9346889cb60921a$var$CalendarIcon = (props)=>/*#__PURE__*/ $b9346889cb60921a$var$_react.default.createElement($b9346889cb60921a$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $b9346889cb60921a$var$_calendarFilled.default
    }, props));
$b9346889cb60921a$var$CalendarIcon.Name = 'CalendarIconMigration';
var $b9346889cb60921a$var$_default = module.exports.default = $b9346889cb60921a$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3c6678ca49b47a08391fd96c442f9a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("bm9C8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $844934f4eb646769$var$_react = $844934f4eb646769$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $844934f4eb646769$var$_calendar = $844934f4eb646769$var$_interopRequireDefault((parcelRequire("3fesp")));
function $844934f4eb646769$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $844934f4eb646769$var$CalendarFilledIcon = (props)=>/*#__PURE__*/ $844934f4eb646769$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M19 5h.005C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5H5v1c0 1.112.895 2 2 2 1.112 0 2-.895 2-2V5h6v1c0 1.112.895 2 2 2 1.112 0 2-.895 2-2z"/><path fill="inherit" d="M7 13h2v-2H7zm0 4h2v-2H7zm4-4h2v-2h-2zm0 4h2v-2h-2zm4-4h2v-2h-2zm0 4h2v-2h-2z"/><path fill="currentcolor" d="M16 6V5h2v1a1 1 0 0 1-2 0m0-2a1 1 0 0 1 2 0v1h-2zM6 4a1 1 0 0 1 2 0v1H6zm0 2V5h2v1a1 1 0 0 1-2 0"/></g></svg>`
    }, props, {
        newIcon: $844934f4eb646769$var$_calendar.default
    }));
$844934f4eb646769$var$CalendarFilledIcon.displayName = 'CalendarFilledIcon';
var $844934f4eb646769$var$_default = module.exports.default = $844934f4eb646769$var$CalendarFilledIcon;

});


parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3be954ea5d070f5903d5961389b0e8fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("7EZ5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3611c0152bc32ad7e4a8e40b5d90bbb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $593ba794a5c6525a$var$_react = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $593ba794a5c6525a$var$_baseNew = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $593ba794a5c6525a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $593ba794a5c6525a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $593ba794a5c6525a$var$_react.default.createElement($593ba794a5c6525a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1v9.75M15 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25m0 0 4.5-4.5L8.5 8.5l5.25-5.25m.5 3.75V2.75H10"/>`
    }, props));
$593ba794a5c6525a$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $593ba794a5c6525a$var$_default = module.exports.default = $593ba794a5c6525a$var$ChartTrendIcon;

});

parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("liax7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d851cfba5f716e38$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d851cfba5f716e38$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    team: {
        id: 'eoc.auto-complete.custom-option.team-icon.no-translate',
        defaultMessage: 'Group',
        description: 'Label of group icon that indicates responder is a group'
    },
    schedule: {
        id: 'eoc.auto-complete.custom-option.schedule-icon.no-translate',
        defaultMessage: 'Calendar',
        description: 'Label of calendar icon that indicates responder is a schedule'
    },
    escalation: {
        id: 'eoc.auto-complete.custom-option.escalation-icon.no-translate',
        defaultMessage: 'Chart',
        description: 'Label of chart icon that indicates responder is a escalation'
    },
    user: {
        id: 'eoc.auto-complete.custom-option.user-icon.no-translate',
        defaultMessage: 'User',
        description: 'Label of user icon that indicates responder is a user'
    }
});

});


parcelRegister("5IIdi", function(module, exports) {

$parcel$export(module.exports, "useAutoCompleteOptions", () => $735d26251c8e20ba$export$f95737357eb49713);

var $iCBcG = parcelRequire("iCBcG");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $aI12f = parcelRequire("aI12f");
var $2tKfK = parcelRequire("2tKfK");
const $735d26251c8e20ba$export$f95737357eb49713 = (endpoints)=>{
    const { showFlag: showFlag } = (0, $2tKfK.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($iCBcG)))((inputValue)=>{
        return Promise.all(endpoints.map((endpoint)=>{
            return endpoint({
                keyword: inputValue
            });
        })).then((response)=>response.flatMap((r)=>r.values).map((r)=>({
                    label: r.name,
                    value: r.id,
                    ...r
                }))).catch((error)=>{
            // If we cancel one of the request we shouldn't display toast
            if ((0, $aI12f.isNetworkError)(error) && error.cause instanceof DOMException) return;
            throw error;
        }).catch(defaultCatch({
            id: 'useAutoCompleteOptions',
            httpErrorHandler: (error)=>{
                showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    title: error.message,
                    isAutoDismiss: true
                });
            }
        }));
    }, 300);
};

});
parcelRegister("iCBcG", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d8e8a274648ab511$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d8e8a274648ab511$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d8e8a274648ab511$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d8e8a274648ab511$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});



parcelRegister("6TYWC", function(module, exports) {

$parcel$export(module.exports, "getSchedules", () => $fce90edcc1d0a2e4$export$db731c12fd4796f8);
$parcel$export(module.exports, "getEscalations", () => $fce90edcc1d0a2e4$export$300727380b60aeb4);
$parcel$export(module.exports, "getUsers", () => $fce90edcc1d0a2e4$export$925a4945a6cd0f3e);
$parcel$export(module.exports, "getTeams", () => $fce90edcc1d0a2e4$export$5a622455e94bac3);
$parcel$export(module.exports, "getResponders", () => $fce90edcc1d0a2e4$export$a7fc05d077ca06b5);

var $j74qU = parcelRequire("j74qU");
const $fce90edcc1d0a2e4$export$eae9a4162e9fa557 = '50';
const $fce90edcc1d0a2e4$export$daf3f4a975b45a66 = (types)=>{
    return ({ keyword: keyword }, signalParam, limit = $fce90edcc1d0a2e4$export$eae9a4162e9fa557)=>{
        const params = new URLSearchParams({
            ...types && {
                types: types.join(',')
            },
            ...keyword && {
                keyword: keyword
            },
            limit: limit
        });
        return (0, $j74qU.eocFetch)(`/v1/alerts/responders/auto-complete?${params.toString()}`, signalParam);
    };
};
const $fce90edcc1d0a2e4$export$db731c12fd4796f8 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'schedule'
]);
const $fce90edcc1d0a2e4$export$300727380b60aeb4 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'escalation'
]);
const $fce90edcc1d0a2e4$export$925a4945a6cd0f3e = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'user'
]);
const $fce90edcc1d0a2e4$export$5a622455e94bac3 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'team'
]);
const $fce90edcc1d0a2e4$export$a7fc05d077ca06b5 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66();

});

parcelRegister("lwUwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f32d24addd8db68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4f32d24addd8db68$var$messages = (0, $7VHMR.defineMessages)({
    notAcknowledged: {
        id: 'eoc.escalation-policies.common.ui.rule-input.not-acknowledged.no-translate',
        defaultMessage: 'Not acknowledged',
        description: 'Label of notify condition not acknowledged option'
    },
    notClosed: {
        id: 'eoc.escalation-policies.common.ui.rule-input.not-closed.no-translate',
        defaultMessage: 'Not closed',
        description: 'Label of notify condition not closed option'
    },
    ifTheAlertIs: {
        id: 'eoc.escalation-policies.common.ui.rule-input.if-the-alert-is.no-translate',
        defaultMessage: 'If the alert is',
        description: 'The prefix of notify condition input'
    },
    minutesAfterCreation: {
        id: 'eoc.escalation-policies.common.ui.rule-input.minutes-after-creation.no-translate',
        defaultMessage: 'minutes after creation,',
        description: 'The suffix of number input'
    },
    then: {
        id: 'eoc.escalation-policies.common.ui.rule-input.then.no-translate',
        defaultMessage: 'then',
        description: 'The prefix of notify type input'
    },
    notifyUser: {
        id: 'eoc.escalation-policies.common.ui.notify-user.no-translate',
        defaultMessage: 'Notify user',
        description: 'The label of notify type "notify user" option'
    },
    notifyUsersInSchedule: {
        id: 'eoc.escalation-policies.common.ui.notify-users-in-schedule.no-translate',
        defaultMessage: 'Notify on-call user(s) in schedule',
        description: 'The label of notify type "Notify on-call user(s) in schedule" option'
    },
    routeToTeam: {
        id: 'eoc.escalation-policies.common.ui.route-to-team.no-translate',
        defaultMessage: 'Route to team',
        description: 'The label of notify type "Route to team" option'
    },
    notifyNextUserInRotationForSchedule: {
        id: 'eoc.escalation-policies.common.ui.notify-next-user-in-rotation-for-schedule.no-translate',
        defaultMessage: 'Notify next user (in rotation) for schedule',
        description: 'The label of notify type "Notify next user (in rotation) for schedule" option'
    },
    notifyPreviousUserInRotationForSchedule: {
        id: 'eoc.escalation-policies.common.ui.notify-previous-user-in-rotation-for-schedule.no-translate',
        defaultMessage: 'Notify previous user (in rotation) for schedule',
        description: 'The label of notify type "Notify previous user (in rotation) for schedule" option'
    },
    notifyAllMembersOfTeam: {
        id: 'eoc.escalation-policies.common.ui.notify-all-members-of-team.no-translate',
        defaultMessage: 'Notify all members of team',
        description: 'The label of notify type "Notify all members of team" option'
    },
    notifyAdminsOfTeam: {
        id: 'eoc.escalation-policies.common.ui.notify-admins-of-team.no-translate',
        defaultMessage: 'Notify admin(s) of team',
        description: 'The label of notify type "Notify admin(s) of team" option'
    },
    notifyUsersOfTeam: {
        id: 'eoc.escalation-policies.common.ui.notify-users-of-team.no-translate',
        defaultMessage: 'Notify user(s) of team',
        description: 'The label of notify type "Notify user(s) of team" option'
    },
    notifyRandomMemberOfTeam: {
        id: 'eoc.escalation-policies.common.ui.notify-random-member-of-team.no-translate',
        defaultMessage: 'Notify random member of team',
        description: 'The label of notify type "Notify random member of team" option'
    },
    searchFor: {
        id: 'eoc.escalation-policies.common.ui.search-for.no-translate',
        defaultMessage: `Search for {type, select,
      user {user}
      schedule {schedule}
      other {team}
    }`,
        description: 'Placeholder of search {type} input'
    },
    timeMaxLimit: {
        id: 'eoc.escalation-policies.common.ui.time-max-limit.no-translate',
        defaultMessage: `Rule time cannot be greater than 1440 minutes.`,
        description: 'Error message of time limit that shown if time is bigger than 1440 minutes'
    },
    timeMinLimit: {
        id: 'eoc.escalation-policies.common.ui.time-min-limit.no-translate',
        defaultMessage: `Rule time cannot be negative number.`,
        description: 'Error message of time limit that shown if time is lesser than 0 minute'
    },
    fieldRequired: {
        id: 'eoc.escalation-policies.common.ui.field-required.no-translate',
        defaultMessage: `This field is required.`,
        description: 'Error message of inputs that shown when there is no value'
    },
    validNumber: {
        id: 'eoc.escalation-policies.common.ui.valid-number.no-translate',
        defaultMessage: `Enter a valid number.`,
        description: 'Error message of inputs that shown when there is no value'
    },
    save: {
        id: 'eoc.escalation-policies.common.ui.save.no-translate',
        defaultMessage: `Save`,
        description: 'Label of save rule input button'
    },
    cancel: {
        id: 'eoc.escalation-policies.common.ui.cancel.no-translate',
        defaultMessage: `Cancel`,
        description: 'Label of cancel rule input button'
    },
    deletedResponder: {
        id: 'eoc.escalation-policies.common.ui.deleted-responder.no-translate',
        defaultMessage: 'Deleted responder',
        description: 'Placeholder when responder is deleted'
    },
    deletedFieldRequired: {
        id: 'eoc.escalation-policies.common.ui.deleted-field-required.no-translate',
        defaultMessage: 'Select another responder.',
        description: 'Error message of inputs that shown when responder is deleted'
    }
});
var $4f32d24addd8db68$export$2e2bcd8739ae039 = $4f32d24addd8db68$var$messages;

});

parcelRegister("b5104", function(module, exports) {

$parcel$export(module.exports, "Container", () => $4c8d66fbf3dc8890$export$42a852a2b6b56249);
$parcel$export(module.exports, "Row", () => $4c8d66fbf3dc8890$export$b59bdbef9ce70de2);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $4c8d66fbf3dc8890$export$9e874bb1adc98a55);
$parcel$export(module.exports, "MinuteContainer", () => $4c8d66fbf3dc8890$export$a68386ec551404e7);
$parcel$export(module.exports, "Text", () => $4c8d66fbf3dc8890$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "ActionButtons", () => $4c8d66fbf3dc8890$export$88c65d2d98aab183);
$parcel$export(module.exports, "WarningMessageWrapper", () => $4c8d66fbf3dc8890$export$2c724ccd28c90e5d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $4c8d66fbf3dc8890$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4c8d66fbf3dc8890$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eeak5hy6"
})({
    name: "1dpw8l1",
    styles: "background:var(--ds-surface, #ffffff);box-shadow:var(--ds-shadow-raised, 0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25));border-radius:var(--ds-border-radius-100, 3px);padding:var(--ds-space-150, 12px);z-index:1;position:relative"
});
const $4c8d66fbf3dc8890$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eeak5hy5"
})({
    name: "fnuxvg",
    styles: "display:grid;grid-template-columns:0.3fr repeat(2, 1fr);grid-column-gap:var(--ds-space-150, 12px);&:not(:first-of-type){margin-top:var(--ds-space-100, 8px);}"
});
const $4c8d66fbf3dc8890$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eeak5hy4"
})({
    name: "1uffwd7",
    styles: "grid-column:2 span"
});
const $4c8d66fbf3dc8890$export$a68386ec551404e7 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eeak5hy3"
})({
    name: "1udy5el",
    styles: "display:grid;grid-template-columns:0.35fr 1fr;grid-column-gap:var(--ds-space-150, 12px);input::-webkit-outer-spin-button, input::-webkit-inner-spin-button, input[type='number']{-webkit-appearance:none;-moz-appearance:textfield;}"
});
const $4c8d66fbf3dc8890$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eeak5hy2"
})({
    name: "hm5tta",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);color:var(--ds-text-subtlest, #626F86);margin-top:0;display:flex;height:40px;align-items:center"
});
const $4c8d66fbf3dc8890$export$88c65d2d98aab183 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eeak5hy1"
})({
    display: 'flex',
    justifyContent: 'flex-end',
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $4c8d66fbf3dc8890$export$2c724ccd28c90e5d = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "eeak5hy0"
})({
    alignItems: 'center',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
    marginRight: "var(--ds-space-300, 24px)"
});

});



parcelRegister("ibfj9", function(module, exports) {

$parcel$export(module.exports, "FieldResetter", () => $f3aaecb2649be6b5$export$19e4c5fdd36bc992);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $f3aaecb2649be6b5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f3aaecb2649be6b5$export$19e4c5fdd36bc992 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ej7uo4m0"
})({
    name: "keyfe3",
    styles: "margin-top:var(--ds-space-negative-100, -8px)"
});

});

parcelRegister("h830V", function(module, exports) {

$parcel$export(module.exports, "default", () => $999dbd1b0d3a1b1c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $999dbd1b0d3a1b1c$var$messages = (0, $7VHMR.defineMessages)({
    escalationRules: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.escalation-rules.no-translate',
        defaultMessage: 'Add escalation rules',
        description: 'Title of section seperator'
    },
    escalationRulesTooltip: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.escalation-rules-tooltip.no-translate',
        defaultMessage: 'Set rules to notify responders when the specified time is over and alert status meets your conditions.',
        description: 'Tooltip text of escalation rules seperator'
    },
    addRule: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.add-rule.no-translate',
        defaultMessage: 'Add rule',
        description: 'Label of add escalation rule button'
    },
    lastRule: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.last-rule.no-translate',
        defaultMessage: 'You can add only up to 50 rules. This is the last one.',
        description: 'Warning message that shown when user adding 49th method'
    },
    ruleLimit: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.rule-limit.no-translate',
        defaultMessage: 'This policy has a maximum limit of 50 escalation rules. To add a new rule, delete one or more existing rules.',
        description: 'Warning message that shown when user added 50 method'
    },
    isProcessing: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.is-processing.no-translate',
        defaultMessage: 'Save escalation rules before you continue.',
        description: 'Error shown when user tries to save escalation policy without confirming escalation rules.'
    }
});
var $999dbd1b0d3a1b1c$export$2e2bcd8739ae039 = $999dbd1b0d3a1b1c$var$messages;

});

parcelRegister("1Ukfy", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $696217f0b307321e$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "WarningWrapper", () => $696217f0b307321e$export$e2229b703bf96afa);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fVnbM = parcelRequire("fVnbM");


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $696217f0b307321e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $696217f0b307321e$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $bWGt6.default)((0, $fVnbM.default), {
    target: "e1dj5yh41"
})({
    name: "1l5w2mg",
    styles: "align-items:center;margin-top:var(--ds-space-100, 8px)"
});
const $696217f0b307321e$export$e2229b703bf96afa = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1dj5yh40"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
    alignItems: 'center',
    columnGap: "var(--ds-space-100, 8px)",
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("3FaMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b947c1af76a9abe3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b947c1af76a9abe3$var$messages = (0, $7VHMR.defineMessages)({
    createTitle: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.create-title.no-translate',
        defaultMessage: 'Create escalation policy',
        description: 'Title of create an escalation modal'
    },
    editTitle: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.edit-title.no-translate',
        defaultMessage: 'Edit escalation policy',
        description: 'Title of edit an escalation modal'
    },
    cloneTitle: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.clone-title.no-translate',
        defaultMessage: 'Duplicate escalation policy',
        description: 'Title of create an escalation modal'
    },
    cancel: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.cancel.no-translate',
        defaultMessage: 'Cancel',
        description: 'Label of cancel button'
    },
    create: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.create.no-translate',
        defaultMessage: 'Create',
        description: 'Label of create button'
    },
    clone: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.clone.no-translate',
        defaultMessage: 'Duplicate',
        description: 'Label of clone button'
    },
    update: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.update.no-translate',
        defaultMessage: 'Save',
        description: 'Label of update button'
    },
    infoSection: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.info-section-title.no-translate',
        defaultMessage: `The
    {deletedEntityCount, plural,
      one {responder}
      other {responders}
    }
     you added no longer exists. Select another one.
    `,
        description: 'Informative text in the info section for deleted entity'
    }
});
var $b947c1af76a9abe3$export$2e2bcd8739ae039 = $b947c1af76a9abe3$var$messages;

});

parcelRegister("4n1CW", function(module, exports) {

$parcel$export(module.exports, "NameInputs", () => $716a73ef6410977c$export$6f92e66413227fa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $1aMzM = parcelRequire("1aMzM");

var $ibfj9 = parcelRequire("ibfj9");

var $01C5I = parcelRequire("01C5I");
const $716a73ef6410977c$export$6f92e66413227fa = ({ name: name, description: description, isCloning: isCloning, escalationNames: escalationNames })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        label: formatMessage((0, $01C5I.default).name),
        name: "name",
        defaultValue: isCloning ? '' : name || '',
        isRequired: true,
        "aria-required": true,
        validate: (val)=>{
            if (!val) return formatMessage((0, $1aMzM.default).fieldRequired);
            if (escalationNames?.includes(val) && val !== name) return formatMessage((0, $1aMzM.default).alreadyExist, {
                name: val
            });
        }
    }, ({ fieldProps: { isRequired: isRequired, ...fieldProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            autoComplete: "off",
            placeholder: formatMessage((0, $01C5I.default).namePlaceholder),
            ...fieldProps
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        label: formatMessage((0, $01C5I.default).description),
        name: "description",
        defaultValue: description || ''
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            autoComplete: "off",
            placeholder: formatMessage((0, $01C5I.default).descriptionPlaceholder),
            ...fieldProps
        }))));
};

});
parcelRegister("01C5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc5f2079f7a016c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dc5f2079f7a016c4$var$messages = (0, $7VHMR.defineMessages)({
    name: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.name.no-translate',
        defaultMessage: 'Name',
        description: 'Label of name input'
    },
    namePlaceholder: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.name-placeholder.no-translate',
        defaultMessage: 'Enter a name for the policy',
        description: 'Placeholder of name input'
    },
    description: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.description.no-translate',
        defaultMessage: 'Description',
        description: 'Label of description input'
    },
    descriptionPlaceholder: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.description-placeholder.no-translate',
        defaultMessage: 'Enter a description',
        description: 'Placeholder of description input'
    }
});
var $dc5f2079f7a016c4$export$2e2bcd8739ae039 = $dc5f2079f7a016c4$var$messages;

});


parcelRegister("iLe3F", function(module, exports) {

$parcel$export(module.exports, "RepeatEscalationInputs", () => $e5b5598d14240e24$export$340eb890945a496);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $kkJfY = parcelRequire("kkJfY");

var $hp1g9 = parcelRequire("hp1g9");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $2x3Cb = parcelRequire("2x3Cb");

var $l1N8i = parcelRequire("l1N8i");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");

var $dTlW6 = parcelRequire("dTlW6");

var $dY87H = parcelRequire("dY87H");

var $lsh84 = parcelRequire("lsh84");

var $ibfj9 = parcelRequire("ibfj9");

var $dSYNN = parcelRequire("dSYNN");

var $kp2ll = parcelRequire("kp2ll");
const $e5b5598d14240e24$export$340eb890945a496 = ({ repeat: repeat, maxRepeatCount: maxRepeatCount, unAckWhileRepeating: unAckWhileRepeating, closeAlertWhenRepeatsCompleted: closeAlertWhenRepeatsCompleted })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isRepeating, setIsRepeating] = (0, $5uXOq.useState)(repeat ? repeat > 0 : false);
    const [repeatError, setRepeatError] = (0, $5uXOq.useState)();
    const minuteOptions = (0, $lsh84.generateMinuteOptions)();
    const getDefaultMaxRepeatTime = ()=>{
        if (maxRepeatCount) return minuteOptions.find((option)=>option.value === maxRepeatCount);
        return minuteOptions[0];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "flex-start",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 0.5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage((0, $dSYNN.default).repeatEscalation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kp2ll.Text), null, formatMessage((0, $dSYNN.default).repeatEscalationDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kp2ll.RepeatInputWrapper), {
        "data-testid": "escalation-policy-modal.repeat-wrapper",
        isVisible: isRepeating
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: ""
    }, formatMessage((0, $dSYNN.default).repeat)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center",
        columnGap: 1
    }, formatMessage((0, $dSYNN.default).repeatEscalationInput, {
        input: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kp2ll.MinuteInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                name: "repeat",
                defaultValue: repeat ? repeat : isRepeating ? 1 : 0,
                validate: (val)=>{
                    if (val !== 0 && !val) {
                        setRepeatError(formatMessage((0, $dSYNN.default).fieldRequired));
                        return formatMessage((0, $dSYNN.default).fieldRequired);
                    }
                    if (val > 1440) {
                        setRepeatError(formatMessage((0, $dSYNN.default).repeatMaxLimit));
                        return formatMessage((0, $dSYNN.default).repeatMaxLimit);
                    }
                    if (val < 0) {
                        setRepeatError(formatMessage((0, $dSYNN.default).repeatMinLimit));
                        return formatMessage((0, $dSYNN.default).repeatMinLimit);
                    }
                    setRepeatError('');
                    return '';
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                    type: "number",
                    min: "0",
                    max: "1440",
                    ...fieldProps
                })))),
        select: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kp2ll.SelectWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                name: "maxRepeatCount",
                defaultValue: getDefaultMaxRepeatTime()
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                    menuPosition: "fixed",
                    options: minuteOptions,
                    ...fieldProps
                }))))
    })), repeatError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, repeatError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: ""
    }, formatMessage((0, $dSYNN.default).actions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hp1g9.default), {
        name: "unAckWhileRepeating",
        defaultIsChecked: unAckWhileRepeating || false
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
            ...fieldProps,
            label: formatMessage((0, $dSYNN.default).ifAlertIsNotClosed)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hp1g9.default), {
        name: "closeAlertWhenRepeatsCompleted",
        defaultIsChecked: closeAlertWhenRepeatsCompleted || false
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
            ...fieldProps,
            label: formatMessage((0, $dSYNN.default).ifEscalationRepeats)
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "repeatEnabled",
        defaultValue: repeat !== 0
    }, ({ fieldProps: { onChange: onChange, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
            ...fieldProps,
            label: formatMessage((0, $dSYNN.default).repeatEscalation),
            isChecked: isRepeating,
            value: String(fieldProps.value),
            onChange: (e)=>{
                setIsRepeating(e.currentTarget.checked);
                onChange(e);
            }
        })))));
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");


var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $3106eb14f9b0a593$var$checkboxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $3106eb14f9b0a593$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kag1C.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hsLv2.default), null, label, isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e62YQ.default), null)));
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $7b368d644c230660$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $7b368d644c230660$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $7b368d644c230660$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $7b368d644c230660$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $7b368d644c230660$var$baseStyles,
            label && $7b368d644c230660$var$textLabelLayoutStyles,
            isDisabled && $7b368d644c230660$var$disabledStyles,
            $7b368d644c230660$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce636d67b4ff1120$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $ce636d67b4ff1120$var$labelTextStyles
    }, children);
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2156c28a3894cac$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d2156c28a3894cac$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*"));
}

});


parcelRegister("hp1g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccbe97401ecc0bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: !!fieldValue.find((v)=>v === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: fieldValue,
                value: value
            },
            ...others
        }));
};
$9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;

});

parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_18s8v77o _1yt4v77o _v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ])
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lahQ6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lahQ6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    })));
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2b3d74d01725a5e998bf107ea1b09c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6349e25a79f10f7ca6cae195737423f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right)
    }, children);
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("dSYNN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7670fae07bc8e18f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7670fae07bc8e18f$var$messages = (0, $7VHMR.defineMessages)({
    repeatEscalation: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat-escalation.no-translate',
        defaultMessage: 'Repeat the escalation',
        description: 'Title of section separator'
    },
    repeatEscalationDescription: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat-escalation-description.no-translate',
        defaultMessage: "If alerts aren't acknowledged, turning this on will repeat escalations after a specified duration for a specified number of times. You can also set it to automatically close the alerts when the escalation repetitions are completed.",
        description: 'Description of repeat escalation section'
    },
    repeat: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat.no-translate',
        defaultMessage: 'Repeat',
        description: 'Label of repeat input'
    },
    actions: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.actions.no-translate',
        defaultMessage: 'Actions',
        description: 'Label of actions'
    },
    ifAlertIsNotClosed: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.if-alert-is-not-closed.no-translate',
        defaultMessage: 'Change the alert status to open (even if acknowledged or seen already) on every repeat',
        description: 'Label of actions first checkbox'
    },
    ifEscalationRepeats: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.if-escalation-repeats.no-translate',
        defaultMessage: 'Close the alert automatically when the repeats are over',
        description: 'Label of actions second checkbox'
    },
    repeatEscalationInput: {
        id: 'eoc.escalation-policies.ui.escalation-policy-modal.repeat-escalation-input.no-translate',
        defaultMessage: '<input></input> minute(s) after processing the last escalation rule <select></select> times',
        description: 'Full line of repeat escalation input. example: <input> minute(s) after processing the last escalation rule <select> times'
    },
    repeatMaxLimit: {
        id: 'eoc.escalation-policies.common.ui.repeat-max-limit.no-translate',
        defaultMessage: `Repeat time cannot be greater than 1440 minutes.`,
        description: 'Error message of time limit that shown if time is bigger than 1440 minutes'
    },
    repeatMinLimit: {
        id: 'eoc.escalation-policies.common.ui.repeat-min-limit.no-translate',
        defaultMessage: `Repeat time cannot be negative number.`,
        description: 'Error message of time limit that shown if time is lesser than 0 minute'
    },
    fieldRequired: {
        id: 'eoc.escalation-policies.common.ui.field-required.no-translate',
        defaultMessage: `This field is required.`,
        description: 'Error message of inputs that shown when there is no value'
    }
});
var $7670fae07bc8e18f$export$2e2bcd8739ae039 = $7670fae07bc8e18f$var$messages;

});

parcelRegister("kp2ll", function(module, exports) {

$parcel$export(module.exports, "Text", () => $090568c39dcf1e41$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "RepeatInputWrapper", () => $090568c39dcf1e41$export$9d47bb93095b6586);
$parcel$export(module.exports, "MinuteInputWrapper", () => $090568c39dcf1e41$export$56ee7537cadcd317);
$parcel$export(module.exports, "SelectWrapper", () => $090568c39dcf1e41$export$d586e0ae81c7b89b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $090568c39dcf1e41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $090568c39dcf1e41$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1b7b623"
})({
    name: "lvkd1z",
    styles: "margin-top:var(--ds-space-050, 4px)"
});
const $090568c39dcf1e41$export$9d47bb93095b6586 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b7b622"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isVisible ? 'flex' : 'none'
    }));
const $090568c39dcf1e41$export$56ee7537cadcd317 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b7b621"
})({
    maxWidth: `${56}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button, input[type='number']": {
        WebkitAppearance: 'none',
        MozAppearance: 'textfield'
    }
});
const $090568c39dcf1e41$export$d586e0ae81c7b89b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1b7b620"
})({
    width: `${72}px`
});

});


parcelRegister("54wAN", function(module, exports) {

$parcel$export(module.exports, "SectionMessageContainer", () => $45df114af460da0a$export$e24f31d167719f38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $45df114af460da0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $45df114af460da0a$export$e24f31d167719f38 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eep1m70"
})({
    name: "3pkfjs",
    styles: "margin:var(--ds-space-300, 24px);margin-top:var(--ds-space-negative-100, -8px)"
});

});

parcelRegister("hUXm0", function(module, exports) {

$parcel$export(module.exports, "TeamInput", () => $225ae71bac580a35$export$eb748b4f52b41981);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7O4UO = parcelRequire("7O4UO");

var $koJmi = parcelRequire("koJmi");
var $6TYWC = parcelRequire("6TYWC");

var $fXc9u = parcelRequire("fXc9u");

var $ibfj9 = parcelRequire("ibfj9");

var $8YiX5 = parcelRequire("8YiX5");

var $9HMfF = parcelRequire("9HMfF");
const $225ae71bac580a35$export$eb748b4f52b41981 = ({ teamId: teamId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [responderTeam] = (0, $fXc9u.useResponderNames)(teamId ? [
        {
            type: 'team',
            id: teamId
        }
    ] : []);
    const defaultValue = (0, $5uXOq.useMemo)(()=>{
        if (responderTeam && 'name' in responderTeam) return {
            ...responderTeam,
            label: responderTeam.name,
            value: responderTeam.id
        };
    }, [
        responderTeam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibfj9.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "team",
        label: formatMessage((0, $8YiX5.default).label),
        defaultValue: defaultValue
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koJmi.AutoComplete), {
            ...fieldProps,
            endpoints: [
                (0, $6TYWC.getTeams)
            ],
            components: {
                DropdownIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
                Control: (0, $9HMfF.SelectControl)
            },
            placeholder: formatMessage((0, $8YiX5.default).placeholder),
            isLoading: responderTeam?.isLoading,
            isClearable: true
        })));
};

});
parcelRegister("8YiX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f1acbfab96c013$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c6f1acbfab96c013$var$messages = (0, $7VHMR.defineMessages)({
    label: {
        id: 'eoc.escalation-modal.form.label.no-translate',
        defaultMessage: 'Team',
        description: 'Label of team field.'
    },
    placeholder: {
        id: 'eoc.escalation-modal.form.placeholder.no-translate',
        defaultMessage: 'Search for a team',
        description: 'Label of team field.'
    }
});
var $c6f1acbfab96c013$export$2e2bcd8739ae039 = $c6f1acbfab96c013$var$messages;

});

parcelRegister("9HMfF", function(module, exports) {

$parcel$export(module.exports, "SelectControl", () => $f95de65e76e2b59b$export$bf14d6d11521c08e);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $bChGW = parcelRequire("bChGW");

var $8k22Y = parcelRequire("8k22Y");
const $f95de65e76e2b59b$export$bf14d6d11521c08e = ({ children: children, ...props })=>{
    const responder = props.selectProps.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, props, responder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
        responder: responder,
        size: "small"
    })), children);
};

});
parcelRegister("8k22Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57b99ed8f2cadab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");

var $aIXQ3 = parcelRequire("aIXQ3");

var $gdpBI = parcelRequire("gdpBI");
const $f57b99ed8f2cadab$var$ResponderAvatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { responder: responder, size: size } = props;
    if (responder.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: (0, $aIXQ3.DIMENSIONS)[size],
        height: (0, $aIXQ3.DIMENSIONS)[size],
        variant: "circle"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdpBI.LoadedResponderAvatar), {
        avatarRef: ref,
        ...props
    });
});
var $f57b99ed8f2cadab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f57b99ed8f2cadab$var$ResponderAvatar);

});
parcelRegister("aIXQ3", function(module, exports) {

$parcel$export(module.exports, "DIMENSIONS", () => $fd790a5c37255dd7$export$d67ac355184b7646);
$parcel$export(module.exports, "ICON_SIZE_MAPPER", () => $fd790a5c37255dd7$export$958e13c28bb9605e);
const $fd790a5c37255dd7$export$d67ac355184b7646 = {
    xsmall: 2,
    small: 3,
    medium: 4,
    large: 5
};
const $fd790a5c37255dd7$export$958e13c28bb9605e = {
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};

});

parcelRegister("gdpBI", function(module, exports) {

$parcel$export(module.exports, "LoadedResponderAvatar", () => $7a7b255aa33dc30a$export$63d9675085ad4c01);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ujWmd = parcelRequire("ujWmd");

var $42CjB = parcelRequire("42CjB");

var $fTQ6p = parcelRequire("fTQ6p");

var $bZNwM = parcelRequire("bZNwM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $aIXQ3 = parcelRequire("aIXQ3");

var $8LW0E = parcelRequire("8LW0E");
const $7a7b255aa33dc30a$var$AvatarWithDefault = ({ responder: responder, size: size, avatarRef: avatarRef, labelDescriptor: labelDescriptor, iconComponent: IconComponent, ...props })=>{
    const intlApi = (0, $koVbs.default)();
    const avatarUrl = 'avatarUrl' in responder ? responder.avatarUrl : undefined;
    if (avatarUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        label: intlApi.formatMessage(labelDescriptor),
        ...props,
        ref: avatarRef,
        size: size,
        src: avatarUrl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        ...props,
        ref: avatarRef,
        label: intlApi.formatMessage(labelDescriptor),
        size: size
    }, ({ 'aria-label': label, ref: ref, ...avatarProps })=>{
        return avatarProps.onClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: label,
            ...avatarProps,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
                    ...iconProps,
                    size: (0, $aIXQ3.ICON_SIZE_MAPPER)[size]
                })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
            label: intlApi.formatMessage(labelDescriptor),
            size: (0, $aIXQ3.ICON_SIZE_MAPPER)[size]
        });
    });
};
const $7a7b255aa33dc30a$var$UserResponderAvatar = ({ responder: responder, size: size, avatarRef: avatarRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        ref: avatarRef,
        label: formatMessage((0, $8LW0E.default).user),
        ...props,
        size: size,
        src: 'avatarUrl' in responder ? responder.avatarUrl : undefined
    });
};
const $7a7b255aa33dc30a$export$63d9675085ad4c01 = (props)=>{
    const responder = props.responder;
    switch(responder.type){
        case 'user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$UserResponderAvatar, props);
        case 'team':
        case 'group':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$AvatarWithDefault, {
                labelDescriptor: (0, $8LW0E.default).team,
                iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))),
                ...props
            });
        case 'schedule':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$AvatarWithDefault, {
                labelDescriptor: (0, $8LW0E.default).schedule,
                iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fTQ6p))),
                ...props
            });
        case 'escalation':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$AvatarWithDefault, {
                labelDescriptor: (0, $8LW0E.default).escalation,
                iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
                ...props
            });
    }
};

});
parcelRegister("8LW0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $468472130aa2cf0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $468472130aa2cf0b$var$messages = (0, $7VHMR.defineMessages)({
    team: {
        id: 'eoc.alert-common.custom-option.team-icon.no-translate',
        defaultMessage: 'Group',
        description: 'Label of group icon that indicates responder is a group'
    },
    schedule: {
        id: 'eoc.alert-common.custom-option.schedule-icon.no-translate',
        defaultMessage: 'Calendar',
        description: 'Label of calendar icon that indicates responder is a schedule'
    },
    escalation: {
        id: 'eoc.alert-common.custom-option.escalation-icon.no-translate',
        defaultMessage: 'Chart',
        description: 'Label of chart icon that indicates responder is a escalation'
    },
    user: {
        id: 'eoc.alert-common.custom-option.user-icon.no-translate',
        defaultMessage: 'User',
        description: 'Label of user icon that indicates responder is a user'
    }
});
var $468472130aa2cf0b$export$2e2bcd8739ae039 = $468472130aa2cf0b$var$messages;

});






parcelRegister("aLwrv", function(module, exports) {

$parcel$export(module.exports, "useTeamEscalationsController", () => $fda5fa154f02ef21$export$fda2b5690d459366);

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $8SpRt = parcelRequire("8SpRt");

var $hem2I = parcelRequire("hem2I");

var $c2LK1 = parcelRequire("c2LK1");

var $evNEP = parcelRequire("evNEP");
const $fda5fa154f02ef21$export$fda2b5690d459366 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: data } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    const { saveView: saveView, completeTask: completeTask, ...service } = (0, $c2LK1.useTeamEscalationsService)();
    const escalationsCommonController = (0, $evNEP.useEscalationsCommonController)(service);
    const toggleSection = ()=>{
        (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('useTeamEscalationsController-toggleSection', 'data should not be undefined'));
        const collapsed = data.escalations.collapsed;
        const newData = {
            ...data,
            escalations: {
                ...data.escalations,
                collapsed: !collapsed
            }
        };
        saveView(newData).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy collapsed', {
                collapsed: !collapsed
            });
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy collapseFailed', {
                collapsed: !collapsed
            });
        });
    };
    const handleCollapseStatusChange = (entity)=>{
        (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('useTeamEscalationsController-handleCollapseStatusChange', 'data should not be undefined'));
        const { collapsed: collapsed, id: id } = entity;
        const newData = {
            ...data,
            escalations: {
                ...data.escalations,
                entities: data.escalations.entities.map((entity)=>{
                    return entity.id === id ? {
                        ...entity,
                        collapsed: !collapsed
                    } : entity;
                })
            }
        };
        saveView(newData).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy collapsed', id, {
                collapsed: !collapsed
            });
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy collapseFailed', id);
        });
    };
    const handleOrderChange = (updatedValue, targetIndex, sourceId)=>{
        (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('useTeamEscalationsController-handleOrderChange', 'data should not be undefined'));
        const newData = {
            ...data,
            escalations: {
                ...data.escalations,
                entities: updatedValue
            }
        };
        saveView(newData).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicyOrder changed', sourceId, {
                order: targetIndex
            });
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicyOrder failed', sourceId, {
                order: targetIndex
            });
        });
    };
    const handleEditClick = (data)=>{
        escalationsCommonController.handleEditClick(data);
        completeTask();
    };
    return {
        ...escalationsCommonController,
        handleEditClick: handleEditClick,
        handleCollapseStatusChange: handleCollapseStatusChange,
        handleOrderChange: handleOrderChange,
        toggleSection: toggleSection
    };
};

});
parcelRegister("c2LK1", function(module, exports) {

$parcel$export(module.exports, "useTeamEscalationsService", () => $91f2c18637dc0048$export$e2c5f21f3164683c);

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $2VYEV = parcelRequire("2VYEV");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $8SpRt = parcelRequire("8SpRt");

var $hem2I = parcelRequire("hem2I");

var $gi3Vj = parcelRequire("gi3Vj");

var $kDgqU = parcelRequire("kDgqU");

var $lSeyu = parcelRequire("lSeyu");
const $91f2c18637dc0048$export$e2c5f21f3164683c = ()=>{
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const flagApi = (0, $2tKfK.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { update: update } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const escalationsCommonService = (0, $gi3Vj.useEscalationsCommonService)();
    (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('useTeamEscalationsService', "Missing required 'teamId' parameter"));
    const createEscalation = (params)=>{
        return escalationsCommonService.createEscalation(params).then((res)=>{
            update((data)=>({
                    ...data,
                    escalations: {
                        ...data.escalations,
                        entities: [
                            ...data.escalations.entities,
                            res
                        ]
                    }
                }));
            return res;
        });
    };
    const updateEscalation = (params)=>{
        return escalationsCommonService.updateEscalation(params).then((res)=>{
            update((data)=>({
                    ...data,
                    escalations: {
                        ...data.escalations,
                        entities: data.escalations.entities.map((entity)=>{
                            if (entity.id === res.id) return res;
                            return entity;
                        })
                    }
                }));
            return res;
        });
    };
    const updatePartialEscalation = (params)=>{
        return escalationsCommonService.updatePartialEscalation(params).then((res)=>{
            update((data)=>({
                    ...data,
                    escalations: {
                        ...data.escalations,
                        entities: data.escalations.entities.map((entity)=>{
                            if (entity.id === res.id) return res;
                            return entity;
                        })
                    }
                }));
            return res;
        });
    };
    const deleteEscalation = (id, name)=>{
        return escalationsCommonService.deleteEscalation(id, name).then(()=>{
            update((data)=>({
                    ...data,
                    escalations: {
                        ...data.escalations,
                        entities: data.escalations.entities.filter((entity)=>entity.id !== id)
                    }
                }));
        });
    };
    const saveView = (data)=>{
        update(()=>data);
        const view = {
            collapsed: data.escalations.collapsed,
            preferences: data.escalations.entities.map(({ id: id, collapsed: collapsed })=>({
                    id: id,
                    collapsed: collapsed
                }))
        };
        return (0, $kDgqU.saveViewEndpoint)(teamId, view).catch((error)=>{
            defaultCatch({
                id: 'useTeamEscalationsService-saveView',
                httpErrorHandler: (err)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: formatMessage((0, $lSeyu.default).saveViewError),
                        actions: [
                            {
                                content: formatMessage((0, $lSeyu.default).refresh),
                                onClick: ()=>window.location.reload()
                            }
                        ]
                    });
                }
            }, error);
            throw error;
        });
    };
    const completeTask = ()=>(0, $kDgqU.completeTaskEndpoint)(teamId);
    return {
        ...escalationsCommonService,
        createEscalation: createEscalation,
        deleteEscalation: deleteEscalation,
        saveView: saveView,
        updateEscalation: updateEscalation,
        updatePartialEscalation: updatePartialEscalation,
        completeTask: completeTask
    };
};

});
parcelRegister("gi3Vj", function(module, exports) {

$parcel$export(module.exports, "useEscalationsCommonService", () => $252cea39a82a4fda$export$a6bf29030f29db22);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $75t7L = parcelRequire("75t7L");

var $c734n = parcelRequire("c734n");
const $252cea39a82a4fda$export$a6bf29030f29db22 = ()=>{
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const [isCreating, setIsCreating] = (0, $5uXOq.useState)(false);
    const [isUpdating, setIsUpdating] = (0, $5uXOq.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $5uXOq.useState)(false);
    const [isPartiallyUpdating, setIsPartiallyUpdating] = (0, $5uXOq.useState)(false);
    const flagApi = (0, $2tKfK.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createEscalation = (escalationPolicy)=>{
        setIsCreating(true);
        return (0, $75t7L.createEscalationEndpoint)(teamId, escalationPolicy).then((res)=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $c734n.default).escalationPolicyAdded, {
                    name: escalationPolicy.name
                })
            });
            return res;
        }).catch((error)=>{
            defaultCatch({
                id: 'useEscalationsCommonService-createEscalation',
                httpErrorHandler: (err)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: formatMessage((0, $c734n.default).createError)
                    });
                }
            }, error);
            throw error;
        }).finally(()=>setIsCreating(false));
    };
    const updateEscalation = (escalationPolicy)=>{
        setIsUpdating(true);
        return (0, $75t7L.updateEscalationEndpoint)(teamId, escalationPolicy).then((res)=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $c734n.default).escalationPolicySaved, {
                    name: escalationPolicy.name
                })
            });
            return res;
        }).catch((error)=>{
            defaultCatch({
                id: 'useEscalationsCommonService-updateEscalation',
                httpErrorHandler: (err)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: formatMessage((0, $c734n.default).updateError)
                    });
                }
            });
            throw error;
        }).finally(()=>setIsUpdating(false));
    };
    const updatePartialEscalation = (escalationPolicy)=>{
        setIsPartiallyUpdating(true);
        return (0, $75t7L.updatePartialEscalationEndpoint)(teamId, escalationPolicy).catch((error)=>{
            defaultCatch({
                id: 'useEscalationsCommonService-updatePartialEscalation',
                httpErrorHandler: (err)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: formatMessage((0, $c734n.default).changeStateError, {
                            isEnabled: escalationPolicy.enabled
                        })
                    });
                }
            }, error);
            throw error;
        }).finally(()=>setIsPartiallyUpdating(false));
    };
    const deleteEscalation = (id, name)=>{
        setIsDeleting(true);
        return (0, $75t7L.deleteEscalationEndpoint)(teamId, id).then(()=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $c734n.default).escalationPolicyDeleted, {
                    name: name
                })
            });
        }).catch((error)=>{
            defaultCatch({
                id: 'useEscalationsCommonService-deleteEscalation',
                httpErrorHandler: (err)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: formatMessage((0, $c734n.default).deleteError)
                    });
                }
            }, error);
            throw error;
        }).finally(()=>setIsDeleting(false));
    };
    return {
        isCreating: isCreating,
        isDeleting: isDeleting,
        isUpdating: isUpdating,
        isPartiallyUpdating: isPartiallyUpdating,
        createEscalation: createEscalation,
        deleteEscalation: deleteEscalation,
        updateEscalation: updateEscalation,
        updatePartialEscalation: updatePartialEscalation
    };
};

});
parcelRegister("75t7L", function(module, exports) {

$parcel$export(module.exports, "createEscalationEndpoint", () => $b904b2fc4a144fe1$export$9e8df7800a53074e);
$parcel$export(module.exports, "updateEscalationEndpoint", () => $b904b2fc4a144fe1$export$5a1670338d956854);
$parcel$export(module.exports, "updatePartialEscalationEndpoint", () => $b904b2fc4a144fe1$export$a7badafd1d13a6e5);
$parcel$export(module.exports, "deleteEscalationEndpoint", () => $b904b2fc4a144fe1$export$c9104b723605f4c7);

var $j74qU = parcelRequire("j74qU");
const $b904b2fc4a144fe1$var$getBaseUrl = (teamId)=>{
    if (teamId) return `/v1/teams/${teamId}/escalations`;
    return '/v1/escalations';
};
const $b904b2fc4a144fe1$export$9e8df7800a53074e = (teamId, escalationPolicy)=>{
    return (0, $j74qU.eocFetch)($b904b2fc4a144fe1$var$getBaseUrl(teamId), {
        method: 'POST',
        body: escalationPolicy
    });
};
const $b904b2fc4a144fe1$export$5a1670338d956854 = (teamId, escalationPolicy)=>{
    return (0, $j74qU.eocFetch)(`${$b904b2fc4a144fe1$var$getBaseUrl(teamId)}/${escalationPolicy.id}`, {
        method: 'PUT',
        body: escalationPolicy
    });
};
const $b904b2fc4a144fe1$export$a7badafd1d13a6e5 = (teamId, escalationPolicy)=>{
    return (0, $j74qU.eocFetch)(`${$b904b2fc4a144fe1$var$getBaseUrl(teamId)}/${escalationPolicy.id}`, {
        method: 'PATCH',
        body: escalationPolicy
    });
};
const $b904b2fc4a144fe1$export$c9104b723605f4c7 = (teamId, id)=>{
    return (0, $j74qU.eocFetch)(`${$b904b2fc4a144fe1$var$getBaseUrl(teamId)}/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});

parcelRegister("c734n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70c2396271a05b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $d70c2396271a05b2$var$messages = (0, $7VHMR.defineMessages)({
    escalationPolicyAdded: {
        id: 'eoc.escalation-policy.flag.escalation-policy-added.no-translate',
        defaultMessage: `Escalation policy "{name}" added.`,
        description: 'Title of success message that will be displayed in the flag after escalation policy created'
    },
    escalationPolicySaved: {
        id: 'eoc.escalation-policy.flag.escalation-policy-updated.no-translate',
        defaultMessage: `Escalation policy "{name}" saved.`,
        description: 'Title of success message that will be displayed in the flag after escalation policy updated'
    },
    escalationPolicyDeleted: {
        id: 'eoc.escalation-policy.flag.escalation-policy-deleted.no-translate',
        defaultMessage: `Escalation policy "{name}" deleted.`,
        description: 'Title of success message that will be displayed in the flag after escalation policy deleted'
    },
    changeStateError: {
        id: 'eoc.escalation-policy.flag.change-state-error.no-translate',
        defaultMessage: `We couldn't {isEnabled, select,
      true {turn on}
      other {turn off}
    } the escalation policy.`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while changing escalation policy state'
    },
    deleteError: {
        id: 'eoc.escalation-policy.flag.delete-error.no-translate',
        defaultMessage: `We couldn't delete the escalation policy.`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while deleting escalation policy'
    },
    createError: {
        id: 'eoc.escalation-policy.flag.create-error.no-translate',
        defaultMessage: `We couldn't create the escalation policy`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while creating the escalation policy'
    },
    updateError: {
        id: 'eoc.escalation-policy.flag.update-error.no-translate',
        defaultMessage: `We couldn't update the escalation policy`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while updating the escalation policy'
    }
});
var $d70c2396271a05b2$export$2e2bcd8739ae039 = $d70c2396271a05b2$var$messages;

});


parcelRegister("kDgqU", function(module, exports) {

$parcel$export(module.exports, "saveViewEndpoint", () => $1337480c1d3f63d9$export$9bfec2bc35e4b833);
$parcel$export(module.exports, "completeTaskEndpoint", () => $1337480c1d3f63d9$export$43adb756d1007327);

var $j74qU = parcelRequire("j74qU");
const $1337480c1d3f63d9$export$9bfec2bc35e4b833 = (teamId, view)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/ui-preferences/teams/${teamId}/escalations`, {
        method: 'PATCH',
        body: view,
        responseType: 'headers'
    });
};
const $1337480c1d3f63d9$export$43adb756d1007327 = (teamId)=>{
    return (0, $j74qU.eocFetch)('/v1/onboarding/complete-task', {
        method: 'POST',
        body: {
            platformTeamId: teamId,
            completedItemKey: 'opsgenie-review-oncall-setup'
        }
    });
};

});

parcelRegister("lSeyu", function(module, exports) {

$parcel$export(module.exports, "default", () => $42278f955bf08845$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $42278f955bf08845$var$messages = (0, $7VHMR.defineMessages)({
    saveViewError: {
        id: 'eoc.escalation-policy.flag.save-view-error.no-translate',
        defaultMessage: `We couldn't save the view preferences`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while saving the view preferences'
    },
    refresh: {
        id: 'eoc.escalation-policy.flag.refresh.no-translate',
        defaultMessage: `Refresh`,
        description: 'Label of first action button inside flag'
    }
});
var $42278f955bf08845$export$2e2bcd8739ae039 = $42278f955bf08845$var$messages;

});


parcelRegister("evNEP", function(module, exports) {

$parcel$export(module.exports, "useEscalationsCommonController", () => $536fea7064ed2031$export$56f73076b9ab282c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");
const $536fea7064ed2031$export$56f73076b9ab282c = (service)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [editingData, setEditingData] = (0, $5uXOq.useState)();
    const [editingId, setEditingId] = (0, $5uXOq.useState)('');
    const [isChangeStateModalOpen, setIsChangeStateModalOpen] = (0, $5uXOq.useState)(false);
    const [isCloning, setIsCloning] = (0, $5uXOq.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $5uXOq.useState)(false);
    const [isEscalationPolicyModalOpen, setIsEscalationPolicyModalOpen] = (0, $5uXOq.useState)(false);
    const { isCreating: isCreating, isDeleting: isDeleting, isUpdating: isUpdating, isPartiallyUpdating: isPartiallyUpdating, createEscalation: createEscalation, deleteEscalation: deleteEscalation, updateEscalation: updateEscalation, updatePartialEscalation: updatePartialEscalation } = service;
    const openEscalationPolicyModal = ()=>setIsEscalationPolicyModalOpen(true);
    const closeEscalationPolicyModal = ()=>{
        setIsEscalationPolicyModalOpen(false);
        setIsCloning(false);
        setEditingData(undefined);
    };
    const openDeleteModal = ()=>setIsDeleteModalOpen(true);
    const closeDeleteModal = ()=>{
        setIsDeleteModalOpen(false);
        setIsCloning(false);
        setEditingData(undefined);
    };
    const openChangeStateModal = ()=>setIsChangeStateModalOpen(true);
    const closeChangeStateModal = ()=>{
        setIsChangeStateModalOpen(false);
        setIsCloning(false);
        setEditingData(undefined);
    };
    const handleEditClick = (data)=>{
        setEditingData(data);
        openEscalationPolicyModal();
    };
    const handleCloneClick = (data)=>{
        setIsCloning(true);
        setEditingData(data);
        openEscalationPolicyModal();
    };
    const handleDeleteClick = (data)=>{
        setEditingData(data);
        openDeleteModal();
    };
    const handleChangeStateClick = (data)=>{
        setEditingData(data);
        openChangeStateModal();
    };
    const handleChangeState = ()=>{
        if (editingData) {
            setEditingId(editingData.id);
            updatePartialEscalation({
                enabled: !editingData.enabled,
                id: editingData.id
            }).then(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy changedStatus', editingData.id, {
                    isEnabled: !editingData.enabled
                });
            }).catch(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy changeStatusFailed', editingData.id, {
                    isEnabled: editingData.enabled
                });
            }).finally(()=>setEditingId(''));
            closeChangeStateModal();
        }
    };
    const handleDelete = ()=>{
        if (editingData) {
            setEditingId(editingData.id);
            deleteEscalation(editingData.id, editingData.name).then(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy deleted', editingData.id);
            }).catch(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy deleteFailed', editingData.id);
            }).finally(()=>setEditingId(''));
            closeDeleteModal();
        }
    };
    const handleFormSubmit = (allValues)=>{
        const { repeatEnabled: repeatEnabled, ...values } = allValues;
        const shouldRepeat = Boolean(repeatEnabled);
        const event = createAnalyticsEvent({});
        if (editingData && !isCloning) {
            const updatedData = {
                ...editingData,
                ...values,
                repeat: shouldRepeat ? parseInt(values.repeat) : 0,
                maxRepeatCount: shouldRepeat ? values.maxRepeatCount?.value : 1
            };
            updateEscalation(updatedData).then(()=>closeEscalationPolicyModal()).then(()=>{
                (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy edited', editingData.id, {
                    teamId: values.teamId
                });
            }).catch(()=>{
                (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy editFailed', editingData.id, {
                    teamId: values.teamId
                });
            });
        } else createEscalation({
            ...values,
            enabled: true,
            repeat: shouldRepeat ? parseInt(values.repeat) : 0,
            maxRepeatCount: shouldRepeat ? values.maxRepeatCount?.value : 1
        }).then(()=>{
            closeEscalationPolicyModal();
            if (isCloning && editingData) {
                (0, $h8yj2.fireTrackAnalytics)(event, `escalationPolicy cloned`, editingData.id, {
                    teamId: values.teamId
                });
                return;
            }
            (0, $h8yj2.fireTrackAnalytics)(event, `escalationPolicy added`);
        }).catch(()=>{
            if (isCloning && editingData) {
                (0, $h8yj2.fireTrackAnalytics)(event, `escalationPolicy cloneFailed`, editingData.id, {
                    teamId: values.teamId
                });
                return;
            }
            (0, $h8yj2.fireTrackAnalytics)(event, 'escalationPolicy addFailed', {
                teamId: values.teamId
            });
        });
    };
    return {
        editingData: editingData,
        editingId: editingId,
        isChangeStateModalOpen: isChangeStateModalOpen,
        isCloning: isCloning,
        isCreating: isCreating,
        isDeleteModalOpen: isDeleteModalOpen,
        isDeleting: isDeleting,
        isEscalationPolicyModalOpen: isEscalationPolicyModalOpen,
        isUpdating: isUpdating,
        isPartiallyUpdating: isPartiallyUpdating,
        closeDeleteModal: closeDeleteModal,
        closeEscalationPolicyModal: closeEscalationPolicyModal,
        openChangeStateModal: openChangeStateModal,
        closeChangeStateModal: closeChangeStateModal,
        handleChangeStateClick: handleChangeStateClick,
        handleChangeState: handleChangeState,
        handleCloneClick: handleCloneClick,
        handleDeleteClick: handleDeleteClick,
        handleDelete: handleDelete,
        handleEditClick: handleEditClick,
        handleFormSubmit: handleFormSubmit,
        openDeleteModal: openDeleteModal,
        openEscalationPolicyModal: openEscalationPolicyModal
    };
};

});


parcelRegister("hCQkL", function(module, exports) {

$parcel$export(module.exports, "EscalationRules", () => $7e68cdaea9d75b8b$export$809acd770abf38a4);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWn3s = parcelRequire("bWn3s");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $fXc9u = parcelRequire("fXc9u");

var $8J1d6 = parcelRequire("8J1d6");

var $1aMzM = parcelRequire("1aMzM");

var $5L1zI = parcelRequire("5L1zI");

var $lsh84 = parcelRequire("lsh84");

var $lOjn3 = parcelRequire("lOjn3");

var $luGSO = parcelRequire("luGSO");
// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $7e68cdaea9d75b8b$var$styles = (0, $8CUq3.xcss)({
    textTransform: 'uppercase'
});
const $7e68cdaea9d75b8b$export$809acd770abf38a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ entity: entity, shouldShowSpinner: shouldShowSpinner, onEdit: onEdit, onClone: onClone, onStateChange: onStateChange, onDelete: onDelete, onUpdateCollapseStatus: onUpdateCollapseStatus, hasEditRight: hasEditRight, hasDeleteRight: hasDeleteRight }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCollapsed, setIsCollapsed] = (0, $5uXOq.useState)(entity.collapsed);
    const buttonRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useImperativeHandle)(ref, ()=>({
            getActionButtonRef: ()=>buttonRef
        }));
    const responders = (0, $fXc9u.useResponderNames)(entity.rules.map((rule)=>({
            id: rule.notifyId,
            type: rule.type
        })));
    const hasDeletedResponder = responders.some((responder)=>(0, $lsh84.isResponderDeleted)(responder));
    const toggleCollapsed = ()=>{
        setIsCollapsed(!isCollapsed);
        onUpdateCollapseStatus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8J1d6.RuleCard), {
        value: entity.id,
        droppableId: "escalation-policies",
        title: entity.name,
        headingAs: "h3",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.150"
        }, shouldShowSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            testId: "escalation-policies.escalation-policy-actions.deleting",
            size: "small"
        }), hasDeletedResponder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: "removed"
        }, formatMessage((0, $lOjn3.default).missingResponder)), !entity.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: "moved"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $7e68cdaea9d75b8b$var$styles
        }, formatMessage((0, $1aMzM.default).disabled))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                    label: formatMessage((0, $1aMzM.default).showMore, {
                        name: entity.name
                    }),
                    ...props,
                    ref: (0, $bWn3s.mergeRefs)([
                        triggerRef,
                        buttonRef
                    ]),
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF)))
                }),
            shouldRenderToParent: true
        }, (hasEditRight || hasDeleteRight) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: onEdit
        }, formatMessage((0, $1aMzM.default).edit)), hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: onClone
        }, formatMessage((0, $1aMzM.default).clone)), hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: onStateChange
        }, formatMessage(entity.enabled ? (0, $1aMzM.default).disable : (0, $1aMzM.default).enable)), hasDeleteRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: onDelete
        }, formatMessage((0, $1aMzM.default).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
            hasSeparator: hasEditRight || hasDeleteRight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: toggleCollapsed
        }, isCollapsed ? formatMessage((0, $lOjn3.default).expand) : formatMessage((0, $lOjn3.default).collapse))))),
        gap: `${10}px`
    }, !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luGSO.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L1zI.Rules), {
        rules: entity.rules
    })));
});

});
parcelRegister("bJeNF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
function $889f60aca54b55ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
    }, props));
$889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;

});

parcelRegister("5L1zI", function(module, exports) {

$parcel$export(module.exports, "Rules", () => $34d1d66f8c69c06d$export$374633da432e5a39);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $gDAmW = parcelRequire("gDAmW");
const $34d1d66f8c69c06d$export$374633da432e5a39 = ({ rules: rules })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, rules.sort((a, b)=>a.time - b.time).map((rule, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDAmW.Rule), {
            rule: rule,
            key: `${index}-${rule.type}-${rule.notifyId}`
        })));
};

});
parcelRegister("gDAmW", function(module, exports) {

$parcel$export(module.exports, "Rule", () => $0e156b2ee229d47f$export$f1ff2a90c38ff669);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $3HVJq = parcelRequire("3HVJq");

var $fXc9u = parcelRequire("fXc9u");

var $jM77t = parcelRequire("jM77t");

var $jTu4f = parcelRequire("jTu4f");

var $hfxDa = parcelRequire("hfxDa");

var $9CCsR = parcelRequire("9CCsR");

var $27nwx = parcelRequire("27nwx");
const $0e156b2ee229d47f$export$f1ff2a90c38ff669 = ({ rule: rule })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getColor: getColor } = (0, $3HVJq.useStore)();
    const { backgroundColor: backgroundColor } = getColor(rule.notifyId);
    const [responder] = (0, $fXc9u.useResponderNames)(rule.inlineResponder ? [] : [
        {
            id: rule.notifyId,
            type: rule.type
        }
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfxDa.RuleIcon), {
        type: rule.type
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.TimeText), null, formatMessage((0, $jTu4f.default).minuteAbbreviation, {
        time: rule.time,
        span: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                size: "small",
                color: "color.text.subtle"
            }, str)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.RuleBody), null, rule.time <= 30 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Rectangle), {
        width: (0, $27nwx.widthGenerator)(rule.time),
        backgroundColor: backgroundColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Rectangle), {
        width: (0, $27nwx.widthGenerator)(rule.time),
        backgroundColor: backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Rectangle), {
        width: 10,
        backgroundColor: backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Rectangle), {
        width: 10,
        backgroundColor: backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Rectangle), {
        width: 10,
        backgroundColor: backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.Rectangle), {
        width: 40,
        backgroundColor: backgroundColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.DashedLines), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CCsR.RuleDetail), null, formatMessage((0, $jTu4f.default)['ruleVerbalForm'], {
        type: rule.type,
        notifyType: rule.notifyType,
        notifyCondition: rule.notifyCondition.split('-').join(''),
        strong: (str)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                style: {
                    marginLeft: "var(--ds-space-negative-050, -4px)"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, str)),
        responder: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jM77t.Responder), {
                data: responder,
                inlineResponder: rule.inlineResponder
            })
    })));
};

});
parcelRegister("3HVJq", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $0046d9668c840358$export$6ccbb43953eebf8);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $cp8hK = parcelRequire("cp8hK");

var $2JauX = parcelRequire("2JauX");
const $0046d9668c840358$var$Store = (0, $iXqE5.createStore)({
    initialState: $2JauX.initialState,
    actions: $cp8hK.actions
});
const $0046d9668c840358$export$6ccbb43953eebf8 = (0, $3sQ5x.createActionsHook)($0046d9668c840358$var$Store);

});
parcelRegister("cp8hK", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c2d6f7e2c1db900a$export$e324594224ef24da);

var $f4mSd = parcelRequire("f4mSd");
const $c2d6f7e2c1db900a$var$getColor = (id)=>({ getState: getState, setState: setState })=>{
        const { colorMap: colorMap } = getState();
        if (colorMap[id]) return colorMap[id];
        const index = Object.keys(colorMap).length % (0, $f4mSd.colors).length;
        const color = (0, $f4mSd.colors)[index];
        setState({
            colorMap: {
                ...colorMap,
                [id]: color
            }
        });
        return color;
    };
const $c2d6f7e2c1db900a$export$e324594224ef24da = {
    getColor: $c2d6f7e2c1db900a$var$getColor
};

});
parcelRegister("f4mSd", function(module, exports) {

$parcel$export(module.exports, "colors", () => $c23caaf09f9a406e$export$8f45430ccf837300);

const $c23caaf09f9a406e$var$colorWhite = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $c23caaf09f9a406e$var$colorBlack = `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
const $c23caaf09f9a406e$export$8f45430ccf837300 = [
    {
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        color: $c23caaf09f9a406e$var$colorBlack
    },
    {
        backgroundColor: "var(--ds-background-accent-orange-bolder, #B65C02)",
        color: $c23caaf09f9a406e$var$colorWhite
    },
    {
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        color: $c23caaf09f9a406e$var$colorBlack
    },
    {
        backgroundColor: "var(--ds-background-accent-teal-bolder, #1D7F8C)",
        color: $c23caaf09f9a406e$var$colorWhite
    },
    {
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87462)",
        color: $c23caaf09f9a406e$var$colorBlack
    },
    {
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        color: $c23caaf09f9a406e$var$colorWhite
    },
    {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #60C6D2)",
        color: $c23caaf09f9a406e$var$colorBlack
    },
    {
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        color: $c23caaf09f9a406e$var$colorWhite
    },
    {
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #E2B203)",
        color: $c23caaf09f9a406e$var$colorBlack
    },
    {
        backgroundColor: "var(--ds-background-accent-red-bolder, #CA3521)",
        color: $c23caaf09f9a406e$var$colorWhite
    },
    {
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FAA53D)",
        color: $c23caaf09f9a406e$var$colorBlack
    },
    {
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        color: $c23caaf09f9a406e$var$colorWhite
    },
    {
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        color: $c23caaf09f9a406e$var$colorBlack
    }
];

});


parcelRegister("2JauX", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $481429e5d9185573$export$d4c72bab9d6cc13a);
const $481429e5d9185573$export$d4c72bab9d6cc13a = {
    colorMap: {}
};

});


parcelRegister("jTu4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $df593c1c5e471cef$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $df593c1c5e471cef$var$messages = (0, $7VHMR.defineMessages)({
    ruleVerbalForm: {
        id: 'eoc.escalation-policies.rule.verbal-form.no-translate',
        defaultMessage: `
    {type, select,
      schedule {
        {notifyType, select,
          default {On call users in }
          next {Next user in }
          previous {Previous user in}
          other {}
        }
      }
      team {
        {notifyType, select,
          all {All members of }
          users {Users of}
          admins {Admins of}
          default {Routed target of }
          random {Random member of }
          other {}
        }
      }
      user {
        Notify
      }
      other {}
    }
    <responder></responder>
    <strong>,</strong>
    {
        notifyCondition, select,
        ifnotacked {if not acknowledged}
        ifnotclosed {if not closed}
        other {}
    }
    `,
        description: 'Full message of escalation rule. Example: All members of <responder></responder>, if not acknowledged'
    },
    minuteAbbreviation: {
        id: 'eoc.escalation-policies.rule.minute-abbreviation.no-translate',
        defaultMessage: '{time} <span>m</span>',
        description: 'Abbreviation of the minute.'
    },
    deletedEntitytooltip: {
        id: 'eoc.escalation-policies.rule.deleted-entity-tooltip.no-translate',
        defaultMessage: 'This {type} has been deleted, update with another {type}',
        description: 'The tooltip text that informs user about deleted entity'
    },
    infoLabel: {
        id: 'eoc.escalation-policies.rule.deleted-entity.info-label.no-translate',
        defaultMessage: 'Deleted Entity Info',
        description: 'The label of info icon for deleted entity'
    }
});
var $df593c1c5e471cef$export$2e2bcd8739ae039 = $df593c1c5e471cef$var$messages;

});

parcelRegister("hfxDa", function(module, exports) {

$parcel$export(module.exports, "RuleIcon", () => $c2d5bb12f6cf3681$export$e41a379a742b145b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $acknU = parcelRequire("acknU");

var $4hqZ5 = parcelRequire("4hqZ5");

var $6Lc8h = parcelRequire("6Lc8h");

var $lkJ9N = parcelRequire("lkJ9N");
const $c2d5bb12f6cf3681$export$e41a379a742b145b = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return type === 'schedule' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        color: "currentColor",
        label: formatMessage((0, $lkJ9N.default).scheduleLabel),
        LEGACY_size: "small"
    }) : type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
        color: "currentColor",
        label: formatMessage((0, $lkJ9N.default).teamLabel),
        LEGACY_size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Lc8h))), {
        color: "currentColor",
        label: formatMessage((0, $lkJ9N.default).userLabel),
        LEGACY_size: "small"
    });
};

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab6a74d5dbe2e66f9a6df60fb0887ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("6Lc8h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eff206af8ef628836e20d7516cf55af9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ec08b271318e97e$var$_react = $4ec08b271318e97e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4ec08b271318e97e$var$_personAvatar = $4ec08b271318e97e$var$_interopRequireDefault((parcelRequire("bdVbi")));

var $4ec08b271318e97e$var$_personCircle = $4ec08b271318e97e$var$_interopRequireDefault((parcelRequire("3B33y")));
function $4ec08b271318e97e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "PersonCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ec08b271318e97e$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $4ec08b271318e97e$var$_react.default.createElement($4ec08b271318e97e$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $4ec08b271318e97e$var$_personCircle.default
    }, props));
$4ec08b271318e97e$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $4ec08b271318e97e$var$_default = module.exports.default = $4ec08b271318e97e$var$PersonAvatarIcon;

});

parcelRegister("lkJ9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b076cabb851e82a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $0b076cabb851e82a$var$messages = (0, $7VHMR.defineMessages)({
    scheduleLabel: {
        id: 'eoc.escalation-policies.rule-icon.schedule-label.no-translate',
        defaultMessage: 'Schedule',
        description: 'The label of calendar icon for schedule typed rule'
    },
    teamLabel: {
        id: 'eoc.escalation-policies.rule-icon.team-label.no-translate',
        defaultMessage: 'Team',
        description: 'The label of people icon for team typed rule'
    },
    userLabel: {
        id: 'eoc.escalation-policies.rule-icon.user-label.no-translate',
        defaultMessage: 'User',
        description: 'The label of person icon for user typed rule'
    }
});
var $0b076cabb851e82a$export$2e2bcd8739ae039 = $0b076cabb851e82a$var$messages;

});


parcelRegister("9CCsR", function(module, exports) {

$parcel$export(module.exports, "Container", () => $ea267f4fbaf184c3$export$42a852a2b6b56249);
$parcel$export(module.exports, "IconWrapper", () => $ea267f4fbaf184c3$export$be58b4326e23250f);
$parcel$export(module.exports, "TimeText", () => $ea267f4fbaf184c3$export$c7cb10626006f1a5);
$parcel$export(module.exports, "RuleBody", () => $ea267f4fbaf184c3$export$5138af37cc5516c1);
$parcel$export(module.exports, "Rectangle", () => $ea267f4fbaf184c3$export$4617fb02663045ef);
$parcel$export(module.exports, "DashedLines", () => $ea267f4fbaf184c3$export$a8f157a2240c33e2);
$parcel$export(module.exports, "RuleDetail", () => $ea267f4fbaf184c3$export$a6b704528925a96);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $ea267f4fbaf184c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ea267f4fbaf184c3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1jjnd886"
})({
    height: '24px',
    alignItems: 'center',
    columnGap: "var(--ds-space-100, 8px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`,
    width: '100%'
});
const $ea267f4fbaf184c3$export$be58b4326e23250f = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1jjnd885"
})({
    name: "dkybq8",
    styles: "width:16px;flex-shrink:0;align-items:center"
});
const $ea267f4fbaf184c3$export$c7cb10626006f1a5 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1jjnd884"
})({
    name: "1575uhx",
    styles: "width:45px;flex-shrink:0;column-gap:var(--ds-space-050, 4px);justify-content:flex-end;align-items:center;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600)"
});
const $ea267f4fbaf184c3$export$5138af37cc5516c1 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1jjnd883"
})({
    name: "10ry9rm",
    styles: "column-gap:var(--ds-space-050, 4px);min-width:0"
});
const $ea267f4fbaf184c3$export$4617fb02663045ef = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jjnd882"
})((props)=>({
        height: '8px',
        minWidth: '10px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${props.width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.backgroundColor,
        borderRadius: "var(--ds-border-radius-100, 1px)"
    }));
const $ea267f4fbaf184c3$export$a8f157a2240c33e2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jjnd881"
})({
    name: "osxqlz",
    styles: "width:50px;border:1px dashed #dee4ea;flex-shrink:0"
});
const $ea267f4fbaf184c3$export$a6b704528925a96 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1jjnd880"
})({
    name: "7gk69u",
    styles: "column-gap:var(--ds-space-050, 4px);align-items:center;white-space:nowrap"
});

});

parcelRegister("27nwx", function(module, exports) {

$parcel$export(module.exports, "widthGenerator", () => $070490f4b2fe75d4$export$3868cac4e54caabe);
//  These widths come from design depending on the rule time.
const $070490f4b2fe75d4$export$3868cac4e54caabe = (time)=>{
    if (time < 5) return 10;
    if (time >= 5 && time < 10) return 30;
    if (time >= 10 && time < 15) return 60;
    if (time >= 15 && time < 20) return 90;
    if (time >= 20 && time < 25) return 120;
    if (time >= 25 && time < 30) return 160;
    if (time === 30) return 190;
    return 200;
};

});



parcelRegister("lOjn3", function(module, exports) {

$parcel$export(module.exports, "default", () => $20b8d797fc44c925$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $20b8d797fc44c925$var$messages = (0, $7VHMR.defineMessages)({
    missingResponder: {
        id: 'eoc.escalation-policies.ui.actions.missing-responder.no-translate',
        defaultMessage: 'Missing Responder',
        description: 'Label of lozenge when there is missing responder'
    },
    collapse: {
        id: 'eoc.escalation-policies.ui.actions.collapse.no-translate',
        defaultMessage: 'Collapse',
        description: 'Label of collapse button'
    },
    expand: {
        id: 'eoc.escalation-policies.ui.actions.expand.no-translate',
        defaultMessage: 'Expand',
        description: 'Label of expand button'
    }
});
var $20b8d797fc44c925$export$2e2bcd8739ae039 = $20b8d797fc44c925$var$messages;

});

parcelRegister("luGSO", function(module, exports) {

$parcel$export(module.exports, "Container", () => $125ae11b80e91964$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $125ae11b80e91964$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $125ae11b80e91964$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ciql310"
})({
    name: "uv0shy",
    styles: "margin-top:var(--ds-space-100, 8px)"
});

});


parcelRegister("jdfFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2249290c5d62e31$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $e2249290c5d62e31$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.escalation-policies.ui.title.no-translate',
        defaultMessage: 'Escalation policies',
        description: 'Title of escalation policies section'
    },
    add: {
        id: 'eoc.escalation-policies.ui.add.no-translate',
        defaultMessage: 'Create escalation policy',
        description: 'Label of create an escalation button'
    },
    emptyAdd: {
        id: 'eoc.escalation-policies.ui.empty-add.no-translate',
        defaultMessage: 'Create now',
        description: 'Label of create an escalation button'
    },
    maxPolicy: {
        id: 'eoc.escalation-policies.ui.max-policy-warning.no-translate',
        defaultMessage: 'You have created 300 escalation policies, which is the maximum you can add.',
        description: 'Warning message that will be shown when there is 300 escalation policy'
    },
    empty: {
        id: 'eoc.escalation-policies.ui.empty-message.no-translate',
        defaultMessage: 'No escalation policies here yet.',
        description: 'Text description that will be shown when there is no escalations'
    }
});
var $e2249290c5d62e31$export$2e2bcd8739ae039 = $e2249290c5d62e31$var$messages;

});

parcelRegister("iUMPA", function(module, exports) {

$parcel$export(module.exports, "TitleContainer", () => $5d2c1ea9c0cdc0a4$export$35e09ba17cc51c69);
$parcel$export(module.exports, "SectionContent", () => $5d2c1ea9c0cdc0a4$export$51a9c37cab91cff6);
$parcel$export(module.exports, "RuleCardContainer", () => $5d2c1ea9c0cdc0a4$export$883d4840a83fb5ff);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $5d2c1ea9c0cdc0a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5d2c1ea9c0cdc0a4$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1l2gjry2"
})({
    name: "1r6448k",
    styles: "display:flex;column-gap:var(--ds-space-100, 8px);align-items:center"
});
const $5d2c1ea9c0cdc0a4$export$51a9c37cab91cff6 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1l2gjry1"
})({
    name: "1jhav09",
    styles: "margin-top:var(--ds-space-150, 12px);row-gap:var(--ds-space-150, 12px);flex-direction:column"
});
const $5d2c1ea9c0cdc0a4$export$883d4840a83fb5ff = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1l2gjry0"
})({
    name: "db9nhh",
    styles: "margin-top:0px"
});

});



parcelRegister("deiCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $72819f07bbd278e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bmKPg = parcelRequire("bmKPg");

var $fNobW = parcelRequire("fNobW");

var $jkADf = parcelRequire("jkADf");

var $hem2I = parcelRequire("hem2I");

var $8SpRt = parcelRequire("8SpRt");

var $dnFm2 = parcelRequire("dnFm2");
function $72819f07bbd278e0$export$2e2bcd8739ae039({ onRoutingRuleModalOpen: onRoutingRuleModalOpen, schedules: schedules }) {
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const { loading: loading, error: error } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "eoc-routing-rules-loading"
    });
    if (error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jkADf.ContextWrapper), {
        tags: [
            'on-call',
            'routing-rules'
        ],
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        sourceName: "OnCall",
        objectId: teamId,
        objectType: "routingRule"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnFm2.default), {
        schedules: schedules,
        onRoutingRuleModalOpen: onRoutingRuleModalOpen
    }));
}

});
parcelRegister("dnFm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $40ca4456a7be076c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $16T6Y = parcelRequire("16T6Y");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $faod6 = parcelRequire("faod6");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $3bDjY = parcelRequire("3bDjY");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $dY87H = parcelRequire("dY87H");

var $hem2I = parcelRequire("hem2I");

var $8J1d6 = parcelRequire("8J1d6");
var $k97LS = parcelRequire("k97LS");

var $kugKu = parcelRequire("kugKu");

var $ce4pa = parcelRequire("ce4pa");
var $dnjeJ = parcelRequire("dnjeJ");

var $ffQsw = parcelRequire("ffQsw");

var $kIkhc = parcelRequire("kIkhc");

var $8b9tZ = parcelRequire("8b9tZ");

var $8SpRt = parcelRequire("8SpRt");

var $5HC04 = parcelRequire("5HC04");

var $c88EM = parcelRequire("c88EM");

var $3cKzy = parcelRequire("3cKzy");

var $5y8ya = parcelRequire("5y8ya");

var $lLH2S = parcelRequire("lLH2S");

var $7uKo4 = parcelRequire("7uKo4");

var $FpHBG = parcelRequire("FpHBG");
function $40ca4456a7be076c$export$2e2bcd8739ae039({ onRoutingRuleModalOpen: onRoutingRuleModalOpen, schedules: schedules }) {
    (0, $dnjeJ.useUFOComponentExperience)((0, $kIkhc.routingRulesLoadExperience));
    const { data: data } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createRuleButtonRef = (0, $5uXOq.useRef)(null);
    const ruleActionButtonRefs = (0, $5uXOq.useRef)({});
    const [returnFocusRef, setReturnFocusRef] = (0, $5uXOq.useState)(undefined);
    (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('RoutingRules', 'data should be fetched if there is no loading and error'));
    const { routingRules: { entities: entities, collapsed: collapsed, hasEditRight: hasEditRight, hasDeleteRight: hasDeleteRight }, routingRuleConditionFields: routingRuleConditionFields, defaultTimeZone: defaultTimeZone } = data;
    const { closeRoutingRuleModal: closeRoutingRuleModal, openRoutingRuleModal: openRoutingRuleModal, closeDeleteModal: closeDeleteModal, handleEditClick: handleEditClick, handleCloneClick: handleCloneClick, handleSubmitRule: handleSubmitRule, handleDeleteClick: handleDeleteClick, handleDeleteRule: handleDeleteRule, handleChangeOrder: handleChangeOrder, toggleSection: toggleSection, isDeleteModalOpen: isDeleteModalOpen, isRoutingRuleModalOpen: isRoutingRuleModalOpen, isCloning: isCloning, isCreating: isCreating, isUpdating: isUpdating, isDeleting: isDeleting, deletingId: deletingId, routeToOptions: routeToOptions, editingData: editingData } = (0, $8b9tZ.useRoutingRulesController)({
        schedules: schedules
    });
    (0, $k97LS.useMonitorRuleCards)({
        droppableId: 'routing-rules',
        data: entities,
        onComplete: ({ updatedValue: updatedValue, targetIndex: targetIndex, sourceId: sourceId })=>{
            handleChangeOrder({
                id: sourceId,
                targetIndex: targetIndex
            }, updatedValue);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce4pa.ExperienceSuccess), {
        experience: (0, $kIkhc.routingRulesLoadExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kugKu.Section), {
        isOpen: !collapsed,
        onClick: toggleSection,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            columnGap: 1,
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            as: "h2",
            size: "medium"
        }, formatMessage((0, $3cKzy.default).title)), data.routingRules.entities.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            max: 300
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "aria-hidden": true
        }, data.routingRules.entities.length))),
        actions: hasEditRight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3cKzy.default).add)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: formatMessage((0, $3cKzy.default).add),
            onClick: (e)=>{
                setReturnFocusRef(createRuleButtonRef);
                e.stopPropagation();
                openRoutingRuleModal();
            },
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($faod6))),
            ref: createRuleButtonRef
        })) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FpHBG.SectionContent), null, entities.length > 0 && entities.map((entity, i)=>{
        // Backend always returns a routing rule thats why we need to check it
        // and show the `else` card instead of it.
        const isLastItem = i === entities.length - 1;
        const Wrapper = isLastItem ? (0, $5Fk4Z.default) : (0, $5uXOq.Fragment);
        let spotlightProps = {};
        if (isLastItem) spotlightProps = {
            name: (0, $ffQsw.SPOTLIGHT_NAMES).lastEntity
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            key: i,
            ...spotlightProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FpHBG.RuleCardContainer), {
            isLastItem: isLastItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8J1d6.RuleCard), {
            key: entity.id,
            value: entity.id,
            droppableId: isLastItem ? '' : 'routing-rules',
            title: isLastItem ? '' : entity.name,
            headingAs: "h3",
            actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLH2S.RuleCardActions), {
                isDeleted: !!entity.deleted,
                isLoading: isDeleting && deletingId === entity.id,
                isLastItem: isLastItem,
                onClone: ()=>{
                    setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                    return handleCloneClick(entity);
                },
                onEdit: ()=>{
                    setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                    return handleEditClick(entity);
                },
                onDelete: ()=>{
                    setReturnFocusRef(ruleActionButtonRefs?.current[entity.id] || undefined);
                    return handleDeleteClick(entity);
                },
                name: entity.name,
                hasEditRight: hasEditRight,
                hasDeleteRight: hasDeleteRight,
                ref: (el)=>{
                    ruleActionButtonRefs.current[entity.id] = el?.getActionButtonRef();
                }
            })
        }, isLastItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c88EM.ElseCardContent), {
            isDeleted: !!entity.deleted,
            routeToOptions: routeToOptions,
            entity: entity,
            entityCount: entities.length,
            hasEditRight: hasEditRight
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7uKo4.RuleCardContent), {
            entity: entity,
            index: i
        }))));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y8ya.RoutingRuleModal), {
        isOpen: isRoutingRuleModalOpen,
        isCloning: isCloning,
        isLoading: isCreating || isUpdating,
        onSubmit: handleSubmitRule,
        onClose: closeRoutingRuleModal,
        conditionFields: routingRuleConditionFields,
        routeToOptions: routeToOptions,
        data: editingData,
        defaultTimeZone: defaultTimeZone,
        onOpen: onRoutingRuleModalOpen,
        returnFocusRef: returnFocusRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HC04.DeleteModal), {
        isOpen: isDeleteModalOpen,
        onClose: closeDeleteModal,
        onConfirm: handleDeleteRule,
        name: editingData?.name || '',
        returnFocusRef: returnFocusRef
    }));
}

});
parcelRegister("ffQsw", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS", () => $99e7e29e33b6775a$export$98ff4de2f070152d);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $99e7e29e33b6775a$export$a7c923252528b255);

var $9UOXx = parcelRequire("9UOXx");
const $99e7e29e33b6775a$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $9UOXx.OperationIds).Matches,
        name: (0, $9UOXx.Operation).Matches
    },
    {
        order: 1,
        id: (0, $9UOXx.OperationIds).Equals,
        name: (0, $9UOXx.Operation).Equals
    },
    {
        order: 2,
        id: (0, $9UOXx.OperationIds).Contains,
        name: (0, $9UOXx.Operation).Contains
    },
    {
        order: 3,
        id: (0, $9UOXx.OperationIds).StartsWith,
        name: (0, $9UOXx.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $9UOXx.OperationIds).EndsWith,
        name: (0, $9UOXx.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $9UOXx.OperationIds).ContainsKey,
        name: (0, $9UOXx.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $9UOXx.OperationIds).ContainsValue,
        name: (0, $9UOXx.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $9UOXx.OperationIds).GreaterThan,
        name: (0, $9UOXx.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $9UOXx.OperationIds).LessThan,
        name: (0, $9UOXx.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $9UOXx.OperationIds).IsEmpty,
        name: (0, $9UOXx.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $9UOXx.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $9UOXx.Operation).EqualsIgnoreWhitespace
    }
];
const $99e7e29e33b6775a$export$a7c923252528b255 = {
    lastEntity: 'eoc-routing-rules_last_entity',
    alertFilters: 'eoc-routing-rules_alert_filters',
    timeSlots: 'eoc-routing-rules_time_slots'
};

});
parcelRegister("9UOXx", function(module, exports) {

$parcel$export(module.exports, "OperationIds", () => $c6f99876d1cc943b$export$9e369e35ea3634d7);
$parcel$export(module.exports, "MatchConditionType", () => $c6f99876d1cc943b$export$dab128282aa7aeee);
$parcel$export(module.exports, "Operation", () => $c6f99876d1cc943b$export$ab5aad00225c5662);
var $c6f99876d1cc943b$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $c6f99876d1cc943b$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});
var $c6f99876d1cc943b$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});

});


parcelRegister("kIkhc", function(module, exports) {

$parcel$export(module.exports, "routingRulesLoadExperience", () => $b0e034091738a56b$export$7385ded1fc45a62d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $b0e034091738a56b$export$7385ded1fc45a62d = new (0, $duUGa.UFOExperience)('eoc-routing-rules-load', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load
});

});

parcelRegister("8b9tZ", function(module, exports) {

$parcel$export(module.exports, "useRoutingRulesController", () => $56e3182ba7192fe7$export$417178ef74d8c8f0);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $hem2I = parcelRequire("hem2I");

var $ffQsw = parcelRequire("ffQsw");

var $9UOXx = parcelRequire("9UOXx");

var $7OWo5 = parcelRequire("7OWo5");

var $8SpRt = parcelRequire("8SpRt");

var $bPsP4 = parcelRequire("bPsP4");
const $56e3182ba7192fe7$export$417178ef74d8c8f0 = ({ schedules: schedules })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: data } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('useRoutingRulesController', 'We should not render useRoutingRulesController before data is fetched'));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [editingData, setEditingData] = (0, $5uXOq.useState)();
    const [isCloning, setIsCloning] = (0, $5uXOq.useState)(false);
    const [lastRuleValue, setLastRuleValue] = (0, $5uXOq.useState)();
    const [routeToOptions, setRouteToOptions] = (0, $5uXOq.useState)([]);
    const [isRoutingRuleModalOpen, setIsRoutingRuleModalOpen] = (0, $5uXOq.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $5uXOq.useState)(false);
    const [deletingId, setDeletingId] = (0, $5uXOq.useState)('');
    const { createRoutingRule: createRoutingRule, updateRoutingRule: updateRoutingRule, deleteRoutingRule: deleteRoutingRule, changeOrderRoutingRule: changeOrderRoutingRule, isDeleting: isDeleting, isCreating: isCreating, isUpdating: isUpdating, isChangingOrder: isChangingOrder, saveView: saveView, completeTask: completeTask } = (0, $bPsP4.useRoutingRuleService)();
    (0, $5uXOq.useEffect)(()=>{
        if (data) {
            const options = (0, $7OWo5.createRouteAlertOptions)(formatMessage, data, schedules);
            setRouteToOptions(options);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        schedules
    ]);
    const openRoutingRuleModal = ()=>setIsRoutingRuleModalOpen(true);
    const closeRoutingRuleModal = ()=>{
        setIsRoutingRuleModalOpen(false);
        setIsCloning(false);
        setEditingData(undefined);
    };
    const openDeleteModal = ()=>setIsDeleteModalOpen(true);
    const closeDeleteModal = ()=>{
        setIsDeleteModalOpen(false);
        setIsCloning(false);
        setEditingData(undefined);
    };
    const handleEditClick = (data)=>{
        setEditingData(data);
        openRoutingRuleModal();
        completeTask();
    };
    const handleCloneClick = (data)=>{
        setIsCloning(true);
        setEditingData(data);
        openRoutingRuleModal();
    };
    const handleDeleteClick = (data)=>{
        setEditingData(data);
        openDeleteModal();
    };
    const handleSubmitRule = (values)=>{
        let timeRestrictions = values.timeRestrictions;
        if (values.start && values.end) timeRestrictions = [
            (0, $7OWo5.transformTimeToObject)(values.start, values.end)
        ];
        const isNoOne = values.entity.value === 'noOne';
        const formattedValues = {
            name: values.name,
            conditionMatchType: (0, $9UOXx.MatchConditionType)[values.conditions.matchType],
            conditions: values.conditions.conditions.map((condition)=>({
                    ...condition,
                    operation: (0, $ffQsw.OPERATIONS).find((operation)=>operation.name === condition.operation).id
                })),
            timeRestrictedInterval: {
                appliedTimeZone: editingData?.timeRestrictedInterval.appliedTimeZone || '',
                enabled: values.timeRestrictedIntervalEnabled,
                timeRestrictions: timeRestrictions
            },
            entityId: isNoOne ? '' : values.entity.value,
            entityType: isNoOne ? '' : values.entity.type,
            timeZoneId: values.timeZoneId?.value || null,
            ruleTarget: isNoOne ? 0 : 1
        };
        if (editingData && !isCloning) {
            const updatedData = {
                ...formattedValues,
                id: editingData.id,
                isDefault: false
            };
            updateRoutingRule(updatedData).then(()=>closeRoutingRuleModal()).then(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule edited', editingData.id);
            }).catch(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule editFailed', editingData.id);
            });
        } else createRoutingRule(formattedValues).then((res)=>{
            closeRoutingRuleModal();
            const event = createAnalyticsEvent({});
            if (isCloning && editingData) {
                (0, $h8yj2.fireTrackAnalytics)(event, `routingRule cloned`, editingData.id);
                return;
            }
            (0, $h8yj2.fireTrackAnalytics)(event, `routingRule added`);
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule createFailed');
        });
    };
    const handleChangeLastRule = (entity, changedValue)=>{
        setLastRuleValue(changedValue);
        const isNoOne = changedValue.value === 'noOne';
        const formattedValues = {
            ...entity,
            entityId: isNoOne ? '' : changedValue.value,
            entityType: isNoOne ? '' : changedValue.type,
            ruleTarget: isNoOne ? 0 : 1
        };
        updateRoutingRule({
            ...formattedValues,
            isDefault: true
        }).catch(()=>{
            setLastRuleValue(lastRuleValue);
        });
    };
    const handleDeleteRule = ()=>{
        if (editingData) {
            setDeletingId(editingData.id);
            deleteRoutingRule(editingData.id, editingData.name).then(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule deleted', editingData.id);
            }).catch(()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule deleteFailed', editingData.id);
            }).finally(()=>setDeletingId(''));
            closeDeleteModal();
        }
    };
    const handleChangeOrder = (payload, updatedValue)=>{
        changeOrderRoutingRule(payload, updatedValue).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'routingRuleOrder changed', payload.id, {
                order: payload.targetIndex
            });
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'routingRuleOrder failed', payload.id, {
                order: payload.targetIndex
            });
        });
    };
    const handleSaveView = ()=>{
        saveView().then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule collapsed');
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'routingRule collapseFailed');
        });
    };
    return {
        isCreating: isCreating,
        isUpdating: isUpdating,
        isCloning: isCloning,
        isDeleting: isDeleting,
        isDeleteModalOpen: isDeleteModalOpen,
        isChangingOrder: isChangingOrder,
        isRoutingRuleModalOpen: isRoutingRuleModalOpen,
        routeToOptions: routeToOptions,
        editingData: editingData,
        lastRuleValue: lastRuleValue,
        deletingId: deletingId,
        handleDeleteClick: handleDeleteClick,
        handleEditClick: handleEditClick,
        handleCloneClick: handleCloneClick,
        openRoutingRuleModal: openRoutingRuleModal,
        closeRoutingRuleModal: closeRoutingRuleModal,
        openDeleteModal: openDeleteModal,
        closeDeleteModal: closeDeleteModal,
        setLastRuleValue: setLastRuleValue,
        handleSubmitRule: handleSubmitRule,
        handleChangeLastRule: handleChangeLastRule,
        handleDeleteRule: handleDeleteRule,
        handleChangeOrder: handleChangeOrder,
        toggleSection: handleSaveView
    };
};

});
parcelRegister("7OWo5", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $cea97fe6e59ae9cc$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "createRouteAlertOptions", () => $cea97fe6e59ae9cc$export$14fe882a85223edc);
$parcel$export(module.exports, "getDefaultTimes", () => $cea97fe6e59ae9cc$export$951e947e785c998d);
$parcel$export(module.exports, "transformTimeToObject", () => $cea97fe6e59ae9cc$export$f9391ba4dca4b420);
$parcel$export(module.exports, "getMatchType", () => $cea97fe6e59ae9cc$export$a8ea0fb63186ef7e);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $f2F4g = parcelRequire("f2F4g");

var $1GF3c = parcelRequire("1GF3c");

var $ffQsw = parcelRequire("ffQsw");

var $fS4FX = parcelRequire("fS4FX");
const $cea97fe6e59ae9cc$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $ffQsw.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $cea97fe6e59ae9cc$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), 'EEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $cea97fe6e59ae9cc$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $cea97fe6e59ae9cc$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};
const $cea97fe6e59ae9cc$export$14fe882a85223edc = (formatMessage, data, schedules)=>{
    const escalationEntities = data.escalations.entities?.map((esc)=>({
            value: esc.id,
            type: 'esc',
            label: esc.name,
            enabled: esc.enabled
        }));
    const scheduleEntities = schedules?.map((schedule)=>({
            value: schedule.id || '',
            type: 'sch',
            label: schedule.name || '',
            enabled: schedule.enabled
        }));
    const escalationOptions = {
        label: formatMessage((0, $fS4FX.default).escalations),
        options: escalationEntities || []
    };
    const scheduleOptions = {
        label: formatMessage((0, $fS4FX.default).schedules),
        options: scheduleEntities || []
    };
    const otherOption = {
        label: formatMessage((0, $fS4FX.default).other),
        options: [
            {
                value: 'noOne',
                label: formatMessage((0, $fS4FX.default).noOne),
                type: ''
            }
        ]
    };
    let options = [];
    if (escalationOptions.options.length > 0) options.push(escalationOptions);
    if (scheduleOptions.options.length > 0) options.push(scheduleOptions);
    options.push(otherOption);
    return options;
};
const $cea97fe6e59ae9cc$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $cea97fe6e59ae9cc$export$f9391ba4dca4b420 = (startTime, endTime)=>{
    const [startHour, startMinute] = startTime.split(':');
    const [endHour, endMinute] = endTime.split(':');
    return {
        startHour: parseInt(startHour, 10),
        startMinute: parseInt(startMinute, 10),
        endHour: parseInt(endHour, 10),
        endMinute: parseInt(endMinute, 10)
    };
};
const $cea97fe6e59ae9cc$export$a8ea0fb63186ef7e = (conditionMatchType)=>{
    switch(conditionMatchType){
        case 1:
            return 'match-any-condition';
        case 2:
            return 'match-all-conditions';
        default:
            return 'match-all';
    }
};

});
parcelRegister("fS4FX", function(module, exports) {

$parcel$export(module.exports, "default", () => $79293a4cf5b403ba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $79293a4cf5b403ba$var$messages = (0, $7VHMR.defineMessages)({
    other: {
        id: 'eoc.routing-rules.ui.other.no-translate',
        defaultMessage: 'Other',
        description: 'The label of other group when will be shown on select options'
    },
    escalations: {
        id: 'eoc.routing-rules.ui.escalations.no-translate',
        defaultMessage: 'Escalation(s)',
        description: 'The label of escalations group when will be shown on select options'
    },
    schedules: {
        id: 'eoc.routing-rules.ui.schedules.no-translate',
        defaultMessage: 'Schedule(s)',
        description: 'The label of schedules group when will be shown on select options'
    },
    noOne: {
        id: 'eoc.routing-rules.ui.no-one.no-translate',
        defaultMessage: 'No one',
        description: 'The label of other group option'
    }
});
var $79293a4cf5b403ba$export$2e2bcd8739ae039 = $79293a4cf5b403ba$var$messages;

});


parcelRegister("bPsP4", function(module, exports) {

$parcel$export(module.exports, "useRoutingRuleService", () => $3cbde2949540730e$export$9fbd69c25aa51c3e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $2VYEV = parcelRequire("2VYEV");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $8SpRt = parcelRequire("8SpRt");

var $h1GR2 = parcelRequire("h1GR2");

var $kgbQk = parcelRequire("kgbQk");
const $3cbde2949540730e$export$9fbd69c25aa51c3e = ()=>{
    const { data: data, update: update } = (0, $hem2I.default)((0, $8SpRt.routingRulesResource));
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const [isCreating, setIsCreating] = (0, $5uXOq.useState)(false);
    const [isUpdating, setIsUpdating] = (0, $5uXOq.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $5uXOq.useState)(false);
    const [isChangingOrder, setIsChangingOrder] = (0, $5uXOq.useState)(false);
    const flagApi = (0, $2tKfK.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $hmVmJ.assert)(!!data && !!teamId, new (0, $dH6Pi.AssertionError)('useRoutingRuleService', 'We should not render useRoutingRuleService before teamId is fetched'));
    const createRoutingRule = (0, $5uXOq.useCallback)((routingRule)=>{
        setIsCreating(true);
        return (0, $h1GR2.createRoutingRuleEndpoint)(teamId, routingRule).then((res)=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $kgbQk.default).routingRuleCreated, {
                    name: routingRule.name || false
                })
            });
            update(()=>res);
            const lastIndex = res.routingRules.entities.length - 2;
            const addedEntity = res.routingRules.entities[lastIndex];
            return addedEntity;
        }).catch(defaultCatch({
            id: 'useRoutingRuleService-createRoutingRule',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kgbQk.default).createError)
                });
                throw err;
            }
        })).finally(()=>setIsCreating(false));
    }, [
        defaultCatch,
        flagApi,
        formatMessage,
        teamId,
        update
    ]);
    const updateRoutingRule = (0, $5uXOq.useCallback)((routingRule)=>{
        setIsUpdating(true);
        return (0, $h1GR2.updateRoutingRuleEndpoint)(teamId, routingRule).then((res)=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage(routingRule.isDefault ? (0, $kgbQk.default).defaultRoutingRuleUpdated : (0, $kgbQk.default).routingRuleUpdated, {
                    name: routingRule.name || false
                })
            });
            update(()=>res);
        }).catch(defaultCatch({
            id: 'useRoutingRuleService-updateRoutingRule',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kgbQk.default).updateError)
                });
                throw err;
            }
        })).finally(()=>setIsUpdating(false));
    }, [
        defaultCatch,
        flagApi,
        formatMessage,
        teamId,
        update
    ]);
    const deleteRoutingRule = (0, $5uXOq.useCallback)((routingRuleId, name)=>{
        setIsDeleting(true);
        return (0, $h1GR2.deleteRoutingRuleEndpoint)(teamId, routingRuleId).then((res)=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $kgbQk.default).routingRuleDeleted, {
                    name: name || false
                })
            });
            const entities = data.routingRules.entities.filter((entity)=>entity.id !== routingRuleId);
            update(()=>({
                    ...data,
                    routingRules: {
                        ...data.routingRules,
                        entities: entities
                    }
                }));
        }).catch(defaultCatch({
            id: 'useRoutingRuleService-deleteRoutingRule',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kgbQk.default).deleteError),
                    actions: [
                        {
                            content: formatMessage((0, $kgbQk.default).refresh),
                            onClick: ()=>window.location.reload()
                        }
                    ]
                });
                throw err;
            }
        })).finally(()=>setIsDeleting(false));
    }, [
        data,
        defaultCatch,
        flagApi,
        formatMessage,
        teamId,
        update
    ]);
    const changeOrderRoutingRule = (0, $5uXOq.useCallback)((payload, updatedValue)=>{
        setIsChangingOrder(true);
        update(()=>{
            return {
                ...data,
                routingRules: {
                    ...data.routingRules,
                    entities: updatedValue
                }
            };
        });
        return (0, $h1GR2.changeOrderRoutingRuleEndpoint)(teamId, payload).catch(defaultCatch({
            id: 'useRoutingRuleService-changeOrderRoutingRule',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kgbQk.default).reorderError),
                    actions: [
                        {
                            content: formatMessage((0, $kgbQk.default).refresh),
                            onClick: ()=>window.location.reload()
                        }
                    ]
                });
                throw err;
            }
        })).finally(()=>setIsChangingOrder(false));
    }, [
        data,
        defaultCatch,
        flagApi,
        formatMessage,
        teamId,
        update
    ]);
    const saveView = (0, $5uXOq.useCallback)(()=>{
        const collapsed = data.routingRules.collapsed;
        const newData = {
            ...data,
            routingRules: {
                ...data.routingRules,
                collapsed: !collapsed
            }
        };
        update(()=>newData);
        const view = {
            collapsed: !collapsed
        };
        return (0, $h1GR2.saveViewEndpoint)(teamId, view).catch(defaultCatch({
            id: 'useRoutingRuleService-saveView',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kgbQk.default).saveViewError),
                    actions: [
                        {
                            content: formatMessage((0, $kgbQk.default).refresh),
                            onClick: ()=>window.location.reload()
                        }
                    ]
                });
                throw err;
            }
        }));
    }, [
        data,
        defaultCatch,
        flagApi,
        formatMessage,
        teamId,
        update
    ]);
    const completeTask = (0, $5uXOq.useCallback)(()=>{
        return (0, $h1GR2.completeTaskEndpoint)(teamId);
    }, [
        teamId
    ]);
    return {
        isCreating: isCreating,
        isUpdating: isUpdating,
        isDeleting: isDeleting,
        isChangingOrder: isChangingOrder,
        createRoutingRule: createRoutingRule,
        updateRoutingRule: updateRoutingRule,
        deleteRoutingRule: deleteRoutingRule,
        changeOrderRoutingRule: changeOrderRoutingRule,
        saveView: saveView,
        completeTask: completeTask
    };
};

});
parcelRegister("h1GR2", function(module, exports) {

$parcel$export(module.exports, "createRoutingRuleEndpoint", () => $0e00ab0f23d119ab$export$61fe20abe6790e6a);
$parcel$export(module.exports, "updateRoutingRuleEndpoint", () => $0e00ab0f23d119ab$export$3bcb8f970b2e60b8);
$parcel$export(module.exports, "deleteRoutingRuleEndpoint", () => $0e00ab0f23d119ab$export$9d0836f5c0a3ae24);
$parcel$export(module.exports, "changeOrderRoutingRuleEndpoint", () => $0e00ab0f23d119ab$export$68c39d776dc21d7);
$parcel$export(module.exports, "saveViewEndpoint", () => $0e00ab0f23d119ab$export$9bfec2bc35e4b833);
$parcel$export(module.exports, "completeTaskEndpoint", () => $0e00ab0f23d119ab$export$43adb756d1007327);

var $j74qU = parcelRequire("j74qU");
const $0e00ab0f23d119ab$export$61fe20abe6790e6a = (teamId, routingRule)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/routing-rules`, {
        method: 'POST',
        body: routingRule
    });
};
const $0e00ab0f23d119ab$export$3bcb8f970b2e60b8 = (teamId, routingRule)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/routing-rules/${routingRule.id}`, {
        method: 'PUT',
        body: routingRule
    });
};
const $0e00ab0f23d119ab$export$9d0836f5c0a3ae24 = (teamId, deletedRoutingRuleId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/routing-rules/${deletedRoutingRuleId}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $0e00ab0f23d119ab$export$68c39d776dc21d7 = (teamId, payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/routing-rules/${payload.id}/orders`, {
        method: 'POST',
        body: payload,
        responseType: 'headers'
    });
};
const $0e00ab0f23d119ab$export$9bfec2bc35e4b833 = (teamId, view)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/ui-preferences/teams/${teamId}/routing-rules`, {
        method: 'PATCH',
        body: view,
        responseType: 'headers'
    });
};
const $0e00ab0f23d119ab$export$43adb756d1007327 = (teamId)=>{
    return (0, $j74qU.eocFetch)('/v1/onboarding/complete-task', {
        method: 'POST',
        body: {
            platformTeamId: teamId,
            completedItemKey: 'opsgenie-review-oncall-setup'
        }
    });
};

});

parcelRegister("kgbQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa81332a3917743$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6fa81332a3917743$var$messages = (0, $7VHMR.defineMessages)({
    routingRuleCreated: {
        id: 'eoc.routing-rules.flag.routing-rule-created.no-translate',
        defaultMessage: `Routing rule{name, select,
      false {}
      other { "{name}"}
    } added.`,
        description: 'Title of success message that will be displayed in the flag after routing rule created'
    },
    routingRuleUpdated: {
        id: 'eoc.routing-rules.flag.routing-rule-updated.no-translate',
        defaultMessage: `Routing rule{name, select,
      false {}
      other { "{name}"}
    } saved.`,
        description: 'Title of success message that will be displayed in the flag after routing rule updated'
    },
    routingRuleDeleted: {
        id: 'eoc.routing-rules.flag.routing-rule-deleted.no-translate',
        defaultMessage: `Routing rule{name, select,
      false {}
      other { "{name}"}
    } deleted.`,
        description: 'Title of success message that will be displayed in the flag after routing rule updated'
    },
    defaultRoutingRuleUpdated: {
        id: 'eoc.routing-rules.flag.default-routing-rule-updated.no-translate',
        defaultMessage: 'Routing rule updated.',
        description: 'Title of success message that will be displayed in the flag after default routing rule updated'
    },
    reorderError: {
        id: 'eoc.routing-rules.flag.reorder-error.no-translate',
        defaultMessage: `We couldn't reorder routing rules`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while reordering the routing rules'
    },
    deleteError: {
        id: 'eoc.routing-rules.flag.delete-error.no-translate',
        defaultMessage: `We couldn't delete the routing rule`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while deleting the routing rule'
    },
    updateError: {
        id: 'eoc.routing-rules.flag.update-error.no-translate',
        defaultMessage: `We couldn't update the routing rule`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while updating the routing rule'
    },
    createError: {
        id: 'eoc.routing-rules.flag.create-error.no-translate',
        defaultMessage: `We couldn't create the routing rule`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while creating the routing rule'
    },
    saveViewError: {
        id: 'eoc.routing-rules.flag.save-view-error.no-translate',
        defaultMessage: `We couldn't save the view preferences`,
        description: 'Title of error message that will be displayed in the flag if something went wrong while saving the view preferences'
    },
    refresh: {
        id: 'eoc.routing-rules.flag.refresh.no-translate',
        defaultMessage: `Refresh`,
        description: 'Label of first action button inside flag'
    }
});
var $6fa81332a3917743$export$2e2bcd8739ae039 = $6fa81332a3917743$var$messages;

});



parcelRegister("5HC04", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $d9e0b1e65be7937f$export$73392e09138fecd6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $8cFjQ = parcelRequire("8cFjQ");
const $d9e0b1e65be7937f$export$73392e09138fecd6 = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, name: name, returnFocusRef: returnFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        width: "small",
        onClose: onClose,
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $8cFjQ.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage((0, $8cFjQ.messages).description, {
        name: name || false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $8cFjQ.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "warning",
        onClick: onConfirm
    }, formatMessage((0, $8cFjQ.messages).deleteButton)))));
};

});
parcelRegister("8cFjQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4ee609d1966bdd57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4ee609d1966bdd57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.routing-rules.delete-modal.title.no-translate',
        defaultMessage: 'Delete routing rule?',
        description: 'The text will be displayed in the delete modal title.'
    },
    description: {
        id: 'eoc.routing-rules.delete-modal.description.no-translate',
        defaultMessage: `This will permanently delete the routing rule{name, select,
      false {}
      other { "{name}"}
    }. This can\u{2019}t be undone.`,
        description: 'The text will be displayed in the delete modal description.'
    },
    cancelButton: {
        id: 'eoc.routing-rules.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    deleteButton: {
        id: 'eoc.routing-rules.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("c88EM", function(module, exports) {

$parcel$export(module.exports, "ElseCardContent", () => $284dc3250410c3d0$export$2486aba241017c40);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lj8SI = parcelRequire("lj8SI");

var $7K5PP = parcelRequire("7K5PP");

var $dY87H = parcelRequire("dY87H");

var $9poNi = parcelRequire("9poNi");

var $34Ozh = parcelRequire("34Ozh");

var $8b9tZ = parcelRequire("8b9tZ");

var $1BuQ2 = parcelRequire("1BuQ2");

var $qk6mY = parcelRequire("qk6mY");
const $284dc3250410c3d0$export$2486aba241017c40 = ({ entityCount: entityCount, entity: entity, routeToOptions: routeToOptions, isDeleted: isDeleted, hasEditRight: hasEditRight })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { handleChangeLastRule: handleChangeLastRule, isUpdating: isUpdating, lastRuleValue: lastRuleValue, setLastRuleValue: setLastRuleValue } = (0, $8b9tZ.useRoutingRulesController)({});
    (0, $5uXOq.useEffect)(()=>{
        if (routeToOptions) {
            if (isDeleted) {
                setLastRuleValue(null);
                return;
            }
            const options = routeToOptions.flatMap((option)=>option.options);
            const defaultValue = options.find((option)=>{
                if (option?.value === entity.entityId) return option?.value === entity.entityId;
            });
            const noOneValue = options.find((option)=>option?.value === 'noOne');
            setLastRuleValue(defaultValue || noOneValue);
        }
    }, [
        entity.entityId,
        routeToOptions,
        setLastRuleValue,
        isDeleted
    ]);
    const handleChange = (selectedItem)=>{
        if (selectedItem) handleChangeLastRule(entity, selectedItem);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qk6mY.ElseRuleCardContentContainer), {
        isLastItem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center",
        columnGap: 3.75,
        flex: 1
    }, entityCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "inprogress"
    }, formatMessage((0, $1BuQ2.default).else)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qk6mY.ElseRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center",
        columnGap: 3,
        flex: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "route-all-alerts-to"
    }, formatMessage(entityCount > 1 ? (0, $1BuQ2.default).routeAllAlertsTo : (0, $1BuQ2.default).routeAllAlertsToSingle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qk6mY.SelectContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        placeholder: isDeleted ? formatMessage((0, $1BuQ2.default).deletedEntity) : undefined,
        options: routeToOptions,
        value: lastRuleValue,
        onChange: handleChange,
        isLoading: isUpdating,
        isDisabled: isUpdating || !hasEditRight,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                justifyContent: "space-between",
                alignItems: "center",
                columnGap: 1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.OptionLabel), null, option?.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                columnGap: 1
            }, option?.enabled === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
                appearance: "moved"
            }, formatMessage((0, $9poNi.default).off)))),
        labelId: "route-all-alerts-to"
    })), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qk6mY.DeletedLozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, formatMessage((0, $1BuQ2.default).routeTargetDeleted)))))));
};

});
parcelRegister("9poNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $151cefe6017e4a3c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $151cefe6017e4a3c$var$messages = (0, $7VHMR.defineMessages)({
    operationVerbalForm: {
        id: 'eoc.routing-rules.common-messages.operation-verbal-form.no-translate',
        defaultMessage: `{field} {not, select,
        true {does not}
        other {}
      } {operation} <strong>{expectedValue}</strong>`,
        description: 'Full message of operation. Example: message contains important / message does not contains important'
    },
    operationVerbalFreeForm: {
        id: 'eoc.routing-rules.common-messages.operation-verbal-free-form.no-translate',
        defaultMessage: `value of {field} in extra properties {not, select,
        true {does not}
        other {}
      } {operation} <strong>{expectedValue}</strong>`,
        description: 'Full message of freeform operation. Example: value of message in extra properties contains important / value of message in extra properties does not contains important'
    },
    or: {
        id: 'eoc.routing-rules.common-messages.or.no-translate',
        defaultMessage: '<strong>OR </strong>',
        description: '"Or" condition'
    },
    and: {
        id: 'eoc.routing-rules.common-messages.and.no-translate',
        defaultMessage: '<strong>AND </strong>',
        description: '"And" condition'
    },
    matches: {
        id: 'eoc.routing-rules.common-messages.matches.no-translate',
        defaultMessage: 'matches',
        description: '"matches" operation. example: message matches "critical"'
    },
    matches_singular: {
        id: 'eoc.routing-rules.common-messages.matches_singular.no-translate',
        defaultMessage: 'match',
        description: 'singular version of "matches" operation. example: message does not match "critical"'
    },
    contains: {
        id: 'eoc.routing-rules.common-messages.contains.no-translate',
        defaultMessage: 'contains',
        description: '"contains" operation. example: message contains "critical"'
    },
    contains_singular: {
        id: 'eoc.routing-rules.common-messages.contains_singular.no-translate',
        defaultMessage: 'contain',
        description: 'singular version of "contains" operation. example: message does not contain "critical"'
    },
    'starts-with': {
        id: 'eoc.routing-rules.common-messages.starts-with.no-translate',
        defaultMessage: 'starts with',
        description: '"starts-with" operation. example: message starts with "critical"'
    },
    'starts-with_singular': {
        id: 'eoc.routing-rules.common-messages.starts-with_singular.no-translate',
        defaultMessage: 'start with',
        description: 'singular version of "starts-with" operation. example: message does not start with "critical"'
    },
    'ends-with': {
        id: 'eoc.routing-rules.common-messages.ends-with.no-translate',
        defaultMessage: 'ends with',
        description: '"ends-with" operation. example: message ends with "critical"'
    },
    'ends-with_singular': {
        id: 'eoc.routing-rules.common-messages.ends-with_singular.no-translate',
        defaultMessage: 'end with',
        description: 'singular version of "ends-with" operation. example: message does not end with "critical"'
    },
    equals: {
        id: 'eoc.routing-rules.common-messages.equals.no-translate',
        defaultMessage: 'equals',
        description: '"equals" operation. example: message equals "critical"'
    },
    equals_singular: {
        id: 'eoc.routing-rules.common-messages.equals_singular.no-translate',
        defaultMessage: 'equal',
        description: 'singular version of "equals" operation. example: message does not equal "critical"'
    },
    'contains-key': {
        id: 'eoc.routing-rules.common-messages.contains-key.no-translate',
        defaultMessage: 'contains key',
        description: '"contains-key" operation. example: message contains key "critical"'
    },
    'contains-key_singular': {
        id: 'eoc.routing-rules.common-messages.contains-key_singular.no-translate',
        defaultMessage: 'contain key',
        description: 'singular version of "contains-key" operation. example: message does not contain key "critical"'
    },
    'contains-value': {
        id: 'eoc.routing-rules.common-messages.contains-value.no-translate',
        defaultMessage: 'contains value',
        description: '"contains-value" operation. example: message contains value "critical"'
    },
    'contains-value_singular': {
        id: 'eoc.routing-rules.common-messages.contains-value_singular.no-translate',
        defaultMessage: 'contain value',
        description: 'singular version of "contains-value" operation. example: message does not contain value "critical"'
    },
    'greater-than': {
        id: 'eoc.routing-rules.common-messages.greater-than.no-translate',
        defaultMessage: 'greater than',
        description: '"greater-than" operation. example: message greater than "4"'
    },
    'greater-than_singular': {
        id: 'eoc.routing-rules.common-messages.greater-than_singular.no-translate',
        defaultMessage: 'greater than',
        description: '"greater-than" operation. example: message greater than "4"'
    },
    'less-than': {
        id: 'eoc.routing-rules.common-messages.less-than.no-translate',
        defaultMessage: 'less than',
        description: '"less-than" operation. example: message less than "5"'
    },
    'less-than_singular': {
        id: 'eoc.routing-rules.common-messages.less-than_singular.no-translate',
        defaultMessage: 'less than',
        description: '"less-than" operation. example: message less than "5"'
    },
    'is-empty': {
        id: 'eoc.routing-rules.common-messages.is-empty.no-translate',
        defaultMessage: 'is empty',
        description: '"is empty" operation. example: message is empty'
    },
    'is-empty_singular': {
        id: 'eoc.routing-rules.common-messages.is-empty_singular.no-translate',
        defaultMessage: 'is empty',
        description: '"is empty" operation. example: message is empty'
    },
    'equals-ignore-whitespace': {
        id: 'eoc.routing-rules.common-messages.equals-ignore-whitespace.no-translate',
        defaultMessage: 'equals ignore whitespace',
        description: '"equals-ignore-whitespace" operation. example: message equals ignore whitespace "critical"'
    },
    'equals-ignore-whitespace_singular': {
        id: 'eoc.routing-rules.common-messages.equals-ignore-whitespace_singular.no-translate',
        defaultMessage: 'equal ignore whitespace',
        description: 'singular version of "equals-ignore-whitespace" operation. example: message does not equal ignore whitespace "critical"'
    },
    forAny: {
        id: 'eoc.routing-rules.common-messages.for-any-received-alert.no-translate',
        defaultMessage: 'for any received alert',
        description: 'Label of rule card condition'
    },
    errorTitle: {
        id: 'eoc.routing-rules.flag.error-title.no-translate',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    },
    successTitle: {
        id: 'eoc.routing-rules.flag.success-title.no-translate',
        defaultMessage: 'Success',
        description: 'Title of success message that will be displayed in the flag'
    },
    off: {
        id: 'eoc.routing-rules.common-messages.off.no-translate',
        defaultMessage: 'Off',
        description: 'Indicator text when one of the route all alerts to option is not enabled.'
    }
});
var $151cefe6017e4a3c$export$2e2bcd8739ae039 = $151cefe6017e4a3c$var$messages;

});

parcelRegister("34Ozh", function(module, exports) {

$parcel$export(module.exports, "RuleCardContentContainer", () => $e0bb6fe3f03f6545$export$81624605cfa46850);
$parcel$export(module.exports, "LozengeWrapper", () => $e0bb6fe3f03f6545$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "FieldResetter", () => $e0bb6fe3f03f6545$export$19e4c5fdd36bc992);
$parcel$export(module.exports, "OptionLabel", () => $e0bb6fe3f03f6545$export$2cf7ef1e2dd6c6b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $e0bb6fe3f03f6545$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e0bb6fe3f03f6545$export$cd749991632e68e2 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e8yh2i84"
})({
    name: "1ntk8fw",
    styles: "flex-direction:column;row-gap:var(--ds-space-050, 4px)"
});
const $e0bb6fe3f03f6545$export$81624605cfa46850 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8yh2i83"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        rowGap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: props.isLastItem ? "var(--ds-space-0, 0px)" : "var(--ds-space-100, 8px)",
        marginLeft: "var(--ds-space-400, 32px)",
        width: '90%'
    }));
const $e0bb6fe3f03f6545$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8yh2i82"
})({
    name: "17j5deh",
    styles: "display:flex;align-items:center;height:21px;width:100%;flex-grow:0"
});
const $e0bb6fe3f03f6545$export$19e4c5fdd36bc992 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8yh2i81"
})({
    name: "keyfe3",
    styles: "margin-top:var(--ds-space-negative-100, -8px)"
});
const $e0bb6fe3f03f6545$export$2cf7ef1e2dd6c6b1 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8yh2i80"
})({
    name: "ayssrx",
    styles: "width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});

});

parcelRegister("1BuQ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c606bc5377e2ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a7c606bc5377e2ed$var$messages = (0, $7VHMR.defineMessages)({
    else: {
        id: 'eoc.routing-rules.ui.else-card-content.else.no-translate',
        defaultMessage: 'ELSE',
        description: 'Label of last rule condition'
    },
    routeAllAlertsTo: {
        id: 'eoc.routing-rules.ui.else-card-content.route-all-alerts-to.no-translate',
        defaultMessage: 'route all alerts to',
        description: 'The label of latest rule condition'
    },
    routeAllAlertsToSingle: {
        id: 'eoc.routing-rules.ui.else-card-content.route-all-alerts-to-single.no-translate',
        defaultMessage: 'Route all alerts to',
        description: 'The label of latest rule condition'
    },
    routeTargetDeleted: {
        id: 'eoc.routing-rules.ui.else-card-content.route-target-deleted.no-translate',
        defaultMessage: 'Route Target Deleted',
        description: 'Label of route target deleted lozenge'
    },
    deletedEntity: {
        id: 'eoc.routing-rules.ui.else-card-content.deleted-entity.no-translate',
        defaultMessage: 'Deleted Entity',
        description: 'Plcaeholder of route target to selectbox when the entity is not exist anymore'
    }
});
var $a7c606bc5377e2ed$export$2e2bcd8739ae039 = $a7c606bc5377e2ed$var$messages;

});

parcelRegister("qk6mY", function(module, exports) {

$parcel$export(module.exports, "SelectContainer", () => $7c5a7a5a43381915$export$446eebadefe1123b);
$parcel$export(module.exports, "DeletedLozengeWrapper", () => $7c5a7a5a43381915$export$b53c1e45a3b0624d);
$parcel$export(module.exports, "ElseRow", () => $7c5a7a5a43381915$export$3fc0a76ad114ee32);
$parcel$export(module.exports, "ElseRuleCardContentContainer", () => $7c5a7a5a43381915$export$f6542214bd75d247);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jj11s = parcelRequire("jj11s");

var $34Ozh = parcelRequire("34Ozh");

var $bWGt6 = parcelRequire("bWGt6");
function $7c5a7a5a43381915$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7c5a7a5a43381915$export$446eebadefe1123b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e4btis73"
})({
    width: `${360}px`
});
const $7c5a7a5a43381915$export$b53c1e45a3b0624d = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e4btis72"
})({
    name: "1o3nkn",
    styles: "margin-left:auto"
});
const $7c5a7a5a43381915$export$3fc0a76ad114ee32 = /*#__PURE__*/ (0, $bWGt6.default)((0, $jj11s.RuleItemRow), {
    target: "e4btis71"
})({
    name: "82a6rk",
    styles: "flex:1"
});
const $7c5a7a5a43381915$export$f6542214bd75d247 = /*#__PURE__*/ (0, $bWGt6.default)((0, $34Ozh.RuleCardContentContainer), {
    target: "e4btis70"
})({
    name: "8y7yn",
    styles: "width:unset;margin-right:var(--ds-space-400, 32px)"
});

});


parcelRegister("3cKzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f5c5b2d590f044$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a9f5c5b2d590f044$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.routing-rules.ui.title.no-translate',
        defaultMessage: 'Routing rules',
        description: 'Title of routing rules section'
    },
    add: {
        id: 'eoc.routing-rules.ui.add.no-translate',
        defaultMessage: 'Create routing rule',
        description: 'Label of add routing rule button'
    }
});
var $a9f5c5b2d590f044$export$2e2bcd8739ae039 = $a9f5c5b2d590f044$var$messages;

});

parcelRegister("5y8ya", function(module, exports) {

$parcel$export(module.exports, "RoutingRuleModal", () => $a8fef3ce4ef1595a$export$82dfa0d0086012d8);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $kkJfY = parcelRequire("kkJfY");

var $jdTq6 = parcelRequire("jdTq6");

var $hp1g9 = parcelRequire("hp1g9");
var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $l1N8i = parcelRequire("l1N8i");

var $96UJI = parcelRequire("96UJI");

var $lj8SI = parcelRequire("lj8SI");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $cgL5K = parcelRequire("cgL5K");

var $3rLiX = parcelRequire("3rLiX");

var $92Z2l = parcelRequire("92Z2l");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $fbSeI = parcelRequire("fbSeI");

var $2TID8 = parcelRequire("2TID8");

var $dY87H = parcelRequire("dY87H");

var $ffQsw = parcelRequire("ffQsw");

var $9poNi = parcelRequire("9poNi");

var $34Ozh = parcelRequire("34Ozh");

var $7OWo5 = parcelRequire("7OWo5");

var $a5H39 = parcelRequire("a5H39");

var $4KBlT = parcelRequire("4KBlT");

var $1sGdg = parcelRequire("1sGdg");
const $a8fef3ce4ef1595a$export$82dfa0d0086012d8 = ({ isOpen: isOpen, isCloning: isCloning, isLoading: isLoading, onClose: onClose, onSubmit: onSubmit, onOpen: onOpen, conditionFields: conditionFields, routeToOptions: routeToOptions, data: data, defaultTimeZone: defaultTimeZone, returnFocusRef: returnFocusRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { timezones: timezones, isTimezonesLoading: isTimezonesLoading } = (0, $a5H39.useRoutingRuleModalController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    const isTimeRestricted = data && data.timeRestrictedInterval.timeRestrictions.length > 0;
    const isDeleted = data && !!data.deleted;
    const handleDefaultEntity = ()=>{
        if (routeToOptions) {
            const options = routeToOptions.flatMap((option)=>option.options);
            if (data && data.deleted) return null;
            const defaultValue = options.find((option)=>{
                if (data && option?.value === data.entityId) return option?.value === data.entityId;
            });
            const noOneValue = options.find((option)=>option?.value === 'noOne');
            return defaultValue || noOneValue;
        }
    };
    const radioGroupOptions = [
        {
            name: 'everyday',
            value: 'everyday',
            label: formatMessage((0, $4KBlT.default).forEveryday)
        },
        {
            name: 'customize-days',
            value: 'customize-days',
            label: formatMessage((0, $4KBlT.default).customizeDays)
        }
    ];
    const getDefaultTimeRestrictedInterval = ()=>{
        if (isTimeRestricted) {
            if (data.timeRestrictedInterval.timeRestrictions[0].startDay) return 'customize-days';
            return 'everyday';
        }
        return 'everyday';
    };
    const getDefaultStartTime = ()=>{
        if (isTimeRestricted) return `${data?.timeRestrictedInterval.timeRestrictions[0].startHour || '00'}:${data?.timeRestrictedInterval.timeRestrictions[0].startMinute || '00'}`;
        else return `00:00`;
    };
    const getDefaultEndTime = ()=>{
        if (isTimeRestricted) return `${data?.timeRestrictedInterval.timeRestrictions[0].endHour || '00'}:${data?.timeRestrictedInterval.timeRestrictions[0].endMinute || '00'}`;
        else return '06:00';
    };
    const getDefaultCustomTimeRestrictionValue = ()=>{
        if (isTimeRestricted) return data.timeRestrictedInterval.timeRestrictions;
        else return [
            {
                startDay: 2,
                startHour: 0,
                startMinute: 0,
                endDay: 3,
                endHour: 6,
                endMinute: 0
            }
        ];
    };
    const getDefaultTimezone = ()=>{
        if (data && data.timeZoneId) {
            const timezoneOption = timezones?.find((timezone)=>timezone.value === data.timeZoneId);
            return timezoneOption;
        }
        const defaultTimezoneOption = timezones?.find((timezone)=>timezone.value === defaultTimeZone.id);
        return {
            label: defaultTimezoneOption?.label,
            value: ''
        };
    };
    const getModalTitle = ()=>{
        if (isCloning) return formatMessage((0, $4KBlT.default).cloneTitle);
        if (data) return formatMessage((0, $4KBlT.default).editTitle);
        return formatMessage((0, $4KBlT.default).addTitle);
    };
    const getDefaultName = ()=>{
        if (!isCloning && data) return data.name;
        return '';
    };
    const getDefaultConditions = ()=>{
        if (data) return {
            conditions: data.conditions.map((condition)=>({
                    ...condition,
                    operation: (0, $7OWo5.getOperationName)(condition.operation)
                })),
            matchType: (0, $7OWo5.getMatchType)(data.conditionMatchType)
        };
        return {
            conditions: [],
            matchType: 'match-all'
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onOpenComplete: onOpen,
        width: "large",
        onClose: (_, event)=>{
            (0, $h8yj2.fireUIAnalytics)(event, 'routingRuleModal');
            handleClose();
        },
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            id: "routing-rule-modal",
            ...formProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, getModalTitle())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            flexDirection: "column",
            rowGap: 2.5
        }, isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            appearance: "warning"
        }, formatMessage((0, $4KBlT.default).routeDeletedWarning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $4KBlT.default).ruleTitle),
            name: "name",
            defaultValue: getDefaultName()
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                placeholder: formatMessage((0, $4KBlT.default).ruleTitlePlaceholder),
                autoComplete: "off",
                ...fieldProps
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: (0, $ffQsw.SPOTLIGHT_NAMES).alertFilters
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small"
        }, formatMessage((0, $4KBlT.default).followingConditions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.ConditionFilterWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $4KBlT.default).notifyInput),
            name: "conditions",
            defaultValue: getDefaultConditions(),
            validate: (value)=>{
                if (value && value.conditions.length > 0) {
                    const { conditions: conditions } = value;
                    const freeformFields = conditions.filter((condition)=>condition.fieldFreeForm);
                    if (freeformFields.length > 0) {
                        const isEmpty = freeformFields.some((freeformField)=>!freeformField.field);
                        if (isEmpty) return 'REQUIRED';
                    }
                }
            }
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbSeI.ConditionFilter), {
                fields: conditionFields.map((field)=>({
                        label: field.label,
                        type: field.type,
                        value: field.id
                    })),
                ...fieldProps
            }), error === 'REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, formatMessage((0, $4KBlT.default).conditionRequired))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.FieldResetter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: (0, $ffQsw.SPOTLIGHT_NAMES).timeSlots
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hp1g9.default), {
            label: formatMessage((0, $4KBlT.default).restrictToTimeInterval),
            name: "timeRestrictedIntervalEnabled",
            defaultIsChecked: data ? data.timeRestrictedInterval.enabled : false
        }, ({ fieldProps: { id: id, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
                label: formatMessage((0, $4KBlT.default).specificInterval),
                ...fieldProps
            }), fieldProps.isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                name: "timeRestrictedInterval",
                defaultValue: getDefaultTimeRestrictedInterval()
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.RadioWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rLiX.default), {
                    options: radioGroupOptions,
                    ...fieldProps
                }), fieldProps.value === 'everyday' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                    columnGap: 1
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.TimePickerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                    name: "start",
                    label: formatMessage((0, $4KBlT.default).from),
                    defaultValue: getDefaultStartTime(),
                    validate: (value)=>{
                        if (!value) return formatMessage((0, $4KBlT.default).fieldRequired);
                    }
                }, ({ fieldProps: { id: id, ...fieldProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
                        times: (0, $7OWo5.getDefaultTimes)(),
                        timeIsEditable: true,
                        ...fieldProps,
                        id: id
                    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.TimePickerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                    name: "end",
                    label: formatMessage((0, $4KBlT.default).to),
                    defaultValue: getDefaultEndTime(),
                    validate: (value)=>{
                        if (!value) return formatMessage((0, $4KBlT.default).fieldRequired);
                    }
                }, ({ fieldProps: { id: id, ...fieldProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
                        times: (0, $7OWo5.getDefaultTimes)(),
                        placeholder: "6:00 PM",
                        timeIsEditable: true,
                        ...fieldProps,
                        id: id
                    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))))), fieldProps.value === 'customize-days' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                    name: "timeRestrictions",
                    validate: (value)=>{
                        if (!value) return formatMessage((0, $4KBlT.default).fieldRequired);
                        const nullExist = value.find((interval)=>Object.values(interval).includes(null));
                        if (nullExist) return formatMessage((0, $4KBlT.default).fieldRequired);
                    },
                    defaultValue: getDefaultCustomTimeRestrictionValue()
                }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.DayTimeIntervalWrapper), {
                        flexDirection: "column"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2TID8.DayTimeInterval), {
                        labels: {
                            start: formatMessage((0, $4KBlT.default).from),
                            end: formatMessage((0, $4KBlT.default).to)
                        },
                        timeIsEditable: true,
                        autoAddNextDay: true,
                        ...fieldProps
                    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.TimezoneWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
                    name: "timeZoneId",
                    label: formatMessage((0, $4KBlT.default).timezone),
                    defaultValue: getDefaultTimezone()
                }, ({ fieldProps: { id: id, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                        inputId: id,
                        menuPosition: "fixed",
                        options: timezones,
                        isLoading: isTimezonesLoading,
                        ...fieldProps,
                        onChange: (value)=>{
                            fieldProps.onChange(value);
                            const event = createAnalyticsEvent({});
                            (0, $h8yj2.fireUIAnalytics)(event, 'routingRule changedTimezone', id);
                        }
                    }))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            columnGap: 0.5,
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "small"
        }, formatMessage((0, $4KBlT.default).thenRouteUsing)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4KBlT.default).routeTargetTooltipContent)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $4KBlT.default).routeTargetTooltipLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($96UJI))),
                ...tooltipProps
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "entity",
            label: formatMessage((0, $4KBlT.default).routeTo),
            defaultValue: handleDefaultEntity(),
            validate: (value)=>{
                if (!value) return formatMessage((0, $4KBlT.default).routeToRequired);
            }
        }, ({ fieldProps: { id: id, ...fieldProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.SelectWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                placeholder: isDeleted ? formatMessage((0, $4KBlT.default).deletedTeam) : undefined,
                options: routeToOptions,
                inputId: id,
                menuPosition: "fixed",
                formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                        justifyContent: "space-between",
                        alignItems: "center",
                        columnGap: 1
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.OptionLabel), null, option?.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
                        columnGap: 1
                    }, option?.enabled === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
                        appearance: "moved"
                    }, formatMessage((0, $9poNi.default).off)))),
                ...fieldProps
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error)), fieldProps.value?.type === 'sch' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1sGdg.SectionMessageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, formatMessage((0, $4KBlT.default).scheduleWarning))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: (e, event)=>{
                (0, $h8yj2.fireUIAnalytics)(event, 'cancelButton');
                handleClose();
            }
        }, formatMessage((0, $4KBlT.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            isLoading: isLoading,
            type: "submit",
            appearance: "primary"
        }, isCloning ? formatMessage((0, $4KBlT.default).clone) : formatMessage(data ? (0, $4KBlT.default).update : (0, $4KBlT.default).add)))))));
};

});
parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`,
        onKeyDown: onSelectKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        appearance: appearance,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        components: selectComponents,
        inputId: id,
        isClearable: true,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: isOpen && !isDisabled,
        menuPlacement: "auto",
        openMenuOnFocus: true,
        onBlur: onBlur,
        onCreateOption: onCreateOption,
        onChange: onChange,
        options: options,
        onFocus: onFocus,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
        styles: mergedStyles,
        value: initialValue,
        spacing: spacing,
        // We need this to get things to work, even though it's not supported.
        // @ts-ignore
        fixedLayerRef: containerRef,
        isInvalid: isInvalid,
        testId: testId,
        ...otherSelectProps
    }));
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $is0Fy.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $3wYKB = parcelRequire("3wYKB");

var $lCAti = parcelRequire("lCAti");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});
parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $k5uoT = parcelRequire("k5uoT");
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - (0, $k5uoT.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $k5uoT.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});


parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$export$c38a243baf9c6083(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$export$ed20539f7181c701(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$export$4077529dfc44a251(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$export$c38a243baf9c6083(timeArray[0].trim());
    const hour = $b5e493719c30ce57$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$export$865db99128311580(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$export$865db99128311580(time2);
}

});

parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children);
    };

});


parcelRegister("3rLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ca8b717dad009c8c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $jouoW = parcelRequire("jouoW");
const $ca8b717dad009c8c$var$noOptions = [];
function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $eGmKJ.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ $5uXOq.createElement("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c81oud _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("input", {
        ...rest,
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
            (0, $VSDnB.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-icon-control-migration') && "_t9ec1soj _z0ai120g _1qdg120g"
        ])
    }), label ? /*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            "_1yt4u49m"
        ])
    }, label) : null);
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});


parcelRegister("fbSeI", function(module, exports) {

$parcel$export(module.exports, "ConditionFilter", () => $53f86d487290ce5e$export$2429b5e5355ec596);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $99M5v = parcelRequire("99M5v");

var $7K5PP = parcelRequire("7K5PP");

var $h8yj2 = parcelRequire("h8yj2");

var $cSpl2 = parcelRequire("cSpl2");

var $42wzd = parcelRequire("42wzd");

var $aAJnf = parcelRequire("aAJnf");

var $9OmvO = parcelRequire("9OmvO");

var $i6oXq = parcelRequire("i6oXq");
const $53f86d487290ce5e$export$2429b5e5355ec596 = ({ value: value, onChange: update, fields: fields = (0, $cSpl2.DEFAULT_FIELDS), isFieldKeyRequired: isFieldKeyRequired, isDisabled: isDisabled, isReadOnly: isReadOnly, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [didAddNewCondition, setDidAddNewCondition] = (0, $5uXOq.useState)(false);
    const matchType = (0, $cSpl2.CONDITION_MATCH_TYPES).find((type)=>type.value === value.matchType);
    const updateCondition = (0, $5uXOq.useCallback)((index)=>(record)=>{
            const _state = JSON.parse(JSON.stringify(value));
            for (const [key, value] of (0, $i6oXq.getEntries)(record))_state.conditions[index][key] = value;
            update(_state);
        }, [
        update,
        value
    ]);
    const deleteCondition = (index)=>()=>{
            const _state = JSON.parse(JSON.stringify(value));
            _state.conditions.splice(index, 1);
            update(_state);
        };
    const AddNewCondition = ()=>update({
            ...value,
            conditions: [
                ...value.conditions,
                {
                    field: fields[0].value,
                    expectedValue: '',
                    not: false,
                    operation: (0, $cSpl2.FIELD_MAPPINGS)[fields[0].type]?.default.value ?? 'contains',
                    fieldFreeForm: fields[0].value === ''
                }
            ]
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        id: "condition-filter-match-type",
        inputId: id,
        options: (0, $cSpl2.CONDITION_MATCH_TYPES),
        defaultValue: matchType,
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        onChange: (match_type)=>{
            if (match_type) {
                // If there isn't a condition and match-all is not selected, add a default condition
                if (match_type.value !== 'match-all' && value.conditions.length === 0) {
                    update({
                        conditions: [
                            {
                                field: fields[0].value,
                                expectedValue: '',
                                not: false,
                                operation: (0, $cSpl2.FIELD_MAPPINGS)[fields[0].type]?.default.value ?? 'contains',
                                fieldFreeForm: fields[0].value === ''
                            }
                        ],
                        matchType: match_type.value
                    });
                    return;
                }
                // If match-all is selected, clear the previously added conditions
                if (match_type.value === 'match-all') {
                    update({
                        conditions: [],
                        matchType: match_type.value
                    });
                    return;
                }
                update({
                    ...value,
                    matchType: match_type.value
                });
                return;
            }
        },
        menuPosition: "fixed"
    }), value.matchType !== 'match-all' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OmvO.ConditionsWrapper), null, value.conditions.map((cond, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aAJnf.default), {
            key: idx,
            fields: fields,
            update: updateCondition(idx),
            delete: deleteCondition(idx),
            conditionCount: value.conditions.length,
            isFieldKeyRequired: isFieldKeyRequired,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            autoFocus: didAddNewCondition && idx === value.conditions.length - 1,
            ...cond
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OmvO.AddConditionButton), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small",
            label: "",
            color: "currentColor"
        }),
        onClick: (e, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'addFilterCondition');
            AddNewCondition();
            setDidAddNewCondition(true);
        },
        isDisabled: isDisabled || isReadOnly
    }, formatMessage((0, $42wzd.ConditionFilterMessages).AddNewCondition))));
};

});
parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45e9dbc5862bfe91f01c54aec1c8b1e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});

parcelRegister("cSpl2", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS", () => $8595483c2ad37027$export$98ff4de2f070152d);
$parcel$export(module.exports, "FIELD_MAPPINGS", () => $8595483c2ad37027$export$db504e133380dea0);
$parcel$export(module.exports, "DEFAULT_FIELDS", () => $8595483c2ad37027$export$ee583b753737a1a7);
$parcel$export(module.exports, "BOOLEAN_FIELD", () => $8595483c2ad37027$export$5aabab4094ff3b79);
$parcel$export(module.exports, "CONDITION_MATCH_TYPES", () => $8595483c2ad37027$export$11a827f78ef6e4d);

var $i5FdW = parcelRequire("i5FdW");

var $42wzd = parcelRequire("42wzd");
const { formatMessage: $8595483c2ad37027$var$formatMessage } = (0, $i5FdW.createIntl)({
    locale: 'en'
});
const $8595483c2ad37027$export$98ff4de2f070152d = {
    'matches-regex': {
        value: 'matches',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationRegex)
    },
    matches: {
        value: 'matches',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationRegex)
    },
    contains: {
        value: 'contains',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationContains)
    },
    'contains-key': {
        value: 'contains-key',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationContainsKey)
    },
    'contains-value': {
        value: 'contains-value',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationContainsValue)
    },
    'starts-with': {
        value: 'starts-with',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationStartsWith)
    },
    'ends-with': {
        value: 'ends-with',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationEndsWith)
    },
    equals: {
        value: 'equals',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationEquals)
    },
    'is-empty': {
        value: 'is-empty',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationIsEmpty)
    },
    'equals-ignore-whitespace': {
        value: 'equals-ignore-whitespace',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationEqualsIgnoreWhitespace)
    },
    'greater-than': {
        value: 'greater-than',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationGreaterThan)
    },
    'less-than': {
        value: 'less-than',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).OperationLessThan)
    }
};
const $8595483c2ad37027$export$afad353d00ed07eb = [
    'string',
    'list',
    'keyValue',
    'boolean',
    'number',
    'priority',
    'map',
    'url'
];
const $8595483c2ad37027$export$db504e133380dea0 = {
    string: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['matches-regex'],
            $8595483c2ad37027$export$98ff4de2f070152d['contains'],
            $8595483c2ad37027$export$98ff4de2f070152d['starts-with'],
            $8595483c2ad37027$export$98ff4de2f070152d['ends-with'],
            $8595483c2ad37027$export$98ff4de2f070152d['equals'],
            $8595483c2ad37027$export$98ff4de2f070152d['is-empty'],
            $8595483c2ad37027$export$98ff4de2f070152d['equals-ignore-whitespace']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['contains']
    },
    list: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['matches-regex'],
            $8595483c2ad37027$export$98ff4de2f070152d['contains'],
            $8595483c2ad37027$export$98ff4de2f070152d['is-empty']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['contains']
    },
    keyValue: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['matches-regex'],
            $8595483c2ad37027$export$98ff4de2f070152d['contains'],
            $8595483c2ad37027$export$98ff4de2f070152d['starts-with'],
            $8595483c2ad37027$export$98ff4de2f070152d['ends-with'],
            $8595483c2ad37027$export$98ff4de2f070152d['equals'],
            $8595483c2ad37027$export$98ff4de2f070152d['is-empty'],
            $8595483c2ad37027$export$98ff4de2f070152d['equals-ignore-whitespace']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['contains']
    },
    boolean: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['equals']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['equals']
    },
    number: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['matches-regex'],
            $8595483c2ad37027$export$98ff4de2f070152d['equals'],
            $8595483c2ad37027$export$98ff4de2f070152d['greater-than'],
            $8595483c2ad37027$export$98ff4de2f070152d['less-than']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['matches-regex']
    },
    priority: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['equals'],
            $8595483c2ad37027$export$98ff4de2f070152d['greater-than'],
            $8595483c2ad37027$export$98ff4de2f070152d['less-than']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['equals']
    },
    map: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['contains'],
            $8595483c2ad37027$export$98ff4de2f070152d['contains-key'],
            $8595483c2ad37027$export$98ff4de2f070152d['contains-value'],
            $8595483c2ad37027$export$98ff4de2f070152d['is-empty']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['contains']
    },
    url: {
        operations: [
            $8595483c2ad37027$export$98ff4de2f070152d['matches-regex'],
            $8595483c2ad37027$export$98ff4de2f070152d['contains'],
            $8595483c2ad37027$export$98ff4de2f070152d['starts-with'],
            $8595483c2ad37027$export$98ff4de2f070152d['ends-with'],
            $8595483c2ad37027$export$98ff4de2f070152d['equals'],
            $8595483c2ad37027$export$98ff4de2f070152d['is-empty']
        ],
        default: $8595483c2ad37027$export$98ff4de2f070152d['contains']
    }
};
const $8595483c2ad37027$export$ee583b753737a1a7 = [
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldKeyValue),
        value: '',
        type: 'keyValue'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldMessage),
        value: 'message',
        type: 'string'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldResponders),
        value: 'responders',
        type: 'list'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldAlias),
        value: 'alias',
        type: 'string'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldEntity),
        value: 'entity',
        type: 'string'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldSource),
        value: 'source',
        type: 'string'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldTags),
        value: 'tags',
        type: 'list'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldActions),
        value: 'actions',
        type: 'list'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldDescription),
        value: 'description',
        type: 'string'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldDetails),
        value: 'extraProperties',
        type: 'map'
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).FieldPriority),
        value: 'priority',
        type: 'priority'
    }
];
const $8595483c2ad37027$export$5aabab4094ff3b79 = [
    {
        label: '--',
        value: false
    },
    {
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).BooleanNot),
        value: true
    }
];
const $8595483c2ad37027$export$11a827f78ef6e4d = [
    {
        value: 'match-all',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).MatchAll)
    },
    {
        value: 'match-any-condition',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).MatchAnyCondition)
    },
    {
        value: 'match-all-conditions',
        label: $8595483c2ad37027$var$formatMessage((0, $42wzd.ConditionFilterMessages).MatchAllConditions)
    }
];

});
parcelRegister("42wzd", function(module, exports) {

$parcel$export(module.exports, "ConditionFilterMessages", () => $6be9d278c76dafa3$export$eaeb7999cc2055b3);

var $7VHMR = parcelRequire("7VHMR");
const $6be9d278c76dafa3$export$eaeb7999cc2055b3 = (0, $7VHMR.defineMessages)({
    AddNewCondition: {
        id: `eoc.integration-automation.condition-filter.add-new-condition`,
        defaultMessage: `Add condition`,
        description: `The text will be displayed in button that adds new condition rows to filter`
    },
    MatchAll: {
        id: `eoc.integration-automation.condition-filter.match-types.match-all`,
        defaultMessage: `All the alerts (no conditions in use)`,
        description: `The text will be displayed in dropdown stating rule's filter will match with all`
    },
    MatchAnyCondition: {
        id: `eoc.integration-automation.condition-filter.match-types.match-any-condition`,
        defaultMessage: `Only alerts that match any condition`,
        description: `The text will be displayed in dropdown stating rule's filter has to match one or more conditions`
    },
    MatchAllConditions: {
        id: `eoc.integration-automation.condition-filter.match-types.match-all-conditions`,
        defaultMessage: `Only alerts that match all the conditions`,
        description: `The text will be displayed in dropdown stating rule's filter has to match with all conditions`
    },
    OperationRegex: {
        id: `eoc.integration-automation.condition-filter.operations.regex`,
        defaultMessage: `Matches (Regex)`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationContains: {
        id: `eoc.integration-automation.condition-filter.operations.contains`,
        defaultMessage: `Contains`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationContainsKey: {
        id: `eoc.integration-automation.condition-filter.operations.contains-key`,
        defaultMessage: `Contains Key`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationContainsValue: {
        id: `eoc.integration-automation.condition-filter.operations.contains-value`,
        defaultMessage: `Contains Value`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationStartsWith: {
        id: `eoc.integration-automation.condition-filter.operations.starts-with`,
        defaultMessage: `Starts With`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationEndsWith: {
        id: `eoc.integration-automation.condition-filter.operations.ends-with`,
        defaultMessage: `Ends With`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationEquals: {
        id: `eoc.integration-automation.condition-filter.operations.equals`,
        defaultMessage: `Equals`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationIsEmpty: {
        id: `eoc.integration-automation.condition-filter.operations.is-empty`,
        defaultMessage: `Is Empty`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationEqualsIgnoreWhitespace: {
        id: `eoc.integration-automation.condition-filter.operations.equals-ignore-whitespace`,
        defaultMessage: `Equals Ignore Whitespace`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationGreaterThan: {
        id: `eoc.integration-automation.condition-filter.operations.greater-than`,
        defaultMessage: `Greater Than`,
        description: `The text will be displayed in dropdown for operation select`
    },
    OperationLessThan: {
        id: `eoc.integration-automation.condition-filter.operations.less-than`,
        defaultMessage: `Less Than`,
        description: `The text will be displayed in dropdown for operation select`
    },
    FieldKeyValue: {
        id: `eoc.integration-automation.condition-filter.field.key-value`,
        defaultMessage: `Details (Key-Value Based)`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldMessage: {
        id: `eoc.integration-automation.condition-filter.field.message`,
        defaultMessage: `Message`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldResponders: {
        id: `eoc.integration-automation.condition-filter.field.responders`,
        defaultMessage: `Responders`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldAlias: {
        id: `eoc.integration-automation.condition-filter.field.alias`,
        defaultMessage: `Alias`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldEntity: {
        id: `eoc.integration-automation.condition-filter.field.entity`,
        defaultMessage: `Entity`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldSource: {
        id: `eoc.integration-automation.condition-filter.field.source`,
        defaultMessage: `Source`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldTags: {
        id: `eoc.integration-automation.condition-filter.field.tags`,
        defaultMessage: `Tags`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldActions: {
        id: `eoc.integration-automation.condition-filter.field.actions`,
        defaultMessage: `Actions`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldDescription: {
        id: `eoc.integration-automation.condition-filter.field.description`,
        defaultMessage: `Description`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldDetails: {
        id: `eoc.integration-automation.condition-filter.field.details`,
        defaultMessage: `Details`,
        description: `The text will be displayed in dropdown for field select`
    },
    FieldPriority: {
        id: `eoc.integration-automation.condition-filter.field.priority`,
        defaultMessage: `Priority`,
        description: `The text will be displayed in dropdown for field select`
    },
    BooleanNot: {
        id: `eoc.integration-automation.condition-filter.boolean.not`,
        defaultMessage: `Not`,
        description: `The text will be displayed in dropdown for boolean select`
    },
    DeleteIconLabel: {
        id: `eoc.integration-automation.condition-filter.button.delete-condition`,
        defaultMessage: `Delete Condition`,
        description: `The text will be used for icon label delete condition button`
    },
    KeyValuePlaceholder: {
        id: `eoc.integration-automation.condition-filter.field.key-value-placeholder`,
        defaultMessage: `Key`,
        description: `The text will be used as a placeholder for the custom key-value input field`
    },
    ExpectedValuePlaceholder: {
        id: `eoc.integration-automation.condition-filter.field.expected-value-placeholder`,
        defaultMessage: `Value`,
        description: `The text will be used as a placeholder for the expected-value input field`
    },
    PriorityCritical: {
        id: `eoc.integration-automation.condition-filter.priority.critical`,
        defaultMessage: `P1-Critical`,
        description: `The text for condition filter's proirity selection, indicates critical severity`
    },
    PriorityHigh: {
        id: `eoc.integration-automation.condition-filter.priority.critical`,
        defaultMessage: `P2-High`,
        description: `The text for condition filter's proirity selection, indicates high severity`
    },
    PriorityModerate: {
        id: `eoc.integration-automation.condition-filter.priority.critical`,
        defaultMessage: `P3-Moderate`,
        description: `The text for condition filter's proirity selection, indicates moderate severity`
    },
    PriorityLow: {
        id: `eoc.integration-automation.condition-filter.priority.critical`,
        defaultMessage: `P4-Low`,
        description: `The text for condition filter's proirity selection, indicates low severity`
    },
    PriorityInformational: {
        id: `eoc.integration-automation.condition-filter.priority.critical`,
        defaultMessage: `P5-Informational`,
        description: `The text for condition filter's proirity selection, indicates informational severity`
    },
    AlertFieldAriaLabel: {
        id: `eoc.integration-automation.condition-filter.alert-field-aria-label`,
        defaultMessage: `Select alert field`,
        description: `The text will be used for aria-label in dropdown for alert field select`
    },
    IsNotFieldAriaLabel: {
        id: `eoc.integration-automation.condition-filter.is-not-field-aria-label`,
        defaultMessage: `Select IS or NOT operator`,
        description: `The text will be used for aria-label in dropdown for boolean select`
    },
    ValueFieldAriaLabel: {
        id: `eoc.integration-automation.condition-filter.value-field-aria-label`,
        defaultMessage: `Select value field operator`,
        description: `The text will be used for aria-label in dropdown for value operator select`
    },
    EnterKeyFieldAriaLabel: {
        id: `eoc.integration-automation.condition-filter.field.key-value-label`,
        defaultMessage: `Enter key`,
        description: `The text will be used for aria-label in textfield for key-value field`
    },
    EnterValueFieldAriaLabel: {
        id: `eoc.integration-automation.condition-filter.enter-value-field-aria-label`,
        defaultMessage: `Enter value`,
        description: `The text will be used for aria-label in textfield for value field`
    },
    PriorityFieldAriaLabel: {
        id: `eoc.integration-automation.condition-filter.priority-field-aria-label`,
        defaultMessage: `Select priority`,
        description: `The text will be used for aria-label in select for priority field`
    },
    RemoveConditionButtonAriaLabel: {
        id: `eoc.integration-automation.condition-filter.remove-condition-button-aria-label`,
        defaultMessage: `Remove condition`,
        description: `The text will be used for aria-label in remove condition button`
    }
});

});


parcelRegister("aAJnf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acc5bfd9850b959$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $84THj = parcelRequire("84THj");

var $7K5PP = parcelRequire("7K5PP");

var $h8yj2 = parcelRequire("h8yj2");

var $cSpl2 = parcelRequire("cSpl2");

var $42wzd = parcelRequire("42wzd");

var $4p2VH = parcelRequire("4p2VH");

var $6ytmS = parcelRequire("6ytmS");
const $1acc5bfd9850b959$var$Condition = ({ expectedValue: expectedValue, field: field, not: not, operation: operation, fields: fields, update: update, delete: deleteCondition, conditionCount: conditionCount, isFieldKeyRequired: isFieldKeyRequired, isDisabled: isDisabled, isReadOnly: isReadOnly, autoFocus: autoFocus })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fieldSelectValue = (0, $5uXOq.useMemo)(()=>{
        const matchedField = fields.find((f)=>f.value === field);
        return matchedField ?? (0, $cSpl2.DEFAULT_FIELDS)[0];
    }, [
        field,
        fields
    ]);
    const Fields = (0, $6ytmS.TYPE_MAPPING)[fieldSelectValue.type];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4p2VH.ConditionWrapper), {
        "data-testid": "condition-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        autoFocus: autoFocus,
        options: fields,
        value: fieldSelectValue,
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        onChange: (selectedKey)=>{
            if (selectedKey) update({
                field: selectedKey.value,
                expectedValue: '',
                fieldFreeForm: selectedKey.type === 'keyValue'
            });
        },
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).AlertFieldAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fields, {
        field: field,
        fieldType: fieldSelectValue.type,
        update: update,
        expectedValue: expectedValue,
        not: not,
        operation: operation,
        isFieldKeyRequired: isFieldKeyRequired,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
    }), conditionCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4p2VH.Button), {
        onClick: (e, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'removeFilterCondition');
            deleteCondition();
        },
        isDisabled: isDisabled || isReadOnly,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            label: formatMessage((0, $42wzd.ConditionFilterMessages).DeleteIconLabel),
            color: "currentColor"
        }),
        appearance: "subtle",
        "aria-label": formatMessage((0, $42wzd.ConditionFilterMessages).RemoveConditionButtonAriaLabel)
    }));
};
var $1acc5bfd9850b959$export$2e2bcd8739ae039 = $1acc5bfd9850b959$var$Condition;

});
parcelRegister("4p2VH", function(module, exports) {

$parcel$export(module.exports, "Button", () => $47919637af38d709$export$353f5b6fc5456de1);
$parcel$export(module.exports, "ConditionWrapper", () => $47919637af38d709$export$53a5dda3c8d16b50);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fVnbM = parcelRequire("fVnbM");

var $bWGt6 = parcelRequire("bWGt6");
function $47919637af38d709$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $47919637af38d709$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $bWGt6.default)((0, $fVnbM.default), {
    target: "ei6ophc1"
})({
    name: "zdwu6b",
    styles: "min-width:var(--ds-space-500, 40px);width:var(--ds-space-500, 40px);height:var(--ds-space-500, 40px);flex-basis:auto !important"
});
const $47919637af38d709$export$53a5dda3c8d16b50 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ei6ophc0"
})({
    name: "1jxv9o4",
    styles: "display:flex;gap:var(--ds-space-100, 8px);align-items:center;& > *, & > [data-ds--text-field--container]{flex:0 0 15%;}& > div:last-of-type{flex:1;}"
});

});

parcelRegister("6ytmS", function(module, exports) {

$parcel$export(module.exports, "TYPE_MAPPING", () => $3e58a141281d36c9$export$b7da42f8340be434);

var $l3Zbw = parcelRequire("l3Zbw");

var $lWdyE = parcelRequire("lWdyE");

var $g5YcV = parcelRequire("g5YcV");
const $3e58a141281d36c9$export$b7da42f8340be434 = {
    string: (0, $l3Zbw.default),
    number: (0, $l3Zbw.default),
    list: (0, $l3Zbw.default),
    keyValue: (0, $lWdyE.default),
    boolean: (0, $l3Zbw.default),
    priority: (0, $g5YcV.default),
    map: (0, $l3Zbw.default),
    url: (0, $l3Zbw.default)
};

});
parcelRegister("l3Zbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cde6cf326963437$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7K5PP = parcelRequire("7K5PP");

var $cSpl2 = parcelRequire("cSpl2");

var $42wzd = parcelRequire("42wzd");

var $1aUWw = parcelRequire("1aUWw");
const $3cde6cf326963437$var$CommonConditionFields = ({ fieldType: fieldType, update: update, operation: op, not: not, expectedValue: expectedValue, isDisabled: isDisabled, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { availableOperations: availableOperations, operation: operation } = (0, $5uXOq.useMemo)(()=>{
        const availableOperations = (0, $cSpl2.FIELD_MAPPINGS)[fieldType].operations;
        const operation = (0, $cSpl2.OPERATIONS)[op] ?? (0, $cSpl2.FIELD_MAPPINGS)[fieldType].default;
        return {
            availableOperations: availableOperations,
            operation: operation
        };
    }, [
        fieldType,
        op
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $cSpl2.FIELD_MAPPINGS)[fieldType].operations.map((operation)=>operation.value).includes(operation.value)) update({
            operation: (0, $cSpl2.FIELD_MAPPINGS)[fieldType].operations[0].value
        });
    }, [
        fieldType,
        operation,
        update
    ]);
    const bool = (0, $5uXOq.useMemo)(()=>(0, $cSpl2.BOOLEAN_FIELD).find((b)=>b.value === not), [
        not
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: bool,
        onChange: (boolValue)=>boolValue && update({
                not: boolValue.value
            }),
        options: (0, $cSpl2.BOOLEAN_FIELD),
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).IsNotFieldAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: operation,
        options: availableOperations,
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        onChange: (op)=>{
            if (!op) return;
            if (op.value !== (0, $cSpl2.OPERATIONS)['is-empty'].value) update({
                operation: op.value
            });
            else update({
                operation: op.value,
                expectedValue: ''
            });
        },
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).ValueFieldAriaLabel)
    }), operation.value !== (0, $cSpl2.OPERATIONS)['is-empty'].value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUWw.Textfield), {
        name: "expectedValue",
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        placeholder: formatMessage((0, $42wzd.ConditionFilterMessages).ExpectedValuePlaceholder),
        "aria-label": formatMessage((0, $42wzd.ConditionFilterMessages).EnterValueFieldAriaLabel),
        value: expectedValue,
        onChange: (e)=>update({
                expectedValue: e.currentTarget.value
            })
    }));
};
var $3cde6cf326963437$export$2e2bcd8739ae039 = $3cde6cf326963437$var$CommonConditionFields;

});
parcelRegister("1aUWw", function(module, exports) {

$parcel$export(module.exports, "Textfield", () => $a076dc8f92569d4f$export$d66ddc2063fc70a7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kY99m = parcelRequire("kY99m");

var $bWGt6 = parcelRequire("bWGt6");
function $a076dc8f92569d4f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a076dc8f92569d4f$export$d66ddc2063fc70a7 = /*#__PURE__*/ (0, $bWGt6.default)((0, $kY99m.default), {
    target: "eosn6b20"
})({
    name: "1ae1a03",
    styles: "min-width:var(--ds-space-1000, 80px)"
});

});


parcelRegister("lWdyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $846fc0872573278d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7K5PP = parcelRequire("7K5PP");

var $cSpl2 = parcelRequire("cSpl2");

var $42wzd = parcelRequire("42wzd");

var $1aUWw = parcelRequire("1aUWw");
const $846fc0872573278d$var$KeyValueConditionFields = ({ field: field, fieldType: fieldType, update: update, operation: op, not: not, expectedValue: expectedValue, isFieldKeyRequired: isFieldKeyRequired, isDisabled: isDisabled, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { availableOperations: availableOperations, operation: operation } = (0, $5uXOq.useMemo)(()=>{
        const availableOperations = (0, $cSpl2.FIELD_MAPPINGS)[fieldType].operations;
        const operation = (0, $cSpl2.OPERATIONS)[op] ?? (0, $cSpl2.FIELD_MAPPINGS)[fieldType].default;
        return {
            availableOperations: availableOperations,
            operation: operation
        };
    }, [
        fieldType,
        op
    ]);
    const bool = (0, $5uXOq.useMemo)(()=>(0, $cSpl2.BOOLEAN_FIELD).find((b)=>b.value === not), [
        not
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $cSpl2.OPERATIONS)[op]) update({
            operation: (0, $cSpl2.FIELD_MAPPINGS)[fieldType].default.value
        });
    }, [
        fieldType,
        op,
        update
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUWw.Textfield), {
        placeholder: formatMessage((0, $42wzd.ConditionFilterMessages).KeyValuePlaceholder),
        name: "field",
        value: field,
        onChange: (e)=>update({
                field: e.currentTarget.value
            }),
        isRequired: isFieldKeyRequired,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        "aria-label": formatMessage((0, $42wzd.ConditionFilterMessages).EnterKeyFieldAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: bool,
        onChange: (boolValue)=>boolValue && update({
                not: boolValue.value
            }),
        options: (0, $cSpl2.BOOLEAN_FIELD),
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).IsNotFieldAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: operation,
        options: availableOperations,
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        onChange: (op)=>{
            if (!op) return;
            if (op.value !== (0, $cSpl2.OPERATIONS)['is-empty'].value) update({
                operation: op.value
            });
            else update({
                operation: op.value,
                expectedValue: ''
            });
        },
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).ValueFieldAriaLabel)
    }), operation.value !== (0, $cSpl2.OPERATIONS)['is-empty'].value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUWw.Textfield), {
        name: "expectedValue",
        placeholder: formatMessage((0, $42wzd.ConditionFilterMessages).ExpectedValuePlaceholder),
        value: expectedValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        onChange: (e)=>update({
                expectedValue: e.currentTarget.value
            }),
        "aria-label": formatMessage((0, $42wzd.ConditionFilterMessages).EnterValueFieldAriaLabel)
    }));
};
var $846fc0872573278d$export$2e2bcd8739ae039 = $846fc0872573278d$var$KeyValueConditionFields;

});

parcelRegister("g5YcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef0a8be810ada0d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7K5PP = parcelRequire("7K5PP");

var $2n2ED = parcelRequire("2n2ED");

var $cSpl2 = parcelRequire("cSpl2");

var $42wzd = parcelRequire("42wzd");

var $kHSyf = parcelRequire("kHSyf");
const $1ef0a8be810ada0d$var$PriorityConditionFields = ({ fieldType: fieldType, update: update, operation: op, not: not, expectedValue: expectedValue, isDisabled: isDisabled, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { availableOperations: availableOperations, operation: operation, priority: priority } = (0, $5uXOq.useMemo)(()=>{
        const availableOperations = (0, $cSpl2.FIELD_MAPPINGS)[fieldType].operations;
        const operation = [
            ...availableOperations
        ].find((_op)=>_op.value === op) ?? (0, $cSpl2.FIELD_MAPPINGS)[fieldType].default;
        const priority = (0, $kHSyf.PRIORITY_MAP)[expectedValue] ?? (0, $kHSyf.PRIORITY_MAP).P3;
        return {
            availableOperations: availableOperations,
            operation: operation,
            priority: priority
        };
    }, [
        expectedValue,
        fieldType,
        op
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (![
            ...availableOperations
        ].find((_op)=>_op.value === op)) update({
            operation: (0, $cSpl2.FIELD_MAPPINGS)[fieldType].default.value
        });
    }, [
        availableOperations,
        fieldType,
        op,
        update
    ]);
    // This effect is to ensure that the expected value is always a valid priority
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $kHSyf.PRIORITY_MAP)[expectedValue]) update({
            expectedValue: (0, $kHSyf.PRIORITY_MAP).P3.value
        });
    }, [
        expectedValue,
        update
    ]);
    const bool = (0, $5uXOq.useMemo)(()=>(0, $cSpl2.BOOLEAN_FIELD).find((b)=>b.value === not), [
        not
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: bool,
        onChange: (boolValue)=>boolValue && update({
                not: boolValue.value
            }),
        options: (0, $cSpl2.BOOLEAN_FIELD),
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        // Make it appear over the top of the modal rather than scrollable
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).IsNotFieldAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: operation,
        options: availableOperations,
        onChange: (op)=>op && update({
                operation: op.value
            }),
        isDisabled: isDisabled,
        menuIsOpen: isReadOnly ? false : undefined,
        isSearchable: !isReadOnly,
        menuPosition: "fixed",
        label: formatMessage((0, $42wzd.ConditionFilterMessages).ValueFieldAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2n2ED.PriorityDropdown), {
        value: priority,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        onChange: (_priority)=>_priority && update({
                expectedValue: _priority.value
            }),
        menuPosition: "fixed",
        showDynamicPriority: false,
        "aria-label": formatMessage((0, $42wzd.ConditionFilterMessages).PriorityFieldAriaLabel)
    }));
};
var $1ef0a8be810ada0d$export$2e2bcd8739ae039 = $1ef0a8be810ada0d$var$PriorityConditionFields;

});
parcelRegister("2n2ED", function(module, exports) {

$parcel$export(module.exports, "PriorityDropdown", () => $1d148769edd62f3f$export$b95fc38821f8220f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $jeNGJ = parcelRequire("jeNGJ");

var $kYRgd = parcelRequire("kYRgd");

var $8XNXR = parcelRequire("8XNXR");

var $F5e2Z = parcelRequire("F5e2Z");
const $1d148769edd62f3f$export$b95fc38821f8220f = ({ showDynamicPriority: showDynamicPriority, isReadOnly: isReadOnly, isCreatable: isCreatable, onChange: onChange, id: id, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const initialValue = (0, $5uXOq.useRef)(props.value); // We need to hold a ref to the initial value to not to lose it when the user changed the value
    const [lastCreatedOption, setLastCreatedOption] = (0, $5uXOq.useState)(null);
    const priorityOptions = (0, $5uXOq.useMemo)(()=>{
        const tempValues = Object.entries((0, $jeNGJ.PRIORITIES)).map(([value, { label: label }])=>({
                label: label,
                value: value
            }));
        return tempValues;
    }, []);
    const options = (0, $5uXOq.useMemo)(()=>{
        const newOptions = [
            ...priorityOptions
        ];
        if (showDynamicPriority) newOptions.unshift({
            label: '{{priority}}',
            value: '{{priority}}'
        });
        // If it is creatable select and the initial value is present, we need to add this value into the options (if it is not already there)
        if (isCreatable && !!initialValue.current) {
            if (props.isMulti) {
                const initialOptions = initialValue.current;
                initialOptions.forEach((initialOption)=>{
                    if (!newOptions.some(({ value: value })=>value === initialOption.value)) newOptions.unshift(initialOption);
                });
            } else {
                const initialOption = initialValue.current;
                if (!newOptions.some(({ value: value })=>value === initialOption.value)) newOptions.unshift(initialOption);
            }
        }
        if (isCreatable && lastCreatedOption) newOptions.unshift(lastCreatedOption);
        return newOptions;
    }, [
        isCreatable,
        lastCreatedOption,
        priorityOptions,
        props.isMulti,
        showDynamicPriority
    ]);
    const SelectComponent = isCreatable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
        isSearchable: !isReadOnly,
        menuIsOpen: isReadOnly ? false : undefined,
        defaultValue: priorityOptions[2],
        components: {
            SingleValue: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $F5e2Z.PriorityValue), {
                    ...props,
                    isCreatable: isCreatable
                }),
            Option: (0, $8XNXR.PriorityOption),
            ...props.components
        },
        options: options,
        formatCreateLabel: (inputValue)=>`"${inputValue}" (${formatMessage((0, $kYRgd.PriorityDropdownMessages).CustomPriority)})`,
        onChange: (value, actionMeta)=>{
            if (actionMeta.action === 'create-option') setLastCreatedOption(actionMeta.option);
            onChange?.(value, actionMeta);
        },
        filterOption: (option, inputValue)=>{
            return option.label.toLowerCase().includes(inputValue.toLowerCase());
        },
        inputId: id,
        ...props
    });
};

});
parcelRegister("jeNGJ", function(module, exports) {

$parcel$export(module.exports, "PRIORITIES", () => $5bc4c76c82cbc0b9$export$19868e2467c966ad);
const $5bc4c76c82cbc0b9$export$19868e2467c966ad = {
    P1: {
        label: 'Critical',
        appearance: 'removed',
        isBold: true
    },
    P2: {
        label: 'High',
        appearance: 'removed',
        isBold: false
    },
    P3: {
        label: 'Moderate',
        appearance: 'moved',
        isBold: false
    },
    P4: {
        label: 'Low',
        appearance: 'success',
        isBold: false
    },
    P5: {
        label: 'Informational',
        appearance: 'success',
        isBold: true
    }
};

});

parcelRegister("kYRgd", function(module, exports) {

$parcel$export(module.exports, "PriorityDropdownMessages", () => $25f109cc688fe0f5$export$2f644cced96045eb);

var $7VHMR = parcelRequire("7VHMR");
const $25f109cc688fe0f5$export$2f644cced96045eb = (0, $7VHMR.defineMessages)({
    CustomPriority: {
        id: `eoc.priority-dropdown.custom-priority`,
        defaultMessage: `Custom priority`,
        description: `The text will be displayed in the dropdown menu if the user has written a custom priority`
    }
});

});

parcelRegister("8XNXR", function(module, exports) {

$parcel$export(module.exports, "PriorityOption", () => $722e0e2db3b4b7c2$export$bc13d4a32a621269);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $dY87H = parcelRequire("dY87H");

var $gILJi = parcelRequire("gILJi");
var $jeNGJ = parcelRequire("jeNGJ");
const $722e0e2db3b4b7c2$export$bc13d4a32a621269 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        columnGap: 1,
        alignItems: "center"
    }, props.data.value === '{{priority}}' || !(0, $jeNGJ.PRIORITIES)[props.data.value] ? props.data.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gILJi.default), {
        priority: props.data.value
    }), (0, $jeNGJ.PRIORITIES)[props.data.value].label)));
};

});
parcelRegister("gILJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a17abc8711014b3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $kgoHi = parcelRequire("kgoHi");

var $jeNGJ = parcelRequire("jeNGJ");
function $a17abc8711014b3e$export$2e2bcd8739ae039({ priority: priority }) {
    const { label: label, ...lozengeProps } = (0, $jeNGJ.PRIORITIES)[priority];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), lozengeProps, priority));
}

});


parcelRegister("F5e2Z", function(module, exports) {

$parcel$export(module.exports, "PriorityValue", () => $daa23da3c576535e$export$db2dcb6c314147ca);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $gILJi = parcelRequire("gILJi");
var $jeNGJ = parcelRequire("jeNGJ");
const $daa23da3c576535e$var$valueWhenFocusedStyles = (0, $8CUq3.xcss)({
    opacity: 'opacity.disabled'
});
const $daa23da3c576535e$export$db2dcb6c314147ca = (props)=>{
    const shouldReduceOpacity = props.selectProps.menuIsOpen && props.isCreatable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            shouldReduceOpacity && $daa23da3c576535e$var$valueWhenFocusedStyles
        ]
    }, Object.keys((0, $jeNGJ.PRIORITIES)).includes(props.data.value) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gILJi.default), {
        priority: props.data.value
    }), (0, $jeNGJ.PRIORITIES)[props.data.value].label) : props.data.label));
};

});


parcelRegister("kHSyf", function(module, exports) {

$parcel$export(module.exports, "PRIORITY_MAP", () => $3b0bc34f55ac5407$export$71fa7ffbf6a314a1);

var $i5FdW = parcelRequire("i5FdW");

var $42wzd = parcelRequire("42wzd");
const { formatMessage: $3b0bc34f55ac5407$var$formatMessage } = (0, $i5FdW.createIntl)({
    locale: 'en'
});
const $3b0bc34f55ac5407$export$71fa7ffbf6a314a1 = {
    P1: {
        label: $3b0bc34f55ac5407$var$formatMessage((0, $42wzd.ConditionFilterMessages).PriorityCritical),
        value: 'P1'
    },
    P2: {
        label: $3b0bc34f55ac5407$var$formatMessage((0, $42wzd.ConditionFilterMessages).PriorityHigh),
        value: 'P2'
    },
    P3: {
        label: $3b0bc34f55ac5407$var$formatMessage((0, $42wzd.ConditionFilterMessages).PriorityModerate),
        value: 'P3'
    },
    P4: {
        label: $3b0bc34f55ac5407$var$formatMessage((0, $42wzd.ConditionFilterMessages).PriorityLow),
        value: 'P4'
    },
    P5: {
        label: $3b0bc34f55ac5407$var$formatMessage((0, $42wzd.ConditionFilterMessages).PriorityInformational),
        value: 'P5'
    }
};

});




parcelRegister("9OmvO", function(module, exports) {

$parcel$export(module.exports, "AddConditionButton", () => $1c8c41e7b59eeb3a$export$6930330dce9f956c);
$parcel$export(module.exports, "ConditionsWrapper", () => $1c8c41e7b59eeb3a$export$5baf8688a85d30b5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fVnbM = parcelRequire("fVnbM");

var $bWGt6 = parcelRequire("bWGt6");
function $1c8c41e7b59eeb3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c8c41e7b59eeb3a$export$6930330dce9f956c = /*#__PURE__*/ (0, $bWGt6.default)((0, $fVnbM.default), {
    target: "e1sx7fii1"
})({
    name: "1xf0l7g",
    styles: "padding:0!important;max-width:fit-content!important;margin-top:var(--ds-space-100, 8px)"
});
const $1c8c41e7b59eeb3a$export$5baf8688a85d30b5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1sx7fii0"
})({
    name: "g0tmwc",
    styles: "display:grid;gap:var(--ds-space-100, 8px);margin-top:var(--ds-space-100, 8px)"
});

});

parcelRegister("i6oXq", function(module, exports) {

$parcel$export(module.exports, "getEntries", () => $e15d910843e2a414$export$e7320818614f0b3e);
const $e15d910843e2a414$export$e7320818614f0b3e = (obj)=>Object.entries(obj);

});


parcelRegister("2TID8", function(module, exports) {

$parcel$export(module.exports, "DayTimeInterval", () => $99efc5e2b9332504$export$7b7089970260c521);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $2jwCH = parcelRequire("2jwCH");

var $3Fq5M = parcelRequire("3Fq5M");

var $3bDjY = parcelRequire("3bDjY");

var $6gHcP = parcelRequire("6gHcP");

var $gdarC = parcelRequire("gdarC");

var $cBVPs = parcelRequire("cBVPs");

var $eHmI5 = parcelRequire("eHmI5");
const $99efc5e2b9332504$var$initialValue = {
    startDay: null,
    startHour: null,
    startMinute: null,
    endDay: null,
    endHour: null,
    endMinute: null
};
const $99efc5e2b9332504$var$rowColumnSpacing = {
    default: 1.5,
    compact: 1
};
const $99efc5e2b9332504$var$actionsColumnSpacing = {
    default: 1,
    compact: 0.5
};
const $99efc5e2b9332504$export$7b7089970260c521 = (props)=>{
    const { value: value, labels: labels, weekStartDay: weekStartDay, onChange: onChange, newIntervalValue: newIntervalValue, isDisabled: isDisabled, timeIsEditable: timeIsEditable, autoAddNextDay: autoAddNextDay } = props;
    const variant = props.variant ?? 'default';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleDelete = (deletedItemIndex)=>{
        const newIntervals = value?.filter((_, i)=>i !== deletedItemIndex);
        if (onChange) onChange(newIntervals);
    };
    const handleAdd = ()=>{
        let newInterval = newIntervalValue || $99efc5e2b9332504$var$initialValue;
        if (!newIntervalValue && autoAddNextDay && value?.length > 0) {
            // copy and create new interval, otherwise it will be the same object and will change the original value
            const lastInterval = {
                ...value[value.length - 1]
            };
            const { startDay: startDay, endDay: endDay } = lastInterval;
            // if last interval doesn't have a value, don't do anything
            if (startDay && endDay) {
                lastInterval.startDay = startDay === 7 ? 7 : startDay + 1;
                lastInterval.endDay = endDay === 7 ? 7 : endDay + 1;
                newInterval = lastInterval;
            }
        }
        const newIntervals = [
            ...value,
            {
                ...newInterval,
                key: new Date().getTime(),
                isNew: true
            }
        ];
        onChange(newIntervals);
    };
    const handleClone = (interval, clonedItemIndex)=>{
        const newIntervals = [
            ...value
        ];
        const newInterval = {
            ...interval,
            key: new Date().getTime()
        };
        Array.prototype.splice.call(newIntervals, clonedItemIndex + 1, 0, newInterval);
        onChange(newIntervals);
    };
    const handleChange = (values, changedItemIndex)=>{
        const newIntervals = value?.map((interval, i)=>{
            if (i === changedItemIndex) return {
                ...values,
                ...interval.key ? {
                    key: interval.key
                } : {}
            };
            return interval;
        });
        onChange(newIntervals);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdarC.FullWidthFlex), {
        flexDirection: "column",
        rowGap: 1
    }, value.map((interval, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdarC.FullWidthFlex), {
            key: interval.key || i,
            columnGap: $99efc5e2b9332504$var$rowColumnSpacing[variant],
            alignItems: "flex-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6gHcP.DayTimeRangePicker), {
            weekStartDay: weekStartDay,
            labels: labels,
            value: interval,
            onChange: (values)=>handleChange(values, i),
            isDisabled: isDisabled,
            timeIsEditable: timeIsEditable,
            timeSlotIndex: i,
            variant: variant
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHmI5.ActionsWrapper), {
            variant: variant,
            columnGap: $99efc5e2b9332504$var$actionsColumnSpacing[variant]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $cBVPs.default).clone)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: formatMessage((0, $cBVPs.default).clone),
            spacing: "compact",
            appearance: "subtle",
            onClick: ()=>handleClone(interval, i),
            isDisabled: isDisabled,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
                    ...iconProps,
                    LEGACY_size: "small"
                })
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $cBVPs.default).delete)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: formatMessage((0, $cBVPs.default).delete),
            spacing: "compact",
            appearance: "subtle",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                    ...iconProps,
                    LEGACY_size: "small"
                }),
            onClick: ()=>handleDelete(i),
            isDisabled: isDisabled ? isDisabled : value.length < 2
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        isDisabled: isDisabled,
        onClick: handleAdd,
        spacing: "none",
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        // https://product-fabric.atlassian.net/browse/DSP-19027
        appearance: "link"
    }, formatMessage((0, $cBVPs.default).addNew))));
};

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e966e44e10d4af587c95b714fe3851cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("6gHcP", function(module, exports) {

$parcel$export(module.exports, "DayTimeRangePicker", () => $d392a02c28ccd533$export$781eaa075945742e);

var $5uXOq = parcelRequire("5uXOq");

var $7OLmU = parcelRequire("7OLmU");

var $gdarC = parcelRequire("gdarC");
const $d392a02c28ccd533$var$rangeColumnSpacing = {
    default: 1.5,
    compact: 1
};
const $d392a02c28ccd533$export$781eaa075945742e = ({ labels: labels, value: value, onChange: onChange, weekStartDay: weekStartDay, isDisabled: isDisabled, timeIsEditable: timeIsEditable, timeSlotIndex: timeSlotIndex, variant: variant = 'default' })=>{
    const [start, setStart] = (0, $5uXOq.useState)(value ? {
        day: value.startDay,
        hour: value.startHour,
        minute: value.startMinute
    } : null);
    const [end, setEnd] = (0, $5uXOq.useState)(value ? {
        day: value.endDay,
        hour: value.endHour,
        minute: value.endMinute
    } : null);
    const handleChangeStart = (values)=>{
        setStart(values);
        const isAllValuesSet = !!(values?.day && end?.day);
        if (onChange && isAllValuesSet) onChange({
            startDay: values.day,
            startHour: values.hour,
            startMinute: values.minute,
            endDay: end.day,
            endHour: end.hour,
            endMinute: end.minute
        });
    };
    const handleChangeEnd = (values)=>{
        setEnd(values);
        const isAllValuesSet = !!(start?.day && values?.day);
        if (onChange && isAllValuesSet) onChange({
            startDay: start.day,
            startHour: start.hour,
            startMinute: start.minute,
            endDay: values.day,
            endHour: values.hour,
            endMinute: values.minute
        });
    };
    (0, $5uXOq.useEffect)(()=>{
        if (value) {
            setStart({
                day: value.startDay,
                hour: value.startHour,
                minute: value.startMinute
            });
            setEnd({
                day: value.endDay,
                hour: value.endHour,
                minute: value.endMinute
            });
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdarC.FullWidthFlex), {
        columnGap: $d392a02c28ccd533$var$rangeColumnSpacing[variant]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OLmU.DayTimePicker), {
        autoFocus: value?.isNew,
        weekStartDay: weekStartDay,
        value: start,
        onChange: (values)=>handleChangeStart(values),
        label: labels?.start,
        isDisabled: isDisabled,
        timeIsEditable: timeIsEditable,
        timeSlotIndex: timeSlotIndex,
        variant: variant
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OLmU.DayTimePicker), {
        weekStartDay: weekStartDay,
        value: end,
        onChange: (values)=>handleChangeEnd(values),
        label: labels?.end,
        isDisabled: isDisabled,
        timeIsEditable: timeIsEditable,
        timeSlotIndex: timeSlotIndex,
        variant: variant
    }));
};

});
parcelRegister("7OLmU", function(module, exports) {

$parcel$export(module.exports, "DayTimePicker", () => $240fb91eeec3f6e4$export$b63039ff2b1a1e69);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jdTq6 = parcelRequire("jdTq6");

var $aTtVK = parcelRequire("aTtVK");

var $hO2mG = parcelRequire("hO2mG");

var $6c9fp = parcelRequire("6c9fp");

var $gdarC = parcelRequire("gdarC");

var $jN3Zu = parcelRequire("jN3Zu");

var $aB4dw = parcelRequire("aB4dw");
const $240fb91eeec3f6e4$export$b63039ff2b1a1e69 = ({ autoFocus: autoFocus, label: label, value: value, onChange: onChange, weekStartDay: weekStartDay, defaultValue: defaultValue, testId: testId, isDisabled: isDisabled, timeIsEditable: timeIsEditable, timeSlotIndex: timeSlotIndex, variant: variant = 'default' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const timePickerRef = (0, $5uXOq.useRef)(null);
    const [day, setDay] = (0, $5uXOq.useState)((0, $hO2mG.getDayValue)(value, variant));
    const [time, setTime] = (0, $5uXOq.useState)((0, $hO2mG.getTimeValue)(value));
    const handleChangeFromDay = (selectedOption)=>{
        setDay(selectedOption);
        const isAllValuesSet = selectedOption && time !== undefined && time !== null;
        if (onChange && isAllValuesSet) {
            const [hour, minute] = time.split(':');
            onChange({
                day: selectedOption.value,
                hour: parseInt(hour),
                minute: parseInt(minute)
            });
        }
    };
    const handleChangeFromTime = (selectedOption)=>{
        setTime(selectedOption);
        const isAllValuesSet = day && selectedOption;
        if (onChange && isAllValuesSet) {
            const [hour, minute] = selectedOption.split(':');
            onChange({
                day: day.value,
                hour: parseInt(hour),
                minute: parseInt(minute)
            });
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        if (value) {
            setDay((0, $hO2mG.getDayValue)(value, variant));
            setTime((0, $hO2mG.getTimeValue)(value));
        }
    }, [
        value,
        variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdarC.FullWidthFlex), {
        rowGap: 0.5,
        flexDirection: "column"
    }, timeSlotIndex < 1 && label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aB4dw.Label), null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdarC.FullWidthFlex), {
        flexShrink: 0,
        columnGap: 0.5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aB4dw.InputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6c9fp.DayPicker), {
        autoFocus: autoFocus,
        weekStartDay: weekStartDay,
        value: day,
        defaultValue: (0, $hO2mG.getDayValue)(defaultValue, variant),
        onChange: handleChangeFromDay,
        testId: testId && `${testId}-day-picker`,
        isDisabled: isDisabled,
        components: (0, $aTtVK.selectComponents)[variant],
        spacing: variant,
        variant: variant,
        "aria-label": label && formatMessage((0, $jN3Zu.default).dayLabel, {
            label: label,
            index: timeSlotIndex + 1
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aB4dw.InputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        ref: timePickerRef,
        times: (0, $hO2mG.getDefaultTimes)(),
        // @ts-ignore -  Property 'isClearable' does not exist on type 'TimePickerProps'
        isClearable: false,
        defaultValue: (0, $hO2mG.getTimeValue)(defaultValue),
        onChange: handleChangeFromTime,
        isDisabled: isDisabled,
        timeIsEditable: timeIsEditable,
        hideIcon: variant === 'compact',
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        selectProps: {
            isClearable: false,
            spacing: variant
        },
        testId: testId && `${testId}-time-picker`,
        ...time && {
            value: time
        },
        label: label && formatMessage((0, $jN3Zu.default).timeLabel, {
            label: label,
            index: timeSlotIndex + 1
        })
    }))));
};

});
parcelRegister("aTtVK", function(module, exports) {

$parcel$export(module.exports, "selectComponents", () => $80fdd50943f545bb$export$c34d65c0f5a1c617);
const $80fdd50943f545bb$export$5e30e9a24d6c1203 = ()=>null;
const $80fdd50943f545bb$export$c34d65c0f5a1c617 = {
    default: {},
    compact: {
        ClearIndicator: $80fdd50943f545bb$export$5e30e9a24d6c1203,
        DropdownIndicator: $80fdd50943f545bb$export$5e30e9a24d6c1203
    }
};

});

parcelRegister("hO2mG", function(module, exports) {

$parcel$export(module.exports, "getDayOptions", () => $b6e9dfed9f9dd9c8$export$c9a4384ba880408a);
$parcel$export(module.exports, "getDefaultTimes", () => $b6e9dfed9f9dd9c8$export$951e947e785c998d);
$parcel$export(module.exports, "createEmptyIntervalValue", () => $b6e9dfed9f9dd9c8$export$f1cb5eeb3e4452b1);
$parcel$export(module.exports, "getDayValue", () => $b6e9dfed9f9dd9c8$export$3a1562e64a58f62b);
$parcel$export(module.exports, "getTimeValue", () => $b6e9dfed9f9dd9c8$export$9ea65b90e29638cb);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $jovBr = parcelRequire("jovBr");

var $1GF3c = parcelRequire("1GF3c");
const $b6e9dfed9f9dd9c8$var$dayLabelFormat = {
    default: 'EEEE',
    compact: 'EEE'
};
const $b6e9dfed9f9dd9c8$export$c9a4384ba880408a = (params = {
    weekStartDay: 1
}, variant = 'default')=>{
    if (params.weekStartDay > 8) params.weekStartDay = params.weekStartDay % 8;
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: params.weekStartDay - 1
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), $b6e9dfed9f9dd9c8$var$dayLabelFormat[variant]),
            value: (i + params.weekStartDay - 1) % 7 + 1
        }));
    return weekDays;
};
const $b6e9dfed9f9dd9c8$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $b6e9dfed9f9dd9c8$export$f1cb5eeb3e4452b1 = ()=>{
    return {
        startDay: null,
        startHour: null,
        startMinute: null,
        endDay: null,
        endHour: null,
        endMinute: null
    };
};
const $b6e9dfed9f9dd9c8$export$3a1562e64a58f62b = (value, variant = 'default')=>{
    if (value) {
        if (value.day) {
            const dayOptions = $b6e9dfed9f9dd9c8$export$c9a4384ba880408a(undefined, variant);
            const dayValue = dayOptions.find((day)=>day.value === value.day);
            return dayValue || undefined;
        }
    }
    return undefined;
};
const $b6e9dfed9f9dd9c8$export$9ea65b90e29638cb = (value)=>{
    if (!value) return;
    const { hour: hour, minute: minute } = value;
    if (hour === null || hour === undefined || minute === null || minute === undefined) return;
    if (hour > 24 || minute > 60) return;
    const date = new Date();
    date.setHours(hour, minute);
    if (!(0, $jovBr.default)(date)) return;
    return (0, $k7m40.default)(date, 'HH:mm');
};

});

parcelRegister("6c9fp", function(module, exports) {

$parcel$export(module.exports, "DayPicker", () => $8862597113bc4cdb$export$97e6db89a86ff7ab);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $hO2mG = parcelRequire("hO2mG");
const $8862597113bc4cdb$export$97e6db89a86ff7ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ weekStartDay: weekStartDay, value: value, testId: testId, variant: variant = 'default', ...selectProps }, ref)=>{
    const days = (0, $hO2mG.getDayOptions)({
        weekStartDay: weekStartDay || 1
    }, variant);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ref: ref,
        placeholder: days[0].label.slice(0, 3),
        value: value,
        ...selectProps,
        options: days,
        menuPosition: "fixed",
        testId: testId
    });
});

});

parcelRegister("gdarC", function(module, exports) {

$parcel$export(module.exports, "FullWidthFlex", () => $1b4601b04f1e99a1$export$4d88252e27557a87);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $1b4601b04f1e99a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b4601b04f1e99a1$export$4d88252e27557a87 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "ejhrnl80"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});

});

parcelRegister("jN3Zu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4728c6e6bb434eb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $f4728c6e6bb434eb$var$messages = (0, $7VHMR.defineMessages)({
    timeLabel: {
        id: 'eoc.common.ui.date-time-picker.time-label.no-translate',
        defaultMessage: '{label} time for the {index, select, 1 {1st} 2 {2nd} 3{3rd} other {{index, number}th}} time slot ',
        description: 'Accessibility label of nth time picker in day time interval'
    },
    dayLabel: {
        id: 'eoc.common.ui.date-time-picker.day-label.no-translate',
        defaultMessage: '{label} day for the {index, select, 1 {1st} 2 {2nd} 3{3rd} other {{index, number}th}} time slot ',
        description: 'Accessibility label of nth day picker in day time interval'
    }
});
var $f4728c6e6bb434eb$export$2e2bcd8739ae039 = $f4728c6e6bb434eb$var$messages;

});

parcelRegister("aB4dw", function(module, exports) {

$parcel$export(module.exports, "InputWrapper", () => $f889237f3472c9fc$export$fb9f58ebe9de6283);
$parcel$export(module.exports, "Label", () => $f889237f3472c9fc$export$b04be29aa201d4f5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $f889237f3472c9fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f889237f3472c9fc$export$fb9f58ebe9de6283 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh8pmdh1"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $f889237f3472c9fc$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $bWGt6.default)("label", {
    target: "eh8pmdh0"
})({
    name: "1qupjyf",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);color:var(--ds-text-subtlest, #626F86);margin-top:0"
});

});



parcelRegister("cBVPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $399a4a8c63545f64$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $399a4a8c63545f64$var$messages = (0, $7VHMR.defineMessages)({
    clone: {
        id: 'eoc.common.ui.date-time-interval.clone',
        defaultMessage: 'Duplicate',
        description: 'Accessibility label of clone interval button'
    },
    delete: {
        id: 'eoc.common.ui.date-time-interval.delete',
        defaultMessage: 'Delete',
        description: 'Accessibility label of delete interval button'
    },
    addNew: {
        id: 'eoc.common.ui.date-time-interval.add-new',
        defaultMessage: 'Add time slot',
        description: 'Label of add new interval button'
    }
});
var $399a4a8c63545f64$export$2e2bcd8739ae039 = $399a4a8c63545f64$var$messages;

});

parcelRegister("eHmI5", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $2768438b57a43435$export$c8223871eecc8f3a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
const $2768438b57a43435$var$padding = {
    default: "var(--ds-space-100, 8px)",
    compact: "var(--ds-space-050, 4px)"
};
const $2768438b57a43435$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1antvyp0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingBottom: $2768438b57a43435$var$padding[props.variant]
    }));

});


parcelRegister("a5H39", function(module, exports) {

$parcel$export(module.exports, "useRoutingRuleModalController", () => $9ba5c264b0e742ef$export$4f819cb7561c0995);

var $5uXOq = parcelRequire("5uXOq");

var $3hQTY = parcelRequire("3hQTY");
const $9ba5c264b0e742ef$export$4f819cb7561c0995 = ()=>{
    const { getTimezones: getTimezones, isTimezonesLoading: isTimezonesLoading } = (0, $3hQTY.useRoutingRuleModalService)();
    const [timezones, setTimezones] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        getTimezones().then((res)=>{
            if (res.timezones) {
                const options = res.timezones.map((timezone)=>({
                        label: timezone.simpleName,
                        value: timezone.id
                    }));
                setTimezones(options);
            }
        });
    }, [
        getTimezones
    ]);
    return {
        timezones: timezones,
        isTimezonesLoading: isTimezonesLoading
    };
};

});
parcelRegister("3hQTY", function(module, exports) {

$parcel$export(module.exports, "useRoutingRuleModalService", () => $4a74fb4713bc1f5c$export$9cf120758ee2a5bd);

var $5uXOq = parcelRequire("5uXOq");

var $3b4Wn = parcelRequire("3b4Wn");
const $4a74fb4713bc1f5c$export$9cf120758ee2a5bd = ()=>{
    const [isTimezonesLoading, setIsTimezonesLoading] = (0, $5uXOq.useState)(false);
    const getTimezones = (0, $5uXOq.useCallback)(()=>{
        setIsTimezonesLoading(true);
        return (0, $3b4Wn.getTimezonesEndpoint)().finally(()=>setIsTimezonesLoading(false));
    }, []);
    return {
        isTimezonesLoading: isTimezonesLoading,
        getTimezones: getTimezones
    };
};

});
parcelRegister("3b4Wn", function(module, exports) {

$parcel$export(module.exports, "getTimezonesEndpoint", () => $bc378cab1f70e4cd$export$d0edaa6f449b260);

var $j74qU = parcelRequire("j74qU");
const $bc378cab1f70e4cd$export$d0edaa6f449b260 = ()=>{
    return (0, $j74qU.eocFetch)(`/v1/customers/timezones`);
};

});



parcelRegister("4KBlT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a307e7ba5e426f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c5a307e7ba5e426f$var$messages = (0, $7VHMR.defineMessages)({
    addTitle: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.add-title.no-translate',
        defaultMessage: 'Create routing rule',
        description: 'Title of add routing rule modal'
    },
    editTitle: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.edit-title.no-translate',
        defaultMessage: 'Edit routing rule',
        description: 'Title of edit routing rule modal'
    },
    cloneTitle: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.edit-title.no-translate',
        defaultMessage: 'Duplicate routing rule',
        description: 'Title of clone routing rule modal'
    },
    ruleTitle: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.rule-title.no-translate',
        defaultMessage: 'Name',
        description: 'Label of rule title input'
    },
    ruleTitlePlaceholder: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.rule-title-placeholder.no-translate',
        defaultMessage: 'Enter a name for the rule',
        description: 'Placeholder of rule title input'
    },
    followingConditions: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.following-conditions.no-translate',
        defaultMessage: 'Alert Filters',
        description: 'The seperator title of form sections'
    },
    notifyInput: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.notify-input.no-translate',
        defaultMessage: 'Filter alerts',
        description: 'Label of notify input'
    },
    restrictToTimeInterval: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.restrict-to-time-interval.no-translate',
        defaultMessage: 'Time slots',
        description: 'Label of restrict to time interval section'
    },
    specificInterval: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.specific-interval.no-translate',
        defaultMessage: 'Route during specified time slots only',
        description: 'Label of specific interval checkbox'
    },
    thenRouteUsing: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.then-route-using.no-translate',
        defaultMessage: 'Route target',
        description: 'The seperator title of form sections'
    },
    routeTo: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-to.no-translate',
        defaultMessage: 'Route to',
        description: 'Label of route to select'
    },
    routeTargetTooltipContent: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-target-tooltip-content.no-translate',
        defaultMessage: 'Select a target to route your alerts to',
        description: 'Tooltip content message to introduce route target section'
    },
    routeTargetTooltipLabel: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-target-tooltip-label.no-translate',
        defaultMessage: 'More about route target',
        description: `Label of the tooltip info button for accessibility`
    },
    forEveryday: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.for-everyday.no-translate',
        defaultMessage: 'Daily',
        description: 'Label of for everyday radio'
    },
    customizeDays: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.customize-days.no-translate',
        defaultMessage: 'Custom',
        description: 'Label of customize days radio'
    },
    from: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.from.no-translate',
        defaultMessage: 'From',
        description: 'Label of date time pickers: from'
    },
    to: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.to.no-translate',
        defaultMessage: 'To',
        description: 'Label of date time pickers: to'
    },
    timezone: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.timezone.no-translate',
        defaultMessage: 'Select timezone',
        description: 'Label of timezone select'
    },
    cancel: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.cancel.no-translate',
        defaultMessage: 'Cancel',
        description: 'Label of close modal button'
    },
    add: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.add.no-translate',
        defaultMessage: 'Create',
        description: 'Label of submit add routing rule button'
    },
    update: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.update.no-translate',
        defaultMessage: 'Update',
        description: 'Label of update routing rule button'
    },
    clone: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.clone.no-translate',
        defaultMessage: 'Duplicate',
        description: 'Label of clone routing rule button'
    },
    scheduleWarning: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.schedule-warning.no-translate',
        defaultMessage: "You\u2019ve selected a schedule to route the alerts. This means, when you receive an alert according to this routing rule, we\u2019ll ignore other escalation policies the alerts might be subjected to, and route them directly to the schedule you\u2019ve selected.",
        description: 'Warning message that shown when user select route to field schedule'
    },
    routeDeletedWarning: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.route-deleted-warning.no-translate',
        defaultMessage: 'The team selected for routing no longer exists. Select a different route target.',
        description: 'Warning message that shown when routing rule is not exist anymore'
    },
    deletedTeam: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.deleted-team-placeholder.no-translate',
        defaultMessage: 'Deleted team',
        description: 'Indicator message when team is not exist anymore'
    },
    conditionRequired: {
        id: 'eoc.routing-rules.ui.add-routing-rules-modal.condition-required.no-translate',
        defaultMessage: 'Enter a key for the condition work',
        description: 'Error message that shown when field free form value is not exist'
    },
    fieldRequired: {
        id: 'eoc.routing-rules.ui.common.required.no-translate',
        defaultMessage: 'This field is required',
        description: 'Error message that shown required input is empty'
    },
    routeToRequired: {
        id: 'eoc.routing-rules.ui.common.route-to-required.no-translate',
        defaultMessage: 'Select a different route target.',
        description: 'Error message that shown route to select is not selected'
    }
});
var $c5a307e7ba5e426f$export$2e2bcd8739ae039 = $c5a307e7ba5e426f$var$messages;

});

parcelRegister("1sGdg", function(module, exports) {

$parcel$export(module.exports, "ConditionFilterWrapper", () => $1bdfe3c359871dba$export$7d61180229cc5ced);
$parcel$export(module.exports, "SelectWrapper", () => $1bdfe3c359871dba$export$d586e0ae81c7b89b);
$parcel$export(module.exports, "RadioWrapper", () => $1bdfe3c359871dba$export$ffcbb0cdcfc3e158);
$parcel$export(module.exports, "TimePickerWrapper", () => $1bdfe3c359871dba$export$c4fb2c7ede889acb);
$parcel$export(module.exports, "TimezoneWrapper", () => $1bdfe3c359871dba$export$7bd7f983e14736de);
$parcel$export(module.exports, "DayTimeIntervalWrapper", () => $1bdfe3c359871dba$export$841b127148377a5);
$parcel$export(module.exports, "SectionMessageWrapper", () => $1bdfe3c359871dba$export$c5e20d5e200edfe2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $1bdfe3c359871dba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1bdfe3c359871dba$var$maxInputWidth = `${352}px`;
const $1bdfe3c359871dba$export$7d61180229cc5ced = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et7r2ot6"
})({
    marginTop: "var(--ds-space-150, 12px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#condition-filter-match-type': {
        maxWidth: $1bdfe3c359871dba$var$maxInputWidth
    }
});
const $1bdfe3c359871dba$export$d586e0ae81c7b89b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et7r2ot5"
})({
    maxWidth: $1bdfe3c359871dba$var$maxInputWidth
});
const $1bdfe3c359871dba$export$ffcbb0cdcfc3e158 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et7r2ot4"
})({
    name: "1rri4ev",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-200, 16px);div[role='radiogroup']{display:flex;column-gap:var(--ds-space-300, 24px);}"
});
const $1bdfe3c359871dba$export$c4fb2c7ede889acb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et7r2ot3"
})({
    width: '100%',
    maxWidth: `${166}px`,
    marginTop: "var(--ds-space-100, 8px)"
});
const $1bdfe3c359871dba$export$7bd7f983e14736de = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et7r2ot2"
})({
    width: '100%',
    maxWidth: `${340}px`,
    marginTop: "var(--ds-space-200, 16px)"
});
const $1bdfe3c359871dba$export$841b127148377a5 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "et7r2ot1"
})({
    width: '100%',
    maxWidth: `${496}px`,
    marginTop: "var(--ds-space-250, 20px)"
});
const $1bdfe3c359871dba$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "et7r2ot0"
})({
    name: "uv0shy",
    styles: "margin-top:var(--ds-space-100, 8px)"
});

});


parcelRegister("lLH2S", function(module, exports) {

$parcel$export(module.exports, "RuleCardActions", () => $4f23cf2b48234a50$export$b9e83baafd032738);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWn3s = parcelRequire("bWn3s");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $lj8SI = parcelRequire("lj8SI");

var $eZJjh = parcelRequire("eZJjh");

var $dY87H = parcelRequire("dY87H");

var $eBpAx = parcelRequire("eBpAx");
const $4f23cf2b48234a50$export$b9e83baafd032738 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isLastItem: isLastItem, isLoading: isLoading, onEdit: onEdit, onClone: onClone, onDelete: onDelete, name: name, hasEditRight: hasEditRight, hasDeleteRight: hasDeleteRight, isDeleted: isDeleted }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useImperativeHandle)(ref, ()=>({
            getActionButtonRef: ()=>buttonRef
        }));
    if (isLastItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center",
        columnGap: 1.5
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "routing-rules.rule-card-actions.deleting",
        size: "small"
    }), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, formatMessage((0, $eBpAx.default).routeTargetDeleted)), (hasEditRight || hasDeleteRight) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                label: formatMessage((0, $eBpAx.default).showMore, {
                    name: name
                }),
                ref: (0, $bWn3s.mergeRefs)([
                    triggerRef,
                    buttonRef
                ]),
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF)))
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onEdit
    }, formatMessage((0, $eBpAx.default).edit)), hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onClone
    }, formatMessage((0, $eBpAx.default).clone)), hasDeleteRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onDelete
    }, formatMessage((0, $eBpAx.default).delete)))));
});

});
parcelRegister("eBpAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab123cd6836c0970$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ab123cd6836c0970$var$messages = (0, $7VHMR.defineMessages)({
    edit: {
        id: 'eoc.routing-rules.ui.rule-card-actions.edit.no-translate',
        defaultMessage: 'Edit',
        description: 'Label of edit button'
    },
    clone: {
        id: 'eoc.routing-rules.ui.rule-card-actions.clone.no-translate',
        defaultMessage: 'Duplicate',
        description: 'Label of clone button'
    },
    delete: {
        id: 'eoc.routing-rules.ui.rule-card-actions.add.no-translate',
        defaultMessage: 'Delete',
        description: 'Label of delete button'
    },
    showMore: {
        id: 'eoc.routing-rules.ui.rule-card-actions.show-more.no-translate',
        defaultMessage: 'Show Actions of {name}',
        description: 'Label of show more button'
    },
    routeTargetDeleted: {
        id: 'eoc.routing-rules.ui.rule-card-actions.route-target-deleted.no-translate',
        defaultMessage: 'Route Target Deleted',
        description: 'Label of route target deleted lozenge'
    }
});
var $ab123cd6836c0970$export$2e2bcd8739ae039 = $ab123cd6836c0970$var$messages;

});


parcelRegister("7uKo4", function(module, exports) {

$parcel$export(module.exports, "RuleCardContent", () => $4cc4ed9de2be228a$export$af1ea2c1c6e3c42);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dD7Zc = parcelRequire("dD7Zc");

var $6tRzQ = parcelRequire("6tRzQ");

var $lj8SI = parcelRequire("lj8SI");

var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $dY87H = parcelRequire("dY87H");

var $hkH3Y = parcelRequire("hkH3Y");
var $jj11s = parcelRequire("jj11s");

var $4LTQA = parcelRequire("4LTQA");
var $kjV7K = parcelRequire("kjV7K");

var $34Ozh = parcelRequire("34Ozh");

var $7Ovoi = parcelRequire("7Ovoi");

var $fEOVW = parcelRequire("fEOVW");
const $4cc4ed9de2be228a$var$DeletedEntityIndicator = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: (0, $fEOVW.deletedEntityIndicatorStyle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        label: "Error icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        weight: "semibold"
    }, formatMessage((0, $7Ovoi.default).deletedEntity))));
};
const $4cc4ed9de2be228a$export$af1ea2c1c6e3c42 = ({ entity: entity, index: index })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.RuleCardContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkH3Y.RuleItemGroup), {
        left: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: "inprogress"
        }, formatMessage(index === 0 ? (0, $7Ovoi.default).if : (0, $7Ovoi.default).elseIf)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jj11s.RuleItemRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 0.5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4LTQA.ConditionList), {
        data: entity.conditions,
        matchType: entity.conditionMatchType,
        noConditionMessage: formatMessage((0, $7Ovoi.default).forAny)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjV7K.TimeList), {
        data: entity.timeRestrictedInterval.timeRestrictions,
        enabled: entity.timeRestrictedInterval.enabled,
        beforeMessage: formatMessage((0, $7Ovoi.default).routingTimeIsBetween)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkH3Y.RuleItemGroup), {
        left: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34Ozh.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            style: (0, $fEOVW.transparentLozengeStyle)
        }, formatMessage((0, $7Ovoi.default).then)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jj11s.RuleItemRow), null, formatMessage((0, $7Ovoi.default).routeAlertTo, {
        entityName: entity.deleted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cc4ed9de2be228a$var$DeletedEntityIndicator, null) : !entity.entityId ? formatMessage((0, $7Ovoi.default).noOne) : entity.entityName,
        strong: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, str)
    }), entity.entityType === 'sch' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $7Ovoi.default).scheduleWarning)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        label: formatMessage((0, $7Ovoi.default).scheduleWarning),
        LEGACY_size: "small"
    }))))));
};

});
parcelRegister("4LTQA", function(module, exports) {

$parcel$export(module.exports, "ConditionList", () => $d53e6f03cf87e315$export$f87be7148ef64c4c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cgL5K = parcelRequire("cgL5K");

var $78cPr = parcelRequire("78cPr");

var $ixPbc = parcelRequire("ixPbc");
const $d53e6f03cf87e315$export$f87be7148ef64c4c = ({ data: data, matchType: matchType, noConditionMessage: noConditionMessage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (matchType === 0 && noConditionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixPbc.Condition), null, noConditionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data.map((condition, i)=>{
        const { fieldFreeForm: fieldFreeForm, field: field, not: not, operation: operation, expectedValue: expectedValue } = condition;
        const value = expectedValue ?? (operation !== 10 ? 'null' : false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixPbc.Condition), {
            isCapitalized: i === 0,
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, matchType === 1 && formatMessage((0, $78cPr.default)['or'], {
            strong: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, str)
        }), matchType === 2 && formatMessage((0, $78cPr.default)['and'], {
            strong: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, str)
        })), formatMessage((0, $78cPr.default).operationVerbalForm, {
            field: field,
            not: not,
            fieldFreeForm: fieldFreeForm,
            operation: operation,
            value: value,
            strong: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, str)
        }));
    }));
};

});
parcelRegister("78cPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $882b6e87c26758c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $882b6e87c26758c2$var$messages = (0, $7VHMR.defineMessages)({
    operationVerbalForm: {
        id: 'eoc.rule-card.condition-list.operation-verbal-form.no-translate',
        defaultMessage: `{fieldFreeForm, select,
      false {{field}}
      other {value of {field} in extra properties}
    } {not, select,
        true {{operation, select,
          0 {does not match}
          1 {does not contain}
          3 {does not start with}
          4 {does not end with}
          5 {does not equal}
          6 {does not contain key}
          7 {does not contain value}
          8 {does not greater than}
          9 {does not less than}
          10 {is not empty}
          11 {is not equal ignore whitespace}
          other {}
        }}
        other {{operation, select,
          0 {matches}
          1 {contains}
          3 {starts with}
          4 {ends with}
          5 {equals}
          6 {contains key}
          7 {contains value}
          8 {is greater than}
          9 {less than}
          10 {is empty}
          11 {equals ignore whitespace}
          other {}
        }}
      } {value, select, false {} other {<strong>{value}</strong>}}`,
        description: 'Full message of operation. Example: message contains important / message does not contains important'
    },
    or: {
        id: 'eoc.rule-card.condition-list.or.no-translate',
        defaultMessage: '<strong>OR </strong>',
        description: '"Or" condition'
    },
    and: {
        id: 'eoc.rule-card.condition-list.and.no-translate',
        defaultMessage: '<strong>AND </strong>',
        description: '"And" condition'
    }
});
var $882b6e87c26758c2$export$2e2bcd8739ae039 = $882b6e87c26758c2$var$messages;

});

parcelRegister("ixPbc", function(module, exports) {

$parcel$export(module.exports, "Condition", () => $126d3751ceace28c$export$fcea0b2db26e6b18);

var $bWGt6 = parcelRequire("bWGt6");
const $126d3751ceace28c$export$fcea0b2db26e6b18 = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "eps6b910"
})((props)=>({
        marginTop: 0,
        '&::first-letter': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            textTransform: props.isCapitalized ? 'capitalize' : 'none'
        }
    }));

});


parcelRegister("kjV7K", function(module, exports) {

$parcel$export(module.exports, "TimeList", () => $77f95c69a7f01ab1$export$2b1f73527d7bd6b5);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cgL5K = parcelRequire("cgL5K");

var $kUYXs = parcelRequire("kUYXs");

var $b1ILu = parcelRequire("b1ILu");

var $k6Uw3 = parcelRequire("k6Uw3");
const $77f95c69a7f01ab1$export$2b1f73527d7bd6b5 = ({ data: data, enabled: enabled, beforeMessage: beforeMessage })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!enabled || data.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6Uw3.Condition), null, formatMessage((0, $b1ILu.default)['and'], {
        strong: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, str)
    }), beforeMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, beforeMessage), data.map((t, i)=>{
        let isNextWeek = false;
        if (t.startDay && t.endDay) {
            const isBeforeDay = t.startDay > t.endDay;
            const isSameDay = t.startDay === t.endDay;
            const isSameDayButBeforeHour = isSameDay && t.startHour > t.endHour;
            isNextWeek = isBeforeDay || isSameDayButBeforeHour;
        }
        if (i === data.length - 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong",
            key: i
        }, (0, $kUYXs.formatRestriction)(t), isNextWeek ? ` ${formatMessage((0, $b1ILu.default).nextWeek)}` : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong",
            key: i
        }, (0, $kUYXs.formatRestriction)(t), isNextWeek ? ` ${formatMessage((0, $b1ILu.default).nextWeek)}` : '', ",", ' ');
    })));
};

});
parcelRegister("kUYXs", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $3d454fac060187d4$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "formatRestriction", () => $3d454fac060187d4$export$99bcc87a197977ea);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $f2F4g = parcelRequire("f2F4g");

var $1GF3c = parcelRequire("1GF3c");

var $gSMVt = parcelRequire("gSMVt");
const $3d454fac060187d4$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $gSMVt.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $3d454fac060187d4$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), 'EEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $3d454fac060187d4$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $3d454fac060187d4$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};

});
parcelRegister("gSMVt", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS", () => $b61e2f68a5a5e519$export$98ff4de2f070152d);

var $lH9fx = parcelRequire("lH9fx");
const $b61e2f68a5a5e519$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $lH9fx.OperationIds).Matches,
        name: (0, $lH9fx.Operation).Matches
    },
    {
        order: 1,
        id: (0, $lH9fx.OperationIds).Equals,
        name: (0, $lH9fx.Operation).Equals
    },
    {
        order: 2,
        id: (0, $lH9fx.OperationIds).Contains,
        name: (0, $lH9fx.Operation).Contains
    },
    {
        order: 3,
        id: (0, $lH9fx.OperationIds).StartsWith,
        name: (0, $lH9fx.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $lH9fx.OperationIds).EndsWith,
        name: (0, $lH9fx.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $lH9fx.OperationIds).ContainsKey,
        name: (0, $lH9fx.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $lH9fx.OperationIds).ContainsValue,
        name: (0, $lH9fx.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $lH9fx.OperationIds).GreaterThan,
        name: (0, $lH9fx.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $lH9fx.OperationIds).LessThan,
        name: (0, $lH9fx.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $lH9fx.OperationIds).IsEmpty,
        name: (0, $lH9fx.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $lH9fx.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $lH9fx.Operation).EqualsIgnoreWhitespace
    }
];

});
parcelRegister("lH9fx", function(module, exports) {

$parcel$export(module.exports, "OperationIds", () => $87e0af6f7cae01cd$export$9e369e35ea3634d7);
$parcel$export(module.exports, "Operation", () => $87e0af6f7cae01cd$export$ab5aad00225c5662);
$parcel$export(module.exports, "MatchConditionType", () => $87e0af6f7cae01cd$export$dab128282aa7aeee);
var $87e0af6f7cae01cd$export$c897a47ee206642e = /*#__PURE__*/ function(WeekDay) {
    WeekDay[WeekDay["Sunday"] = 1] = "Sunday";
    WeekDay[WeekDay["Monday"] = 2] = "Monday";
    WeekDay[WeekDay["Tuesday"] = 3] = "Tuesday";
    WeekDay[WeekDay["Wednesday"] = 4] = "Wednesday";
    WeekDay[WeekDay["Thursday"] = 5] = "Thursday";
    WeekDay[WeekDay["Friday"] = 6] = "Friday";
    WeekDay[WeekDay["Saturday"] = 7] = "Saturday";
    return WeekDay;
}({});
var $87e0af6f7cae01cd$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $87e0af6f7cae01cd$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});
var $87e0af6f7cae01cd$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});

});



parcelRegister("b1ILu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0d529f7d8bb4f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8a0d529f7d8bb4f6$var$messages = (0, $7VHMR.defineMessages)({
    nextWeek: {
        id: 'eoc.rule-card.time-list.next-week.no-translate',
        defaultMessage: 'next week',
        description: 'The text will shown when start day is later than end day'
    },
    and: {
        id: 'eoc.rule-card.time-list.and.no-translate',
        defaultMessage: '<strong>AND </strong>',
        description: '"And" condition'
    }
});
var $8a0d529f7d8bb4f6$export$2e2bcd8739ae039 = $8a0d529f7d8bb4f6$var$messages;

});

parcelRegister("k6Uw3", function(module, exports) {

$parcel$export(module.exports, "Condition", () => $6e6c882a4f67d66f$export$fcea0b2db26e6b18);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $6e6c882a4f67d66f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6e6c882a4f67d66f$export$fcea0b2db26e6b18 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ty6izk0"
})({
    name: "1co5u2f",
    styles: "display:inline-flex;column-gap:var(--ds-space-050, 4px);flex-wrap:wrap;word-break:break-word;margin-top:0"
});

});


parcelRegister("7Ovoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ffcfb1ba4a6266$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $34ffcfb1ba4a6266$var$messages = (0, $7VHMR.defineMessages)({
    if: {
        id: 'eoc.routing-rules.ui.rule-card-content.if.no-translate',
        defaultMessage: 'IF',
        description: 'Label of first rule condition'
    },
    elseIf: {
        id: 'eoc.routing-rules.ui.rule-card-content.else-if.no-translate',
        defaultMessage: 'ELSE IF',
        description: 'Label of other rule condition'
    },
    then: {
        id: 'eoc.routing-rules.ui.rule-card-content.then.no-translate',
        defaultMessage: 'THEN',
        description: 'The indicator of what gonna happen after conditions end'
    },
    routeAlertTo: {
        id: 'eoc.routing-rules.ui.rule-card-content.route-alert-to.no-translate',
        defaultMessage: 'route the alert to <strong>{entityName}</strong>',
        description: 'The label of "then" rule'
    },
    noOne: {
        id: 'eoc.routing-rules.ui.rule-card-content.no-one.no-translate',
        defaultMessage: 'No one',
        description: 'The label that appears if entity id/name does not exist.'
    },
    scheduleWarning: {
        id: 'eoc.routing-rules.ui.rule-card-content.schedule-warning.no-translate',
        defaultMessage: "Filtered alerts are not escalated because they're routed to a schedule",
        description: 'The label that appears if routing rule is schedule.'
    },
    deletedEntity: {
        id: 'eoc.routing-rules.ui.rule-card-content.deleted-entity.no-translate',
        defaultMessage: 'Deleted Entity',
        description: 'The label that appears if entity deleted'
    },
    forAny: {
        id: 'eoc.routing-rules.ui.rule-card-content.for-any-received-alert.no-translate',
        defaultMessage: 'for any received alert',
        description: 'Label of rule card condition'
    },
    routingTimeIsBetween: {
        id: 'eoc.routing-rules.common-messages.routing-time-is-between.no-translate',
        defaultMessage: 'routing time is between ',
        description: 'A text message that will be exist when routing rule is time restricted'
    }
});
var $34ffcfb1ba4a6266$export$2e2bcd8739ae039 = $34ffcfb1ba4a6266$var$messages;

});

parcelRegister("fEOVW", function(module, exports) {

$parcel$export(module.exports, "transparentLozengeStyle", () => $e3c84e48e3354f01$export$8380a4df11e1761e);
$parcel$export(module.exports, "deletedEntityIndicatorStyle", () => $e3c84e48e3354f01$export$963e918b3adaf4d1);

const $e3c84e48e3354f01$export$8380a4df11e1761e = {
    backgroundColor: 'transparent',
    color: "var(--ds-text-subtlest, #626F86)"
};
const $e3c84e48e3354f01$export$963e918b3adaf4d1 = {
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
    gap: "var(--ds-space-050, 4px)"
};

});


parcelRegister("FpHBG", function(module, exports) {

$parcel$export(module.exports, "SectionContent", () => $1190944a8cadfc6e$export$51a9c37cab91cff6);
$parcel$export(module.exports, "RuleCardContainer", () => $1190944a8cadfc6e$export$883d4840a83fb5ff);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $1190944a8cadfc6e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1190944a8cadfc6e$export$f99233281efd08a0 = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "e1u7n2ws2"
})({
    name: "1i9vogi",
    styles: "margin-top:0"
});
const $1190944a8cadfc6e$export$51a9c37cab91cff6 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1u7n2ws1"
})({
    name: "uv0shy",
    styles: "margin-top:var(--ds-space-100, 8px)"
});
const $1190944a8cadfc6e$export$883d4840a83fb5ff = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1u7n2ws0"
})("&:not(:only-child){margin-top:", (props)=>props.isLastItem ? 10 : 0, "px;}");

});



parcelRegister("jZP9x", function(module, exports) {

$parcel$export(module.exports, "SchedulePage", () => $8612fce3942be8d9$export$9429539b69647520);

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $jMht3 = parcelRequire("jMht3");

var $jxRF2 = parcelRequire("jxRF2");

var $eoC0M = parcelRequire("eoC0M");

var $hem2I = parcelRequire("hem2I");

var $dmLt8 = parcelRequire("dmLt8");

var $aSTVt = parcelRequire("aSTVt");

var $d41OH = parcelRequire("d41OH");

var $dTe1P = parcelRequire("dTe1P");

var $6RRyp = parcelRequire("6RRyp");

var $bPR4Q = parcelRequire("bPR4Q");

var $3S1hY = parcelRequire("3S1hY");
const $8612fce3942be8d9$export$9429539b69647520 = ({ onSchedulesReady: onSchedulesReady })=>{
    const { loading: getScheduleRightsLoading, error: getScheduleRightsError } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const { loading: getSchedulesLoading, error: getSchedulesError } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { loading: getUiPreferencesLoading, error: getUiPreferencesError } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { loading: getScheduleTimeTemplatesLoading, error: getScheduleTimeTemplatesError } = (0, $hem2I.default)((0, $6RRyp.getScheduleTimeTemplatesResource));
    const { loading: eocUserLoading, error: eocUserError } = (0, $hem2I.default)((0, $jxRF2.eocUserResource));
    const { loading: getTimezonesLoading, error: getTimezonesError } = (0, $hem2I.default)((0, $dmLt8.getTimezonesResource));
    const isError = getScheduleRightsError || getSchedulesError || getUiPreferencesError || getScheduleTimeTemplatesError || eocUserError || getTimezonesError;
    const isLoading = getScheduleRightsLoading || getSchedulesLoading || getUiPreferencesLoading || getScheduleTimeTemplatesLoading || eocUserLoading || getTimezonesLoading;
    if (isError || isLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            source: 'onCall',
            tags: (0, $aSTVt.ANALYTICS_TAGS).onCall
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMht3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eoC0M.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTe1P.Container), {
        onAllSchedulesReady: onSchedulesReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d41OH.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3S1hY.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPR4Q.List), null)))))));
};

});
parcelRegister("jMht3", function(module, exports) {

$parcel$export(module.exports, "default", () => $523b802983b65f41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cQDa6 = parcelRequire("cQDa6");

var $9JUz5 = parcelRequire("9JUz5");

var $4vCEN = parcelRequire("4vCEN");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $523b802983b65f41$var$ErrorBoundaryBase extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, { componentStack: componentStack }) {
        this.setState({
            error: error,
            hasError: true,
            componentStack: componentStack
        });
        this.props.onError(error, componentStack);
    }
    componentDidMount() {
        this.props.onMount && this.props.onMount();
    }
    componentWillUnmount() {
        this.props.onUnMount && this.props.onUnMount(this.state.error, this.state.componentStack);
    }
    reset() {
        this.setState({
            error: null,
            hasError: false,
            componentStack: null
        });
    }
    render() {
        const FallbackComponent = this.props.FallbackComponent ?? (0, $9JUz5.default);
        if (this.state.hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, {
            error: this.state.error,
            componentStack: this.state.componentStack,
            resetError: this.resetError,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: null,
            hasError: false,
            componentStack: null
        }, this.resetError = ()=>{
            if (this.props.onReset) this.props.onReset(this.state.error, this.state.componentStack);
            this.reset();
        };
    }
}
function $523b802983b65f41$export$2e2bcd8739ae039({ children: children, className: className, attributes: attributes, ...props }) {
    const reporter = (0, $cQDa6.useReportError)();
    const FallbackComponent = props.FallbackComponent;
    const handleError = (error, componentStack)=>{
        if (props.onError) props.onError(error, componentStack);
        const id = (0, $4vCEN.getErrorId)(error);
        reporter(id, error, attributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($523b802983b65f41$var$ErrorBoundaryBase, {
        ...props,
        onError: handleError,
        FallbackComponent: FallbackComponent
    }, children);
}

});
parcelRegister("9JUz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c83afba149ab3bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $hTEpF = parcelRequire("hTEpF");

var $6yUsV = parcelRequire("6yUsV");

var $fFX6Q = parcelRequire("fFX6Q");

var $7tgKu = parcelRequire("7tgKu");

var $gr83d = parcelRequire("gr83d");
const $1c83afba149ab3bd$var$Fallback = ({ error: error, className: className })=>{
    const intl = (0, $koVbs.default)();
    const ref = (0, $5uXOq.useRef)(null);
    const [isSmallSize, setIsSmallSize] = (0, $5uXOq.useState)(undefined);
    const MIN_WIDTH_LIMIT = 258; // Width limit for the show small component
    const MIN_HEIGHT_LIMIT = 250; // Height limit for the show small component
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current) {
            const { clientWidth: clientWidth, clientHeight: clientHeight } = ref.current;
            setIsSmallSize(clientWidth < MIN_WIDTH_LIMIT || clientHeight < MIN_HEIGHT_LIMIT && clientHeight !== 0);
        }
    }, []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gr83d.FallbackWrapper), {
        className: className,
        ref: ref
    }, isSmallSize !== undefined && (isSmallSize ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
        appearance: "error",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gr83d.InitialTextWrapWrapper), null, intl.formatMessage((0, $7tgKu.messages).errorMessage))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, error.message)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: intl.formatMessage((0, $7tgKu.messages).errorMessage),
        description: error.message,
        imageHeight: MIN_HEIGHT_LIMIT,
        imageWidth: MIN_WIDTH_LIMIT,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fFX6Q)))
    }))));
};
const $1c83afba149ab3bd$var$DefaultFallbackComponent = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c83afba149ab3bd$var$Fallback, props));
};
var $1c83afba149ab3bd$export$2e2bcd8739ae039 = $1c83afba149ab3bd$var$DefaultFallbackComponent;

});
parcelRegister("6yUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c43b93305034f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $ctg8C = parcelRequire("ctg8C");

var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");

var $60LNO = parcelRequire("60LNO");
const $e2c43b93305034f0$var$rootStyles = null;
const $e2c43b93305034f0$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const toggleDialog = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $e2c43b93305034f0$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ctg8C.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $fVnbM.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $60LNO.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;

});
parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("60LNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $474777c4d72d6c07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jfSgx = parcelRequire("jfSgx");
const $474777c4d72d6c07$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $474777c4d72d6c07$var$iconWrapperStyles = null;
const $474777c4d72d6c07$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $jfSgx.typesMapping);
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $474777c4d72d6c07$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious"
    }));
};
var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;

});
parcelRegister("jfSgx", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $e3da74fa628ddd87$export$4d111645c0b39d5d);

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");
const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("fFX6Q", function(module, exports) {
module.exports = new URL("somethings-wrong.ef47b20e.png", import.meta.url).toString();

});

parcelRegister("7tgKu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9ea62820b198db80$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9ea62820b198db80$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorMessage: {
        id: 'eoc.error-boundary.default-fallback',
        defaultMessage: 'Something went wrong!',
        description: 'The text will be displayed when error occurred in the component which was wrapped by ErrorBoundary'
    }
});

});

parcelRegister("gr83d", function(module, exports) {

$parcel$export(module.exports, "InitialTextWrapWrapper", () => $26538196befbae8e$export$e5423837861faf90);
$parcel$export(module.exports, "FallbackWrapper", () => $26538196befbae8e$export$fd72a2f6962b1b80);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $26538196befbae8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $26538196befbae8e$export$e5423837861faf90 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqci3911"
})({
    name: "9f3hnf",
    styles: "text-overflow:ellipsis;white-space:initial;overflow:hidden;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $26538196befbae8e$export$fd72a2f6962b1b80 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eqci3910"
})({
    name: "w1atjl",
    styles: "width:100%;height:100%"
});

});


parcelRegister("4vCEN", function(module, exports) {

$parcel$export(module.exports, "getErrorId", () => $fe7a85344a81df1e$export$fa5cbc28aaf29d29);
function $fe7a85344a81df1e$var$isObject(error) {
    return typeof error === 'object' && error !== null;
}
function $fe7a85344a81df1e$var$hasId(error) {
    return $fe7a85344a81df1e$var$isObject(error) && typeof error.id === 'string';
}
function $fe7a85344a81df1e$export$fa5cbc28aaf29d29(error) {
    return $fe7a85344a81df1e$var$hasId(error) ? error.id : 'unknown-id';
}

});


parcelRegister("aSTVt", function(module, exports) {

$parcel$export(module.exports, "LAYER_HEIGHT", () => $2800981a136a0b36$export$1ed3e6d9e93fcfd8);
$parcel$export(module.exports, "SCHEDULE_NAME_MAX_LENGTH", () => $2800981a136a0b36$export$1ac411979f0f114);
$parcel$export(module.exports, "ROTATION_NAME_MAX_LENGTH", () => $2800981a136a0b36$export$5e7abbe03690cd8f);
$parcel$export(module.exports, "WEEK_DAY_COUNT", () => $2800981a136a0b36$export$fe62c2dddb4d77ea);
$parcel$export(module.exports, "REQUESTED_NO_ONE", () => $2800981a136a0b36$export$4da0bbb2d275ef20);
$parcel$export(module.exports, "DEFAULT_TIMES", () => $2800981a136a0b36$export$8424696d93134b23);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $2800981a136a0b36$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $2800981a136a0b36$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "ANALYTICS_TAGS", () => $2800981a136a0b36$export$5c5dde904519fd9b);
// this is used to calculate indicators height
const $2800981a136a0b36$export$1ed3e6d9e93fcfd8 = "var(--ds-space-200, 16px)";
const $2800981a136a0b36$export$1ac411979f0f114 = 127;
// TODO: LEARN CORRECT MAX LENGTH
const $2800981a136a0b36$export$5e7abbe03690cd8f = 127;
const $2800981a136a0b36$export$fe62c2dddb4d77ea = 7;
const $2800981a136a0b36$export$4da0bbb2d275ef20 = {
    id: 'noone',
    type: 'noone'
};
/*
 * Times - ["00:00", "00:30", ..., "23:00", "23:30"]
 */ const $2800981a136a0b36$export$8424696d93134b23 = Array.from({
    length: 24
}, (_, i)=>i).flatMap((time)=>{
    return [
        `${time}:00`,
        `${time}:30`
    ].map((t)=>t.padStart(5, '0'));
});
const $2800981a136a0b36$export$a7c923252528b255 = {
    firstSchedule: 'eoc-schedule_first_schedule',
    firstListRotationItem: 'eoc-schedule_first_list_schedule_item',
    firstScheduleActions: 'eoc-schedule-first-schedule_actions',
    editRotationTimings: 'eoc-schedule-edit_rotation_timings',
    editRotationForm: 'eoc-schedule_edit_rotation_rotation',
    editModeSchedule: 'eoc-schedule-edit_mode_schedule',
    shiftTile: 'eoc-schedule-shift_tile'
};
const $2800981a136a0b36$export$38c46ed7a5bc80a0 = {
    rotationEdit: 'eoc-schedule-rotation-edit',
    shiftTile: 'eoc-schedule-shift-tile',
    rotationList: 'eoc-schedule-rotation-list',
    scheduleActions: 'eoc-schedule-schedule-actions'
};
const $2800981a136a0b36$export$5c5dde904519fd9b = {
    onCall: [
        'eoc-schedule',
        'eoc-on-call'
    ],
    editMode: [
        'eoc-on-call',
        'eoc-schedule',
        'eoc-edit-mode'
    ],
    editRotation: [
        'eoc-on-call',
        'eoc-schedule',
        'eoc-edit-mode',
        'eoc-edit-rotation'
    ]
};

});

parcelRegister("d41OH", function(module, exports) {

$parcel$export(module.exports, "store", () => $2741f1ecf0967b1b$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "Container", () => $2741f1ecf0967b1b$export$42a852a2b6b56249);
$parcel$export(module.exports, "Subscriber", () => $2741f1ecf0967b1b$export$60959659b2c22881);
$parcel$export(module.exports, "useActions", () => $2741f1ecf0967b1b$export$bc923229a7fa61e7);

var $hem2I = parcelRequire("hem2I");

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $6RRyp = parcelRequire("6RRyp");

var $lCzwW = parcelRequire("lCzwW");

var $5Tind = parcelRequire("5Tind");

var $lvPIw = parcelRequire("lvPIw");
const $2741f1ecf0967b1b$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $lvPIw.initialState,
    actions: $5Tind.actions
});
const $2741f1ecf0967b1b$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($2741f1ecf0967b1b$export$6f57813fe9f31bf9, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { data: schedulesResponse } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
            const schedules = (0, $lCzwW.getSafe)(()=>schedulesResponse.schedules, []);
            return {
                schedules: schedules
            };
        }
    })
});
// REFACTOR: We can create many different subscriber with selectors to avoid unnecessary rerenders
// See: https://atlassian.github.io/react-sweet-state/#/api/subscriber?id=example
const $2741f1ecf0967b1b$export$60959659b2c22881 = (0, $51nlc.createSubscriber)($2741f1ecf0967b1b$export$6f57813fe9f31bf9);
const $2741f1ecf0967b1b$export$6ccbb43953eebf8 = (0, $3sQ5x.createHook)($2741f1ecf0967b1b$export$6f57813fe9f31bf9);
const $2741f1ecf0967b1b$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($2741f1ecf0967b1b$export$6f57813fe9f31bf9);

});
parcelRegister("5Tind", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f2477f7988233508$export$e324594224ef24da);

var $kCCbe = parcelRequire("kCCbe");

var $lvPIw = parcelRequire("lvPIw");

var $lNHZW = parcelRequire("lNHZW");
const $f2477f7988233508$var$combine = (current, { id: id, replace: replace })=>replace ? current.slice(0, -1).concat([
        id
    ]) : current.concat([
        id
    ]);
const $f2477f7988233508$var$openCreateSchedule = ({ id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            isCreateScheduleOpen: true,
            createVariant: (0, $lNHZW.CreateVariant).Create,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openCloneSchedule = ({ schedule: schedule, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            isCreateScheduleOpen: true,
            createVariant: (0, $lNHZW.CreateVariant).Clone,
            activeSchedule: schedule,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openEditMode = ({ schedule: schedule, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            activeSchedule: schedule,
            isEditModeOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openTakeOnCall = ({ schedule: schedule, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            activeSchedule: schedule,
            isTakeOnCallOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openAddOverride = ({ schedule: schedule, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            activeSchedule: schedule,
            overrideVariant: (0, $lNHZW.OverrideVariant).Add,
            isAddOverrideOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openEditOverride = ({ override: override, context: context, id: id, replace: replace })=>({ setState: setState, getState: getState }, { schedules: schedules })=>{
        // TODO: add assertion
        const schedule = schedules.find(({ id: id })=>context.scheduleId === id);
        setState({
            activeSchedule: schedule,
            activeOverride: override,
            overrideVariant: (0, $lNHZW.OverrideVariant).Edit,
            isAddOverrideOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openRevertOverride = ({ override: override, context: context, id: id, replace: replace })=>({ setState: setState, getState: getState }, { schedules: schedules })=>{
        // TODO: add assertion
        const schedule = schedules.find(({ id: id })=>context.scheduleId === id);
        setState({
            activeSchedule: schedule,
            activeOverride: override,
            isRevertOverrideOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openCustomizeOverride = ({ override: override, context: context, id: id, replace: replace })=>({ setState: setState, getState: getState }, { schedules: schedules })=>{
        // TODO: add assertion
        const schedule = schedules.find(({ id: id })=>context.scheduleId === id);
        setState({
            activeSchedule: schedule,
            activeOverride: override,
            overrideVariant: (0, $lNHZW.OverrideVariant).Customize,
            isAddOverrideOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openDeleteSchedule = ({ schedule: schedule, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        if (schedule) setState({
            activeSchedule: schedule,
            isDeleteScheduleOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
        else setState({
            isDeleteScheduleOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openDeleteRotation = ({ rotation: rotation, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            activeRotation: rotation,
            isDeleteRotationOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$openDiscardChanges = ({ variant: variant, id: id, replace: replace })=>({ setState: setState, getState: getState })=>{
        setState({
            discardVariant: variant,
            isDiscardChangesOpen: true,
            sources: $f2477f7988233508$var$combine(getState().sources, {
                id: id,
                replace: replace
            })
        });
    };
const $f2477f7988233508$var$closePageModal = (modal)=>({ setState: setState })=>{
        switch(modal){
            case (0, $kCCbe.PageModalType).CreateSchedule:
                setState({
                    isCreateScheduleOpen: false,
                    createVariant: undefined,
                    activeSchedule: undefined
                });
                break;
            case (0, $kCCbe.PageModalType).AddOverride:
                setState({
                    isAddOverrideOpen: false,
                    activeSchedule: undefined,
                    overrideVariant: undefined,
                    activeOverride: undefined
                });
                break;
            case (0, $kCCbe.PageModalType).DeleteSchedule:
                setState({
                    isDeleteScheduleOpen: false
                });
                break;
            case (0, $kCCbe.PageModalType).DeleteRotation:
                setState({
                    isDeleteRotationOpen: false,
                    activeRotation: undefined
                });
                break;
            case (0, $kCCbe.PageModalType).DiscardChanges:
                setState({
                    isDiscardChangesOpen: false,
                    discardVariant: undefined
                });
                break;
            case (0, $kCCbe.PageModalType).EditMode:
                setState({
                    isEditModeOpen: false,
                    activeSchedule: undefined
                });
                break;
            case (0, $kCCbe.PageModalType).RevertOverride:
                setState({
                    isRevertOverrideOpen: false,
                    activeSchedule: undefined,
                    activeOverride: undefined
                });
                break;
            case (0, $kCCbe.PageModalType).TakeOnCall:
                setState({
                    isTakeOnCallOpen: false,
                    activeSchedule: undefined
                });
                break;
            default:
                setState((0, $lvPIw.initialState));
        }
    };
const $f2477f7988233508$var$focusSource = ()=>({ setState: setState, getState: getState })=>{
        const stack = [
            ...getState().sources
        ];
        const queue = stack.pop();
        if (queue) {
            if (Array.isArray(queue)) window.setTimeout((refs)=>{
                while(Array.isArray(refs) && refs.length > 0){
                    const id = refs.shift();
                    if (!id) continue;
                    const element = document.getElementById(id);
                    if (element && document.body.contains(element)) {
                        element.focus();
                        break;
                    }
                }
            }, 0, queue);
            else if (queue) window.setTimeout((id)=>{
                if (!id) return;
                const element = document.getElementById(id);
                if (element && document.body.contains(element)) element.focus();
            }, 0, queue);
        }
        setState({
            sources: stack
        });
    };
const $f2477f7988233508$export$e324594224ef24da = {
    closePageModal: $f2477f7988233508$var$closePageModal,
    focusSource: $f2477f7988233508$var$focusSource,
    openAddOverride: $f2477f7988233508$var$openAddOverride,
    openCreateSchedule: $f2477f7988233508$var$openCreateSchedule,
    openCloneSchedule: $f2477f7988233508$var$openCloneSchedule,
    openCustomizeOverride: $f2477f7988233508$var$openCustomizeOverride,
    openDeleteSchedule: $f2477f7988233508$var$openDeleteSchedule,
    openEditMode: $f2477f7988233508$var$openEditMode,
    openEditOverride: $f2477f7988233508$var$openEditOverride,
    openRevertOverride: $f2477f7988233508$var$openRevertOverride,
    openTakeOnCall: $f2477f7988233508$var$openTakeOnCall,
    openDeleteRotation: $f2477f7988233508$var$openDeleteRotation,
    openDiscardChanges: $f2477f7988233508$var$openDiscardChanges
};

});
parcelRegister("kCCbe", function(module, exports) {

$parcel$export(module.exports, "LayerTypes", () => $cfe1099ef1e0af51$export$5ffa1bccf2593c64);
$parcel$export(module.exports, "ShiftStatus", () => $cfe1099ef1e0af51$export$a99e0dd4ead620e);
$parcel$export(module.exports, "ShiftAction", () => $cfe1099ef1e0af51$export$e9c3228f4957bd42);
$parcel$export(module.exports, "PageModalType", () => $cfe1099ef1e0af51$export$753302fc2411e46);
$parcel$export(module.exports, "Scope", () => $cfe1099ef1e0af51$export$775b6bb06e53a214);
$parcel$export(module.exports, "TimingType", () => $cfe1099ef1e0af51$export$83fa51b329d2275b);
$parcel$export(module.exports, "ShiftFrequency", () => $cfe1099ef1e0af51$export$3d1d54199b3126b8);
$parcel$export(module.exports, "RotationType", () => $cfe1099ef1e0af51$export$91397be43fc980cc);
var $cfe1099ef1e0af51$export$5ffa1bccf2593c64 = /*#__PURE__*/ function(LayerTypes) {
    LayerTypes["BaseLayer"] = "defaultLayers";
    LayerTypes["OverrideLayer"] = "overrideLayers";
    LayerTypes["ForwardingLayer"] = "forwardingLayers";
    LayerTypes["FinalLayer"] = "finalLayers";
    return LayerTypes;
}({});
var $cfe1099ef1e0af51$export$a99e0dd4ead620e = /*#__PURE__*/ function(ShiftStatus) {
    ShiftStatus["Default"] = "default";
    ShiftStatus["Multi"] = "multi";
    ShiftStatus["MultiQuickOverride"] = "multi-quick-override";
    ShiftStatus["Single"] = "single";
    ShiftStatus["SingleViewOnly"] = "single-view-only";
    ShiftStatus["SingleOverriden"] = "single-overriden";
    ShiftStatus["SingleQuickOverride"] = "single-quick-override";
    return ShiftStatus;
}({});
var $cfe1099ef1e0af51$export$e9c3228f4957bd42 = /*#__PURE__*/ function(ShiftAction) {
    ShiftAction["AddOverride"] = "add-override";
    ShiftAction["Cancel"] = "cancel";
    return ShiftAction;
}({});
var $cfe1099ef1e0af51$export$753302fc2411e46 = /*#__PURE__*/ function(PageModalType) {
    PageModalType["EditMode"] = "edit-mode";
    PageModalType["TakeOnCall"] = "take-on-call";
    PageModalType["AddOverride"] = "add-override";
    PageModalType["RevertOverride"] = "revert-override";
    PageModalType["DeleteSchedule"] = "delete-schedule";
    PageModalType["CreateSchedule"] = "create-schedule";
    PageModalType["DeleteRotation"] = "delete-rotation";
    PageModalType["DiscardChanges"] = "discard-changes";
    return PageModalType;
}({});
var $cfe1099ef1e0af51$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Edit"] = "edit";
    return Scope;
}({});
var $cfe1099ef1e0af51$export$83fa51b329d2275b = /*#__PURE__*/ function(TimingType) {
    TimingType["Everday"] = "everyday";
    TimingType["Customday"] = "customday";
    return TimingType;
}({});
var $cfe1099ef1e0af51$export$3d1d54199b3126b8 = /*#__PURE__*/ function(ShiftFrequency) {
    ShiftFrequency["Daily"] = "daily";
    ShiftFrequency["Weekly"] = "weekly";
    ShiftFrequency["Custom"] = "custom";
    return ShiftFrequency;
}({});
var $cfe1099ef1e0af51$export$91397be43fc980cc = /*#__PURE__*/ function(RotationType) {
    RotationType["DAILY"] = "daily";
    RotationType["WEEKLY"] = "weekly";
    RotationType["HOURLY"] = "hourly";
    RotationType["INVALID"] = "invalid";
    return RotationType;
}({});

});

parcelRegister("lvPIw", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $8e6fc45c4f0da6f3$export$d4c72bab9d6cc13a);
const $8e6fc45c4f0da6f3$export$d4c72bab9d6cc13a = {
    activeSchedule: undefined,
    activeOverride: undefined,
    activeRotation: undefined,
    createVariant: undefined,
    overrideVariant: undefined,
    discardVariant: undefined,
    sources: [],
    isEditModeOpen: false,
    isTakeOnCallOpen: false,
    isAddOverrideOpen: false,
    isRevertOverrideOpen: false,
    isDeleteScheduleOpen: false,
    isCreateScheduleOpen: false,
    isDeleteRotationOpen: false,
    isDiscardChangesOpen: false
};

});

parcelRegister("lNHZW", function(module, exports) {

$parcel$export(module.exports, "OverrideVariant", () => $ca48fc14ea187184$export$88223c93483ae6b1);
$parcel$export(module.exports, "DiscardVariant", () => $ca48fc14ea187184$export$43a996b4e70cc5);
$parcel$export(module.exports, "CreateVariant", () => $ca48fc14ea187184$export$caa59baf87824b13);
var $ca48fc14ea187184$export$88223c93483ae6b1 = /*#__PURE__*/ function(OverrideVariant) {
    OverrideVariant[OverrideVariant["Add"] = 1] = "Add";
    OverrideVariant[OverrideVariant["Edit"] = 2] = "Edit";
    OverrideVariant[OverrideVariant["Customize"] = 3] = "Customize";
    return OverrideVariant;
}({});
var $ca48fc14ea187184$export$43a996b4e70cc5 = /*#__PURE__*/ function(DiscardVariant) {
    DiscardVariant[DiscardVariant["Discard"] = 1] = "Discard";
    DiscardVariant[DiscardVariant["Close"] = 2] = "Close";
    return DiscardVariant;
}({});
var $ca48fc14ea187184$export$caa59baf87824b13 = /*#__PURE__*/ function(CreateVariant) {
    CreateVariant[CreateVariant["Create"] = 1] = "Create";
    CreateVariant[CreateVariant["Clone"] = 2] = "Clone";
    return CreateVariant;
}({});

});



parcelRegister("dTe1P", function(module, exports) {

$parcel$export(module.exports, "useActions", () => $f8ea6fffd44e23e8$export$bc923229a7fa61e7);
$parcel$export(module.exports, "Container", () => $f8ea6fffd44e23e8$export$42a852a2b6b56249);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $9T6pk = parcelRequire("9T6pk");

var $3Xifg = parcelRequire("3Xifg");

var $kZTk4 = parcelRequire("kZTk4");
const $f8ea6fffd44e23e8$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $kZTk4.initialState,
    actions: $3Xifg.actions
});
const $f8ea6fffd44e23e8$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($f8ea6fffd44e23e8$export$6f57813fe9f31bf9);
const $f8ea6fffd44e23e8$export$6ccbb43953eebf8 = (0, $3sQ5x.createHook)($f8ea6fffd44e23e8$export$6f57813fe9f31bf9);
const $f8ea6fffd44e23e8$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($f8ea6fffd44e23e8$export$6f57813fe9f31bf9, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useContainerHook: ()=>{
            const { init: init } = $f8ea6fffd44e23e8$export$bc923229a7fa61e7();
            const { schedulePreferences: schedulePreferences, schedulesCollapsed: schedulesCollapsed } = (0, $9T6pk.useUiPreferences)();
            (0, $5uXOq.useEffect)(()=>{
                init(schedulesCollapsed, schedulePreferences);
            }, [
                init,
                schedulePreferences,
                schedulesCollapsed
            ]);
        }
    })
});

});
parcelRegister("9T6pk", function(module, exports) {

$parcel$export(module.exports, "useUiPreferences", () => $c15ac9ad5011a375$export$d3aab33c7c2e65f2);
$parcel$export(module.exports, "useSectionUiPreferences", () => $c15ac9ad5011a375$export$cdd69a2084e0ef5c);
$parcel$export(module.exports, "useOrderUiPreference", () => $c15ac9ad5011a375$export$ecd0407d06c0d15f);
$parcel$export(module.exports, "useCollapseUiPreference", () => $c15ac9ad5011a375$export$95cc5dd6b877c69f);
$parcel$export(module.exports, "useLayersUiPreference", () => $c15ac9ad5011a375$export$95cb1394c8986cf1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $jkGAf = parcelRequire("jkGAf");

var $6FjDf = parcelRequire("6FjDf");

var $6RRyp = parcelRequire("6RRyp");

var $lCzwW = parcelRequire("lCzwW");

var $aHP8W = parcelRequire("aHP8W");

var $laTym = parcelRequire("laTym");

var $gTUJm = parcelRequire("gTUJm");
const $c15ac9ad5011a375$export$d3aab33c7c2e65f2 = ()=>{
    const { data: schedulesResponse } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { data: uiPreferences } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const schedules = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>schedulesResponse.schedules, []), [
        schedulesResponse
    ]);
    const schedulePreferences = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>uiPreferences.schedulePreferences, []), [
        uiPreferences
    ]);
    const allSchedulePreferences = (0, $5uXOq.useMemo)(()=>schedules.map(({ id: id })=>{
            const preference = schedulePreferences.find((schedulePreference)=>schedulePreference.id === id);
            return {
                id: id,
                collapsed: preference?.collapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.collapsed,
                showAllLayers: preference?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers
            };
        }), [
        schedulePreferences,
        schedules
    ]);
    const uiPreferencesWithDefaults = (0, $5uXOq.useMemo)(()=>({
            displayDensity: uiPreferences?.displayDensity ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).displayDensity,
            scheduleOrder: uiPreferences?.scheduleOrder ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).scheduleOrder,
            schedulesCollapsed: uiPreferences?.schedulesCollapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulesCollapsed,
            showGaps: uiPreferences?.showGaps ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).showGaps,
            schedulePreferences: allSchedulePreferences
        }), [
        allSchedulePreferences,
        uiPreferences?.displayDensity,
        uiPreferences?.scheduleOrder,
        uiPreferences?.schedulesCollapsed,
        uiPreferences?.showGaps
    ]);
    return uiPreferencesWithDefaults;
};
const $c15ac9ad5011a375$var$useUiPreferencesService = ()=>{
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const teamId = (0, $aHP8W.useTeamId)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const updatePreferences = (0, $5uXOq.useCallback)(async ({ key: key, value: value })=>{
        try {
            await (0, $6FjDf.endpoints).updateUiPreferences({
                teamId: teamId,
                key: key,
                value: value
            });
        } catch (error) {
            defaultCatch({
                id: 'useUiPreferencesService-updatePreferences',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $gTUJm.messages).updatePreferencesErrorTitle),
                        actions: [
                            {
                                content: intlApi.formatMessage((0, $jkGAf.messages).tryAgain),
                                onClick: ()=>updatePreferences({
                                        key: key,
                                        value: value
                                    })
                            }
                        ]
                    });
                }
            }, error);
        }
    }, [
        defaultCatch,
        flagApi,
        intlApi,
        teamId
    ]);
    return {
        updatePreferences: updatePreferences
    };
};
const $c15ac9ad5011a375$export$cdd69a2084e0ef5c = ()=>{
    const { data: uiPreferences, update: updateUiPreferencesResource } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { updatePreferences: updatePreferencesService } = $c15ac9ad5011a375$var$useUiPreferencesService();
    const partialUpdate = (0, $5uXOq.useCallback)(({ key: key, value: value })=>{
        updatePreferencesService({
            key: key,
            value: value
        });
        updateUiPreferencesResource((prev)=>({
                ...prev,
                [key]: value
            }));
    }, [
        updatePreferencesService,
        updateUiPreferencesResource
    ]);
    const displayDensity = (0, $5uXOq.useMemo)(()=>uiPreferences?.displayDensity ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).displayDensity, [
        uiPreferences?.displayDensity
    ]);
    const schedulesCollapsed = (0, $5uXOq.useMemo)(()=>uiPreferences?.schedulesCollapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulesCollapsed, [
        uiPreferences?.schedulesCollapsed
    ]);
    const scheduleOrder = (0, $5uXOq.useMemo)(()=>uiPreferences?.scheduleOrder ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).scheduleOrder, [
        uiPreferences?.scheduleOrder
    ]);
    return {
        partialUpdate: partialUpdate,
        displayDensity: displayDensity,
        scheduleOrder: scheduleOrder,
        schedulesCollapsed: schedulesCollapsed
    };
};
const $c15ac9ad5011a375$export$ecd0407d06c0d15f = ()=>{
    const { update: updateScheduleListResource } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { data: uiPreferences } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { updatePreferences: updatePreferences } = $c15ac9ad5011a375$var$useUiPreferencesService();
    const schedulePreferences = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>uiPreferences.schedulePreferences, []), [
        uiPreferences
    ]);
    const onDragEnd = (0, $5uXOq.useCallback)((reorderedSchedules)=>{
        updateScheduleListResource(()=>{
            return {
                schedules: reorderedSchedules
            };
        });
        updatePreferences({
            key: 'schedulePreferences',
            value: reorderedSchedules.map(({ id: id })=>{
                const preference = schedulePreferences.find((schedulePreference)=>schedulePreference.id === id);
                return {
                    id: id,
                    collapsed: preference?.collapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.collapsed,
                    showAllLayers: preference?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers
                };
            })
        });
    }, [
        schedulePreferences,
        updatePreferences,
        updateScheduleListResource
    ]);
    return {
        onDragEnd: onDragEnd
    };
};
const $c15ac9ad5011a375$export$95cc5dd6b877c69f = ({ id: id })=>{
    const { data: schedulesResponse } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { data: uiPreferences, update: updateUiPreferencesResource } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { updatePreferences: updatePreferences } = $c15ac9ad5011a375$var$useUiPreferencesService();
    const schedules = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>schedulesResponse.schedules, []), [
        schedulesResponse
    ]);
    const schedulePreferences = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>uiPreferences.schedulePreferences, []), [
        uiPreferences
    ]);
    const toggleCollapsePreference = (0, $5uXOq.useCallback)(()=>{
        const updatedPreferences = schedules.map(({ id: scheduleId })=>{
            const preference = schedulePreferences.find((schedulePreference)=>schedulePreference.id === scheduleId);
            return {
                id: scheduleId,
                collapsed: id === scheduleId ? !preference?.collapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.collapsed : preference?.collapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.collapsed,
                showAllLayers: preference?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers
            };
        });
        updateUiPreferencesResource((prev)=>{
            return {
                ...prev,
                schedulePreferences: updatedPreferences
            };
        });
        updatePreferences({
            key: 'schedulePreferences',
            value: updatedPreferences
        });
    }, [
        id,
        schedulePreferences,
        schedules,
        updatePreferences,
        updateUiPreferencesResource
    ]);
    const isCollapsed = (0, $5uXOq.useMemo)(()=>schedulePreferences.find(({ id: scheduleId })=>scheduleId === id)?.collapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.collapsed, [
        id,
        schedulePreferences
    ]);
    return {
        toggleCollapsePreference: toggleCollapsePreference,
        isCollapsed: isCollapsed
    };
};
const $c15ac9ad5011a375$export$95cb1394c8986cf1 = ({ id: id })=>{
    const { data: schedulesResponse } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { data: uiPreferences, update: updateUiPreferencesResource } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { updatePreferences: updatePreferences } = $c15ac9ad5011a375$var$useUiPreferencesService();
    const schedules = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>schedulesResponse.schedules, []), [
        schedulesResponse
    ]);
    const schedulePreferences = (0, $5uXOq.useMemo)(()=>(0, $lCzwW.getSafe)(()=>uiPreferences.schedulePreferences, []), [
        uiPreferences
    ]);
    const toggleShowAllLayers = (0, $5uXOq.useCallback)(()=>{
        const updatedPreferences = schedules.map(({ id: scheduleId })=>{
            const preference = schedulePreferences.find((schedulePreference)=>schedulePreference.id === scheduleId);
            return {
                id: scheduleId,
                collapsed: preference?.collapsed ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.collapsed,
                showAllLayers: id === scheduleId ? !preference?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers : preference?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers
            };
        });
        updateUiPreferencesResource((prev)=>{
            return {
                ...prev,
                schedulePreferences: updatedPreferences
            };
        });
        updatePreferences({
            key: 'schedulePreferences',
            value: updatedPreferences
        });
    }, [
        id,
        schedulePreferences,
        schedules,
        updatePreferences,
        updateUiPreferencesResource
    ]);
    const showAllLayers = (0, $5uXOq.useMemo)(()=>schedulePreferences.find(({ id: scheduleId })=>scheduleId === id)?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers, [
        id,
        schedulePreferences
    ]);
    return {
        toggleShowAllLayers: toggleShowAllLayers,
        showAllLayers: showAllLayers
    };
};

});
parcelRegister("aHP8W", function(module, exports) {

$parcel$export(module.exports, "useTeamId", () => $46f8e8bd81d5fc26$export$398c0d27f0571d18);

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $8jH9Z = parcelRequire("8jH9Z");
/**
 * @returns Platform Team Id in the url.
 */ const $46f8e8bd81d5fc26$export$398c0d27f0571d18 = ()=>{
    const intlApi = (0, $koVbs.default)();
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    if (!teamId) throw new Error(intlApi.formatMessage((0, $8jH9Z.messages).teamIdError));
    return teamId;
};

});
parcelRegister("8jH9Z", function(module, exports) {

$parcel$export(module.exports, "messages", () => $68cadae0fc40909a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $68cadae0fc40909a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    teamIdError: {
        id: 'eoc-schedule.controllers.use-team-id.team-id-error',
        defaultMessage: 'Schedules cannot be used without a team, please check the path.',
        description: 'This message indicates schedule page is being rendered where team id does not exist, so schedule page fails to load.'
    }
});

});


parcelRegister("laTym", function(module, exports) {

$parcel$export(module.exports, "UI_PREFERENCES_DEFAULT_VALUES", () => $85348dce55f5e1a7$export$d250ff8c3f890593);
const $85348dce55f5e1a7$export$d250ff8c3f890593 = {
    displayDensity: 'slim',
    scheduleOrder: 'baseSchedule',
    schedulesCollapsed: false,
    showGaps: false,
    schedulePreferences: {
        collapsed: false,
        showAllLayers: false
    }
};

});

parcelRegister("gTUJm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bfb19d61fb58de92$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bfb19d61fb58de92$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    updatePreferencesErrorTitle: {
        id: 'eoc-schedule.controllers.preferences.update-preferences-error-title',
        defaultMessage: "We couldn't update your preferences.",
        description: 'This message indicates that our back-end services did not respond when changing schedule view.'
    }
});

});


parcelRegister("3Xifg", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e2879a4a57b3edc0$export$e324594224ef24da);
const $e2879a4a57b3edc0$var$init = (sectionCollapsed, schedulePreferences)=>({ setState: setState, getState: getState }, { onAllSchedulesReady: onAllSchedulesReady })=>{
        const status = getState().status;
        // Already initialized
        if (status === 'done' || status === 'terminated' || status === 'ready') return;
        // Main schedule is initially collapsed
        if (sectionCollapsed) {
            setState({
                status: 'terminated'
            });
            return;
        }
        // There are no schedules
        if (schedulePreferences.length === 0) {
            setState({
                status: 'terminated'
            });
            return;
        }
        // All schedules are initially collapsed
        if (schedulePreferences.every(({ collapsed: collapsed })=>collapsed)) {
            setState({
                status: 'done',
                schedules: schedulePreferences.reduce((acc, { id: id })=>({
                        [id]: true,
                        ...acc
                    }), {})
            });
            onAllSchedulesReady?.();
            return;
        }
        setState({
            status: 'ready',
            schedules: schedulePreferences.reduce((acc, { id: id, collapsed: collapsed })=>({
                    [id]: collapsed,
                    ...acc
                }), {})
        });
    };
const $e2879a4a57b3edc0$var$onScheduleReady = (scheduleId)=>({ setState: setState, getState: getState }, { onAllSchedulesReady: onAllSchedulesReady })=>{
        const status = getState().status;
        // Already finished or not initialized
        if (status === 'done' || status === 'terminated' || status === 'idle') return;
        const schedules = getState().schedules ?? {};
        if (schedules?.[scheduleId] === false) {
            schedules[scheduleId] = true;
            // All schedules are ready
            if (Object.keys(schedules).every((scheduleId)=>schedules[scheduleId] === true)) {
                setState({
                    schedules: schedules,
                    status: 'done'
                });
                onAllSchedulesReady?.();
                return;
            }
            setState({
                schedules: schedules
            });
        }
    };
const $e2879a4a57b3edc0$export$e324594224ef24da = {
    init: $e2879a4a57b3edc0$var$init,
    onScheduleReady: $e2879a4a57b3edc0$var$onScheduleReady
};

});

parcelRegister("kZTk4", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $0e43f45d0ef69126$export$d4c72bab9d6cc13a);
const $0e43f45d0ef69126$export$d4c72bab9d6cc13a = {
    schedules: null,
    status: 'idle'
};

});


parcelRegister("bPR4Q", function(module, exports) {

$parcel$export(module.exports, "List", () => $bf953c162b034d3f$export$54c2e3dc7acea9f5);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $1R1Ge = parcelRequire("1R1Ge");
var $i8Qvm = parcelRequire("i8Qvm");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $cgL5K = parcelRequire("cgL5K");

var $c9zAO = parcelRequire("c9zAO");

var $dcaj2 = parcelRequire("dcaj2");

var $hem2I = parcelRequire("hem2I");

var $k97LS = parcelRequire("k97LS");

var $5sA4Z = parcelRequire("5sA4Z");

var $j0DLp = parcelRequire("j0DLp");

var $aSTVt = parcelRequire("aSTVt");

var $kCCbe = parcelRequire("kCCbe");

var $hzEDn = parcelRequire("hzEDn");

var $d41OH = parcelRequire("d41OH");

var $9T6pk = parcelRequire("9T6pk");

var $9It5A = parcelRequire("9It5A");

var $6RRyp = parcelRequire("6RRyp");

var $lCzwW = parcelRequire("lCzwW");

var $d2kfz = parcelRequire("d2kfz");

var $gKAPA = parcelRequire("gKAPA");

var $i2ZmL = parcelRequire("i2ZmL");

var $4eQ1P = parcelRequire("4eQ1P");

var $uz971 = parcelRequire("uz971");

var $k3iuD = parcelRequire("k3iuD");

var $b3zjN = parcelRequire("b3zjN");

var $36xgB = parcelRequire("36xgB");

var $4B2j7 = parcelRequire("4B2j7");

var $h40Qo = parcelRequire("h40Qo");

var $jVWA4 = parcelRequire("jVWA4");
const $bf953c162b034d3f$export$54c2e3dc7acea9f5 = ()=>{
    const intlApi = (0, $koVbs.default)();
    const { openCreateSchedule: openCreateSchedule } = (0, $d41OH.useActions)();
    const { trigger: trigger } = (0, $j0DLp.useActions)();
    const { data: scheduleRights } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const { data: schedulesResponse } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const schedules = (0, $lCzwW.getSafe)(()=>schedulesResponse.schedules, []);
    const { onDragEnd: onDragEnd } = (0, $9T6pk.useOrderUiPreference)();
    (0, $k97LS.useMonitorRuleCards)({
        droppableId: 'schedules',
        data: schedules,
        onComplete: ({ updatedValue: updatedValue })=>onDragEnd(updatedValue)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $lCzwW.isEmpty)(schedules) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3iuD.EmptyImage), null),
        imageHeight: 160,
        imageWidth: 160,
        header: intlApi.formatMessage((0, $b3zjN.messages).yourTeamSchedulesAppear),
        description: scheduleRights?.hasEditRight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $b3zjN.messages).startBuildingSchedules), " ") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $b3zjN.messages).seeOnCallOnceAdmin), " "),
        primaryAction: scheduleRights?.hasEditRight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            id: "empty-state-create-schedule-button",
            appearance: "primary",
            onClick: ()=>openCreateSchedule({
                    id: [
                        'empty-state-create-schedule-button',
                        'create-schedule-button'
                    ]
                })
        }, intlApi.formatMessage((0, $b3zjN.messages).addSchedule)) : undefined,
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcaj2.IPHLink), {
            id: "on-call-schedules-empty-state",
            requiresDot: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            weight: "bold"
        }, intlApi.formatMessage((0, $b3zjN.messages).readMoreAboutSchedules)))
    }), !(0, $lCzwW.isEmpty)(schedules) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h40Qo.ScheduleContainer), null, schedules.map((schedule, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            key: schedule.id,
            scope: schedule.id,
            schedule: schedule
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sA4Z.Wrap), {
            within: (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                    name: (0, $aSTVt.SPOTLIGHT_NAMES).firstSchedule
                }, e),
            when: index === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4B2j7.Schedule), {
            index: index
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d41OH.Subscriber), null, ({ activeSchedule: // NOTE: might be able to set active schedule internally, schedule id might be sufficent
    activeSchedule, activeOverride: activeOverride, activeRotation: activeRotation, discardVariant: discardVariant, overrideVariant: overrideVariant, isEditModeOpen: isEditModeOpen, isTakeOnCallOpen: isTakeOnCallOpen, isAddOverrideOpen: isAddOverrideOpen, isDeleteScheduleOpen: isDeleteScheduleOpen, isRevertOverrideOpen: isRevertOverrideOpen, isDeleteRotationOpen: isDeleteRotationOpen, isDiscardChangesOpen: isDiscardChangesOpen }, { closePageModal: closePageModal, focusSource: focusSource })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9zAO.default), {
            // TODO: add close on escape
            isOpen: isEditModeOpen,
            onAnimationFinish: (transition)=>{
                if (transition === 'entering') trigger((0, $aSTVt.SPOTLIGHT_TOURS).rotationList);
                if (transition === 'exiting') focusSource();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            // WARNING: Shouldn't have to use "find" here
            scope: (0, $kCCbe.Scope).Edit,
            schedule: schedules.find(({ id: id })=>id === activeSchedule?.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzEDn.Container), {
            scope: (0, $kCCbe.Scope).Edit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $uz971.EditSchedule), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isTakeOnCallOpen && activeSchedule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            autoFocus: true,
            onCloseComplete: focusSource,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).TakeOnCall),
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            scope: activeSchedule.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVWA4.TakeOnCall), {
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).TakeOnCall)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isRevertOverrideOpen && activeSchedule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            autoFocus: true,
            onCloseComplete: focusSource,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).RevertOverride),
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            scope: activeSchedule.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $36xgB.RevertOverride), {
            alias: activeOverride.alias,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).RevertOverride)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isAddOverrideOpen && overrideVariant && activeSchedule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            autoFocus: true,
            onCloseComplete: focusSource,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).AddOverride),
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            scope: activeSchedule.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d2kfz.AddOverride), {
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).AddOverride),
            baseOverride: activeOverride,
            variant: overrideVariant
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isDeleteScheduleOpen && activeSchedule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            autoFocus: true,
            onCloseComplete: focusSource,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).DeleteSchedule),
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            scope: activeSchedule.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2ZmL.DeleteSchedule), {
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).DeleteSchedule)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isEditModeOpen && isDeleteRotationOpen && activeSchedule && activeRotation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            autoFocus: true,
            onCloseComplete: focusSource,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).DeleteRotation),
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            scope: (0, $kCCbe.Scope).Edit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzEDn.Container), {
            scope: (0, $kCCbe.Scope).Edit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gKAPA.DeleteRotation), {
            baseRotation: activeRotation,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).DeleteRotation)
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isEditModeOpen && isDiscardChangesOpen && activeSchedule && discardVariant && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
            autoFocus: true,
            onCloseComplete: focusSource,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).DiscardChanges),
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9It5A.Container), {
            scope: (0, $kCCbe.Scope).Edit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzEDn.Container), {
            scope: (0, $kCCbe.Scope).Edit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eQ1P.DiscardChanges), {
            variant: discardVariant,
            onClose: ()=>closePageModal((0, $kCCbe.PageModalType).DiscardChanges)
        }))))))));
};

});
parcelRegister("c9zAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcb38b620190310$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $k8nZq = parcelRequire("k8nZq");

var $hwd6J = parcelRequire("hwd6J");
const $7dcb38b620190310$var$FocusState = ({ isOpen: isOpen, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8nZq.default), {
        zIndex: "unset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwd6J.Wrapper), props)));
var $7dcb38b620190310$export$2e2bcd8739ae039 = $7dcb38b620190310$var$FocusState;

});
parcelRegister("hwd6J", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $827b078dcb836503$export$e6dfd72ab29f8598);

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $9ZKDH = parcelRequire("9ZKDH");

var $2alJM = parcelRequire("2alJM");

var $SliG5 = parcelRequire("SliG5");

var $8Sbj3 = parcelRequire("8Sbj3");

var $VSDnB = parcelRequire("VSDnB");

var $j8GHK = parcelRequire("j8GHK");
const $827b078dcb836503$export$e6dfd72ab29f8598 = ({ children: children, onAnimationFinish: onAnimationFinish, autoFocus: autoFocus = false, whiteList: whiteList, returnFocusRef: returnFocusRef, returnFocus: returnFocus, onDeactivation: onDeactivation, label: label, titleId: titleId })=>{
    const FocusLock = (0, $VSDnB.fg)('platform_dst_modal-dialog-bump-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const accessibilityAttributes = {
        role: 'dialog',
        'aria-modal': true,
        'aria-label': label,
        'aria-labelledby': titleId
    };
    (0, $SliG5.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Sbj3.default), {
        enterFrom: "left",
        exitTo: "left",
        fade: "in",
        duration: 500,
        onFinish: onAnimationFinish
    }, (slideInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FocusLock, {
            returnFocus: returnFocus,
            autoFocus: autoFocusLock,
            onDeactivation: (args)=>{
                if (!!returnFocusRef) window.setTimeout(()=>{
                    returnFocusRef.current?.focus();
                }, 0);
                onDeactivation?.(args);
            },
            whiteList: (element)=>{
                if (element.role === 'alert') return false; // False means it will not be controlled by the focus
                return !!whiteList ? whiteList(element) : true;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8GHK.Container), {
            ...slideInProps,
            ...accessibilityAttributes,
            tabIndex: -1
        }, children))));
};

});
parcelRegister("9ZKDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $746dfd2d0cf51cd7$export$2e2bcd8739ae039);

var $6PeDP = parcelRequire("6PeDP");

var $746dfd2d0cf51cd7$export$2e2bcd8739ae039 = (0, $6PeDP.default);

});
parcelRegister("6PeDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f82dcf8634374b5$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ahD4b = parcelRequire("ahD4b");

var $b2m1U = parcelRequire("b2m1U");
var $4f82dcf8634374b5$var$FocusLockCombination = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $ahD4b.default), (0, $bS32t.default)({
        sideCar: (0, $b2m1U.default),
        ref: ref
    }, props));
});
var $4f82dcf8634374b5$var$_ref = (0, $ahD4b.default).propTypes || {}, $4f82dcf8634374b5$var$sideCar = $4f82dcf8634374b5$var$_ref.sideCar, $4f82dcf8634374b5$var$propTypes = (0, $ddEsc.default)($4f82dcf8634374b5$var$_ref, [
    "sideCar"
]);
$4f82dcf8634374b5$var$FocusLockCombination.propTypes = {};
var $4f82dcf8634374b5$export$2e2bcd8739ae039 = $4f82dcf8634374b5$var$FocusLockCombination;

});
parcelRegister("ahD4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c9cbb18a82bf09$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");


var $26Cgu = parcelRequire("26Cgu");

var $3Du7S = parcelRequire("3Du7S");

var $i9hEi = parcelRequire("i9hEi");

var $bBdTc = parcelRequire("bBdTc");

var $qUTzN = parcelRequire("qUTzN");
var $77c9cbb18a82bf09$var$emptyArray = [];
var $77c9cbb18a82bf09$var$FocusLock = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $5uXOq.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $5uXOq.useRef();
    var isActive = $5uXOq.useRef(false);
    var originalFocusedElement = $5uXOq.useRef(null);
    var _React$useState2 = $5uXOq.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $77c9cbb18a82bf09$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $5uXOq.useState({}), id = _React$useState3[0];
    var onActivation = $5uXOq.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $5uXOq.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $5uXOq.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $5uXOq.useCallback(function(event) {
        if (isActive.current) (0, $bBdTc.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $bBdTc.mediumBlur).useMedium;
    var setObserveNode = $5uXOq.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $bS32t.default)((_extends2 = {}, _extends2[$26Cgu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$26Cgu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3Du7S.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $5uXOq.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $i9hEi.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $i9hEi.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $5uXOq.createElement(SideCar, {
        id: id,
        sideCar: (0, $bBdTc.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ $5uXOq.createElement(Container, (0, $bS32t.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $5uXOq.createElement((0, $qUTzN.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $i9hEi.hiddenGuard)
    }));
});
$77c9cbb18a82bf09$var$FocusLock.propTypes = {};
var $77c9cbb18a82bf09$export$2e2bcd8739ae039 = $77c9cbb18a82bf09$var$FocusLock;

});
parcelRegister("i9hEi", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $d366c1f945d68088$export$b8c7b07253306600);

var $5uXOq = parcelRequire("5uXOq");

var $d366c1f945d68088$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $d366c1f945d68088$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $d366c1f945d68088$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $d366c1f945d68088$export$b8c7b07253306600
    }));
};
$d366c1f945d68088$var$InFocusGuard.propTypes = {};
var $d366c1f945d68088$export$2e2bcd8739ae039 = $d366c1f945d68088$var$InFocusGuard;

});

parcelRegister("bBdTc", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $871dec83c3926a0e$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $871dec83c3926a0e$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $871dec83c3926a0e$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $871dec83c3926a0e$export$892cbf28e5518020);

var $bzFTo = parcelRequire("bzFTo");
var $871dec83c3926a0e$export$5733e022b1d538cb = (0, $bzFTo.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $871dec83c3926a0e$export$b3e9a9312f73723c = (0, $bzFTo.createMedium)();
var $871dec83c3926a0e$export$3a1d52767cbc07b8 = (0, $bzFTo.createMedium)();
var $871dec83c3926a0e$export$892cbf28e5518020 = (0, $bzFTo.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("qUTzN", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $050e900ff3b78811$export$f5272e9b1168239c);

var $5uXOq = parcelRequire("5uXOq");
var $050e900ff3b78811$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("b2m1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $8090f8448316e203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $6mqio = parcelRequire("6mqio");

var $j4988 = parcelRequire("j4988");
var $2RQOj = parcelRequire("2RQOj");
var $1q0r0 = parcelRequire("1q0r0");
var $5x9g9 = parcelRequire("5x9g9");
var $jl7aa = parcelRequire("jl7aa");
var $l1lpg = parcelRequire("l1lpg");
var $cCk2L = parcelRequire("cCk2L");

var $e53ns = parcelRequire("e53ns");

var $bBdTc = parcelRequire("bBdTc");
var $8090f8448316e203$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $8090f8448316e203$var$isFreeFocus = function isFreeFocus() {
    return $8090f8448316e203$var$focusOnBody() || (0, $jl7aa.focusIsHidden)();
};
var $8090f8448316e203$var$lastActiveTrap = null;
var $8090f8448316e203$var$lastActiveFocus = null;
var $8090f8448316e203$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $8090f8448316e203$var$lastPortaledElement = null;
var $8090f8448316e203$var$focusWasOutsideWindow = false;
var $8090f8448316e203$var$windowFocused = false;
var $8090f8448316e203$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $8090f8448316e203$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($8090f8448316e203$var$lastActiveTrap.whiteList || $8090f8448316e203$var$defaultWhitelist)(activeElement);
};
var $8090f8448316e203$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $8090f8448316e203$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $8090f8448316e203$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $8090f8448316e203$var$lastPortaledElement && $8090f8448316e203$var$lastPortaledElement.portaledElement === element;
};
function $8090f8448316e203$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $8090f8448316e203$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($8090f8448316e203$var$focusWasOutsideWindow);
    return $8090f8448316e203$var$focusWasOutsideWindow === 'meanwhile';
};
var $8090f8448316e203$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $8090f8448316e203$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $8090f8448316e203$var$checkInHost(activeElement, area, area);
    });
};
var $8090f8448316e203$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $l1lpg.getFocusableNodes)(nodes, new Map());
};
var $8090f8448316e203$var$isNotFocusable = function isNotFocusable(node) {
    return !$8090f8448316e203$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $8090f8448316e203$var$activateTrap = function activateTrap() {
    var result = false;
    if ($8090f8448316e203$var$lastActiveTrap) {
        var _lastActiveTrap = $8090f8448316e203$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $8090f8448316e203$var$lastPortaledElement && $8090f8448316e203$var$lastPortaledElement.portaledElement;
        if ($8090f8448316e203$var$focusOnBody() && $8090f8448316e203$var$lastActiveFocus) {
            if (!document.body.contains($8090f8448316e203$var$lastActiveFocus) || $8090f8448316e203$var$isNotFocusable($8090f8448316e203$var$lastActiveFocus)) {
                $8090f8448316e203$var$lastActiveFocus = null;
                var newTarget = $8090f8448316e203$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $e53ns.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$8090f8448316e203$var$focusWasOutside(crossFrame) || !noFocusGuards || !$8090f8448316e203$var$lastActiveFocus || $8090f8448316e203$var$windowFocused) return false;
                var nodes = $8090f8448316e203$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $8090f8448316e203$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $8090f8448316e203$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$8090f8448316e203$var$isFreeFocus() || !$8090f8448316e203$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $5x9g9.focusInside)(workingArea) || activeElement && $8090f8448316e203$var$withinHost(activeElement, workingArea) || $8090f8448316e203$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$8090f8448316e203$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $cCk2L.moveFocusInside)(workingArea, $8090f8448316e203$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $8090f8448316e203$var$lastPortaledElement = {};
                        }
                    }
                    $8090f8448316e203$var$focusWasOutsideWindow = false;
                    $8090f8448316e203$var$lastActiveFocus = document && document.activeElement;
                    $8090f8448316e203$var$tryRestoreFocus = (0, $j4988.captureFocusRestore)($8090f8448316e203$var$lastActiveFocus);
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2RQOj.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $8090f8448316e203$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $8090f8448316e203$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $8090f8448316e203$var$onTrap = function onTrap(event) {
    if ($8090f8448316e203$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $8090f8448316e203$var$onBlur = function onBlur() {
    return (0, $e53ns.deferAction)($8090f8448316e203$var$activateTrap);
};
var $8090f8448316e203$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $8090f8448316e203$var$recordPortal(currentNode, source);
};
var $8090f8448316e203$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $8090f8448316e203$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        onBlur: $8090f8448316e203$var$onBlur,
        onFocus: $8090f8448316e203$var$onFocus
    }, children);
};
$8090f8448316e203$var$FocusTrap.propTypes = {};
var $8090f8448316e203$var$onWindowFocus = function onWindowFocus() {
    $8090f8448316e203$var$windowFocused = true;
};
var $8090f8448316e203$var$onWindowBlur = function onWindowBlur() {
    $8090f8448316e203$var$windowFocused = false;
    $8090f8448316e203$var$focusWasOutsideWindow = 'just';
    (0, $e53ns.deferAction)(function() {
        $8090f8448316e203$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $8090f8448316e203$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $8090f8448316e203$var$onTrap);
    document.addEventListener('focusout', $8090f8448316e203$var$onBlur);
    window.addEventListener('focus', $8090f8448316e203$var$onWindowFocus);
    window.addEventListener('blur', $8090f8448316e203$var$onWindowBlur);
};
var $8090f8448316e203$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $8090f8448316e203$var$onTrap);
    document.removeEventListener('focusout', $8090f8448316e203$var$onBlur);
    window.removeEventListener('focus', $8090f8448316e203$var$onWindowFocus);
    window.removeEventListener('blur', $8090f8448316e203$var$onWindowBlur);
};
function $8090f8448316e203$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $8090f8448316e203$var$focusLockAPI = {
    moveFocusInside: (0, $cCk2L.moveFocusInside),
    focusInside: (0, $5x9g9.focusInside),
    focusNextElement: (0, $1q0r0.focusNextElement),
    focusPrevElement: (0, $1q0r0.focusPrevElement),
    focusFirstElement: (0, $1q0r0.focusFirstElement),
    focusLastElement: (0, $1q0r0.focusLastElement),
    captureFocusRestore: (0, $j4988.captureFocusRestore)
};
function $8090f8448316e203$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$8090f8448316e203$var$lastActiveTrap) $8090f8448316e203$var$attachHandler();
    var lastTrap = $8090f8448316e203$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $8090f8448316e203$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $8090f8448316e203$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($8090f8448316e203$var$focusLockAPI);
        $8090f8448316e203$var$activateTrap(true);
        (0, $e53ns.deferAction)($8090f8448316e203$var$activateTrap);
    } else {
        $8090f8448316e203$var$detachHandler();
        $8090f8448316e203$var$lastActiveFocus = null;
    }
}
(0, $bBdTc.mediumFocus).assignSyncMedium($8090f8448316e203$var$onFocus);
(0, $bBdTc.mediumBlur).assignMedium($8090f8448316e203$var$onBlur);
(0, $bBdTc.mediumEffect).assignMedium(function(cb) {
    return cb($8090f8448316e203$var$focusLockAPI);
});
var $8090f8448316e203$export$2e2bcd8739ae039 = (0, $6mqio.default)($8090f8448316e203$var$reducePropsToState, $8090f8448316e203$var$handleStateChangeOnClient)($8090f8448316e203$var$FocusWatcher);

});
parcelRegister("e53ns", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $a40426fda9e67416$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $a40426fda9e67416$export$c613fed06e332533);
function $a40426fda9e67416$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $a40426fda9e67416$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $a40426fda9e67416$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("j8GHK", function(module, exports) {

$parcel$export(module.exports, "Container", () => $cef6782c660ceaff$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $cef6782c660ceaff$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fzto3r0"
})({
    position: 'fixed',
    display: 'flex',
    zIndex: (0, $k5uoT.layers).modal(),
    top: '0px',
    left: '0px',
    width: '100vw',
    height: '100vh',
    background: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    pointerEvents: 'initial'
});

});



parcelRegister("dcaj2", function(module, exports) {

$parcel$export(module.exports, "IPHLink", () => $0f1e1fb6194c43d2$export$8ca4cba792159c15);
$parcel$export(module.exports, "IPHAnchor", () => $0f1e1fb6194c43d2$export$207fbd0853777a20);

var $5uXOq = parcelRequire("5uXOq");

var $hDzhb = parcelRequire("hDzhb");

var $jhmo0 = parcelRequire("jhmo0");

var $cgL5K = parcelRequire("cgL5K");

var $5CSWr = parcelRequire("5CSWr");
const $0f1e1fb6194c43d2$export$8ca4cba792159c15 = ({ id: id, children: children, requiresDot: requiresDot, onClick: onClick, ...restProps })=>{
    const { handleClick: handleClick } = (0, $5CSWr.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        onClick: (event)=>{
            event.preventDefault();
            onClick?.(event);
            handleClick(id);
        },
        ...restProps
    }, children), requiresDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, "."));
};
const $0f1e1fb6194c43d2$export$207fbd0853777a20 = ({ id: id, children: children, requiresDot: requiresDot, onClick: onClick, ...restProps })=>{
    const { handleClick: handleClick } = (0, $5CSWr.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: "",
        onClick: (event, analytics)=>{
            event.preventDefault();
            onClick?.(event, analytics);
            handleClick(id);
        },
        ...restProps
    }, children), requiresDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, "."));
};

});

parcelRegister("5sA4Z", function(module, exports) {

$parcel$export(module.exports, "Wrap", () => $ab6b27815c4dbafa$export$f6b1e3902165e5e1);

var $5uXOq = parcelRequire("5uXOq");
const $ab6b27815c4dbafa$export$f6b1e3902165e5e1 = ({ when: when, within: within, children: children })=>when ? within(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("j0DLp", function(module, exports) {

$parcel$export(module.exports, "store", () => $42f797844235d74d$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useActions", () => $42f797844235d74d$export$bc923229a7fa61e7);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $hT0bn = parcelRequire("hT0bn");

var $dUvWt = parcelRequire("dUvWt");
const $42f797844235d74d$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $dUvWt.initialState,
    actions: $hT0bn.actions
});
const $42f797844235d74d$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($42f797844235d74d$export$6f57813fe9f31bf9);
const $42f797844235d74d$export$60959659b2c22881 = (0, $51nlc.createSubscriber)($42f797844235d74d$export$6f57813fe9f31bf9);
const $42f797844235d74d$export$6ccbb43953eebf8 = (0, $3sQ5x.createHook)($42f797844235d74d$export$6f57813fe9f31bf9);
const $42f797844235d74d$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($42f797844235d74d$export$6f57813fe9f31bf9);

});
parcelRegister("hT0bn", function(module, exports) {

$parcel$export(module.exports, "actions", () => $98110653bd04729e$export$e324594224ef24da);
const $98110653bd04729e$var$trigger = (id)=>({ setState: setState, getState: getState })=>{
        return setState({
            spotlights: {
                ...getState().spotlights,
                [id]: true
            }
        });
    };
const $98110653bd04729e$export$e324594224ef24da = {
    trigger: $98110653bd04729e$var$trigger
};

});

parcelRegister("dUvWt", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $bf14282f46f0140d$export$d4c72bab9d6cc13a);
const $bf14282f46f0140d$export$d4c72bab9d6cc13a = {
    spotlights: {}
};

});


parcelRegister("hzEDn", function(module, exports) {

$parcel$export(module.exports, "store", () => $60881c24024cd1bf$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useActions", () => $60881c24024cd1bf$export$bc923229a7fa61e7);
$parcel$export(module.exports, "Container", () => $60881c24024cd1bf$export$42a852a2b6b56249);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $9It5A = parcelRequire("9It5A");

var $gV29J = parcelRequire("gV29J");

var $3jFJc = parcelRequire("3jFJc");
const $60881c24024cd1bf$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $3jFJc.initialState,
    actions: $gV29J.actions
});
const $60881c24024cd1bf$export$6ccbb43953eebf8 = (0, $3sQ5x.createHook)($60881c24024cd1bf$export$6f57813fe9f31bf9);
const $60881c24024cd1bf$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($60881c24024cd1bf$export$6f57813fe9f31bf9);
const $60881c24024cd1bf$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($60881c24024cd1bf$export$6f57813fe9f31bf9, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { setRotationAction: setRotationAction } = (0, $9It5A.useActions)();
            return {
                setRotationAction: setRotationAction
            };
        }
    })
});
const $60881c24024cd1bf$export$60959659b2c22881 = (0, $51nlc.createSubscriber)($60881c24024cd1bf$export$6f57813fe9f31bf9);

});
parcelRegister("9It5A", function(module, exports) {

$parcel$export(module.exports, "store", () => $3aa82895718c14d5$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useStore", () => $3aa82895718c14d5$export$6ccbb43953eebf8);
$parcel$export(module.exports, "useActions", () => $3aa82895718c14d5$export$bc923229a7fa61e7);
$parcel$export(module.exports, "Container", () => $3aa82895718c14d5$export$42a852a2b6b56249);

var $ajpes = parcelRequire("ajpes");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $2VYEV = parcelRequire("2VYEV");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $2tKfK = parcelRequire("2tKfK");

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $jOikx = parcelRequire("jOikx");

var $lCzwW = parcelRequire("lCzwW");

var $d41OH = parcelRequire("d41OH");

var $cFenU = parcelRequire("cFenU");

var $c9DPK = parcelRequire("c9DPK");
const $3aa82895718c14d5$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $c9DPK.initialState,
    actions: $cFenU.actions
});
const $3aa82895718c14d5$export$6ccbb43953eebf8 = (0, $3sQ5x.createHook)($3aa82895718c14d5$export$6f57813fe9f31bf9);
const $3aa82895718c14d5$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($3aa82895718c14d5$export$6f57813fe9f31bf9);
const $3aa82895718c14d5$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($3aa82895718c14d5$export$6f57813fe9f31bf9, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const flagApi = (0, $2tKfK.default)();
            const intlApi = (0, $koVbs.default)();
            const { closePageModal: closePageModal } = (0, $d41OH.useActions)();
            const defaultCatch = (0, $2VYEV.useDefaultCatch)();
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
            return {
                flagApi: flagApi,
                intlApi: intlApi,
                closePageModal: closePageModal,
                defaultCatch: defaultCatch,
                createAnalyticsEvent: createAnalyticsEvent
            };
        }
    }),
    onInit: ()=>({ setState: setState, dispatch: dispatch, getState: getState }, { schedule: schedule })=>{
            // If not initialized before
            if (getState().schedule === undefined) {
                setState({
                    schedule: schedule,
                    currentDate: (0, $jOikx.zoned).midOfDay(new Date(), schedule.timezone)
                });
                (0, $hmVmJ.assert)(!(0, $lCzwW.isEmpty)(getState().schedule), new (0, $dH6Pi.AssertionError)('eoc-schedule', 'schedule-store: schedule is not defined'));
                dispatch((0, $cFenU.actions).getTimelineAction());
            }
        },
    onUpdate: ()=>({ setState: setState, dispatch: dispatch, getState: getState }, { schedule: schedule })=>{
            // Either timezone, name, description, enabled is changed
            // TODO: update schedule store instead of team schedule list resource
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(getState().schedule, schedule) && !(0, $lCzwW.isEmpty)(schedule)) {
                const timezone = getState().schedule.timezone;
                const utcTimeOffsetMillis = getState().schedule.utcTimeOffsetMillis;
                setState({
                    schedule: schedule
                });
                if (timezone !== schedule.timezone || utcTimeOffsetMillis !== schedule.utcTimeOffsetMillis) dispatch((0, $cFenU.actions).getTimelineAction());
            }
        }
});
const $3aa82895718c14d5$export$60959659b2c22881 = (0, $51nlc.createSubscriber)($3aa82895718c14d5$export$6f57813fe9f31bf9);

});
parcelRegister("jOikx", function(module, exports) {

$parcel$export(module.exports, "guessTimeZone", () => $2bc691b3b5f8a42e$export$c333b33f2586074c);
$parcel$export(module.exports, "getTimezoneOffsetDiff", () => $2bc691b3b5f8a42e$export$f7e6998e4242dc64);
$parcel$export(module.exports, "formatTimezone", () => $2bc691b3b5f8a42e$export$26da7aa151b6684c);
$parcel$export(module.exports, "formatting", () => $2bc691b3b5f8a42e$export$e8eb56737f1ebbe8);
$parcel$export(module.exports, "partitionDate", () => $2bc691b3b5f8a42e$export$6943f6d465e2abc1);
$parcel$export(module.exports, "conversion", () => $2bc691b3b5f8a42e$export$b7c27b346f5e5e21);
$parcel$export(module.exports, "zoned", () => $2bc691b3b5f8a42e$export$5641f8d0fec558ce);

var $dyJ0D = parcelRequire("dyJ0D");

var $2f6j1 = parcelRequire("2f6j1");

var $ifLRl = parcelRequire("ifLRl");

var $5Ppij = parcelRequire("5Ppij");

var $bSkeG = parcelRequire("bSkeG");

var $gwejS = parcelRequire("gwejS");

var $3DR3e = parcelRequire("3DR3e");

var $16v6W = parcelRequire("16v6W");

var $jj52j = parcelRequire("jj52j");

var $94UJE = parcelRequire("94UJE");

var $1GF3c = parcelRequire("1GF3c");

var $pyK8a = parcelRequire("pyK8a");

var $kAAot = parcelRequire("kAAot");

var $4PxOH = parcelRequire("4PxOH");
const $2bc691b3b5f8a42e$var$HOUR_MILLIS = 3600000;
const $2bc691b3b5f8a42e$var$MINUTE_MILLIS = 60000;
const $2bc691b3b5f8a42e$var$HOUR_MINUTES = 60;
const $2bc691b3b5f8a42e$export$c333b33f2586074c = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone;
const $2bc691b3b5f8a42e$export$f7e6998e4242dc64 = (timezone, date)=>{
    const browserOffset = (0, $ifLRl.default)($2bc691b3b5f8a42e$export$c333b33f2586074c(), date);
    return typeof timezone === 'number' ? browserOffset - timezone : browserOffset - (0, $ifLRl.default)(timezone, date);
};
const $2bc691b3b5f8a42e$export$a52dc21079c7600 = (timezone, date)=>{
    const millis = typeof timezone === 'string' ? (0, $ifLRl.default)(timezone, date) : timezone;
    const sign = millis >= 0 ? '+' : '-';
    const abs = Math.abs(millis);
    const hours = Math.floor(abs / $2bc691b3b5f8a42e$var$HOUR_MILLIS);
    const minutes = Math.floor(abs / $2bc691b3b5f8a42e$var$MINUTE_MILLIS) % $2bc691b3b5f8a42e$var$HOUR_MINUTES;
    return sign + Math.abs(hours).toString().padStart(2, '0') + ':' + Math.abs(minutes).toString().padStart(2, '0');
};
const $2bc691b3b5f8a42e$export$26da7aa151b6684c = ({ name: name, offset: offset, variant: variant })=>{
    const timezone = name.replace(/_/g, ' ');
    const offsetString = $2bc691b3b5f8a42e$export$a52dc21079c7600(offset);
    switch(variant){
        case 'short':
            return `${timezone} (${offsetString})`;
        case 'long':
            return `${timezone} (UTC ${offsetString})`;
    }
};
const $2bc691b3b5f8a42e$export$3a0e5999dee698e6 = (epoch, offset)=>{
    return (0, $dyJ0D.default)(epoch, "yyyy-MM-dd'T'HH:mm") + $2bc691b3b5f8a42e$export$a52dc21079c7600(offset);
};
const $2bc691b3b5f8a42e$export$e8eb56737f1ebbe8 = {
    /**
	 * Formats date to date hour minute string
	 * @param date - Date | number
	 * @return time - string - Ex. '2024/08/21 08:00'
	 */ toDateHourMinute: (date)=>{
        if (typeof date === 'string') date = new Date(date);
        return (0, $dyJ0D.default)(date, 'yyyy/MM/dd HH:mm');
    },
    /**
	 * Formats date to ISO string
	 * @param date - Date | number
	 * @return time - string - Ex. '2024-08-21T08:00:00+00:00'
	 */ toISO: (date)=>{
        if (typeof date === 'string') date = new Date(date);
        return (0, $jj52j.default)(date);
    }
};
const $2bc691b3b5f8a42e$export$673d9c03888d3bd2 = (epoch, offset)=>{
    if (typeof offset === 'number') {
        const diff = $2bc691b3b5f8a42e$export$f7e6998e4242dc64(offset);
        return (0, $jj52j.default)((typeof epoch === 'number' ? epoch : new Date(epoch).valueOf()) - diff);
    }
    return (0, $2f6j1.default)((0, $5Ppij.default)(epoch, offset), $2bc691b3b5f8a42e$export$c333b33f2586074c(), "yyyy-MM-dd'T'HH:mmxxx");
};
const $2bc691b3b5f8a42e$export$ae56e508f818813c = (epoch, timezone)=>{
    return (0, $2f6j1.default)((0, $bSkeG.default)(epoch, timezone), timezone, "yyyy-MM-dd'T'HH:mmxxx");
};
const $2bc691b3b5f8a42e$export$6943f6d465e2abc1 = (date)=>{
    return {
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        month: date.getMonth(),
        year: date.getFullYear()
    };
};
const $2bc691b3b5f8a42e$export$3ea1dcd6f0a65c97 = ({ year: year, month: month, day: day, hour: hour, minute: minute, millis: millis }, timezone)=>{
    const utc = Date.UTC(year, month, day, hour, minute, millis);
    const local = new Date(year, month, day, hour, minute, millis);
    if (typeof timezone === 'string') return (0, $bSkeG.default)(local, timezone);
    return new Date(utc - timezone);
};
const $2bc691b3b5f8a42e$export$b7c27b346f5e5e21 = {
    /**
	 * Formats date to local timezone without changing nominal date.
	 * @warning Date must be in utc
	 * @example Browser: UTC +3:00, Remote: UTC +0:00 8:00  => UTC +3:00 8:00
	 * @example Browser: UTC +7:00, Remote: UTC -7:00 15:00 => UTC +7:00 15:00
	 */ toLocal: (date, timezone)=>{
        if (typeof timezone === 'string') return (0, $5Ppij.default)(date, timezone);
        return new Date((typeof date === 'number' ? date : date.valueOf()) - ((0, $ifLRl.default)($2bc691b3b5f8a42e$export$c333b33f2586074c(), date) - timezone));
    },
    /**
	 * Formats date to remote timezone without changing nominal date.
	 * @warning Date must be in utc
	 * @example Browser: UTC +3:00 8:00, Remote: UTC +0:00 => UTC +0:00 8:00
	 * @example Browser: UTC +7:00 15:00, Remote: UTC -7:00 => UTC -7:00 15:00
	 */ toRemote: (date, timezone)=>{
        if (typeof timezone === 'string') return (0, $bSkeG.default)(date, timezone);
        return new Date((typeof date === 'number' ? date : date.valueOf()) + ((0, $ifLRl.default)($2bc691b3b5f8a42e$export$c333b33f2586074c(), date) - timezone));
    }
};
const $2bc691b3b5f8a42e$export$5641f8d0fec558ce = {
    /** @description Set time to 12 o'clock in given timezone */ midOfDay: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const mid = $2bc691b3b5f8a42e$export$3ea1dcd6f0a65c97({
            year: input.getFullYear(),
            month: input.getMonth(),
            day: input.getDate(),
            hour: 12,
            minute: 0,
            millis: 0
        }, timezone);
        return mid;
    },
    /** @description Add day in given timezone */ nextDay: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const nextDay = (0, $gwejS.default)(input, 1);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(nextDay, timezone);
        return output;
    },
    /** @description Add week in given timezone */ nextWeek: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const nextWeek = (0, $16v6W.default)((0, $1GF3c.default)(input, {
            weekStartsOn: 1
        }), 1);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(nextWeek, timezone);
        return output;
    },
    /** @description Add two weeks in given timezone */ nextTwoWeeks: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const nextTwoWeeks = (0, $16v6W.default)((0, $1GF3c.default)(input, {
            weekStartsOn: 1
        }), 2);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(nextTwoWeeks, timezone);
        return output;
    },
    /** @description Add month in given timezone */ nextMonth: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const nextMonth = (0, $3DR3e.default)((0, $94UJE.default)(input), 1);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(nextMonth, timezone);
        return output;
    },
    /** @description Subtract day in given timezone */ previousDay: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const prevDay = (0, $pyK8a.default)(input, 1);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(prevDay, timezone);
        return output;
    },
    /** @description Subtract week in given timezone */ previousWeek: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const prevWeek = (0, $4PxOH.default)((0, $1GF3c.default)(input, {
            weekStartsOn: 1
        }), 1);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(prevWeek, timezone);
        return output;
    },
    /** @description Subtract two weeks in given timezone */ previousTwoWeeks: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const prevTwoWeeks = (0, $4PxOH.default)((0, $1GF3c.default)(input, {
            weekStartsOn: 1
        }), 2);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(prevTwoWeeks, timezone);
        return output;
    },
    /** @description Subtract month in given timezone */ previousMonth: (epoch, timezone)=>{
        const input = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toLocal(epoch, timezone);
        const prevMonth = (0, $kAAot.default)((0, $94UJE.default)(input), 1);
        const output = $2bc691b3b5f8a42e$export$b7c27b346f5e5e21.toRemote(prevMonth, timezone);
        return output;
    }
};

});
parcelRegister("dyJ0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df15d400c3831c4$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $gl2vg = parcelRequire("gl2vg");

var $cjNsf = parcelRequire("cjNsf");
var $9df15d400c3831c4$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $9df15d400c3831c4$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($9df15d400c3831c4$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $cjNsf.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $gl2vg.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("gl2vg", function(module, exports) {

$parcel$export(module.exports, "default", () => $be508c9fb2c68127$export$2e2bcd8739ae039);

var $bs9Vd = parcelRequire("bs9Vd");

var $lwdOT = parcelRequire("lwdOT");
var $be508c9fb2c68127$var$MILLISECONDS_IN_MINUTE = 60000;
var $be508c9fb2c68127$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $be508c9fb2c68127$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $be508c9fb2c68127$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $be508c9fb2c68127$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $be508c9fb2c68127$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $be508c9fb2c68127$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $be508c9fb2c68127$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $be508c9fb2c68127$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $be508c9fb2c68127$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $be508c9fb2c68127$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $be508c9fb2c68127$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $be508c9fb2c68127$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $bs9Vd.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $bs9Vd.default)('long', date, options);
        }
    }
};
function $be508c9fb2c68127$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $lwdOT.default)(timeZone, originalDate, true) / $be508c9fb2c68127$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $be508c9fb2c68127$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $be508c9fb2c68127$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $be508c9fb2c68127$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $be508c9fb2c68127$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $be508c9fb2c68127$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $be508c9fb2c68127$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $be508c9fb2c68127$var$formatTimezone(offset, dirtyDelimeter);
}
function $be508c9fb2c68127$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $be508c9fb2c68127$var$addLeadingZeros(minutes, 2);
}
var $be508c9fb2c68127$export$2e2bcd8739ae039 = $be508c9fb2c68127$var$formatters;

});
parcelRegister("bs9Vd", function(module, exports) {

$parcel$export(module.exports, "default", () => $856a017dd229ad51$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $856a017dd229ad51$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $856a017dd229ad51$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $856a017dd229ad51$var$partsTimeZone(dtf, date) : $856a017dd229ad51$var$hackyTimeZone(dtf, date);
}
function $856a017dd229ad51$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $856a017dd229ad51$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $856a017dd229ad51$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("lwdOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa74e776714d473$export$2e2bcd8739ae039);

var $81tKT = parcelRequire("81tKT");

var $gv6e6 = parcelRequire("gv6e6");
var $faa74e776714d473$var$MILLISECONDS_IN_HOUR = 3600000;
var $faa74e776714d473$var$MILLISECONDS_IN_MINUTE = 60000;
var $faa74e776714d473$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $faa74e776714d473$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $faa74e776714d473$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $faa74e776714d473$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$faa74e776714d473$var$validateTimezone(hours)) return NaN;
        return -(hours * $faa74e776714d473$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $faa74e776714d473$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$faa74e776714d473$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $faa74e776714d473$var$MILLISECONDS_IN_HOUR + minutes * $faa74e776714d473$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($faa74e776714d473$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $faa74e776714d473$var$toUtcDate(date);
        var offset = $faa74e776714d473$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $faa74e776714d473$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $faa74e776714d473$var$toUtcDate(date) {
    return (0, $gv6e6.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $faa74e776714d473$var$calcOffset(date, timezoneString) {
    var tokens = (0, $81tKT.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $gv6e6.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $faa74e776714d473$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $faa74e776714d473$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $faa74e776714d473$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $faa74e776714d473$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $faa74e776714d473$var$validIANATimezoneCache = {};
function $faa74e776714d473$var$isValidTimezoneIANAString(timeZoneString) {
    if ($faa74e776714d473$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $faa74e776714d473$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("81tKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d757f805ec2c399$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $5d757f805ec2c399$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $5d757f805ec2c399$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $5d757f805ec2c399$var$partsOffset(dtf, date) : $5d757f805ec2c399$var$hackyOffset(dtf, date);
}
var $5d757f805ec2c399$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $5d757f805ec2c399$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $5d757f805ec2c399$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $5d757f805ec2c399$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $5d757f805ec2c399$var$dtfCache = {};
function $5d757f805ec2c399$var$getDateTimeFormat(timeZone) {
    if (!$5d757f805ec2c399$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $5d757f805ec2c399$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $5d757f805ec2c399$var$dtfCache[timeZone];
}

});

parcelRegister("gv6e6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0345f0a655c41f8$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c0345f0a655c41f8$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("cjNsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7d9f0b358f43bf$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $lwdOT = parcelRequire("lwdOT");

var $TQPcz = parcelRequire("TQPcz");
var $8f7d9f0b358f43bf$var$MILLISECONDS_IN_HOUR = 3600000;
var $8f7d9f0b358f43bf$var$MILLISECONDS_IN_MINUTE = 60000;
var $8f7d9f0b358f43bf$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8f7d9f0b358f43bf$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $TQPcz.default)
};
function $8f7d9f0b358f43bf$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8f7d9f0b358f43bf$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8f7d9f0b358f43bf$var$splitDateString(argument);
    var parseYearResult = $8f7d9f0b358f43bf$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8f7d9f0b358f43bf$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8f7d9f0b358f43bf$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $lwdOT.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8f7d9f0b358f43bf$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8f7d9f0b358f43bf$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8f7d9f0b358f43bf$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8f7d9f0b358f43bf$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8f7d9f0b358f43bf$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8f7d9f0b358f43bf$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8f7d9f0b358f43bf$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8f7d9f0b358f43bf$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8f7d9f0b358f43bf$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8f7d9f0b358f43bf$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8f7d9f0b358f43bf$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8f7d9f0b358f43bf$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8f7d9f0b358f43bf$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8f7d9f0b358f43bf$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8f7d9f0b358f43bf$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8f7d9f0b358f43bf$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8f7d9f0b358f43bf$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8f7d9f0b358f43bf$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8f7d9f0b358f43bf$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8f7d9f0b358f43bf$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8f7d9f0b358f43bf$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8f7d9f0b358f43bf$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8f7d9f0b358f43bf$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8f7d9f0b358f43bf$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8f7d9f0b358f43bf$var$validateTime(hours)) return NaN;
        return hours % 24 * $8f7d9f0b358f43bf$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8f7d9f0b358f43bf$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8f7d9f0b358f43bf$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8f7d9f0b358f43bf$var$MILLISECONDS_IN_HOUR + minutes * $8f7d9f0b358f43bf$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8f7d9f0b358f43bf$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8f7d9f0b358f43bf$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8f7d9f0b358f43bf$var$MILLISECONDS_IN_HOUR + minutes * $8f7d9f0b358f43bf$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8f7d9f0b358f43bf$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8f7d9f0b358f43bf$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f7d9f0b358f43bf$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8f7d9f0b358f43bf$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8f7d9f0b358f43bf$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8f7d9f0b358f43bf$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8f7d9f0b358f43bf$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8f7d9f0b358f43bf$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8f7d9f0b358f43bf$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8f7d9f0b358f43bf$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8f7d9f0b358f43bf$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8f7d9f0b358f43bf$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("TQPcz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a7e1d1494afdee3$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $0a7e1d1494afdee3$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $0a7e1d1494afdee3$export$2e2bcd8739ae039 = $0a7e1d1494afdee3$var$tzPattern;

});



parcelRegister("2f6j1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a21dfa9a8e5a967$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $dyJ0D = parcelRequire("dyJ0D");

var $5Ppij = parcelRequire("5Ppij");
function $1a21dfa9a8e5a967$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $dyJ0D.default)((0, $5Ppij.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("5Ppij", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e5561acca4ee24$export$2e2bcd8739ae039);

var $lwdOT = parcelRequire("lwdOT");

var $cjNsf = parcelRequire("cjNsf");
function $43e5561acca4ee24$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $cjNsf.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $lwdOT.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("ifLRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d49ec091eba6dc49$export$2e2bcd8739ae039);

var $lwdOT = parcelRequire("lwdOT");
function $d49ec091eba6dc49$export$2e2bcd8739ae039(timeZone, date) {
    return -(0, $lwdOT.default)(timeZone, date);
}

});

parcelRegister("bSkeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a546f3e5eaa91e9$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $cjNsf = parcelRequire("cjNsf");

var $TQPcz = parcelRequire("TQPcz");

var $lwdOT = parcelRequire("lwdOT");

var $gv6e6 = parcelRequire("gv6e6");
function $8a546f3e5eaa91e9$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $TQPcz.default))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $cjNsf.default)(date, extendedOptions);
    }
    var d = (0, $cjNsf.default)(date, options);
    var utc = (0, $gv6e6.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $lwdOT.default)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

});


parcelRegister("cFenU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b79c164d683c470d$export$e324594224ef24da);

var $jekok = parcelRequire("jekok");

var $h8yj2 = parcelRequire("h8yj2");

var $8eCQi = parcelRequire("8eCQi");

var $5s9eT = parcelRequire("5s9eT");
var $jOikx = parcelRequire("jOikx");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $dQNfh = parcelRequire("dQNfh");

var $lCzwW = parcelRequire("lCzwW");

var $11Uc3 = parcelRequire("11Uc3");

var $kRnku = parcelRequire("kRnku");
const $b79c164d683c470d$var$getTimelineAction = ()=>async ({ getState: getState, setState: setState }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        const { schedule: schedule, currentDate: currentDate, selectedView: selectedView, timelineType: timelineType, rotation: rotation } = getState();
        setState({
            getTimelineLoading: true
        });
        const formattedCurrent = (0, $jekok.default)(currentDate, 'UTC', "yyyy-MM-dd'T'HH:mmxxx");
        try {
            if (selectedView === (0, $5s9eT.NavigationMode).Timeline) {
                const response = await (0, $dQNfh.endpoints).getTimeline({
                    scheduleId: schedule.id,
                    currentDate: formattedCurrent,
                    mode: selectedView,
                    timelineType: timelineType,
                    ...!(0, $lCzwW.isEmpty)(rotation) && {
                        rotation: (0, $kRnku.fromRotationDetailToRotationPayload)(rotation)
                    }
                });
                setState({
                    timelineData: {
                        startEpoch: response.startTimeUtcMillis,
                        endEpoch: response.endTimeUtcMillis,
                        nowEpoch: response.currentTime,
                        startOffset: response.startOffsetMillis,
                        endOffset: response.endOffsetMillis,
                        nowOffset: response.utcTimeOffsetMillis,
                        hasDeletedResponders: response.hasDeletedResponders,
                        // TODO: Rename to 'baseRotations'
                        defaultLayers: (response.scheduleLayer?.rotations ?? []).map(({ id: id, name: name, periods: periods, hasDeletedResponders: hasDeletedResponders })=>({
                                id: id,
                                name: name,
                                hasDeletedResponders: hasDeletedResponders,
                                periods: periods.map((period)=>(0, $kRnku.fromPeriodResponseToPeriod)(period))
                            })),
                        overrideLayers: (response.overrideLayer?.rotations ?? []).map(({ id: id, name: name, periods: periods, hasDeletedResponders: hasDeletedResponders })=>({
                                id: id,
                                name: name,
                                hasDeletedResponders: hasDeletedResponders,
                                periods: periods.map((period)=>(0, $kRnku.fromPeriodResponseToPeriod)(period))
                            })),
                        forwardingLayers: (response.forwardingLayer?.rotations ?? []).map(({ id: id, name: name, periods: periods, hasDeletedResponders: hasDeletedResponders })=>({
                                id: id,
                                name: name,
                                hasDeletedResponders: hasDeletedResponders,
                                periods: periods.map((period)=>(0, $kRnku.fromPeriodResponseToPeriod)(period))
                            })),
                        finalLayers: (response.finalLayer?.rotations ?? []).map(({ id: id, name: name, periods: periods, hasDeletedResponders: hasDeletedResponders })=>({
                                id: id,
                                name: name,
                                hasDeletedResponders: hasDeletedResponders,
                                periods: periods.map((period)=>(0, $kRnku.fromPeriodResponseToPeriod)(period))
                            }))
                    },
                    calendarData: undefined
                });
            } else if (selectedView === (0, $5s9eT.NavigationMode).Calendar) {
                const response = await (0, $dQNfh.endpoints).getCalendar({
                    scheduleId: schedule.id,
                    currentDate: formattedCurrent,
                    mode: selectedView,
                    timelineType: (0, $5s9eT.NavigationPeriodId).OneMonth,
                    ...!(0, $lCzwW.isEmpty)(rotation) && {
                        rotation: (0, $kRnku.fromRotationDetailToRotationPayload)(rotation)
                    }
                });
                setState({
                    timelineData: undefined,
                    calendarData: {
                        startEpoch: response.startTimeUtcMillis,
                        endEpoch: response.endTimeUtcMillis,
                        nowEpoch: response.currentTime,
                        startOffset: response.startOffsetMillis,
                        endOffset: response.endOffsetMillis,
                        nowOffset: response.utcTimeOffsetMillis,
                        hasDeletedResponders: response.hasDeletedResponders,
                        baseWeeks: (0, $kRnku.fromCalendarLayerWeekToWeek)(response.scheduleLayer.weeks),
                        finalWeeks: (0, $kRnku.fromCalendarLayerWeekToWeek)(response.finalLayer.weeks)
                    }
                });
            }
        } catch (error) {
            defaultCatch({
                id: 'getTimelineAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).getLayersErrorTitle),
                        description: intlApi.formatMessage((0, $11Uc3.messages).getLayersErrorDescription)
                    });
                }
            }, error);
        } finally{
            setState({
                getTimelineLoading: false
            });
        }
    };
const $b79c164d683c470d$var$setRotationAction = (rotation)=>({ setState: setState, dispatch: dispatch })=>{
        setState({
            rotation: rotation
        });
        dispatch($b79c164d683c470d$var$getTimelineAction());
    };
const $b79c164d683c470d$var$setSelectedViewAction = (selectedView)=>({ setState: setState, dispatch: dispatch })=>{
        setState({
            selectedView: selectedView
        });
        dispatch($b79c164d683c470d$var$getTimelineAction());
    };
const $b79c164d683c470d$var$setTimelineTypeAction = (timelineType)=>({ setState: setState, dispatch: dispatch })=>{
        setState({
            timelineType: timelineType
        });
        dispatch($b79c164d683c470d$var$getTimelineAction());
    };
const $b79c164d683c470d$var$previousPeriodAction = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { currentDate: currentDate, timelineType: timelineType, selectedView: selectedView, schedule: { timezone: timezone } } = getState();
        switch(selectedView){
            case (0, $5s9eT.NavigationMode).Calendar:
                setState({
                    currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).previousMonth(currentDate, timezone), timezone)
                });
                break;
            case (0, $5s9eT.NavigationMode).Timeline:
                switch(timelineType){
                    case (0, $5s9eT.NavigationPeriodId).OneDay:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).previousDay(currentDate, timezone), timezone)
                        });
                        break;
                    case (0, $5s9eT.NavigationPeriodId).OneWeek:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).previousWeek(currentDate, timezone), timezone)
                        });
                        break;
                    case (0, $5s9eT.NavigationPeriodId).TwoWeeks:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).previousTwoWeeks(currentDate, timezone), timezone)
                        });
                        break;
                    case (0, $5s9eT.NavigationPeriodId).OneMonth:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).previousMonth(currentDate, timezone), timezone)
                        });
                }
                break;
        }
        dispatch($b79c164d683c470d$var$getTimelineAction());
    };
const $b79c164d683c470d$var$nextPeriodAction = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { currentDate: currentDate, timelineType: timelineType, selectedView: selectedView, schedule: { timezone: timezone } } = getState();
        switch(selectedView){
            case (0, $5s9eT.NavigationMode).Calendar:
                setState({
                    currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).nextMonth(currentDate, timezone), timezone)
                });
                break;
            case (0, $5s9eT.NavigationMode).Timeline:
                switch(timelineType){
                    case (0, $5s9eT.NavigationPeriodId).OneDay:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).nextDay(currentDate, timezone), timezone)
                        });
                        break;
                    case (0, $5s9eT.NavigationPeriodId).OneWeek:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).nextWeek(currentDate, timezone), timezone)
                        });
                        break;
                    case (0, $5s9eT.NavigationPeriodId).TwoWeeks:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).nextTwoWeeks(currentDate, timezone), timezone)
                        });
                        break;
                    case (0, $5s9eT.NavigationPeriodId).OneMonth:
                        setState({
                            currentDate: (0, $jOikx.zoned).midOfDay((0, $jOikx.zoned).nextMonth(currentDate, timezone), timezone)
                        });
                }
                break;
        }
        dispatch($b79c164d683c470d$var$getTimelineAction());
    };
const $b79c164d683c470d$var$takeOnCallAction = ({ accountId: accountId })=>async ({ dispatch: dispatch, setState: setState, getState: getState }, { flagApi: flagApi, intlApi: intlApi, closePageModal: closePageModal, defaultCatch: defaultCatch })=>{
        setState({
            takeOnCallLoading: true
        });
        try {
            await (0, $dQNfh.endpoints).takeOnCall({
                accountId: accountId,
                scheduleId: getState().schedule.id
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $11Uc3.messages).takeOnCallSuccessTitle),
                isAutoDismiss: true
            });
            dispatch($b79c164d683c470d$var$getTimelineAction());
            closePageModal((0, $kCCbe.PageModalType).TakeOnCall);
        } catch (error) {
            defaultCatch({
                id: 'takeOnCallAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).takeOnCallErrorTitle)
                    });
                }
            }, error);
        } finally{
            setState({
                takeOnCallLoading: false
            });
        }
    };
const $b79c164d683c470d$var$getOverrideAction = ({ alias: alias })=>async ({ getState: getState }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        try {
            const override = await (0, $dQNfh.endpoints).getOverride({
                scheduleId: getState().schedule.id,
                alias: alias
            });
            return override;
        } catch (error) {
            defaultCatch({
                id: 'getOverrideAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).getOverrideErrorTitle)
                    });
                }
            }, error);
            throw error;
        }
    };
const $b79c164d683c470d$var$revertOverrideAction = ({ alias: alias })=>async ({ dispatch: dispatch, setState: setState, getState: getState }, { flagApi: flagApi, intlApi: intlApi, closePageModal: closePageModal, defaultCatch: defaultCatch })=>{
        try {
            setState({
                revertOverrideLoading: true
            });
            await (0, $dQNfh.endpoints).revertOverride({
                scheduleId: getState().schedule.id,
                alias: alias
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $11Uc3.messages).revertOverrideSuccessTitle),
                isAutoDismiss: true
            });
            dispatch($b79c164d683c470d$var$getTimelineAction());
            closePageModal((0, $kCCbe.PageModalType).RevertOverride);
        } catch (error) {
            defaultCatch({
                id: 'revertOverrideAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).revertOverrideErrorTitle)
                    });
                }
            }, error);
        } finally{
            setState({
                revertOverrideLoading: false
            });
        }
    };
// TODO: consider using different loading state variable for add override, add override bulk and update override
const $b79c164d683c470d$var$addOverrideAction = ({ rotationIds: rotationIds, startTime: startTime, responder: responder, timezone: timezone, endTime: endTime })=>async ({ dispatch: dispatch, setState: setState, getState: getState }, { flagApi: flagApi, intlApi: intlApi, closePageModal: closePageModal, defaultCatch: defaultCatch, createAnalyticsEvent: createAnalyticsEvent })=>{
        setState({
            addOverrideLoading: true
        });
        const event = createAnalyticsEvent({});
        try {
            await (0, $dQNfh.endpoints).addOverride({
                scheduleId: getState().schedule.id,
                rotationIds: rotationIds,
                startTime: startTime,
                responder: responder,
                timezone: timezone,
                endTime: endTime
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $11Uc3.messages).addOverrideSuccessTitle),
                isAutoDismiss: true
            });
            dispatch($b79c164d683c470d$var$getTimelineAction());
            closePageModal((0, $kCCbe.PageModalType).AddOverride);
            (0, $h8yj2.fireTrackAnalytics)(event, 'overrideCreation succeeded', getState().schedule.id);
        } catch (error) {
            defaultCatch({
                id: 'addOverrideAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).addOverrideErrorTitle)
                    });
                }
            }, error);
            (0, $h8yj2.fireTrackAnalytics)(event, 'overrideCreation failed', getState().schedule.id);
        } finally{
            setState({
                addOverrideLoading: false
            });
        }
    };
const $b79c164d683c470d$var$updateOverrideAction = ({ rotationIds: rotationIds, startTime: startTime, responder: responder, timezone: timezone, endTime: endTime, alias: alias })=>async ({ dispatch: dispatch, setState: setState, getState: getState }, { flagApi: flagApi, intlApi: intlApi, closePageModal: closePageModal, defaultCatch: defaultCatch, createAnalyticsEvent: createAnalyticsEvent })=>{
        setState({
            addOverrideLoading: true
        });
        try {
            await (0, $dQNfh.endpoints).updateOverride({
                scheduleId: getState().schedule.id,
                rotationIds: rotationIds,
                startTime: startTime,
                responder: responder,
                timezone: timezone,
                endTime: endTime,
                alias: alias
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $11Uc3.messages).updateOverrideSuccessTitle),
                isAutoDismiss: true
            });
            dispatch($b79c164d683c470d$var$getTimelineAction());
            closePageModal((0, $kCCbe.PageModalType).AddOverride);
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'override updated', getState().schedule.id);
        } catch (error) {
            defaultCatch({
                id: 'updateOverrideAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).updateOverrideErrorTitle)
                    });
                }
            }, error);
        } finally{
            setState({
                addOverrideLoading: false
            });
        }
    };
const $b79c164d683c470d$var$addOverrideBulkAction = ({ overrides: overrides })=>async ({ dispatch: dispatch, setState: setState, getState: getState }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        setState({
            addOverrideLoading: true
        });
        try {
            await (0, $dQNfh.endpoints).addOverrideBulk({
                scheduleId: getState().schedule.id,
                overrides: overrides
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $11Uc3.messages).addOverrideBulkSuccessTitle),
                isAutoDismiss: true
            });
            dispatch($b79c164d683c470d$var$getTimelineAction());
        } catch (error) {
            defaultCatch({
                id: 'addOverrideBulkAction',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $11Uc3.messages).addOverrideBulkErrorTitle)
                    });
                }
            }, error);
        } finally{
            setState({
                addOverrideLoading: false
            });
        }
    };
const $b79c164d683c470d$var$todayAction = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        setState({
            currentDate: (0, $jOikx.zoned).midOfDay(new Date(), getState().schedule.timezone)
        });
        dispatch($b79c164d683c470d$var$getTimelineAction());
    };
const $b79c164d683c470d$export$e324594224ef24da = {
    addOverrideAction: $b79c164d683c470d$var$addOverrideAction,
    addOverrideBulkAction: $b79c164d683c470d$var$addOverrideBulkAction,
    getOverrideAction: $b79c164d683c470d$var$getOverrideAction,
    revertOverrideAction: $b79c164d683c470d$var$revertOverrideAction,
    updateOverrideAction: $b79c164d683c470d$var$updateOverrideAction,
    getTimelineAction: $b79c164d683c470d$var$getTimelineAction,
    nextPeriodAction: $b79c164d683c470d$var$nextPeriodAction,
    previousPeriodAction: $b79c164d683c470d$var$previousPeriodAction,
    setSelectedViewAction: $b79c164d683c470d$var$setSelectedViewAction,
    setRotationAction: $b79c164d683c470d$var$setRotationAction,
    setTimelineTypeAction: $b79c164d683c470d$var$setTimelineTypeAction,
    takeOnCallAction: $b79c164d683c470d$var$takeOnCallAction,
    todayAction: $b79c164d683c470d$var$todayAction
};

});
parcelRegister("jekok", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfff2474aaec4c1f$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $9zpvl = parcelRequire("9zpvl");

var $hWMqm = parcelRequire("hWMqm");
function $dfff2474aaec4c1f$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $9zpvl.default)((0, $hWMqm.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("9zpvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7b2a97b4d5fba6$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $fBAYT = parcelRequire("fBAYT");

var $2uBDs = parcelRequire("2uBDs");
var $6f7b2a97b4d5fba6$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $6f7b2a97b4d5fba6$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($6f7b2a97b4d5fba6$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2uBDs.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $fBAYT.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("fBAYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5c6ff65cb0b7f7f$export$2e2bcd8739ae039);

var $8djpa = parcelRequire("8djpa");

var $4QKiR = parcelRequire("4QKiR");
var $b5c6ff65cb0b7f7f$var$MILLISECONDS_IN_MINUTE = 60000;
var $b5c6ff65cb0b7f7f$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $b5c6ff65cb0b7f7f$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b5c6ff65cb0b7f7f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $b5c6ff65cb0b7f7f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b5c6ff65cb0b7f7f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $b5c6ff65cb0b7f7f$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b5c6ff65cb0b7f7f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $b5c6ff65cb0b7f7f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b5c6ff65cb0b7f7f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $b5c6ff65cb0b7f7f$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b5c6ff65cb0b7f7f$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b5c6ff65cb0b7f7f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $8djpa.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $8djpa.default)('long', date, options);
        }
    }
};
function $b5c6ff65cb0b7f7f$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $4QKiR.default)(timeZone, originalDate, true) / $b5c6ff65cb0b7f7f$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $b5c6ff65cb0b7f7f$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $b5c6ff65cb0b7f7f$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $b5c6ff65cb0b7f7f$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $b5c6ff65cb0b7f7f$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $b5c6ff65cb0b7f7f$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $b5c6ff65cb0b7f7f$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $b5c6ff65cb0b7f7f$var$formatTimezone(offset, dirtyDelimeter);
}
function $b5c6ff65cb0b7f7f$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $b5c6ff65cb0b7f7f$var$addLeadingZeros(minutes, 2);
}
var $b5c6ff65cb0b7f7f$export$2e2bcd8739ae039 = $b5c6ff65cb0b7f7f$var$formatters;

});
parcelRegister("8djpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fae970974ddb9ac$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $5fae970974ddb9ac$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $5fae970974ddb9ac$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $5fae970974ddb9ac$var$partsTimeZone(dtf, date) : $5fae970974ddb9ac$var$hackyTimeZone(dtf, date);
}
function $5fae970974ddb9ac$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $5fae970974ddb9ac$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $5fae970974ddb9ac$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("4QKiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $387fef99a835af50$export$2e2bcd8739ae039);

var $aFyUf = parcelRequire("aFyUf");

var $aR8Dr = parcelRequire("aR8Dr");
var $387fef99a835af50$var$MILLISECONDS_IN_HOUR = 3600000;
var $387fef99a835af50$var$MILLISECONDS_IN_MINUTE = 60000;
var $387fef99a835af50$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $387fef99a835af50$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $387fef99a835af50$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $387fef99a835af50$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$387fef99a835af50$var$validateTimezone(hours)) return NaN;
        return -(hours * $387fef99a835af50$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $387fef99a835af50$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$387fef99a835af50$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $387fef99a835af50$var$MILLISECONDS_IN_HOUR + minutes * $387fef99a835af50$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($387fef99a835af50$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $387fef99a835af50$var$toUtcDate(date);
        var offset = $387fef99a835af50$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $387fef99a835af50$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $387fef99a835af50$var$toUtcDate(date) {
    return (0, $aR8Dr.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $387fef99a835af50$var$calcOffset(date, timezoneString) {
    var tokens = (0, $aFyUf.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $aR8Dr.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $387fef99a835af50$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $387fef99a835af50$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $387fef99a835af50$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $387fef99a835af50$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $387fef99a835af50$var$validIANATimezoneCache = {};
function $387fef99a835af50$var$isValidTimezoneIANAString(timeZoneString) {
    if ($387fef99a835af50$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $387fef99a835af50$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("aFyUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c48cf58ff864aec$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $7c48cf58ff864aec$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $7c48cf58ff864aec$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $7c48cf58ff864aec$var$partsOffset(dtf, date) : $7c48cf58ff864aec$var$hackyOffset(dtf, date);
}
var $7c48cf58ff864aec$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $7c48cf58ff864aec$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $7c48cf58ff864aec$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $7c48cf58ff864aec$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $7c48cf58ff864aec$var$dtfCache = {};
function $7c48cf58ff864aec$var$getDateTimeFormat(timeZone) {
    if (!$7c48cf58ff864aec$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $7c48cf58ff864aec$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $7c48cf58ff864aec$var$dtfCache[timeZone];
}

});

parcelRegister("aR8Dr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e758d6141b1c227$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $7e758d6141b1c227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2uBDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0b93b69e19b804$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $4QKiR = parcelRequire("4QKiR");

var $ht7Rk = parcelRequire("ht7Rk");
var $1d0b93b69e19b804$var$MILLISECONDS_IN_HOUR = 3600000;
var $1d0b93b69e19b804$var$MILLISECONDS_IN_MINUTE = 60000;
var $1d0b93b69e19b804$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1d0b93b69e19b804$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $ht7Rk.default)
};
function $1d0b93b69e19b804$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1d0b93b69e19b804$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1d0b93b69e19b804$var$splitDateString(argument);
    var parseYearResult = $1d0b93b69e19b804$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1d0b93b69e19b804$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1d0b93b69e19b804$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $4QKiR.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1d0b93b69e19b804$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1d0b93b69e19b804$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1d0b93b69e19b804$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1d0b93b69e19b804$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1d0b93b69e19b804$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1d0b93b69e19b804$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1d0b93b69e19b804$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1d0b93b69e19b804$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1d0b93b69e19b804$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1d0b93b69e19b804$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1d0b93b69e19b804$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1d0b93b69e19b804$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1d0b93b69e19b804$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1d0b93b69e19b804$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1d0b93b69e19b804$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1d0b93b69e19b804$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1d0b93b69e19b804$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1d0b93b69e19b804$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1d0b93b69e19b804$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1d0b93b69e19b804$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1d0b93b69e19b804$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1d0b93b69e19b804$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1d0b93b69e19b804$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1d0b93b69e19b804$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1d0b93b69e19b804$var$validateTime(hours)) return NaN;
        return hours % 24 * $1d0b93b69e19b804$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1d0b93b69e19b804$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1d0b93b69e19b804$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1d0b93b69e19b804$var$MILLISECONDS_IN_HOUR + minutes * $1d0b93b69e19b804$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1d0b93b69e19b804$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1d0b93b69e19b804$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1d0b93b69e19b804$var$MILLISECONDS_IN_HOUR + minutes * $1d0b93b69e19b804$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1d0b93b69e19b804$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1d0b93b69e19b804$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1d0b93b69e19b804$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1d0b93b69e19b804$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1d0b93b69e19b804$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1d0b93b69e19b804$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1d0b93b69e19b804$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1d0b93b69e19b804$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1d0b93b69e19b804$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1d0b93b69e19b804$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1d0b93b69e19b804$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1d0b93b69e19b804$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("ht7Rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7b3dc243830af1$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $cb7b3dc243830af1$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $cb7b3dc243830af1$export$2e2bcd8739ae039 = $cb7b3dc243830af1$var$tzPattern;

});



parcelRegister("hWMqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d10d6a7db409f554$export$2e2bcd8739ae039);

var $4QKiR = parcelRequire("4QKiR");

var $2uBDs = parcelRequire("2uBDs");
function $d10d6a7db409f554$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2uBDs.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $4QKiR.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("5s9eT", function(module, exports) {

$parcel$export(module.exports, "EXTRA_SELECT_PROPS", () => $36842a3bf45988fd$export$ea5f9e8c4126885d);
$parcel$export(module.exports, "GET_EXTRA_SELECT_PROPS", () => $36842a3bf45988fd$export$6ca3d23fd02e8d3);
$parcel$export(module.exports, "COMMON_SPOTLIGHT_NAMES", () => $36842a3bf45988fd$export$46b646a2c0aa13dd);
$parcel$export(module.exports, "COMMON_SPOTLIGHT_TOURS", () => $36842a3bf45988fd$export$e9286a6836b4dcdd);
$parcel$export(module.exports, "DEFAULT_TIMES", () => $36842a3bf45988fd$export$8424696d93134b23);
$parcel$export(module.exports, "PeriodType", () => $36842a3bf45988fd$export$63f58aa530dd6aae);
$parcel$export(module.exports, "ShiftFrequency", () => $36842a3bf45988fd$export$3d1d54199b3126b8);
$parcel$export(module.exports, "TimingType", () => $36842a3bf45988fd$export$83fa51b329d2275b);
$parcel$export(module.exports, "RotationType", () => $36842a3bf45988fd$export$91397be43fc980cc);
$parcel$export(module.exports, "NavigationMode", () => $36842a3bf45988fd$export$9c0eac0e0a38beb0);
$parcel$export(module.exports, "NavigationPeriodId", () => $36842a3bf45988fd$export$4a3a656088fc918c);
$parcel$export(module.exports, "LayerType", () => $36842a3bf45988fd$export$551ff448b1eb3ef1);
$parcel$export(module.exports, "ShiftAction", () => $36842a3bf45988fd$export$e9c3228f4957bd42);
$parcel$export(module.exports, "ShiftStatus", () => $36842a3bf45988fd$export$a99e0dd4ead620e);
// SEE: https://atlaskit.atlassian.com/packages/design-system/select/example/select-in-modal-dialog
const $36842a3bf45988fd$export$ea5f9e8c4126885d = {
    menuPortalTarget: document.body,
    styles: {
        menuPortal: (base)=>({
                ...base,
                zIndex: 9999
            })
    }
};
const $36842a3bf45988fd$export$6ca3d23fd02e8d3 = ()=>({
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        }
    });
const $36842a3bf45988fd$export$46b646a2c0aa13dd = {
    firstListRotationItem: 'eoc-schedule_first_list_schedule_item',
    editRotationTimings: 'eoc-schedule-edit_rotation_timings',
    editRotationForm: 'eoc-schedule_edit_rotation_rotation',
    editModeSchedule: 'eoc-schedule-edit_mode_schedule'
};
const $36842a3bf45988fd$export$e9286a6836b4dcdd = {
    rotationEdit: 'eoc-schedule-rotation-edit',
    rotationList: 'eoc-schedule-rotation-list'
};
const $36842a3bf45988fd$export$8424696d93134b23 = Array.from({
    length: 24
}, (_, i)=>i).flatMap((time)=>{
    return [
        `${time}:00`,
        `${time}:30`
    ].map((t)=>t.padStart(5, '0'));
});
var $36842a3bf45988fd$export$63f58aa530dd6aae = /*#__PURE__*/ function(PeriodType) {
    PeriodType["Schedule"] = "schedule";
    PeriodType["Override"] = "override";
    PeriodType["Forwarding"] = "forwarding";
    return PeriodType;
}({});
var $36842a3bf45988fd$export$3d1d54199b3126b8 = /*#__PURE__*/ function(ShiftFrequency) {
    ShiftFrequency["Daily"] = "daily";
    ShiftFrequency["Weekly"] = "weekly";
    ShiftFrequency["Custom"] = "custom";
    return ShiftFrequency;
}({});
var $36842a3bf45988fd$export$83fa51b329d2275b = /*#__PURE__*/ function(TimingType) {
    TimingType["Everday"] = "everyday";
    TimingType["Customday"] = "customday";
    return TimingType;
}({});
var $36842a3bf45988fd$export$91397be43fc980cc = /*#__PURE__*/ function(RotationType) {
    RotationType["DAILY"] = "daily";
    RotationType["WEEKLY"] = "weekly";
    RotationType["HOURLY"] = "hourly";
    RotationType["INVALID"] = "invalid";
    return RotationType;
}({});
var $36842a3bf45988fd$export$9c0eac0e0a38beb0 = /*#__PURE__*/ function(NavigationMode) {
    NavigationMode["Calendar"] = "calendar";
    NavigationMode["Timeline"] = "timeline";
    return NavigationMode;
}({});
var $36842a3bf45988fd$export$4a3a656088fc918c = /*#__PURE__*/ function(NavigationPeriodId) {
    NavigationPeriodId[NavigationPeriodId["OneDay"] = 1] = "OneDay";
    NavigationPeriodId[NavigationPeriodId["OneWeek"] = 2] = "OneWeek";
    NavigationPeriodId[NavigationPeriodId["TwoWeeks"] = 3] = "TwoWeeks";
    NavigationPeriodId[NavigationPeriodId["OneMonth"] = 4] = "OneMonth";
    return NavigationPeriodId;
}({});
var $36842a3bf45988fd$export$551ff448b1eb3ef1 = /*#__PURE__*/ function(LayerType) {
    LayerType["Base"] = "defaultLayers";
    LayerType["Override"] = "overrideLayers";
    LayerType["Forwarding"] = "forwardingLayers";
    LayerType["Final"] = "finalLayers";
    return LayerType;
}({});
var $36842a3bf45988fd$export$e9c3228f4957bd42 = /*#__PURE__*/ function(ShiftAction) {
    ShiftAction["AddOverride"] = "add-override";
    ShiftAction["Cancel"] = "cancel";
    return ShiftAction;
}({});
var $36842a3bf45988fd$export$a99e0dd4ead620e = /*#__PURE__*/ function(ShiftStatus) {
    ShiftStatus["Default"] = "default";
    ShiftStatus["Multi"] = "multi";
    ShiftStatus["MultiQuickOverride"] = "multi-quick-override";
    ShiftStatus["Single"] = "single";
    ShiftStatus["SingleViewOnly"] = "single-view-only";
    ShiftStatus["SingleOverriden"] = "single-overriden";
    ShiftStatus["SingleQuickOverride"] = "single-quick-override";
    return ShiftStatus;
}({});

});

parcelRegister("dQNfh", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $d2c5b59a7e065944$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $d2c5b59a7e065944$var$takeOnCall = ({ accountId: accountId, scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.overrides.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        // TODO: replace in future (when variable duration is possible)
        body: {
            hours: 1,
            responder: {
                id: accountId,
                type: 'user'
            }
        }
    });
};
const $d2c5b59a7e065944$var$addOverride = ({ endTime: endTime, responder: responder, rotationIds: rotationIds, scheduleId: scheduleId, startTime: startTime, timezone: timezone })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.overrides.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            endTime: endTime,
            responder: responder,
            rotationIds: rotationIds,
            startTime: startTime,
            timezone: timezone
        }
    });
};
const $d2c5b59a7e065944$var$addOverrideBulk = ({ overrides: overrides, scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.overrides.bulk.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            overrides: overrides
        }
    });
};
const $d2c5b59a7e065944$var$getOverride = ({ alias: alias, scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.overrides.alias.url({
        alias: alias,
        scheduleId: scheduleId
    }), {
        method: 'GET'
    });
};
const $d2c5b59a7e065944$var$revertOverride = ({ alias: alias, scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.overrides.alias.url({
        alias: alias,
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $d2c5b59a7e065944$var$updateOverride = ({ alias: alias, endTime: endTime, responder: responder, rotationIds: rotationIds, scheduleId: scheduleId, startTime: startTime, timezone: timezone })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.overrides.alias.url({
        alias: alias,
        scheduleId: scheduleId
    }), {
        method: 'PUT',
        body: {
            endTime: endTime,
            responder: responder,
            rotationIds: rotationIds,
            startTime: startTime,
            timezone: timezone
        }
    });
};
const $d2c5b59a7e065944$var$getTimeline = ({ scheduleId: scheduleId, currentDate: currentDate, mode: mode, timelineType: timelineType, rotation: rotation })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.timeline.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            scheduleId: scheduleId,
            currentDate: currentDate,
            mode: mode,
            timelineType: timelineType,
            rotation: rotation
        }
    });
};
const $d2c5b59a7e065944$var$getCalendar = ({ scheduleId: scheduleId, currentDate: currentDate, mode: mode, timelineType: timelineType, rotation: rotation })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.timeline.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            scheduleId: scheduleId,
            currentDate: currentDate,
            mode: mode,
            timelineType: timelineType,
            rotation: rotation
        }
    });
};
const $d2c5b59a7e065944$var$exportTimeline = async ({ scheduleId: scheduleId })=>{
    const response = await (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.timeline.url({
        scheduleId: scheduleId
    }), {
        method: 'GET',
        responseType: 'headers',
        headers: {
            'Content-Type': 'application/octet-stream'
        }
    });
    const filename = response.headers?.get('content-disposition')?.split(';')[2].trim().split('=')[1].replace(/"/g, '');
    const content = await response.text();
    return {
        content: content,
        filename: filename
    };
};
const $d2c5b59a7e065944$export$3a2536d80ecc00e7 = {
    addOverride: $d2c5b59a7e065944$var$addOverride,
    addOverrideBulk: $d2c5b59a7e065944$var$addOverrideBulk,
    exportTimeline: $d2c5b59a7e065944$var$exportTimeline,
    getCalendar: $d2c5b59a7e065944$var$getCalendar,
    getOverride: $d2c5b59a7e065944$var$getOverride,
    getTimeline: $d2c5b59a7e065944$var$getTimeline,
    revertOverride: $d2c5b59a7e065944$var$revertOverride,
    takeOnCall: $d2c5b59a7e065944$var$takeOnCall,
    updateOverride: $d2c5b59a7e065944$var$updateOverride
};

});

parcelRegister("11Uc3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2e87908da3d3c250$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2e87908da3d3c250$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    getLayersErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.get-layers-error-title',
        defaultMessage: 'An error occurred',
        description: 'A message which indicates that an error is occurred'
    },
    getLayersErrorDescription: {
        id: 'eoc-schedule.controllers.schedule-store.actions.get-layers-error-description',
        defaultMessage: "Schedule couldn't be loaded, please try again later.",
        description: 'A message that indicates we could not fetch the schedule'
    },
    takeOnCallErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.take-oncall-error-title',
        defaultMessage: 'We could not create the override at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when adding an override.'
    },
    takeOnCallSuccessTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.take-oncall-success-title',
        defaultMessage: 'You are now on-call for all rotations for the next one hour.',
        description: 'This message indicates override is successfully created.'
    },
    addOverrideErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.add-override-error-title',
        defaultMessage: 'We could not create the override at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when adding an override.'
    },
    addOverrideSuccessTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.add-override-success-title',
        defaultMessage: 'Override is created successfully.',
        description: 'This message indicates override is successfully created.'
    },
    addOverrideBulkErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.add-override-bulk-error-title',
        defaultMessage: 'We could not create the override at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when adding a bulk override.'
    },
    addOverrideBulkSuccessTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.add-override-bulk-success-title',
        defaultMessage: 'Selected participants overriden successfully.',
        description: 'This message indicates bulk overrides are successfully overriden.'
    },
    updateOverrideErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.update-override-error-title',
        defaultMessage: 'We could not create the override at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when updating an override.'
    },
    updateOverrideSuccessTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.update-override-success-title',
        defaultMessage: 'Override updated successfully.',
        description: 'This message indicates override is successfully updated.'
    },
    getOverrideErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.get-override-error-title',
        defaultMessage: 'We could not retrieve the override details at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when retrieving override details.'
    },
    revertOverrideSuccessTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.revert-override-success-title',
        defaultMessage: 'Override removed successfully.',
        description: 'This message indicates override is successfully updated.'
    },
    revertOverrideErrorTitle: {
        id: 'eoc-schedule.controllers.schedule-store.actions.revert-override-error-title',
        defaultMessage: 'We could not removed the override at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when removing an override.'
    }
});

});

parcelRegister("kRnku", function(module, exports) {

$parcel$export(module.exports, "fromPeriodResponseToPeriod", () => $e870e7ac6202cbb9$export$8a6643bc93cffaf5);
$parcel$export(module.exports, "fromRotationDetailToRotationPayload", () => $e870e7ac6202cbb9$export$82e20c120cf1579f);
$parcel$export(module.exports, "fromCalendarLayerWeekToWeek", () => $e870e7ac6202cbb9$export$8acdb8e0b467afb3);

var $7Jxgt = parcelRequire("7Jxgt");

var $lCzwW = parcelRequire("lCzwW");
const $e870e7ac6202cbb9$export$8a6643bc93cffaf5 = (period)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, responder: responder, periodType: periodType, alias: alias, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, from: from } = period;
    return {
        id: (0, $7Jxgt.v4)(),
        responder: {
            id: responder?.id,
            type: responder.type,
            deleted: responder?.deleted ?? false
        },
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        type: periodType,
        alias: alias,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        from: from ? {
            id: from?.id,
            type: from.type,
            deleted: from?.deleted ?? false
        } : undefined
    };
};
const $e870e7ac6202cbb9$export$82e20c120cf1579f = (rotation)=>{
    const { id: id, name: name, responders: responders, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw, rotationType: rotationType, timeTemplateId: timeTemplateId, rotationPeriod: rotationPeriod } = rotation;
    const payload = {
        id: id,
        name: name,
        responders: responders,
        rotationType: rotationType,
        rotationPeriod: rotationPeriod,
        startTimeRaw: startTimeRaw
    };
    if ((0, $lCzwW.isEmpty)(endTimeRaw)) payload.hasEndTime = false;
    else {
        payload.hasEndTime = true;
        payload.endTimeRaw = endTimeRaw;
    }
    if ((0, $lCzwW.isEmpty)(timeTemplateId)) {
        payload.restrictions = rotation.restrictions;
        payload.timingType = rotation.timingType;
    } else payload.timeTemplateId = timeTemplateId;
    return payload;
};
const $e870e7ac6202cbb9$export$8acdb8e0b467afb3 = (weeks)=>{
    return weeks.map(({ rotations: rotations, relativeEndTime: relativeEndTime, relativeStartTime: relativeStartTime })=>({
            startEpoch: relativeStartTime,
            endEpoch: relativeEndTime,
            rotations: rotations.map(({ id: id, name: name, periods: periods, hasDeletedResponders: hasDeletedResponders })=>({
                    id: id,
                    name: name,
                    hasDeletedResponders: hasDeletedResponders,
                    periods: periods.map((period)=>$e870e7ac6202cbb9$export$8a6643bc93cffaf5(period))
                }))
        }));
};

});


parcelRegister("c9DPK", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $71e0dd4ea9c292f1$export$d4c72bab9d6cc13a);

var $5s9eT = parcelRequire("5s9eT");
const $71e0dd4ea9c292f1$export$d4c72bab9d6cc13a = {
    addOverrideLoading: false,
    revertOverrideLoading: false,
    getTimelineLoading: true,
    selectedView: (0, $5s9eT.NavigationMode).Timeline,
    takeOnCallLoading: false,
    timelineData: undefined,
    calendarData: undefined,
    timelineType: (0, $5s9eT.NavigationPeriodId).TwoWeeks,
    currentDate: undefined,
    schedule: undefined
};

});


parcelRegister("gV29J", function(module, exports) {

$parcel$export(module.exports, "actions", () => $37b464dcebef1456$export$e324594224ef24da);

var $fxiJ3 = parcelRequire("fxiJ3");
const $37b464dcebef1456$var$setOrderRotationLoading = (loading)=>({ setState: setState })=>{
        setState({
            orderRotationLoading: loading
        });
    };
const $37b464dcebef1456$var$goToDetail = ({ rotation: rotation, variant: variant, recipientUpdate: recipientUpdate })=>({ setState: setState })=>{
        // TODO: should be removed (edit-rotation component should be responsible fully)
        // NOTE: due to timezone hack (useInitialValues) we apply, this triggers duplicate requests
        // setRotationAction(rotation);
        setState({
            step: (0, $fxiJ3.EditStep).Detail,
            rotationDetailVariant: variant,
            initialRotation: rotation,
            recipientUpdate: recipientUpdate
        });
    };
const $37b464dcebef1456$var$goBack = ()=>({ setState: setState }, { setRotationAction: setRotationAction })=>{
        // TODO: should be removed (edit-rotation component should be responsible fully)
        setRotationAction(undefined);
        setState({
            step: (0, $fxiJ3.EditStep).List,
            rotationDetailVariant: undefined,
            initialRotation: undefined,
            recipientUpdate: undefined
        });
    };
const $37b464dcebef1456$export$e324594224ef24da = {
    setOrderRotationLoading: $37b464dcebef1456$var$setOrderRotationLoading,
    goToDetail: $37b464dcebef1456$var$goToDetail,
    goBack: $37b464dcebef1456$var$goBack
};

});
parcelRegister("fxiJ3", function(module, exports) {

$parcel$export(module.exports, "EditStep", () => $4651e96ffe8867b3$export$2508d78546785964);
$parcel$export(module.exports, "RotationDetailVariant", () => $4651e96ffe8867b3$export$e21eb9cb2c0e95e2);
var $4651e96ffe8867b3$export$2508d78546785964 = /*#__PURE__*/ function(EditStep) {
    /** @description Listing timeline rotations. */ EditStep[EditStep["List"] = 1] = "List";
    /** @description Rotation details (add, edit, clone) */ EditStep[EditStep["Detail"] = 2] = "Detail";
    return EditStep;
}({});
var $4651e96ffe8867b3$export$e21eb9cb2c0e95e2 = /*#__PURE__*/ function(RotationDetailVariant) {
    RotationDetailVariant[RotationDetailVariant["Add"] = 1] = "Add";
    RotationDetailVariant[RotationDetailVariant["Edit"] = 2] = "Edit";
    RotationDetailVariant[RotationDetailVariant["Clone"] = 3] = "Clone";
    return RotationDetailVariant;
}({});

});


parcelRegister("3jFJc", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $bfd9bbee6d45c27e$export$d4c72bab9d6cc13a);

var $fxiJ3 = parcelRequire("fxiJ3");
const $bfd9bbee6d45c27e$export$d4c72bab9d6cc13a = {
    orderRotationLoading: false,
    step: (0, $fxiJ3.EditStep).List,
    rotationDetailVariant: undefined,
    initialRotation: undefined,
    recipientUpdate: undefined
};

});


parcelRegister("d2kfz", function(module, exports) {

$parcel$export(module.exports, "AddOverride", () => $060041f43ba00dd0$export$dcaef3059c00b79f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $htnpT = parcelRequire("htnpT");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $94bNw = parcelRequire("94bNw");

var $6TYWC = parcelRequire("6TYWC");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $5XoGW = parcelRequire("5XoGW");

var $hem2I = parcelRequire("hem2I");

var $9YkY7 = parcelRequire("9YkY7");
var $5s9eT = parcelRequire("5s9eT");
var $ksSWS = parcelRequire("ksSWS");

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");

var $3ogs7 = parcelRequire("3ogs7");

var $lNHZW = parcelRequire("lNHZW");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $6RRyp = parcelRequire("6RRyp");

var $csGzA = parcelRequire("csGzA");

var $lCzwW = parcelRequire("lCzwW");

var $6EibS = parcelRequire("6EibS");

var $er6tx = parcelRequire("er6tx");

var $gSPFA = parcelRequire("gSPFA");

var $k3fl7 = parcelRequire("k3fl7");
const $060041f43ba00dd0$export$dcaef3059c00b79f = ({ baseOverride: baseOverride, onClose: onClose, variant: variant })=>{
    const intlApi = (0, $koVbs.default)();
    const { data: scheduleRights } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const [{ schedule: schedule, getTimelineLoading: getTimelineLoading, addOverrideLoading: addOverrideLoading }, { addOverrideAction: addOverrideAction, updateOverrideAction: updateOverrideAction }] = (0, $9It5A.useStore)();
    const [{ nowEpoch: nowEpoch }] = (0, $3NQti.useTimelineEpoch)();
    const [rotations] = (0, $3NQti.useTimelineRotations)();
    const rotationOptions = (0, $5uXOq.useMemo)(()=>(0, $k3fl7.convertRotationsToOptions)(rotations), [
        rotations
    ]);
    if (variant === (0, $lNHZW.OverrideVariant).Edit || variant === (0, $lNHZW.OverrideVariant).Customize) (0, $hmVmJ.assert)(!(0, $lCzwW.isEmpty)(baseOverride), new (0, $dH6Pi.AssertionError)('eoc-schedule', 'add-override: baseOverride is empty in edit or customize variant'));
    if (variant === (0, $lNHZW.OverrideVariant).Edit) (0, $hmVmJ.assert)(!(0, $lCzwW.isEmpty)(baseOverride?.alias) && !(0, $lCzwW.isEmpty)(baseOverride?.responder), new (0, $dH6Pi.AssertionError)('eoc-schedule', 'add-override: alias or responder (within baseOverride) is empty in edit variant'));
    const isRequiredValidator = (0, $5XoGW.useValidators)([
        (0, $5XoGW.isRequired)()
    ]);
    const titleVariants = (0, $5uXOq.useMemo)(()=>({
            [(0, $lNHZW.OverrideVariant).Edit]: intlApi.formatMessage((0, $er6tx.messages).editTitle),
            [(0, $lNHZW.OverrideVariant).Add]: intlApi.formatMessage((0, $er6tx.messages).addTitle),
            [(0, $lNHZW.OverrideVariant).Customize]: intlApi.formatMessage((0, $er6tx.messages).customizeTitle)
        }), [
        intlApi
    ]);
    const confirmText = (0, $5uXOq.useMemo)(()=>(0, $6EibS.confirmTextButtons)(intlApi), [
        intlApi
    ]);
    const isStartDisabled = (0, $5uXOq.useMemo)(()=>{
        // NOTE: consider adding buffer in order to prevent edge cases
        if (variant === (0, $lNHZW.OverrideVariant).Edit && baseOverride.startEpoch < nowEpoch) return true;
        return false;
    }, [
        baseOverride,
        nowEpoch,
        variant
    ]);
    const defaultValues = (0, $k3fl7.useDefaultValues)({
        base: baseOverride,
        variant: variant,
        schedule: schedule
    });
    const { isError: isUserError, isLoading: isUserLoading, user: user } = (0, $k3fl7.useDefaultUser)({
        variant: variant,
        base: baseOverride
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ({ rotation: rotation, end: end, start: start, responder: responder, timezone: timezone })=>{
            if (variant === (0, $lNHZW.OverrideVariant).Edit) updateOverrideAction({
                startTime: (0, $csGzA.partitionDate)(new Date(start)),
                endTime: (0, $csGzA.partitionDate)(new Date(end)),
                rotationIds: rotation?.map(({ value: value })=>value),
                timezone: timezone.value,
                alias: baseOverride.alias,
                responder: {
                    id: responder.atlassianIdentifier,
                    type: responder.type
                }
            });
            else addOverrideAction({
                startTime: (0, $csGzA.partitionDate)(new Date(start)),
                endTime: (0, $csGzA.partitionDate)(new Date(end)),
                rotationIds: rotation?.map(({ value: value })=>value),
                timezone: timezone.value,
                responder: {
                    id: responder.atlassianIdentifier,
                    type: responder.type
                }
            });
        }
    }, ({ formProps: formProps, getState: getState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, titleVariants[variant])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSPFA.FirstField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "timezone",
            label: intlApi.formatMessage((0, $er6tx.messages).timezone),
            defaultValue: defaultValues.timezone
        }, ({ fieldProps: fieldProps })=>// @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksSWS.TimezoneSelect), {
                ...fieldProps,
                ...(0, $5s9eT.EXTRA_SELECT_PROPS),
                autoFocus: true
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "start",
            label: intlApi.formatMessage((0, $9YkY7.messages).from),
            isRequired: true,
            isDisabled: isStartDisabled,
            defaultValue: defaultValues.start,
            validate: (value)=>{
                if (isStartDisabled) return;
                if ((0, $lCzwW.isEmpty)(value)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                // TODO: Use final form and format value using current timezone
                // const d = new Date(value);
                // if (isBefore(addMinutes(d, 5), nowEpoch)) { // add 5 minutes for buffer
                //   return intlApi.formatMessage(commonMessages.timePast);
                // }
                if ((0, $lCzwW.isEmpty)(getState().values.end)) return;
                if (new Date(value).valueOf() > new Date(getState().values.end).valueOf()) return intlApi.formatMessage((0, $jkGAf.messages).startLaterEnd);
            }
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...fieldProps,
                datePickerProps: {
                    minDate: (0, $k3fl7.formatDateForProp)(nowEpoch),
                    weekStartDay: 1,
                    label: intlApi.formatMessage((0, $er6tx.messages).override, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).startDate)
                    }).toLowerCase()
                },
                timePickerProps: {
                    times: (0, $aSTVt.DEFAULT_TIMES),
                    label: intlApi.formatMessage((0, $er6tx.messages).override, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).startTime)
                    }).toLowerCase(),
                    timeIsEditable: true
                }
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "end",
            label: intlApi.formatMessage((0, $9YkY7.messages).to),
            isRequired: true,
            defaultValue: defaultValues.end,
            validate: (value)=>{
                if ((0, $lCzwW.isEmpty)(value)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                // TODO: Use final form and format value using current timezone
                // if (isBefore(new Date(value), nowEpoch)) { // add 5 minute buffer
                //   return intlApi.formatMessage(commonMessages.timePast);
                // }
                if ((0, $lCzwW.isEmpty)(getState().values.start)) return;
                if (new Date(value).valueOf() < new Date(getState().values.start).valueOf()) return intlApi.formatMessage((0, $jkGAf.messages).endEarlierStart);
            }
        }, ({ fieldProps: fieldProps, error: error })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...fieldProps,
                datePickerProps: {
                    minDate: (0, $k3fl7.formatDateForProp)(nowEpoch),
                    weekStartDay: 1,
                    label: intlApi.formatMessage((0, $er6tx.messages).override, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).endDate)
                    }).toLowerCase()
                },
                timePickerProps: {
                    times: (0, $aSTVt.DEFAULT_TIMES),
                    label: intlApi.formatMessage((0, $er6tx.messages).override, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).endTime)
                    }).toLowerCase(),
                    timeIsEditable: true
                }
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "rotation",
            label: intlApi.formatMessage((0, $er6tx.messages).selectRotation),
            defaultValue: defaultValues.rotation
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94bNw.default), {
                ...fieldProps,
                ...(0, $5s9eT.EXTRA_SELECT_PROPS),
                ...getTimelineLoading && {
                    isLoading: true
                },
                placeholder: intlApi.formatMessage((0, $er6tx.messages).allRotations),
                options: rotationOptions
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "responder",
            label: intlApi.formatMessage((0, $er6tx.messages).overrideShiftParticipantWith),
            defaultValue: user,
            validate: isRequiredValidator
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ogs7.AutoCompleteWithNoOne), {
                ...fieldProps,
                ...(0, $5s9eT.EXTRA_SELECT_PROPS),
                ...isUserLoading && {
                    isLoading: true
                },
                ...isUserError && {
                    isError: true
                },
                endpoints: [
                    (0, $6TYWC.getUsers)
                ],
                isDisabled: !scheduleRights.hasEditRight
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: onClose
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            isLoading: addOverrideLoading,
            type: "submit"
        }, confirmText[variant])))));
};

});
parcelRegister("htnpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2698ee0cdd579e$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $9Lqvx = parcelRequire("9Lqvx");

var $hB1kl = parcelRequire("hB1kl");
const $fa2698ee0cdd579e$var$DateTimePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-time-picker-use-functional-component'), (0, $hB1kl.default), (0, $9Lqvx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("9Lqvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $597f1543018f8252$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
function $597f1543018f8252$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $597f1543018f8252$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $597f1543018f8252$var$packageName = "platform-pkg";
const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $597f1543018f8252$var$datePickerContainerStyles = {
    name: "d1cmrh",
    styles: "flex-basis:50%;flex-grow:1;flex-shrink:0"
};
const $597f1543018f8252$var$timePickerContainerStyles = {
    name: "zwso5s",
    styles: "flex-basis:50%;flex-grow:1"
};
const $597f1543018f8252$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: "var(--ds-border-width, 1px)",
    alignItems: 'center',
    flexBasis: 'inherit',
    backgroundColor: 'inherit',
    border: 'none',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    paddingBlockEnd: "var(--ds-space-075, 6px)",
    paddingBlockStart: "var(--ds-space-075, 6px)",
    paddingInlineEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-050, 4px)",
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
// react-select overrides (via @atlaskit/select).
const $597f1543018f8252$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $597f1543018f8252$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time';
class $597f1543018f8252$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
        };
        // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8JNJx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $597f1543018f8252$var$datePickerContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($597f1543018f8252$var$DatePicker, {
            appearance: appearance,
            "aria-describedby": datePickerAriaDescribedBy,
            autoFocus: datePickerProps.autoFocus || autoFocus,
            dateFormat: datePickerProps.dateFormat,
            defaultIsOpen: datePickerProps.defaultIsOpen,
            defaultValue: datePickerProps.defaultValue,
            disabled: datePickerProps.disabled,
            disabledDateFilter: datePickerProps.disabledDateFilter,
            formatDisplayLabel: datePickerProps.formatDisplayLabel,
            hideIcon: datePickerProps.hideIcon || true,
            icon: datePickerProps.icon,
            id: datePickerProps.id || id,
            innerProps: datePickerProps.innerProps,
            isDisabled: datePickerProps.isDisabled || isDisabled,
            isInvalid: datePickerProps.isInvalid || isInvalid,
            isRequired: datePickerProps.isRequired || isRequired,
            isOpen: datePickerProps.isOpen,
            label: datePickerLabel,
            locale: datePickerProps.locale || locale,
            maxDate: datePickerProps.maxDate,
            minDate: datePickerProps.minDate,
            name: datePickerProps.name,
            nextMonthLabel: datePickerProps.nextMonthLabel,
            onBlur: this.onDateBlur,
            onChange: this.onDateChange,
            onFocus: this.onDateFocus,
            parseInputValue: datePickerProps.parseInputValue,
            placeholder: datePickerProps.placeholder,
            previousMonthLabel: datePickerProps.previousMonthLabel,
            selectProps: mergedDatePickerSelectProps,
            shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
            spacing: datePickerProps.spacing || spacing,
            testId: testId && `${testId}--datepicker` || datePickerProps.testId,
            value: dateValue,
            weekStartDay: datePickerProps.weekStartDay
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $597f1543018f8252$var$timePickerContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jdTq6.default), {
            appearance: timePickerProps.appearance || appearance,
            "aria-describedby": timePickerAriaDescribedBy,
            autoFocus: timePickerProps.autoFocus,
            defaultIsOpen: timePickerProps.defaultIsOpen,
            defaultValue: timePickerProps.defaultValue,
            formatDisplayLabel: timePickerProps.formatDisplayLabel,
            hideIcon: timePickerProps.hideIcon || true,
            id: timePickerProps.id,
            innerProps: timePickerProps.innerProps,
            isDisabled: timePickerProps.isDisabled || isDisabled,
            isInvalid: timePickerProps.isInvalid || isInvalid,
            isOpen: timePickerProps.isOpen,
            isRequired: timePickerProps.isRequired || isRequired,
            label: timePickerLabel,
            locale: timePickerProps.locale || locale,
            name: timePickerProps.name,
            onBlur: this.onTimeBlur,
            onChange: this.onTimeChange,
            onFocus: this.onTimeFocus,
            parseInputValue: timePickerProps.parseInputValue,
            placeholder: timePickerProps.placeholder,
            selectProps: mergedTimePickerSelectProps,
            spacing: timePickerProps.spacing || spacing,
            testId: timePickerProps.testId || testId && `${testId}--timepicker`,
            timeFormat: timePickerProps.timeFormat,
            timeIsEditable: timePickerProps.timeIsEditable,
            times: timePickerProps.times,
            value: timeValue
        })), isClearable && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
            css: $597f1543018f8252$var$iconContainerStyles,
            onClick: this.onClear,
            "data-testid": testId && `${testId}--icon--container`,
            tabIndex: -1,
            type: "button"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: clearControlLabel
        }), ' ') : null);
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        }, // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $597f1543018f8252$var$DateTimePicker = (0, $994MI.default)({
    componentName: 'dateTimePicker',
    packageName: $597f1543018f8252$var$packageName,
    packageVersion: $597f1543018f8252$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $597f1543018f8252$var$packageName,
            packageVersion: $597f1543018f8252$var$packageVersion
        }
    })
})($597f1543018f8252$export$732a1726f0a3523b));
var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;

});
parcelRegister("8JNJx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $346cb403038f00ec$export$83034b1f07ab0b20);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

function $346cb403038f00ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $346cb403038f00ec$var$isInvalidBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
});
const $346cb403038f00ec$var$isFocusedBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
});
const $346cb403038f00ec$var$isFocusedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
});
const $346cb403038f00ec$var$subtleBgStyles = {
    name: "1wrome1",
    styles: "background-color:transparent;border-color:transparent"
};
const $346cb403038f00ec$var$subtleFocusedBgStyles = {
    name: "17swi1q",
    styles: "background-color:var(--ds-background-input-pressed, transparent);border-color:transparent"
};
const $346cb403038f00ec$var$noBgStyles = {
    name: "14n6qpm",
    styles: "background-color:transparent;border-color:transparent;&:hover{background-color:transparent;border-color:transparent;}"
};
const $346cb403038f00ec$var$hoverStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
    }
});
const $346cb403038f00ec$var$isInvalidHoverStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    }
});
const $346cb403038f00ec$var$isDisabledStyles = {
    name: "1xp4bos",
    styles: "&:hover{cursor:default;}"
};
const $346cb403038f00ec$var$newBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
});
const $346cb403038f00ec$var$baseContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    border: `2px solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background-color 200ms ease-in-out, border-color 200ms ease-in-out',
    '&:hover': {
        cursor: 'pointer'
    }
});
const $346cb403038f00ec$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $346cb403038f00ec$var$baseContainerStyles,
            $346cb403038f00ec$var$newBorderStyles,
            isDisabled && $346cb403038f00ec$var$isDisabledStyles,
            isFocused && $346cb403038f00ec$var$isFocusedStyles,
            appearance === 'subtle' && (isFocused ? $346cb403038f00ec$var$subtleFocusedBgStyles : $346cb403038f00ec$var$subtleBgStyles),
            isFocused && $346cb403038f00ec$var$isFocusedBorderStyles,
            isInvalid && $346cb403038f00ec$var$isInvalidBorderStyles,
            notFocusedOrIsDisabled && (isInvalid ? $346cb403038f00ec$var$isInvalidHoverStyles : $346cb403038f00ec$var$hoverStyles),
            appearance === 'none' && $346cb403038f00ec$var$noBgStyles
        ],
        ...innerProps,
        "data-testid": testId,
        ref: ref
    }, children);
});

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $cTemL = parcelRequire("cTemL");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $19201d0a1f7d7d54$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $19201d0a1f7d7d54$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: 'color.text.subtlest',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    transition: `color 150ms`,
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.400'
});
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.050'
});
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.025'
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.CalendarIcon = (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? (0, (/*@__PURE__*/$parcel$interopDefault($acknU))) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))), // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso);
            // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
            // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        }, // This event handler is triggered from both keydown and click. It's weird.
        this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                });
                // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        }, // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = this.CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        // Until innerProps is removed, it must remain a div rather than a primitive component.
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ...innerProps,
            css: $19201d0a1f7d7d54$var$pickerContainerStyles,
            // Since the onclick, onfocus are passed down, adding role="presentation" prevents typecheck errors.
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            label: label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            // FOr some reason, this and the below `styles` type error _only_ show
            // up when you alter some of the properties in the `selectComponents`
            // object. These errors are still present, and I suspect have always
            // been present, without changing the unrelated code. Ignoring as the
            // component still works as expected despite this error. And also
            // because the select refresh team may solve it later.
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $5RLF6.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9KnKW.IdProvider), {
            prefix: "open-calendar-label--"
        }, ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: [
                    $19201d0a1f7d7d54$var$iconContainerStyles,
                    value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                ]
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                appearance: "subtle",
                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                id: openCalendarLabelId,
                icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(this.CalendarIcon, {
                        ...iconProps,
                        ...(0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? {
                            color: "var(--ds-icon, #44546F)"
                        } : {
                            primaryColor: "var(--ds-icon, #44546F)"
                        }
                    }),
                onClick: this.onCalendarButtonClick,
                onKeyDown: this.onCalendarButtonKeyDown,
                ref: this.calendarButtonRef,
                testId: testId && `${testId}--open-calendar-button`
            }))) : null));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});

parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");
function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
    name: "i3e4rp",
    styles: "margin-inline-start:var(--ds-space-400, 32px)"
};
const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
    name: "19a3ait",
    styles: "margin-inline-start:var(--ds-space-300, 24px)"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).IndicatorsContainer, rest));

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");


var $k5uoT = parcelRequire("k5uoT");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $k5uoT.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9MHPe.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: // The mousedown event is required for a date selection to work when
        // the menu is opened via the calendar button. The reason why is
        // because there is a mousedown event on the menu inside of
        // `react-select` that will stop the calendar select event from
        // firing. This is passed in via the `innerProps`. Therefore, we must
        // pass it in *after* the `innerProps` spread.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $e800a879ee1613fc$var$menuStyles,
            ...innerProps,
            onMouseDown: onMenuMouseDown
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1f0Hs.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $16abbcd9b9109722$var$styles.box,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $414Wj.default), {
        space: "space.150"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ePz3p.default // The month number needs to be translated to index in the month
    ), {
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextMonthHeading: getNextMonthHeading(),
        nextYearHeading: getNextYearHeading(),
        previousMonthHeading: getPreviousMonthHeading(),
        previousYearHeading: getPreviousYearHeading(),
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $avO9B.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lJWdi.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    }))))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("414Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $452354e10b30c8d8$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $452354e10b30c8d8$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $452354e10b30c8d8$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $452354e10b30c8d8$var$styles.hug, grow === 'fill' && $452354e10b30c8d8$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$452354e10b30c8d8$var$Stack.displayName = 'Stack';
var $452354e10b30c8d8$export$2e2bcd8739ae039 = $452354e10b30c8d8$var$Stack;

});

parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, (0, $VSDnB.fg)('dst-a11y-add-year-buttons-to-calendar') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevYearInteraction,
        testId: testId && `${testId}--previous-year`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
        label: `${previousYearLabel}, ${previousYearHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), (0, $VSDnB.fg)('dst-a11y-add-year-buttons-to-calendar') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextYearInteraction,
        testId: testId && `${testId}--next-year`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
        label: `${nextYearLabel}, ${nextYearHeading}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6s76W))),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    })));
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e9bde9ffb1901db299d24420ed3d13>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 10.5 6 6l4.5-4.5m-4.75 9L1.25 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71b79966080ec94bc04e328878ca72a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.5 10.5 6 6 1.5 1.5m4.75 9 4.5-4.5-4.5-4.5"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6122da5228d1f3e4cce8be42702737a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});



parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h581D.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1q4y8.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ $5uXOq.createElement("button", {
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
        className: (0, $bwpsq.default)([
            "_kkk2n7od _1yt41qfp _2rko1l7b _11c81oud _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
            isSibling && "_syaz1wmz _30l31wmz",
            isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
            isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
            isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
            isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
        ])
    }, day));
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- TODO: Allow pass-through from `props.xcss`
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
            padding: "space.100",
            xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});



parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $cTemL = parcelRequire("cTemL");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
};
const $48f5b21daaca02ab$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $48f5b21daaca02ab$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: 'color.text.subtlest',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    transition: `color 150ms`,
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.400'
});
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.050'
});
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.025'
});
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const CalendarIcon = (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? (0, (/*@__PURE__*/$parcel$interopDefault($acknU))) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    (0, (/*@__PURE__*/$parcel$interopDefault($cTemL)));
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false);
            // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso);
        // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            });
            // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase();
        // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
        // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    };
    // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    };
    // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref;
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
    };
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null;
    // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return(// These event handlers must be on this element because the events come
    // from different child elements.
    // Until innerProps is removed, it must remain a div rather than a primitive component.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...innerProps,
        css: $48f5b21daaca02ab$var$pickerContainerStyles,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        // Since the onclick, onfocus are passed down, adding role="presentation" prevents typecheck errors.
        role: "presentation"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
        appearance: appearance,
        "aria-describedby": ariaDescribedBy,
        label: label || undefined,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        closeMenuOnSelect: true,
        // For some reason, this and the below `styles` type error _only_ show
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $5RLF6.getPlaceholder)({
            placeholder: placeholder,
            l10n: l10n
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: mergedStyles,
        value: initialValue,
        ...selectProps,
        // These are below the spread because I don't know what is in
        // selectProps or not and what wil be overwritten
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        // These aren't part of `Select`'s API, but we're using them here.
        // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
    }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: [
            $48f5b21daaca02ab$var$iconContainerStyles,
            value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        appearance: "subtle",
        label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
        "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
        id: openCalendarLabelId,
        icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(CalendarIcon, {
                ...iconProps,
                ...(0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? {
                    color: "var(--ds-icon, #44546F)"
                } : {
                    primaryColor: "var(--ds-icon, #44546F)"
                }
            }),
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && `${testId}--open-calendar-button`
    })) : null));
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("hB1kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24b25c52c40a49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $9d24b25c52c40a49$var$DatePicker = (0, $cKsfY.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $9d24b25c52c40a49$var$packageName = "platform-pkg";
const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
const $9d24b25c52c40a49$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $9d24b25c52c40a49$var$packageName,
    packageVersion: $9d24b25c52c40a49$var$packageVersion
};
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $9d24b25c52c40a49$var$datePickerContainerStyles = (0, $8CUq3.xcss)({
    flexBasis: '50%',
    flexGrow: 1,
    flexShrink: 0
});
const $9d24b25c52c40a49$var$timePickerContainerStyles = (0, $8CUq3.xcss)({
    flexBasis: '50%',
    flexGrow: 1
});
const $9d24b25c52c40a49$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexBasis: 'inherit'
});
// react-select overrides (via @atlaskit/select).
const $9d24b25c52c40a49$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time';
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $9d24b25c52c40a49$var$DateTimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$9d24b25c52c40a49$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
    };
    // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8JNJx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9d24b25c52c40a49$var$datePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d24b25c52c40a49$var$DatePicker, {
        appearance: appearance,
        "aria-describedby": datePickerAriaDescribedBy,
        autoFocus: datePickerProps.autoFocus || autoFocus,
        dateFormat: datePickerProps.dateFormat,
        defaultIsOpen: datePickerProps.defaultIsOpen,
        defaultValue: datePickerProps.defaultValue,
        disabled: datePickerProps.disabled,
        disabledDateFilter: datePickerProps.disabledDateFilter,
        formatDisplayLabel: datePickerProps.formatDisplayLabel,
        hideIcon: datePickerProps.hideIcon || true,
        icon: datePickerProps.icon,
        id: datePickerProps.id || id,
        innerProps: datePickerProps.innerProps,
        inputLabel: datePickerProps.inputLabel,
        inputLabelId: datePickerProps.inputLabelId,
        isDisabled: datePickerProps.isDisabled || isDisabled,
        isInvalid: datePickerProps.isInvalid || isInvalid,
        isOpen: datePickerProps.isOpen,
        isRequired: datePickerProps.isRequired || isRequired,
        label: datePickerLabel,
        locale: datePickerProps.locale || locale,
        maxDate: datePickerProps.maxDate,
        minDate: datePickerProps.minDate,
        name: datePickerProps.name,
        nextMonthLabel: datePickerProps.nextMonthLabel,
        onBlur: onDateBlur,
        onChange: onDateChange,
        onFocus: onDateFocus,
        openCalendarLabel: datePickerProps.openCalendarLabel,
        parseInputValue: datePickerProps.parseInputValue,
        placeholder: datePickerProps.placeholder,
        previousMonthLabel: datePickerProps.previousMonthLabel,
        selectProps: mergedDatePickerSelectProps,
        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
        spacing: datePickerProps.spacing || spacing,
        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
        value: dateValue,
        weekStartDay: datePickerProps.weekStartDay
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9d24b25c52c40a49$var$timePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        appearance: timePickerProps.appearance || appearance,
        "aria-describedby": timePickerAriaDescribedBy,
        autoFocus: timePickerProps.autoFocus,
        defaultIsOpen: timePickerProps.defaultIsOpen,
        defaultValue: timePickerProps.defaultValue,
        formatDisplayLabel: timePickerProps.formatDisplayLabel,
        hideIcon: timePickerProps.hideIcon || true,
        id: timePickerProps.id,
        innerProps: timePickerProps.innerProps,
        isDisabled: timePickerProps.isDisabled || isDisabled,
        isInvalid: timePickerProps.isInvalid || isInvalid,
        isOpen: timePickerProps.isOpen,
        isRequired: timePickerProps.isRequired || isRequired,
        label: timePickerLabel,
        locale: timePickerProps.locale || locale,
        name: timePickerProps.name,
        onBlur: onTimeBlur,
        onChange: onTimeChange,
        onFocus: onTimeFocus,
        parseInputValue: timePickerProps.parseInputValue,
        placeholder: timePickerProps.placeholder,
        selectProps: mergedTimePickerSelectProps,
        spacing: timePickerProps.spacing || spacing,
        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
        timeFormat: timePickerProps.timeFormat,
        timeIsEditable: timePickerProps.timeIsEditable,
        times: timePickerProps.times,
        value: timeValue
    })), isClearable && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $9d24b25c52c40a49$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        label: clearControlLabel,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                ...iconProps,
                color: "var(--ds-text-subtlest, #626F86)",
                LEGACY_size: "small"
            }),
        onClick: onClear,
        testId: testId && `${testId}--icon--container`,
        tabIndex: -1
    })) : null);
});
var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;

});


parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $itpgN = parcelRequire("itpgN");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});

parcelRegister("5XoGW", function(module, exports) {

$parcel$export(module.exports, "isRequired", () => $fb82f1a21cb63744$export$669b575c90eb8624);
$parcel$export(module.exports, "isMaxCharacterCount", () => $fb82f1a21cb63744$export$979681787ea99873);
$parcel$export(module.exports, "useValidators", () => $fb82f1a21cb63744$export$eeef3a222667930f);
$parcel$export(module.exports, "isValidEmail", () => $fb82f1a21cb63744$export$371e338370561054);
$parcel$export(module.exports, "isValidUrl", () => $fb82f1a21cb63744$export$bef94a5618bf18bf);
$parcel$export(module.exports, "matchesRegex", () => $fb82f1a21cb63744$export$c0225c6191cf5821);

var $koVbs = parcelRequire("koVbs");

var $5cy7c = parcelRequire("5cy7c");
function $fb82f1a21cb63744$export$fce6876652108ab(value) {
    return typeof value === 'undefined';
}
function $fb82f1a21cb63744$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
const $fb82f1a21cb63744$export$7fbbfbca30081d0 = (value)=>{
    const regExp = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i);
    return regExp.test(value);
};
const $fb82f1a21cb63744$export$8304a22d431f958 = (value)=>{
    try {
        new URL(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $fb82f1a21cb63744$export$a0a81dc3380ce7d3 = (value)=>Number(value).valueOf();
const $fb82f1a21cb63744$export$669b575c90eb8624 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (value === null || typeof value === 'undefined' || value === '') return message ?? formatMessage((0, $5cy7c.messages).requiredMessage);
            if ($fb82f1a21cb63744$export$43bee75e5e14138e(value) && value.length === 0) return message ?? formatMessage((0, $5cy7c.messages).requiredMessage);
        };
const $fb82f1a21cb63744$export$979681787ea99873 = (limit, message)=>({ formatMessage: formatMessage })=>(value)=>$fb82f1a21cb63744$export$fce6876652108ab(value) || value.length <= limit ? undefined : message ?? formatMessage((0, $5cy7c.messages).validMaxLengthMessage);
const $fb82f1a21cb63744$export$eeef3a222667930f = (validators)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (value)=>{
        if (!validators?.length) return;
        return validators.reduce((acc, validator)=>acc.then((error)=>error || validator({
                    formatMessage: formatMessage
                })(value)), Promise.resolve(undefined));
    };
};
const $fb82f1a21cb63744$export$371e338370561054 = (message)=>({ formatMessage: formatMessage })=>(value)=>value === '' || $fb82f1a21cb63744$export$7fbbfbca30081d0(value) ? undefined : message ?? formatMessage((0, $5cy7c.messages).invalidEmailMessage);
const $fb82f1a21cb63744$export$bef94a5618bf18bf = (message)=>({ formatMessage: formatMessage })=>(value)=>$fb82f1a21cb63744$export$fce6876652108ab(value) || value === '' || $fb82f1a21cb63744$export$8304a22d431f958(value) ? undefined : message ?? formatMessage((0, $5cy7c.messages).invalidUrlMessage);
const $fb82f1a21cb63744$export$c0225c6191cf5821 = (regex, message)=>({ formatMessage: formatMessage })=>(value)=>!$fb82f1a21cb63744$export$fce6876652108ab(value) && regex.test(value) ? undefined : formatMessage(message);

});
parcelRegister("5cy7c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d1058a39353dc677$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d1058a39353dc677$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    requiredMessage: {
        id: `eoc.common.validators.requiredMessage`,
        defaultMessage: `This field is required`,
        description: 'The text will be displayed in required form fields'
    },
    validMaxLengthMessage: {
        id: `eoc.common.validators.validMaxLengthMessage`,
        defaultMessage: `You have exceeded the maximum character limit`,
        description: 'The text will be displayed when maximum length for given text in form fields'
    },
    invalidEmailMessage: {
        id: `eoc.common.validators.invalidEmailMessage`,
        defaultMessage: `Please enter a valid e-mail`,
        description: 'The text will be displayed when given email is invalid in form fields'
    },
    invalidUrlMessage: {
        id: `eoc.common.validators.invalidUrlMessage`,
        defaultMessage: `Please enter a valid url`,
        description: 'The text will be displayed when given url is invalid in form fields'
    }
});

});


parcelRegister("9YkY7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f7411fb472c2976d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f7411fb472c2976d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    error: {
        id: 'eoc-schedule-common.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule-common.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    noOne: {
        id: 'eoc-schedule-common.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    team: {
        id: 'eoc-schedule-common.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule-common.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule-common.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    formerUser: {
        id: 'eoc-schedule-common.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    teamDeleted: {
        id: 'eoc-schedule-common.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule-common.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule-common.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    missingResponder: {
        id: 'eoc-schedule-common.common.missing-responder',
        defaultMessage: 'Participant missing',
        description: 'Label that indicates there is missing responder.'
    },
    off: {
        id: 'eoc-schedule-common.common.off',
        defaultMessage: 'Off',
        description: 'An indicator for disabled schedule.'
    },
    on: {
        id: 'eoc-schedule-common.common.on',
        defaultMessage: 'On',
        description: 'An indicator for enabled schedule.'
    },
    noStartTime: {
        id: 'eoc-schedule-common.common.no-start-time',
        defaultMessage: 'Earlier than the current period',
        description: "Indicates that we are not able to show start time as period item doesn't fit to screen."
    },
    noEndTime: {
        id: 'eoc-schedule-common.common.no-end-time',
        defaultMessage: 'Later than the current period',
        description: "Indicates that we are not able to show end time as period item doesn't fit to screen."
    },
    from: {
        id: 'eoc-schedule-common.common.from',
        defaultMessage: 'From',
        description: 'Label that "from" side of a range'
    },
    to: {
        id: 'eoc-schedule-common.common.to',
        defaultMessage: 'To',
        description: 'Label that "to" side of a range'
    },
    rotation: {
        id: 'eoc-schedule-common.common.rotation',
        defaultMessage: 'Rotation',
        description: 'Label for rotation field.'
    },
    calendarLayer: {
        id: 'eoc-schedule-common.common.calendar-layer',
        defaultMessage: 'Calendar layer',
        description: 'Label for calendar layer field.'
    },
    timelineLayer: {
        id: 'eoc-schedule-common.common.timeline-layer',
        defaultMessage: 'Timeline layer',
        description: 'Label for timeline layer field.'
    },
    timelineView: {
        id: 'eoc-schedule-common.common.timeline-view',
        defaultMessage: 'Timeline view',
        description: 'Schedule timeline view option label'
    },
    calendarView: {
        id: 'eoc-schedule-common.common.calendar-view',
        defaultMessage: 'Calendar view',
        description: 'Schedule calendar view option label'
    },
    inSchedule: {
        id: 'eoc-schedule-common.common.in-schedule',
        defaultMessage: '{prefix} in schedule {scheduleName}',
        description: 'Label for in schedule.'
    },
    day: {
        id: 'eoc-schedule-common.common.day',
        defaultMessage: 'day',
        description: 'Label for day period.'
    },
    week: {
        id: 'eoc-schedule-common.common.week',
        defaultMessage: 'week',
        description: 'Label for week period.'
    },
    month: {
        id: 'eoc-schedule-common.common.month',
        defaultMessage: 'month',
        description: 'Label for month period.'
    },
    oneDay: {
        id: 'eoc-schedule-common.common.one-day',
        defaultMessage: '1 day',
        description: 'Label for seeing periods in the range of 1 day.'
    },
    oneWeek: {
        id: 'eoc-schedule-common.common.one-week',
        defaultMessage: '1 week',
        description: ' Label for seeing periods in the range of 1 week.'
    },
    twoWeeks: {
        id: 'eoc-schedule-common.common.two-weeks',
        defaultMessage: '2 weeks',
        description: ' Label for seeing periods in the range of 2 weeks.'
    },
    oneMonth: {
        id: 'eoc-schedule-common.common.one-month',
        defaultMessage: '1 month',
        description: ' Label for seeing periods in the range of 1 month.'
    },
    yourShifts: {
        id: 'eoc-schedule-common.common.your-shifts',
        defaultMessage: 'Your shifts',
        description: 'Label for your shifts.'
    },
    selectTimelineView: {
        id: 'eoc-schedule-common.common.select-timeline-view',
        defaultMessage: 'Select the timeline period for schedule {scheduleName}',
        description: 'Label for selecting timeline view.'
    },
    selectScheduleView: {
        id: 'eoc-schedule-common.common.select-schedule-view',
        defaultMessage: 'Select schedule view type for schedule {scheduleName}',
        description: 'Label for selecting schedule view.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule-common.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Title for quick override card.'
    },
    selectionCount: {
        id: 'eoc-schedule-common.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    confirmProceed: {
        id: 'eoc-schedule-common.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    base: {
        id: 'eoc-schedule-common.common.base',
        defaultMessage: 'Base',
        description: 'Base layer view of a schedule'
    },
    forwarding: {
        id: 'eoc-schedule-common.common.forwarding',
        defaultMessage: 'Forwarding',
        description: 'Forwarding layer view of a schedule'
    },
    final: {
        id: 'eoc-schedule-common.common.final',
        defaultMessage: 'Final',
        description: 'Final layer view of a schedule'
    },
    search: {
        id: 'eoc-schedule-common.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    participants: {
        id: 'eoc-schedule-common.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule-common.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule-common.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    noneGlobalSchedule: {
        id: 'eoc-schedule-common.common.none-global-schedule',
        defaultMessage: 'None (Global schedule)',
        description: 'Label for global schedule that is not owned by any team.'
    },
    noneGlobalScheduleBold: {
        id: 'eoc-schedule-common.common.none-global-schedule-bold',
        defaultMessage: '<bold>None</bold> (Global schedule)',
        description: 'Label for global schedule that is not owned by any team.'
    },
    /*
   Common button related messages
  */ nextPeriod: {
        id: 'eoc-schedule-common.common.next-period',
        defaultMessage: 'Next {period}',
        description: 'Button for going to next period. Ex. Next 2 weeks'
    },
    previousPeriod: {
        id: 'eoc-schedule-common.common.previous-period',
        defaultMessage: 'Previous {period}',
        description: 'Button for going to previous period. Ex. Previous month'
    },
    showAllLayers: {
        id: 'eoc-schedule-common.common.show-all-layers',
        defaultMessage: 'Show all layers',
        description: 'Button for showing all layers of schedule.'
    },
    showLessLayers: {
        id: 'eoc-schedule-common.common.show-less-layers',
        defaultMessage: 'Show less layers',
        description: 'Button for showing less layers of schedule.'
    },
    cancel: {
        id: 'eoc-schedule-common.common.cancel',
        defaultMessage: 'Cancel',
        description: 'Button for cancelling an action.'
    },
    close: {
        id: 'eoc-schedule-common.common.close',
        defaultMessage: 'Close',
        description: 'Button for closing modal or dialog.'
    },
    today: {
        id: 'eoc-schedule-common.common.today',
        defaultMessage: 'Today',
        description: 'Buttom for navigating to today.'
    },
    override: {
        id: 'eoc-schedule-common.common.override',
        defaultMessage: 'Override',
        description: 'Button for adding override.'
    },
    save: {
        id: 'eoc-schedule-common.common.save',
        defaultMessage: 'Save',
        description: 'Buttom for saving changes.'
    },
    confirm: {
        id: 'eoc-schedule-common.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    discard: {
        id: 'eoc-schedule-common.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    moreActionsForSchedule: {
        id: 'eoc-schedule-common.common.more-actions-for-schedule',
        defaultMessage: 'More actions for schedule {scheduleName}',
        description: 'Button for schedule settings.'
    },
    loadMore: {
        id: 'eoc-schedule-common.common.loadMore',
        defaultMessage: 'Load more',
        description: 'Button for loading more schedules.'
    },
    replaceWith: {
        id: 'eoc-schedule-common.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'Button for opening popup for replacing a participant.'
    },
    remove: {
        id: 'eoc-schedule-common.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing schedule or rotation.'
    },
    delete: {
        id: 'eoc-schedule-common.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    edit: {
        id: 'eoc-schedule-common.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule-common.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    /*
   Common start and end related messages
  */ start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule-common.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule-common.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule-common.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule-common.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule-common.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule-common.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule-common.common.start-later-end',
        defaultMessage: 'Start time should be earlier than the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule-common.common.end-earlier-start',
        defaultMessage: 'End time should be later than the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule-common.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule-common.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    /*
	 Common feedback related messages
	*/ exportTimelineErrorTitle: {
        id: 'eoc-schedule-common.common.export-timeline-error-title',
        defaultMessage: "We couldn't export your schedule.",
        description: 'This message indicates that our back-end services did not respond when exporting schedule.'
    },
    exportTimelineSuccessTitle: {
        id: 'eoc-schedule-common.common.export-timeline-success-title',
        defaultMessage: 'Your schedule is successfully exported.',
        description: 'This message indicates schedule is successfully exported.'
    },
    updateScheduleErrorTitle: {
        id: 'eoc-schedule-common.common.update-schedule-error-title',
        defaultMessage: "We couldn't update your schedule.",
        description: 'This message indicates that our back-end services did not respond when updating schedule.'
    },
    deleteScheduleSuccessTitle: {
        id: 'eoc-schedule-common.common.delete-schedule-success-title',
        defaultMessage: 'Your schedule is successfully deleted.',
        description: 'This message indicates schedule is successfully deleted.'
    },
    deleteScheduleErrorTitle: {
        id: 'eoc-schedule-common.common.delete-schedule-error-title',
        defaultMessage: "We couldn't delete your schedule.",
        description: 'This message indicates that our back-end services did not respond when deleting schedule.'
    },
    createScheduleErrorTitle: {
        id: 'eoc-schedule-common.common.create-schedule-error-title',
        defaultMessage: "We couldn't create your schedule.",
        description: 'This message indicates that our back-end services did not respond when creating schedule.'
    },
    createScheduleSuccessTitle: {
        id: 'eoc-schedule-common.common.create-schedule-success-title',
        defaultMessage: "You\u2019ve created a new schedule",
        description: 'This message indicates schedule is successfully created.'
    },
    createScheduleSuccessDescription: {
        id: 'eoc-schedule-common.common.create-schedule-success-description',
        defaultMessage: 'Continue to configure this schedule by adding participants and rotation details.',
        description: 'This message indicates schedule is successfully created.'
    },
    cloneScheduleErrorTitle: {
        id: 'eoc-schedule-common.common.clone-schedule-error-title',
        defaultMessage: "We couldn't duplicate your schedule.",
        description: 'This message indicates that our back-end services did not respond when duplicating schedule.'
    },
    cloneScheduleSuccessTitle: {
        id: 'eoc-schedule-common.common.clone-schedule-success-title',
        defaultMessage: "You've duplicated the schedule.",
        description: 'This message indicates schedule is successfully duplicated.'
    },
    /*
	 Common dropdown actions related messages
	*/ export: {
        id: 'eoc-schedule-common.common.export',
        defaultMessage: 'Export',
        description: 'Export schedule option in the dropdown'
    },
    turnOn: {
        id: 'eoc-schedule-common.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Turn on schedule option in the dropdown'
    },
    turnOff: {
        id: 'eoc-schedule-common.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Turn off schedule option in the dropdown'
    },
    /*
	 Create & duplicate schedule related messages
	*/ createSchedule: {
        id: 'eoc-schedule-common.common.create-schedule',
        defaultMessage: 'Create schedule',
        description: 'Create a new schedule title.'
    },
    scheduleName: {
        id: 'eoc-schedule-common.common.schedule-name',
        defaultMessage: 'Schedule name',
        description: 'Text field label for schedule name.'
    },
    description: {
        id: 'eoc-schedule-common.common.description',
        defaultMessage: 'Description',
        description: 'Text field label for schedule description.'
    },
    timezone: {
        id: 'eoc-schedule-common.common.timezone',
        defaultMessage: 'Timezone',
        description: 'Text field label for schedule timezone.'
    },
    create: {
        id: 'eoc-schedule-common.common.create',
        defaultMessage: 'Create',
        description: 'A create button for create schedule.'
    },
    copyOfScheduleName: {
        id: 'eoc-schedule-common.common.copy-of-schedule-name',
        defaultMessage: 'Copy of {scheduleName}',
        description: 'Automatically generated cloned schedule name. Ex. Copy of Paid Schedule'
    },
    createScheduleFooter: {
        id: 'eoc-schedule-common.common.create-schedule-footer',
        defaultMessage: 'Save this schedule to add rotations and configure its details.',
        description: 'Footer text for create schedule.'
    }
});

});

parcelRegister("ksSWS", function(module, exports) {

$parcel$export(module.exports, "TimezoneSelect", () => $0508dbfba43490ce$export$64c704ec3c95b80f);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $fdFPq = parcelRequire("fdFPq");
const $0508dbfba43490ce$export$64c704ec3c95b80f = (props)=>{
    const { timezones: timezones, loading: loading } = (0, $fdFPq.useTimezoneOptions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...props,
        options: timezones,
        isLoading: loading
    });
};

});
parcelRegister("fdFPq", function(module, exports) {

$parcel$export(module.exports, "useTimezoneOptions", () => $c9bd8997cf9c2768$export$381860a5efa5a10f);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");

var $dmLt8 = parcelRequire("dmLt8");

var $jOikx = parcelRequire("jOikx");
const $c9bd8997cf9c2768$export$381860a5efa5a10f = ()=>{
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $dmLt8.getTimezonesResource));
    const timezones = (0, $5uXOq.useMemo)(()=>data?.timezones.map((timezone)=>({
                value: timezone.id,
                offset: timezone.currentOffset,
                label: (0, $jOikx.formatTimezone)({
                    name: timezone.id,
                    offset: timezone.currentOffset,
                    variant: 'short'
                })
            }))?.sort((a, b)=>{
            if (a.value === b.value) return a.offset - b.offset;
            return a.value.localeCompare(b.value);
        }) ?? [], [
        data
    ]);
    const getTimezoneOption = (0, $5uXOq.useCallback)(({ offset: offset, timeZone: timeZone } = {})=>{
        if (!timezones.length) return {};
        if (timeZone) return timezones.find(({ value: value })=>value === timeZone);
        if (offset) return timezones.find(({ offset: tzOffset })=>tzOffset === offset);
        // TODO: use Jira user timezone
        return timezones.find(({ value: value })=>value === (0, $jOikx.guessTimeZone)()) ?? timezones[0];
    }, [
        timezones
    ]);
    return {
        timezones: timezones,
        loading: loading,
        getTimezoneOption: getTimezoneOption
    };
};

});


parcelRegister("3ogs7", function(module, exports) {

$parcel$export(module.exports, "AutoCompleteWithNoOne", () => $bc709e57298aebd5$export$92d6cd56d3530473);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $d7FF4 = parcelRequire("d7FF4");

var $5IIdi = parcelRequire("5IIdi");

var $cNMw5 = parcelRequire("cNMw5");

var $bKi9r = parcelRequire("bKi9r");

var $eUcQs = parcelRequire("eUcQs");
const $bc709e57298aebd5$export$92d6cd56d3530473 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { id: id, ...rest } = props;
    const intlApi = (0, $koVbs.default)();
    const getAutoCompleteOptions = (0, $5IIdi.useAutoCompleteOptions)(props.endpoints);
    const [_, noOne] = (0, $5uXOq.useMemo)(()=>(0, $cNMw5.getNoOne)(intlApi), [
        intlApi
    ]);
    const getAutoCompleteOptionsWithNoOne = (0, $5uXOq.useCallback)(async (value)=>{
        const options = await getAutoCompleteOptions(value);
        return [
            ...options ?? [],
            noOne
        ];
    }, [
        getAutoCompleteOptions,
        noOne
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ...rest,
        ref: ref,
        inputId: id,
        menuPosition: "absolute",
        loadOptions: getAutoCompleteOptionsWithNoOne,
        components: {
            Option: (0, $eUcQs.CustomOption),
            Input: (0, $bKi9r.CustomInput),
            ...props.components
        }
    });
});

});
parcelRegister("cNMw5", function(module, exports) {

$parcel$export(module.exports, "getNoOne", () => $7bd786b94f971a53$export$fee790f685eeb3c8);
$parcel$export(module.exports, "getResponder", () => $7bd786b94f971a53$export$691e04a71bf259a4);

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");
/**
 * Get predefined values of type "noone" responder
 * @returns [ResponderNamesItem, AutoCompleteWithNoOneItem]
 */ const $7bd786b94f971a53$export$fee790f685eeb3c8 = (intlApi)=>[
        {
            id: (0, $aSTVt.REQUESTED_NO_ONE).id,
            type: (0, $aSTVt.REQUESTED_NO_ONE).type,
            name: intlApi.formatMessage((0, $jkGAf.messages).noOne),
            deleted: false
        },
        {
            label: intlApi.formatMessage((0, $jkGAf.messages).noOne),
            type: (0, $aSTVt.REQUESTED_NO_ONE).type,
            value: (0, $aSTVt.REQUESTED_NO_ONE).id,
            // NOTE: All override made with atlassianIdentifier so assuming no-one has atlassianIdentifier
            atlassianIdentifier: (0, $aSTVt.REQUESTED_NO_ONE).id
        }
    ];
const $7bd786b94f971a53$var$getDeletedResponderName = (type, intlApi)=>{
    switch(type){
        case 'user':
            return intlApi.formatMessage((0, $jkGAf.messages).formerUser);
        case 'escalation':
            return intlApi.formatMessage((0, $jkGAf.messages).deletedEscalation);
        case 'team':
        case 'group':
            return intlApi.formatMessage((0, $jkGAf.messages).teamDeleted);
        case 'schedule':
            return intlApi.formatMessage((0, $jkGAf.messages).deletedSchedule);
    }
};
/**
 * Get responder with fallback. (Handles type "noone")
 */ const $7bd786b94f971a53$export$691e04a71bf259a4 = (requested, recieved, intlApi)=>{
    // NOTE: Schedule BE is source of truth for deleted status and type
    const deleted = 'deleted' in requested ? requested.deleted : false;
    const type = requested.type;
    if (type === 'noone') {
        const [noOne] = $7bd786b94f971a53$export$fee790f685eeb3c8(intlApi);
        return noOne;
    }
    if (recieved.isError || recieved.isLoading) return {
        id: requested.id,
        type: type,
        deleted: deleted,
        name: deleted ? $7bd786b94f971a53$var$getDeletedResponderName(type, intlApi) : '',
        email: ''
    };
    if (deleted) return {
        ...recieved,
        deleted: deleted,
        name: recieved.name ?? $7bd786b94f971a53$var$getDeletedResponderName(type, intlApi)
    };
    return recieved;
};

});

parcelRegister("bKi9r", function(module, exports) {

$parcel$export(module.exports, "CustomInput", () => $8071bef25161f999$export$edb137763a395322);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $8071bef25161f999$export$edb137763a395322 = (props)=>{
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
};

});

parcelRegister("eUcQs", function(module, exports) {

$parcel$export(module.exports, "CustomOption", () => $a8579563b853d45f$export$bf9b4e708cea1760);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7sUFC = parcelRequire("7sUFC");
var $ujWmd = parcelRequire("ujWmd");

var $fTQ6p = parcelRequire("fTQ6p");

var $bZNwM = parcelRequire("bZNwM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $bChGW = parcelRequire("bChGW");

var $2wTTC = parcelRequire("2wTTC");
const $a8579563b853d45f$export$bf9b4e708cea1760 = (props)=>{
    const { data: data } = props;
    const intlApi = (0, $koVbs.default)();
    const responderOption = (0, $5uXOq.useMemo)(()=>{
        let defaultConfig = {
            primaryText: data.label
        };
        switch(data.type){
            case 'user':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        src: data.avatarUrl
                    }),
                    secondaryText: data.email
                };
            case 'escalation':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intlApi.formatMessage((0, $2wTTC.messages).escalation)
                    })
                };
            case 'schedule':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fTQ6p))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intlApi.formatMessage((0, $2wTTC.messages).schedule)
                    })
                };
            case 'noone':
                return {
                    ...defaultConfig,
                    avatar: null
                };
            case 'team':
                return {
                    ...defaultConfig,
                    avatar: data.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        src: data.avatarUrl
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intlApi.formatMessage((0, $2wTTC.messages).team)
                    })
                };
            default:
                throw new Error('Incorrect data type is provided or it is missing!');
        }
    }, [
        data.avatarUrl,
        data.email,
        data.label,
        data.type,
        intlApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
        avatar: responderOption.avatar,
        primaryText: responderOption.primaryText,
        secondaryText: responderOption.secondaryText
    }));
};

});
parcelRegister("2wTTC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $643389d4af6d9bea$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $643389d4af6d9bea$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    team: {
        id: 'eoc.schedule.common.ui.auto-complete-with-noone.custom-option.team-icon',
        defaultMessage: 'Group',
        description: 'Label of group icon that indicates responder is a group'
    },
    schedule: {
        id: 'eoc.schedule.common.ui.auto-complete-with-noone.custom-option.schedule-icon',
        defaultMessage: 'Calendar',
        description: 'Label of calendar icon that indicates responder is a schedule'
    },
    escalation: {
        id: 'eoc.schedule.common.ui.auto-complete-with-noone.custom-option.escalation-icon',
        defaultMessage: 'Chart',
        description: 'Label of chart icon that indicates responder is a escalation'
    }
});

});



parcelRegister("3NQti", function(module, exports) {

$parcel$export(module.exports, "useTimelineRotations", () => $cf05d5a5b44acc15$export$8915f3ac9e46c35e);
$parcel$export(module.exports, "useTimelineEpoch", () => $cf05d5a5b44acc15$export$4016af3fae14cd0);
$parcel$export(module.exports, "useTimelineLoading", () => $cf05d5a5b44acc15$export$2836e7771793415b);
$parcel$export(module.exports, "useSchedule", () => $cf05d5a5b44acc15$export$7ee40412d692b14f);
$parcel$export(module.exports, "useRotation", () => $cf05d5a5b44acc15$export$cdc1a43299ca92f);
$parcel$export(module.exports, "useHasDeleted", () => $cf05d5a5b44acc15$export$e59cf274b58211c7);

var $3sQ5x = parcelRequire("3sQ5x");

var $9It5A = parcelRequire("9It5A");

var $boZEu = parcelRequire("boZEu");
const $cf05d5a5b44acc15$export$8915f3ac9e46c35e = (0, $3sQ5x.createHook)((0, $9It5A.store), {
    selector: (0, $boZEu.selectors).getRotations
});
const $cf05d5a5b44acc15$export$4016af3fae14cd0 = (0, $3sQ5x.createHook)((0, $9It5A.store), {
    selector: (0, $boZEu.selectors).getEpoch
});
const $cf05d5a5b44acc15$export$2836e7771793415b = (0, $3sQ5x.createHook)((0, $9It5A.store), {
    selector: (0, $boZEu.selectors).getLoading
});
const $cf05d5a5b44acc15$export$7ee40412d692b14f = (0, $3sQ5x.createHook)((0, $9It5A.store), {
    selector: (0, $boZEu.selectors).getSchedule
});
const $cf05d5a5b44acc15$export$cdc1a43299ca92f = (0, $3sQ5x.createHook)((0, $9It5A.store), {
    selector: (0, $boZEu.selectors).getRotation
});
const $cf05d5a5b44acc15$export$e59cf274b58211c7 = (0, $3sQ5x.createHook)((0, $9It5A.store), {
    selector: (0, $boZEu.selectors).getHasDeleted
});

});
parcelRegister("boZEu", function(module, exports) {

$parcel$export(module.exports, "selectors", () => $7829ea6741b60bb5$export$e1252723db1c541);

var $6dDSs = parcelRequire("6dDSs");

var $5s9eT = parcelRequire("5s9eT");

var $lCzwW = parcelRequire("lCzwW");
// NOTE: Loadings, Rotations, Data, Epochs might be selected by single selector
const $7829ea6741b60bb5$var$getEpoch = (state)=>{
    if (state.selectedView === (0, $5s9eT.NavigationMode).Timeline) {
        const { startEpoch: startEpoch = 0, startOffset: startOffset = 0, endEpoch: endEpoch = 0, endOffset: endOffset = 0, nowEpoch: nowEpoch = 0, nowOffset: nowOffset = 0 } = state.timelineData || {};
        return {
            startEpoch: startEpoch,
            startOffset: startOffset,
            endEpoch: endEpoch,
            endOffset: endOffset,
            nowEpoch: nowEpoch,
            nowOffset: nowOffset
        };
    }
    if (state.selectedView === (0, $5s9eT.NavigationMode).Calendar) {
        const { startEpoch: startEpoch = 0, startOffset: startOffset = 0, endEpoch: endEpoch = 0, endOffset: endOffset = 0, nowEpoch: nowEpoch = 0, nowOffset: nowOffset = 0 } = state.calendarData || {};
        return {
            startEpoch: startEpoch,
            startOffset: startOffset,
            endEpoch: endEpoch,
            endOffset: endOffset,
            nowEpoch: nowEpoch,
            nowOffset: nowOffset
        };
    }
    return {
        startEpoch: 0,
        endEpoch: 0,
        startOffset: 0,
        endOffset: 0,
        nowEpoch: 0,
        nowOffset: 0
    };
};
// NOTE: should we filter past rotations
const $7829ea6741b60bb5$var$getRotations = (0, $6dDSs.createSelector)((state)=>state.selectedView, (state)=>state.timelineData, (state)=>state.calendarData, (view, timeline, calendar)=>{
    if (view === (0, $5s9eT.NavigationMode).Timeline) {
        if ((0, $lCzwW.isNullOrUndefined)(timeline)) return undefined;
        return timeline.defaultLayers.map(({ id: id, name: name })=>({
                id: id,
                name: name
            }));
    }
    if (view === (0, $5s9eT.NavigationMode).Calendar) {
        if ((0, $lCzwW.isNullOrUndefined)(calendar)) return undefined;
        const allRotations = new Map();
        for (const week of calendar.baseWeeks)for (const rotation of week.rotations)allRotations.set(rotation.id, rotation.name);
        return Array.from(allRotations.entries(), ([id, name])=>({
                id: id,
                name: name
            }));
    }
});
const $7829ea6741b60bb5$var$getSchedule = (state)=>{
    return state.schedule;
};
const $7829ea6741b60bb5$var$getRotation = (state)=>{
    return state.rotation;
};
const $7829ea6741b60bb5$var$getHasDeleted = (state)=>{
    let hasDeletedResponders = false;
    if (state.selectedView === (0, $5s9eT.NavigationMode).Timeline) hasDeletedResponders = state?.timelineData?.hasDeletedResponders ?? false;
    if (state.selectedView === (0, $5s9eT.NavigationMode).Calendar) hasDeletedResponders = state?.calendarData?.hasDeletedResponders ?? false;
    return hasDeletedResponders;
};
const $7829ea6741b60bb5$var$getLoading = (state)=>{
    let isInitialLoading = false;
    const isLoading = state.getTimelineLoading;
    if (state.selectedView === (0, $5s9eT.NavigationMode).Timeline) isInitialLoading = (0, $lCzwW.isNullOrUndefined)(state.timelineData) && state.getTimelineLoading;
    if (state.selectedView === (0, $5s9eT.NavigationMode).Calendar) isInitialLoading = (0, $lCzwW.isNullOrUndefined)(state.calendarData) && state.getTimelineLoading;
    return {
        isLoading: isLoading,
        isInitialLoading: isInitialLoading,
        isSubsequentLoading: !isInitialLoading && isLoading
    };
};
const $7829ea6741b60bb5$export$e1252723db1c541 = {
    getSchedule: $7829ea6741b60bb5$var$getSchedule,
    getEpoch: $7829ea6741b60bb5$var$getEpoch,
    getRotations: $7829ea6741b60bb5$var$getRotations,
    getLoading: $7829ea6741b60bb5$var$getLoading,
    getRotation: $7829ea6741b60bb5$var$getRotation,
    getHasDeleted: $7829ea6741b60bb5$var$getHasDeleted
};

});


parcelRegister("csGzA", function(module, exports) {

$parcel$export(module.exports, "partitionDate", () => $5932e8f8e0cbe995$export$6943f6d465e2abc1);
$parcel$export(module.exports, "formatting", () => $5932e8f8e0cbe995$export$e8eb56737f1ebbe8);

var $k7m40 = parcelRequire("k7m40");

var $jj52j = parcelRequire("jj52j");
const $5932e8f8e0cbe995$export$6943f6d465e2abc1 = (date)=>{
    return {
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        month: date.getMonth(),
        year: date.getFullYear()
    };
};
const $5932e8f8e0cbe995$export$e8eb56737f1ebbe8 = {
    /**
	 * Formats date to date hour minute string
	 * @param date - Date | number
	 * @return time - string - Ex. '2024/08/21 08:00'
	 */ toDateHourMinute: (date)=>{
        if (typeof date === 'string') date = new Date(date);
        return (0, $k7m40.default)(date, 'yyyy/MM/dd HH:mm');
    },
    /**
	 * Formats date to ISO string
	 * @param date - Date | number
	 * @return time - string - Ex. '2024-08-21T08:00:00+00:00'
	 */ toISO: (date)=>{
        if (typeof date === 'string') date = new Date(date);
        return (0, $jj52j.default)(date);
    }
};

});

parcelRegister("6EibS", function(module, exports) {

$parcel$export(module.exports, "confirmTextButtons", () => $a21b54e74884ba5b$export$a090e1efcbc9ea2e);

var $jkGAf = parcelRequire("jkGAf");

var $lNHZW = parcelRequire("lNHZW");
const $a21b54e74884ba5b$export$a090e1efcbc9ea2e = (intlApi)=>({
        [(0, $lNHZW.OverrideVariant).Edit]: intlApi.formatMessage((0, $jkGAf.messages).saveButton),
        [(0, $lNHZW.OverrideVariant).Add]: intlApi.formatMessage((0, $jkGAf.messages).overrideButton),
        [(0, $lNHZW.OverrideVariant).Customize]: intlApi.formatMessage((0, $jkGAf.messages).saveButton)
    });

});

parcelRegister("er6tx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $64c4e8ae3bfff56c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $64c4e8ae3bfff56c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addTitle: {
        id: 'eoc-schedule.ui.list.add-override.add-title',
        defaultMessage: 'Override',
        description: 'Title for add override modal.'
    },
    editTitle: {
        id: 'eoc-schedule.ui.list.add-override.edit-title',
        defaultMessage: 'Edit Override',
        description: 'Title for edit override modal.'
    },
    customizeTitle: {
        id: 'eoc-schedule.ui.list.add-override.customize-title',
        defaultMessage: 'Override',
        description: 'Title for customize override modal.'
    },
    timezone: {
        id: 'eoc-schedule.ui.list.add-override.timezone',
        defaultMessage: 'Timezone',
        description: 'Label for override timezone.'
    },
    allRotations: {
        id: 'eoc-schedule.ui.list.add-override.all-rotations',
        defaultMessage: 'All Rotations',
        description: 'Placeholder when all rotations are selected for override.'
    },
    overrideShiftParticipantWith: {
        id: 'eoc-schedule.ui.list.add-override.override-shift-participant-with',
        defaultMessage: 'Override shift participant with',
        description: 'Label for field that indicates which participant is overriding.'
    },
    selectRotation: {
        id: 'eoc-schedule.ui.list.add-override.select-rotation',
        defaultMessage: 'Select rotation',
        description: 'Label for select a rotation field.'
    },
    override: {
        id: 'eoc-schedule.ui.list.add-override.override',
        defaultMessage: 'Override {label}',
        description: 'Prefix for labels. Ex. override start time, override end time.'
    }
});

});

parcelRegister("gSPFA", function(module, exports) {

$parcel$export(module.exports, "FirstField", () => $93f12028e034a27a$export$d27f189f8944998c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $93f12028e034a27a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93f12028e034a27a$export$d27f189f8944998c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "etgxuuy0"
})({
    name: "keyfe3",
    styles: "margin-top:var(--ds-space-negative-100, -8px)"
});

});

parcelRegister("k3fl7", function(module, exports) {

$parcel$export(module.exports, "formatDateForProp", () => $c3d91af826e85a19$export$1e167b6d9d6f8f8);
$parcel$export(module.exports, "convertRotationsToOptions", () => $c3d91af826e85a19$export$874178f3beae0a52);
$parcel$export(module.exports, "useDefaultValues", () => $c3d91af826e85a19$export$7df8a7696a8980e2);
$parcel$export(module.exports, "useDefaultUser", () => $c3d91af826e85a19$export$46aad2de444a3ef4);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("hfWo4");
var $9zpvl = parcelRequire("9zpvl");

var $7XUeK = parcelRequire("7XUeK");

var $koVbs = parcelRequire("koVbs");

var $fXc9u = parcelRequire("fXc9u");

var $jOikx = parcelRequire("jOikx");
var $cP0uo = parcelRequire("cP0uo");
var $fdFPq = parcelRequire("fdFPq");

var $lNHZW = parcelRequire("lNHZW");

var $3NQti = parcelRequire("3NQti");

var $1bRoC = parcelRequire("1bRoC");

var $cNMw5 = parcelRequire("cNMw5");

var $lCzwW = parcelRequire("lCzwW");
const $c3d91af826e85a19$export$1e167b6d9d6f8f8 = (epoch)=>(0, $9zpvl.default)(new Date(epoch), 'yyyy-MM-dd');
const $c3d91af826e85a19$export$874178f3beae0a52 = (rotations)=>(rotations ?? []).map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $c3d91af826e85a19$export$7df8a7696a8980e2 = ({ variant: variant, base: base, schedule: schedule })=>{
    const { getTimezoneOption: getTimezoneOption } = (0, $fdFPq.useTimezoneOptions)();
    const [{ nowEpoch: nowEpoch, nowOffset: nowOffset }] = (0, $3NQti.useTimelineEpoch)();
    const [rotations] = (0, $3NQti.useTimelineRotations)();
    const defaults = (0, $5uXOq.useMemo)(()=>{
        const timezone = getTimezoneOption({
            timeZone: schedule.timezone
        });
        switch(variant){
            case (0, $lNHZW.OverrideVariant).Add:
                return {
                    start: (0, $jOikx.conversion).toLocal(nowEpoch, nowOffset).toISOString(),
                    end: (0, $jOikx.conversion).toLocal((0, $7XUeK.default)(nowEpoch, 1).valueOf(), nowOffset).toISOString(),
                    rotation: [],
                    timezone: timezone
                };
            case (0, $lNHZW.OverrideVariant).Edit:
            case (0, $lNHZW.OverrideVariant).Customize:
                {
                    const options = $c3d91af826e85a19$export$874178f3beae0a52(rotations);
                    return {
                        start: (0, $jOikx.conversion).toLocal(base.startEpoch, base.startOffset).toISOString(),
                        end: (0, $jOikx.conversion).toLocal(base.endEpoch, base.endOffset).toISOString(),
                        rotation: base.rotations.map(({ id: id, name: name })=>({
                                value: id,
                                label: name ?? options.find(({ value: value })=>id === value).label
                            })),
                        timezone: timezone
                    };
                }
        }
    }, [
        base,
        getTimezoneOption,
        nowEpoch,
        nowOffset,
        rotations,
        schedule.timezone,
        variant
    ]);
    return defaults;
};
const $c3d91af826e85a19$export$46aad2de444a3ef4 = ({ variant: variant, base: base })=>{
    const intlApi = (0, $koVbs.default)();
    const current = (0, $1bRoC.useCurrentUser)();
    // NOTE: baseUser can be undefined in Customize and Add
    const [baseUser] = (0, $fXc9u.useResponderNames)(base?.responder ? (0, $cP0uo.filterNoOne)([
        base.responder
    ]) : []);
    const initial = (0, $5uXOq.useMemo)(()=>({
            isLoading: baseUser?.isLoading ?? false,
            isError: baseUser?.isError ?? false,
            user: (0, $lCzwW.isEmpty)(baseUser) || baseUser?.isError || baseUser?.isLoading ? undefined : {
                value: baseUser.id,
                label: baseUser.name,
                atlassianIdentifier: baseUser.atlassianIdentifier,
                type: 'user'
            }
        }), [
        baseUser
    ]);
    const isNoOne = base?.responder?.type === 'noone';
    const noOne = (0, $5uXOq.useMemo)(()=>{
        const [, noBody] = (0, $cNMw5.getNoOne)(intlApi);
        return {
            isLoading: false,
            isError: false,
            user: noBody
        };
    }, [
        intlApi
    ]);
    switch(variant){
        case (0, $lNHZW.OverrideVariant).Add:
            return current;
        case (0, $lNHZW.OverrideVariant).Customize:
            if ((0, $lCzwW.isEmpty)(base?.responder)) return current;
            else if (isNoOne) return noOne;
            else return initial;
        case (0, $lNHZW.OverrideVariant).Edit:
            if (isNoOne) return noOne;
            else return initial;
    }
};

});
parcelRegister("hfWo4", function(module, exports) {

$parcel$export(module.exports, "format", () => (parcelRequire("9zpvl")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $9zpvl = parcelRequire("9zpvl");






});

parcelRegister("cP0uo", function(module, exports) {

$parcel$export(module.exports, "getNoOne", () => $76b80db8b6d2f445$export$fee790f685eeb3c8);
$parcel$export(module.exports, "getResponderName", () => $76b80db8b6d2f445$export$523d8f04c14fb2e6);
$parcel$export(module.exports, "getResponder", () => $76b80db8b6d2f445$export$691e04a71bf259a4);
$parcel$export(module.exports, "filterNoOne", () => $76b80db8b6d2f445$export$b7836ac71eb6f26c);
$parcel$export(module.exports, "filterNoTeam", () => $76b80db8b6d2f445$export$c8b06f3b91a6c636);
$parcel$export(module.exports, "getAutoCompleteItem", () => $76b80db8b6d2f445$export$8649bc899c4c82f3);

var $9YkY7 = parcelRequire("9YkY7");

var $1533n = parcelRequire("1533n");

var $2smie = parcelRequire("2smie");
/**
 * Get predefined values of type "noone" responder
 * @returns [ResponderNamesItem, AutoCompleteWithNoOneItem]
 */ const $76b80db8b6d2f445$export$fee790f685eeb3c8 = (intlApi)=>[
        {
            id: (0, $2smie.REQUESTED_NO_ONE).id,
            type: (0, $2smie.REQUESTED_NO_ONE).type,
            name: intlApi.formatMessage((0, $9YkY7.messages).noOne),
            deleted: false
        },
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).noOne),
            type: (0, $2smie.REQUESTED_NO_ONE).type,
            value: (0, $2smie.REQUESTED_NO_ONE).id,
            // NOTE: All override made with atlassianIdentifier so assuming no-one has atlassianIdentifier
            atlassianIdentifier: (0, $2smie.REQUESTED_NO_ONE).id
        }
    ];
const $76b80db8b6d2f445$var$getDeletedResponderName = (type, intlApi)=>{
    switch(type){
        case 'user':
            return intlApi.formatMessage((0, $9YkY7.messages).formerUser);
        case 'escalation':
            return intlApi.formatMessage((0, $9YkY7.messages).deletedEscalation);
        case 'team':
        case 'group':
            return intlApi.formatMessage((0, $9YkY7.messages).teamDeleted);
        case 'schedule':
            return intlApi.formatMessage((0, $9YkY7.messages).deletedSchedule);
    }
};
const $76b80db8b6d2f445$export$523d8f04c14fb2e6 = (responder, intlApi)=>{
    if ('name' in responder) return responder.name;
    if ('deleted' in responder && responder.deleted) return $76b80db8b6d2f445$var$getDeletedResponderName(responder.type, intlApi);
    if ((0, $1533n.isEmpty)(responder.id) && responder.type === 'team') return intlApi.formatMessage((0, $9YkY7.messages).noneGlobalSchedule);
    return '';
};
/**
 * Get responder with fallback. (Handles type "noone")
 */ const $76b80db8b6d2f445$export$691e04a71bf259a4 = (requested, received, intlApi)=>{
    // NOTE: Schedule BE is source of truth for deleted status and type
    const { id: id, type: type } = requested;
    const deleted = 'deleted' in requested ? requested.deleted : false;
    if (type === 'noone') {
        const [noOneResponder] = $76b80db8b6d2f445$export$fee790f685eeb3c8(intlApi);
        return noOneResponder;
    }
    const isReceivedLoadingOrError = received.isError || received.isLoading;
    if (isReceivedLoadingOrError) return {
        id: id,
        type: type,
        deleted: deleted,
        name: deleted ? $76b80db8b6d2f445$var$getDeletedResponderName(type, intlApi) : '',
        email: ''
    };
    if (deleted) return {
        ...received,
        deleted: deleted,
        name: received.name ?? $76b80db8b6d2f445$var$getDeletedResponderName(type, intlApi)
    };
    return {
        ...received,
        deleted: deleted
    };
};
const $76b80db8b6d2f445$export$b7836ac71eb6f26c = (items)=>items.filter((item)=>item.type !== (0, $2smie.REQUESTED_NO_ONE).type);
const $76b80db8b6d2f445$export$c8b06f3b91a6c636 = (items)=>items.filter((item)=>!(item.type === 'team' && (0, $1533n.isEmpty)(item.id)));
const $76b80db8b6d2f445$export$8649bc899c4c82f3 = (responder)=>{
    if (!responder || responder.isError || responder.isLoading) return null;
    return {
        ...responder,
        label: responder.name,
        value: responder.id
    };
};

});
parcelRegister("1533n", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $dde5258dc73661fc$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $dde5258dc73661fc$export$bedb7023a7733221);
const $dde5258dc73661fc$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $dde5258dc73661fc$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};

});

parcelRegister("2smie", function(module, exports) {

$parcel$export(module.exports, "REQUESTED_NO_ONE", () => $92be4d5a53639e88$export$4da0bbb2d275ef20);
const $92be4d5a53639e88$export$4da0bbb2d275ef20 = {
    id: 'noone',
    type: 'noone'
};

});


parcelRegister("1bRoC", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $3031ca74c0610a08$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $jxRF2 = parcelRequire("jxRF2");

var $hem2I = parcelRequire("hem2I");
/**
 * @warning Responder here has only atlassianIdentifier, not OG ID
 * @returns {object} JSM user in same format as ResponderItem
 */ const $3031ca74c0610a08$export$3901076af3749fa9 = ()=>{
    const jsmUser = (0, $hem2I.default)((0, $jxRF2.eocUserResource));
    const current = (0, $5uXOq.useMemo)(()=>({
            isLoading: jsmUser.loading,
            isError: jsmUser.error,
            user: jsmUser.loading || jsmUser.error ? undefined : {
                atlassianIdentifier: jsmUser.data.accountId,
                label: jsmUser.data.displayName,
                type: 'user',
                // NOTE: it is not safe to use 'value' (traditionally corresponds to ops id)
                value: jsmUser.data.accountId
            }
        }), [
        jsmUser
    ]);
    return current;
};

});



parcelRegister("gKAPA", function(module, exports) {

$parcel$export(module.exports, "DeleteRotation", () => $e868c6c765974a48$export$7533fd64b28500d1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");

var $bU3PY = parcelRequire("bU3PY");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $cgL5K = parcelRequire("cgL5K");


var $dY87H = parcelRequire("dY87H");

var $jkGAf = parcelRequire("jkGAf");

var $g3AjQ = parcelRequire("g3AjQ");

var $31qqw = parcelRequire("31qqw");

var $3NQti = parcelRequire("3NQti");

var $8yuhc = parcelRequire("8yuhc");
// TODO: Should disable "cancel" button when delete is loading ? (same goes for other modals!)
// Image while rotation is being deleted, the modal is closed ? It shouldn't happen
// We should disable while loading! Remove onClose from modal, handle close by 'ESC' inside components
// Use useOnEsc(action) like hook. This hook can be also used on focus state, and period items.
// Hooks implementation should be based on atlaskit/modal esc functionality.
const $e868c6c765974a48$export$7533fd64b28500d1 = ({ onClose: onClose, baseRotation: baseRotation })=>{
    const intlApi = (0, $koVbs.default)();
    const [{ id: scheduleId }] = (0, $3NQti.useSchedule)();
    const { deleteRotation: deleteRotation, isLoading: isLoading } = (0, $31qqw.useDeleteRotationService)(scheduleId, baseRotation.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ()=>{
            deleteRotation();
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            columnGap: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            spacing: "spacious",
            label: "warning",
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$59619663aa6500fb)})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, intlApi.formatMessage((0, $8yuhc.messages).title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $8yuhc.messages).explanation, {
            bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3AjQ.Bold), null, str),
            rotationName: baseRotation.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $jkGAf.messages).confirmProceed))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: onClose
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            autoFocus: true,
            appearance: "warning",
            isLoading: isLoading,
            type: "submit"
        }, intlApi.formatMessage((0, $jkGAf.messages).delete))))));
};

});
parcelRegister("g3AjQ", function(module, exports) {

$parcel$export(module.exports, "Bold", () => $1b8aa45277ee56f6$export$95aa4184327d6b72);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $1b8aa45277ee56f6$export$95aa4184327d6b72 = /*#__PURE__*/ (0, $bWGt6.default)("strong", {
    target: "eovjmsg0"
})({
    color: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    overflowWrap: 'break-word'
});

});

parcelRegister("31qqw", function(module, exports) {

$parcel$export(module.exports, "useRotationOptions", () => $aaa2c872e1c95b6e$export$a1c5d14ffd1b9155);
$parcel$export(module.exports, "useInitialValues", () => $aaa2c872e1c95b6e$export$26f1cfe35ce1c30d);
$parcel$export(module.exports, "useRotationUpdate", () => $aaa2c872e1c95b6e$export$b0a46d6cfae492e4);
$parcel$export(module.exports, "useDeleteRotationService", () => $aaa2c872e1c95b6e$export$d91be6ccddd3524e);
$parcel$export(module.exports, "useRotationOrder", () => $aaa2c872e1c95b6e$export$2ba776e40cbd366b);
$parcel$export(module.exports, "useRotationActions", () => $aaa2c872e1c95b6e$export$afa5a3a15feb95c8);
$parcel$export(module.exports, "useRotationFlows", () => $aaa2c872e1c95b6e$export$48d11556ee900f2);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $ajpes = parcelRequire("ajpes");

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $6CGrT = parcelRequire("6CGrT");

var $6RRyp = parcelRequire("6RRyp");

var $csGzA = parcelRequire("csGzA");

var $domT0 = parcelRequire("domT0");

var $hzEDn = parcelRequire("hzEDn");

var $7Sso9 = parcelRequire("7Sso9");

var $fxiJ3 = parcelRequire("fxiJ3");

var $d41OH = parcelRequire("d41OH");

var $9It5A = parcelRequire("9It5A");

var $kRnku = parcelRequire("kRnku");

var $3NQti = parcelRequire("3NQti");

var $hOvyv = parcelRequire("hOvyv");

var $7MFR3 = parcelRequire("7MFR3");
const $aaa2c872e1c95b6e$var$DEBOUNCE_TIME = 500;
const $aaa2c872e1c95b6e$export$a1c5d14ffd1b9155 = ()=>{
    const intlApi = (0, $koVbs.default)();
    const { data: scheduleTimeTemplates } = (0, $hem2I.default)((0, $6RRyp.getScheduleTimeTemplatesResource));
    const timingOptions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $kCCbe.TimingType).Everday,
                value: (0, $kCCbe.TimingType).Everday,
                label: intlApi.formatMessage((0, $hOvyv.messages).forEveryday)
            },
            {
                name: (0, $kCCbe.TimingType).Customday,
                value: (0, $kCCbe.TimingType).Customday,
                label: intlApi.formatMessage((0, $hOvyv.messages).customizeDays)
            }
        ], [
        intlApi
    ]);
    const templateOptions = (0, $5uXOq.useMemo)(()=>scheduleTimeTemplates?.timeTemplates.map(({ id: value, name: label, restrictions: restrictions, timingType: timingType })=>({
                value: value,
                label: label,
                restrictions: restrictions,
                timingType: timingType
            })) ?? [], [
        scheduleTimeTemplates?.timeTemplates
    ]);
    const shiftFrequencyOptions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $kCCbe.ShiftFrequency).Daily,
                value: (0, $kCCbe.ShiftFrequency).Daily,
                label: intlApi.formatMessage((0, $hOvyv.messages).daily)
            },
            {
                name: (0, $kCCbe.ShiftFrequency).Weekly,
                value: (0, $kCCbe.ShiftFrequency).Weekly,
                label: intlApi.formatMessage((0, $hOvyv.messages).weekly)
            },
            {
                name: (0, $kCCbe.ShiftFrequency).Custom,
                value: (0, $kCCbe.ShiftFrequency).Custom,
                label: intlApi.formatMessage((0, $hOvyv.messages).custom)
            }
        ], [
        intlApi
    ]);
    const shiftTypeOptions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $kCCbe.RotationType).HOURLY,
                value: (0, $kCCbe.RotationType).HOURLY,
                label: intlApi.formatMessage((0, $hOvyv.messages).hours)
            },
            {
                name: (0, $kCCbe.RotationType).DAILY,
                value: (0, $kCCbe.RotationType).DAILY,
                label: intlApi.formatMessage((0, $hOvyv.messages).days)
            },
            {
                name: (0, $kCCbe.RotationType).WEEKLY,
                value: (0, $kCCbe.RotationType).WEEKLY,
                label: intlApi.formatMessage((0, $hOvyv.messages).weeks)
            }
        ], [
        intlApi
    ]);
    return {
        timingOptions: timingOptions,
        templateOptions: templateOptions,
        shiftTypeOptions: shiftTypeOptions,
        shiftFrequencyOptions: shiftFrequencyOptions
    };
};
const $aaa2c872e1c95b6e$export$26f1cfe35ce1c30d = ()=>{
    const { templateOptions: templateOptions, shiftTypeOptions: shiftTypeOptions, shiftFrequencyOptions: shiftFrequencyOptions } = $aaa2c872e1c95b6e$export$a1c5d14ffd1b9155();
    const [rotation] = (0, $7Sso9.useInitialRotation)();
    const [recipientUpdate] = (0, $7Sso9.useRecipientUpdate)();
    const rotationId = (0, $5uXOq.useMemo)(()=>rotation?.id, [
        rotation?.id
    ]);
    const initialValues = (0, $5uXOq.useMemo)(()=>{
        if (!rotation) return undefined;
        // TODO: Get timezone offset from get rotation response
        return (0, $7MFR3.fromRotationDetailToRotationForm)({
            base: rotation,
            shiftFrequencyOptions: shiftFrequencyOptions,
            shiftTypeOptions: shiftTypeOptions,
            templateOptions: templateOptions
        });
    }, [
        rotation,
        shiftFrequencyOptions,
        shiftTypeOptions,
        templateOptions
    ]);
    return [
        rotationId,
        initialValues,
        recipientUpdate
    ];
};
const $aaa2c872e1c95b6e$export$b0a46d6cfae492e4 = (rotationId)=>{
    // NOTE: do not use rotationId in current (it might be undefined)
    const [current, { setRotationAction: setRotationAction }] = (0, $3NQti.useRotation)();
    /** @description Runs only if values are different than current previewed */ const updateRotation = (0, $5uXOq.useCallback)((values)=>{
        const incoming = (0, $7MFR3.fromRotationFormToRotationDetail)({
            base: values,
            rotationId: rotationId
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(current, incoming)) setRotationAction(incoming);
    }, [
        current,
        rotationId,
        setRotationAction
    ]);
    /** @description Runs only if values are different than current previewed */ const updateRotationDebounced = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((values)=>updateRotation(values), $aaa2c872e1c95b6e$var$DEBOUNCE_TIME), [
        updateRotation
    ]);
    return {
        updateRotation: updateRotation,
        updateRotationDebounced: updateRotationDebounced
    };
};
// REFACTOR: consider renaming useDeleteRotationService like hooks to useDeleteRotation
const $aaa2c872e1c95b6e$export$d91be6ccddd3524e = (scheduleId, rotationId)=>{
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const { closePageModal: closePageModal } = (0, $d41OH.useActions)();
    const { getTimelineAction: getTimelineAction } = (0, $9It5A.useActions)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const deleteRotation = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            await (0, $6CGrT.endpoints).deleteRotation({
                scheduleId: scheduleId,
                rotationId: rotationId
            });
        } catch (error) {
            defaultCatch({
                id: 'useRotationOrder-deleteRotation',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $hOvyv.messages).deleteRotationErrorTitle),
                        isAutoDismiss: true
                    });
                }
            }, error);
        }
        try {
            await getTimelineAction();
        } finally{
            setIsLoading(false);
            closePageModal((0, $kCCbe.PageModalType).DeleteRotation);
        }
    }, [
        closePageModal,
        defaultCatch,
        flagApi,
        getTimelineAction,
        intlApi,
        rotationId,
        scheduleId
    ]);
    return {
        isLoading: isLoading,
        deleteRotation: deleteRotation
    };
};
const $aaa2c872e1c95b6e$export$2ba776e40cbd366b = (scheduleId)=>{
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const [rotations, { getTimelineAction: getTimelineAction }] = (0, $3NQti.useTimelineRotations)();
    const [isLoading, { setOrderRotationLoading: setOrderRotationLoading }] = (0, $7Sso9.useOrderRotationLoading)();
    const [internalRotations, setInternalRotations] = (0, $5uXOq.useState)(rotations);
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (rotations) // filtered because when goBack invoked timeline data still has canceled data
        setInternalRotations(rotations?.filter(({ id: id })=>Boolean(id)));
    }, [
        rotations
    ]);
    const orderRotation = (0, $5uXOq.useCallback)(async (sourceIndex, destinationIndex)=>{
        setOrderRotationLoading(true);
        try {
            const rotationId = rotations[sourceIndex].id;
            let after;
            if (destinationIndex === 0) after = '';
            else if (destinationIndex > sourceIndex) after = rotations[destinationIndex].id;
            else after = rotations[destinationIndex - 1].id;
            setInternalRotations((0, $domT0.reorderItems)(rotations, sourceIndex, destinationIndex));
            await (0, $6CGrT.endpoints).orderRotation({
                scheduleId: scheduleId,
                rotationId: rotationId,
                after: after
            });
            getTimelineAction();
        } catch (error) {
            setInternalRotations(rotations);
            defaultCatch({
                id: 'useRotationOrder-orderRotation',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $hOvyv.messages).orderRotationErrorTitle)
                    });
                }
            }, error);
        } finally{
            setOrderRotationLoading(false);
        }
    }, [
        defaultCatch,
        flagApi,
        getTimelineAction,
        intlApi,
        rotations,
        scheduleId,
        setOrderRotationLoading
    ]);
    return {
        rotations: internalRotations,
        isLoading: isLoading,
        orderRotation: orderRotation
    };
};
const $aaa2c872e1c95b6e$export$afa5a3a15feb95c8 = (scheduleId, rotationId)=>{
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const { goBack: goBack } = (0, $hzEDn.useActions)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const add = (0, $5uXOq.useCallback)(async (fields, actionCallback)=>{
        try {
            await (0, $6CGrT.endpoints).addRotation({
                scheduleId: scheduleId,
                ...(0, $kRnku.fromRotationDetailToRotationPayload)((0, $7MFR3.fromRotationFormToRotationDetail)({
                    base: fields,
                    rotationId: rotationId
                }))
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $hOvyv.messages).addRotationSuccessTitle)
            });
            goBack();
            actionCallback?.onSuccess?.();
        } catch (error) {
            defaultCatch({
                id: 'useRotationActions-add',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $hOvyv.messages).addRotationErrorTitle),
                        isAutoDismiss: true
                    });
                }
            }, error);
            actionCallback?.onError?.();
        }
    }, [
        defaultCatch,
        flagApi,
        goBack,
        intlApi,
        rotationId,
        scheduleId
    ]);
    const edit = (0, $5uXOq.useCallback)(async (fields, actionCallback)=>{
        try {
            await (0, $6CGrT.endpoints).editRotation({
                scheduleId: scheduleId,
                ...(0, $kRnku.fromRotationDetailToRotationPayload)((0, $7MFR3.fromRotationFormToRotationDetail)({
                    base: fields,
                    rotationId: rotationId
                }))
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $hOvyv.messages).editRotationSuccessTitle)
            });
            goBack();
            actionCallback?.onSuccess?.();
        } catch (error) {
            defaultCatch({
                id: 'useRotationActions-edit',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $hOvyv.messages).editRotationErrorTitle),
                        isAutoDismiss: true
                    });
                }
            }, error);
            actionCallback?.onError?.();
        }
    }, [
        defaultCatch,
        flagApi,
        goBack,
        intlApi,
        rotationId,
        scheduleId
    ]);
    return {
        add: add,
        edit: edit
    };
};
const $aaa2c872e1c95b6e$export$48d11556ee900f2 = (scheduleId)=>{
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const { goToDetail: goToDetail } = (0, $hzEDn.useActions)();
    const [rotations] = (0, $3NQti.useTimelineRotations)();
    const { data: timeTemplateResponse } = (0, $hem2I.default)((0, $6RRyp.getScheduleTimeTemplatesResource));
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const clone = (0, $5uXOq.useCallback)(async (rotationId)=>{
        // TODO: use translations
        const name = (0, $7MFR3.generateName)(rotations ?? []);
        setIsLoading(true);
        try {
            const rotation = await (0, $6CGrT.endpoints).getRotation({
                scheduleId: scheduleId,
                rotationId: rotationId
            });
            const detail = (0, $7MFR3.fromGetRotationResponseToRotationDetail)(rotation, timeTemplateResponse.timeTemplates);
            const recipientUpdate = (0, $7MFR3.fromGetRotationResponseToRecipientUpdate)(rotation);
            detail.id = undefined;
            detail.name = name;
            goToDetail({
                rotation: detail,
                variant: (0, $fxiJ3.RotationDetailVariant).Clone,
                recipientUpdate: recipientUpdate
            });
        } catch (error) {
            defaultCatch({
                id: 'useRotationFlows-clone',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $hOvyv.messages).getRotationErrorTitle),
                        actions: [
                            {
                                content: intlApi.formatMessage((0, $jkGAf.messages).tryAgain),
                                onClick: ()=>clone(rotationId)
                            }
                        ]
                    });
                }
            }, error);
        } finally{
            setIsLoading(false);
        }
    }, [
        rotations,
        scheduleId,
        timeTemplateResponse,
        goToDetail,
        defaultCatch,
        flagApi,
        intlApi
    ]);
    const edit = (0, $5uXOq.useCallback)(async (rotationId)=>{
        setIsLoading(true);
        try {
            const rotation = await (0, $6CGrT.endpoints).getRotation({
                scheduleId: scheduleId,
                rotationId: rotationId
            });
            const detail = (0, $7MFR3.fromGetRotationResponseToRotationDetail)(rotation, timeTemplateResponse.timeTemplates);
            const recipientUpdate = (0, $7MFR3.fromGetRotationResponseToRecipientUpdate)(rotation);
            goToDetail({
                rotation: detail,
                variant: (0, $fxiJ3.RotationDetailVariant).Edit,
                recipientUpdate: recipientUpdate
            });
        } catch (error) {
            defaultCatch({
                id: 'useRotationFlows-edit',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $hOvyv.messages).getRotationErrorTitle),
                        actions: [
                            {
                                content: intlApi.formatMessage((0, $jkGAf.messages).tryAgain),
                                onClick: ()=>edit(rotationId)
                            }
                        ]
                    });
                }
            }, error);
        } finally{
            setIsLoading(false);
        }
    }, [
        scheduleId,
        timeTemplateResponse,
        goToDetail,
        defaultCatch,
        flagApi,
        intlApi
    ]);
    const add = (0, $5uXOq.useCallback)(()=>{
        // TODO: use translations
        const name = (0, $7MFR3.generateName)(rotations ?? []);
        const firstTemplate = timeTemplateResponse.timeTemplates[0];
        const start = (0, $7MFR3.generateDefaultStart)();
        const detail = {
            name: name,
            responders: [],
            rotationPeriod: 1,
            rotationType: (0, $kCCbe.RotationType).WEEKLY,
            startTimeRaw: (0, $csGzA.formatting).toDateHourMinute(start),
            restrictions: firstTemplate.restrictions,
            timeTemplateId: firstTemplate.id,
            timingType: firstTemplate.timingType
        };
        goToDetail({
            rotation: detail,
            variant: (0, $fxiJ3.RotationDetailVariant).Add
        });
    }, [
        rotations,
        timeTemplateResponse,
        goToDetail
    ]);
    return {
        clone: clone,
        add: add,
        edit: edit,
        isLoading: isLoading
    };
};

});
parcelRegister("domT0", function(module, exports) {

$parcel$export(module.exports, "reorderItems", () => $3f7d583683efdd37$export$a427362af7551d96);

var $LpImS = parcelRequire("LpImS");
const $3f7d583683efdd37$export$a427362af7551d96 = (items, sourceIndex, destinationIndex)=>{
    const copy = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(items);
    const [moved] = copy.splice(sourceIndex, 1);
    copy.splice(destinationIndex, 0, moved);
    return copy;
};

});

parcelRegister("7Sso9", function(module, exports) {

$parcel$export(module.exports, "useStep", () => $123bb1df16de3847$export$7896576cb7635832);
$parcel$export(module.exports, "useDetailVariant", () => $123bb1df16de3847$export$e6b0f432ebe388a1);
$parcel$export(module.exports, "useOrderRotationLoading", () => $123bb1df16de3847$export$2344ae58e117424);
$parcel$export(module.exports, "useRecipientUpdate", () => $123bb1df16de3847$export$4feae785ad8b100f);
$parcel$export(module.exports, "useInitialRotation", () => $123bb1df16de3847$export$944fe7ad4b02aeb5);

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $hzEDn = parcelRequire("hzEDn");

var $Srxzr = parcelRequire("Srxzr");
const $123bb1df16de3847$export$7896576cb7635832 = (0, $3sQ5x.createHook)((0, $hzEDn.store), {
    selector: (0, $Srxzr.selectors).getStep
});
const $123bb1df16de3847$export$e6b0f432ebe388a1 = (0, $3sQ5x.createHook)((0, $hzEDn.store), {
    selector: (0, $Srxzr.selectors).getDetailVariant
});
const $123bb1df16de3847$export$2344ae58e117424 = (0, $3sQ5x.createHook)((0, $hzEDn.store), {
    selector: (0, $Srxzr.selectors).getOrderRotationLoading
});
const $123bb1df16de3847$export$4feae785ad8b100f = (0, $3sQ5x.createHook)((0, $hzEDn.store), {
    selector: (0, $Srxzr.selectors).getRecipientUpdate
});
const $123bb1df16de3847$export$944fe7ad4b02aeb5 = (0, $3sQ5x.createHook)((0, $hzEDn.store), {
    selector: (0, $Srxzr.selectors).getInitialRotation
});
const $123bb1df16de3847$export$885cc5bf58339e93 = (0, $51nlc.createSubscriber)((0, $hzEDn.store), {
    selector: (0, $Srxzr.selectors).getStep
});

});
parcelRegister("Srxzr", function(module, exports) {

$parcel$export(module.exports, "selectors", () => $1a82062b90845971$export$e1252723db1c541);
const $1a82062b90845971$var$getStep = (state)=>{
    return state.step;
};
const $1a82062b90845971$var$getDetailVariant = (state)=>{
    return state.rotationDetailVariant;
};
const $1a82062b90845971$var$getOrderRotationLoading = (state)=>{
    return state.orderRotationLoading;
};
const $1a82062b90845971$var$getInitialRotation = (state)=>{
    return state.initialRotation;
};
const $1a82062b90845971$var$getRecipientUpdate = (state)=>{
    return state.recipientUpdate;
};
const $1a82062b90845971$export$e1252723db1c541 = {
    getStep: $1a82062b90845971$var$getStep,
    getDetailVariant: $1a82062b90845971$var$getDetailVariant,
    getRecipientUpdate: $1a82062b90845971$var$getRecipientUpdate,
    getInitialRotation: $1a82062b90845971$var$getInitialRotation,
    getOrderRotationLoading: $1a82062b90845971$var$getOrderRotationLoading
};

});


parcelRegister("hOvyv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1027e78400d0277b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1027e78400d0277b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    getRotationErrorTitle: {
        id: 'eoc-schedule.controllers.edit.get-rotation-error-title',
        defaultMessage: "We couldn't get your rotation.",
        description: 'This message indicates that our back-end services did not respond when getting rotation.'
    },
    deleteRotationErrorTitle: {
        id: 'eoc-schedule.controllers.edit.delete-rotation-error-title',
        defaultMessage: 'We could not delete the rotation.',
        description: 'This message indicates that our back-end services did not respond when deleting rotation.'
    },
    addRotationErrorTitle: {
        id: 'eoc-schedule.controllers.edit.add-rotation-error-title',
        defaultMessage: 'We could not add the rotation.',
        description: 'This message indicates that our back-end services did not respond when adding rotation.'
    },
    editRotationErrorTitle: {
        id: 'eoc-schedule.controllers.edit.edit-rotation-error-title',
        defaultMessage: 'We could not edit the rotation.',
        description: 'This message indicates that our back-end services did not respond when editting rotation.'
    },
    orderRotationErrorTitle: {
        id: 'eoc-schedule.controllers.edit.order-rotation-error-title',
        defaultMessage: 'We could not order the rotation at this moment. Please try again.',
        description: 'This message indicates that our back-end services did not respond when ordering rotations.'
    },
    forEveryday: {
        id: 'eoc-schedule.controllers.edit.for-everyday',
        defaultMessage: 'For everyday',
        description: 'Label of timing type radio button: For repeating time intervals for everyday.'
    },
    customizeDays: {
        id: 'eoc-schedule.controllers.edit.customize-days',
        defaultMessage: 'Customize days',
        description: 'Label of timing type radio button: For allowing to add custom date-time intervals.'
    },
    hours: {
        id: 'eoc-schedule.controllers.edit.custom.hours',
        defaultMessage: 'Hours',
        description: 'Text that indicates hours repeation'
    },
    days: {
        id: 'eoc-schedule.controllers.edit.custom.days',
        defaultMessage: 'Days',
        description: 'Text that indicates days repeation'
    },
    weeks: {
        id: 'eoc-schedule.controllers.edit.custom.weeks',
        defaultMessage: 'Weeks',
        description: 'Text that indicates weeks repeation'
    },
    daily: {
        id: 'eoc-schedule.controllers.edit.daily',
        defaultMessage: 'Daily',
        description: 'Text that indicates daily repeation'
    },
    weekly: {
        id: 'eoc-schedule.controllers.edit.weekly',
        defaultMessage: 'Weekly',
        description: 'Text that indicates weekly repeation'
    },
    custom: {
        id: 'eoc-schedule.controllers.edit.custom',
        defaultMessage: 'Custom',
        description: 'Text that indicates custom repeation'
    },
    addRotationSuccessTitle: {
        id: 'eoc-schedule.controllers.edit.add-rotation-success-title',
        defaultMessage: "You've added new rotation.",
        description: 'Success message for adding rotation.'
    },
    editRotationSuccessTitle: {
        id: 'eoc-schedule.controllers.edit.edit-rotation-success-title',
        defaultMessage: "You've updated the rotation.",
        description: 'Success message for editing rotation.'
    }
});

});

parcelRegister("7MFR3", function(module, exports) {

$parcel$export(module.exports, "generateName", () => $ad807bb0c73dfbd9$export$5d832d6580b26c5);
$parcel$export(module.exports, "fromRotationFormToRotationDetail", () => $ad807bb0c73dfbd9$export$4d88d2edee0b79ce);
$parcel$export(module.exports, "fromRotationDetailToRotationForm", () => $ad807bb0c73dfbd9$export$8d158ddff046e1d7);
$parcel$export(module.exports, "fromGetRotationResponseToRecipientUpdate", () => $ad807bb0c73dfbd9$export$cf19998d01d04883);
$parcel$export(module.exports, "fromGetRotationResponseToRotationDetail", () => $ad807bb0c73dfbd9$export$e973cd0ab82f72e9);
$parcel$export(module.exports, "downsizeRestriction", () => $ad807bb0c73dfbd9$export$82c197f2b50d5b62);
$parcel$export(module.exports, "expandRestriction", () => $ad807bb0c73dfbd9$export$492861ef0820f1bf);
$parcel$export(module.exports, "generateDefaultStart", () => $ad807bb0c73dfbd9$export$fb7b41a335212cd1);
$parcel$export(module.exports, "generateDefaultEnd", () => $ad807bb0c73dfbd9$export$1861d05b323fd607);
$parcel$export(module.exports, "getNextInterval", () => $ad807bb0c73dfbd9$export$91cbfd2b4a39e120);
$parcel$export(module.exports, "rearrageParticipants", () => $ad807bb0c73dfbd9$export$b6818c621a038dd4);

var $7XUeK = parcelRequire("7XUeK");

var $c43fn = parcelRequire("c43fn");

var $i5zNV = parcelRequire("i5zNV");

var $ajpes = parcelRequire("ajpes");

var $jOikx = parcelRequire("jOikx");

var $aSTVt = parcelRequire("aSTVt");

var $kCCbe = parcelRequire("kCCbe");

var $csGzA = parcelRequire("csGzA");

var $lCzwW = parcelRequire("lCzwW");

var $3QnCy = parcelRequire("3QnCy");

var $3wU5e = parcelRequire("3wU5e");
// TODO: Make more sofiscated
// Might be better if we use similar logic to clone schedule
// such as -> "Clone - [Rotation Name]" | "Rotation"
const $ad807bb0c73dfbd9$export$5d832d6580b26c5 = (rotations)=>{
    return [
        'Rotation',
        rotations.length + 1
    ].join(' ');
};
const $ad807bb0c73dfbd9$export$4d88d2edee0b79ce = ({ base: base, rotationId: rotationId })=>{
    const { startTime: startTime, restrictions: restrictions, participants: responders, name: name, shiftPeriod: shiftPeriod, hasEndTime: hasEndTime, template: template, shiftType: shiftType, timingType: timingType, endTime: endTime } = base;
    const state = {
        id: rotationId,
        name: name,
        responders: responders,
        restrictions: restrictions,
        rotationType: shiftType.value,
        timingType: timingType,
        rotationPeriod: parseInt(shiftPeriod),
        startTimeRaw: (0, $csGzA.formatting).toDateHourMinute(startTime)
    };
    if (template) state.timeTemplateId = template.value;
    if (hasEndTime && endTime) state.endTimeRaw = (0, $csGzA.formatting).toDateHourMinute(endTime);
    return state;
};
const $ad807bb0c73dfbd9$export$8d158ddff046e1d7 = ({ base: base, templateOptions: templateOptions, shiftTypeOptions: shiftTypeOptions, shiftFrequencyOptions: shiftFrequencyOptions })=>{
    const frequency = $ad807bb0c73dfbd9$export$d8ae8d412e002799(base);
    const fields = {
        name: base.name,
        shiftType: shiftTypeOptions.find(({ value: value })=>value === base?.rotationType),
        shiftFrequency: shiftFrequencyOptions.find(({ value: value })=>value === frequency),
        startTime: (0, $csGzA.formatting).toISO(base.startTimeRaw),
        restrictions: base.restrictions,
        timingType: base.timingType,
        participants: base.responders,
        shiftPeriod: base.rotationPeriod.toString()
    };
    if (base.timeTemplateId) fields.template = templateOptions.find(({ value: value })=>value === base.timeTemplateId);
    else fields.template = null;
    if (base.endTimeRaw) {
        fields.endTime = (0, $csGzA.formatting).toISO(base.endTimeRaw);
        fields.hasEndTime = true;
    } else fields.hasEndTime = false;
    // WARNING: Consider removing this when comparing RotationDetail and RotationForm
    fields.hackStatus = (0, $3wU5e.HackStatus).None;
    return fields;
};
const $ad807bb0c73dfbd9$export$cf19998d01d04883 = (response)=>({
        responders: response.respondersShifted,
        startTime: (0, $csGzA.formatting).toISO(response.startTimeForRecipientUpdate),
        shiftable: !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(response.respondersShifted, response.responders)
    });
const $ad807bb0c73dfbd9$export$e973cd0ab82f72e9 = (response, templates)=>{
    let restrictions;
    let timingType;
    const { id: id, name: name, responders: responders, rotationType: rotationType, rotationPeriod: rotationPeriod, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw, timeTemplateId: timeTemplateId } = response;
    if (timeTemplateId) {
        const template = templates.find((template)=>timeTemplateId === template.id);
        restrictions = template.restrictions;
        timingType = template.timingType;
    } else {
        restrictions = response.restrictions;
        timingType = response.timingType;
    }
    const detail = {
        id: id,
        name: name,
        responders: responders,
        rotationType: rotationType,
        restrictions: restrictions,
        rotationPeriod: rotationPeriod,
        timeTemplateId: timeTemplateId,
        timingType: timingType,
        startTimeRaw: startTimeRaw
    };
    if (endTimeRaw) detail.endTimeRaw = endTimeRaw;
    return detail;
};
const $ad807bb0c73dfbd9$export$82c197f2b50d5b62 = (intervals)=>{
    const firstInterval = intervals[0];
    // WARNING: Current is not correct 'days', are missing
    return [
        {
            ...firstInterval,
            startDay: null,
            endDay: null
        }
    ];
};
const $ad807bb0c73dfbd9$export$492861ef0820f1bf = (intervals)=>{
    const interval = intervals[0];
    return [
        {
            ...interval,
            // NOTE: assuming default start day is Monday
            startDay: (0, $3QnCy.MONDAY),
            endDay: (0, $3QnCy.MONDAY)
        }
    ];
};
const $ad807bb0c73dfbd9$export$d8ae8d412e002799 = (rotation)=>{
    if ((0, $lCzwW.isEmpty)(rotation)) return undefined;
    if (rotation.rotationType === (0, $kCCbe.RotationType).DAILY && rotation.rotationPeriod === 1) return (0, $kCCbe.ShiftFrequency).Daily;
    if (rotation.rotationType === (0, $kCCbe.RotationType).WEEKLY && rotation.rotationPeriod === 1) return (0, $kCCbe.ShiftFrequency).Weekly;
    return (0, $kCCbe.ShiftFrequency).Custom;
};
/**
 * Get 8:00 AM in given timezone
 * Imitates BE response (start epoch) for startTime
 * Ex. Browser: UTC +3:00, Incoming: UTC +1:00 -> UTC +3:00 6:00 AM
 * Ex. Browser: UTC +3:00, Incoming: UTC -9:00 -> UTC +3:00 8:00 PM
 * @return time - Date
 */ const $ad807bb0c73dfbd9$export$fb7b41a335212cd1 = (timezone)=>{
    const time = new Date();
    time.setMinutes(0, 0, 0);
    const localToday8am = (0, $i5zNV.default)(time, 8);
    const offsetHack = timezone ? (0, $jOikx.getTimezoneOffsetDiff)(timezone) : 0;
    const movedToday8am = new Date(localToday8am.valueOf() + offsetHack);
    return movedToday8am;
};
const $ad807bb0c73dfbd9$export$1861d05b323fd607 = (base)=>{
    const time = base ? new Date(base) : new Date();
    time.setSeconds(0, 0);
    const nextHourUsingStartTime = (0, $c43fn.default)((0, $7XUeK.default)(time, 1), {
        nearestTo: 30
    });
    return nextHourUsingStartTime;
};
const $ad807bb0c73dfbd9$export$91cbfd2b4a39e120 = (base)=>{
    const last = {
        ...base[base.length - 1]
    };
    last.startDay = last.startDay % (0, $aSTVt.WEEK_DAY_COUNT) + 1;
    last.endDay = last.endDay % (0, $aSTVt.WEEK_DAY_COUNT) + 1;
    return last;
};
const $ad807bb0c73dfbd9$export$b6818c621a038dd4 = (base, shifted)=>{
    const getIndexOfItemOnRespondersShifted = (item)=>shifted.findIndex(({ id: id })=>item.id === id);
    const rearraged = [
        ...base
    ].sort((r1, r2)=>getIndexOfItemOnRespondersShifted(r1) === -1 || getIndexOfItemOnRespondersShifted(r2) === -1 ? 0 : getIndexOfItemOnRespondersShifted(r1) - getIndexOfItemOnRespondersShifted(r2));
    return rearraged;
};

});
parcelRegister("3QnCy", function(module, exports) {

$parcel$export(module.exports, "MONDAY", () => $1ae066e304c8e23b$export$f553f4faf24ab170);
$parcel$export(module.exports, "INITIAL_CUSTOM_RESTRICTIONS", () => $1ae066e304c8e23b$export$fba4efd965a6b3d6);
$parcel$export(module.exports, "DEFAULT_SHIFT_PERIOD", () => $1ae066e304c8e23b$export$42e622adef2d79f3);
$parcel$export(module.exports, "VALID_SHIFT_RANGE", () => $1ae066e304c8e23b$export$6a262a83c90053b5);

var $kCCbe = parcelRequire("kCCbe");
const $1ae066e304c8e23b$export$f553f4faf24ab170 = 2;
const $1ae066e304c8e23b$export$fba4efd965a6b3d6 = [
    {
        startDay: $1ae066e304c8e23b$export$f553f4faf24ab170,
        startHour: 8,
        startMinute: 0,
        endDay: $1ae066e304c8e23b$export$f553f4faf24ab170,
        endHour: 17,
        endMinute: 0
    }
];
const $1ae066e304c8e23b$export$42e622adef2d79f3 = '1';
const $1ae066e304c8e23b$export$6a262a83c90053b5 = {
    [(0, $kCCbe.RotationType).HOURLY]: {
        max: 720,
        min: 1
    },
    [(0, $kCCbe.RotationType).DAILY]: {
        max: 365,
        min: 1
    },
    [(0, $kCCbe.RotationType).WEEKLY]: {
        max: 52,
        min: 1
    }
};

});

parcelRegister("3wU5e", function(module, exports) {

$parcel$export(module.exports, "HackStatus", () => $b7d9e5a18974a5ae$export$d6ce9d56299ca7e5);
var $b7d9e5a18974a5ae$export$d6ce9d56299ca7e5 = /*#__PURE__*/ function(HackStatus) {
    /** @description No hack is applied or rejected. Participants havent been modified */ HackStatus[HackStatus["None"] = 1] = "None";
    /** @description Hack is applied. But can be rejected if requested. */ HackStatus[HackStatus["Applied"] = 2] = "Applied";
    /** @description Hack was applied. Now rejected, which the terminal state. */ HackStatus[HackStatus["Rejected"] = 3] = "Rejected";
    return HackStatus;
}({});

});



parcelRegister("8yuhc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fcbbb9a94a06c962$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fcbbb9a94a06c962$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc-schedule.ui.list.delete-rotation.title',
        defaultMessage: 'Delete rotation?',
        description: 'Title for delete rotation modal.'
    },
    explanation: {
        id: 'eoc-schedule.ui.list.delete-rotation.explanation',
        defaultMessage: "You're permanently deleting rotation <bold>{rotationName}</bold>.",
        description: 'Explanation for what "Delete rotation" does.'
    }
});

});


parcelRegister("i2ZmL", function(module, exports) {

$parcel$export(module.exports, "DeleteSchedule", () => $edd182ff45e138b1$export$90c98aa169be810b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");

var $bU3PY = parcelRequire("bU3PY");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");


var $dY87H = parcelRequire("dY87H");

var $jkGAf = parcelRequire("jkGAf");

var $g3AjQ = parcelRequire("g3AjQ");

var $eDnUx = parcelRequire("eDnUx");

var $3NQti = parcelRequire("3NQti");

var $8kkCO = parcelRequire("8kkCO");
// TODO: Should disable "cancel" button when delete is loading ? (same goes for other modals!)
const $edd182ff45e138b1$export$90c98aa169be810b = ({ onClose: onClose })=>{
    const intlApi = (0, $koVbs.default)();
    const [{ id: scheduleId, name: scheduleName }] = (0, $3NQti.useSchedule)();
    const { isLoading: isLoading, deleteSchedule: deleteSchedule } = (0, $eDnUx.useDeleteScheduleService)(scheduleId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ()=>{
            deleteSchedule();
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            columnGap: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            spacing: "spacious",
            label: "warning",
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$59619663aa6500fb)})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, intlApi.formatMessage((0, $8kkCO.messages).title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, intlApi.formatMessage((0, $8kkCO.messages).explanation, {
            bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3AjQ.Bold), null, str),
            scheduleName: scheduleName
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: onClose
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            autoFocus: true,
            appearance: "warning",
            isLoading: isLoading,
            type: "submit"
        }, intlApi.formatMessage((0, $jkGAf.messages).confirm))))));
};

});
parcelRegister("eDnUx", function(module, exports) {

$parcel$export(module.exports, "usePartialUpdateScheduleService", () => $3eaf6c221824fc49$export$85d5b70bfd3b7036);
$parcel$export(module.exports, "useDeleteScheduleService", () => $3eaf6c221824fc49$export$e5c7ef98a3f3735c);
$parcel$export(module.exports, "useLayers", () => $3eaf6c221824fc49$export$f6020efd5d3388a0);

var $5uXOq = parcelRequire("5uXOq");

var $3NMrl = parcelRequire("3NMrl");

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $6bC8A = parcelRequire("6bC8A");

var $6RRyp = parcelRequire("6RRyp");

var $lCzwW = parcelRequire("lCzwW");

var $d41OH = parcelRequire("d41OH");

var $9T6pk = parcelRequire("9T6pk");

var $laTym = parcelRequire("laTym");

var $3NQti = parcelRequire("3NQti");

var $6Ge3x = parcelRequire("6Ge3x");
// TODO: make similar to section ui preference hook
const $3eaf6c221824fc49$export$ecc08c2862d6f726 = (scheduleId)=>{
    const { update: updateSchedulesResource } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const updateSchedule = (0, $5uXOq.useCallback)(async ({ enabled: enabled, timezone: timezone, description: description, name: name }, actionCallback)=>{
        setIsLoading(true);
        const updatedFields = {
            ...!(0, $lCzwW.isNullOrUndefined)(enabled) && {
                enabled: enabled
            },
            ...!(0, $lCzwW.isNullOrUndefined)(name) && {
                name: name
            },
            ...!(0, $lCzwW.isNullOrUndefined)(description) && {
                description: description
            },
            ...!(0, $lCzwW.isNullOrUndefined)(timezone) && {
                timezone: timezone
            }
        };
        try {
            const response = await (0, $6bC8A.endpoints).updateSchedule({
                scheduleId: scheduleId,
                ...updatedFields
            });
            updateSchedulesResource((prev)=>{
                const schedules = [
                    ...prev?.schedules ?? []
                ];
                const selectedIdx = schedules.findIndex(({ id: id })=>id === scheduleId);
                (0, $hmVmJ.assert)(selectedIdx !== -1, new (0, $dH6Pi.AssertionError)('eoc-schedule', 'use-update-schedule-service: schedule not found'));
                schedules[selectedIdx] = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(response, [
                    'id',
                    'name',
                    'description',
                    'timezone',
                    'enabled',
                    'utcTimeOffsetMillis'
                ]);
                return {
                    schedules: schedules
                };
            });
            actionCallback?.onSuccess?.();
        } catch (error) {
            defaultCatch({
                id: 'useUpdateScheduleService-updateSchedule',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $6Ge3x.messages).updateScheduleErrorTitle),
                        actions: [
                            {
                                content: intlApi.formatMessage((0, $jkGAf.messages).tryAgain),
                                onClick: ()=>updateSchedule({
                                        enabled: enabled,
                                        timezone: timezone,
                                        description: description,
                                        name: name
                                    })
                            }
                        ]
                    });
                }
            }, error);
            actionCallback?.onError?.();
        } finally{
            setIsLoading(false);
        }
    }, [
        defaultCatch,
        flagApi,
        intlApi,
        scheduleId,
        updateSchedulesResource
    ]);
    return {
        updateSchedule: updateSchedule,
        isLoading: isLoading
    };
};
const $3eaf6c221824fc49$export$85d5b70bfd3b7036 = (scheduleId, field)=>{
    const { isLoading: isLoading, updateSchedule: updateSchedule } = $3eaf6c221824fc49$export$ecc08c2862d6f726(scheduleId);
    const partialUpdate = (0, $5uXOq.useCallback)((value, actionCallback)=>updateSchedule({
            [field]: value
        }, actionCallback), [
        field,
        updateSchedule
    ]);
    return {
        isLoading: isLoading,
        partialUpdate: partialUpdate
    };
};
const $3eaf6c221824fc49$export$e5c7ef98a3f3735c = (scheduleId)=>{
    const { update: updateSchedulesResource } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { closePageModal: closePageModal } = (0, $d41OH.useActions)();
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const deleteSchedule = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            await (0, $6bC8A.endpoints).deleteSchedule({
                scheduleId: scheduleId
            });
            closePageModal((0, $kCCbe.PageModalType).DeleteSchedule);
            closePageModal((0, $kCCbe.PageModalType).EditMode);
            updateSchedulesResource((prev)=>{
                return {
                    schedules: (prev?.schedules ?? []).filter(({ id: id })=>id !== scheduleId)
                };
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $6Ge3x.messages).deleteScheduleSuccessTitle),
                isAutoDismiss: true
            });
        } catch (error) {
            defaultCatch({
                id: 'useDeleteScheduleService-deleteSchedule',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $6Ge3x.messages).deleteScheduleErrorTitle),
                        isAutoDismiss: true
                    });
                }
            }, error);
        } finally{
            setIsLoading(false);
        }
    }, [
        defaultCatch,
        flagApi,
        intlApi,
        closePageModal,
        scheduleId,
        updateSchedulesResource
    ]);
    return {
        deleteSchedule: deleteSchedule,
        isLoading: isLoading
    };
};
const $3eaf6c221824fc49$export$f6020efd5d3388a0 = ({ withForwarding: withForwarding })=>{
    const intlApi = (0, $koVbs.default)();
    const [{ id: scheduleId }] = (0, $3NQti.useSchedule)();
    const { data: uiPreferences } = (0, $hem2I.default)((0, $6RRyp.getUiPreferencesResource));
    const { scheduleOrder: scheduleOrder } = (0, $9T6pk.useSectionUiPreferences)();
    const showAllLayers = (0, $5uXOq.useMemo)(()=>uiPreferences?.schedulePreferences.find(({ id: id })=>id === scheduleId)?.showAllLayers ?? (0, $laTym.UI_PREFERENCES_DEFAULT_VALUES).schedulePreferences.showAllLayers, [
        scheduleId,
        uiPreferences?.schedulePreferences
    ]);
    const layers = (0, $5uXOq.useMemo)(()=>({
            base: {
                label: intlApi.formatMessage((0, $6Ge3x.messages).base),
                value: (0, $kCCbe.LayerTypes).BaseLayer
            },
            override: {
                label: intlApi.formatMessage((0, $6Ge3x.messages).override),
                value: (0, $kCCbe.LayerTypes).OverrideLayer
            },
            forwarding: {
                label: intlApi.formatMessage((0, $6Ge3x.messages).forwarding),
                value: (0, $kCCbe.LayerTypes).ForwardingLayer
            },
            final: {
                label: intlApi.formatMessage((0, $6Ge3x.messages).final),
                value: (0, $kCCbe.LayerTypes).FinalLayer
            }
        }), [
        intlApi
    ]);
    // TODO: ensure the order is correct
    const ordered = (0, $5uXOq.useMemo)(()=>{
        if (scheduleOrder === 'finalSchedule') return [
            layers.final,
            ...withForwarding ? [
                layers.forwarding
            ] : [],
            layers.override,
            layers.base
        ];
        else return [
            layers.base,
            layers.override,
            ...withForwarding ? [
                layers.forwarding
            ] : [],
            layers.final
        ];
    }, [
        layers,
        scheduleOrder,
        withForwarding
    ]);
    return {
        /** @description Layers adjusted for all ui preferences */ preferedLayers: showAllLayers ? ordered : [
            layers.final
        ],
        /** @description Layers adjusted for only order ui preference */ allLayers: ordered,
        layers: /** @description This can be used to access labels for the layers */ layers
    };
};

});
parcelRegister("6Ge3x", function(module, exports) {

$parcel$export(module.exports, "messages", () => $316f98863dad286f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $316f98863dad286f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    updateScheduleErrorTitle: {
        id: 'eoc-schedule.controllers.list.update-schedule-error-title',
        defaultMessage: "We couldn't update your schedule.",
        description: 'This message indicates that our back-end services did not respond when updating schedule.'
    },
    deleteScheduleErrorTitle: {
        id: 'eoc-schedule.controllers.list.delete-schedule-error-title',
        defaultMessage: "We couldn't delete your schedule.",
        description: 'This message indicates that our back-end services did not respond when deleting schedule.'
    },
    deleteScheduleSuccessTitle: {
        id: 'eoc-schedule.controllers.list.delete-schedule-success-title',
        defaultMessage: 'Your schedule is successfully deleted.',
        description: 'This message indicates schedule is successfully deleted.'
    },
    base: {
        id: 'eoc-schedule.controllers.list.base',
        defaultMessage: 'Base',
        description: 'Base layer view of a schedule'
    },
    override: {
        id: 'eoc-schedule.controllers.list.override',
        defaultMessage: 'Override',
        description: 'Override layer view of a schedule'
    },
    forwarding: {
        id: 'eoc-schedule.controllers.list.forwarding',
        defaultMessage: 'Forwarding',
        description: 'Forwarding layer view of a schedule'
    },
    final: {
        id: 'eoc-schedule.controllers.list.final',
        defaultMessage: 'Final',
        description: 'Final layer view of a schedule'
    }
});

});


parcelRegister("8kkCO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0f67e66e54ec7a4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0f67e66e54ec7a4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc-schedule.ui.list.delete-schedule.title',
        defaultMessage: 'Delete schedule',
        description: 'Title for delete schedule modal.'
    },
    explanation: {
        id: 'eoc-schedule.ui.list.delete-schedule.explanation',
        defaultMessage: 'Are you sure you want to delete the schedule <bold>{scheduleName}</bold>?',
        description: 'Explanation for what "Delete schedule" does.'
    }
});

});


parcelRegister("4eQ1P", function(module, exports) {

$parcel$export(module.exports, "DiscardChanges", () => $4bd4925420734c7c$export$7cd93dd4f651c66e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");

var $bU3PY = parcelRequire("bU3PY");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $cgL5K = parcelRequire("cgL5K");


var $dY87H = parcelRequire("dY87H");

var $bKpgX = parcelRequire("bKpgX");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $g3AjQ = parcelRequire("g3AjQ");

var $hzEDn = parcelRequire("hzEDn");

var $d41OH = parcelRequire("d41OH");

var $lNHZW = parcelRequire("lNHZW");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $9Auxn = parcelRequire("9Auxn");
// TODO: Should disable "cancel" button when delete is loading ? (same goes for other modals!)
// Image while rotation is being deleted, the modal is closed ? It shouldn't happen
// We should disable while loading! Remove onClose from modal, handle close by 'ESC' inside components
// Use useOnEsc(action) like hook. This hook can be also used on focus state, and period items.
// Hooks implementation should be based on atlaskit/modal esc functionality.
const $4bd4925420734c7c$export$7cd93dd4f651c66e = ({ onClose: onClose, variant: variant })=>{
    const intlApi = (0, $koVbs.default)();
    const [rotation] = (0, $3NQti.useRotation)();
    const [{ id: scheduleId }] = (0, $3NQti.useSchedule)();
    const { goBack: goBack } = (0, $hzEDn.useActions)();
    const { closePageModal: closePageModal } = (0, $d41OH.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ()=>{
            if (variant === (0, $lNHZW.DiscardVariant).Discard) {
                closePageModal((0, $kCCbe.PageModalType).DiscardChanges);
                goBack();
            }
            if (variant === (0, $lNHZW.DiscardVariant).Close) {
                (0, $bKpgX.defaultRegistry).getStore((0, $9It5A.store), scheduleId).actions.getTimelineAction();
                closePageModal((0, $kCCbe.PageModalType).DiscardChanges);
                closePageModal((0, $kCCbe.PageModalType).EditMode);
            }
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            columnGap: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            spacing: "spacious",
            label: "warning",
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$59619663aa6500fb)})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, variant === (0, $lNHZW.DiscardVariant).Discard && intlApi.formatMessage((0, $9Auxn.messages).discardTitle), variant === (0, $lNHZW.DiscardVariant).Close && intlApi.formatMessage((0, $9Auxn.messages).discardCloseTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, variant === (0, $lNHZW.DiscardVariant).Discard && intlApi.formatMessage((0, $9Auxn.messages).discardDescription, {
            bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3AjQ.Bold), null, str),
            rotationName: rotation?.name
        }), variant === (0, $lNHZW.DiscardVariant).Close && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $9Auxn.messages).discardCloseDescription, {
            bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3AjQ.Bold), null, str),
            rotationName: rotation?.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $jkGAf.messages).confirmProceed)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: onClose
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), variant === (0, $lNHZW.DiscardVariant).Discard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            autoFocus: true,
            appearance: "warning",
            type: "submit"
        }, intlApi.formatMessage((0, $jkGAf.messages).discard)), variant === (0, $lNHZW.DiscardVariant).Close && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            autoFocus: true,
            appearance: "warning",
            type: "submit"
        }, intlApi.formatMessage((0, $9Auxn.messages).discardClose))))));
};

});
parcelRegister("9Auxn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $362d506de02d4357$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $362d506de02d4357$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    discardTitle: {
        id: 'eoc-schedule.ui.list.discard-changes.discard-title',
        defaultMessage: 'Discard changes?',
        description: 'Title for discard changes modal.'
    },
    discardDescription: {
        id: 'eoc-schedule.ui.list.discard-changes.discard-description',
        defaultMessage: 'Rotation <bold>{rotationName}</bold> will continue to work as it is.',
        description: 'Explanation for what discarding edit rotation does.'
    },
    discardCloseTitle: {
        id: 'eoc-schedule.ui.list.discard-changes.discard-close-title',
        defaultMessage: 'You have unsaved changes',
        description: 'Title for discard and close changes modal.'
    },
    discardCloseDescription: {
        id: 'eoc-schedule.ui.list.discard-changes.discard-close-description',
        defaultMessage: "You've made some changes on rotation <bold>{rotationName}</bold> but didn't update. Closing the schedule will discard changes and rotation <bold>{rotationName}</bold> will continue to work as it is.",
        description: 'Explanation for what discarding and closing edit rotation does.'
    },
    discardClose: {
        id: 'eoc-schedule.ui.list.discard-changes.discard-close',
        defaultMessage: 'Discard and close',
        description: 'Button for discarding and closing edit mode.'
    }
});

});


parcelRegister("uz971", function(module, exports) {

$parcel$export(module.exports, "EditSchedule", () => $ca3f304ba3f8c795$export$382eb2dd717430f5);

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $aSTVt = parcelRequire("aSTVt");

var $7Sso9 = parcelRequire("7Sso9");

var $fxiJ3 = parcelRequire("fxiJ3");

var $a0mkb = parcelRequire("a0mkb");

var $c3yb1 = parcelRequire("c3yb1");

var $blo5K = parcelRequire("blo5K");

var $5jsh9 = parcelRequire("5jsh9");
const $ca3f304ba3f8c795$export$382eb2dd717430f5 = ()=>{
    const [step] = (0, $7Sso9.useStep)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            source: step === (0, $fxiJ3.EditStep).List ? 'editMode' : 'editRotation',
            tags: step === (0, $fxiJ3.EditStep).List ? (0, $aSTVt.ANALYTICS_TAGS).editMode : (0, $aSTVt.ANALYTICS_TAGS).editRotation
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jsh9.Container), {
        flexDirection: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0mkb.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jsh9.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blo5K.Sidebar), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3yb1.Schedule), null))));
};

});
parcelRegister("a0mkb", function(module, exports) {

$parcel$export(module.exports, "Header", () => $427508936795aa05$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");

var $dD7Zc = parcelRequire("dD7Zc");

var $bJeNF = parcelRequire("bJeNF");

var $ctg8C = parcelRequire("ctg8C");

var $bopR4 = parcelRequire("bopR4");

var $lj8SI = parcelRequire("lj8SI");


var $agcXw = parcelRequire("agcXw");
var $h8yj2 = parcelRequire("h8yj2");

var $5XoGW = parcelRequire("5XoGW");

var $dY87H = parcelRequire("dY87H");

var $bKpgX = parcelRequire("bKpgX");

var $9YkY7 = parcelRequire("9YkY7");
var $5s9eT = parcelRequire("5s9eT");
var $ksSWS = parcelRequire("ksSWS");
var $fdFPq = parcelRequire("fdFPq");

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $7Sso9 = parcelRequire("7Sso9");

var $fxiJ3 = parcelRequire("fxiJ3");

var $eDnUx = parcelRequire("eDnUx");

var $d41OH = parcelRequire("d41OH");

var $lNHZW = parcelRequire("lNHZW");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $lCzwW = parcelRequire("lCzwW");

var $8V6om = parcelRequire("8V6om");

var $4zMWE = parcelRequire("4zMWE");
const $427508936795aa05$export$8b251419efc915eb = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intlApi = (0, $koVbs.default)();
    const [schedule] = (0, $3NQti.useSchedule)();
    const [step] = (0, $7Sso9.useStep)();
    const [hasDeleted] = (0, $3NQti.useHasDeleted)();
    const { closePageModal: closePageModal, openDeleteSchedule: openDeleteSchedule, openDiscardChanges: openDiscardChanges } = (0, $d41OH.useActions)();
    const [edittingName, setEdittingName] = (0, $5uXOq.useState)(false);
    const nameValidator = (0, $5XoGW.useValidators)([
        (0, $5XoGW.isRequired)(),
        (0, $5XoGW.isMaxCharacterCount)((0, $aSTVt.SCHEDULE_NAME_MAX_LENGTH)),
        (0, $lCzwW.noLeadingOrTrailingSpaces)()
    ]);
    const { getTimezoneOption: getTimezoneOption } = (0, $fdFPq.useTimezoneOptions)();
    const { id: scheduleId, name: name, timezone: timeZone, enabled: enabled } = schedule;
    const { partialUpdate: updateName, isLoading: isNameLoading } = (0, $eDnUx.usePartialUpdateScheduleService)(scheduleId, 'name');
    const { partialUpdate: updateTimezone, isLoading: isTimezoneLoading } = (0, $eDnUx.usePartialUpdateScheduleService)(scheduleId, 'timezone');
    const { partialUpdate: updateEnabled, isLoading: isEnabledLoading } = (0, $eDnUx.usePartialUpdateScheduleService)(scheduleId, 'enabled');
    const timezoneOption = getTimezoneOption({
        timeZone: timeZone
    });
    const isSettingsLoading = isEnabledLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.NameWrapper), {
        expanded: edittingName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: name,
        onConfirm: (value)=>{
            if (value !== name) {
                const event = createAnalyticsEvent({});
                updateName(value, {
                    onSuccess: ()=>{
                        (0, $h8yj2.fireTrackAnalytics)(event, 'scheduleNameUpdate succeeded');
                    },
                    onError: ()=>{
                        (0, $h8yj2.fireTrackAnalytics)(event, 'scheduleNameUpdate failed');
                    }
                });
            }
            setEdittingName(false);
        },
        onEdit: ()=>setEdittingName(true),
        onCancel: ()=>setEdittingName(false),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
                isOpen: fieldProps.isInvalid,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, errorMessage),
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.NameEditView), {
                ...fieldProps,
                autoComplete: "off",
                autoFocus: true,
                isCompact: true,
                isDisabled: isNameLoading,
                "aria-label": intlApi.formatMessage((0, $8V6om.messages).editScheduleName),
                elemAfterInput: fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.DialogError), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    spacing: "spacious",
                    label: "error",
                    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                }))
            })),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.NameReadView), {
                isLoading: isNameLoading
            }, name),
        validate: nameValidator,
        editButtonLabel: intlApi.formatMessage((0, $8V6om.messages).editScheduleName)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.TimeZoneWrapper), {
        alignedRight: edittingName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: timezoneOption,
        editView: (fieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.TimeZoneEditView), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksSWS.TimezoneSelect), {
                ...(0, $5s9eT.EXTRA_SELECT_PROPS),
                ...fieldProps,
                autoFocus: true,
                isDisabled: isTimezoneLoading,
                openMenuOnFocus: true,
                "aria-label": intlApi.formatMessage((0, $8V6om.messages).editScheduleTimezone),
                styles: {
                    control: (base)=>({
                            ...base,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            ...(0, $4zMWE.timeZoneSelectStyles)
                        }),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ...(0, $5s9eT.EXTRA_SELECT_PROPS).styles
                }
            })),
        hideActionButtons: true,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.TimeZoneReadView), {
                isLoading: isTimezoneLoading
            }, timezoneOption.label),
        onConfirm: (value)=>{
            if (value.value !== timeZone) {
                const event = createAnalyticsEvent({});
                // FIX: Update schedule timezone offset as well. See: TARDIS-9135
                updateTimezone(value.value, {
                    onSuccess: ()=>{
                        (0, $h8yj2.fireTrackAnalytics)(event, 'timeZoneUpdate succeeded');
                    },
                    onError: ()=>{
                        (0, $h8yj2.fireTrackAnalytics)(event, 'timeZoneUpdate failed');
                    }
                });
            }
        },
        editButtonLabel: intlApi.formatMessage((0, $8V6om.messages).editScheduleTimezone)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        columnGap: 1,
        justifyContent: "center"
    }, hasDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, intlApi.formatMessage((0, $9YkY7.messages).missingResponder)), !enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "moved"
    }, intlApi.formatMessage((0, $9YkY7.messages).off))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zMWE.DoneWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        id: "done",
        appearance: "default",
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'editModeClose');
            if (step === (0, $fxiJ3.EditStep).List) {
                (0, $bKpgX.defaultRegistry).getStore((0, $9It5A.store), scheduleId).actions.getTimelineAction();
                closePageModal((0, $kCCbe.PageModalType).EditMode);
            }
            if (step === (0, $fxiJ3.EditStep).Detail) openDiscardChanges({
                variant: (0, $lNHZW.DiscardVariant).Close,
                id: 'done'
            });
        }
    }, intlApi.formatMessage((0, $9YkY7.messages).close))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                label: intlApi.formatMessage((0, $8V6om.messages).moreActions),
                id: "edit-options-button",
                isLoading: isSettingsLoading,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                ref: triggerRef
            })
    }, enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'editModeDisableSchedule');
            updateEnabled(false);
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).turnOff)), !enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'editModeEnableSchedule');
            updateEnabled(true);
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).turnOn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'editModeDeleteSchedule');
            openDeleteSchedule({
                id: [
                    'edit-options-button',
                    'create-schedule-button'
                ]
            });
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $agcXw.FireScreenAnalytics), {
        componentName: "editSchedule"
    }));
};

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $VSDnB.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus,
                className: (0, $bwpsq.default)([
                    "_p12f1osq _kqswh2mm"
                ])
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PDuf.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fb3572edb783a8f$var$InnerInlineEdit, props);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("3Lty3", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb08f4038c94d3$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $a1dy0 = parcelRequire("a1dy0");
const $70eb08f4038c94d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $70eb08f4038c94d3$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $5uXOq.createElement((0, $a1dy0.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($70eb08f4038c94d3$var$styles.root, isDisabled && $70eb08f4038c94d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }, children);
});
var $70eb08f4038c94d3$export$2e2bcd8739ae039 = $70eb08f4038c94d3$var$Pressable;

});

parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $kbxJz = parcelRequire("kbxJz");

var $lLLkM = parcelRequire("lLLkM");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        tabIndex: -1,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c81oud _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kbxJz))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ $5uXOq.createElement("div", {
        tabIndex: -1,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c81oud _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});
parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});


parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_18s8ze3t _1yt4ze3t _12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
        xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
            readViewFitContainerWidth && "_1bsb1osq"
        ])
    }, readView()));
};
var $1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("agcXw", function(module, exports) {

$parcel$export(module.exports, "FireUIAnalytics", () => $5625c4255a3b29d6$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $5625c4255a3b29d6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $5625c4255a3b29d6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $5625c4255a3b29d6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $h8yj2 = parcelRequire("h8yj2");
const $5625c4255a3b29d6$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $5625c4255a3b29d6$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $5625c4255a3b29d6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $5625c4255a3b29d6$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $5625c4255a3b29d6$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $h8yj2.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $5625c4255a3b29d6$var$WithAnalytics = (0, $cb25w.default)()($5625c4255a3b29d6$var$FireComponent);
const $5625c4255a3b29d6$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$a1562d08625f5d7e)
    });
const $5625c4255a3b29d6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$947dac6c72b26f81)
    });
const $5625c4255a3b29d6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$12346a674644c156)
    });
const $5625c4255a3b29d6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("8V6om", function(module, exports) {

$parcel$export(module.exports, "messages", () => $92e6e306147341b8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $92e6e306147341b8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    moreActions: {
        id: 'eoc-schedule.ui.list.edit-schedule.header.more-actions',
        defaultMessage: 'More actions for schedule',
        description: 'More actions button for schedule settings.'
    },
    nameEmptyValidationError: {
        id: 'eoc-schedule.ui.list.edit-schedule.header.name-empty-validation-error',
        defaultMessage: 'Schedule name cannot be empty.',
        description: 'Validation error when text is empty.'
    },
    nameLongValidationError: {
        id: 'eoc-schedule.ui.list.edit-schedule.header.name-long-validation-error',
        defaultMessage: 'Schedule name cannot be more than {length} characters.',
        description: 'Validation error when text is too long.'
    },
    editScheduleName: {
        id: 'eoc-schedule.ui.list.edit-schedule.header.edit-schedule-name',
        defaultMessage: 'Edit schedule name',
        description: 'Label for inline edit of schedule name.'
    },
    editScheduleTimezone: {
        id: 'eoc-schedule.ui.list.edit-schedule.header.edit-schedule-timezone',
        defaultMessage: 'Edit schedule timezone',
        description: 'Label for inline edit of schedule timezone.'
    }
});

});

parcelRegister("4zMWE", function(module, exports) {

$parcel$export(module.exports, "HEADER_HEIGHT", () => $07bc7675f9a6c341$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "Container", () => $07bc7675f9a6c341$export$42a852a2b6b56249);
$parcel$export(module.exports, "NameWrapper", () => $07bc7675f9a6c341$export$45df02f361199409);
$parcel$export(module.exports, "NameReadView", () => $07bc7675f9a6c341$export$f23e95d599c85cde);
$parcel$export(module.exports, "NameEditView", () => $07bc7675f9a6c341$export$3333985f36f2808c);
$parcel$export(module.exports, "DialogError", () => $07bc7675f9a6c341$export$f1d34fac351547d3);
$parcel$export(module.exports, "TimeZoneWrapper", () => $07bc7675f9a6c341$export$2548d3aa8d6ba7);
$parcel$export(module.exports, "TimeZoneReadView", () => $07bc7675f9a6c341$export$80a7977cf2bfb214);
$parcel$export(module.exports, "TimeZoneEditView", () => $07bc7675f9a6c341$export$b2dd7541232a0f2f);
$parcel$export(module.exports, "timeZoneSelectStyles", () => $07bc7675f9a6c341$export$36cfb6edffa7b5ed);
$parcel$export(module.exports, "DoneWrapper", () => $07bc7675f9a6c341$export$529e69cfe689bf83);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kY99m = parcelRequire("kY99m");


var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
function $07bc7675f9a6c341$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07bc7675f9a6c341$export$cdb7fd9d999c7168 = (0, $k5uoT.gridSize)() * 6;
const $07bc7675f9a6c341$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt138"
})({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$07bc7675f9a6c341$export$cdb7fd9d999c7168}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${$07bc7675f9a6c341$export$cdb7fd9d999c7168}px`,
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& form': {
        margin: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& form > div': {
        margin: 0
    }
});
const $07bc7675f9a6c341$export$45df02f361199409 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt137"
})("margin-right:var(--ds-space-300, 24px);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ expanded: expanded })=>expanded && `flex: 1 1 auto;`);
const $07bc7675f9a6c341$export$f23e95d599c85cde = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt136"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isLoading ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$fbae4efaa892d883})` : `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
        font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)"
    }));
const $07bc7675f9a6c341$export$3333985f36f2808c = /*#__PURE__*/ (0, $bWGt6.default)((0, $kY99m.default), {
    target: "e1yklt135"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > [data-ds--text-field--input]': {
        fontSize: `24px`,
        fontWeight: "var(--ds-font-weight-medium, 500)"
    }
});
const $07bc7675f9a6c341$export$f1d34fac351547d3 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt134"
})({
    name: "gl5b9h",
    styles: "line-height:100%;padding-right:var(--ds-space-100, 8px)"
});
const $07bc7675f9a6c341$export$2548d3aa8d6ba7 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt133"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        marginRight: props.alignedRight ? (0, $k5uoT.gridSize)() + 'px' : 'auto'
    }));
const $07bc7675f9a6c341$export$80a7977cf2bfb214 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt132"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isLoading ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$fbae4efaa892d883})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'nowrap'
    }));
const $07bc7675f9a6c341$export$b2dd7541232a0f2f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt131"
})({
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$fbae4efaa892d883)})`,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
const $07bc7675f9a6c341$export$36cfb6edffa7b5ed = {
    // TODO: remove width after ‘@atlaskit/Select’ upgrade
    maxWidth: '360px',
    minWidth: '360px',
    width: '360px'
};
const $07bc7675f9a6c341$export$529e69cfe689bf83 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1yklt130"
})({
    margin: `0 ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"}`
});

});


parcelRegister("c3yb1", function(module, exports) {

$parcel$export(module.exports, "Schedule", () => $64c75366911bab24$export$a74e4df6c6355a42);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $kIROY = parcelRequire("kIROY");

var $dY87H = parcelRequire("dY87H");

var $8BDSK = parcelRequire("8BDSK");
var $ck74K = parcelRequire("ck74K");
var $pQkjl = parcelRequire("pQkjl");
var $4lizm = parcelRequire("4lizm");
var $5s9eT = parcelRequire("5s9eT");
var $cKHxL = parcelRequire("cKHxL");

var $8icyj = parcelRequire("8icyj");

var $aSTVt = parcelRequire("aSTVt");

var $1Ntyt = parcelRequire("1Ntyt");

var $7Sso9 = parcelRequire("7Sso9");

var $eDnUx = parcelRequire("eDnUx");

var $9T6pk = parcelRequire("9T6pk");

var $4XJMJ = parcelRequire("4XJMJ");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $5verT = parcelRequire("5verT");

var $lCzwW = parcelRequire("lCzwW");

var $fIAuI = parcelRequire("fIAuI");

var $6R5iM = parcelRequire("6R5iM");

var $aBYdx = parcelRequire("aBYdx");
const $64c75366911bab24$export$a74e4df6c6355a42 = ()=>{
    const [{ selectedView: selectedView, timelineType: timelineType, timelineData: timelineData, calendarData: calendarData, currentDate: currentDate, schedule: schedule }, { setTimelineTypeAction: setTimelineTypeAction, setSelectedViewAction: setSelectedViewAction, previousPeriodAction: previousPeriodAction, nextPeriodAction: nextPeriodAction, todayAction: todayAction }] = (0, $9It5A.useStore)();
    const { allLayers: allLayers, layers: layers } = (0, $eDnUx.useLayers)({
        withForwarding: !(0, $lCzwW.isEmpty)(timelineData?.forwardingLayers)
    });
    const [{ startEpoch: startEpoch, endEpoch: endEpoch, nowEpoch: nowEpoch, startOffset: startOffset, endOffset: endOffset, nowOffset: nowOffset }] = (0, $3NQti.useTimelineEpoch)();
    const [{ isInitialLoading: isInitialLoading, isSubsequentLoading: isSubsequentLoading }] = (0, $3NQti.useTimelineLoading)();
    const [orderRotationLoading] = (0, $7Sso9.useOrderRotationLoading)();
    const { displayDensity: displayDensity } = (0, $9T6pk.useSectionUiPreferences)();
    const { isLoading: isResponderNamesLoading } = (0, $4XJMJ.useNamesLoading)();
    const isScheduleLoading = isSubsequentLoading || orderRotationLoading || isResponderNamesLoading;
    // TODO: Add Initial Loading for Calendar
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R5iM.Container), null, isInitialLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R5iM.HeaderContainer), {
        columnGap: 1.5,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 4,
        width: 15
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 4,
        width: 15
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 15,
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 15,
        width: "100%"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R5iM.ScrollableArea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R5iM.HeaderContainer), {
        alignItems: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Ntyt.DateNavigation), {
        endEpoch: endEpoch,
        isLoading: isScheduleLoading,
        nextPeriod: nextPeriodAction,
        nowEpoch: nowEpoch,
        onTimelineTypeChange: setTimelineTypeAction,
        onToday: todayAction,
        onViewChange: setSelectedViewAction,
        previousPeriod: previousPeriodAction,
        selectedTimelineType: timelineType,
        selectedView: selectedView,
        startEpoch: startEpoch,
        startOffset: startOffset,
        endOffset: endOffset,
        nowOffset: nowOffset,
        scheduleName: schedule.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $aSTVt.SPOTLIGHT_NAMES).editModeSchedule
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R5iM.Scrollable), null, selectedView === (0, $5s9eT.NavigationMode).Timeline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, allLayers.map((layer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: `fragment-${layer.value}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6R5iM.LayerName), null, layer.label), isScheduleLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKHxL.TimelineLoading), {
            variant: "full",
            size: displayDensity !== 'comfort' ? 'medium' : 'large',
            numberOfDays: (0, $5verT.getNumberOfDays)({
                timelineType: timelineType,
                currentDate: currentDate
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $pQkjl.Layer), {
            nowEpoch: nowEpoch,
            startEpoch: startEpoch,
            endEpoch: endEpoch,
            offset: startOffset,
            size: displayDensity !== 'comfort' ? 'medium' : 'large',
            variant: "full",
            rotationSlot: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIROY.default), null, (width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIAuI.RotationList), {
                    width: width ? width - ((0, $4lizm.SIDE_HEADER_WIDTH) + (0, $4lizm.LINE_WIDTH)) : 0,
                    nowEpoch: nowEpoch,
                    startEpoch: startEpoch,
                    endEpoch: endEpoch,
                    rotations: timelineData?.[layer.value] ?? [],
                    layer: layer
                }))
        })))), selectedView === (0, $5s9eT.NavigationMode).Calendar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isScheduleLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ck74K.CalendarLoading), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BDSK.Calendar), {
        nowEpoch: nowEpoch,
        startEpoch: startEpoch,
        offset: startOffset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIROY.default), null, (width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBYdx.WeekList), {
            width: width ?? 0,
            nowEpoch: nowEpoch,
            offset: startOffset,
            weeks: calendarData?.finalWeeks ?? [],
            layer: layers.final
        }))))))));
};

});
parcelRegister("kIROY", function(module, exports) {

$parcel$export(module.exports, "default", () => $da62c8b5caf9f678$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");
const $da62c8b5caf9f678$var$containerDivStyle = {
    width: '100%',
    position: 'relative'
};
// Not using styled-components here for performance
// and framework-agnostic reasons.
const $da62c8b5caf9f678$var$sizerStyle = {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    height: 0,
    width: '100%',
    opacity: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: -1
};
class $da62c8b5caf9f678$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.state = {}, this.handleResize = (0, $7nRxN.default)(()=>{
            const { container: container } = this;
            if (!container) return;
            const width = container.offsetWidth;
            this.setState({
                width: width
            });
            if (this.props.onResize) this.props.onResize(width);
        }), this.handleContainerRef = (ref)=>{
            if (!ref) return;
            this.container = ref;
        }, this.handleObjectRef = (ref)=>{
            if (!ref) return;
            this.resizeObject = ref;
        }, this.handleObjectLoad = ()=>{
            if (!this.resizeObject) return;
            this.resizeObjectDocument = this.resizeObject.contentDocument.defaultView;
            this.resizeObjectDocument.addEventListener('resize', this.handleResize);
            this.handleResize();
        };
        // eslint-disable-next-line no-console
        console.warn('WidthDetector will be deprecated, please use WidthObserver from @atlaskit/width-detector instead.');
    }
    static{
        this.defaultProps = {
            containerStyle: {}
        };
    }
    componentDidMount() {
        if (this.resizeObject) this.resizeObject.data = 'about:blank';
        // Calculate width first time, after object has loaded.
        // Prevents it from getting in a weird state where width is always 0.
        this.handleResize();
    }
    componentWillUnmount() {
        this.handleResize.cancel();
        if (this.resizeObjectDocument) this.resizeObjectDocument.removeEventListener('resize', this.handleResize);
    }
    render() {
        // @TODO: Add alternative method using IntersectionObserver or ResizeObserver
        const sizerEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("object", {
            type: "text/html",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $da62c8b5caf9f678$var$sizerStyle,
            ref: this.handleObjectRef,
            onLoad: this.handleObjectLoad,
            "aria-hidden": true,
            tabIndex: -1
        }));
        // pluck non-DOM props off the props so we can safely spread remaining items
        const { containerStyle: containerStyle, onResize: onResize, children: children, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$da62c8b5caf9f678$var$containerDivStyle,
                ...containerStyle
            },
            ref: this.handleContainerRef
        }, children(this.state.width), sizerEl);
    }
}

});

parcelRegister("8BDSK", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $f33b4169a1bd8c2d$export$e1aef45b828286de);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $62zF1 = parcelRequire("62zF1");

var $iXJ3r = parcelRequire("iXJ3r");
const $f33b4169a1bd8c2d$export$e1aef45b828286de = ({ children: children, startEpoch: startEpoch, offset: offset })=>{
    const intlApi = (0, $koVbs.default)();
    const monthColumns = (0, $5uXOq.useMemo)(()=>(0, $iXJ3r.generateMonthColumns)({
            startEpoch: startEpoch,
            intlApi: intlApi,
            offset: offset
        }), [
        intlApi,
        startEpoch,
        offset
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.Header), {
        "aria-hidden": true
    }, monthColumns.map((title)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.Day), {
            key: title
        }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.Weeks), null, children));
};

});
parcelRegister("62zF1", function(module, exports) {

$parcel$export(module.exports, "Header", () => $fdb2588dc4ea5745$export$8b251419efc915eb);
$parcel$export(module.exports, "DaySkeleton", () => $fdb2588dc4ea5745$export$f45badcf1ee836b6);
$parcel$export(module.exports, "WeekSkeletonContainer", () => $fdb2588dc4ea5745$export$e686f80a3a95517a);
$parcel$export(module.exports, "WeeksSkeleton", () => $fdb2588dc4ea5745$export$74d749bbc7e3ccb5);
$parcel$export(module.exports, "Day", () => $fdb2588dc4ea5745$export$7a9a31a911eb9a20);
$parcel$export(module.exports, "Weeks", () => $fdb2588dc4ea5745$export$cee3aa9d41feb83e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $lklAx = parcelRequire("lklAx");

var $bWGt6 = parcelRequire("bWGt6");
function $fdb2588dc4ea5745$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fdb2588dc4ea5745$export$8b251419efc915eb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1tn7uk75"
})({
    name: "1a57w32",
    styles: "display:flex;margin-bottom:var(--ds-space-100, 8px)"
});
const $fdb2588dc4ea5745$export$f45badcf1ee836b6 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1tn7uk74"
})({
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${100 / (0, $lklAx.WEEK_DAY_COUNT)}%`
});
const $fdb2588dc4ea5745$export$e686f80a3a95517a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1tn7uk73"
})({
    borderLeft: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    display: 'grid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `repeat(7, ${100 / (0, $lklAx.WEEK_DAY_COUNT)}%)`
});
const $fdb2588dc4ea5745$export$74d749bbc7e3ccb5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1tn7uk72"
})({
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    borderRight: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $lklAx.WEEK_MIN_HEIGHT)}px`,
    display: 'flex',
    flexDirection: 'column',
    gap: "var(--ds-space-150, 12px)",
    padding: "var(--ds-space-150, 12px)"
});
const $fdb2588dc4ea5745$export$7a9a31a911eb9a20 = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "e1tn7uk71"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${100 / (0, $lklAx.WEEK_DAY_COUNT)}%`,
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
    margin: 0,
    textAlign: 'center'
});
const $fdb2588dc4ea5745$export$cee3aa9d41feb83e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1tn7uk70"
})({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    borderLeft: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    width: '100%'
});

});
parcelRegister("lklAx", function(module, exports) {

$parcel$export(module.exports, "WEEK_DAY_COUNT", () => $c6d69938c58800d0$export$fe62c2dddb4d77ea);
$parcel$export(module.exports, "MONTH_DAY_COUNT", () => $c6d69938c58800d0$export$243317962ac0cf80);
$parcel$export(module.exports, "WEEK_MIN_HEIGHT", () => $c6d69938c58800d0$export$74f38e755072fb13);
const $c6d69938c58800d0$export$fe62c2dddb4d77ea = 7;
const $c6d69938c58800d0$export$243317962ac0cf80 = 35;
const $c6d69938c58800d0$export$74f38e755072fb13 = 126;

});


parcelRegister("iXJ3r", function(module, exports) {

$parcel$export(module.exports, "generateMonthColumns", () => $cce562dfbc889a4e$export$3fd6ec063009a7c8);

var $5Ppij = parcelRequire("5Ppij");

var $gwejS = parcelRequire("gwejS");

var $lklAx = parcelRequire("lklAx");
const $cce562dfbc889a4e$export$3fd6ec063009a7c8 = ({ startEpoch: startEpoch, intlApi: intlApi, offset: offset })=>{
    const start = (0, $5Ppij.default)(startEpoch + offset, 'UTC');
    return [
        ...Array((0, $lklAx.WEEK_DAY_COUNT))
    ].map((_, index)=>intlApi.formatDate((0, $gwejS.default)(start, index), {
            weekday: 'long'
        }));
};

});


parcelRegister("ck74K", function(module, exports) {

$parcel$export(module.exports, "CalendarLoading", () => $484aa2c5d67f9744$export$b89ba05b2fdd8ec3);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");

var $lklAx = parcelRequire("lklAx");

var $62zF1 = parcelRequire("62zF1");
const $484aa2c5d67f9744$export$b89ba05b2fdd8ec3 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.Header), null, Array.from({
        length: (0, $lklAx.WEEK_DAY_COUNT)
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.DaySkeleton), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            height: 1,
            width: 3
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.WeekSkeletonContainer), null, Array.from({
        length: (0, $lklAx.MONTH_DAY_COUNT)
    }).fill(null).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62zF1.WeeksSkeleton), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            height: 1,
            width: 1.5
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            height: 3,
            width: 3
        })))));
};

});

parcelRegister("pQkjl", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $65d0d55a70872bc4$export$936d0764594b6eb3);

var $5uXOq = parcelRequire("5uXOq");

var $5Ppij = parcelRequire("5Ppij");

var $koVbs = parcelRequire("koVbs");

var $hhW0G = parcelRequire("hhW0G");

var $jfjFL = parcelRequire("jfjFL");

var $khXRb = parcelRequire("khXRb");

var $7oQpL = parcelRequire("7oQpL");
// TODO: add Gaps
const $65d0d55a70872bc4$export$936d0764594b6eb3 = ({ nowEpoch: nowEpoch, startEpoch: startEpoch, endEpoch: endEpoch, offset: offset, size: size, variant: variant, rotationSlot: rotationSlot })=>{
    const intlApi = (0, $koVbs.default)();
    const display = (0, $7oQpL.getTimeDisplay)(startEpoch, endEpoch);
    const ranges = (0, $7oQpL.generateRanges)({
        startEpoch: startEpoch,
        endEpoch: endEpoch,
        offset: offset
    });
    const nowInRange = (0, $jfjFL.getNowLocation)(startEpoch, endEpoch, nowEpoch) === (0, $hhW0G.NowLocation).InRange;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Container), null, ranges.map(([start, end], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Line), {
            variant: variant,
            ratio: 100 / ranges.length,
            index: i,
            key: `line-${start.valueOf()}-${end.valueOf()}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Header), {
        "aria-hidden": true
    }, variant === 'full' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.EmptyTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Inner), null, ranges.map(([start, end])=>{
        const [first, second] = (0, $7oQpL.generateDateStrings)({
            intlApi: intlApi,
            display: display,
            date: start
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Cell), {
            variant: variant,
            ratio: 100 / ranges.length,
            display: display,
            key: `cell-${start.valueOf()}-${end.valueOf()}`,
            nowLocation: (0, $jfjFL.getNowLocation)(start.valueOf(), end.valueOf(), (0, $5Ppij.default)(nowEpoch + offset, 'UTC').valueOf())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Time), {
            "data-testid": "first-time",
            display: display
        }, first), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Time), {
            "data-testid": "second-time",
            display: display
        }, second));
    }))), nowInRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Stripe), {
        "data-testid": "indicator",
        nowEpoch: nowEpoch,
        startEpoch: startEpoch,
        endEpoch: endEpoch,
        variant: variant
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.List), {
        size: size
    }, rotationSlot));
};

});
parcelRegister("hhW0G", function(module, exports) {

$parcel$export(module.exports, "NowLocation", () => $2d03d76e9bdc7438$export$f3accd68e6d1c6a3);
var $2d03d76e9bdc7438$export$f3accd68e6d1c6a3 = /*#__PURE__*/ function(NowLocation) {
    NowLocation["InRange"] = "in-range";
    NowLocation["Before"] = "before";
    NowLocation["After"] = "after";
    return NowLocation;
}({});

});

parcelRegister("jfjFL", function(module, exports) {

$parcel$export(module.exports, "getNowLocation", () => $e8888b900827cd1f$export$e6665d7f0d1b1985);
$parcel$export(module.exports, "getNumberOfDays", () => $e8888b900827cd1f$export$cfb876877a7c9210);
$parcel$export(module.exports, "generateName", () => $e8888b900827cd1f$export$5d832d6580b26c5);

var $6D6zP = parcelRequire("6D6zP");

var $5s9eT = parcelRequire("5s9eT");

var $9YkY7 = parcelRequire("9YkY7");

var $hhW0G = parcelRequire("hhW0G");
const $e8888b900827cd1f$export$e6665d7f0d1b1985 = (startEpoch, endEpoch, nowEpoch)=>{
    if (nowEpoch > endEpoch) return (0, $hhW0G.NowLocation).After;
    if (nowEpoch < startEpoch) return (0, $hhW0G.NowLocation).Before;
    return (0, $hhW0G.NowLocation).InRange;
};
const $e8888b900827cd1f$export$cfb876877a7c9210 = (timelineType, currentDate)=>{
    switch(timelineType){
        case (0, $5s9eT.NavigationPeriodId).OneDay:
            return 1;
        case (0, $5s9eT.NavigationPeriodId).OneWeek:
            return 7;
        case (0, $5s9eT.NavigationPeriodId).TwoWeeks:
            return 14;
        case (0, $5s9eT.NavigationPeriodId).OneMonth:
            return (0, $6D6zP.default)(currentDate);
    }
};
const $e8888b900827cd1f$export$5d832d6580b26c5 = (scheduleName, intlApi)=>{
    return intlApi.formatMessage((0, $9YkY7.messages).copyOfScheduleName, {
        scheduleName: scheduleName
    });
};

});

parcelRegister("khXRb", function(module, exports) {

$parcel$export(module.exports, "Container", () => $c48414640e6300f1$export$42a852a2b6b56249);
$parcel$export(module.exports, "Line", () => $c48414640e6300f1$export$17d680238e50603e);
$parcel$export(module.exports, "EmptyTime", () => $c48414640e6300f1$export$fdd47b9cc93176d7);
$parcel$export(module.exports, "Inner", () => $c48414640e6300f1$export$f63ba74aa66682be);
$parcel$export(module.exports, "Header", () => $c48414640e6300f1$export$8b251419efc915eb);
$parcel$export(module.exports, "Cell", () => $c48414640e6300f1$export$f6f0c3fe4ec306ea);
$parcel$export(module.exports, "Time", () => $c48414640e6300f1$export$680ea196effce5f);
$parcel$export(module.exports, "Stripe", () => $c48414640e6300f1$export$3c7919ca4c48cda4);
$parcel$export(module.exports, "List", () => $c48414640e6300f1$export$54c2e3dc7acea9f5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $hhW0G = parcelRequire("hhW0G");

var $4lizm = parcelRequire("4lizm");

var $bWGt6 = parcelRequire("bWGt6");
function $c48414640e6300f1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c48414640e6300f1$var$STRIPE_WIDTH = 2;
const $c48414640e6300f1$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j58"
})({
    position: 'relative',
    height: '100%',
    width: '100%',
    boxSizing: 'inherit',
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`
});
const $c48414640e6300f1$export$17d680238e50603e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j57"
})("position:absolute;height:100%;border-left:", (0, $4lizm.LINE_WIDTH), "px dashed ", `var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`, ";z-index:1;", ({ ratio: ratio, variant: variant, index: index })=>{
    switch(variant){
        case 'compact':
            return `
          left: calc(${ratio}% * ${index});

          &:first-of-type {
            display: none;
          }
        `;
        case 'full':
            return `
          left: calc(((100% - ${0, $4lizm.SIDE_HEADER_WIDTH}px) * ${ratio} * ${index}) / 100 + ${0, $4lizm.SIDE_HEADER_WIDTH}px);
        `;
    }
}, ";");
const $c48414640e6300f1$export$fdd47b9cc93176d7 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j56"
})({
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $4lizm.SIDE_HEADER_WIDTH)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $4lizm.SIDE_HEADER_WIDTH)}px`
});
const $c48414640e6300f1$export$f63ba74aa66682be = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j55"
})({
    name: "aeaamz",
    styles: "display:flex;flex-direction:row;width:100%;height:100%"
});
const $c48414640e6300f1$export$8b251419efc915eb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j54"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $4lizm.TIME_HEADER_HEIGHT)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${(0, $4lizm.TIME_HEADER_HEIGHT)}px`,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $c48414640e6300f1$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j53"
})("display:flex;justify-content:center;flex-direction:column;width:", ({ ratio: ratio })=>ratio, "%;", ({ nowLocation: nowLocation })=>{
    switch(nowLocation){
        case (0, $hhW0G.NowLocation).InRange:
            return `
          color: ${`var(--ds-text-accent-purple, ${0, $829f609a65d26a98$export$b48405b95304b5a1})`};
        `;
        default:
            return `
          color: ${`var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$ad0bacf983b7ddaa})`};
        `;
    }
}, " ", ({ display: display })=>{
    switch(display){
        case (0, $4lizm.TimeDisplay).HorizontalDay:
        case (0, $4lizm.TimeDisplay).VerticalDay:
            return `
          align-items: center;
        `;
        case (0, $4lizm.TimeDisplay).Hour:
            return `
          align-items: flex-start;
        `;
    }
}, ";");
const $c48414640e6300f1$export$680ea196effce5f = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1jpk2j52"
})("line-height:16px;", ({ display: display })=>{
    switch(display){
        case (0, $4lizm.TimeDisplay).Hour:
            return `
          margin: 0 0 0 ${"var(--ds-space-100, 8px)"};
        `;
        default:
            return `
          margin: 0;
        `;
    }
}, ";");
const $c48414640e6300f1$export$3c7919ca4c48cda4 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j51"
})("background-color:", `var(--ds-text-accent-purple, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`, ";height:100%;position:absolute;top:0;width:", $c48414640e6300f1$var$STRIPE_WIDTH, "px;z-index:3;", ({ nowEpoch: nowEpoch, endEpoch: endEpoch, startEpoch: startEpoch, variant: variant })=>{
    const ratio = (nowEpoch - startEpoch) / (endEpoch - startEpoch);
    const halfWidth = $c48414640e6300f1$var$STRIPE_WIDTH / 2;
    if (variant === 'compact') return `left: calc((100%  * ${ratio}) - ${halfWidth}px);`;
    if (variant === 'full') // appropriate ratio of whole for smaller part (exclude rotation name width)
    return `left: calc(((100% - ${0, $4lizm.SIDE_HEADER_WIDTH}px) * ${ratio}) + ${0, $4lizm.SIDE_HEADER_WIDTH}px);`;
}, ";");
const $c48414640e6300f1$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1jpk2j50"
})((props)=>({
        minHeight: `${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $4lizm.ROTATION_FIRST_MARGIN) + (0, $4lizm.ROTATION_HEIGHT)[props.size] + (0, $4lizm.ROTATION_MARGIN)[props.size]}px`
    }));

});
parcelRegister("4lizm", function(module, exports) {

$parcel$export(module.exports, "TIME_HEADER_HEIGHT", () => $18a99bc9229f2bd0$export$9dbc926f0766cdb7);
$parcel$export(module.exports, "LINE_WIDTH", () => $18a99bc9229f2bd0$export$74793dbe506a1a5f);
$parcel$export(module.exports, "SIDE_HEADER_WIDTH", () => $18a99bc9229f2bd0$export$85b8fd35590e7592);
$parcel$export(module.exports, "ROTATION_FIRST_MARGIN", () => $18a99bc9229f2bd0$export$969c15374cd4f837);
$parcel$export(module.exports, "ROTATION_SLIM_HEIGHT", () => $18a99bc9229f2bd0$export$b7f6c9e5d8494bbe);
$parcel$export(module.exports, "ROTATION_HEIGHT", () => $18a99bc9229f2bd0$export$945bca128c67de1f);
$parcel$export(module.exports, "ROTATION_MARGIN", () => $18a99bc9229f2bd0$export$132b6f6673b4f494);
$parcel$export(module.exports, "TimeDisplay", () => $18a99bc9229f2bd0$export$9b3df3d60caed5f9);
const $18a99bc9229f2bd0$export$9dbc926f0766cdb7 = 44;
const $18a99bc9229f2bd0$export$74793dbe506a1a5f = 2;
const $18a99bc9229f2bd0$export$85b8fd35590e7592 = 104;
const $18a99bc9229f2bd0$export$969c15374cd4f837 = 4;
const $18a99bc9229f2bd0$export$bc331d17e73ab24a = 24; // Calendar rotation height
const $18a99bc9229f2bd0$export$4a96aed6b672ce98 = 2;
const $18a99bc9229f2bd0$export$b7f6c9e5d8494bbe = 32;
const $18a99bc9229f2bd0$export$3368e11b2039841b = 12;
const $18a99bc9229f2bd0$export$20b11068e0adbcf3 = 56;
const $18a99bc9229f2bd0$export$b4c9350680546616 = 24;
const $18a99bc9229f2bd0$export$945bca128c67de1f = {
    small: $18a99bc9229f2bd0$export$bc331d17e73ab24a,
    medium: $18a99bc9229f2bd0$export$b7f6c9e5d8494bbe,
    large: $18a99bc9229f2bd0$export$20b11068e0adbcf3
};
const $18a99bc9229f2bd0$export$132b6f6673b4f494 = {
    small: $18a99bc9229f2bd0$export$4a96aed6b672ce98,
    medium: $18a99bc9229f2bd0$export$3368e11b2039841b,
    large: $18a99bc9229f2bd0$export$b4c9350680546616
};
var $18a99bc9229f2bd0$export$9b3df3d60caed5f9 = /*#__PURE__*/ function(TimeDisplay) {
    TimeDisplay["Hour"] = "hourly";
    /* Short daily view */ TimeDisplay["VerticalDay"] = "short";
    /* Long daily view */ TimeDisplay["HorizontalDay"] = "long";
    return TimeDisplay;
}({});

});


parcelRegister("7oQpL", function(module, exports) {

$parcel$export(module.exports, "generateRanges", () => $e23307c3ed895235$export$8dcf5b6d0220a31f);
$parcel$export(module.exports, "getTimeDisplay", () => $e23307c3ed895235$export$b6fc5e3b7791f49);
$parcel$export(module.exports, "generateDateStrings", () => $e23307c3ed895235$export$75eb5c7ded32b293);

var $5Ppij = parcelRequire("5Ppij");

var $gwejS = parcelRequire("gwejS");

var $7XUeK = parcelRequire("7XUeK");

var $llSAI = parcelRequire("llSAI");

var $4lizm = parcelRequire("4lizm");

var $cbdlf = parcelRequire("cbdlf");
const $e23307c3ed895235$var$DAY_SECTION_LENGTH = 6; // 6 hours (24 / 4)
const $e23307c3ed895235$var$DAY_HOURS = 24;
const $e23307c3ed895235$var$WEEK_HOURS = 168;
const $e23307c3ed895235$var$MAX_DST_HOURS = 2; // Maximum DST offset
/**
 * Generates timeline displays (for day every 6 hours, for week every day, for month every day, etc.)
 * @returns Array of [start, end] for each section of timeline
 */ const $e23307c3ed895235$export$8dcf5b6d0220a31f = ({ startEpoch: startEpoch, endEpoch: endEpoch, offset: offset })=>{
    const times = [];
    const hours = (0, $llSAI.default)(endEpoch, startEpoch);
    const startDate = (0, $5Ppij.default)(startEpoch + offset, 'UTC');
    if (hours <= $e23307c3ed895235$var$DAY_HOURS + $e23307c3ed895235$var$MAX_DST_HOURS) // Every 6 hours
    for(let i = 0; i < $e23307c3ed895235$var$DAY_HOURS; i += $e23307c3ed895235$var$DAY_SECTION_LENGTH){
        const start = (0, $7XUeK.default)(startDate, i);
        const end = (0, $7XUeK.default)(start, $e23307c3ed895235$var$DAY_SECTION_LENGTH);
        times.push([
            start,
            end
        ]);
    }
    else {
        // It will be always between either 6.5 - 7.5 days or 13.5 - 14.5 days ...
        const days = Math.round(hours / 24);
        // Every day
        for(let i = 0; i < days; i++){
            const start = (0, $gwejS.default)(startDate, i);
            const end = (0, $gwejS.default)(start, 1);
            times.push([
                start,
                end
            ]);
        }
    }
    return times;
};
/**
 * Depending on difference between start and end epoch, returns oriantation of time (time header)
 * @returns TimeDisplay of the timeline (hour, horizontal day, vertical day)
 */ const $e23307c3ed895235$export$b6fc5e3b7791f49 = (start, end)=>{
    const hours = (0, $llSAI.default)(end, start);
    if (hours <= $e23307c3ed895235$var$DAY_HOURS + $e23307c3ed895235$var$MAX_DST_HOURS) return (0, $4lizm.TimeDisplay).Hour;
    if (hours <= $e23307c3ed895235$var$WEEK_HOURS + $e23307c3ed895235$var$MAX_DST_HOURS) return (0, $4lizm.TimeDisplay).HorizontalDay;
    return (0, $4lizm.TimeDisplay).VerticalDay;
};
/**
 * Generates date strings for a given display (hour, horizontal day, vertical day)
 * @returns [firstTime, secondTime]
 */ const $e23307c3ed895235$export$75eb5c7ded32b293 = ({ intlApi: intlApi, display: display, date: date })=>{
    switch(display){
        case (0, $4lizm.TimeDisplay).Hour:
            return [
                intlApi.formatMessage((0, $cbdlf.messages).weekDayShortDayNumeric, {
                    weekDayShort: intlApi.formatDate(date, {
                        weekday: 'short'
                    }).toUpperCase(),
                    dayNumeric: intlApi.formatDate(date, {
                        day: 'numeric'
                    })
                }),
                intlApi.formatDate(date, {
                    hour: '2-digit',
                    minute: '2-digit'
                })
            ];
        case (0, $4lizm.TimeDisplay).HorizontalDay:
            return [
                intlApi.formatMessage((0, $cbdlf.messages).weekDayShortDayNumeric, {
                    weekDayShort: intlApi.formatDate(date, {
                        weekday: 'short'
                    }).toUpperCase(),
                    dayNumeric: intlApi.formatDate(date, {
                        day: 'numeric'
                    })
                })
            ];
        case (0, $4lizm.TimeDisplay).VerticalDay:
            return [
                intlApi.formatDate(date, {
                    weekday: 'narrow'
                }),
                intlApi.formatDate(date, {
                    day: 'numeric'
                })
            ];
    }
};

});
parcelRegister("cbdlf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef8f25afd60f0127$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ef8f25afd60f0127$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    weekDayShortDayNumeric: {
        id: 'eoc-schedule-common.common.ui.timeline.layer.week-day-short-day-numeric',
        defaultMessage: '{weekDayShort} {dayNumeric}',
        description: 'Date render method for a day or a week. (e.g. MON 14, TUE 31)'
    }
});

});



parcelRegister("cKHxL", function(module, exports) {

$parcel$export(module.exports, "TimelineLoading", () => $8831476d2fc5f44d$export$fac7c14eeddcfe8c);

var $5uXOq = parcelRequire("5uXOq");

var $eXUv6 = parcelRequire("eXUv6");

var $cu6aN = parcelRequire("cu6aN");
const $8831476d2fc5f44d$export$fac7c14eeddcfe8c = ({ size: size = 'medium', numberOfDays: numberOfDays, variant: variant })=>{
    const sectionCount = numberOfDays === 1 ? 4 : numberOfDays;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXUv6.LayerLoading), {
        variant: variant,
        size: size,
        numberOfDays: sectionCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cu6aN.RotationLoading), {
        variant: variant,
        size: size,
        numberOfDays: sectionCount
    }));
};

});
parcelRegister("eXUv6", function(module, exports) {

$parcel$export(module.exports, "LayerLoading", () => $8b413efbbfc43723$export$3d573c5a0d303702);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");

var $hhW0G = parcelRequire("hhW0G");

var $4lizm = parcelRequire("4lizm");

var $khXRb = parcelRequire("khXRb");
const $8b413efbbfc43723$export$3d573c5a0d303702 = ({ numberOfDays: numberOfDays, children: children, variant: variant, size: size })=>{
    const sectionCount = numberOfDays === 1 ? 4 : numberOfDays;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Container), null, Array.from({
        length: sectionCount
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Line), {
            variant: variant,
            ratio: 100 / sectionCount,
            index: i,
            key: i
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Header), null, variant === 'full' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.EmptyTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Inner), null, Array.from({
        length: sectionCount
    }).map((_, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.Cell), {
            variant: variant,
            ratio: 100 / sectionCount,
            display: (0, $4lizm.TimeDisplay).VerticalDay,
            key: i,
            nowLocation: (0, $hhW0G.NowLocation).After
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            height: 1,
            width: 3.25
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khXRb.List), {
        size: size
    }, children));
};

});

parcelRegister("cu6aN", function(module, exports) {

$parcel$export(module.exports, "RotationLoading", () => $a8acc1f54ddb6ded$export$e669eb6d892086e);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");

var $hYELq = parcelRequire("hYELq");
const $a8acc1f54ddb6ded$export$e669eb6d892086e = ({ size: size, numberOfDays: numberOfDays, variant: variant })=>{
    const sectionCount = numberOfDays === 1 ? 4 : numberOfDays;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Container), {
        highlighted: false,
        size: size
    }, variant === 'full' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Side), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 2,
        width: 7
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Inner), null, Array.from({
        length: sectionCount
    }).map((_, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.SkeletonItemContainer), {
            numberOfDays: sectionCount,
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
            height: 2.375,
            width: 2.375
        }));
    })));
};

});
parcelRegister("hYELq", function(module, exports) {

$parcel$export(module.exports, "Container", () => $3abb6afe9e09122e$export$42a852a2b6b56249);
$parcel$export(module.exports, "Side", () => $3abb6afe9e09122e$export$80a00690bda7f17e);
$parcel$export(module.exports, "Inner", () => $3abb6afe9e09122e$export$f63ba74aa66682be);
$parcel$export(module.exports, "Name", () => $3abb6afe9e09122e$export$c7bd411105e2dec3);
$parcel$export(module.exports, "SkeletonItemContainer", () => $3abb6afe9e09122e$export$ac08e2a91acf255f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $4lizm = parcelRequire("4lizm");

var $bWGt6 = parcelRequire("bWGt6");
function $3abb6afe9e09122e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3abb6afe9e09122e$var$NAME_PADDING = 8;
const $3abb6afe9e09122e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1pi78xc4"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $4lizm.ROTATION_HEIGHT)[props.size]}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingTop: `${(0, $4lizm.ROTATION_MARGIN)[props.size] / 2}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingBottom: `${(0, $4lizm.ROTATION_MARGIN)[props.size] / 2}px`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isFirstLastSame: isFirstLastSame, size: size })=>isFirstLastSame !== true && `
      &:first-of-type {
		${''}
        padding-top: ${0, $4lizm.ROTATION_FIRST_MARGIN}px;
      }

      &:last-of-type {
${''}
        padding-bottom: ${(0, $4lizm.ROTATION_MARGIN)[size]}px;
      }
    `, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.highlighted ? "var(--ds-background-accent-teal-subtlest, #E3FAFC)" : 'transparent'
    }));
const $3abb6afe9e09122e$export$80a00690bda7f17e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1pi78xc3"
})({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $4lizm.SIDE_HEADER_WIDTH) + (0, $4lizm.LINE_WIDTH)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $4lizm.SIDE_HEADER_WIDTH) + (0, $4lizm.LINE_WIDTH)}px`
});
const $3abb6afe9e09122e$export$f63ba74aa66682be = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1pi78xc2"
})({
    name: "19r0v6o",
    styles: "position:relative;display:flex;width:100%;height:100%"
});
const $3abb6afe9e09122e$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "e1pi78xc1"
})((props)=>({
        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        overflow: 'hidden',
        padding: `0 ${$3abb6afe9e09122e$var$NAME_PADDING}px`,
        textAlign: 'right',
        textOverflow: 'ellipsis',
        textTransform: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $4lizm.SIDE_HEADER_WIDTH) - 2 * $3abb6afe9e09122e$var$NAME_PADDING}px`,
        '@supports (-webkit-line-clamp: 1)': {
            display: '-webkit-box',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            WebkitLineClamp: props.slim ? 2 : 4,
            WebkitBoxOrient: 'vertical'
        }
    }));
const $3abb6afe9e09122e$export$ac08e2a91acf255f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1pi78xc0"
})((props)=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% / ${props.numberOfDays})`
    }));

});



parcelRegister("1Ntyt", function(module, exports) {

$parcel$export(module.exports, "DateNavigation", () => $4c154988d63f20c1$export$739274af9066f01f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $3Qiip = parcelRequire("3Qiip");

var $hWZau = parcelRequire("hWZau");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $9YkY7 = parcelRequire("9YkY7");
var $5s9eT = parcelRequire("5s9eT");
var $jU88x = parcelRequire("jU88x");
var $cebl7 = parcelRequire("cebl7");

var $8icyj = parcelRequire("8icyj");

var $3wjxB = parcelRequire("3wjxB");

var $5verT = parcelRequire("5verT");

var $vkkME = parcelRequire("vkkME");

var $krvjv = parcelRequire("krvjv");
const $4c154988d63f20c1$var$arrowButtonContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});
const $4c154988d63f20c1$export$739274af9066f01f = ({ startEpoch: startEpoch, endEpoch: endEpoch, nowEpoch: nowEpoch, startOffset: startOffset, endOffset: endOffset, isLoading: isLoading, nextPeriod: nextPeriod, onTimelineTypeChange: onTimelineTypeChange, onToday: onToday, onViewChange: onViewChange, previousPeriod: previousPeriod, selectedTimelineType: selectedTimelineType, selectedView: selectedView, scheduleName: scheduleName })=>{
    const intlApi = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [bodyWidth] = (0, $cebl7.useResize)(document.documentElement);
    const navLabels = (0, $jU88x.getNavigationLabels)(intlApi)(selectedTimelineType, scheduleName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vkkME.RangeContainer), null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 2,
        width: 15
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $5verT.getNowLocation)(startEpoch, endEpoch, nowEpoch) !== (0, $3wjxB.NowLocation).InRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        appearance: "link",
        // TODO: prevent change if loading
        onClick: ()=>onToday()
    }, intlApi.formatMessage((0, $9YkY7.messages).today)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vkkME.ScheduleDate), null, (0, $krvjv.formatScheduleDate)({
        intlApi: intlApi,
        startEpoch: startEpoch,
        endEpoch: endEpoch,
        startOffset: startOffset,
        endOffset: endOffset,
        view: selectedView,
        range: selectedTimelineType,
        variant: bodyWidth <= 1024 ? 'short' : 'long'
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: navLabels.previous.tooltip,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4c154988d63f20c1$var$arrowButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        // TODO: prevent change if loading
        onClick: previousPeriod,
        label: navLabels.previous.aria,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Qiip)))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: navLabels.next.tooltip,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4c154988d63f20c1$var$arrowButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        // TODO: prevent change if loading
        onClick: nextPeriod,
        label: navLabels.next.aria,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWZau)))
    }))), selectedView === (0, $5s9eT.NavigationMode).Timeline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...(0, $5s9eT.GET_EXTRA_SELECT_PROPS)(),
        isSearchable: false,
        // TODO: prevent change if loading
        onChange: (option)=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', `${(0, $krvjv.timelineTypeToName)(option.value)}`);
            onTimelineTypeChange(option.value);
        },
        options: (0, $jU88x.getTimelineTypeOptions)(intlApi).map((timelineTypeOption)=>timelineTypeOption),
        styles: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            control: (base)=>({
                    ...base,
                    ...(0, $vkkME.periodSelectStyles)
                }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $5s9eT.GET_EXTRA_SELECT_PROPS)().styles
        },
        spacing: "compact",
        value: (0, $jU88x.getTimelineTypeOptions)(intlApi).find(({ value: value })=>value === selectedTimelineType),
        label: intlApi.formatMessage((0, $9YkY7.messages).selectTimelineView, {
            scheduleName: scheduleName
        }),
        placeholder: intlApi.formatMessage((0, $9YkY7.messages).selectTimelineView, {
            scheduleName: scheduleName
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...(0, $5s9eT.GET_EXTRA_SELECT_PROPS)(),
        isSearchable: false,
        // TODO: prevent change if loading
        onChange: (option)=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', `${option.value}View`);
            onViewChange(option.value);
        },
        options: (0, $jU88x.getScheduleViewOptions)(intlApi).map((viewOption)=>viewOption),
        spacing: "compact",
        styles: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            control: (base)=>({
                    ...base,
                    ...(0, $vkkME.viewSelectStyles)
                }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $5s9eT.GET_EXTRA_SELECT_PROPS)().styles
        },
        value: (0, $jU88x.getScheduleViewOptions)(intlApi).find(({ value: value })=>value === selectedView),
        label: intlApi.formatMessage((0, $9YkY7.messages).selectScheduleView, {
            scheduleName: scheduleName
        }),
        placeholder: intlApi.formatMessage((0, $9YkY7.messages).selectScheduleView, {
            scheduleName: scheduleName
        })
    }));
};

});
parcelRegister("3Qiip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4921a5f5d2bd15795c12deee4a34e513>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc46ba193f64324$var$_react = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cc46ba193f64324$var$_chevronLeft = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("lRheX")));

var $2cc46ba193f64324$var$_chevronLeft2 = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("nHhrH")));
function $2cc46ba193f64324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc46ba193f64324$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2cc46ba193f64324$var$_react.default.createElement($2cc46ba193f64324$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $2cc46ba193f64324$var$_chevronLeft2.default
    }, props));
$2cc46ba193f64324$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $2cc46ba193f64324$var$_default = module.exports.default = $2cc46ba193f64324$var$ChevronLeftIcon;

});
parcelRegister("nHhrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $0473b8ae11c957a6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0473b8ae11c957a6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;

});


parcelRegister("jU88x", function(module, exports) {

$parcel$export(module.exports, "getScheduleViewOptions", () => $5ea672bc7181bc53$export$b1a780f8c997f4d9);
$parcel$export(module.exports, "getTimelineTypeOptions", () => $5ea672bc7181bc53$export$238acae52845763b);
$parcel$export(module.exports, "getNavigationLabels", () => $5ea672bc7181bc53$export$5adda790f01efade);

var $5s9eT = parcelRequire("5s9eT");

var $9YkY7 = parcelRequire("9YkY7");

var $8Gzu0 = parcelRequire("8Gzu0");
const $5ea672bc7181bc53$export$b1a780f8c997f4d9 = (intlApi)=>[
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).timelineView),
            value: (0, $5s9eT.NavigationMode).Timeline
        },
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).calendarView),
            value: (0, $5s9eT.NavigationMode).Calendar
        }
    ];
const $5ea672bc7181bc53$export$238acae52845763b = (intlApi)=>[
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).oneDay),
            value: (0, $5s9eT.NavigationPeriodId).OneDay
        },
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).oneWeek),
            value: (0, $5s9eT.NavigationPeriodId).OneWeek
        },
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).twoWeeks),
            value: (0, $5s9eT.NavigationPeriodId).TwoWeeks
        },
        {
            label: intlApi.formatMessage((0, $9YkY7.messages).oneMonth),
            value: (0, $5s9eT.NavigationPeriodId).OneMonth
        }
    ];
const $5ea672bc7181bc53$export$5adda790f01efade = (intlApi)=>(period, scheduleName)=>({
            next: {
                aria: intlApi.formatMessage((0, $9YkY7.messages).inSchedule, {
                    prefix: intlApi.formatMessage((0, $9YkY7.messages).nextPeriod, {
                        period: intlApi.formatMessage((0, $8Gzu0.navigationLabels)[period])
                    }),
                    scheduleName: scheduleName
                }),
                tooltip: intlApi.formatMessage((0, $9YkY7.messages).nextPeriod, {
                    period: intlApi.formatMessage((0, $8Gzu0.navigationLabels)[period])
                })
            },
            previous: {
                aria: intlApi.formatMessage((0, $9YkY7.messages).inSchedule, {
                    prefix: intlApi.formatMessage((0, $9YkY7.messages).previousPeriod, {
                        period: intlApi.formatMessage((0, $8Gzu0.navigationLabels)[period])
                    }),
                    scheduleName: scheduleName
                }),
                tooltip: intlApi.formatMessage((0, $9YkY7.messages).previousPeriod, {
                    period: intlApi.formatMessage((0, $8Gzu0.navigationLabels)[period])
                })
            }
        });

});
parcelRegister("8Gzu0", function(module, exports) {

$parcel$export(module.exports, "navigationLabels", () => $ae5944a65771681a$export$32b600928ab879c0);
$parcel$export(module.exports, "timelineTypeNames", () => $ae5944a65771681a$export$d3627ffc7d1a33ae);

var $5s9eT = parcelRequire("5s9eT");

var $9YkY7 = parcelRequire("9YkY7");
const $ae5944a65771681a$export$32b600928ab879c0 = {
    [(0, $5s9eT.NavigationPeriodId).OneDay]: (0, $9YkY7.messages).day,
    [(0, $5s9eT.NavigationPeriodId).OneWeek]: (0, $9YkY7.messages).week,
    [(0, $5s9eT.NavigationPeriodId).TwoWeeks]: (0, $9YkY7.messages).twoWeeks,
    [(0, $5s9eT.NavigationPeriodId).OneMonth]: (0, $9YkY7.messages).month
};
const $ae5944a65771681a$export$d3627ffc7d1a33ae = {
    [(0, $5s9eT.NavigationPeriodId).OneDay]: 'oneDay',
    [(0, $5s9eT.NavigationPeriodId).OneWeek]: 'oneWeek',
    [(0, $5s9eT.NavigationPeriodId).TwoWeeks]: 'twoWeeks',
    [(0, $5s9eT.NavigationPeriodId).OneMonth]: 'oneMonth'
};

});


parcelRegister("cebl7", function(module, exports) {

$parcel$export(module.exports, "useResize", () => $383fdb6e74558303$export$e8b771555dc4a003);

var $5uXOq = parcelRequire("5uXOq");
/**
 * @template T extends HTMLElement - Target Element Type
 * @param targetRef - Target Element
 * @returns [width: number, height: number]
 */ const $383fdb6e74558303$export$e8b771555dc4a003 = (targetRef)=>{
    const [size, setSize] = (0, $5uXOq.useState)(null);
    const observerRef = (0, $5uXOq.useRef)(new ResizeObserver((entries)=>{
        const { width: width, height: height } = entries[0].contentRect;
        setSize([
            width,
            height
        ]);
    }));
    (0, $5uXOq.useLayoutEffect)(()=>{
        const observer = observerRef.current;
        const target = targetRef && 'current' in targetRef ? targetRef.current : targetRef;
        if (!target) return ()=>{};
        observer.observe(target);
        return ()=>{
            observer.unobserve(target);
        };
    }, [
        targetRef
    ]);
    return size || [];
};

});

parcelRegister("3wjxB", function(module, exports) {

$parcel$export(module.exports, "NowLocation", () => $df7139224cff8926$export$f3accd68e6d1c6a3);
var $df7139224cff8926$export$f3accd68e6d1c6a3 = /*#__PURE__*/ function(NowLocation) {
    NowLocation[NowLocation["InRange"] = 0] = "InRange";
    NowLocation[NowLocation["Before"] = 1] = "Before";
    NowLocation[NowLocation["After"] = 2] = "After";
    return NowLocation;
}({});

});

parcelRegister("5verT", function(module, exports) {

$parcel$export(module.exports, "getNowLocation", () => $f33054550a619e2b$export$e6665d7f0d1b1985);
$parcel$export(module.exports, "getNumberOfDays", () => $f33054550a619e2b$export$cfb876877a7c9210);

var $6D6zP = parcelRequire("6D6zP");

var $5s9eT = parcelRequire("5s9eT");

var $3wjxB = parcelRequire("3wjxB");
// TODO: move to schedule common
/**
 * @returns Before | After | InRange
 */ const $f33054550a619e2b$export$e6665d7f0d1b1985 = (startEpoch, endEpoch, nowEpoch)=>{
    if (nowEpoch > endEpoch) return (0, $3wjxB.NowLocation).After;
    if (nowEpoch < startEpoch) return (0, $3wjxB.NowLocation).Before;
    return (0, $3wjxB.NowLocation).InRange;
};
// TODO: move to schedule common
const $f33054550a619e2b$export$cfb876877a7c9210 = ({ timelineType: timelineType, currentDate: currentDate })=>{
    switch(timelineType){
        case (0, $5s9eT.NavigationPeriodId).OneDay:
            return 1;
        case (0, $5s9eT.NavigationPeriodId).OneWeek:
            return 7;
        case (0, $5s9eT.NavigationPeriodId).TwoWeeks:
            return 14;
        case (0, $5s9eT.NavigationPeriodId).OneMonth:
            return (0, $6D6zP.default)(currentDate);
    }
};

});

parcelRegister("vkkME", function(module, exports) {

$parcel$export(module.exports, "ScheduleDate", () => $6531a3e7b7961114$export$f2ea622dd6ce9dd8);
$parcel$export(module.exports, "RangeContainer", () => $6531a3e7b7961114$export$368161631670e034);
$parcel$export(module.exports, "periodSelectStyles", () => $6531a3e7b7961114$export$3de1ba05f879200a);
$parcel$export(module.exports, "viewSelectStyles", () => $6531a3e7b7961114$export$5b3ac59ed765cd96);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
const $6531a3e7b7961114$export$f2ea622dd6ce9dd8 = /*#__PURE__*/ (0, $bWGt6.default)("h5", {
    target: "exk4ji61"
})({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    margin: `0 0 0 ${"var(--ds-space-100, 8px)"}`
});
const $6531a3e7b7961114$export$368161631670e034 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "exk4ji60"
})({
    display: 'flex',
    alignItems: 'center',
    margin: `0 ${"var(--ds-space-100, 8px)"} 0 0`
});
const $6531a3e7b7961114$export$3de1ba05f879200a = {
    marginRight: "var(--ds-space-100, 8px)",
    // TODO: remove width after ‘@atlaskit/Select’ upgrade
    maxWidth: '110px',
    minWidth: '110px',
    width: '110px'
};
const $6531a3e7b7961114$export$5b3ac59ed765cd96 = {
    // TODO: remove width after ‘@atlaskit/Select’ upgrade
    maxWidth: '150px',
    minWidth: '150px',
    width: '150px'
};

});

parcelRegister("krvjv", function(module, exports) {

$parcel$export(module.exports, "formatScheduleDate", () => $ea53ac127aa4d2c8$export$acf97949b8b3b80a);
$parcel$export(module.exports, "timelineTypeToName", () => $ea53ac127aa4d2c8$export$12b4f0fa5d0f1d3e);

var $hWMqm = parcelRequire("hWMqm");

var $gwejS = parcelRequire("gwejS");

var $4mBKK = parcelRequire("4mBKK");

var $5s9eT = parcelRequire("5s9eT");

var $kLazb = parcelRequire("kLazb");
const $ea53ac127aa4d2c8$export$acf97949b8b3b80a = ({ intlApi: intlApi, startEpoch: startEpoch, endEpoch: endEpoch, range: range, view: view, startOffset: startOffset, endOffset: endOffset, variant: variant })=>{
    const startDate = (0, $hWMqm.default)(startEpoch + startOffset, 'UTC');
    const endDate = (0, $hWMqm.default)(endEpoch + endOffset - 1, 'UTC');
    if (view === (0, $5s9eT.NavigationMode).Timeline) return range === (0, $5s9eT.NavigationPeriodId).OneDay ? intlApi.formatMessage((0, $kLazb.messages).dateSingle, {
        weekDayLong: intlApi.formatDate(startDate, {
            weekday: 'long'
        }),
        monthShort: intlApi.formatDate(startDate, {
            month: variant
        }),
        dayNumeric: intlApi.formatDate(startDate, {
            day: 'numeric'
        })
    }) : intlApi.formatMessage((0, $kLazb.messages).dateRange, {
        startMonthShort: intlApi.formatDate(startDate, {
            month: variant
        }),
        startDayNumeric: intlApi.formatDate(startDate, {
            day: 'numeric'
        }),
        endMonthShort: intlApi.formatDate(endDate, {
            month: variant
        }),
        endDayNumeric: intlApi.formatDate(endDate, {
            day: 'numeric'
        })
    });
    const midDate = (0, $gwejS.default)(startDate, Math.floor((0, $4mBKK.default)(endDate, startDate) / 2));
    if (view === (0, $5s9eT.NavigationMode).Calendar) return intlApi.formatMessage((0, $kLazb.messages).dateCalendar, {
        monthLong: intlApi.formatDate(midDate, {
            month: 'long'
        }),
        yearLong: intlApi.formatDate(midDate, {
            year: 'numeric'
        })
    });
};
// TODO: make common
const $ea53ac127aa4d2c8$export$12b4f0fa5d0f1d3e = (timelineType)=>{
    switch(timelineType){
        case (0, $5s9eT.NavigationPeriodId).OneDay:
            return 'oneDay';
        case (0, $5s9eT.NavigationPeriodId).OneWeek:
            return 'oneWeek';
        case (0, $5s9eT.NavigationPeriodId).TwoWeeks:
            return 'twoWeeks';
        case (0, $5s9eT.NavigationPeriodId).OneMonth:
            return 'oneMonth';
    }
};

});
parcelRegister("kLazb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b0fd68aadebf56ec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b0fd68aadebf56ec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dateRange: {
        id: 'eoc-schedule.common.ui.date-navigation.date-range',
        defaultMessage: '{startMonthShort} {startDayNumeric} - {endMonthShort} {endDayNumeric}',
        description: 'Shown date range in schedule. (e.g. Nov 14 - Nov 28)'
    },
    dateSingle: {
        id: 'eoc-schedule.common.ui.date-navigation.date-single',
        defaultMessage: '{weekDayLong}, {monthShort} {dayNumeric}',
        description: 'Shown single date in schedule. (e.g. Tuesday, Nov 15)'
    },
    dateCalendar: {
        id: 'eoc-schedule.common.ui.date-navigation.date-calendar',
        defaultMessage: '{monthLong} {yearLong}',
        description: 'Shown date in schedule for calendar view. (e.g. February 2023)'
    }
});

});



parcelRegister("4XJMJ", function(module, exports) {

$parcel$export(module.exports, "useExportTimelineService", () => $f1ebb55495b12bbb$export$4a05aa4861284d26);
$parcel$export(module.exports, "useNamesLoading", () => $f1ebb55495b12bbb$export$f77ad22e805711bb);
$parcel$export(module.exports, "useCompleteTask", () => $f1ebb55495b12bbb$export$488061e46b76b34a);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $doZTA = parcelRequire("doZTA");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $fXc9u = parcelRequire("fXc9u");

var $cP0uo = parcelRequire("cP0uo");
var $5s9eT = parcelRequire("5s9eT");
var $3swqE = parcelRequire("3swqE");

var $jkGAf = parcelRequire("jkGAf");

var $aEk7H = parcelRequire("aEk7H");

var $dQNfh = parcelRequire("dQNfh");

var $1IQ7I = parcelRequire("1IQ7I");

var $9It5A = parcelRequire("9It5A");

var $eLDPp = parcelRequire("eLDPp");
const $f1ebb55495b12bbb$export$4a05aa4861284d26 = (scheduleId)=>{
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const exportTimeline = (0, $5uXOq.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            const { filename: filename, content: content } = await (0, $dQNfh.endpoints).exportTimeline({
                scheduleId: scheduleId
            });
            // TODO: find proper fallback
            (0, $3swqE.saveTextAsFile)(content, filename ?? 'file.ics');
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $eLDPp.messages).exportTimelineSuccessTitle),
                isAutoDismiss: true
            });
        } catch (error) {
            defaultCatch({
                id: 'useExportTimelineService-exportTimeline',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $eLDPp.messages).exportTimelineErrorTitle),
                        actions: [
                            {
                                content: intlApi.formatMessage((0, $jkGAf.messages).tryAgain),
                                onClick: ()=>exportTimeline()
                            }
                        ]
                    });
                }
            }, error);
        } finally{
            setIsLoading(false);
        }
    }, [
        defaultCatch,
        flagApi,
        intlApi,
        scheduleId
    ]);
    return {
        isLoading: isLoading,
        exportTimeline: exportTimeline
    };
};
const $f1ebb55495b12bbb$export$f77ad22e805711bb = ()=>{
    const [{ selectedView: selectedView, timelineData: timelineData, calendarData: calendarData }] = (0, $9It5A.useStore)();
    const responders = (0, $5uXOq.useMemo)(()=>{
        let uniqueResponders = [];
        if (selectedView === (0, $5s9eT.NavigationMode).Timeline) {
            const layers = [
                ...timelineData?.defaultLayers ? timelineData?.defaultLayers : [],
                ...timelineData?.overrideLayers ? timelineData?.overrideLayers : [],
                ...timelineData?.finalLayers ? timelineData?.finalLayers : []
            ];
            uniqueResponders = layers.reduce((acc, layer)=>{
                layer.periods.forEach((period)=>{
                    const { id: id, type: type } = period.responder;
                    if (!acc.some((responder)=>responder.id === id)) acc.push({
                        id: id,
                        type: type
                    });
                });
                return acc;
            }, []);
        }
        if (selectedView === (0, $5s9eT.NavigationMode).Calendar) uniqueResponders = calendarData ? calendarData.finalWeeks.reduce((acc, week)=>{
            week.rotations.forEach((rotation)=>{
                rotation.periods.forEach((period)=>{
                    const { id: id, type: type } = period.responder;
                    if (!acc.some((responder)=>responder.id === id)) acc.push({
                        id: id,
                        type: type
                    });
                });
            });
            return acc;
        }, []) : [];
        return uniqueResponders;
    }, [
        calendarData,
        selectedView,
        timelineData?.defaultLayers,
        timelineData?.finalLayers,
        timelineData?.overrideLayers
    ]);
    const users = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)(responders));
    const isLoading = (0, $5uXOq.useMemo)(()=>users.some((user)=>user.isLoading), [
        users
    ]);
    return {
        isLoading: isLoading
    };
};
const $f1ebb55495b12bbb$export$488061e46b76b34a = ()=>{
    const [routerContext] = (0, $doZTA.useRouter)();
    const teamId = (0, $1IQ7I.getTeamIdFromContext)(routerContext);
    const completeTask = (0, $5uXOq.useCallback)(()=>{
        return (0, $aEk7H.completeTaskEndpoint)(teamId);
    }, [
        teamId
    ]);
    return {
        completeTask: completeTask
    };
};

});
parcelRegister("3swqE", function(module, exports) {

$parcel$export(module.exports, "saveTextAsFile", () => $c122e43a559bcd1c$export$f4011cafd3cb5b2a);
// TODO: Follow best practices!
// TODO: move to separete folder
const $c122e43a559bcd1c$export$f4011cafd3cb5b2a = (content, filename)=>{
    if (!content || !filename) // TODO: throw error or send event
    return;
    const blob = new Blob([
        content
    ], {
        type: 'text/plain'
    });
    const a = document.createElement('a');
    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = [
        'text/plain',
        a.download,
        a.href
    ].join(':');
    document.body.appendChild(a);
    a.click();
    a.remove();
};

});

parcelRegister("aEk7H", function(module, exports) {

$parcel$export(module.exports, "completeTaskEndpoint", () => $4b535ec852611254$export$43adb756d1007327);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $4b535ec852611254$export$43adb756d1007327 = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).onboarding.completeTask.url(), {
        method: 'POST',
        body: {
            platformTeamId: teamId,
            completedItemKey: 'opsgenie-review-oncall-setup'
        }
    });
};

});

parcelRegister("eLDPp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4e03f42c22600bec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4e03f42c22600bec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    exportTimelineErrorTitle: {
        id: 'eoc-schedule.controllers.schedule.export-timeline-error-title',
        defaultMessage: "We couldn't export your schedule.",
        description: 'This message indicates that our back-end services did not respond when exporting schedule.'
    },
    exportTimelineSuccessTitle: {
        id: 'eoc-schedule.controllers.schedule.export-timeline-success-title',
        defaultMessage: 'Your schedule is successfully exported.',
        description: 'This message indicates schedule is successfully exported.'
    }
});

});


parcelRegister("fIAuI", function(module, exports) {

$parcel$export(module.exports, "RotationList", () => $a43a568790dc4dc7$export$1a518033514482d5);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $i07hd = parcelRequire("i07hd");
var $3FhTI = parcelRequire("3FhTI");
var $5s9eT = parcelRequire("5s9eT");
var $dAkvd = parcelRequire("dAkvd");
var $jH8Xl = parcelRequire("jH8Xl");
var $cR6iS = parcelRequire("cR6iS");
var $bZWhc = parcelRequire("bZWhc");

var $9T6pk = parcelRequire("9T6pk");

var $3NQti = parcelRequire("3NQti");
const $a43a568790dc4dc7$export$1a518033514482d5 = (props)=>{
    const { rotations: rotations, layer: layer, ...rest } = props;
    const [activePopup, setActivePopup] = (0, $5uXOq.useState)();
    const [activeRotation] = (0, $3NQti.useRotation)();
    const { displayDensity: displayDensity } = (0, $9T6pk.useSectionUiPreferences)();
    const timeline = rest;
    const itemTable = (0, $5uXOq.useMemo)(()=>(0, $i07hd.fromRotationsToItemTable)(rotations), [
        rotations
    ]);
    const { tabbed: tabbed, focusRefs: focusRefs, onContainerKeyDown: onContainerKeyDown, tab: tab } = (0, $bZWhc.useShiftFocus)(itemTable, timeline.nowEpoch);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // NOTE: might be re add later
        // role="table"
        // aria-label={layer.label}
        // aria-roledescription={intlApi.formatMessage(
        //   scheduleCommonMessages.timelineLayer,
        // )}
        onKeyDown: onContainerKeyDown
    }, rotations.map((rotation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAkvd.Rotation), {
            key: rotation.id,
            highlighted: activeRotation && rotation.id === null || activeRotation?.id === rotation.id,
            name: rotation.name,
            variant: "full",
            size: displayDensity !== 'comfort' ? 'medium' : 'large'
        }, rotation.periods.map((period)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
                key: period.id,
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR6iS.SingleViewShiftCard), {
                        onClose: ()=>setActivePopup(undefined),
                        cards: [
                            {
                                ...period,
                                rotation: rotation
                            }
                        ]
                    }),
                isOpen: activePopup === period.id,
                // TODO: make common function
                // Made onClose ignore close if an shift tile in current layer is click
                // Because for some reason onClose fires after new popup open causing
                // it to close as well
                onClose: (e)=>{
                    if (e.target instanceof HTMLElement) {
                        const target = e.target.closest('[data-shift-id]');
                        if (target && Object.values(focusRefs).some((ref)=>ref.current === target)) return;
                    }
                    setActivePopup(undefined);
                },
                placement: "bottom",
                zIndex: (0, $k5uoT.layers).modal() + 1,
                trigger: ({ ref: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH8Xl.SimpleShiftTile), {
                        ref: (0, $3FhTI.mergeRefs)(triggerRef, focusRefs[period.id]),
                        onClick: ()=>{
                            if (activePopup === period.id) setActivePopup(undefined);
                            else {
                                tab(period.id);
                                setActivePopup(period.id);
                            }
                        },
                        period: period,
                        outerTimeFrame: timeline,
                        isSelected: activePopup === period.id,
                        isTabbable: tabbed?.id === period.id,
                        size: displayDensity !== 'comfort' ? 'medium' : 'large',
                        hasOverrideBorder: period.type === (0, $5s9eT.PeriodType).Override || period.type === (0, $5s9eT.PeriodType).Forwarding
                    })
            }))))));
};

});
parcelRegister("i07hd", function(module, exports) {

$parcel$export(module.exports, "getClosestInTable", () => $57c037ffdd302431$export$e8a4a9ae9f7a1fff);
$parcel$export(module.exports, "move", () => $57c037ffdd302431$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "findItemIndexInTable", () => $57c037ffdd302431$export$905343f4c882cd13);
$parcel$export(module.exports, "getItem", () => $57c037ffdd302431$export$f92dfeb71e9bb569);
$parcel$export(module.exports, "fromClusterPeriodsToItemTable", () => $57c037ffdd302431$export$37fa7720f4af9c1c);
$parcel$export(module.exports, "fromRotationsToItemTable", () => $57c037ffdd302431$export$d7b6dfbcf1445709);
$parcel$export(module.exports, "fromWeeksToItemTable", () => $57c037ffdd302431$export$c79d9e1d369bcfdc);
/**
 * @param items - List of items
 * @param epoch - Target epoch
 * @returns index - Index of nearest item to the given epoch (prefers future side of epoch)
 * @returns null - If item not found
 */ const $57c037ffdd302431$export$3c1958d6a7298a16 = (items, epoch)=>{
    if (items.length === 0) return null;
    if (epoch <= items[0].epoch) return 0;
    if (epoch >= items[items.length - 1].epoch) return items.length - 1;
    let left = 0;
    let right = items.length - 1;
    while(left <= right){
        let mid = Math.floor((left + right) / 2);
        if (epoch < items[mid].epoch) right = mid - 1;
        else if (epoch > items[mid].epoch) left = mid + 1;
        else return mid;
    }
    return items[left].epoch - epoch < epoch - items[right].epoch ? left : right;
};
/**
 * @param table - Table of items
 * @param epoch - Target epoch
 * @returns [index, index] - Index of nearest item to the given epoch (prefers future side of epoch)
 * @returns null - If item not found
 */ const $57c037ffdd302431$export$e8a4a9ae9f7a1fff = (table, epoch)=>{
    let size = table.length;
    if (size === 0) return null;
    let column = null;
    let row = null;
    for(let i = 0; i < size; i++){
        column = $57c037ffdd302431$export$3c1958d6a7298a16(table[i], epoch);
        if (column !== null) {
            row = i;
            break;
        }
    }
    if (row === null || column === null) return null;
    return [
        row,
        column
    ];
};
/**
 * @param table - Table of items
 * @returns move - Function to move focus
 */ const $57c037ffdd302431$export$d947e5f4f4c48d48 = (table)=>/**
	 * @param current - Current index
	 * @param direction - Direction to move
	 * @returns [index, index] - Index of nearest item to the given epoch
	 */ (current, direction)=>{
        if (table.every(function(row) {
            return !row.length;
        }) || !current) return null;
        const size = table.length;
        const [row, column] = current;
        switch(direction){
            case 'up':
                {
                    if (row === 0) return [
                        row,
                        column
                    ];
                    let r = row - 1;
                    let c = $57c037ffdd302431$export$3c1958d6a7298a16(table[r], table[row][column].epoch);
                    while(c === null && r > 0){
                        r--;
                        c = $57c037ffdd302431$export$3c1958d6a7298a16(table[r], table[row][column].epoch);
                    }
                    if (c === null) return [
                        row,
                        column
                    ];
                    return [
                        r,
                        c
                    ];
                }
            case 'down':
                {
                    if (row === size - 1) return [
                        row,
                        column
                    ];
                    let r = row + 1;
                    let c = $57c037ffdd302431$export$3c1958d6a7298a16(table[r], table[row][column].epoch);
                    while(c === null && r < size - 1){
                        r++;
                        c = $57c037ffdd302431$export$3c1958d6a7298a16(table[r], table[row][column].epoch);
                    }
                    if (c === null) return [
                        row,
                        column
                    ];
                    return [
                        r,
                        c
                    ];
                }
            case 'left':
                return column === 0 ? [
                    row,
                    column
                ] : [
                    row,
                    column - 1
                ];
            case 'right':
                return column === table[row].length - 1 ? [
                    row,
                    column
                ] : [
                    row,
                    column + 1
                ];
            default:
                return [
                    row,
                    column
                ];
        }
    };
/**
 * @param table - Table of items
 * @param item - Target item
 * @returns [index, index] - Index of item in the table
 * @returns null - If item not found
 */ const $57c037ffdd302431$export$905343f4c882cd13 = (table, id)=>{
    const size = table.length;
    for(let i = 0; i < size; i++){
        const index = table[i].findIndex((x)=>x.id === id);
        if (index !== -1) return [
            i,
            index
        ];
    }
    return null;
};
/**
 * @param table - Table of items
 * @param item - Target item
 * @returns Item - Item from the table
 * @returns null - If item not found
 */ const $57c037ffdd302431$export$f92dfeb71e9bb569 = (table, indexes)=>{
    if (indexes === null) return null;
    const [row, column] = indexes;
    return table?.[row]?.[column] ?? null;
};
const $57c037ffdd302431$export$37fa7720f4af9c1c = (clusterPeriods)=>[
        clusterPeriods.flatMap((clusterPeriod)=>clusterPeriod.overlaps.map((overlap)=>({
                    id: overlap.id,
                    epoch: overlap.startEpoch + (overlap.endEpoch - overlap.startEpoch) / 2
                })))
    ];
const $57c037ffdd302431$export$d7b6dfbcf1445709 = (rotations)=>rotations.map((rotation)=>rotation.periods.map((period)=>({
                id: period.id,
                epoch: period.startEpoch + (period.endEpoch - period.startEpoch) / 2
            })));
/*
  Week = {
    rotations: {
      id: string,
      periods: {
      id,
      startEpoch,
      endEpoch
      }[]
    }[]
  }[]

  to 
  
  Item = {
    id: string,
    epoch: number
  }[][]
 */ const $57c037ffdd302431$export$c79d9e1d369bcfdc = (weeks)=>{
    const table = {};
    weeks.forEach((week)=>{
        week.rotations.forEach((rotation)=>{
            if (!table[rotation.id]) table[rotation.id] = [];
            table[rotation.id].push(...rotation.periods.map((period)=>({
                    id: period.id,
                    epoch: period.startEpoch + (period.endEpoch - period.startEpoch) / 2
                })));
        });
    });
    return Object.values(table);
};

});

parcelRegister("3FhTI", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $458a08b230051831$export$c9058316764c140e);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ const $458a08b230051831$export$c9058316764c140e = (...refs)=>{
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
};

});

parcelRegister("dAkvd", function(module, exports) {

$parcel$export(module.exports, "Rotation", () => $48d026c8dfc60c78$export$9bdec6016cc824e2);

var $5uXOq = parcelRequire("5uXOq");

var $hYELq = parcelRequire("hYELq");
const $48d026c8dfc60c78$export$9bdec6016cc824e2 = ({ size: size, highlighted: highlighted, isFirstLastSame: isFirstLastSame, name: name, variant: variant, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Container), {
        role: "none",
        highlighted: highlighted,
        size: size,
        isFirstLastSame: isFirstLastSame
    }, variant === 'full' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Side), {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Name), {
        slim: size !== 'large'
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYELq.Inner), {
        role: "none"
    }, children));
};

});

parcelRegister("jH8Xl", function(module, exports) {

$parcel$export(module.exports, "SimpleShiftTile", () => $4b625f6404f82945$export$73be2fc2821a16d4);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dD7Zc = parcelRequire("dD7Zc");

var $3HVJq = parcelRequire("3HVJq");

var $8k22Y = parcelRequire("8k22Y");
var $fXc9u = parcelRequire("fXc9u");

var $cP0uo = parcelRequire("cP0uo");

var $3LLOP = parcelRequire("3LLOP");

var $9YkY7 = parcelRequire("9YkY7");

var $lWyWq = parcelRequire("lWyWq");

var $60FVM = parcelRequire("60FVM");

var $eHWQU = parcelRequire("eHWQU");
const $4b625f6404f82945$export$73be2fc2821a16d4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ size: size, period: period, outerTimeFrame: outerTimeFrame, hasOverrideBorder: hasOverrideBorder, onClick: onClick, onMouseEnter: onMouseEnter, isTabbable: isTabbable = false, isSelected: isSelected = false, ...rest }, ref)=>{
    const { responder: responder } = period;
    const intlApi = (0, $koVbs.default)();
    const internalRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useImperativeHandle)(ref, ()=>internalRef.current);
    const users = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)([
        responder
    ]));
    const user = users[0];
    const { getColor: getColor } = (0, $3HVJq.useStore)();
    const { itemWidth: itemWidth, itemLeft: itemLeft, nowLocation: nowLocation, nowFillRatio: nowFillRatio } = (0, $3LLOP.computePosition)(period, outerTimeFrame);
    const layout = (0, $eHWQU.findLayout)(itemWidth, size);
    // TODO: handle error and loading. See: TARDIS-7446
    const { name: name, type: type, deleted: deleted } = (0, $cP0uo.getResponder)(responder, user, intlApi);
    const isNoOne = type === 'noone';
    const isDeleted = deleted;
    const userHasAvatar = user && 'avatarUrl' in user;
    const { color: color, backgroundColor: backgroundColor } = isNoOne ? (0, $lWyWq.noOneColor) : isDeleted ? (0, $lWyWq.deletedColor) : getColor(responder.id);
    // TODO: Update label content. See: TARDIS-8571
    const label = name + ' ' + (0, $3LLOP.formatAccessibleRange)(intlApi, period);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Outer), {
        size: size,
        left: itemLeft,
        width: itemWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Inner), {
        ...rest,
        color: color,
        hasBorder: isSelected,
        hasDashedBorder: isNoOne,
        isTrueStartTime: period.isTrueStartTime,
        isTrueEndTime: period.isTrueEndTime,
        size: size,
        layout: layout,
        "data-testid": "period-item",
        "data-shift-id": period.id,
        ref: internalRef,
        tabIndex: isTabbable ? 0 : -1,
        role: "button",
        "aria-roledescription": "shift",
        "aria-haspopup": "dialog",
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onKeyPress: (event)=>{
            // NOTE: Might want to exclude 'Spacebar' as it is also mean to select for multi mode
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault();
                onClick?.(event);
            }
        }
    }, isDeleted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Gradient), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Background), {
        color: backgroundColor
    }), hasOverrideBorder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.OverrideBorder), {
        mini: isSelected
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.User), {
        "aria-hidden": true,
        layout: layout
    }, !(isNoOne || isDeleted) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Profile), {
        layout: layout,
        hasSvg: !userHasAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
        appearance: "circle",
        borderColor: "transparent",
        responder: user,
        size: "xsmall",
        testId: "avatar"
    })), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.MissingResponder), {
        layout: layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: intlApi.formatMessage((0, $9YkY7.messages).missingResponder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Name), {
        layout: layout
    }, (0, $eHWQU.formatName)(name, layout, isNoOne, isDeleted))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Time), {
        "aria-hidden": true,
        layout: layout
    }, (0, $eHWQU.formatTimeRange)(intlApi, period)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60FVM.Overlay), {
        isTrueStartTime: period.isTrueStartTime,
        isTrueEndTime: period.isTrueEndTime,
        nowFillRatio: nowFillRatio,
        nowLocation: nowLocation
    })));
});

});
parcelRegister("3LLOP", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $5bec64d9e1f25e01$export$48a53dcb22e581d0);
$parcel$export(module.exports, "computeBorderRadius", () => $5bec64d9e1f25e01$export$924072b433e2971c);
$parcel$export(module.exports, "formatAccessibleRange", () => $5bec64d9e1f25e01$export$ace13fd5735d0c6);
parcelRequire("ewaHK");
var $dyJ0D = parcelRequire("dyJ0D");

var $5Ppij = parcelRequire("5Ppij");

var $9YkY7 = parcelRequire("9YkY7");

var $jfjFL = parcelRequire("jfjFL");

var $4GUqJ = parcelRequire("4GUqJ");
const $5bec64d9e1f25e01$export$48a53dcb22e581d0 = (inner, outer)=>{
    // how much space inner item takes overall as ratio
    const itemRatio = (inner.endEpoch - inner.startEpoch) / (outer.endEpoch - outer.startEpoch);
    // how far is the inner item from the start of the outer item as ratio
    const itemPosition = (inner.startEpoch - outer.startEpoch) / (outer.endEpoch - outer.startEpoch);
    // how far is the inner item from the left as pixel
    const itemLeft = itemPosition * outer.width;
    // actual pixel of inner item
    const itemWidth = itemRatio * outer.width;
    // whether inner item is in past, present or future
    const nowLocation = (0, $jfjFL.getNowLocation)(inner.startEpoch, inner.endEpoch, outer.nowEpoch);
    // how much of the inner item is filled with overlay (how much of is past time) as ratio (normalized between 0 and 1)
    const nowFillRatio = Math.max(Math.min((outer.nowEpoch - inner.startEpoch) / (inner.endEpoch - inner.startEpoch), 1), 0);
    return {
        itemRatio: itemRatio,
        itemLeft: itemLeft,
        itemPosition: itemPosition,
        itemWidth: itemWidth,
        nowFillRatio: nowFillRatio,
        nowLocation: nowLocation
    };
};
const $5bec64d9e1f25e01$export$924072b433e2971c = ({ leftRounded: leftRounded, rightRounded: rightRounded, radius: radius })=>{
    if (leftRounded && rightRounded) return `
      border-radius: ${radius};
    `;
    else if (!leftRounded && !rightRounded) return `
      border-radius: 0;
    `;
    else if (leftRounded) return `
      border-top-left-radius: ${radius};
      border-bottom-left-radius: ${radius};
    `;
    else if (rightRounded) return `
      border-top-right-radius: ${radius};
      border-bottom-right-radius: ${radius};
    `;
    throw new Error('Invalid combination of roundedLeft and roundedRight');
};
// TODO: Establish common time range format - https://ifountain.atlassian.net/browse/TARDIS-8527
/**
 * @returns string - 'From 12:18 AM to Later than the current period' | ...
 */ const $5bec64d9e1f25e01$export$ace13fd5735d0c6 = (intlApi, time)=>{
    const start = (0, $5Ppij.default)(time.startEpoch + time.startOffset, 'UTC');
    const end = (0, $5Ppij.default)(time.endEpoch + time.endOffset, 'UTC');
    const startTime = time.isTrueStartTime ? (0, $dyJ0D.default)(start, 'h:mm a') : intlApi.formatMessage((0, $9YkY7.messages).noStartTime);
    const endTime = time.isTrueEndTime ? (0, $dyJ0D.default)(end, 'h:mm a') : intlApi.formatMessage((0, $9YkY7.messages).noEndTime);
    return intlApi.formatMessage((0, $4GUqJ.messages).timeRange, {
        start: startTime,
        end: endTime
    });
};

});
parcelRegister("ewaHK", function(module, exports) {

$parcel$export(module.exports, "format", () => (parcelRequire("dyJ0D")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $dyJ0D = parcelRequire("dyJ0D");






});

parcelRegister("4GUqJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $05509d6fd837ec91$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $05509d6fd837ec91$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    timeRange: {
        id: 'eoc-schedule-common.utils.shift.time-range',
        defaultMessage: 'From {start} to {end}',
        description: 'Time range label. Ex. From Oct 31 12:18 AM to Later than the current period, or any other range.'
    }
});

});


parcelRegister("lWyWq", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $a204e60d1b33c25d$export$c84671f46d6a1ca);
$parcel$export(module.exports, "noOneColor", () => $a204e60d1b33c25d$export$7148c6692e3ad7c);
$parcel$export(module.exports, "deletedColor", () => $a204e60d1b33c25d$export$492d85787d911d00);
$parcel$export(module.exports, "iconColor", () => $a204e60d1b33c25d$export$3797a580396e3639);
$parcel$export(module.exports, "borderColor", () => $a204e60d1b33c25d$export$e7fb0694ba2404fc);
$parcel$export(module.exports, "SHIFT_BORDER", () => $a204e60d1b33c25d$export$6f90a1b9c2ff3151);
$parcel$export(module.exports, "SHIFT_RADIUS", () => $a204e60d1b33c25d$export$72cb6dbe81cd173b);
$parcel$export(module.exports, "OVERRIDE_BORDER", () => $a204e60d1b33c25d$export$ed57d1b6fe848b11);
$parcel$export(module.exports, "PROFILE_SIZE", () => $a204e60d1b33c25d$export$b9ac7cac811ad864);
$parcel$export(module.exports, "TIME_FONT_SIZE", () => $a204e60d1b33c25d$export$df814c7db2f59f8d);
$parcel$export(module.exports, "TIME_LINE_HEIGHT", () => $a204e60d1b33c25d$export$91c706e62826dc1d);
$parcel$export(module.exports, "ICON_MARGIN", () => $a204e60d1b33c25d$export$86955db3a341ec67);
$parcel$export(module.exports, "CONTENT_PADDING", () => $a204e60d1b33c25d$export$6e84eb1dcf528852);
$parcel$export(module.exports, "OVERRIDE_IMAGE", () => $a204e60d1b33c25d$export$748425e952aa8ae2);
$parcel$export(module.exports, "DELETED_IMAGE", () => $a204e60d1b33c25d$export$84cf1f68e0601623);

var $a204e60d1b33c25d$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    /** @description Profile, Name, Time are visible. (>= 100px) */ Layout["FullView"] = "full-view";
    /** @description Profile, Name Initials are visible. (>= 52px) */ Layout["SparseView"] = "sparse-view";
    /** @description Profile, Name Initials (vertical) are visible. (>= 36px) */ Layout["CompactView"] = "compact-view";
    /** @description Profile, First Initial (vertical) are visible. (>= 16px) */ Layout["MiniView"] = "mini-view";
    /** @description None are visible. (< 16px) */ Layout["NoneView"] = "none-view";
    /** @description Profile, Name are visible. (>= 100px) */ Layout["FullSlimView"] = "full-slim-view";
    /** @description Profile, Name Initials are visible. (>= 52px) */ Layout["SparseSlimView"] = "sparse-slim-view";
    /** @description Name Initials are visible. (>= 36px) */ Layout["CompactSlimView"] = "compact-slim-view";
    /** @description First Initial are visible. (>= 16px) */ Layout["MiniSlimView"] = "mini-slim-view";
    /** @description None are visible. (< 16px) */ Layout["NoneSlimView"] = "none-slim-view";
    return Layout;
}({});
const $a204e60d1b33c25d$export$7148c6692e3ad7c = {
    backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    color: `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`
};
const $a204e60d1b33c25d$export$492d85787d911d00 = {
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
};
const $a204e60d1b33c25d$export$3797a580396e3639 = {
    backgroundColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
    color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
};
const $a204e60d1b33c25d$export$e7fb0694ba2404fc = {
    noone: `var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
    default: "var(--ds-chart-gray-boldest, #44546F)"
};
const $a204e60d1b33c25d$export$6f90a1b9c2ff3151 = 2;
const $a204e60d1b33c25d$export$72cb6dbe81cd173b = 6;
const $a204e60d1b33c25d$export$ed57d1b6fe848b11 = 4;
const $a204e60d1b33c25d$export$b9ac7cac811ad864 = 16;
const $a204e60d1b33c25d$export$df814c7db2f59f8d = 14 * 0.7;
const $a204e60d1b33c25d$export$91c706e62826dc1d = 14 * 1.4;
const $a204e60d1b33c25d$export$86955db3a341ec67 = 2;
const $a204e60d1b33c25d$var$TIMELINE_CONTENT_PADDING = 8;
const $a204e60d1b33c25d$var$CALENDAR_CONTENT_PADDING = 4;
const $a204e60d1b33c25d$export$6e84eb1dcf528852 = {
    small: $a204e60d1b33c25d$var$CALENDAR_CONTENT_PADDING,
    medium: $a204e60d1b33c25d$var$TIMELINE_CONTENT_PADDING,
    large: $a204e60d1b33c25d$var$TIMELINE_CONTENT_PADDING
};
const $a204e60d1b33c25d$export$748425e952aa8ae2 = {
    BACKGROUND: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    FOREGROUND: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
};
const $a204e60d1b33c25d$export$84cf1f68e0601623 = {
    BACKGROUND: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    FOREGROUND: `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`
};

});

parcelRegister("60FVM", function(module, exports) {

$parcel$export(module.exports, "Outer", () => $5982bce984148f4d$export$7c0b2773cfb50ce4);
$parcel$export(module.exports, "Inner", () => $5982bce984148f4d$export$f63ba74aa66682be);
$parcel$export(module.exports, "OverrideBorder", () => $5982bce984148f4d$export$160172f78036107d);
$parcel$export(module.exports, "Gradient", () => $5982bce984148f4d$export$3d3dd8f63ff0f876);
$parcel$export(module.exports, "Background", () => $5982bce984148f4d$export$668799e4797757a8);
$parcel$export(module.exports, "Overlay", () => $5982bce984148f4d$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "User", () => $5982bce984148f4d$export$1f44aaf2ec115b54);
$parcel$export(module.exports, "Profile", () => $5982bce984148f4d$export$5120f2d0b8d4cab8);
$parcel$export(module.exports, "MissingResponder", () => $5982bce984148f4d$export$7760e021411ad424);
$parcel$export(module.exports, "Name", () => $5982bce984148f4d$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Time", () => $5982bce984148f4d$export$680ea196effce5f);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $hhW0G = parcelRequire("hhW0G");

var $3LLOP = parcelRequire("3LLOP");

var $4lizm = parcelRequire("4lizm");

var $lWyWq = parcelRequire("lWyWq");

var $bWGt6 = parcelRequire("bWGt6");
const $5982bce984148f4d$export$7c0b2773cfb50ce4 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q6711"
})("position:absolute;z-index:1;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ width: width, left: left, size: size })=>`
    left: ${left}px;
    width: ${width}px;
	${''}
    height: ${(0, $4lizm.ROTATION_HEIGHT)[size]}px;

	${''}
    min-height: ${(0, $4lizm.ROTATION_HEIGHT)[size]}px;
${''}
    max-height: ${(0, $4lizm.ROTATION_HEIGHT)[size]}px;
  `);
const $5982bce984148f4d$export$f63ba74aa66682be = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q6710"
})("position:relative;box-sizing:border-box;:focus-visible{border:", (0, $lWyWq.SHIFT_BORDER), "px solid transparent;z-index:2;}overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;color:", ({ color: color })=>color, ";", ({ hasDashedBorder: hasDashedBorder })=>hasDashedBorder && `
      border: ${0, $lWyWq.SHIFT_BORDER}px dashed ${(0, $lWyWq.borderColor).noone};
    `, " ", ({ hasBorder: hasBorder })=>hasBorder && `
      box-shadow: ${`var(--ds-shadow-raised, ${`1px 2px 3px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`};
    `, ";", ({ hasBorder: hasBorder })=>hasBorder && `
      border: ${0, $lWyWq.SHIFT_BORDER}px solid ${(0, $lWyWq.borderColor).default};
    `, ";", ({ isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime })=>(0, $3LLOP.computeBorderRadius)({
        leftRounded: isTrueStartTime,
        rightRounded: isTrueEndTime,
        radius: `${(0, $lWyWq.SHIFT_RADIUS)}px`
    }), ";", ({ layout: layout, size: size, hasDashedBorder: hasDashedBorder, hasBorder: hasBorder })=>{
    const padding = (0, $lWyWq.CONTENT_PADDING)[size];
    const offset = hasBorder || hasDashedBorder ? (0, $lWyWq.SHIFT_BORDER) : 0;
    switch(layout){
        case (0, $lWyWq.Layout).FullView:
            return `
          padding: ${padding - offset}px;

          :focus-visible {
            padding: ${padding - (0, $lWyWq.SHIFT_BORDER)}px;
          }

          justify-content: space-between;
        `;
        case (0, $lWyWq.Layout).CompactView:
        case (0, $lWyWq.Layout).MiniView:
        case (0, $lWyWq.Layout).SparseView:
            return `
          padding: ${padding - offset}px;

          :focus-visible {
            padding: ${padding - (0, $lWyWq.SHIFT_BORDER)}px;
          }

          justify-content: flex-start;
        `;
        case (0, $lWyWq.Layout).NoneView:
            return `
          padding: 0;
        `;
        case (0, $lWyWq.Layout).FullSlimView:
        case (0, $lWyWq.Layout).SparseSlimView:
            return `
          padding: 0 ${padding - offset}px;

          :focus-visible {
            padding: ${padding - (0, $lWyWq.SHIFT_BORDER)}px;
          }

          justify-content: center;
        `;
        case (0, $lWyWq.Layout).CompactSlimView:
        case (0, $lWyWq.Layout).MiniSlimView:
        case (0, $lWyWq.Layout).NoneSlimView:
            return `
          padding: 0 ;

          justify-content: center;
        `;
    }
}, ";");
const $5982bce984148f4d$export$160172f78036107d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q679"
})("position:absolute;left:0;bottom:0;z-index:0;height:", ({ mini: mini })=>(0, $lWyWq.OVERRIDE_BORDER) - (mini ? (0, $lWyWq.SHIFT_BORDER) / 2 : 0), "px;width:100%;background-image:repeating-linear-gradient(\n\t\t-45deg,\n\t\t", (0, $lWyWq.OVERRIDE_IMAGE).BACKGROUND, ",\n\t\t", (0, $lWyWq.OVERRIDE_IMAGE).BACKGROUND, " var(--ds-space-100, 8px),\n\t\t", (0, $lWyWq.OVERRIDE_IMAGE).FOREGROUND, " var(--ds-space-100, 8px),\n\t\t", (0, $lWyWq.OVERRIDE_IMAGE).FOREGROUND, " var(--ds-space-200, 16px)\n\t);");
const $5982bce984148f4d$export$3d3dd8f63ff0f876 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q678"
})({
    position: 'absolute',
    left: 0,
    bottom: 0,
    zIndex: 0,
    height: '100%',
    width: '100%',
    backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    backgroundImage: `repeating-linear-gradient( -45deg, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $lWyWq.DELETED_IMAGE).BACKGROUND}, ${(0, $lWyWq.DELETED_IMAGE).BACKGROUND} ${"var(--ds-space-050, 4px)"}, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $lWyWq.DELETED_IMAGE).FOREGROUND} ${"var(--ds-space-050, 4px)"}, ${(0, $lWyWq.DELETED_IMAGE).FOREGROUND} ${"var(--ds-space-075, 6px)"} )`
});
const $5982bce984148f4d$export$668799e4797757a8 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q677"
})((props)=>({
        position: 'absolute',
        left: 0,
        bottom: 0,
        zIndex: 0,
        height: '100%',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.color
    }));
const $5982bce984148f4d$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q676"
})("background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`, ";content:'';height:100%;left:0;opacity:0.5;position:absolute;top:0;z-index:2;", ({ nowLocation: nowLocation, nowFillRatio: nowFillRatio })=>{
    switch(nowLocation){
        case (0, $hhW0G.NowLocation).InRange:
            return `width: ${nowFillRatio * 100}%;`;
        case (0, $hhW0G.NowLocation).After:
            return 'width: 100%;';
        case (0, $hhW0G.NowLocation).Before:
            return 'display: none;';
    }
}, ";");
const $5982bce984148f4d$export$1f44aaf2ec115b54 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q675"
})("align-items:center;display:flex;justify-content:center;width:100%;z-index:2;", ({ layout: layout })=>{
    switch(layout){
        case (0, $lWyWq.Layout).CompactView:
        case (0, $lWyWq.Layout).MiniView:
            return `
          flex-direction: column;
          height: 100%;
          justify-content: space-between;
        `;
        case (0, $lWyWq.Layout).NoneView:
        case (0, $lWyWq.Layout).NoneSlimView:
            return `
          display: none;
        `;
        default:
            return `
          flex-direction: row;
        `;
    }
}, ";");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5982bce984148f4d$var$IconCommon = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ez04q674"
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $lWyWq.PROFILE_SIZE)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $lWyWq.PROFILE_SIZE)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $lWyWq.PROFILE_SIZE)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $lWyWq.PROFILE_SIZE)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lWyWq.PROFILE_SIZE)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${(0, $lWyWq.PROFILE_SIZE)}px`
});
const $5982bce984148f4d$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $bWGt6.default)($5982bce984148f4d$var$IconCommon, {
    target: "ez04q673"
})(({ hasSvg: hasSvg })=>hasSvg && `
    border-radius: 50%;
    overflow: hidden;

    background-color: ${(0, $lWyWq.iconColor).backgroundColor};
    color: ${(0, $lWyWq.iconColor).color};

    & svg {
      background-color: ${(0, $lWyWq.iconColor).backgroundColor};
      color: ${(0, $lWyWq.iconColor).color};
    }
    `, " ", ({ layout: layout })=>{
    switch(layout){
        case (0, $lWyWq.Layout).CompactSlimView:
        case (0, $lWyWq.Layout).MiniSlimView:
        case (0, $lWyWq.Layout).NoneSlimView:
        case (0, $lWyWq.Layout).NoneView:
            return `
          display: none;
        `;
        case (0, $lWyWq.Layout).FullView:
        case (0, $lWyWq.Layout).FullSlimView:
        case (0, $lWyWq.Layout).SparseView:
        case (0, $lWyWq.Layout).SparseSlimView:
            return `
          margin-right: ${0, $lWyWq.ICON_MARGIN}px;
        `;
    }
}, ";");
const $5982bce984148f4d$export$7760e021411ad424 = /*#__PURE__*/ (0, $bWGt6.default)($5982bce984148f4d$var$IconCommon, {
    target: "ez04q672"
})("color:", `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`, ";", ({ layout: layout })=>{
    switch(layout){
        case (0, $lWyWq.Layout).NoneSlimView:
        case (0, $lWyWq.Layout).NoneView:
            return `
          display: none;
        `;
        case (0, $lWyWq.Layout).FullView:
        case (0, $lWyWq.Layout).FullSlimView:
        case (0, $lWyWq.Layout).SparseView:
        case (0, $lWyWq.Layout).SparseSlimView:
            return `
          margin-right: ${0, $lWyWq.ICON_MARGIN}px;
        `;
    }
}, ";");
const $5982bce984148f4d$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ez04q671"
})("color:inherit;margin:0;overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap;line-height:", (0, $lWyWq.PROFILE_SIZE), "px;", ({ layout: layout })=>{
    switch(layout){
        case (0, $lWyWq.Layout).CompactView:
        case (0, $lWyWq.Layout).MiniView:
            return `
          line-height: ${0, $lWyWq.TIME_LINE_HEIGHT}px;
        `;
    }
}, ";");
const $5982bce984148f4d$export$680ea196effce5f = /*#__PURE__*/ (0, $bWGt6.default)("time", {
    target: "ez04q670"
})("color:inherit;display:none;font-size:", (0, $lWyWq.TIME_FONT_SIZE), "px;line-height:", (0, $lWyWq.TIME_LINE_HEIGHT), "px;overflow:hidden;white-space:nowrap;z-index:2;", ({ layout: layout })=>{
    switch(layout){
        case (0, $lWyWq.Layout).FullView:
            return `
          display: block;
        `;
    }
}, ";");

});

parcelRegister("eHWQU", function(module, exports) {

$parcel$export(module.exports, "findLayout", () => $c488e880689f4d33$export$ed07cca9d2955131);
$parcel$export(module.exports, "formatName", () => $c488e880689f4d33$export$61b6a526e2f145be);
$parcel$export(module.exports, "formatTimeRange", () => $c488e880689f4d33$export$b40fc491ceb69c4e);

var $lWyWq = parcelRequire("lWyWq");

var $6kGp9 = parcelRequire("6kGp9");
const $c488e880689f4d33$export$ed07cca9d2955131 = (width, size)=>{
    const slim = size === 'small' || size === 'medium';
    if (width < 16) return slim ? (0, $lWyWq.Layout).NoneSlimView : (0, $lWyWq.Layout).NoneView;
    else if (width < 36) return slim ? (0, $lWyWq.Layout).MiniSlimView : (0, $lWyWq.Layout).MiniView;
    else if (width < 52) return slim ? (0, $lWyWq.Layout).CompactSlimView : (0, $lWyWq.Layout).CompactView;
    else if (width < 100) return slim ? (0, $lWyWq.Layout).SparseSlimView : (0, $lWyWq.Layout).SparseView;
    else return slim ? (0, $lWyWq.Layout).FullSlimView : (0, $lWyWq.Layout).FullView;
};
const $c488e880689f4d33$export$61b6a526e2f145be = (name = '', layout, isNoOne, isDeleted)=>{
    if (isNoOne) switch(layout){
        case (0, $lWyWq.Layout).CompactView:
        case (0, $lWyWq.Layout).CompactSlimView:
        case (0, $lWyWq.Layout).SparseView:
        case (0, $lWyWq.Layout).SparseSlimView:
        case (0, $lWyWq.Layout).MiniView:
        case (0, $lWyWq.Layout).MiniSlimView:
            return '-';
        case (0, $lWyWq.Layout).NoneView:
        case (0, $lWyWq.Layout).NoneSlimView:
            return '';
        case (0, $lWyWq.Layout).FullView:
        case (0, $lWyWq.Layout).FullSlimView:
        default:
            return name;
    }
    if (isDeleted) switch(layout){
        case (0, $lWyWq.Layout).CompactView:
        case (0, $lWyWq.Layout).CompactSlimView:
        case (0, $lWyWq.Layout).SparseView:
        case (0, $lWyWq.Layout).SparseSlimView:
            return name.split(' ').map((n)=>n[0]).join('');
        case (0, $lWyWq.Layout).MiniView:
        case (0, $lWyWq.Layout).MiniSlimView:
        case (0, $lWyWq.Layout).NoneView:
        case (0, $lWyWq.Layout).NoneSlimView:
            return '';
        case (0, $lWyWq.Layout).FullView:
        case (0, $lWyWq.Layout).FullSlimView:
        default:
            return name;
    }
    switch(layout){
        case (0, $lWyWq.Layout).CompactView:
        case (0, $lWyWq.Layout).CompactSlimView:
        case (0, $lWyWq.Layout).SparseView:
        case (0, $lWyWq.Layout).SparseSlimView:
            return name.split(' ').map((n)=>n[0]).join('');
        case (0, $lWyWq.Layout).MiniView:
        case (0, $lWyWq.Layout).MiniSlimView:
            return name[0];
        case (0, $lWyWq.Layout).NoneView:
        case (0, $lWyWq.Layout).NoneSlimView:
            return '';
        case (0, $lWyWq.Layout).FullView:
        case (0, $lWyWq.Layout).FullSlimView:
        default:
            return name;
    }
};
const $c488e880689f4d33$export$b40fc491ceb69c4e = (intlApi, time)=>{
    const startDate = new Date(time.startEpoch + time.startOffset);
    const endDate = new Date(time.endEpoch + time.endOffset);
    return intlApi.formatMessage((0, $6kGp9.messages).timeRange, {
        startHourMinute: time.isTrueStartTime ? intlApi.formatDate(startDate, {
            hour: 'numeric',
            minute: startDate.getMinutes() === 0 ? undefined : 'numeric',
            timeZone: 'UTC'
        }) : intlApi.formatMessage((0, $6kGp9.messages).startTimeUnknown),
        endHourMinute: time.isTrueEndTime ? intlApi.formatDate(endDate, {
            hour: 'numeric',
            minute: endDate.getMinutes() === 0 ? undefined : 'numeric',
            timeZone: 'UTC'
        }) : intlApi.formatMessage((0, $6kGp9.messages).endTimeUnknown)
    });
};

});
parcelRegister("6kGp9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $76ed5038edd23f7e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $76ed5038edd23f7e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    timeRange: {
        id: 'eoc-schedule.common.ui.period-item.time-range',
        defaultMessage: '{startHourMinute} - {endHourMinute}',
        description: 'Period item date range, amount of reserved time. (e.g. "6 AM - 5 PM", "5 PM - 5:45 AM", "< Prev - 8 PM" , "< Prev - Next >)'
    },
    endTimeUnknown: {
        id: 'eoc-schedule.common.ui.period-item.end-time-unknown',
        defaultMessage: 'Next >',
        description: 'Placeholder for future unknown time'
    },
    startTimeUnknown: {
        id: 'eoc-schedule.common.ui.period-item.start-time-unknown',
        defaultMessage: '< Prev',
        description: 'Placeholder for past unknown time'
    }
});

});



parcelRegister("cR6iS", function(module, exports) {

$parcel$export(module.exports, "SingleViewShiftCard", () => $701a964829ec4501$export$55b0d97ce55aaf79);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $luBm6 = parcelRequire("luBm6");

var $5s9eT = parcelRequire("5s9eT");

var $9YkY7 = parcelRequire("9YkY7");

var $legSc = parcelRequire("legSc");

var $80MT9 = parcelRequire("80MT9");

var $k4umG = parcelRequire("k4umG");

var $ez1ft = parcelRequire("ez1ft");

var $lMhXb = parcelRequire("lMhXb");

var $3yAjd = parcelRequire("3yAjd");

var $5jHhH = parcelRequire("5jHhH");
const $701a964829ec4501$export$55b0d97ce55aaf79 = ({ cards: cards, onClose: onClose })=>{
    const intlApi = (0, $koVbs.default)();
    const singleCard = cards[0];
    const { rotation: rotation, ...period } = singleCard;
    const { responder: responder } = period;
    const isDeleted = responder.deleted;
    const isForwarded = period.from && period.type === (0, $5s9eT.PeriodType).Forwarding;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $legSc.Card), {
        role: "dialog",
        "aria-labelledby": "shift-card-title",
        controls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CloseButton), {
            onClick: onClose
        }),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yAjd.Contact), {
            id: "shift-card-title",
            responder: responder
        }), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jHhH.DeletedWarning), null), isForwarded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jHhH.ForwardedInfo), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "start",
            epoch: period.startEpoch + period.startOffset,
            isTrueTime: period.isTrueStartTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "end",
            epoch: period.endEpoch + period.endOffset,
            isTrueTime: period.isTrueEndTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
            variant: "inline",
            label: intlApi.formatMessage((0, $9YkY7.messages).rotation)
        }, rotation.name), isForwarded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMhXb.ReadonlyUser), {
            variant: "previousOnCall",
            responder: period.from
        })))
    });
};

});
parcelRegister("legSc", function(module, exports) {

$parcel$export(module.exports, "Card", () => $24aa6423ced90561$export$60332b2344f7fe41);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $24aa6423ced90561$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    width: '360px',
    padding: 'space.300'
});
const $24aa6423ced90561$var$controlsStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.200',
    right: 'space.200'
});
const $24aa6423ced90561$export$60332b2344f7fe41 = ({ content: content, controls: controls, ...a11yProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $24aa6423ced90561$var$containerStyles,
        ...a11yProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $24aa6423ced90561$var$controlsStyles,
        alignItems: "center",
        justifyContent: "end",
        columnGap: "space.050"
    }, controls), content);
};

});

parcelRegister("80MT9", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $234624bb311a6f39$export$de65de8213222d10);
$parcel$export(module.exports, "CancelButton", () => $234624bb311a6f39$export$488fee190faedb43);
$parcel$export(module.exports, "OverrideButton", () => $234624bb311a6f39$export$fb6405413c54f37f);
$parcel$export(module.exports, "EditOverrideButton", () => $234624bb311a6f39$export$23bf2ecbac938594);
$parcel$export(module.exports, "RevertOverrideButton", () => $234624bb311a6f39$export$4138014e9fed7d77);
$parcel$export(module.exports, "EditDetailsButton", () => $234624bb311a6f39$export$baf689bd6e5e63e9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $hUqzg = parcelRequire("hUqzg");

var $1ywCO = parcelRequire("1ywCO");

var $7paD5 = parcelRequire("7paD5");

var $3bDjY = parcelRequire("3bDjY");

var $9YkY7 = parcelRequire("9YkY7");

var $5gz4l = parcelRequire("5gz4l");
const $234624bb311a6f39$export$de65de8213222d10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intlApi.formatMessage((0, $9YkY7.messages).close),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        label: intlApi.formatMessage((0, $9YkY7.messages).close),
        ref: ref,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj)))
    }));
});
const $234624bb311a6f39$export$488fee190faedb43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref,
        appearance: "subtle"
    }, intlApi.formatMessage((0, $9YkY7.messages).cancel));
});
const $234624bb311a6f39$export$fb6405413c54f37f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }, intlApi.formatMessage((0, $5gz4l.messages).override));
});
const $234624bb311a6f39$export$d066cb8fc870c764 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }, intlApi.formatMessage((0, $5gz4l.messages).addOverride));
});
const $234624bb311a6f39$export$23bf2ecbac938594 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intlApi.formatMessage((0, $5gz4l.messages).editOverride),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref,
        appearance: "subtle",
        label: intlApi.formatMessage((0, $5gz4l.messages).editOverride),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ywCO)))
    }));
});
const $234624bb311a6f39$export$4138014e9fed7d77 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intlApi.formatMessage((0, $5gz4l.messages).removeOverride),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref,
        appearance: "subtle",
        label: intlApi.formatMessage((0, $5gz4l.messages).removeOverride),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hUqzg)))
    }));
});
const $234624bb311a6f39$export$baf689bd6e5e63e9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        ref: ref,
        appearance: "link",
        spacing: "none",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            color: "currentColor",
            label: ""
        })
    }, intlApi.formatMessage((0, $5gz4l.messages).editDetails));
});

});
parcelRegister("1ywCO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f1499f88a5a9b0ec5069c962ed12d1a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $122246161208ff48$var$_react = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $122246161208ff48$var$_edit = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $122246161208ff48$var$_editFilled = $122246161208ff48$var$_interopRequireDefault((parcelRequire("avBcG")));
function $122246161208ff48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $122246161208ff48$var$EditIcon = (props)=>/*#__PURE__*/ $122246161208ff48$var$_react.default.createElement($122246161208ff48$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $122246161208ff48$var$_editFilled.default
    }, props));
$122246161208ff48$var$EditIcon.Name = 'EditIconMigration';
var $122246161208ff48$var$_default = module.exports.default = $122246161208ff48$var$EditIcon;

});
parcelRegister("avBcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a69a877f42e31b8$var$_react = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7a69a877f42e31b8$var$_edit = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $7a69a877f42e31b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a69a877f42e31b8$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7a69a877f42e31b8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $7a69a877f42e31b8$var$_edit.default
    }));
$7a69a877f42e31b8$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $7a69a877f42e31b8$var$_default = module.exports.default = $7a69a877f42e31b8$var$EditFilledIcon;

});


parcelRegister("5gz4l", function(module, exports) {

$parcel$export(module.exports, "messages", () => $765ce9e9b7c67090$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $765ce9e9b7c67090$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    override: {
        id: 'eoc-schedule-common.common.ui.card.button.confirm-override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    addOverride: {
        id: 'eoc-schedule-common.common.ui.card.button.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    editOverride: {
        id: 'eoc-schedule-common.common.ui.card.button.edit-override',
        defaultMessage: 'Edit override',
        description: 'Label for editing override.'
    },
    editDetails: {
        id: 'eoc-schedule-common.common.ui.card.button.edit-details',
        defaultMessage: 'Edit details',
        description: 'Text of button for customizing override at quick override step.'
    },
    removeOverride: {
        id: 'eoc-schedule-common.common.ui.card.button.remove-override',
        defaultMessage: 'Remove override',
        description: 'Label for deleting override.'
    }
});

});


parcelRegister("k4umG", function(module, exports) {

$parcel$export(module.exports, "Row", () => $f2cad8ba0aaf183c$export$b59bdbef9ce70de2);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3CdCU = parcelRequire("3CdCU");
const $f2cad8ba0aaf183c$var$inlineStyles = (0, $8CUq3.xcss)({
    flexDirection: 'row',
    columnGap: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $3CdCU.FIELD_HEIGHT)}px`,
    alignItems: 'center'
});
const $f2cad8ba0aaf183c$var$blockStyles = (0, $8CUq3.xcss)({
    flexDirection: 'column',
    rowGap: 'space.100',
    justifyContent: 'center'
});
const $f2cad8ba0aaf183c$var$fieldStyles = {
    inline: $f2cad8ba0aaf183c$var$inlineStyles,
    block: $f2cad8ba0aaf183c$var$blockStyles
};
const $f2cad8ba0aaf183c$var$labelStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $3CdCU.LABEL_WIDTH)}px`
});
const $f2cad8ba0aaf183c$var$valueStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $3CdCU.VALUE_WIDTH)}px`
});
const $f2cad8ba0aaf183c$export$b59bdbef9ce70de2 = ({ children: children, label: label, variant: variant, htmlFor: htmlFor })=>{
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $f2cad8ba0aaf183c$var$fieldStyles[variant]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "label",
        htmlFor: htmlFor,
        xcss: $f2cad8ba0aaf183c$var$labelStyles
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: typeof children === 'string' ? 'span' : 'div',
        xcss: $f2cad8ba0aaf183c$var$valueStyles
    }, children))) : null;
};

});
parcelRegister("3CdCU", function(module, exports) {

$parcel$export(module.exports, "FIELD_HEIGHT", () => $d4c601c3fbafb41d$export$5d4b9731aba74569);
$parcel$export(module.exports, "LABEL_WIDTH", () => $d4c601c3fbafb41d$export$fc6b1e9923bb7632);
$parcel$export(module.exports, "VALUE_WIDTH", () => $d4c601c3fbafb41d$export$49070b443b7f066a);
const $d4c601c3fbafb41d$export$5d4b9731aba74569 = 32;
const $d4c601c3fbafb41d$export$fc6b1e9923bb7632 = 120;
const $d4c601c3fbafb41d$export$49070b443b7f066a = 184;

});


parcelRegister("ez1ft", function(module, exports) {

$parcel$export(module.exports, "DateTime", () => $12caa601fed3ecfb$export$82f9ebd9adeba146);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3CdCU = parcelRequire("3CdCU");

var $k4umG = parcelRequire("k4umG");

var $fssSL = parcelRequire("fssSL");

var $3hQcR = parcelRequire("3hQcR");
const $12caa601fed3ecfb$var$dateStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $fssSL.DATE_WIDTH)}px`
});
const $12caa601fed3ecfb$var$timeStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $fssSL.TIME_WIDTH)}px`
});
const $12caa601fed3ecfb$var$infoStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    fontWeight: 'font.weight.regular',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $3CdCU.VALUE_WIDTH)}px`
});
const $12caa601fed3ecfb$export$82f9ebd9adeba146 = ({ epoch: epoch, isTrueTime: isTrueTime, variant: variant })=>{
    const intlApi = (0, $koVbs.default)();
    const date = intlApi.formatDate(epoch, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
    });
    const time = intlApi.formatTime(epoch, {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'UTC'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
        variant: "inline",
        label: (0, $3hQcR.labelText)(intlApi)[variant]
    }, isTrueTime ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.050",
        alignItems: "center",
        xcss: $12caa601fed3ecfb$var$infoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $12caa601fed3ecfb$var$dateStyles
    }, date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $12caa601fed3ecfb$var$timeStyles
    }, time)) : (0, $3hQcR.infoText)(intlApi)[variant]);
};

});
parcelRegister("fssSL", function(module, exports) {

$parcel$export(module.exports, "DATE_WIDTH", () => $66e367bde76362b1$export$e09826daa65c7246);
$parcel$export(module.exports, "TIME_WIDTH", () => $66e367bde76362b1$export$db149f3d58a414fb);
const $66e367bde76362b1$export$e09826daa65c7246 = 120;
const $66e367bde76362b1$export$db149f3d58a414fb = 108;

});

parcelRegister("3hQcR", function(module, exports) {

$parcel$export(module.exports, "labelText", () => $2a441597040eb97f$export$51c3c710ff66e3c3);
$parcel$export(module.exports, "infoText", () => $2a441597040eb97f$export$fda920bf43776f02);

var $9YkY7 = parcelRequire("9YkY7");
const $2a441597040eb97f$export$51c3c710ff66e3c3 = (intlApi)=>({
        start: intlApi.formatMessage((0, $9YkY7.messages).from),
        end: intlApi.formatMessage((0, $9YkY7.messages).to)
    });
const $2a441597040eb97f$export$fda920bf43776f02 = (intlApi)=>({
        start: intlApi.formatMessage((0, $9YkY7.messages).noStartTime),
        end: intlApi.formatMessage((0, $9YkY7.messages).noEndTime)
    });

});


parcelRegister("lMhXb", function(module, exports) {

$parcel$export(module.exports, "ReadonlyUser", () => $eec626d33f8d2bb3$export$ae769617d97a5c68);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $8k22Y = parcelRequire("8k22Y");
var $fXc9u = parcelRequire("fXc9u");

var $cP0uo = parcelRequire("cP0uo");

var $k4umG = parcelRequire("k4umG");

var $BLh0k = parcelRequire("BLh0k");
const $eec626d33f8d2bb3$export$ae769617d97a5c68 = ({ responder: responder, variant: variant })=>{
    const intlApi = (0, $koVbs.default)();
    const [user] = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)([
        responder
    ]));
    const { name: name } = (0, $cP0uo.getResponder)(responder, user, intlApi);
    const isNoOne = responder.type === 'noone';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
        variant: "inline",
        label: (0, $BLh0k.labelText)(intlApi)[variant]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100"
    }, !isNoOne && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
        responder: user,
        size: "small",
        appearance: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span"
    }, name)));
};

});
parcelRegister("BLh0k", function(module, exports) {

$parcel$export(module.exports, "labelText", () => $26a17082257b4076$export$51c3c710ff66e3c3);

var $gbyrN = parcelRequire("gbyrN");
const $26a17082257b4076$export$51c3c710ff66e3c3 = (intlApi)=>({
        previousOnCall: intlApi.formatMessage((0, $gbyrN.messages).previousOnCall),
        shiftParticipant: intlApi.formatMessage((0, $gbyrN.messages).shiftParticipant)
    });

});
parcelRegister("gbyrN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4a908d3727dd7660$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4a908d3727dd7660$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    previousOnCall: {
        id: 'eoc-schedule-common.common.ui.card.row.readonly-user.previous-on-call',
        defaultMessage: 'Previous on-call',
        description: 'Label for previous on-call.'
    },
    shiftParticipant: {
        id: 'eoc-schedule-common.common.ui.card.row.readonly-user.shift-participant',
        defaultMessage: 'Shift participant',
        description: 'Label for shift participant.'
    }
});

});



parcelRegister("3yAjd", function(module, exports) {

$parcel$export(module.exports, "Contact", () => $9754720b8c6dd083$export$836a6ea60fb78f25);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $aVnO1 = parcelRequire("aVnO1");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $8k22Y = parcelRequire("8k22Y");
var $fXc9u = parcelRequire("fXc9u");

var $8icyj = parcelRequire("8icyj");

var $cP0uo = parcelRequire("cP0uo");

var $lMFqp = parcelRequire("lMFqp");

var $avfXb = parcelRequire("avfXb");
const $9754720b8c6dd083$var$nameWrapperStyles = (0, $8CUq3.xcss)({
    margin: '0',
    width: '192px'
});
const $9754720b8c6dd083$var$fieldStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $9754720b8c6dd083$export$836a6ea60fb78f25 = ({ responder: responder, id: id })=>{
    const intlApi = (0, $koVbs.default)();
    const users = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)([
        responder
    ]));
    const user = users[0];
    // TODO: handle error. See: TARDIS-7446
    const { name: name, email: email, deleted: deleted, type: type } = (0, $cP0uo.getResponder)(responder, user, intlApi);
    const isNoOne = type === 'noone';
    const isDeleted = deleted;
    const isDeactivated = type === 'user' && deleted && name;
    const userHasAvatar = user && 'avatarUrl' in user;
    const showEmail = !isDeleted && email;
    const AvatarWrapper = userHasAvatar ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment : (0, $avfXb.SvgCorrection);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: showEmail ? 'space.100' : 'space.150'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, !isNoOne && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
        appearance: responder.type === 'user' ? 'circle' : 'square',
        size: "medium",
        responder: user,
        borderColor: "transparent"
    })), user?.isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "100px",
        height: "14px",
        variant: "square"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9754720b8c6dd083$var$nameWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        id: id,
        as: "h2",
        size: "xsmall"
    }, name))), showEmail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
        color: "currentColor",
        label: intlApi.formatMessage((0, $lMFqp.messages).email),
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9754720b8c6dd083$var$fieldStyles,
        as: "span"
    }, email)), isDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, intlApi.formatMessage((0, $lMFqp.messages).accountDeactivated))));
};

});
parcelRegister("lMFqp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $136c13a441cd71c7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $136c13a441cd71c7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    email: {
        id: 'eoc-schedule-common.common.ui.participant-card.contact.email',
        defaultMessage: 'Email',
        description: 'Email Icon Label.'
    },
    accountDeactivated: {
        id: 'eoc-schedule-common.common.ui.participant-card.contact.account-deactivated',
        defaultMessage: 'Account Deactivated',
        description: 'Information text that indicates responder is deactivated.'
    },
    noOneIsOnCall: {
        id: 'eoc-schedule-common.common.ui.participant-card.contact.no-one-is-on-call',
        defaultMessage: 'No one is on-call on this shift.',
        description: 'Warning text that indicates current responder is deactivated/deleted and no-one is on-call.'
    }
});

});

parcelRegister("avfXb", function(module, exports) {

$parcel$export(module.exports, "SvgCorrection", () => $97a8716dea4e4c66$export$e65345f20dc4fa02);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $vIiRg = parcelRequire("vIiRg");


var $bWGt6 = parcelRequire("bWGt6");
const $97a8716dea4e4c66$export$e65345f20dc4fa02 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ew9x0ob0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& svg': {
        backgroundColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
        color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $vIiRg.AVATAR_RADIUS)['medium']}px`,
        overflow: 'hidden'
    }
});

});


parcelRegister("5jHhH", function(module, exports) {

$parcel$export(module.exports, "DeletedWarning", () => $81bb31f845109be7$export$d883a484d0d08774);
$parcel$export(module.exports, "ForwardedInfo", () => $81bb31f845109be7$export$ff01b5dbe2cd694b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");


var $4kJsj = parcelRequire("4kJsj");
const $81bb31f845109be7$var$textStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $81bb31f845109be7$export$d883a484d0d08774 = ()=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        // TODO: make icon labels common translations
        label: "warning",
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $81bb31f845109be7$var$textStyles,
        as: "span"
    }, intlApi.formatMessage((0, $4kJsj.messages).noOneIsOnCall)));
};
const $81bb31f845109be7$export$ff01b5dbe2cd694b = ()=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: "info",
        color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $81bb31f845109be7$var$textStyles,
        as: "span"
    }, intlApi.formatMessage((0, $4kJsj.messages).forwardingParticipant)));
};

});
parcelRegister("4kJsj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b7155ddafb3b059d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b7155ddafb3b059d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forwardingParticipant: {
        id: 'eoc-schedule-common.common.ui.shift-card.info.forwarding-participant',
        defaultMessage: 'Call will be forwarded to this participant.',
        description: 'Explanation text for forwarding participant.'
    },
    noOneIsOnCall: {
        id: 'eoc-schedule-common.common.ui.shift-card.info.no-one-is-on-call',
        defaultMessage: 'No one is on-call on this shift.',
        description: 'Warning text that indicates current responder is deactivated/deleted and no-one is on-call.'
    }
});

});



parcelRegister("bZWhc", function(module, exports) {

$parcel$export(module.exports, "useShiftFocus", () => $ca5ca985c7e028e0$export$5bd858da5be21a83);

var $5uXOq = parcelRequire("5uXOq");

var $fx8zI = parcelRequire("fx8zI");

var $i07hd = parcelRequire("i07hd");
/**
 * Hook to manage focus state in a table.
 * @param table - Table of items to focus on.
 * @param epoch - Epoch to focus near initially.
 * @returns Focused tab, tabbed, focusRefs, onContainerKeyDown,.
 * @var tab - Function to make specific item tabbable.
 * @var tabbed - Currently tabbale item.
 * @var focusRefs - Refs to focusable items.
 * @var onContainerKeyDown - Function to handle keydown on container.
 */ const $ca5ca985c7e028e0$export$5bd858da5be21a83 = (table, epoch)=>{
    const [tabable, setTabable] = (0, $5uXOq.useState)(()=>(0, $i07hd.getClosestInTable)(table, epoch));
    const focusRefs = (0, $5uXOq.useMemo)(()=>table.flat().reduce((acc, { id: id })=>({
                ...acc,
                [id]: (0, $5uXOq.createRef)()
            }), {}), [
        table
    ]);
    const focus = (0, $5uXOq.useCallback)((indexes)=>{
        const item = (0, $i07hd.getItem)(table, indexes);
        if (item) focusRefs[item.id].current?.focus();
    }, [
        focusRefs,
        table
    ]);
    const handleMove = (0, $5uXOq.useMemo)(()=>(0, $i07hd.move)(table), [
        table
    ]);
    const navigate = (0, $5uXOq.useCallback)((direction)=>{
        if (tabable === null) return null;
        setTabable((prev)=>{
            if (prev) {
                const next = handleMove(prev, direction);
                focus(next);
                return next;
            }
            return null;
        });
    }, [
        tabable,
        handleMove,
        focus
    ]);
    const onContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const direction = key in (0, $fx8zI.arrowKeys) ? (0, $fx8zI.arrowKeys)[key] : null;
        if (direction) {
            e.preventDefault();
            navigate(direction);
        }
    }, [
        navigate
    ]);
    const tab = (0, $5uXOq.useCallback)((id)=>{
        setTabable((0, $i07hd.findItemIndexInTable)(table, id));
    }, [
        table
    ]);
    const tabbed = (0, $i07hd.getItem)(table, tabable);
    return {
        tab: tab,
        tabbed: tabbed,
        focusRefs: focusRefs,
        onContainerKeyDown: onContainerKeyDown
    };
};

});
parcelRegister("fx8zI", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $1a235d38b488135f$export$8b15eca9c6d5c48a);
const $1a235d38b488135f$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};

});



parcelRegister("6R5iM", function(module, exports) {

$parcel$export(module.exports, "Container", () => $0bb0ce7dd5fcb1da$export$42a852a2b6b56249);
$parcel$export(module.exports, "ScrollableArea", () => $0bb0ce7dd5fcb1da$export$83c3fa3ac4f31acf);
$parcel$export(module.exports, "HeaderContainer", () => $0bb0ce7dd5fcb1da$export$1e86fd0e1db89578);
$parcel$export(module.exports, "LayerName", () => $0bb0ce7dd5fcb1da$export$3b1c31f03926e321);
$parcel$export(module.exports, "Scrollable", () => $0bb0ce7dd5fcb1da$export$fcc7818a78919c8c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $aSTVt = parcelRequire("aSTVt");

var $4mXPL = parcelRequire("4mXPL");

var $bWGt6 = parcelRequire("bWGt6");
function $0bb0ce7dd5fcb1da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0bb0ce7dd5fcb1da$var$HEADER_HEIGHT = "var(--ds-space-400, 32px)";
const $0bb0ce7dd5fcb1da$var$HEADER_BOTTOM = "var(--ds-space-200, 16px)";
const $0bb0ce7dd5fcb1da$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1r4v4mh4"
})({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% - ${(0, $4mXPL.WIDTH)}px)`
});
const $0bb0ce7dd5fcb1da$export$83c3fa3ac4f31acf = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1r4v4mh3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${1024 - (0, $4mXPL.WIDTH)}px`
});
const $0bb0ce7dd5fcb1da$export$1e86fd0e1db89578 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1r4v4mh2"
})({
    margin: `0 0 ${$0bb0ce7dd5fcb1da$var$HEADER_BOTTOM} 0`,
    minHeight: $0bb0ce7dd5fcb1da$var$HEADER_HEIGHT,
    maxHeight: $0bb0ce7dd5fcb1da$var$HEADER_HEIGHT
});
const $0bb0ce7dd5fcb1da$export$3b1c31f03926e321 = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "e1r4v4mh1"
})({
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $aSTVt.LAYER_HEIGHT),
    padding: `0 0 ${"var(--ds-space-050, 4px)"} 0`
});
const $0bb0ce7dd5fcb1da$export$fcc7818a78919c8c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1r4v4mh0"
})({
    name: "1x3purg",
    styles: "flex:1 1 auto;height:100%;overflow-y:auto;overflow-x:hidden;padding-right:var(--ds-space-025, 2px)"
});

});
parcelRegister("4mXPL", function(module, exports) {

$parcel$export(module.exports, "VERTICAL_SPACING", () => $c3414fdce3510451$export$a854365ab38d7f3d);
$parcel$export(module.exports, "LEFT_SPACING", () => $c3414fdce3510451$export$ab94c4b81769d6c2);
$parcel$export(module.exports, "WIDTH", () => $c3414fdce3510451$export$397f5285b920487e);
$parcel$export(module.exports, "Container", () => $c3414fdce3510451$export$42a852a2b6b56249);

var $bWGt6 = parcelRequire("bWGt6");
const $c3414fdce3510451$export$a854365ab38d7f3d = 40;
const $c3414fdce3510451$export$ab94c4b81769d6c2 = 2;
const $c3414fdce3510451$export$397f5285b920487e = 400;
const $c3414fdce3510451$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1oc1upa0"
})({
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 ${$c3414fdce3510451$export$a854365ab38d7f3d / 2}px 0 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$c3414fdce3510451$export$397f5285b920487e}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${$c3414fdce3510451$export$397f5285b920487e}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${$c3414fdce3510451$export$a854365ab38d7f3d / 2}px 0 ${$c3414fdce3510451$export$ab94c4b81769d6c2}px`,
    position: 'relative'
});

});


parcelRegister("aBYdx", function(module, exports) {

$parcel$export(module.exports, "WeekList", () => $d6a4f10b985d1bc1$export$468ed64885c1e535);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $i07hd = parcelRequire("i07hd");
var $3FhTI = parcelRequire("3FhTI");
var $5s9eT = parcelRequire("5s9eT");
var $dAkvd = parcelRequire("dAkvd");
var $jH8Xl = parcelRequire("jH8Xl");
var $cR6iS = parcelRequire("cR6iS");
var $bZWhc = parcelRequire("bZWhc");
var $9w5KV = parcelRequire("9w5KV");

var $3NQti = parcelRequire("3NQti");
const $d6a4f10b985d1bc1$export$468ed64885c1e535 = (props)=>{
    const { weeks: weeks, nowEpoch: nowEpoch, offset: offset, width: width } = props;
    const [activePopup, setActivePopup] = (0, $5uXOq.useState)();
    const [activeRotation] = (0, $3NQti.useRotation)();
    const itemTable = (0, $5uXOq.useMemo)(()=>{
        return (0, $i07hd.fromWeeksToItemTable)(weeks);
    }, [
        weeks
    ]);
    const { tabbed: tabbed, focusRefs: focusRefs, onContainerKeyDown: onContainerKeyDown, tab: tab } = (0, $bZWhc.useShiftFocus)(itemTable, nowEpoch);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // NOTE: might be re add later
        // role="table"
        // aria-label={layer.label}
        // aria-roledescription={intlApi.formatMessage(
        //   scheduleCommonMessages.calendarLayer,
        // )}
        onKeyDown: onContainerKeyDown
    }, weeks.map(({ startEpoch: startEpoch, endEpoch: endEpoch, rotations: rotations })=>{
        const week = {
            startEpoch: startEpoch,
            endEpoch: endEpoch,
            nowEpoch: nowEpoch,
            width: width
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9w5KV.Week), {
            key: `week-${startEpoch}-${endEpoch}`,
            startEpoch: startEpoch,
            endEpoch: endEpoch,
            nowEpoch: nowEpoch,
            offset: offset,
            rotationSlot: rotations.map((rotation, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAkvd.Rotation), {
                    key: index,
                    isFirstLastSame: true,
                    variant: "compact",
                    highlighted: activeRotation && rotation.id === null || activeRotation?.id === rotation.id,
                    name: rotation.name,
                    size: "small"
                }, rotation.periods.map((period)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
                        key: period.id,
                        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR6iS.SingleViewShiftCard), {
                                onClose: ()=>setActivePopup(undefined),
                                cards: [
                                    {
                                        ...period,
                                        rotation: rotation
                                    }
                                ]
                            }),
                        isOpen: activePopup === period.id,
                        // TODO: make common function
                        // Made onClose ignore close if an shift tile in current layer is click
                        // Because for some reason onClose fires after new popup open causing
                        // it to close as well
                        onClose: (e)=>{
                            if (e.target instanceof HTMLElement) {
                                const target = e.target.closest('[data-shift-id]');
                                if (target && Object.values(focusRefs).some((ref)=>ref.current === target)) return;
                            }
                            setActivePopup(undefined);
                        },
                        placement: "bottom",
                        zIndex: (0, $k5uoT.layers).modal() + 1,
                        trigger: ({ ref: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH8Xl.SimpleShiftTile), {
                                ref: (0, $3FhTI.mergeRefs)(triggerRef, focusRefs[period.id]),
                                onClick: ()=>{
                                    if (activePopup === period.id) setActivePopup(undefined);
                                    else {
                                        tab(period.id);
                                        setActivePopup(period.id);
                                    }
                                },
                                period: period,
                                outerTimeFrame: week,
                                isSelected: activePopup === period.id,
                                isTabbable: tabbed?.id === period.id,
                                size: "small",
                                hasOverrideBorder: period.type === (0, $5s9eT.PeriodType).Override || period.type === (0, $5s9eT.PeriodType).Forwarding
                            })
                    }))))
        });
    })));
};

});
parcelRegister("9w5KV", function(module, exports) {

$parcel$export(module.exports, "Week", () => $93aa8dec41a0371a$export$fca4f8121099df57);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $hhW0G = parcelRequire("hhW0G");

var $jfjFL = parcelRequire("jfjFL");

var $1YaWe = parcelRequire("1YaWe");

var $QHzNW = parcelRequire("QHzNW");
const $93aa8dec41a0371a$export$fca4f8121099df57 = ({ nowEpoch: nowEpoch, startEpoch: startEpoch, endEpoch: endEpoch, offset: offset, rotationSlot: rotationSlot })=>{
    const intlApi = (0, $koVbs.default)();
    const ref = (0, $5uXOq.useRef)(null);
    const days = (0, $5uXOq.useMemo)(()=>(0, $QHzNW.generateWeekDays)(intlApi)(startEpoch, offset), [
        intlApi,
        offset,
        startEpoch
    ]);
    const isInWeek = (0, $jfjFL.getNowLocation)(startEpoch, endEpoch, nowEpoch) === (0, $hhW0G.NowLocation).InRange;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YaWe.Container), {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YaWe.Grid), {
        "aria-hidden": true
    }, days.map(({ text: text, dayStartEpoch: dayStartEpoch, dayEndEpoch: dayEndEpoch, isFirstDay: isFirstDay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YaWe.Cell), {
            key: `${dayStartEpoch}-${dayEndEpoch}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YaWe.Day), {
            isLong: isFirstDay,
            nowLocation: (0, $jfjFL.getNowLocation)(dayStartEpoch, dayEndEpoch, nowEpoch)
        }, text)))), rotationSlot, isInWeek && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YaWe.Stripe), {
        "data-testid": "indicator",
        nowEpoch: nowEpoch,
        endEpoch: endEpoch,
        startEpoch: startEpoch
    }));
};

});
parcelRegister("1YaWe", function(module, exports) {

$parcel$export(module.exports, "Container", () => $6df468fbc0aca916$export$42a852a2b6b56249);
$parcel$export(module.exports, "Grid", () => $6df468fbc0aca916$export$ef2184bd89960b14);
$parcel$export(module.exports, "Cell", () => $6df468fbc0aca916$export$f6f0c3fe4ec306ea);
$parcel$export(module.exports, "Day", () => $6df468fbc0aca916$export$7a9a31a911eb9a20);
$parcel$export(module.exports, "Stripe", () => $6df468fbc0aca916$export$3c7919ca4c48cda4);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $hhW0G = parcelRequire("hhW0G");

var $lklAx = parcelRequire("lklAx");

var $bWGt6 = parcelRequire("bWGt6");
function $6df468fbc0aca916$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6df468fbc0aca916$var$DAY_SIZE = 20;
const $6df468fbc0aca916$var$DAY_MARGIN = 8;
const $6df468fbc0aca916$var$STRIPE_WIDTH = 2;
const $6df468fbc0aca916$export$74f38e755072fb13 = 126;
const $6df468fbc0aca916$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh8lp0c4"
})({
    boxSizing: 'border-box',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${$6df468fbc0aca916$export$74f38e755072fb13}px`,
    paddingBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingTop: `${2 * $6df468fbc0aca916$var$DAY_MARGIN + $6df468fbc0aca916$var$DAY_SIZE}px`,
    position: 'relative',
    width: '100%'
});
const $6df468fbc0aca916$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh8lp0c3"
})({
    name: "tgh932",
    styles: "display:flex;height:inherit;left:0;position:absolute;top:0;width:inherit"
});
const $6df468fbc0aca916$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh8lp0c2"
})({
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${100 / (0, $lklAx.WEEK_DAY_COUNT)}%`,
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    borderRight: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`
});
const $6df468fbc0aca916$export$7a9a31a911eb9a20 = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "eh8lp0c1"
})("align-items:center;border-radius:", $6df468fbc0aca916$var$DAY_SIZE, "px;display:flex;height:", $6df468fbc0aca916$var$DAY_SIZE, "px;justify-content:center;left:var(--ds-space-100, 8px);margin:0;min-width:", $6df468fbc0aca916$var$DAY_SIZE, "px;padding:0px;position:absolute;top:var(--ds-space-100, 8px);", ({ isLong: isLong })=>isLong && `
    padding: 0 ${"var(--ds-space-050, 4px)"};
    `, " ", ({ nowLocation: nowLocation })=>{
    switch(nowLocation){
        case (0, $hhW0G.NowLocation).Before:
            return `
          color: ${`var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`};
        `;
        case (0, $hhW0G.NowLocation).After:
            return `
          color: ${`var(--ds-text-disabled, ${0, $829f609a65d26a98$export$fbae4efaa892d883})`};
        `;
        case (0, $hhW0G.NowLocation).InRange:
            return `
          color: ${`var(--ds-text-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`};
          background-color: ${`var(--ds-background-neutral-bold, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`};
        `;
    }
}, ";");
const $6df468fbc0aca916$export$3c7919ca4c48cda4 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "eh8lp0c0"
})("background-color:", `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`, ";height:100%;position:absolute;top:0;width:", $6df468fbc0aca916$var$STRIPE_WIDTH, "px;z-index:2;", ({ nowEpoch: nowEpoch, endEpoch: endEpoch, startEpoch: startEpoch })=>{
    const ratio = (nowEpoch - startEpoch) / (endEpoch - startEpoch);
    const halfWidth = $6df468fbc0aca916$var$STRIPE_WIDTH / 2;
    return `left: calc((100%  * ${ratio}) - ${halfWidth}px);`;
}, ";");

});

parcelRegister("QHzNW", function(module, exports) {

$parcel$export(module.exports, "generateWeekDays", () => $55cfebc1a68e4483$export$a14ade945f24e200);

var $5Ppij = parcelRequire("5Ppij");

var $gwejS = parcelRequire("gwejS");

var $cgQWJ = parcelRequire("cgQWJ");

var $lklAx = parcelRequire("lklAx");
const $55cfebc1a68e4483$export$a14ade945f24e200 = (intlApi)=>(startEpoch, offset)=>[
            ...Array.from({
                length: (0, $lklAx.WEEK_DAY_COUNT)
            })
        ].map((_, index)=>{
            const start = (0, $gwejS.default)(startEpoch, index).valueOf();
            const end = (0, $gwejS.default)(startEpoch, index + 1).valueOf();
            const zoned = (0, $5Ppij.default)(start + offset, 'UTC');
            const isFirstDay = (0, $cgQWJ.default)(zoned);
            const text = isFirstDay ? intlApi.formatDate(zoned, {
                day: 'numeric',
                month: 'short'
            }).toLocaleUpperCase(intlApi.locale) : intlApi.formatDate(zoned, {
                day: 'numeric'
            });
            return {
                dayStartEpoch: start,
                dayEndEpoch: end,
                isFirstDay: isFirstDay,
                text: text
            };
        });

});




parcelRegister("blo5K", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $9d2077f78db04c6a$export$1ba59dacbcbf90fe);

var $5uXOq = parcelRequire("5uXOq");

var $7Sso9 = parcelRequire("7Sso9");

var $fxiJ3 = parcelRequire("fxiJ3");

var $7L8P1 = parcelRequire("7L8P1");

var $8oZxV = parcelRequire("8oZxV");
const $9d2077f78db04c6a$export$1ba59dacbcbf90fe = ()=>{
    const [step] = (0, $7Sso9.useStep)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, step === (0, $fxiJ3.EditStep).List && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8oZxV.ListRotation), null), step === (0, $fxiJ3.EditStep).Detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7L8P1.EditRotation), null));
};

});
parcelRegister("7L8P1", function(module, exports) {

$parcel$export(module.exports, "EditRotation", () => $bc34ca9f0bce4ec7$export$15ea7cb19b40d310);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $koVbs = parcelRequire("koVbs");

var $7Jxgt = parcelRequire("7Jxgt");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");

var $fVnbM = parcelRequire("fVnbM");

var $htnpT = parcelRequire("htnpT");

var $d2gYe = parcelRequire("d2gYe");

var $6yUsV = parcelRequire("6yUsV");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3rLiX = parcelRequire("3rLiX");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");

var $h8yj2 = parcelRequire("h8yj2");

var $2TID8 = parcelRequire("2TID8");

var $dY87H = parcelRequire("dY87H");

var $jDgon = parcelRequire("jDgon");
var $gcpT9 = parcelRequire("gcpT9");
var $iMJ36 = parcelRequire("iMJ36");

var $9YkY7 = parcelRequire("9YkY7");

var $j0DLp = parcelRequire("j0DLp");

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $6kX15 = parcelRequire("6kX15");

var $dWcqj = parcelRequire("dWcqj");

var $4mXPL = parcelRequire("4mXPL");

var $bqBGd = parcelRequire("bqBGd");

var $31qqw = parcelRequire("31qqw");

var $7Sso9 = parcelRequire("7Sso9");

var $fxiJ3 = parcelRequire("fxiJ3");

var $3QnCy = parcelRequire("3QnCy");

var $3wU5e = parcelRequire("3wU5e");

var $7MFR3 = parcelRequire("7MFR3");

var $d41OH = parcelRequire("d41OH");

var $lNHZW = parcelRequire("lNHZW");

var $3NQti = parcelRequire("3NQti");

var $csGzA = parcelRequire("csGzA");

var $5Ggjw = parcelRequire("5Ggjw");

var $lCzwW = parcelRequire("lCzwW");

var $50BQU = parcelRequire("50BQU");

var $9qkww = parcelRequire("9qkww");

var $kv4zE = parcelRequire("kv4zE");

var $a9u2b = parcelRequire("a9u2b");

var $g8rgl = parcelRequire("g8rgl");

var $igg2Y = parcelRequire("igg2Y");

var $7qLjv = parcelRequire("7qLjv");

var $jmXs9 = parcelRequire("jmXs9");
const $bc34ca9f0bce4ec7$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.100'
});
const $bc34ca9f0bce4ec7$var$backButtonContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
// TODO: add backups for restrictions and shift period
// TODO: need onBlur and onFocus integration for DayTimeInterval component for validateOnBlur
const $bc34ca9f0bce4ec7$export$15ea7cb19b40d310 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intlApi = (0, $koVbs.default)();
    const { trigger: trigger } = (0, $j0DLp.useActions)();
    const [{ id: scheduleId }] = (0, $3NQti.useSchedule)();
    const { timingOptions: timingOptions, templateOptions: templateOptions, shiftTypeOptions: shiftTypeOptions, shiftFrequencyOptions: shiftFrequencyOptions } = (0, $31qqw.useRotationOptions)();
    const [rotationId, initialValues, recipientUpdate] = (0, $31qqw.useInitialValues)();
    const [rotationDetailVariant] = (0, $7Sso9.useDetailVariant)();
    const { openDiscardChanges: openDiscardChanges } = (0, $d41OH.useActions)();
    const { add: add, edit: edit } = (0, $31qqw.useRotationActions)(scheduleId, rotationId);
    const original = (0, $5uXOq.useRef)({});
    const focusDecorator = (0, $5uXOq.useMemo)(()=>(0, $5Ggjw.createFormFocusDecorator)(), []);
    (0, $5uXOq.useEffect)(()=>{
        trigger((0, $aSTVt.SPOTLIGHT_TOURS).rotationEdit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcpT9.EocForm), {
        initialValues: initialValues,
        // NOTE: not allowing initial values to overwrite
        initialValuesEqual: ()=>true,
        decorators: [
            focusDecorator
        ],
        subscription: {
            submitting: true,
            hasValidationErrors: true
        },
        // TODO: Add async validation -> Do all validations here and updateRotation -> remove OnChange component
        onSubmit: async (values)=>{
            const event = createAnalyticsEvent({});
            const eventPayload = {
                nameChange: initialValues?.name === values.name,
                participantsChange: JSON.stringify(initialValues?.participants) === JSON.stringify(values.participants),
                timingChange: initialValues?.startTime === values.startTime || initialValues?.endTime === values.endTime
            };
            switch(rotationDetailVariant){
                case (0, $fxiJ3.RotationDetailVariant).Edit:
                    return edit(values, {
                        onSuccess: ()=>(0, $h8yj2.fireTrackAnalytics)(event, 'rotationUpdate succeeded', eventPayload),
                        onError: ()=>()=>(0, $h8yj2.fireTrackAnalytics)(event, 'rotationUpdate failed', eventPayload)
                    });
                case (0, $fxiJ3.RotationDetailVariant).Add:
                case (0, $fxiJ3.RotationDetailVariant).Clone:
                    return add(values, {
                        onSuccess: ()=>(0, $h8yj2.fireTrackAnalytics)(event, 'rotationUpdate succeeded', eventPayload),
                        onError: ()=>()=>(0, $h8yj2.fireTrackAnalytics)(event, 'rotationUpdate failed', eventPayload)
                    });
            }
        }
    }, ({ form: form, submitting: submitting, handleSubmit: handleSubmit })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: (0, $aSTVt.SPOTLIGHT_NAMES).editRotationForm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mXPL.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $bc34ca9f0bce4ec7$var$backButtonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            id: "back-button",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))),
            onClick: ()=>openDiscardChanges({
                    variant: (0, $lNHZW.DiscardVariant).Discard,
                    id: 'back-button'
                }),
            appearance: "subtle"
        }, intlApi.formatMessage((0, $50BQU.messages).back))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Scrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "name",
            label: intlApi.formatMessage((0, $50BQU.messages).rotationName),
            isRequired: true,
            validate: (value)=>{
                if ((0, $lCzwW.isEmpty)(value)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                if (value.startsWith(' ') || value.endsWith(' ')) return intlApi.formatMessage((0, $jkGAf.messages).noSpaceAtEndOrStart);
                if (value.length > (0, $aSTVt.ROTATION_NAME_MAX_LENGTH)) return intlApi.formatMessage((0, $jkGAf.messages).maxLength, {
                    max: (0, $aSTVt.ROTATION_NAME_MAX_LENGTH)
                });
            }
        }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                autoComplete: "off"
            }), meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), {
                fieldId: 'name'
            }, meta.error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kX15.FieldCondition), {
            when: "hackStatus",
            is: (0, $3wU5e.HackStatus).Applied
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.MessageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
            ...submitting && {
                isDisabled: submitting
            },
            appearance: "confirmation",
            title: intlApi.formatMessage((0, $50BQU.messages).participantListStartUpdated)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            flexDirection: "column",
            rowGap: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, intlApi.formatMessage((0, $50BQU.messages).preserveOnCallOrder)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...submitting && {
                isDisabled: submitting
            },
            appearance: "link",
            onClick: ()=>{
                form.batch(()=>{
                    form.change('hackStatus', (0, $3wU5e.HackStatus).Rejected);
                    form.change('startTime', original.current.startTime ?? initialValues?.startTime);
                    form.change('participants', original.current.participants ?? initialValues?.participants);
                });
            }
        }, intlApi.formatMessage((0, $50BQU.messages).undoAutomaticChanges)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "participants",
            label: intlApi.formatMessage((0, $jkGAf.messages).participants)
        }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kv4zE.ParticipantList), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                value: input.value.map((responder)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, responder, {
                        key: 'key' in responder ? responder.key : (0, $7Jxgt.v4)()
                    })),
                onChange: (value, type)=>{
                    // TODO: Behavior for replace with going to be weird and possible wrong.
                    // This is on purpose. We need to re-think about shifted responders for JSM use cases.
                    // Behavior for other actions are same as OpsGenie
                    const hackStatus = form.getState().values.hackStatus;
                    const hackable = recipientUpdate?.shiftable && hackStatus === (0, $3wU5e.HackStatus).None;
                    const ignored = [
                        (0, $a9u2b.ChangeEvent).Order,
                        (0, $a9u2b.ChangeEvent).Replace
                    ].some((t)=>type === t);
                    if (hackable && !ignored) {
                        original.current.participants = value;
                        original.current.startTime = form.getState().values.startTime;
                        form.batch(()=>{
                            form.change('hackStatus', (0, $3wU5e.HackStatus).Applied);
                            form.change('startTime', recipientUpdate.startTime);
                            form.change('participants', (0, $7MFR3.rearrageParticipants)(value, recipientUpdate.responders));
                        });
                        return;
                    }
                    form.change('participants', value);
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Timings), null, intlApi.formatMessage((0, $50BQU.messages).timings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "template",
            label: intlApi.formatMessage((0, $50BQU.messages).selectShiftDuration)
        }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $igg2Y.TemplateSelect), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                onChange: (template)=>{
                    if (template) form.batch(()=>{
                        const timingType = template.restrictions.length ? template.timingType : null;
                        form.change('template', template);
                        form.change('timingType', timingType);
                        form.change('restrictions', template.restrictions);
                    });
                },
                options: templateOptions,
                placeholder: (0, $jmXs9.getTimingStatus)(form.getState().values.template) !== (0, $7qLjv.TimingStatus).Custom ? intlApi.formatMessage((0, $jkGAf.messages).select) : intlApi.formatMessage((0, $50BQU.messages).customTimings),
                onCustomize: ()=>{
                    form.batch(()=>{
                        form.change('template', null);
                        form.change('timingType', (0, $kCCbe.TimingType).Customday);
                        form.change('restrictions', (0, $3QnCy.INITIAL_CUSTOM_RESTRICTIONS));
                    });
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kX15.FieldCondition), {
            when: "template",
            not: (0, $7qLjv.TimingStatus).NoRestriction,
            transform: (template)=>(0, $jmXs9.getTimingStatus)(template)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "timingType"
        }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Group), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rLiX.default), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                onChange: (value)=>{
                    const timing = value.target.value;
                    if (timing === (0, $kCCbe.TimingType).Everday) form.batch(()=>{
                        form.change('template', null);
                        form.change('timingType', (0, $kCCbe.TimingType).Everday);
                        form.change('restrictions', (0, $7MFR3.downsizeRestriction)(form.getState().values.restrictions));
                    });
                    if (timing === (0, $kCCbe.TimingType).Customday) form.batch(()=>{
                        form.change('template', null);
                        form.change('timingType', (0, $kCCbe.TimingType).Customday);
                        form.change('restrictions', (0, $7MFR3.expandRestriction)(form.getState().values.restrictions));
                    });
                },
                options: timingOptions
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kX15.FieldCondition), {
            when: "timingType",
            is: (0, $kCCbe.TimingType).Everday
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "restrictions",
            validate: (value)=>{
                const range = value[0];
                if ((0, $lCzwW.isEmpty)(range)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                if (range.startHour === range.endHour && range.startMinute === range.endMinute) return intlApi.formatMessage((0, $jkGAf.messages).startEndSame);
                if (range.startMinute !== 30 && range.startMinute !== 0 && range.endMinute !== 30 && range.endMinute !== 0) return intlApi.formatMessage((0, $jkGAf.messages).thirtyMinuteInterval);
            }
        }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bqBGd.TimeInterval), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                isInvalid: meta.error,
                value: input.value[0],
                onChange: (timeRange)=>{
                    form.batch(()=>{
                        if (form.getState().values.template) form.change('template', null);
                        // WARNING: invalid assertion (but will not break anything)
                        form.change('restrictions', [
                            timeRange
                        ]);
                    });
                },
                labels: {
                    start: intlApi.formatMessage((0, $9YkY7.messages).from),
                    end: intlApi.formatMessage((0, $9YkY7.messages).to)
                }
            }), meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), {
                fieldId: 'restrictions'
            }, meta.error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kX15.FieldCondition), {
            when: "timingType",
            is: (0, $kCCbe.TimingType).Customday
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "restrictions",
            validate: (value)=>{
                // NOTE: This is temporary validation function
                // Replace with updated DayTimeIntervalField component
                for (const range of value){
                    if ((0, $lCzwW.isEmpty)(range)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                    if (range.startDay === range.endDay && range.startHour === range.endHour && range.startMinute === range.endMinute) return intlApi.formatMessage((0, $jkGAf.messages).startEndSame);
                    if (range.startMinute !== 30 && range.startMinute !== 0 && range.endMinute !== 30 && range.endMinute !== 0) return intlApi.formatMessage((0, $jkGAf.messages).thirtyMinuteInterval);
                }
            }
        }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2TID8.DayTimeInterval), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                variant: "compact",
                newIntervalValue: (0, $7MFR3.getNextInterval)(input.value),
                onChange: (dayTimeRange)=>{
                    form.batch(()=>{
                        form.change('template', null);
                        // WARNING: invalid assertion (but will not break anything)
                        form.change('restrictions', dayTimeRange);
                    });
                },
                labels: {
                    start: intlApi.formatMessage((0, $9YkY7.messages).from),
                    end: intlApi.formatMessage((0, $9YkY7.messages).to)
                }
            }), meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), {
                fieldId: 'restrictions'
            }, meta.error)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "shiftFrequency",
            label: intlApi.formatMessage((0, $50BQU.messages).shiftFrequency),
            isRequired: true
        }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Shift), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                onChange: (option)=>{
                    if ((0, $lCzwW.isEmpty)(option)) return;
                    const frequency = option.value;
                    if (frequency === (0, $kCCbe.ShiftFrequency).Custom) form.batch(()=>{
                        form.change('shiftFrequency', option);
                        form.change('shiftPeriod', (0, $3QnCy.DEFAULT_SHIFT_PERIOD));
                        form.change('shiftType', shiftTypeOptions.find(({ value: value })=>value === (0, $kCCbe.RotationType).DAILY));
                    });
                    if (frequency === (0, $kCCbe.ShiftFrequency).Daily) form.batch(()=>{
                        form.change('shiftFrequency', option);
                        form.change('shiftPeriod', (0, $3QnCy.DEFAULT_SHIFT_PERIOD));
                        form.change('shiftType', shiftTypeOptions.find(({ value: value })=>value === (0, $kCCbe.RotationType).DAILY));
                    });
                    if (frequency === (0, $kCCbe.ShiftFrequency).Weekly) form.batch(()=>{
                        form.change('shiftFrequency', option);
                        form.change('shiftPeriod', (0, $3QnCy.DEFAULT_SHIFT_PERIOD));
                        form.change('shiftType', shiftTypeOptions.find(({ value: value })=>value === (0, $kCCbe.RotationType).WEEKLY));
                    });
                },
                options: shiftFrequencyOptions
            }), input?.value?.value === (0, $kCCbe.ShiftFrequency).Custom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.ShiftDetails), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
                name: "shiftPeriod",
                validate: (value)=>{
                    if ((0, $lCzwW.isEmpty)(value)) return intlApi.formatMessage((0, $jkGAf.messages).minValue);
                    const num = parseInt(value);
                    const { max: max, min: min } = (0, $3QnCy.VALID_SHIFT_RANGE)[form.getState().values.shiftType.value];
                    if (num > max) return intlApi.formatMessage((0, $jkGAf.messages).maxValue, {
                        max: max
                    });
                    if (num < min) return intlApi.formatMessage((0, $jkGAf.messages).minValue);
                }
            }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.NumberContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                    ...input,
                    ...submitting && {
                        isDisabled: submitting
                    },
                    isInvalid: meta.error,
                    autoComplete: "off",
                    min: (0, $3QnCy.VALID_SHIFT_RANGE)[form.getState().values.shiftType.value].min,
                    max: (0, $3QnCy.VALID_SHIFT_RANGE)[form.getState().values.shiftType.value].max,
                    onChange: (event)=>{
                        const target = event.target;
                        target.value = target.value.replace(/[^0-9]/g, '');
                        if (target.value.length > 1) target.value = target.value.replace(/^0+/, '');
                        input.onChange(event);
                    }
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
                name: "shiftType"
            }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                    ...input,
                    ...submitting && {
                        isDisabled: submitting
                    },
                    onChange: (option)=>{
                        if ((0, $lCzwW.isEmpty)(option)) return;
                        form.batch(()=>{
                            form.change('shiftType', option);
                            form.change('shiftPeriod', (0, $3QnCy.DEFAULT_SHIFT_PERIOD));
                        });
                    },
                    options: shiftTypeOptions
                })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWcqj.FieldError), {
                name: "shiftPeriod"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "startTime",
            label: intlApi.formatMessage((0, $jkGAf.messages).startTime),
            isRequired: true,
            validate: (value)=>{
                if ((0, $lCzwW.isEmpty)(value)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                if (new Date(value).getMinutes() !== 0 && new Date(value).getMinutes() !== 30) return intlApi.formatMessage((0, $jkGAf.messages).thirtyMinuteInterval);
                if (!form.getState().values.hasEndTime) return;
                if (new Date(value).valueOf() > new Date(form.getState().values.endTime).valueOf()) return intlApi.formatMessage((0, $jkGAf.messages).startLaterEnd);
                if (new Date(value).valueOf() === new Date(form.getState().values.endTime).valueOf()) return intlApi.formatMessage((0, $jkGAf.messages).startEndSame);
            }
        }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                isInvalid: meta.error,
                datePickerProps: {
                    weekStartDay: 1,
                    label: intlApi.formatMessage((0, $50BQU.messages).rotation, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).startDate)
                    }).toLowerCase()
                },
                timePickerProps: {
                    times: (0, $aSTVt.DEFAULT_TIMES),
                    // NOTE: limits 30 minutes intervals
                    timeIsEditable: false,
                    label: intlApi.formatMessage((0, $50BQU.messages).rotation, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).startTime)
                    }).toLowerCase()
                }
            }), meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), {
                fieldId: 'startTime'
            }, meta.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Info), null, intlApi.formatMessage((0, $50BQU.messages).timesInScheduleTimezone)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6kX15.FieldCondition), {
            when: "hasEndTime",
            is: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "endTime",
            label: intlApi.formatMessage((0, $jkGAf.messages).endTime),
            isRequired: true,
            validate: (value)=>{
                if ((0, $lCzwW.isEmpty)(value)) return intlApi.formatMessage((0, $jkGAf.messages).required);
                if (new Date(value).getMinutes() !== 0 && new Date(value).getMinutes() !== 30) return intlApi.formatMessage((0, $jkGAf.messages).thirtyMinuteInterval);
                if (new Date(value).valueOf() < new Date(form.getState().values.startTime).valueOf()) return intlApi.formatMessage((0, $jkGAf.messages).endEarlierStart);
                if (new Date(value).valueOf() === new Date(form.getState().values.startTime).valueOf()) return intlApi.formatMessage((0, $jkGAf.messages).startEndSame);
            }
        }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...input,
                ...submitting && {
                    isDisabled: submitting
                },
                isInvalid: meta.error,
                datePickerProps: {
                    weekStartDay: 1,
                    label: intlApi.formatMessage((0, $50BQU.messages).rotation, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).endDate)
                    }).toLowerCase()
                },
                timePickerProps: {
                    times: (0, $aSTVt.DEFAULT_TIMES),
                    // NOTE: limits 30 minutes intervals
                    timeIsEditable: false,
                    label: intlApi.formatMessage((0, $50BQU.messages).rotation, {
                        label: intlApi.formatMessage((0, $jkGAf.messages).endTime)
                    }).toLowerCase()
                }
            }), meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), {
                fieldId: 'endTime'
            }, meta.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Info), null, intlApi.formatMessage((0, $50BQU.messages).timesInScheduleTimezone))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "hasEndTime"
        }, ({ input: { value: hasEndTime } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $bc34ca9f0bce4ec7$var$buttonContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...submitting && {
                    isDisabled: submitting
                },
                appearance: "link",
                onClick: ()=>{
                    if (hasEndTime) form.batch(()=>{
                        form.change('hasEndTime', false);
                    });
                    else form.batch(()=>{
                        form.change('hasEndTime', true);
                        form.change('endTime', (0, $csGzA.formatting).toISO((0, $7MFR3.generateDefaultEnd)(form.getState().values.startTime)));
                    });
                }
            }, hasEndTime ? intlApi.formatMessage((0, $50BQU.messages).removeEndTime) : intlApi.formatMessage((0, $50BQU.messages).defineEndTime))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9qkww.OnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8rgl.Footer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            isLoading: submitting,
            onClick: handleSubmit,
            type: "button"
        }, intlApi.formatMessage(rotationDetailVariant === (0, $fxiJ3.RotationDetailVariant).Edit ? (0, $50BQU.messages).updateRotation : (0, $50BQU.messages).addRotation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...submitting && {
                isDisabled: submitting
            },
            id: "discard-button",
            appearance: "default",
            onClick: (_, analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'editModeDiscardButton');
                openDiscardChanges({
                    variant: (0, $lNHZW.DiscardVariant).Discard,
                    id: 'discard-button'
                });
            }
        }, intlApi.formatMessage((0, $jkGAf.messages).discard)))));
    }));
};

});
parcelRegister("jDgon", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $65f495d59743786f$export$3c4232819458a302);
$parcel$export(module.exports, "EocField", () => $65f495d59743786f$export$35d248c78341e61);

var $5uXOq = parcelRequire("5uXOq");

var $31kPh = parcelRequire("31kPh");

var $8e3lA = parcelRequire("8e3lA");

var $2x3Cb = parcelRequire("2x3Cb");

var $f5TWP = parcelRequire("f5TWP");

var $8xY2r = parcelRequire("8xY2r");

var $5kG7a = parcelRequire("5kG7a");

var $1XCut = parcelRequire("1XCut");
const $65f495d59743786f$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $65f495d59743786f$export$35d248c78341e61 = ({ id: id, children: children, hint: hint, isRequired: isRequired, label: label, name: name, helperMessageComponent: helperMessageComponent, ...restFieldProps })=>{
    const fieldId = (0, $5uXOq.useMemo)(()=>id ? id : `${name}-${(0, $8e3lA.uid)({
            id: name
        })}`, [
        id,
        name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31kPh.Field), {
        name: name,
        ...restFieldProps
    }, (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XCut.Container), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            id: `${fieldId}-label`,
            htmlFor: fieldId
        }, label, isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XCut.Required), null)), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5kG7a.HintPopup), {
            hint: hint,
            label: label
        }), helperMessageComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65f495d59743786f$export$3c4232819458a302.Provider, {
            value: fieldId
        }, (0, $8xY2r.default)(children, {
            input: {
                id: fieldId,
                isInvalid: fieldRenderProps.meta.touched && !fieldRenderProps.meta.valid,
                'aria-invalid': !!fieldRenderProps.meta.error ? true : undefined,
                'aria-labelledby': `${fieldId}-label`,
                'aria-describedby': `${fieldId}-helper ${fieldId}-valid ${fieldId}-error`,
                'aria-required': isRequired,
                ...fieldRenderProps.input
            },
            meta: fieldRenderProps.meta
        }))));
};

});
parcelRegister("31kPh", function(module, exports) {

$parcel$export(module.exports, "Form", () => $23319eb72bd68064$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "useForm", () => $23319eb72bd68064$export$87c0cf8eb5a167e0);
$parcel$export(module.exports, "useFormState", () => $23319eb72bd68064$export$606f11b2eb45ecc6);
$parcel$export(module.exports, "FormSpy", () => $23319eb72bd68064$export$d2e89184086487cb);
$parcel$export(module.exports, "useField", () => $23319eb72bd68064$export$294aa081a6c6f55d);
$parcel$export(module.exports, "Field", () => $23319eb72bd68064$export$a455218a85c89869);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");
var $23319eb72bd68064$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $23319eb72bd68064$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $ddEsc.default)(props, $23319eb72bd68064$var$_excluded$3);
    if (component) return /*#__PURE__*/ $5uXOq.createElement(component, Object.assign(lazyProps, rest, {
        children: children,
        render: render
    }));
    if (render) return render(children === undefined ? Object.assign(lazyProps, rest) : Object.assign(lazyProps, rest, {
        children: children
    }));
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(Object.assign(lazyProps, rest));
}
function $23319eb72bd68064$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $23319eb72bd68064$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $23319eb72bd68064$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $23319eb72bd68064$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $23319eb72bd68064$var$ReactFinalFormContext = /*#__PURE__*/ $5uXOq.createContext();
function $23319eb72bd68064$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
var $23319eb72bd68064$export$83d89fbfd8236492 = "6.5.8";
var $23319eb72bd68064$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $23319eb72bd68064$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $23319eb72bd68064$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $23319eb72bd68064$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $23319eb72bd68064$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $23319eb72bd68064$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $23319eb72bd68064$var$versions = {
    "final-form": (0, $lqWDn.version),
    "react-final-form": $23319eb72bd68064$export$83d89fbfd8236492
};
var $23319eb72bd68064$var$all$1 = (0, $lqWDn.formSubscriptionItems).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $23319eb72bd68064$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $23319eb72bd68064$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $ddEsc.default)(_ref, $23319eb72bd68064$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $23319eb72bd68064$var$useConstant(function() {
        var f = alternateFormApi || (0, $lqWDn.createForm)(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    }); // synchronously register and unregister to query form state for our subscription on first render
    var _React$useState = $5uXOq.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1]; // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $23319eb72bd68064$var$useLatest(state);
    $5uXOq.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                if (!$23319eb72bd68064$var$shallowEqual(s, stateRef.current)) setState(s);
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return(// istanbul ignore next
            decorator(form));
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, decorators); // warn about decorator changes
    $23319eb72bd68064$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $23319eb72bd68064$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $23319eb72bd68064$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $23319eb72bd68064$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $23319eb72bd68064$var$shallowEqual);
    $23319eb72bd68064$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $23319eb72bd68064$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $23319eb72bd68064$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $23319eb72bd68064$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $bS32t.default)({}, form, {
            reset: function reset(eventOrValues) {
                if ($23319eb72bd68064$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $23319eb72bd68064$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $5uXOq.createElement($23319eb72bd68064$var$ReactFinalFormContext.Provider, {
        value: form
    }, $23319eb72bd68064$var$renderComponent((0, $bS32t.default)({}, rest, {
        __versions: $23319eb72bd68064$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $23319eb72bd68064$export$87c0cf8eb5a167e0(componentName) {
    var form = $5uXOq.useContext($23319eb72bd68064$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $23319eb72bd68064$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $23319eb72bd68064$var$all$1 : _ref$subscription;
    var form = $23319eb72bd68064$export$87c0cf8eb5a167e0("useFormState");
    var firstRender = $5uXOq.useRef(true);
    var onChangeRef = $5uXOq.useRef(onChange);
    onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $5uXOq.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        if (onChange) onChange(initialState);
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $5uXOq.useEffect(function() {
        return form.subscribe(function(newState) {
            if (firstRender.current) firstRender.current = false;
            else {
                setState(newState);
                if (onChangeRef.current) onChangeRef.current(newState);
            }
        }, subscription);
    }, []);
    var lazyState = {};
    $23319eb72bd68064$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $23319eb72bd68064$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $23319eb72bd68064$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $ddEsc.default)(_ref, $23319eb72bd68064$var$_excluded$1);
    var reactFinalForm = $23319eb72bd68064$export$87c0cf8eb5a167e0("FormSpy");
    var state = $23319eb72bd68064$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $bS32t.default)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($23319eb72bd68064$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $23319eb72bd68064$var$renderComponent((0, $bS32t.default)({}, rest, renderProps), state, "FormSpy");
}
var $23319eb72bd68064$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $23319eb72bd68064$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $23319eb72bd68064$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $23319eb72bd68064$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $23319eb72bd68064$var$useConstantCallback(callback) {
    var ref = $5uXOq.useRef(callback);
    $5uXOq.useEffect(function() {
        ref.current = callback;
    });
    return $5uXOq.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $23319eb72bd68064$var$all = (0, $lqWDn.fieldSubscriptionItems).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $23319eb72bd68064$var$defaultFormat = function defaultFormat(value, name) {
    return value === undefined ? "" : value;
};
var $23319eb72bd68064$var$defaultParse = function defaultParse(value, name) {
    return value === "" ? undefined : value;
};
var $23319eb72bd68064$var$defaultIsEqual = function defaultIsEqual(a, b) {
    return a === b;
};
function $23319eb72bd68064$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $23319eb72bd68064$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $23319eb72bd68064$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $23319eb72bd68064$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $23319eb72bd68064$export$87c0cf8eb5a167e0("useField");
    var configRef = $23319eb72bd68064$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $23319eb72bd68064$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var _ref = form.getFieldState(name), value = _ref.value;
                    var formatted = format(value, name);
                    if (formatted !== value) form.change(name, formatted);
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: function isEqual(a, b) {
                return (configRef.current.isEqual || $23319eb72bd68064$var$defaultIsEqual)(a, b);
            },
            silent: silent,
            validateFields: validateFields
        }));
    };
    var firstRender = $5uXOq.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $5uXOq.useState(function() {
        var initialState = {}; // temporarily disable destroyOnUnregister
        // temporarily disable destroyOnUnregister
        var destroyOnUnregister = form.destroyOnUnregister;
        form.destroyOnUnregister = false;
        register(function(state) {
            initialState = state;
        }, true)(); // return destroyOnUnregister to its original value
        // return destroyOnUnregister to its original value
        form.destroyOnUnregister = destroyOnUnregister;
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $5uXOq.useEffect(function() {
        return register(function(state) {
            if (firstRender.current) firstRender.current = false;
            else setState(state);
        }, false);
    }, [
        name,
        data,
        defaultValue,
        // cannot reregister field every time validate function !==.
        // validate,
        initialValue // The validateFields array is often passed as validateFields={[]}, creating
    ]);
    var meta = {};
    $23319eb72bd68064$var$addLazyFieldMetaState(meta, state);
    var input = {
        name: name,
        get value () {
            var value = state.value;
            if (formatOnBlur) {
                if (component === "input") value = $23319eb72bd68064$var$defaultFormat(value);
            } else value = format(value, name);
            if (value === null && !allowNull) value = "";
            if (type === "checkbox" || type === "radio") return _value;
            else if (component === "select" && multiple) return value || [];
            return value;
        },
        get checked () {
            var value1 = state.value;
            if (type === "checkbox") {
                value1 = format(value1, name);
                if (_value === undefined) return !!value1;
                else return !!(Array.isArray(value1) && ~value1.indexOf(_value));
            } else if (type === "radio") return format(value1, name) === _value;
            return undefined;
        },
        onBlur: $23319eb72bd68064$var$useConstantCallback(function(event) {
            state.blur();
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(state.name);
                state.change(format(fieldState.value, state.name));
            }
        }),
        onChange: $23319eb72bd68064$var$useConstantCallback(function(event) {
            var targetType, unknown, _value2;
            var value = event && event.target ? $23319eb72bd68064$var$getValue(event, state.value, _value, $23319eb72bd68064$var$isReactNative) : event;
            state.change(parse(value, name));
        }),
        onFocus: $23319eb72bd68064$var$useConstantCallback(function(event) {
            return state.focus();
        })
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force Flow check
    return renderProps;
}
var $23319eb72bd68064$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
];
var $23319eb72bd68064$export$a455218a85c89869 = /*#__PURE__*/ $5uXOq.forwardRef(function Field(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $ddEsc.default)(_ref, $23319eb72bd68064$var$_excluded);
    var field = $23319eb72bd68064$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        children: children,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    if (typeof children === "function") return children((0, $bS32t.default)({}, field, rest));
    if (typeof component === "string") // ignore meta, combine input with any other props
    return /*#__PURE__*/ $5uXOq.createElement(component, (0, $bS32t.default)({}, field.input, {
        children: children,
        ref: ref
    }, rest));
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $23319eb72bd68064$var$renderComponent((0, $bS32t.default)({
        children: children,
        component: component,
        ref: ref
    }, rest), field, "Field(" + name + ")");
});
function $23319eb72bd68064$export$38f9b05178901e14() {
    return {
        Form: $23319eb72bd68064$export$a7fed597f4b8afd8,
        FormSpy: $23319eb72bd68064$export$d2e89184086487cb
    };
}

});

parcelRegister("8xY2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8a33635366e45e$export$2e2bcd8739ae039);
function $7e8a33635366e45e$export$2e2bcd8739ae039(children, props) {
    // Check if the component got 'function as child' more than once
    if (Array.isArray(children)) {
        const countFunctions = children.reduce((accumulator, child)=>typeof child === 'function' ? accumulator += 1 : accumulator, 0);
        if (countFunctions > 1) throw new Error(`Component expected 1 function as child but got ${countFunctions}.`);
    }
    return typeof children === 'function' ? children(props) : children;
}

});

parcelRegister("5kG7a", function(module, exports) {

$parcel$export(module.exports, "HintPopup", () => $efd1ec63f145ef22$export$c393d844e85461b7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $820Wv = parcelRequire("820Wv");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k5uoT = parcelRequire("k5uoT");

var $2R2uW = parcelRequire("2R2uW");
const $efd1ec63f145ef22$var$popupStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    maxWidth: '360px'
});
const $efd1ec63f145ef22$export$c393d844e85461b7 = ({ hint: hint, label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onKeyDown: (e)=>{
            if (e.key === 'Escape' && isOpen) {
                e.nativeEvent.stopImmediatePropagation();
                setIsOpen(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        placement: "right",
        zIndex: (0, $k5uoT.layers).tooltip(),
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $efd1ec63f145ef22$var$popupStyles
            }, hint),
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                label: formatMessage((0, $2R2uW.HintPopupMessages).MoreInfoIconLabel, {
                    fieldName: label
                }),
                appearance: "subtle",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($820Wv))), {
                        ...iconProps,
                        color: "currentColor",
                        LEGACY_size: "small"
                    }),
                "aria-haspopup": "true",
                "aria-expanded": isOpen,
                spacing: "compact"
            })
    }));
};

});
parcelRegister("820Wv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8b47c8580de559edd6a7f4245d87179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d8f3dcf908a8bd0$var$_react = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d8f3dcf908a8bd0$var$_information = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("jxZHv")));

var $5d8f3dcf908a8bd0$var$_panel = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $5d8f3dcf908a8bd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d8f3dcf908a8bd0$var$InformationIcon = (props)=>/*#__PURE__*/ $5d8f3dcf908a8bd0$var$_react.default.createElement($5d8f3dcf908a8bd0$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $5d8f3dcf908a8bd0$var$_panel.default
    }, props));
$5d8f3dcf908a8bd0$var$InformationIcon.Name = 'InformationIconMigration';
var $5d8f3dcf908a8bd0$var$_default = module.exports.default = $5d8f3dcf908a8bd0$var$InformationIcon;

});
parcelRegister("jxZHv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27668a0671d09dc2613ff96651c1fef4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3b0f5e112f2bb60$var$_react = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e3b0f5e112f2bb60$var$_baseNew = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e3b0f5e112f2bb60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3b0f5e112f2bb60$var$InformationIcon = (props)=>/*#__PURE__*/ $e3b0f5e112f2bb60$var$_react.default.createElement($e3b0f5e112f2bb60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e3b0f5e112f2bb60$var$InformationIcon.displayName = 'InformationIcon';
var $e3b0f5e112f2bb60$var$_default = module.exports.default = $e3b0f5e112f2bb60$var$InformationIcon;

});


parcelRegister("2R2uW", function(module, exports) {

$parcel$export(module.exports, "HintPopupMessages", () => $6fff9f970361f592$export$f691ce5de7f63949);

var $7VHMR = parcelRequire("7VHMR");
const $6fff9f970361f592$export$f691ce5de7f63949 = (0, $7VHMR.defineMessages)({
    MoreInfoIconLabel: {
        id: `eoc.form.field.hint-popup.more-info-icon-label`,
        defaultMessage: 'More about {fieldName}',
        description: "The label for the 'More info' icon in the hint popup"
    }
});

});


parcelRegister("1XCut", function(module, exports) {

$parcel$export(module.exports, "Container", () => $714eca9a836db56d$export$42a852a2b6b56249);
$parcel$export(module.exports, "Required", () => $714eca9a836db56d$export$1788c381af06add2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $714eca9a836db56d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $714eca9a836db56d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e45w2f82"
})({
    name: "jatx3t",
    styles: "margin-top:var(--ds-space-100, 8px);font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);flex-direction:column"
});
const $714eca9a836db56d$export$1788c381af06add2 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e45w2f81"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        content: "'*'",
        marginLeft: "var(--ds-space-025, 2px)",
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    }
});
const $714eca9a836db56d$export$78bef78bf8eeb36a = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e45w2f80"
})({
    name: "1hyq6d",
    styles: "margin-left:var(--ds-space-025, 2px)"
});

});


parcelRegister("gcpT9", function(module, exports) {

$parcel$export(module.exports, "EocForm", () => $fa592090fbbbee9c$export$58fc96a19659d9da);

var $5uXOq = parcelRequire("5uXOq");

var $31kPh = parcelRequire("31kPh");

var $8xY2r = parcelRequire("8xY2r");
const $fa592090fbbbee9c$export$58fc96a19659d9da = ({ children: children, subscription: subscription, ...restFormProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31kPh.Form), {
        ...restFormProps,
        subscription: subscription ? subscription : {}
    }, (formRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            onReset: formRenderProps.form.reset,
            onSubmit: formRenderProps.handleSubmit
        }, (0, $8xY2r.default)(children, formRenderProps)));
};

});

parcelRegister("iMJ36", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $aedef8af3acf03a3$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $aedef8af3acf03a3$export$915e9e7bd4f0f96d);

var $5uXOq = parcelRequire("5uXOq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $jDgon = parcelRequire("jDgon");

var $cl7nI = parcelRequire("cl7nI");
const $aedef8af3acf03a3$export$8fbe3c7d0ed2c683 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cl7nI.StyledHelperMessage), {
            id: fieldId ? `${fieldId}-helper` : undefined
        }, children));
};
const $aedef8af3acf03a3$export$5505afb209a532c8 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cl7nI.StyledValidMessage), {
            id: fieldId ? `${fieldId}-valid` : undefined,
            "aria-live": "polite",
            "aria-atomic": "true",
            columnGap: "6px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        }), children));
};
const $aedef8af3acf03a3$export$915e9e7bd4f0f96d = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cl7nI.StyledErrorMessage), {
            id: fieldId ? `${fieldId}-error` : undefined,
            "aria-live": "polite",
            "aria-atomic": "true",
            columnGap: "6px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }), children));
};

});
parcelRegister("cl7nI", function(module, exports) {

$parcel$export(module.exports, "StyledErrorMessage", () => $2489c90ca43e7dbb$export$7e30077cd8dfa6f4);
$parcel$export(module.exports, "StyledValidMessage", () => $2489c90ca43e7dbb$export$36686146fb9443bb);
$parcel$export(module.exports, "StyledHelperMessage", () => $2489c90ca43e7dbb$export$bf92826cd426065b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $2489c90ca43e7dbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2489c90ca43e7dbb$var$commonStyles = {
    name: "1a210gq",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-050, 4px);justify-content:baseline;align-items:center"
};
const $2489c90ca43e7dbb$export$7e30077cd8dfa6f4 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "enawqf62"
})($2489c90ca43e7dbb$var$commonStyles, "color:var(--ds-text-danger, #AE2A19);");
const $2489c90ca43e7dbb$export$36686146fb9443bb = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "enawqf61"
})($2489c90ca43e7dbb$var$commonStyles, "color:var(--ds-text-success, #216E4E);");
const $2489c90ca43e7dbb$export$bf92826cd426065b = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "enawqf60"
})($2489c90ca43e7dbb$var$commonStyles, {
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
});

});


parcelRegister("6kX15", function(module, exports) {

$parcel$export(module.exports, "FieldCondition", () => $2720586f64037043$export$d9b0b0c1dd1ca3d4);

var $5uXOq = parcelRequire("5uXOq");

var $31kPh = parcelRequire("31kPh");
const $2720586f64037043$export$d9b0b0c1dd1ca3d4 = ({ when: when, is: is, not: not, transform: transform, children: children })=>{
    const { input: { value: value } } = (0, $31kPh.useField)(when, {
        subscription: {
            value: true
        }
    });
    let shouldRender;
    if (is) shouldRender = transform ? transform(value) === is : value === is;
    if (not) shouldRender = transform ? transform(value) !== not : value !== not;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldRender ? children : null);
};

});

parcelRegister("dWcqj", function(module, exports) {

$parcel$export(module.exports, "FieldError", () => $d382232e80c1dc2c$export$f551688fc98f2e09);

var $5uXOq = parcelRequire("5uXOq");

var $iMJ36 = parcelRequire("iMJ36");
var $31kPh = parcelRequire("31kPh");
const $d382232e80c1dc2c$export$f551688fc98f2e09 = ({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31kPh.FormSpy), {
        subscription: {
            errors: true
        }
    }, ({ errors: errors })=>errors?.[name] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), {
            fieldId: name
        }, errors[name]) : null);

});

parcelRegister("bqBGd", function(module, exports) {

$parcel$export(module.exports, "TimeInterval", () => $f5acfc14f037be99$export$8bb95198b45adaac);

var $5uXOq = parcelRequire("5uXOq");

var $jdTq6 = parcelRequire("jdTq6");

var $aSTVt = parcelRequire("aSTVt");

var $862Kp = parcelRequire("862Kp");

var $gzGd3 = parcelRequire("gzGd3");

var $5m6ct = parcelRequire("5m6ct");
const $f5acfc14f037be99$export$8bb95198b45adaac = ({ id: id, labels: labels, defaultValue: defaultValue = (0, $862Kp.DEFAULT_VALUE), value: propValue, onChange: onChange, ...restProps })=>{
    const [internalValue, setInternalValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const startId = `start-${id}`;
    const endId = `end-${id}`;
    const onStartChange = (item)=>{
        if (item) {
            const [startHour, startMinute] = item.split(':');
            const next = {
                ...internalValue,
                startHour: parseInt(startHour),
                startMinute: parseInt(startMinute)
            };
            // NOTE: Previously changed here because suspected that It was wrong to have side effects in set state updater function
            // Revert if not a problem
            onChange(next);
            setInternalValue(next);
        }
    };
    const onEndChange = (item)=>{
        if (item) {
            const [endHour, endMinute] = item.split(':');
            const next = {
                ...internalValue,
                endHour: parseInt(endHour),
                endMinute: parseInt(endMinute)
            };
            // NOTE: Previously changed here because suspected that It was wrong to have side effects in set state updater function
            // Revert if not a problem
            onChange(next);
            setInternalValue(next);
        }
    };
    /*
	 * NOTE
	 * If propValue is provided than act as a controlled component,
	 * else act as an uncontrolled component using the value from state
	 */ const [start, end] = (0, $5uXOq.useMemo)(()=>{
        if (propValue !== undefined && (0, $5m6ct.isValidRange)(propValue)) return (0, $5m6ct.getFormattedRange)(propValue);
        return (0, $5m6ct.getFormattedRange)(internalValue);
    }, [
        internalValue,
        propValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzGd3.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzGd3.Inner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzGd3.Label), {
        htmlFor: startId
    }, labels.start), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        ...restProps,
        id: startId,
        name: startId,
        times: (0, $aSTVt.DEFAULT_TIMES),
        onChange: onStartChange,
        selectProps: {
            isClearable: false
        },
        ...start && {
            value: start
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzGd3.Inner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzGd3.Label), {
        htmlFor: endId
    }, labels.end), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        ...restProps,
        id: endId,
        name: startId,
        times: (0, $aSTVt.DEFAULT_TIMES),
        onChange: onEndChange,
        selectProps: {
            isClearable: false
        },
        ...end && {
            value: end
        }
    })));
};

});
parcelRegister("862Kp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VALUE", () => $392e43a0ac80c31d$export$66a151256d4631f5);
const $392e43a0ac80c31d$export$66a151256d4631f5 = {
    startHour: 0,
    startMinute: 0,
    endHour: 0,
    endMinute: 0
};

});

parcelRegister("gzGd3", function(module, exports) {

$parcel$export(module.exports, "Container", () => $15b22977ea0322df$export$42a852a2b6b56249);
$parcel$export(module.exports, "Inner", () => $15b22977ea0322df$export$f63ba74aa66682be);
$parcel$export(module.exports, "Label", () => $15b22977ea0322df$export$b04be29aa201d4f5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $15b22977ea0322df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $15b22977ea0322df$var$FIELD_MARGIN = "var(--ds-space-050, 4px)";
const $15b22977ea0322df$var$LABEL_INPUT_MARGIN = "var(--ds-space-050, 4px)";
const $15b22977ea0322df$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e196kq2i2"
})({
    display: 'flex',
    columnGap: `${$15b22977ea0322df$var$FIELD_MARGIN}px`,
    justifyContent: 'space-between',
    width: '100%'
});
const $15b22977ea0322df$export$f63ba74aa66682be = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e196kq2i1"
})({
    display: 'flex',
    flexDirection: 'column',
    width: `calc(50% - ${$15b22977ea0322df$var$FIELD_MARGIN})`,
    rowGap: `${$15b22977ea0322df$var$LABEL_INPUT_MARGIN}px`
});
const $15b22977ea0322df$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $bWGt6.default)("label", {
    target: "e196kq2i0"
})({
    name: "1qupjyf",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);color:var(--ds-text-subtlest, #626F86);margin-top:0"
});

});

parcelRegister("5m6ct", function(module, exports) {

$parcel$export(module.exports, "isValidRange", () => $b76e9ae5e41321ab$export$44989eade73763a0);
$parcel$export(module.exports, "getFormattedRange", () => $b76e9ae5e41321ab$export$31fe81ca59fa23c);
const $b76e9ae5e41321ab$var$isTimeSet = (hour, minute)=>(hour || hour === 0) && (minute || minute === 0);
const $b76e9ae5e41321ab$var$isTimeValid = (hour, minute)=>hour >= 0 && hour <= 24 && minute >= 0 && minute <= 60;
const $b76e9ae5e41321ab$export$44989eade73763a0 = (range)=>{
    return $b76e9ae5e41321ab$var$isTimeSet(range.startHour, range.startMinute) && $b76e9ae5e41321ab$var$isTimeValid(range.startHour, range.startMinute) && $b76e9ae5e41321ab$var$isTimeSet(range.endHour, range.endMinute) && $b76e9ae5e41321ab$var$isTimeValid(range.endHour, range.endMinute);
};
const $b76e9ae5e41321ab$export$31fe81ca59fa23c = (value)=>{
    return [
        `${value.startHour || '00'}:${value.startMinute || '00'}`,
        `${value.endHour || '00'}:${value.endMinute || '00'}`
    ];
};

});


parcelRegister("5Ggjw", function(module, exports) {

$parcel$export(module.exports, "createFormFocusDecorator", () => $1ce253ab6316d716$export$65db767738868096);

var $lqWDn = parcelRequire("lqWDn");
const $1ce253ab6316d716$var$noop = ()=>{};
const $1ce253ab6316d716$var$findInput = (inputs, errors)=>inputs.find((input)=>input.name && (0, $lqWDn.getIn)(errors, input.name));
const $1ce253ab6316d716$var$getAllInputs = ()=>{
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce((accumulator, form)=>accumulator.concat(Array.prototype.slice.call(form)), []);
};
const $1ce253ab6316d716$export$65db767738868096 = (sectionMessageRef)=>(form)=>{
        // Save original submit function
        const originalSubmit = form.submit;
        let state = {};
        const focusOnFirstError = (errors)=>{
            const firstInput = $1ce253ab6316d716$var$findInput($1ce253ab6316d716$var$getAllInputs(), errors);
            if (firstInput) {
                // Finding by id is the most precise method, but it is unavailable for select and tag-input
                let targetLabelForAttribute;
                if (!!firstInput.id) targetLabelForAttribute = firstInput.id;
                else targetLabelForAttribute = firstInput.name;
                const targetLabel = document.querySelector(`label[for^="${targetLabelForAttribute}"]`);
                // Input doesn't have label
                if (!targetLabel) firstInput?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                else targetLabel?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                firstInput.focus({
                    preventScroll: true
                });
            } else {
                if (errors) {
                    const firstError = Object.keys(errors)?.[0];
                    if (firstError) {
                        // Trying label
                        const targetLabel = document.querySelector(`label[for^="${firstError}"]`);
                        if (targetLabel) {
                            targetLabel?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                            return;
                        }
                        // Trying error message
                        const errorMessage = document.querySelector(`#${firstError}-error`);
                        if (errorMessage) {
                            errorMessage?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                            return;
                        }
                    }
                }
                // The error is not in an input, it is in a section message
                sectionMessageRef?.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        };
        // What to do after submit
        const afterSubmit = ()=>{
            const { errors: errors, submitErrors: submitErrors } = state;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        };
        // Overwrite submit function
        form.submit = ()=>{
            const result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $1ce253ab6316d716$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        const unsubscribe = form.subscribe((nextState)=>{
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        });
        return ()=>{
            unsubscribe();
            form.submit = originalSubmit;
        };
    };

});

parcelRegister("50BQU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $499d8b8671b9968b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $499d8b8671b9968b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    back: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.back',
        defaultMessage: 'Back',
        description: 'Button for going back to rotation list.'
    },
    rotationName: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.rotationName',
        defaultMessage: 'Rotation name',
        description: 'Label for rotation name.'
    },
    addRotation: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.add',
        defaultMessage: 'Add rotation',
        description: 'Button for adding rotation.'
    },
    updateRotation: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.update',
        defaultMessage: 'Update rotation',
        description: 'Button for updating rotation.'
    },
    timings: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.timings',
        defaultMessage: 'Timings',
        description: 'Section header for timings.'
    },
    selectShiftDuration: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.select-shift-duration',
        defaultMessage: 'Select shift duration',
        description: 'Label for duration selection.'
    },
    customTimings: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.custom-timings',
        defaultMessage: 'Custom timings',
        description: 'Placeholder for select when timings are customized.'
    },
    shiftFrequency: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.shift-frequency',
        defaultMessage: 'Shift frequency',
        description: 'Label of shift frequency selection.'
    },
    defineEndTime: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.define-end-time',
        defaultMessage: 'Define end time',
        description: 'Button for adding end time field.'
    },
    removeEndTime: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.remove-end-time',
        defaultMessage: 'Remove end time',
        description: 'Button for removing end time field.'
    },
    timesInScheduleTimezone: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.times-in-schedule-timezone',
        defaultMessage: 'Times are in schedule timezone',
        description: 'Information text that suggest entered date and time will be considered in schedule timezone.'
    },
    participantListStartUpdated: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list-start-updated',
        defaultMessage: 'Participant list and start time updated.',
        description: 'Information text that suggest participant list and start time updated.'
    },
    preserveOnCallOrder: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.perserve-on-call-order',
        defaultMessage: "To preserve the current on-call, automatic changes have been made in the base schedule. Reverting these changes may cause the current on-call to change. Don\u2019t worry, the actual schedule history is preserved in the final schedule.",
        description: 'Information text that suggest updates made to participant list and start time to keep on call order same.'
    },
    undoAutomaticChanges: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.undo-automatic-changes',
        defaultMessage: 'Undo automatic changes',
        description: 'Button for removing automatic changes made to participant list and start time.'
    },
    rotation: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.rotation',
        defaultMessage: 'Rotation {label}',
        description: 'Prefix for labels. Ex. rotation start time, rotation end date.'
    }
});

});

parcelRegister("9qkww", function(module, exports) {

$parcel$export(module.exports, "OnChange", () => $f66d39f63284c031$export$9534ca02305d7b9);

var $31kPh = parcelRequire("31kPh");

var $31qqw = parcelRequire("31qqw");
const $f66d39f63284c031$export$9534ca02305d7b9 = ()=>{
    const [rotationId] = (0, $31qqw.useInitialValues)();
    const { updateRotation: updateRotation, updateRotationDebounced: updateRotationDebounced } = (0, $31qqw.useRotationUpdate)(rotationId);
    (0, $31kPh.useFormState)({
        subscription: {
            active: true,
            hasValidationErrors: true,
            values: true
        },
        onChange: ({ hasValidationErrors: hasValidationErrors, values: values, active: active })=>{
            // Cancel last debounced if validation error occured
            if (hasValidationErrors) {
                updateRotationDebounced.cancel();
                return;
            }
            // TODO: Check the edge cases
            if (!hasValidationErrors) {
                if (active === 'name' || active === 'shiftPeriod') updateRotationDebounced(values);
                else updateRotation(values);
            }
        }
    });
    return null;
};

});

parcelRegister("kv4zE", function(module, exports) {

$parcel$export(module.exports, "ParticipantList", () => $2cea64aba7bd82c1$export$2d83d8ffcc2e6d2c);

var $5uXOq = parcelRequire("5uXOq");

var $LpImS = parcelRequire("LpImS");

var $1UikQ = parcelRequire("1UikQ");

var $koVbs = parcelRequire("koVbs");

var $7Jxgt = parcelRequire("7Jxgt");

var $26g7Y = parcelRequire("26g7Y");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6TYWC = parcelRequire("6TYWC");

var $fXc9u = parcelRequire("fXc9u");

var $cP0uo = parcelRequire("cP0uo");

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");

var $3ogs7 = parcelRequire("3ogs7");

var $8hJb9 = parcelRequire("8hJb9");

var $51Bqb = parcelRequire("51Bqb");

var $bTUue = parcelRequire("bTUue");

var $domT0 = parcelRequire("domT0");

var $7d9v8 = parcelRequire("7d9v8");

var $hW66q = parcelRequire("hW66q");

var $a9u2b = parcelRequire("a9u2b");
const $2cea64aba7bd82c1$var$listWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});
// NOTE: Implement Focus/Blur (do not focus if focused, do not blur if blured)
const $2cea64aba7bd82c1$export$2d83d8ffcc2e6d2c = ({ value: value, onChange: onChange, isDisabled: isDisabled, ...rest })=>{
    const intlApi = (0, $koVbs.default)();
    const autoCompleteRef = (0, $5uXOq.useRef)(null);
    const responders = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)(value));
    const names = (0, $5uXOq.useMemo)(()=>value.map(({ id: id, type: type })=>{
            const item = responders.find((responder)=>responder.id === id) ?? {};
            if ('name' in item) return item.name;
            if (type === 'noone') return intlApi.formatMessage((0, $jkGAf.messages).noOne);
            return id;
        }), [
        intlApi,
        responders,
        value
    ]);
    const reorder = (0, $5uXOq.useCallback)((source, target)=>{
        onChange((0, $domT0.reorderItems)(value, source, target), (0, $a9u2b.ChangeEvent).Order);
    }, [
        onChange,
        value
    ]);
    (0, $bTUue.useMonitorListItems)({
        droppableId: 'participants',
        data: value,
        onComplete: ({ startIndex: startIndex, targetIndex: targetIndex })=>reorder(startIndex, targetIndex),
        property: 'key'
    });
    const onAdd = (0, $5uXOq.useCallback)((participant)=>{
        if (participant) {
            const { value: id, type: type } = participant;
            const responder = {
                id: id,
                type: type,
                deleted: false,
                key: (0, $7Jxgt.v4)()
            };
            onChange([
                ...value,
                responder
            ], (0, $a9u2b.ChangeEvent).Add);
        }
    }, [
        onChange,
        value
    ]);
    const onRemove = (0, $5uXOq.useCallback)((index)=>{
        const copy = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(value);
        copy.splice(index, 1);
        onChange(copy, (0, $a9u2b.ChangeEvent).Remove);
        (0, $7d9v8.focus)(copy.length >= 1 ? copy[index > copy.length - 1 ? copy.length - 1 : index].key : autoCompleteRef);
    }, [
        onChange,
        value
    ]);
    const onReplaceWith = (0, $5uXOq.useCallback)((responderToReplaceIndex, newResponder)=>{
        const copy = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(value);
        copy.splice(responderToReplaceIndex, 1, (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, newResponder, {
            deleted: false,
            key: (0, $7Jxgt.v4)()
        }));
        onChange(copy, (0, $a9u2b.ChangeEvent).Replace);
        (0, $7d9v8.focus)(copy[responderToReplaceIndex].key);
    }, [
        onChange,
        value
    ]);
    const onReplaceWithNoOne = (0, $5uXOq.useCallback)((responderToReplaceIndex)=>{
        const copy = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(value);
        copy.splice(responderToReplaceIndex, 1, (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, (0, $aSTVt.REQUESTED_NO_ONE), {
            deleted: false,
            key: (0, $7Jxgt.v4)()
        }));
        onChange(copy, (0, $a9u2b.ChangeEvent).Replace);
        (0, $7d9v8.focus)(copy[responderToReplaceIndex].key);
    }, [
        onChange,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ogs7.AutoCompleteWithNoOne), {
        ...rest,
        ref: autoCompleteRef,
        endpoints: [
            (0, $6TYWC.getUsers),
            (0, $6TYWC.getTeams),
            (0, $6TYWC.getEscalations)
        ],
        components: {
            DropdownIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: intlApi.formatMessage((0, $jkGAf.messages).search)
                })
        },
        isDisabled: isDisabled,
        onChange: onAdd,
        placeholder: intlApi.formatMessage((0, $jkGAf.messages).addParticipants),
        controlShouldRenderValue: false,
        isOptionSelected: ()=>false,
        "aria-label": intlApi.formatMessage((0, $jkGAf.messages).search)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2cea64aba7bd82c1$var$listWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hJb9.List), {
        variant: "participant",
        testId: "participant-list-container"
    }, value?.map((responder, index)=>{
        const { id: id, type: type, deleted: deleted, key: key } = responder;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $51Bqb.ListItem), {
            key: key,
            value: key,
            title: names[index],
            droppableId: "participants",
            variant: "participant",
            isDisabled: isDisabled,
            index: index,
            length: value.length,
            reorder: reorder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW66q.Participant), {
            identifier: key,
            responder: {
                id: id,
                type: type,
                deleted: deleted
            },
            isDisabled: isDisabled,
            order: index + 1,
            onRemove: ()=>onRemove(index),
            onReplaceWith: (responder)=>onReplaceWith(index, responder),
            onReplaceWithNoOne: ()=>onReplaceWithNoOne(index)
        }));
    }))));
};

});
parcelRegister("8hJb9", function(module, exports) {

$parcel$export(module.exports, "List", () => $7e379f5e4492f7d6$export$54c2e3dc7acea9f5);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $7e379f5e4492f7d6$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    padding: 'space.0',
    margin: 'space.0'
});
const $7e379f5e4492f7d6$var$containerAppearances = {
    rotation: (0, $8CUq3.xcss)({
        rowGap: 'space.0'
    }),
    participant: (0, $8CUq3.xcss)({
        rowGap: 'space.050'
    })
};
const $7e379f5e4492f7d6$export$54c2e3dc7acea9f5 = ({ children: children, variant: variant, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "ul",
        testId: testId,
        xcss: [
            $7e379f5e4492f7d6$var$containerStyles,
            $7e379f5e4492f7d6$var$containerAppearances[variant]
        ]
    }, children);
};

});

parcelRegister("51Bqb", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $d2f4b61ae393cf44$export$a7b06bfba60a8a78);

var $5uXOq = parcelRequire("5uXOq");

var $lHrkK = parcelRequire("lHrkK");

var $koVbs = parcelRequire("koVbs");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $biEfA = parcelRequire("biEfA");

var $i9j7E = parcelRequire("i9j7E");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("7R0nZ");
var $kWQ6T = parcelRequire("kWQ6T");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3FhTI = parcelRequire("3FhTI");

var $7d9v8 = parcelRequire("7d9v8");

var $kIwU2 = parcelRequire("kIwU2");

var $9O9Oz = parcelRequire("9O9Oz");

var $i6Giz = parcelRequire("i6Giz");

var $jgNSd = parcelRequire("jgNSd");
const $d2f4b61ae393cf44$var$outerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    listStyle: 'none',
    borderRadius: 'border.radius.100',
    margin: '0'
});
const $d2f4b61ae393cf44$var$innerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 'border.radius.100',
    width: '100%',
    height: '100%',
    userSelect: 'auto'
});
const $d2f4b61ae393cf44$var$draggingStyles = (0, $8CUq3.xcss)({
    opacity: '0.6',
    backgroundColor: 'elevation.surface.hovered'
});
const $d2f4b61ae393cf44$var$disabledStyles = (0, $8CUq3.xcss)({
    color: 'color.text.disabled',
    cursor: 'not-allowed'
});
const $d2f4b61ae393cf44$var$idleStyles = (0, $8CUq3.xcss)({
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    }
});
const $d2f4b61ae393cf44$var$outerApperances = {
    rotation: (0, $8CUq3.xcss)({
        height: '40px'
    }),
    participant: (0, $8CUq3.xcss)({
        height: '38px',
        boxShadow: 'elevation.shadow.raised'
    })
};
const $d2f4b61ae393cf44$export$a7b06bfba60a8a78 = ({ children: children, droppableId: droppableId, variant: variant, index: index, isDisabled: isDisabled, length: length, reorder: reorder, title: title, value: value })=>{
    const intlApi = (0, $koVbs.default)();
    const listItemRef = (0, $5uXOq.useRef)(null);
    const handlerRef = (0, $5uXOq.useRef)(null);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [dragState, setDragState] = (0, $5uXOq.useState)('idle');
    (0, $5uXOq.useEffect)(()=>{
        if (!listItemRef.current || !handlerRef.current || !droppableId) return;
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: listItemRef.current,
            dragHandle: handlerRef.current,
            getInitialData: ()=>({
                    value: value,
                    droppableId: droppableId
                }),
            onGenerateDragPreview: ({ source: source })=>{
                (0, $kWQ6T.scrollJustEnoughIntoView)({
                    element: source.element
                });
                setDragState('generate-preview');
            },
            onDragStart: ()=>setDragState('dragging'),
            onDrop: ()=>setDragState('idle')
        }), (0, $7gWdR.dropTargetForElements)({
            element: listItemRef.current,
            canDrop: ({ source: { data: data } })=>data.droppableId === droppableId,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const data = {
                    value: value,
                    droppableId: droppableId
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrop: (args)=>{
                setClosestEdge(null);
            },
            onDragEnter: (args)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(args.self.data.value, args.source.data.value)) setClosestEdge((0, $biEfA.extractClosestEdge)(args.self.data));
            },
            onDragLeave: (args)=>{
                setClosestEdge(null);
            },
            onDrag: (args)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(args.self.data.value, args.source.data.value)) setClosestEdge((0, $biEfA.extractClosestEdge)(args.self.data));
            }
        }));
    }, [
        droppableId,
        value
    ]);
    const getIdentifier = (index)=>`${index}-${title}-drag-handle`;
    const position = (0, $jgNSd.getItemPosition)(index, length);
    const isMoveUpDisabled = position === 'first' || position === 'only';
    const isMoveDownDisabled = position === 'last' || position === 'only';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: [
            $d2f4b61ae393cf44$var$outerStyles,
            $d2f4b61ae393cf44$var$outerApperances[variant],
            isDisabled && $d2f4b61ae393cf44$var$disabledStyles,
            dragState === 'dragging' && $d2f4b61ae393cf44$var$draggingStyles,
            !isDisabled && dragState !== 'dragging' && $d2f4b61ae393cf44$var$idleStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $d2f4b61ae393cf44$var$innerStyles
        ],
        ref: listItemRef
    }, droppableId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        onOpenChange: ({ isOpen: isOpen })=>{
            if (!isOpen) (0, $7d9v8.focus)(getIdentifier(index));
        },
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9O9Oz.DragHandleButton), {
                ...triggerProps,
                variant: variant,
                isDisabled: isDisabled,
                id: getIdentifier(index),
                ref: (0, $3FhTI.mergeRefs)(handlerRef, triggerRef),
                label: intlApi.formatMessage((0, $i6Giz.messages).reorder, {
                    title: title,
                    position: index + 1
                })
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            reorder(index, 0);
            (0, $7d9v8.focus)(getIdentifier(0));
        },
        isDisabled: isMoveUpDisabled
    }, intlApi.formatMessage((0, $i6Giz.messages).moveToTop)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            reorder(index, index - 1);
            (0, $7d9v8.focus)(getIdentifier(index - 1));
        },
        isDisabled: isMoveUpDisabled
    }, intlApi.formatMessage((0, $i6Giz.messages).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            reorder(index, index + 1);
            (0, $7d9v8.focus)(getIdentifier(index + 1));
        },
        isDisabled: isMoveDownDisabled
    }, intlApi.formatMessage((0, $i6Giz.messages).moveDown)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            reorder(index, length - 1);
            (0, $7d9v8.focus)(getIdentifier(length - 1));
        },
        isDisabled: isMoveDownDisabled
    }, intlApi.formatMessage((0, $i6Giz.messages).moveToBottom))))), children), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9j7E.DropIndicator), {
        edge: closestEdge,
        gap: `${(0, $kIwU2.indicatorGaps)[variant] / 2}px`
    }));
};

});
parcelRegister("7d9v8", function(module, exports) {

$parcel$export(module.exports, "focus", () => $8391d4362f2ec3b8$export$d7ddd398f22d79ef);
/**
 * Focuses the element with the given identifier.
 * @param identifier - The identifier of the element to focus. Either id of the element or a ref to the element.
 */ const $8391d4362f2ec3b8$export$d7ddd398f22d79ef = (identifier)=>{
    if (typeof identifier === 'string') {
        window.setTimeout((id)=>{
            const element = document.getElementById(id);
            if (element && document.body.contains(element)) element.focus();
        }, 0, identifier);
        return;
    }
    window.setTimeout((ref)=>{
        if (ref.current) ref.current.focus();
    }, 0, identifier);
};

});

parcelRegister("kIwU2", function(module, exports) {

$parcel$export(module.exports, "indicatorGaps", () => $69f39077579f8123$export$2834480d71e75def);
const $69f39077579f8123$export$2834480d71e75def = {
    rotation: 0,
    participant: 4
};

});

parcelRegister("9O9Oz", function(module, exports) {

$parcel$export(module.exports, "DragHandleButton", () => $115b546c5de98415$export$4c99a519d851f90c);

var $5uXOq = parcelRequire("5uXOq");

var $cahRV = parcelRequire("cahRV");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");
const $115b546c5de98415$var$buttonStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.100',
    padding: 'space.0',
    width: 'max-content',
    border: 'none',
    cursor: 'grab',
    display: 'flex'
});
const $115b546c5de98415$var$spaceAppearances = {
    rotation: (0, $8CUq3.xcss)({
        marginLeft: 'space.050'
    }),
    participant: (0, $8CUq3.xcss)({
        marginLeft: 'space.075'
    })
};
const $115b546c5de98415$var$buttonAppearances = {
    default: (0, $8CUq3.xcss)({
        color: 'color.text',
        backgroundColor: 'color.background.neutral',
        ':hover': {
            backgroundColor: 'color.background.neutral.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.pressed'
        }
    }),
    selected: (0, $8CUq3.xcss)({
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected',
        ':hover': {
            backgroundColor: 'color.background.selected.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.selected.pressed'
        }
    }),
    disabled: (0, $8CUq3.xcss)({
        color: 'color.text.disabled',
        backgroundColor: 'color.background.neutral',
        cursor: 'not-allowed'
    })
};
const $115b546c5de98415$export$4c99a519d851f90c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, variant: variant, isSelected: isSelected = false, isDisabled: isDisabled = false, ...buttonProps }, ref)=>{
    const look = isSelected ? 'selected' : isDisabled ? 'disabled' : 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        ref: ref,
        xcss: [
            $115b546c5de98415$var$buttonStyles,
            $115b546c5de98415$var$buttonAppearances[look],
            $115b546c5de98415$var$spaceAppearances[variant]
        ],
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cahRV))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    }));
});

});

parcelRegister("i6Giz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $69be6511213e0d76$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $69be6511213e0d76$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    moveToTop: {
        id: 'eoc-schedule.ui.list.list-item.move-to-top',
        defaultMessage: 'Move to top',
        description: 'Label of a button for moving an item to the top of the list'
    },
    moveToBottom: {
        id: 'eoc-schedule.ui.list.list-item.move-to-bottom',
        defaultMessage: 'Move to bottom',
        description: 'Label of a button for moving an item to the bottom of the list'
    },
    moveUp: {
        id: 'eoc-schedule.ui.list.list-item.move-up',
        defaultMessage: 'Move up',
        description: 'Label of a button for moving an item up in the list'
    },
    moveDown: {
        id: 'eoc-schedule.ui.list.list-item.move-down',
        defaultMessage: 'Move down',
        description: 'Label of a button for moving an item down in the list'
    },
    reorder: {
        id: 'eoc-schedule.ui.list.list-item.reorder',
        defaultMessage: 'Reorder {title} at position {position}',
        description: 'Label of a button for reordering an item in the list'
    }
});

});

parcelRegister("jgNSd", function(module, exports) {

$parcel$export(module.exports, "getItemPosition", () => $3ba4bacf89ec15e3$export$894695389eaf15c0);
const $3ba4bacf89ec15e3$export$894695389eaf15c0 = (index, length)=>{
    if (length === 1) return 'only';
    if (index === 0) return 'first';
    if (index === length - 1) return 'last';
    return 'middle';
};

});


parcelRegister("bTUue", function(module, exports) {

$parcel$export(module.exports, "useMonitorListItems", () => $f7848460f4ad5123$export$70ab4d8ee1d05298);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $3m5yC = parcelRequire("3m5yC");

var $7gWdR = parcelRequire("7gWdR");
const $f7848460f4ad5123$export$70ab4d8ee1d05298 = ({ droppableId: droppableId, data: data, onComplete: onComplete, property: property = 'id' })=>{
    (0, $5uXOq.useEffect)(()=>{
        return (0, $7gWdR.monitorForElements)({
            canMonitor: ({ initial: { dropTargets: dropTargets } })=>{
                if (!data || !dropTargets.length) return false;
                const id = dropTargets[0].data.droppableId;
                return id === droppableId;
            },
            onDrop ({ source: source, location: location }) {
                const [destination] = location.current.dropTargets;
                if (!destination) return;
                const destinationId = destination.data.value;
                const sourceId = source.data.value;
                if (typeof destinationId !== 'string' || typeof sourceId !== 'string') return;
                const startIndex = data.findIndex((item)=>item[property] === sourceId);
                const indexOfTarget = data.findIndex((item)=>item[property] === destinationId);
                const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destination.data);
                const updated = (0, $3m5yC.reorderWithEdge)({
                    list: data,
                    startIndex: startIndex,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    axis: 'vertical'
                });
                onComplete({
                    updatedValue: updated,
                    startIndex: startIndex,
                    targetIndex: indexOfTarget,
                    sourceId: sourceId,
                    destinationId: destinationId
                });
            }
        });
    }, [
        data,
        droppableId,
        onComplete,
        property
    ]);
};

});

parcelRegister("hW66q", function(module, exports) {

$parcel$export(module.exports, "Participant", () => $14dbee9abe4678e7$export$aada361ed1a6c65);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");

var $dD7Zc = parcelRequire("dD7Zc");

var $bJeNF = parcelRequire("bJeNF");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $3HVJq = parcelRequire("3HVJq");

var $8k22Y = parcelRequire("8k22Y");
var $fXc9u = parcelRequire("fXc9u");

var $9YkY7 = parcelRequire("9YkY7");
var $cP0uo = parcelRequire("cP0uo");
var $3FhTI = parcelRequire("3FhTI");

var $8icyj = parcelRequire("8icyj");

var $jkGAf = parcelRequire("jkGAf");

var $cNMw5 = parcelRequire("cNMw5");

var $7d9v8 = parcelRequire("7d9v8");

var $2WBXV = parcelRequire("2WBXV");

var $d1uWB = parcelRequire("d1uWB");
const $14dbee9abe4678e7$var$indexStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginTop: '0',
    marginRight: 'space.075',
    marginBottom: '0',
    marginLeft: '0',
    maxWidth: '16px',
    minWidth: '16px',
    textAlign: 'right'
});
const $14dbee9abe4678e7$var$colorStyles = (0, $8CUq3.xcss)({
    height: '20px',
    minWidth: '20px',
    maxWidth: '20px',
    borderRadius: 'border.radius.100',
    marginTop: '0',
    marginRight: 'space.100',
    marginBottom: '0',
    marginLeft: '0'
});
const $14dbee9abe4678e7$var$missingResponderStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '20px',
    minWidth: '20px',
    maxWidth: '20px',
    marginTop: '0',
    marginRight: 'space.100',
    marginBottom: '0',
    marginLeft: '0'
});
const $14dbee9abe4678e7$var$avatarStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    marginTop: '0',
    marginRight: 'space.100',
    marginBottom: '0',
    marginLeft: '0'
});
const $14dbee9abe4678e7$var$nameStyles = (0, $8CUq3.xcss)({
    fontWeight: 'font.weight.regular',
    marginTop: '0',
    marginRight: 'auto',
    marginBottom: '0',
    marginLeft: '0',
    minWidth: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $14dbee9abe4678e7$var$disabledTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text.disabled'
});
const $14dbee9abe4678e7$var$normalTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text'
});
const $14dbee9abe4678e7$var$optionsStyles = (0, $8CUq3.xcss)({
    marginTop: '0',
    marginRight: 'space.050',
    marginBottom: '0',
    marginLeft: 'space.100',
    minWidth: '32px',
    maxWidth: '32px'
});
// NOTE: Focus/Blur not properly implemented
const $14dbee9abe4678e7$export$aada361ed1a6c65 = ({ identifier: identifier, order: order, responder: responder, onRemove: onRemove, onReplaceWith: onReplaceWith, onReplaceWithNoOne: onReplaceWithNoOne, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur })=>{
    const intlApi = (0, $koVbs.default)();
    const { getColor: getColor } = (0, $3HVJq.useStore)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const onPopupOpen = (0, $5uXOq.useCallback)(()=>{
        setIsPopupOpen(true);
        onFocus?.();
    }, [
        onFocus
    ]);
    const onPopupClose = (0, $5uXOq.useCallback)(()=>{
        setIsPopupOpen(false);
        onBlur?.();
    }, [
        onBlur
    ]);
    const [user] = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)([
        responder
    ]));
    const color = getColor(responder.id);
    // TODO: handle error. See: TARDIS-7446
    const { name: name, type: type, deleted: deleted } = (0, $cNMw5.getResponder)(responder, user, intlApi);
    const isNoOne = type === 'noone';
    const isDeleted = deleted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $14dbee9abe4678e7$var$indexStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: `var(--ds-chart-neutral, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    }, order), !(isNoOne || isDeleted) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $14dbee9abe4678e7$var$colorStyles,
        style: {
            backgroundColor: isDisabled ? `var(--ds-skeleton-subtle, ${0, $829f609a65d26a98$export$486ab785e4bac3c6})` : color.backgroundColor
        }
    }), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $14dbee9abe4678e7$var$missingResponderStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: intlApi.formatMessage((0, $9YkY7.messages).missingResponder)
    })), !isNoOne && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $14dbee9abe4678e7$var$avatarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
        responder: user,
        size: "xsmall",
        appearance: "circle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $14dbee9abe4678e7$var$nameStyles,
            isDisabled ? $14dbee9abe4678e7$var$disabledTextStyles : $14dbee9abe4678e7$var$normalTextStyles
        ],
        title: name
    }, !isNoOne && user.isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 2,
        width: 15
    }) : type === 'user' && isDeleted ? intlApi.formatMessage((0, $2WBXV.messages).deactivated, {
        name: name
    }) : name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $14dbee9abe4678e7$var$optionsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        onOpenChange: ({ isOpen: isOpen })=>{
            if (isOpen) onFocus?.();
            else onBlur?.();
        },
        trigger: ({ triggerRef: dropdownTriggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
                autoFocus: true,
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1uWB.ReplaceWith), {
                        ignored: responder,
                        onClose: ()=>{
                            onPopupClose();
                            (0, $7d9v8.focus)(identifier);
                        },
                        onConfirm: ({ value: value, type: type })=>{
                            onPopupClose();
                            onReplaceWith({
                                id: value,
                                type: type
                            });
                        }
                    }),
                isOpen: isPopupOpen,
                onClose: ()=>{
                    onPopupClose();
                    (0, $7d9v8.focus)(identifier);
                },
                placement: "bottom-start",
                zIndex: (0, $k5uoT.layers).modal() + 1,
                trigger: ({ ref: popupTriggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        content: intlApi.formatMessage((0, $2WBXV.messages).options),
                        position: "bottom"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                        ...props,
                        label: intlApi.formatMessage((0, $2WBXV.messages).actionsForParticipant, {
                            participantName: name
                        }),
                        id: identifier,
                        isDisabled: isDisabled,
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                        ref: (0, $3FhTI.mergeRefs)(dropdownTriggerRef, popupTriggerRef)
                    }))
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onRemove
    }, intlApi.formatMessage((0, $jkGAf.messages).remove)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onPopupOpen
    }, intlApi.formatMessage((0, $jkGAf.messages).replaceWith)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onReplaceWithNoOne
    }, intlApi.formatMessage((0, $2WBXV.messages).replaceWithNoOne)))));
};

});
parcelRegister("2WBXV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ddaa3dd421849bee$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ddaa3dd421849bee$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    options: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.options',
        defaultMessage: 'Participant options',
        description: 'A button for opening participant options dropdown.'
    },
    actionsForParticipant: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.actions-for-participant',
        defaultMessage: 'Actions for participant {participantName}',
        description: 'Label of a button for opening participant options dropdown'
    },
    replaceWithNoOne: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.replaceWithNoOne',
        defaultMessage: 'Replace with no one',
        description: 'A button for replacing a participant with no one (responder type).'
    },
    deactivated: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.participant-list.participant.deactivated',
        defaultMessage: '{name} (Deactivated)',
        description: 'Deactivated tag for user participant. Ex. Burak (Deactivated)'
    }
});

});

parcelRegister("d1uWB", function(module, exports) {

$parcel$export(module.exports, "ReplaceWith", () => $702d92497e33d2f4$export$1c973bfb295e8235);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $l1N8i = parcelRequire("l1N8i");

var $26g7Y = parcelRequire("26g7Y");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $6TYWC = parcelRequire("6TYWC");

var $5XoGW = parcelRequire("5XoGW");

var $80MT9 = parcelRequire("80MT9");
var $9YkY7 = parcelRequire("9YkY7");
var $5s9eT = parcelRequire("5s9eT");

var $jkGAf = parcelRequire("jkGAf");

var $3ogs7 = parcelRequire("3ogs7");

var $fvQU1 = parcelRequire("fvQU1");
const $702d92497e33d2f4$var$formStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'space.300',
    marginTop: 'space.100'
});
const $702d92497e33d2f4$export$1c973bfb295e8235 = ({ ignored: ignored, onClose: onClose, onConfirm: onConfirm })=>{
    const intlApi = (0, $koVbs.default)();
    const isRequiredValidator = (0, $5XoGW.useValidators)([
        (0, $5XoGW.isRequired)()
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvQU1.Container), {
        role: "dialog",
        "aria-labelledby": "replace-with-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        id: "replace-with-title",
        as: "h2",
        size: "medium"
    }, intlApi.formatMessage((0, $jkGAf.messages).replaceWith)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ({ responder: responder })=>onConfirm(responder)
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "form",
            xcss: $702d92497e33d2f4$var$formStyles,
            ...formProps,
            onSubmit: (e)=>{
                e.stopPropagation();
                formProps.onSubmit(e);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "responder",
            label: intlApi.formatMessage((0, $jkGAf.messages).participants),
            validate: isRequiredValidator
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ogs7.AutoCompleteWithNoOne), {
                ...(0, $5s9eT.EXTRA_SELECT_PROPS),
                ...fieldProps,
                placeholder: intlApi.formatMessage((0, $jkGAf.messages).addParticipants),
                // Do not show selected responder
                filterOption: ({ value: value })=>value === ignored.id ? false : true,
                components: {
                    // FIX: Custom Option doesn't render for some reason
                    DropdownIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: intlApi.formatMessage((0, $jkGAf.messages).search)
                        })
                },
                endpoints: [
                    (0, $6TYWC.getUsers),
                    (0, $6TYWC.getTeams),
                    (0, $6TYWC.getEscalations)
                ],
                isClearable: true
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "end",
            columnGap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CancelButton), {
            onClick: ()=>onClose()
        }, intlApi.formatMessage((0, $9YkY7.messages).close)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            type: "submit"
        }, intlApi.formatMessage((0, $jkGAf.messages).confirm))))));
};

});
parcelRegister("fvQU1", function(module, exports) {

$parcel$export(module.exports, "Container", () => $eee272f3f7d41691$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
const $eee272f3f7d41691$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e8cpyxh0"
})({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    width: `${400}px`,
    padding: "var(--ds-space-300, 24px)"
});

});



parcelRegister("a9u2b", function(module, exports) {

$parcel$export(module.exports, "ChangeEvent", () => $55e9bf6808f5b7c4$export$6f3d2ed036691e4e);
var $55e9bf6808f5b7c4$export$6f3d2ed036691e4e = /*#__PURE__*/ function(ChangeEvent) {
    ChangeEvent["Add"] = "add";
    ChangeEvent["Remove"] = "remove";
    ChangeEvent["Replace"] = "replace";
    ChangeEvent["Order"] = "order";
    return ChangeEvent;
}({});

});


parcelRegister("g8rgl", function(module, exports) {

$parcel$export(module.exports, "Timings", () => $3b97380d5591af55$export$504acd65eb411af4);
$parcel$export(module.exports, "Footer", () => $3b97380d5591af55$export$a06f1c675e846f6f);
$parcel$export(module.exports, "Scrollable", () => $3b97380d5591af55$export$fcc7818a78919c8c);
$parcel$export(module.exports, "Group", () => $3b97380d5591af55$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "Shift", () => $3b97380d5591af55$export$e6d3b4e5ac18cdaf);
$parcel$export(module.exports, "ShiftDetails", () => $3b97380d5591af55$export$52782572e8f2864b);
$parcel$export(module.exports, "Info", () => $3b97380d5591af55$export$c4868e4a24d48fad);
$parcel$export(module.exports, "MessageContainer", () => $3b97380d5591af55$export$616d763e306cba45);
$parcel$export(module.exports, "NumberContainer", () => $3b97380d5591af55$export$a71e0d665206bf82);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $k5uoT = parcelRequire("k5uoT");

var $4mXPL = parcelRequire("4mXPL");

var $bWGt6 = parcelRequire("bWGt6");
function $3b97380d5591af55$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b97380d5591af55$var$BACK_HEIGHT = (0, $k5uoT.gridSize)() * 4;
const $3b97380d5591af55$var$BACK_BOTTOM = (0, $k5uoT.gridSize)();
const $3b97380d5591af55$var$FOOTER_HEIGHT = (0, $k5uoT.gridSize)() * 4;
const $3b97380d5591af55$var$FOOTER_TOP = (0, $k5uoT.gridSize)() * 3;
const $3b97380d5591af55$var$FOOTER_BOTTOM = (0, $k5uoT.gridSize)() / 4;
const $3b97380d5591af55$var$SHIFT_FREQUENCY_MARGIN = (0, $k5uoT.gridSize)();
const $3b97380d5591af55$var$SHIFT_PERIOD_MARGIN = (0, $k5uoT.gridSize)() / 2;
// FIX: used for hidden select popups
const $3b97380d5591af55$var$BOTTOM_BUFFER = (0, $k5uoT.gridSize)() * 4;
const $3b97380d5591af55$var$HEIGHT_EXPECT_INNER = $3b97380d5591af55$var$FOOTER_TOP + $3b97380d5591af55$var$FOOTER_BOTTOM + $3b97380d5591af55$var$FOOTER_HEIGHT + $3b97380d5591af55$var$BACK_HEIGHT + $3b97380d5591af55$var$BACK_BOTTOM + $3b97380d5591af55$var$BOTTOM_BUFFER;
const $3b97380d5591af55$export$504acd65eb411af4 = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "en4uttd8"
})({
    margin: `${"var(--ds-space-250, 20px)"} 0 ${"var(--ds-space-100, 8px)"} 0`
});
const $3b97380d5591af55$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd7"
})({
    columnGap: "var(--ds-space-100, 8px)",
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${$3b97380d5591af55$var$FOOTER_TOP}px 0 ${$3b97380d5591af55$var$FOOTER_BOTTOM}px 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$3b97380d5591af55$var$FOOTER_HEIGHT}px`,
    overflow: 'hidden'
});
const $3b97380d5591af55$export$fcc7818a78919c8c = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd6"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% - ${$3b97380d5591af55$var$HEIGHT_EXPECT_INNER}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 -${(0, $4mXPL.VERTICAL_SPACING) / 2}px 0 -${(0, $4mXPL.LEFT_SPACING)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $4mXPL.VERTICAL_SPACING) / 4}px ${$3b97380d5591af55$var$BOTTOM_BUFFER}px ${(0, $4mXPL.LEFT_SPACING)}px`,
    overflowY: 'auto'
});
const $3b97380d5591af55$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd5"
})({
    name: "189vkcx",
    styles: "div[role='radiogroup']{display:flex;column-gap:var(--ds-space-300, 24px);}"
});
const $3b97380d5591af55$export$e6d3b4e5ac18cdaf = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd4"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& >': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:nth-child(1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `calc(50% - ${$3b97380d5591af55$var$SHIFT_FREQUENCY_MARGIN / 2}px)`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `0 ${$3b97380d5591af55$var$SHIFT_FREQUENCY_MARGIN}px 0 0`
        }
    }
});
const $3b97380d5591af55$export$52782572e8f2864b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd3"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(50% - ${$3b97380d5591af55$var$SHIFT_FREQUENCY_MARGIN / 2 + $3b97380d5591af55$var$SHIFT_PERIOD_MARGIN / 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& >': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:nth-child(1)': {
            minWidth: "var(--ds-space-500, 40px)",
            maxWidth: "var(--ds-space-500, 40px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `0 ${$3b97380d5591af55$var$SHIFT_PERIOD_MARGIN}px 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:nth-child(2)': {
            flex: '1 1 auto',
            margin: 0
        }
    }
});
const $3b97380d5591af55$export$c4868e4a24d48fad = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "en4uttd2"
})({
    margin: `${"var(--ds-space-025, 2px)"} 0 0 0`,
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
const $3b97380d5591af55$export$616d763e306cba45 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd1"
})({
    margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
});
const $3b97380d5591af55$export$a71e0d665206bf82 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "en4uttd0"
})({
    name: "ripmw0",
    styles: "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button, input[type='number']{-webkit-appearance:none;-moz-appearance:textfield;}"
});

});

parcelRegister("igg2Y", function(module, exports) {

$parcel$export(module.exports, "TemplateSelect", () => $1a2214e8dd7048e4$export$9b2f0ef1cd0ec8e3);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $dzBxd = parcelRequire("dzBxd");

var $6KZMT = parcelRequire("6KZMT");
const $1a2214e8dd7048e4$export$9b2f0ef1cd0ec8e3 = ({ onCustomize: onCustomize, ...selectProps })=>{
    const selectRef = (0, $5uXOq.useRef)(null);
    const onCustom = ()=>{
        selectRef.current?.blur();
        onCustomize();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...selectProps,
        ...(0, $6KZMT.extraTimingSelectProps),
        ref: selectRef,
        components: {
            MenuList: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzBxd.TimingMenuList), {
                    ...props,
                    onCustom: onCustom
                })
        }
    });
};

});
parcelRegister("dzBxd", function(module, exports) {

$parcel$export(module.exports, "TimingMenuList", () => $37363b877ccc9321$export$6ad6f7207ccf2e0e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $9cvy9 = parcelRequire("9cvy9");
const $37363b877ccc9321$var$footerButtonStyles = (0, $8CUq3.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width',
    textAlign: 'left',
    width: '100%',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: 'space.075',
    paddingInline: 'space.150',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $37363b877ccc9321$export$6ad6f7207ccf2e0e = ({ onCustom: onCustom, ...menuListProps })=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, menuListProps.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: onCustom,
        xcss: $37363b877ccc9321$var$footerButtonStyles
    }, intlApi.formatMessage((0, $9cvy9.messages).createCustomDuration)));
};

});
parcelRegister("9cvy9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $151b960bc2c0d31b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $151b960bc2c0d31b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    createCustomDuration: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-rotation.template-select.timing-menu-list.create-custom-duration',
        defaultMessage: 'Create custom duration',
        description: 'Label for extra dropdown item for switching to adding your own timings.'
    }
});

});


parcelRegister("6KZMT", function(module, exports) {

$parcel$export(module.exports, "extraTimingSelectProps", () => $b3a541d7193f293f$export$3d2de1eeed192e11);
const $b3a541d7193f293f$export$3d2de1eeed192e11 = {
    styles: {
        menuPortal: (base)=>({
                ...base,
                zIndex: 9999
            }),
        menuList: (base)=>({
                ...base,
                paddingBottom: 0
            })
    }
};

});


parcelRegister("7qLjv", function(module, exports) {

$parcel$export(module.exports, "TimingStatus", () => $3bbaeecaaf33017a$export$736f9758ed5ff036);
/**
 * State of timing field
 */ var $3bbaeecaaf33017a$export$736f9758ed5ff036 = /*#__PURE__*/ function(TimingStatus) {
    TimingStatus[TimingStatus["Custom"] = 1] = "Custom";
    TimingStatus[TimingStatus["Template"] = 2] = "Template";
    TimingStatus[TimingStatus["NoRestriction"] = 3] = "NoRestriction";
    return TimingStatus;
}({});

});

parcelRegister("jmXs9", function(module, exports) {

$parcel$export(module.exports, "getTimingStatus", () => $6d8642da1f80cb49$export$637081774a24e49);
parcelRequire("hfWo4");
var $9zpvl = parcelRequire("9zpvl");

var $7qLjv = parcelRequire("7qLjv");
const $6d8642da1f80cb49$export$1e167b6d9d6f8f8 = (epoch)=>(0, $9zpvl.default)(new Date(epoch), 'yyyy-MM-dd');
const $6d8642da1f80cb49$export$637081774a24e49 = (template)=>{
    if (template && template.restrictions.length) return (0, $7qLjv.TimingStatus).Template;
    if (template && template.restrictions) return (0, $7qLjv.TimingStatus).NoRestriction;
    return (0, $7qLjv.TimingStatus).Custom;
};

});


parcelRegister("8oZxV", function(module, exports) {

$parcel$export(module.exports, "ListRotation", () => $8520ab7fbe2b1981$export$a394d1fb0a8f30a7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $bopR4 = parcelRequire("bopR4");

var $kY99m = parcelRequire("kY99m");

var $h8yj2 = parcelRequire("h8yj2");

var $dY87H = parcelRequire("dY87H");

var $8icyj = parcelRequire("8icyj");

var $4mXPL = parcelRequire("4mXPL");

var $eDnUx = parcelRequire("eDnUx");

var $3NQti = parcelRequire("3NQti");

var $lCzwW = parcelRequire("lCzwW");

var $czYxV = parcelRequire("czYxV");

var $hjGj7 = parcelRequire("hjGj7");

var $91QRC = parcelRequire("91QRC");
const $8520ab7fbe2b1981$export$a394d1fb0a8f30a7 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intlApi = (0, $koVbs.default)();
    const [{ id: scheduleId, description: description }] = (0, $3NQti.useSchedule)();
    const { partialUpdate: updateDescription, isLoading: isDescriptionLoading } = (0, $eDnUx.usePartialUpdateScheduleService)(scheduleId, 'description');
    const [{ isInitialLoading: isInitialLoading }] = (0, $3NQti.useTimelineLoading)();
    // NOTE: Maybe we could recreate <SkeletonContainer skeleton children isLoading /> for logics like following
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mXPL.Container), null, isInitialLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        flexDirection: "column",
        rowGap: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 3,
        width: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        height: 3,
        width: 15
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $91QRC.DescriptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: description,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                autoComplete: "off",
                isCompact: true,
                isDisabled: isDescriptionLoading,
                "aria-label": intlApi.formatMessage((0, $czYxV.messages).editScheduleDescription)
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $91QRC.DescriptionReadView), {
                isEmpty: (0, $lCzwW.isEmpty)(description),
                isLoading: isDescriptionLoading
            }, description || intlApi.formatMessage((0, $czYxV.messages).emptyDescriptionInfoTitle)),
        // TODO: consider adding validation for max length
        onConfirm: async (value)=>{
            if (value !== description) {
                const event = createAnalyticsEvent({});
                updateDescription(value ?? '', {
                    onSuccess: ()=>{
                        (0, $h8yj2.fireTrackAnalytics)(event, 'descriptionUpdate succeeded');
                    },
                    onError: ()=>{
                        (0, $h8yj2.fireTrackAnalytics)(event, 'descriptionUpdate failed');
                    }
                });
            }
        },
        keepEditViewOpenOnBlur: true,
        readViewFitContainerWidth: true,
        editButtonLabel: intlApi.formatMessage((0, $czYxV.messages).editScheduleDescription)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjGj7.RotationList), null)));
};

});
parcelRegister("czYxV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a46a728817c12775$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a46a728817c12775$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyDescriptionInfoTitle: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.empty-description-info-title',
        defaultMessage: 'Enter a description...',
        description: 'Placeholder text when description is empty.'
    },
    editScheduleDescription: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.edit-schedule-description',
        defaultMessage: 'Edit schedule description',
        description: 'Label for inline edit of schedule description.'
    }
});

});

parcelRegister("hjGj7", function(module, exports) {

$parcel$export(module.exports, "RotationList", () => $1f815c6a70e0f92e$export$1a518033514482d5);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $h8yj2 = parcelRequire("h8yj2");

var $5sA4Z = parcelRequire("5sA4Z");

var $aSTVt = parcelRequire("aSTVt");

var $8hJb9 = parcelRequire("8hJb9");

var $51Bqb = parcelRequire("51Bqb");

var $31qqw = parcelRequire("31qqw");

var $d41OH = parcelRequire("d41OH");

var $3NQti = parcelRequire("3NQti");

var $bTUue = parcelRequire("bTUue");

var $ezeeD = parcelRequire("ezeeD");

var $4v7tD = parcelRequire("4v7tD");

var $88ENJ = parcelRequire("88ENJ");
const $1f815c6a70e0f92e$var$addRotationButtonContainerStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.200',
    marginBottom: 'space.500',
    marginLeft: 'space.negative.150'
});
// TODO: modify internalRotations on edit, clone, add, and delete
const $1f815c6a70e0f92e$export$1a518033514482d5 = ()=>{
    const intlApi = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ id: scheduleId }] = (0, $3NQti.useSchedule)();
    const { isLoading: orderRotationLoading, rotations: rotations, orderRotation: orderRotation } = (0, $31qqw.useRotationOrder)(scheduleId);
    const { openDeleteRotation: openDeleteRotation } = (0, $d41OH.useActions)();
    const { add: add, clone: clone, edit: edit, isLoading: getRotationLoading } = (0, $31qqw.useRotationFlows)(scheduleId);
    (0, $bTUue.useMonitorListItems)({
        droppableId: 'rotations',
        data: rotations ?? [],
        onComplete: ({ startIndex: startIndex, targetIndex: targetIndex })=>orderRotation(startIndex, targetIndex)
    });
    const [{ isSubsequentLoading: isSubsequentLoading }] = (0, $3NQti.useTimelineLoading)();
    const addHasSpotlight = !rotations?.length;
    const rotationHasSpotlight = !addHasSpotlight;
    const isRotationsDisabled = isSubsequentLoading || orderRotationLoading || getRotationLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88ENJ.RotationTitle), null, intlApi.formatMessage((0, $ezeeD.messages).rotationsTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hJb9.List), {
        variant: "rotation",
        testId: "rotation-list-container"
    }, rotations?.map(({ id: id, name: name }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sA4Z.Wrap), {
            within: (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                    name: (0, $aSTVt.SPOTLIGHT_NAMES).firstListRotationItem
                }, e),
            when: index === 0 && rotationHasSpotlight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $51Bqb.ListItem), {
            key: id,
            value: id,
            title: name,
            isDisabled: isRotationsDisabled,
            droppableId: "rotations",
            variant: "rotation",
            index: index,
            length: rotations.length,
            reorder: (start, target)=>orderRotation(start, target)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4v7tD.Rotation), {
            id: id,
            name: name,
            isDisabled: isRotationsDisabled,
            onEdit: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'editRotation');
                edit(id);
            },
            onClone: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'duplicateRotation');
                clone(id);
            },
            onDelete: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'deleteRotation');
                const rotation = {
                    id: id,
                    name: name
                };
                const excluded = rotations.slice(0, index).concat(rotations.slice(index + 1));
                const fallback = excluded[index > excluded.length - 1 ? index - 1 : index];
                openDeleteRotation({
                    rotation: rotation,
                    id: [
                        `${id}-rotation-options`,
                        `${fallback?.id}-rotation-options`,
                        'add-rotation-button'
                    ]
                });
            }
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sA4Z.Wrap), {
        within: (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: (0, $aSTVt.SPOTLIGHT_NAMES).firstListRotationItem
            }, e),
        when: addHasSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1f815c6a70e0f92e$var$addRotationButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: "add-rotation-button",
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'addRotation');
            add();
        },
        isDisabled: isRotationsDisabled,
        appearance: "link"
    }, intlApi.formatMessage((0, $ezeeD.messages).addRotation)))));
};

});
parcelRegister("ezeeD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0cc0b336853179f5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0cc0b336853179f5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rotationsTitle: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.list-rotation.rotation-list.rotations-title',
        defaultMessage: 'Rotations',
        description: 'Title for rotations configurable list.'
    },
    addRotation: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.list-rotation.rotation-list.add-rotation',
        defaultMessage: 'Add rotation',
        description: 'Button for adding rotation.'
    }
});

});

parcelRegister("4v7tD", function(module, exports) {

$parcel$export(module.exports, "Rotation", () => $fac6d25b97bebc75$export$9bdec6016cc824e2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");

var $bJeNF = parcelRequire("bJeNF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jkGAf = parcelRequire("jkGAf");

var $33w8t = parcelRequire("33w8t");
const $fac6d25b97bebc75$var$nameStyles = (0, $8CUq3.xcss)({
    marginTop: '0',
    marginRight: 'auto',
    marginBottom: '0',
    marginLeft: 'space.150',
    minWidth: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $fac6d25b97bebc75$var$optionStyles = (0, $8CUq3.xcss)({
    marginTop: '0',
    marginRight: 'space.050',
    marginBottom: '0',
    marginLeft: 'space.150',
    minWidth: '32px',
    maxWidth: '32px'
});
const $fac6d25b97bebc75$export$9bdec6016cc824e2 = ({ id: id, name: name, onClone: onClone, onDelete: onDelete, onEdit: onEdit, isDisabled: isDisabled })=>{
    const intlApi = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        title: name,
        xcss: $fac6d25b97bebc75$var$nameStyles
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $fac6d25b97bebc75$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                label: intlApi.formatMessage((0, $33w8t.messages).actionsForRotation, {
                    rotationName: name
                }),
                id: `${id}-rotation-options`,
                isDisabled: isDisabled,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                ref: triggerRef
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onEdit
    }, intlApi.formatMessage((0, $jkGAf.messages).edit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onClone
    }, intlApi.formatMessage((0, $jkGAf.messages).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onDelete
    }, intlApi.formatMessage((0, $jkGAf.messages).delete)))));
};

});
parcelRegister("33w8t", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c4130d2efe612fb0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c4130d2efe612fb0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actionsForRotation: {
        id: 'eoc-schedule.ui.list.edit-schedule.sidebar.list-rotation.actions-for-rotation.options',
        defaultMessage: 'Actions for rotation {rotationName}',
        description: 'Label of a button for opening rotation options dropdown'
    }
});

});


parcelRegister("88ENJ", function(module, exports) {

$parcel$export(module.exports, "RotationTitle", () => $56318019e90adab5$export$f0b55179e4adc90f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $56318019e90adab5$export$f0b55179e4adc90f = /*#__PURE__*/ (0, $bWGt6.default)("h4", {
    target: "emb35d60"
})({
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-100, 8px)"} 0`
});

});


parcelRegister("91QRC", function(module, exports) {

$parcel$export(module.exports, "DescriptionWrapper", () => $27cf1182e4d194d5$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "DescriptionReadView", () => $27cf1182e4d194d5$export$ac6bf204107c6e29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $27cf1182e4d194d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27cf1182e4d194d5$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1qkpx891"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $27cf1182e4d194d5$export$ac6bf204107c6e29 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1qkpx890"
})("color:", ({ isLoading: isLoading, isEmpty: isEmpty })=>{
    if (isEmpty || isLoading) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$fbae4efaa892d883})`;
    return `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`;
}, ";");

});



parcelRegister("5jsh9", function(module, exports) {

$parcel$export(module.exports, "Container", () => $fb49280482aa4337$export$42a852a2b6b56249);
$parcel$export(module.exports, "Content", () => $fb49280482aa4337$export$7c6e2c02157bb7d2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");

var $dY87H = parcelRequire("dY87H");

var $4zMWE = parcelRequire("4zMWE");

var $bWGt6 = parcelRequire("bWGt6");
const $fb49280482aa4337$var$TOP = (0, $k5uoT.gridSize)() * 3;
const $fb49280482aa4337$var$RIGHT = (0, $k5uoT.gridSize)() * 5;
const $fb49280482aa4337$var$BOTTOM = (0, $k5uoT.gridSize)() * 7; // TODO: ASK design actual value
const $fb49280482aa4337$var$LEFT = (0, $k5uoT.gridSize)() * 7;
const $fb49280482aa4337$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1afw03o1"
})({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${$fb49280482aa4337$var$TOP}px ${$fb49280482aa4337$var$RIGHT}px ${$fb49280482aa4337$var$BOTTOM}px ${$fb49280482aa4337$var$LEFT}px`,
    width: '100%'
});
const $fb49280482aa4337$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e1afw03o0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% - ${(0, $4zMWE.HEADER_HEIGHT) + $fb49280482aa4337$var$TOP + $fb49280482aa4337$var$BOTTOM}px)`
});

});


parcelRegister("k3iuD", function(module, exports) {

$parcel$export(module.exports, "EmptyImage", () => $4ed8a18d349e44e5$export$b38299ac7678de55);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");
const $4ed8a18d349e44e5$export$b38299ac7678de55 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "160",
        height: "160",
        viewBox: "0 0 570 372",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_1375_254)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "569.18",
        height: "371.12",
        transform: "translate(0 0.380859)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.1",
        d: "M240.23 361.701C259.267 361.701 274.7 359.185 274.7 356.081C274.7 352.977 259.267 350.461 240.23 350.461C221.193 350.461 205.76 352.977 205.76 356.081C205.76 359.185 221.193 361.701 240.23 361.701Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.1",
        d: "M42.5 363.901C64.6024 363.901 82.52 360.982 82.52 357.381C82.52 353.78 64.6024 350.861 42.5 350.861C20.3975 350.861 2.47998 353.78 2.47998 357.381C2.47998 360.982 20.3975 363.901 42.5 363.901Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.1",
        d: "M405.28 371.5C430.978 371.5 451.81 368.102 451.81 363.91C451.81 359.718 430.978 356.32 405.28 356.32C379.582 356.32 358.75 359.718 358.75 363.91C358.75 368.102 379.582 371.5 405.28 371.5Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.05",
        d: "M565.31 314.73H215.2L51.6201 341.01H494.75L565.88 322.44C568 322.12 569.45 320.14 569.13 318.02C568.85 316.13 567.22 314.73 565.31 314.73Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M224.39 319.611H530.37C532.75 319.741 534.78 317.921 534.91 315.541C534.94 314.991 534.87 314.451 534.69 313.931L443.41 28.4813C442.58 26.1213 440.35 24.5513 437.85 24.5313H131.88C129.5 24.3713 127.45 26.1813 127.3 28.5513C127.26 29.1113 127.34 29.6713 127.52 30.2113L218.84 315.651C219.66 318.021 221.89 319.601 224.39 319.611Z",
        fill: "url(#paint0_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M183.61 341.011H489.58C492.43 341.031 494.75 338.731 494.76 335.881C494.76 335.561 494.73 335.241 494.68 334.931L438.8 28.7711C438.35 26.3211 436.22 24.5311 433.72 24.5411H127.74C124.89 24.5411 122.58 26.8411 122.58 29.6911C122.58 30.0111 122.61 30.3211 122.67 30.6311L178.53 336.781C178.97 339.241 181.12 341.021 183.61 341.011Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M445.66 341.011H139.53C136.8 341.021 134.54 338.891 134.37 336.161L115.76 30.021C115.58 27.181 117.74 24.731 120.58 24.551C120.69 24.541 120.8 24.541 120.91 24.541H427.04C429.77 24.541 432.03 26.661 432.2 29.391L450.82 335.541C451 338.381 448.84 340.831 446 341.011C445.88 341.011 445.77 341.011 445.66 341.011Z",
        fill: "url(#paint1_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M401.67 341.011H95.5299C92.6799 341.021 90.3699 338.711 90.3599 335.861C90.3599 335.751 90.3599 335.641 90.3699 335.531L109.01 29.3813C109.17 26.6513 111.44 24.5313 114.17 24.5313H420.29C423.14 24.5213 425.45 26.8313 425.46 29.6813C425.46 29.7913 425.46 29.9013 425.45 30.0113L406.82 336.151C406.66 338.881 404.4 341.011 401.67 341.011Z",
        fill: "url(#paint2_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M357.59 341.011H51.62C48.77 341.011 46.46 338.711 46.46 335.861C46.46 335.551 46.49 335.241 46.54 334.931L102.35 28.7711C102.8 26.3211 104.93 24.5311 107.43 24.5411H413.46C416.31 24.5411 418.62 26.8411 418.62 29.6911C418.62 30.0111 418.59 30.3211 418.53 30.6311L362.67 336.781C362.22 339.231 360.08 341.011 357.59 341.011Z",
        fill: "url(#paint3_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M418.53 30.6318C419 28.1818 417.65 25.7418 415.32 24.8418L118.47 33.9818C115.97 33.9918 113.75 35.5718 112.91 37.9318L84.5599 126.532L47.6099 329.052H331.94C334.44 329.042 336.66 327.462 337.5 325.102L414.67 51.9518L418.53 30.6318Z",
        fill: "url(#paint4_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M313.05 319.611H7.07008C4.69007 319.771 2.64008 317.961 2.49008 315.591C2.45008 315.031 2.53008 314.471 2.71008 313.931L94.0201 28.4813C94.8501 26.1213 97.0801 24.5513 99.5801 24.5313H405.57C407.95 24.3713 410 26.1813 410.15 28.5513C410.19 29.1113 410.11 29.6713 409.93 30.2113L318.61 315.651C317.79 318.021 315.56 319.601 313.05 319.611Z",
        fill: "url(#paint5_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M405.57 24.5413H99.5898C97.0898 24.5513 94.8698 26.1313 94.0298 28.4913L80.5298 70.7313H396.99L409.94 30.2513C410.71 28.0013 409.51 25.5413 407.26 24.7713C406.72 24.5813 406.14 24.5013 405.57 24.5413Z",
        fill: "#FF7143"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M342.41 54.8809C346.828 54.8809 350.41 51.2991 350.41 46.8809C350.41 42.4626 346.828 38.8809 342.41 38.8809C337.992 38.8809 334.41 42.4626 334.41 46.8809C334.41 51.2991 337.992 54.8809 342.41 54.8809Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M366.55 24.5309H362.96C362.96 13.2009 353.74 3.97086 342.4 3.97086C331.06 3.97086 321.84 13.1909 321.84 24.5309H318.25C318.26 11.2109 329.09 0.380859 342.41 0.380859C355.73 0.380859 366.55 11.2109 366.55 24.5309Z",
        fill: "#EBECF0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M342.42 48.6715C329.11 48.6715 318.27 37.8415 318.27 24.5215H321.86C321.86 35.8515 331.08 45.0815 342.42 45.0815V48.6715Z",
        fill: "url(#paint6_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M240.79 54.8809C245.208 54.8809 248.79 51.2991 248.79 46.8809C248.79 42.4626 245.208 38.8809 240.79 38.8809C236.372 38.8809 232.79 42.4626 232.79 46.8809C232.79 51.2991 236.372 54.8809 240.79 54.8809Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M264.94 24.5309H261.35C261.35 13.2009 252.13 3.97086 240.79 3.97086C229.46 3.97086 220.23 13.1909 220.23 24.5309H216.64C216.65 11.2109 227.48 0.380859 240.8 0.380859C254.11 0.380859 264.94 11.2109 264.94 24.5309Z",
        fill: "#EBECF0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M240.79 48.6715C227.48 48.6715 216.64 37.8415 216.64 24.5215H220.23C220.23 35.8515 229.45 45.0815 240.79 45.0815V48.6715Z",
        fill: "url(#paint7_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M139.18 54.8809C143.598 54.8809 147.18 51.2991 147.18 46.8809C147.18 42.4626 143.598 38.8809 139.18 38.8809C134.762 38.8809 131.18 42.4626 131.18 46.8809C131.18 51.2991 134.762 54.8809 139.18 54.8809Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M163.29 24.5309H159.7C159.7 13.2009 150.48 3.97086 139.14 3.97086C127.8 3.97086 118.58 13.1909 118.58 24.5309H115C115 11.2109 125.83 0.380859 139.14 0.380859C152.45 0.380859 163.29 11.2109 163.29 24.5309Z",
        fill: "#EBECF0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M139.14 48.6715C132.7 48.6715 126.65 46.1715 122.09 41.6215C117.52 37.0715 115 31.0115 114.99 24.5615L118.58 24.5215C118.59 30.0415 120.73 35.2015 124.62 39.0815C128.5 42.9515 133.65 45.0815 139.13 45.0815C139.14 45.0815 139.15 45.0815 139.16 45.0815L139.17 48.6715C139.17 48.6715 139.16 48.6715 139.14 48.6715Z",
        fill: "url(#paint8_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M342.7 135.791L343.64 132.871H292.26L305.23 92.5215H302.31L289.34 132.871H251.67L264.62 92.5215H261.7L248.73 132.871H211.1L224.07 92.5215H221.15L208.17 132.871H170.5L183.48 92.5215H180.56L167.59 132.871H129.91L142.88 92.5215H139.96L126.99 132.871H86.6398L85.6698 135.791H126.02L113.92 173.451H73.5898L72.6498 176.371H113L100.9 214.041H60.5398L59.5998 216.961H99.9498L87.8498 254.631H47.4898L46.5498 257.551H86.8998L73.9298 297.901H76.8498L89.8198 257.551H127.48L114.51 297.901H117.43L130.4 257.551H168.06L155.09 297.901H158.01L170.98 257.551H208.64L195.71 297.901H198.63L211.6 257.551H249.26L236.29 297.901H239.21L252.18 257.551H303.52L304.46 254.631H253.11L265.21 216.971H316.58L317.52 214.051H266.15L278.25 176.391H329.62L330.56 173.471H279.19L291.27 135.791H342.7ZM247.81 135.791L235.72 173.451H198.03L210.16 135.791H247.81ZM197.1 176.381H234.76L222.66 214.041H184.99L197.1 176.381ZM182.06 214.041H144.4L156.5 176.381H194.16L182.06 214.041ZM207.22 135.791L195.12 173.451H157.45L169.55 135.791H207.22ZM128.98 135.791H166.64L154.54 173.451H116.87L128.98 135.791ZM115.93 176.381H153.59L141.48 214.041H103.82L115.93 176.381ZM90.7598 254.631L102.86 216.971H140.52L128.42 254.631H90.7598ZM131.35 254.631L143.46 216.961H181.12L169.03 254.631H131.35ZM171.94 254.631L184.04 216.971H221.7L209.6 254.631H171.94ZM250.19 254.631H212.52L224.6 216.961H262.26L250.19 254.631ZM263.24 214.041H225.57L237.67 176.381H275.33L263.24 214.041ZM276.29 173.451H238.62L250.72 135.791H288.38L276.29 173.451Z",
        fill: "url(#paint9_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.7",
        d: "M156.56 188.81L155.14 191.28C154.72 192.01 154.97 192.94 155.7 193.36C155.71 193.36 155.71 193.37 155.72 193.37L168.1 200.21C161.06 201.46 154.37 204.24 148.53 208.37C126.61 223.25 124.62 273.88 123.82 279.5C123.7 280.33 124.27 281.09 125.1 281.21C125.13 281.21 125.16 281.22 125.19 281.22L128.96 281.56C129.76 281.63 130.48 281.07 130.59 280.27C131.28 275.54 134.71 226.8 152.71 213.67C158.63 209.36 165.66 206.86 172.97 206.46L161.26 221.36C160.74 222.02 160.86 222.98 161.53 223.5L161.54 223.51L163.85 225.24C164.51 225.74 165.45 225.61 165.96 224.96L181.95 204.6C182.85 203.45 182.65 201.79 181.5 200.89C181.39 200.8 181.27 200.73 181.15 200.66L158.61 188.22C157.88 187.83 156.97 188.09 156.56 188.81Z",
        fill: "url(#paint10_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.7",
        d: "M351.39 155.471L351.73 152.141C351.83 151.171 351.13 150.301 350.16 150.201C350.15 150.201 350.13 150.201 350.12 150.201L333.66 148.791C340.75 144.321 346.6 138.121 350.65 130.781C359.13 115.281 356.37 100.161 354.57 93.8415C354.3 92.9015 353.33 92.3515 352.39 92.6215C352.36 92.6315 352.32 92.6415 352.29 92.6515L348.11 94.0815C347.23 94.3915 346.75 95.3315 347 96.2315C349.93 106.581 348.74 117.671 343.67 127.161C339.49 134.641 333.16 140.681 325.49 144.491L330.91 122.961C331.15 122.011 330.58 121.051 329.63 120.811C329.62 120.811 329.6 120.801 329.59 120.801L326.26 120.041C325.32 119.821 324.38 120.401 324.15 121.331L316.86 150.671C316.45 152.331 317.46 154.001 319.11 154.411C319.26 154.451 319.42 154.471 319.58 154.491L349.48 157.101C350.45 157.181 351.31 156.461 351.39 155.491C351.39 155.481 351.39 155.471 351.39 155.471Z",
        fill: "url(#paint11_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M247.51 238.051C233.19 238.111 219.65 231.541 210.83 220.271C203.26 210.661 200.49 198.111 203.31 186.201C206.56 172.261 216.9 159.391 231.7 150.891C246.08 142.631 261.8 140.231 272.72 144.631C279.28 147.281 284.48 152.481 288.17 160.101L281.97 163.681C278.9 157.341 274.69 153.051 269.47 150.951C260.5 147.341 246.76 149.571 234.47 156.631C221.62 164.011 212.67 175.021 209.93 186.851C207.58 196.971 209.98 207.611 216.44 215.751C224.12 225.591 235.91 231.331 248.39 231.311C268.27 231.311 293.34 214.061 299.15 186.271C304.21 162.071 290.04 139.591 266.17 134.031L268.55 127.441C295.52 133.751 311.53 159.251 305.78 186.751C300.62 211.401 276.88 238.021 247.46 238.051H247.51Z",
        fill: "#FF8F73"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M313.19 264.24L302.91 260.83C302.42 260.67 301.89 260.93 301.72 261.42L297.67 273.3C297.5 273.79 297.76 274.33 298.26 274.5L300.05 275.11C300.54 275.28 301.08 275.02 301.25 274.52L303.3 268.5L313.75 295.61C313.94 296.09 314.48 296.34 314.96 296.15L316.73 295.48C317.22 295.29 317.46 294.75 317.28 294.26L306.38 265.96L312 267.83C312.49 267.99 313.03 267.72 313.19 267.23L313.79 265.44C313.94 264.95 313.68 264.41 313.19 264.24Z",
        fill: "#FF8F73"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M286.6 245.93L276.99 240.95C276.53 240.71 275.96 240.89 275.72 241.35L269.86 252.46C269.62 252.92 269.79 253.49 270.26 253.74L271.93 254.62C272.39 254.86 272.96 254.69 273.21 254.22L276.18 248.58L279.51 264.4C279.62 264.91 280.11 265.24 280.62 265.13L282.47 264.74C282.98 264.63 283.31 264.14 283.2 263.63L279.64 246.56L284.9 249.28C285.36 249.52 285.93 249.35 286.18 248.88L287.05 247.2C287.28 246.73 287.09 246.17 286.63 245.93C286.62 245.93 286.61 245.93 286.6 245.93Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M311.71 222.68L300.92 223.66C300.4 223.71 300.02 224.16 300.06 224.68L301.1 237.19C301.14 237.71 301.6 238.1 302.12 238.06C302.12 238.06 302.12 238.06 302.13 238.06L304.01 237.9C304.53 237.86 304.92 237.4 304.88 236.88C304.88 236.88 304.88 236.88 304.88 236.87L304.35 230.52L315.64 242.08C316.01 242.45 316.61 242.45 316.97 242.08L318.33 240.76C318.7 240.39 318.7 239.79 318.33 239.43L306.1 226.95L312 226.42C312.52 226.37 312.9 225.92 312.86 225.4L312.69 223.52C312.63 223.02 312.21 222.66 311.71 222.68Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M178.67 181.09L186.65 173.77C187.04 173.42 187.07 172.82 186.72 172.44L178.3 163.13C177.95 162.74 177.35 162.71 176.97 163.06L175.57 164.33C175.18 164.68 175.15 165.28 175.5 165.66L179.77 170.38L163.79 168.03C163.28 167.93 162.78 168.27 162.69 168.78C162.69 168.8 162.68 168.81 162.68 168.83L162.4 170.7C162.3 171.21 162.64 171.71 163.15 171.8C163.17 171.8 163.18 171.81 163.2 171.81L180.46 174.33L176.09 178.33C175.71 178.68 175.68 179.28 176.03 179.66L177.31 181.05C177.66 181.44 178.26 181.47 178.64 181.11C178.65 181.11 178.66 181.1 178.67 181.09Z",
        fill: "#FF8F73"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M190.29 162.77L201.04 161.47C201.55 161.41 201.92 160.94 201.86 160.43L200.45 147.96C200.39 147.44 199.92 147.07 199.41 147.13L197.53 147.34C197.01 147.4 196.64 147.87 196.7 148.38L197.41 154.7L171.51 129.21C171.14 128.84 170.55 128.83 170.17 129.2L170.16 129.21L168.85 130.57C168.48 130.94 168.48 131.54 168.85 131.9L195.7 158.31L189.82 159.02C189.3 159.08 188.93 159.55 189 160.07L189.22 161.95C189.3 162.47 189.77 162.84 190.29 162.77Z",
        fill: "#FFE380"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M204.6 247.561C203.94 247.901 203.2 248.071 202.45 248.051L197.89 247.931L194.81 251.891C194.33 252.511 193.73 253.011 193.03 253.371C191.85 254.001 190.45 254.031 189.24 253.461C188.05 252.881 187.22 251.751 187.02 250.451L186.19 245.771L182 244.271C180.4 243.661 179.34 242.131 179.34 240.411C179.29 238.571 180.17 236.831 181.69 235.791L185.74 233.011L186.23 228.121C186.41 226.291 187.51 224.671 189.15 223.831C190.65 223.001 192.5 223.201 193.8 224.321L197.13 227.291L201.58 225.771C203.17 225.181 204.95 225.661 206.03 226.971C207.11 228.391 207.31 230.281 206.55 231.891L204.6 236.511L206.89 240.461C207.56 241.671 207.68 243.101 207.22 244.411C206.79 245.751 205.85 246.891 204.6 247.561Z",
        fill: "url(#paint12_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M205.13 244.632C204.47 244.972 203.73 245.142 202.98 245.122L198.42 245.002L195.34 248.962C194.86 249.582 194.26 250.082 193.56 250.442C192.38 251.072 190.98 251.102 189.77 250.532C188.58 249.952 187.75 248.822 187.55 247.522L186.72 242.842L182.53 241.342C180.93 240.732 179.87 239.202 179.87 237.482C179.82 235.642 180.7 233.902 182.22 232.862L186.27 230.082L186.76 225.192C186.94 223.362 188.04 221.742 189.68 220.902C191.18 220.072 193.03 220.272 194.33 221.392L197.66 224.362L202.11 222.842C203.7 222.252 205.48 222.732 206.56 224.042C207.64 225.462 207.84 227.352 207.08 228.962L205.09 233.572L207.38 237.522C208.05 238.732 208.17 240.162 207.71 241.472C207.3 242.802 206.37 243.942 205.13 244.632Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M192.51 223.661L196.87 227.541L202.75 225.551C203.64 225.261 204.59 225.741 204.88 226.621C205.03 227.081 204.98 227.581 204.73 228.001L202.13 234.041L205.13 239.211C205.65 240.241 205.24 241.501 204.21 242.021C203.94 242.161 203.64 242.231 203.34 242.251L197.38 242.091L193.35 247.271C192.86 248.071 191.82 248.311 191.03 247.831C190.62 247.581 190.34 247.171 190.25 246.701L189.14 240.581L183.65 238.611C182.7 238.131 182.31 236.971 182.79 236.011C182.96 235.681 183.21 235.401 183.53 235.221L188.82 231.591L189.46 225.201C189.48 224.141 190.36 223.291 191.42 223.321C191.81 223.311 192.19 223.441 192.51 223.661Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M315.54 196.7C314.87 196.37 314.3 195.89 313.86 195.29L311.21 191.56L306.2 191.48C305.43 191.47 304.67 191.28 303.98 190.95C302.78 190.38 301.91 189.29 301.63 187.98C301.4 186.68 301.82 185.36 302.74 184.42L305.99 180.94L304.62 176.69C304.14 175.04 304.73 173.27 306.1 172.24C307.54 171.09 309.47 170.75 311.21 171.34L315.86 172.9L320.06 170.35C321.63 169.4 323.58 169.31 325.24 170.11C326.8 170.81 327.76 172.41 327.64 174.11L327.27 178.56L331.18 181.24C332.61 182.15 333.3 183.87 332.9 185.52C332.4 187.22 331.01 188.5 329.28 188.85L324.4 190.04L322.62 194.24C322.06 195.5 320.99 196.46 319.67 196.87C318.34 197.37 316.85 197.31 315.54 196.7Z",
        fill: "url(#paint13_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M318.21 195.37C317.54 195.04 316.97 194.56 316.53 193.96L313.88 190.25L308.87 190.17C308.1 190.16 307.34 189.97 306.65 189.64C305.45 189.07 304.58 187.98 304.3 186.67C304.07 185.37 304.49 184.05 305.41 183.11L308.66 179.63L307.34 175.37C306.86 173.72 307.45 171.95 308.82 170.92C310.26 169.77 312.19 169.43 313.93 170.02L318.58 171.58L322.78 169.03C324.35 168.08 326.3 167.99 327.96 168.79C329.52 169.49 330.48 171.09 330.36 172.79L329.99 177.24L333.9 179.92C335.33 180.83 336.02 182.55 335.62 184.2C335.12 185.9 333.73 187.18 332 187.53L327.12 188.72L325.34 192.92C324.78 194.18 323.71 195.14 322.39 195.55C321.03 196.06 319.53 195.99 318.21 195.37Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M327.36 172.661L326.88 178.471L332 181.971C332.77 182.501 332.96 183.551 332.43 184.321C332.16 184.721 331.72 184.981 331.24 185.041L324.86 186.601L322.54 192.161C322.03 193.201 320.78 193.621 319.74 193.111C319.47 192.981 319.23 192.781 319.04 192.551L315.57 187.691L309.01 187.591C308.08 187.681 307.25 187.001 307.16 186.081C307.11 185.601 307.27 185.131 307.6 184.771L311.85 180.211L310.12 174.651C309.69 173.271 311.23 172.001 312.75 172.521L318.83 174.551L324.32 171.221C325.19 170.601 326.39 170.811 327 171.671C327.21 171.961 327.33 172.301 327.36 172.661Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M112.53 285.072L113.53 286.562L120.87 281.632L119.51 279.612C117.2 276.172 116.17 272.042 116.6 267.922V267.412C117.03 263.292 116 259.152 113.69 255.722L24.7698 123.452C20.5998 117.252 12.1898 115.602 5.98978 119.772C-0.210216 123.942 -1.86022 132.352 2.30978 138.552L90.9098 270.282C93.4398 274.042 97.3098 276.682 101.72 277.672C106.14 278.672 110 281.312 112.53 285.072Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M57.6101 220.731C57.7501 213.441 58.5101 203.721 59.0901 196.281C59.6901 188.501 60.2001 181.961 60.4301 176.421L53.5201 166.141C53.5901 174.611 52.6201 187.081 51.9401 195.731C51.5001 201.431 51.1301 206.401 50.8301 210.721L57.6101 220.731Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.8801 128.021C26.3801 167.341 29.8501 176.401 35.8701 177.581C41.2601 178.621 45.0301 172.221 49.0101 165.451C49.5501 164.531 50.2201 163.391 50.9101 162.281L46.5601 155.821C45.3301 157.581 44.1001 159.641 42.8301 161.821C41.3901 164.271 38.8801 168.541 37.2701 170.071C36.2601 168.091 34.3901 161.281 34.7601 138.281L27.8801 128.021Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M72.8799 194.891C66.6999 210.651 62.5999 219.341 59.9399 224.181L64.3899 230.741C67.5899 225.741 71.7999 217.001 77.7299 202.121L72.8799 194.891Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M120.74 291.591L122.96 288.361C123.27 287.911 123.27 287.321 122.96 286.871L119.88 282.291L114.65 285.811L118.53 291.581C118.93 292.191 119.75 292.371 120.36 291.971C120.51 291.871 120.64 291.741 120.74 291.591Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M326.27 234.901L324.9 236.011L330.31 242.771L332.17 241.281C335.33 238.751 339.29 237.401 343.34 237.481H343.84C347.89 237.561 351.85 236.211 355.01 233.681L476.74 136.141C482.45 131.571 483.37 123.231 478.8 117.521C478.8 117.521 478.8 117.521 478.8 117.511C474.23 111.801 465.89 110.881 460.18 115.451C460.18 115.451 460.18 115.451 460.17 115.451L338.93 212.671C335.48 215.431 333.21 219.411 332.59 223.781C331.98 228.161 329.72 232.141 326.27 234.901Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M384.55 176.081C391.67 175.621 401.22 175.561 408.55 175.511C416.16 175.511 422.61 175.391 428.03 175.201L437.5 167.611C429.24 168.371 416.99 168.441 408.5 168.501C402.94 168.501 398.02 168.581 393.78 168.681L384.55 176.081Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M472.57 139.521C434.08 141.281 425.52 145.411 424.88 151.381C424.3 156.731 430.85 159.871 437.78 163.211C438.72 163.671 439.88 164.221 441.03 164.801L446.98 160.031C445.16 158.921 443.05 157.941 440.82 156.871C438.31 155.671 433.94 153.541 432.32 152.141C434.18 151.031 440.67 148.611 463.13 147.081L472.57 139.521Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M410.97 188.88C395.09 184.13 386.25 180.86 381.34 178.65L375.3 183.48C380.45 186.19 389.32 189.58 404.32 194.18L410.97 188.88Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M320.6 243.481L323.93 245.411C324.39 245.681 324.97 245.631 325.39 245.301L329.61 241.971L325.74 237.121L320.43 241.381C319.88 241.841 319.81 242.651 320.26 243.201C320.36 243.311 320.47 243.411 320.6 243.481Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M298.17 124.08C297.81 123.51 297.37 123 296.85 122.57C298.21 121.99 299.24 120.82 299.65 119.4L304.63 102.22C305.58 98.98 303.71 95.59 300.47 94.64C297.23 93.69 293.84 95.56 292.89 98.8C292.81 99.07 292.75 99.34 292.71 99.61L290.02 117.29C289.8 118.75 290.25 120.24 291.24 121.34C288.97 121.97 287.24 123.81 286.74 126.11C285.99 129.49 288.11 132.83 291.49 133.59L292.07 133.69C295.51 134.14 298.67 131.72 299.13 128.27C299.32 126.81 299 125.33 298.21 124.08H298.17Z",
        fill: "url(#paint14_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M314.51 124.6C314.29 123.96 313.96 123.37 313.55 122.83C315.01 122.56 316.27 121.66 316.98 120.36L325.64 104.71C327.33 101.79 326.32 98.0504 323.4 96.3604C320.48 94.6704 316.74 95.6804 315.05 98.6004C314.88 98.8904 314.74 99.1904 314.63 99.5004L308.06 116.17C307.52 117.55 307.62 119.1 308.35 120.39C306 120.5 303.89 121.9 302.89 124.04C301.41 127.16 302.73 130.9 305.85 132.39L306.39 132.61C309.65 133.82 313.27 132.16 314.48 128.91C314.99 127.53 315.01 126.01 314.52 124.62L314.51 124.6Z",
        fill: "url(#paint15_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M45.9098 196.31C46.0098 197.02 45.9098 197.73 45.6298 198.39C45.1698 199.5 43.7298 202.84 42.6198 202.64C42.0898 202.52 41.8498 201.6 41.8098 201.14C41.7198 200.23 42.8498 199.68 42.9198 198.72C42.9098 198.52 42.9398 198.33 43.0098 198.14C43.1098 197.56 43.1498 197.25 43.2898 197.22C43.4198 197.19 43.7998 197.8 44.1998 197.79C44.8898 197.79 45.2198 195.57 45.5998 195.64C45.7898 195.59 45.8698 196.12 45.9098 196.31Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M39.4498 203.081C40.3498 203.921 42.6198 203.481 43.7198 202.141C44.3498 201.291 44.6098 200.211 44.4398 199.161C44.2998 198.051 43.8198 197.951 43.4498 196.811C42.6698 194.391 43.8398 192.361 43.2598 192.051C43.1198 191.991 42.8598 192.051 42.3398 192.511C42.2398 192.381 42.0898 192.311 41.9298 192.301C41.5598 192.301 41.3498 192.971 41.2498 193.271C40.5698 195.081 39.9998 196.941 39.5598 198.831C39.1298 201.391 38.9898 202.671 39.4498 203.081Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M39.6299 195.381C39.4299 196.171 39.3699 196.991 39.4699 197.801C39.4699 200.761 39.0799 202.651 39.3099 202.651C39.5399 202.651 39.6499 202.071 39.7699 201.741C40.6799 199.071 42.0899 193.451 41.2699 193.181C40.8499 193.031 39.9899 194.241 39.6299 195.381Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M30.2501 356.641L18.1401 354.061L19.7801 346.391L23.5001 348.271C23.5001 349.621 24.0101 350.921 24.9401 351.901C26.4701 353.381 28.5701 352.941 29.6701 354.591C30.0701 355.201 30.2701 355.921 30.2501 356.641Z",
        fill: "#162B4C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17.878 353.132L17.7021 353.953L30.2376 356.638L30.4134 355.816L17.878 353.132Z",
        fill: "#8893A5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M82.3399 355.651H68.6499V346.941L73.0999 347.131C73.5599 350.001 74.6599 351.181 75.5199 351.711C77.4399 352.921 79.6999 351.941 81.2999 353.531C81.8499 354.111 82.2199 354.851 82.3399 355.651Z",
        fill: "#162B4C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M82.6299 354.721H68.3799V355.651H82.6299V354.721Z",
        fill: "#8893A5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M55.7599 249.97C54.5299 249.02 53.5999 247.72 53.0999 246.25C51.6999 242.08 53.9499 237.56 58.1199 236.16C60.4799 235.37 63.0799 235.72 65.1399 237.13C66.5099 236.52 68.1199 237.13 68.7399 238.51C69.2099 239.56 68.9699 240.78 68.1399 241.58C68.1399 241.84 68.0999 242.11 68.0199 242.36C67.3199 245.15 65.5999 247.59 63.2099 249.18L55.7599 249.97Z",
        fill: "#27375C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M60.7102 257.44C58.0602 258.37 55.1102 257.86 52.9302 256.08C54.6602 253.97 55.6902 251.38 55.8802 248.66L62.3702 249.77L60.7102 257.44Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M68.1499 241.572C68.1199 242.532 68.1599 243.492 68.2699 244.442C68.3499 245.082 68.4399 245.552 68.4599 245.662C68.6699 246.772 68.9999 247.852 69.4399 248.892L67.8399 249.132L66.3399 254.122C64.1899 254.582 61.9699 254.602 59.8199 254.202C57.9999 253.842 56.1399 253.492 55.3699 252.082C55.1399 251.582 54.9699 251.052 54.8699 250.512C54.7799 250.182 54.6799 249.862 54.5599 249.542C54.4299 249.142 54.2199 248.582 53.9399 247.912C54.5599 248.282 55.2599 248.492 55.9699 248.532C56.6599 248.672 57.3799 248.522 57.9599 248.132C58.7599 247.372 58.1899 246.042 58.9199 245.682C59.2399 245.552 59.6199 245.592 59.8999 245.802C60.6899 246.402 60.3199 248.382 60.3199 248.382H61.7499C61.8399 247.492 62.1499 246.632 62.6499 245.882C63.4299 244.772 64.1299 244.772 64.6999 243.662C65.2699 242.552 64.8899 241.902 65.4299 241.442C65.9699 240.982 66.4999 240.932 68.1499 241.572Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M86.2702 228.741C86.2202 229.411 86.3602 230.071 86.6702 230.661C87.1802 231.641 88.7402 234.721 89.7702 234.421C90.2602 234.281 90.4102 233.401 90.4302 232.961C90.4302 232.101 89.3202 231.671 89.2202 230.741C89.2002 230.561 89.1702 230.381 89.1102 230.211C88.9802 229.671 88.9202 229.401 88.8002 229.381C88.6802 229.361 88.3702 229.961 88.0002 229.971C87.3602 229.971 86.8902 227.991 86.5402 228.071C86.3802 228.081 86.2802 228.571 86.2702 228.741Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M40.6099 276.83C39.3999 279.05 38.3199 281.38 37.2799 283.84C33.2899 293 30.6099 302.68 29.3199 312.59C27.8899 315.92 26.4999 319.41 25.1699 323.14C22.3099 331.29 20.1199 339.67 18.6299 348.18L25.1299 349.67L37.5899 315.87C38.2499 314.49 39.1999 312.42 40.3599 309.93C48.7499 291.76 49.5599 288.52 48.5999 285.23C48.0299 283.34 46.3899 279.95 40.6099 276.83Z",
        fill: "#FF5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M93.2998 234.701C92.4698 235.611 90.1798 235.321 88.9798 234.071C88.2798 233.261 87.9498 232.201 88.0498 231.141C88.1298 230.031 88.5798 229.931 88.8698 228.721C89.4798 226.301 88.1698 224.271 88.7298 223.961C88.8598 223.881 89.1298 223.961 89.6698 224.361C89.7598 224.231 89.8998 224.151 90.0598 224.131C90.4298 224.131 90.6898 224.761 90.8198 225.051C91.6298 226.811 92.3198 228.621 92.8898 230.461C93.4498 232.991 93.7198 234.261 93.2998 234.701Z",
        fill: "#8C715D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M57.1001 280.58C61.5301 291.23 65.2701 302.16 68.3001 313.29C71.4501 324.83 73.8401 336.57 75.4501 348.42H67.9601C66.8801 343.66 65.6401 338.73 64.2401 333.64C62.3201 326.68 60.2401 320.14 58.1001 313.98C47.5701 303.84 40.5301 295.24 38.4801 290.96C37.6901 289.33 36.2601 286.45 37.2701 283.69C37.4101 283.25 37.8101 282.48 38.5901 280.81C39.3701 279.14 40.0701 277.8 40.5201 276.9C45.8401 278.94 51.4401 280.14 57.1301 280.47L57.1001 280.58Z",
        fill: "#FF5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M66.29 256.611C60.8 256.121 55.57 254.011 51.27 250.551C47.91 247.711 45.24 244.141 43.49 240.101C41.73 236.321 40.72 232.241 40.49 228.091C41.48 222.901 42.35 217.431 43.08 211.671C43.43 208.941 43.72 206.271 43.97 203.651L38.41 200.621C37.2 204.931 36.19 209.511 35.15 214.341C34.04 219.741 33.16 224.921 32.48 229.811C33.17 236.711 35.17 243.411 38.39 249.551C40.28 253.131 42.57 256.491 45.23 259.551C44.47 262.141 43.57 264.901 42.46 267.761C41.11 271.211 39.58 274.591 37.87 277.871C43.32 283.041 50.98 285.181 58.32 283.561C59.25 281.271 60.15 278.801 61.01 276.151C62.11 272.801 63.02 269.391 63.73 265.941C66.67 266.261 69.64 266.181 72.55 265.701C75.66 265.181 80.87 264.311 85.23 260.421C88.86 257.231 90.08 253.551 91.61 249.141C93.34 244.141 94.16 238.871 94.03 233.581C93.33 233.261 92.57 233.111 91.81 233.141C90.79 233.171 89.8 233.511 88.98 234.121C87.69 241.301 84.99 248.161 81.03 254.291C76.52 256.721 71.33 257.571 66.28 256.711L66.29 256.611Z",
        fill: "#FF7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.2",
        d: "M305.11 152.641H233.91V227.611H305.11V152.641Z",
        fill: "url(#paint16_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M238.64 223.24L238.57 221.72L237.95 219.86V216.01C238.03 216 238.11 216 238.18 216.01C238.91 216.29 238.89 217.8 238.89 217.88L238.99 213.76C239.19 213.65 239.48 213.54 239.68 213.66C239.88 213.78 239.89 214.42 239.85 215.17C239.81 215.96 239.81 216.75 239.85 217.54L240.38 213.55C240.55 213.53 240.72 213.57 240.86 213.67C241.04 213.86 241.13 214.12 241.09 214.38C241.09 215.4 240.8 217.39 240.78 217.6L241.98 213.8C242.19 213.85 242.37 213.96 242.5 214.13C242.74 214.47 242.56 214.9 242.2 216.26C241.96 217.18 241.77 217.72 242.06 218.14C242.11 218.21 242.16 218.27 242.23 218.32C242.33 217.73 242.7 217.23 243.24 216.98C243.49 216.89 243.77 216.87 244.03 216.92C243.93 217.11 243.84 217.3 243.74 217.51C243.44 218.14 243.2 218.8 243.01 219.48L242.31 221.37V222.91L238.64 223.24Z",
        fill: "#ECC19C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M305.92 152.65C301.71 177.02 290.88 199.77 274.62 218.4H202.62C218.88 199.76 229.7 177.02 233.91 152.65H305.92Z",
        fill: "url(#paint17_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M295.35 122.201C294.99 121.631 294.55 121.121 294.03 120.691C295.39 120.111 296.42 118.941 296.83 117.521L301.79 100.331C302.74 97.0914 300.87 93.7014 297.63 92.7514C294.39 91.8014 291 93.6714 290.05 96.9114C289.97 97.1814 289.91 97.4513 289.87 97.7213L287.18 115.401C286.96 116.861 287.41 118.351 288.4 119.451C286.13 120.081 284.4 121.921 283.9 124.221C283.15 127.601 285.27 130.941 288.65 131.701L289.23 131.801C292.67 132.251 295.83 129.831 296.29 126.381C296.48 124.921 296.16 123.441 295.37 122.191L295.35 122.201Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M294.5 116.84L299.46 99.6499C300.02 97.6899 298.89 95.6399 296.92 95.0699C296.85 95.0499 296.77 95.0299 296.7 95.0099C294.7 94.5799 292.73 95.8399 292.3 97.8399C292.28 97.9199 292.27 97.9899 292.26 98.0699L289.57 115.75C289.37 117.07 290.23 118.32 291.54 118.61C292.84 118.89 294.13 118.12 294.5 116.84Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M286.25 124.732C285.78 126.792 287.07 128.852 289.14 129.322C289.26 129.352 289.39 129.372 289.51 129.392C291.63 129.752 293.64 128.332 294 126.212C294.36 124.092 292.94 122.082 290.82 121.722C288.72 121.302 286.68 122.642 286.25 124.732Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M312.86 122.102C312.7 121.442 312.45 120.822 312.09 120.242C313.57 120.122 314.91 119.352 315.76 118.142L325.99 103.462C327.93 100.702 327.26 96.8818 324.5 94.9418C321.74 93.0018 317.92 93.6718 315.98 96.4318C315.82 96.6618 315.68 96.9018 315.55 97.1418L307.31 113.022C306.63 114.342 306.58 115.882 307.17 117.242C304.82 117.112 302.58 118.292 301.37 120.312C299.58 123.262 300.51 127.112 303.46 128.912L303.97 129.192C307.09 130.722 310.86 129.442 312.39 126.322C313.04 125.002 313.2 123.502 312.86 122.082V122.102Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M313.79 116.77L324.02 102.09C325.19 100.41 324.78 98.1104 323.1 96.9404C323.04 96.9004 322.97 96.8504 322.91 96.8104C321.16 95.7604 318.88 96.3204 317.83 98.0704C317.79 98.1304 317.75 98.2004 317.72 98.2704L309.48 114.15C308.86 115.33 309.27 116.79 310.41 117.48C311.55 118.16 313.02 117.85 313.79 116.77Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M303.43 121.532C302.32 123.332 302.87 125.692 304.67 126.812C304.78 126.882 304.9 126.942 305.02 127.002C306.91 128.032 309.27 127.322 310.3 125.432C311.33 123.542 310.62 121.182 308.73 120.152C306.88 119.082 304.51 119.692 303.43 121.532Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M229.54 159.601C225.11 159.731 220.86 157.811 218.03 154.401C212.9 147.851 215.22 137.621 223.21 131.581C226.73 128.871 231.04 127.361 235.49 127.301C239.92 127.171 244.17 129.091 247 132.501C252.13 139.051 249.81 149.281 241.82 155.321C238.3 158.041 233.99 159.541 229.54 159.601Z",
        fill: "url(#paint18_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M229.54 156.381C225.11 156.511 220.86 154.591 218.03 151.181C212.9 144.631 215.22 134.401 223.21 128.361C226.73 125.651 231.04 124.141 235.49 124.081C239.93 123.961 244.18 125.891 247.02 129.311C252.15 135.861 249.83 146.091 241.84 152.131C238.3 154.841 233.99 156.331 229.54 156.381Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M240.28 150.121C233.61 155.151 224.72 154.811 220.45 149.351C216.18 143.891 218.1 135.381 224.77 130.331C231.44 125.281 240.33 125.641 244.6 131.101C248.87 136.561 246.94 145.091 240.28 150.121Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M231.38 135.221C230.77 135.771 229.84 135.731 229.27 135.141C228.84 134.461 229.04 133.551 229.73 133.121C230.34 132.571 231.27 132.611 231.84 133.201C232.27 133.881 232.07 134.781 231.38 135.221Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M239.05 144.51C238.44 145.06 237.51 145.02 236.94 144.43C236.51 143.75 236.71 142.84 237.4 142.41C238.01 141.86 238.94 141.9 239.51 142.49C239.94 143.17 239.74 144.07 239.05 144.51Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M226.03 137.57C225.37 139.86 225.83 142.33 227.26 144.24C228.79 146.09 231.09 147.14 233.5 147.1L226.03 137.57Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M417.57 271.881C418.86 274.331 420.12 276.911 421.3 279.661C425.71 289.821 428.66 300.551 430.08 311.541L440.42 351.011L434.66 352.651C431.13 339.801 426.51 327.271 420.86 315.211C420.08 313.601 419.32 311.941 417.79 308.631C408.53 288.481 407.58 284.891 408.65 281.251C409.35 279.091 411.16 275.331 417.57 271.881Z",
        fill: "url(#paint19_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M360 224.02C360.84 224.93 363.13 224.64 364.32 223.39C365.01 222.58 365.35 221.53 365.25 220.47C365.18 219.36 364.73 219.25 364.43 218.06C363.83 215.63 365.13 213.61 364.57 213.3C364.44 213.22 364.17 213.24 363.63 213.7C363.54 213.57 363.4 213.49 363.24 213.47C362.87 213.47 362.61 214.09 362.5 214.38C361.69 216.15 361 217.97 360.43 219.83C359.86 222.32 359.58 223.58 360 224.02Z",
        fill: "#926D5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M367.04 218.051C367.09 218.721 366.95 219.391 366.64 219.981C366.14 220.971 364.56 224.041 363.54 223.741C363.05 223.601 362.9 222.721 362.88 222.281C362.88 221.421 363.99 220.991 364.11 220.061C364.11 219.851 364.18 219.741 364.22 219.531C364.35 218.991 364.42 218.721 364.54 218.691C364.66 218.661 364.97 219.271 365.34 219.281C365.98 219.281 366.45 217.311 366.78 217.381C366.98 217.391 367.01 217.891 367.04 218.051Z",
        fill: "#926D5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M360.72 216.342C360.46 217.112 360.35 217.932 360.39 218.742C360.23 221.702 359.67 223.522 359.89 223.572C360.11 223.632 360.28 223.012 360.41 222.692C361.52 220.092 363.32 214.592 362.51 214.252C362.11 214.102 361.16 215.242 360.72 216.342Z",
        fill: "#926D5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M399.3 276.031C389.28 300.131 382.44 325.421 378.94 351.291L385.08 351.351C386.34 346.381 388.21 339.301 390.7 330.811C392.66 324.141 393.48 319.421 396.46 313.161C397.69 310.271 399.24 307.531 401.06 304.981C408.13 295.531 415.82 295.731 419.95 287.701C420.66 286.301 422.42 282.871 421.33 279.641C421.16 279.141 420.73 278.241 419.86 276.451C418.99 274.661 418.23 273.121 417.71 272.121C411.82 274.351 405.61 275.671 399.3 276.031Z",
        fill: "url(#paint20_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M378.84 346.891C378.6 349.141 378.17 351.371 377.56 353.561C376.8 356.301 374.5 358.331 371.69 358.751L366.39 359.541V360.461L374.64 362.451C375.4 362.311 377.53 361.951 377.82 362.611C377.89 362.751 377.89 363.001 377.59 363.411C378.33 363.571 379.1 363.701 379.9 363.821C380.7 363.941 381.47 363.471 381.72 362.711C382.83 359.161 386 349.551 386.17 348.181L378.84 346.891Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M433.38 349.461C433.77 350.241 434.49 352.311 435.2 354.381C436.21 357.411 435.3 360.751 432.9 362.851L430.07 365.331L430.49 366.061L437.8 363.531C438.31 363.051 439.77 361.731 440.32 362.091C440.44 362.171 440.55 362.361 440.53 362.821C441.53 362.431 442.56 362.001 443.61 361.501L443.87 360.881C443.76 360.561 443.63 360.161 443.48 359.691C442.15 355.511 440.31 348.291 439.66 346.891L433.38 349.461Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M409.6 193.371L408.64 192.191C407.84 191.211 407.51 189.921 407.74 188.681L407.84 186.021C408.45 185.471 409.02 184.871 409.54 184.231C410.23 183.401 410.51 182.901 410.65 182.951C410.79 183.011 410.83 183.631 410.14 186.281C411.67 185.621 413.16 184.861 414.59 183.991C416.56 182.801 418.17 181.561 419.25 182.071C419.38 182.141 419.82 182.341 419.87 182.711C419.93 183.091 419.37 183.541 419.33 183.581C419.54 183.581 419.85 183.751 419.94 183.981C420.03 184.211 419.55 184.861 419.18 185.171C417.65 186.511 413.79 189.151 412.84 189.791L413.04 191.291L409.6 193.371Z",
        fill: "#926D5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M389.1 249.45C394.78 247.5 400.34 245.24 405.77 242.68L406.54 242.04L406.72 241.88L406.91 241.71C410.32 238.68 413.09 231.86 413.09 231.86C414.58 228.19 415.87 224.43 416.97 220.62C415.77 217.61 414.82 214.51 414.11 211.35C412.71 205.06 412.9 201.08 410.09 195.95C409.42 194.72 408.64 193.56 407.78 192.46L413.23 189.91C415.15 191.98 416.89 194.21 418.43 196.58C422.12 202.26 424.65 208.62 425.87 215.29C426.18 224.39 424.2 233.43 420.11 241.56C418.08 245.55 415.55 249.26 412.57 252.61C412.56 255.02 412.77 257.42 413.2 259.79C414.07 264.45 415.78 268.92 418.25 272.97L397.75 279.52C399.47 275.76 399.42 273.23 398.8 271.75C397.42 268.42 393.74 267.84 392.38 263.85C391.95 262.55 391.82 261.16 392 259.8C389.42 260.03 378.56 260.71 369.09 253.13C355.46 242.22 357.42 224.38 357.56 223.29L364.86 225.02C364.54 228.82 364.94 232.65 366.05 236.3C369.43 246.02 380.36 252.07 389.1 249.45Z",
        fill: "url(#paint21_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M392.02 232C392.3 232.09 392.59 232.15 392.88 232.19C393.71 232.29 394.51 232.57 395.23 233C396.46 233.86 395.65 235.52 396.72 237.93C397 238.55 397.2 239.2 397.32 239.88C397.38 240.2 397.41 240.52 397.43 240.85C397.43 241.64 397.96 243.24 399.76 246.73L398.65 246.42L395.26 245.12C392.83 243.5 392.28 243.24 392.27 242.09C392.27 240.7 392.27 238.28 392.17 238.19C391.38 237.43 390.36 237.28 391.15 236.34C391.59 235.81 391.94 235.43 392.05 235.32C392.38 234.9 392.63 234.13 392.02 232Z",
        fill: "#926D5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M395.13 232.931C394.76 237.661 395.4 242.421 397 246.891L397.16 247.321C399.05 252.451 404.74 255.071 409.86 253.181C410.4 252.981 410.91 252.741 411.41 252.451L411.94 252.111L412.03 252.041C414.94 250.011 415.65 246.001 413.61 243.091C413.45 242.861 413.27 242.631 413.07 242.421C411.61 240.811 410.37 239.021 409.38 237.091C406.96 232.311 407.29 228.931 404.07 227.091C402 226.091 399.68 225.701 397.4 225.981C396.19 225.981 395.01 226.331 394 226.981C393.22 227.571 392.58 228.331 392.13 229.201C391.65 230.081 391.37 231.061 391.31 232.061C392.62 232.141 393.91 232.471 395.11 233.021L395.13 232.931Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M266.17 222.55L266.68 220.48L268.05 218.12L269.16 212.87C269.05 212.85 268.94 212.85 268.83 212.87C267.72 213.04 267.36 215.09 267.34 215.22L268.35 209.56C268.11 209.36 267.74 209.12 267.44 209.23C267.14 209.34 266.94 210.21 266.8 211.24C266.65 212.33 266.43 213.42 266.16 214.49L266.55 208.93C266.33 208.85 266.09 208.85 265.87 208.93C265.57 209.14 265.38 209.48 265.36 209.84C265.08 211.25 264.9 214.04 264.88 214.29L264.3 208.73C264.01 208.74 263.72 208.85 263.5 209.04C263.08 209.45 263.21 210.07 263.31 212.04C263.38 213.36 263.5 214.16 262.98 214.65C262.9 214.73 262.8 214.8 262.7 214.85C262.74 214.02 262.36 213.23 261.7 212.73C261.37 212.53 260.98 212.42 260.59 212.43C260.67 212.71 260.75 213.01 260.82 213.32C261.05 214.27 261.2 215.24 261.26 216.21L261.69 218.99L261.3 221.1L266.17 222.55Z",
        fill: "#F1DAD5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M223.73 247.78H231.6C230.4 244.98 230.1 241.87 230.76 238.89L225.96 238.66C225.9 238.94 225.82 239.35 225.67 239.84C225.6 240.32 225.42 240.78 225.15 241.17C224.61 241.68 223.56 241.38 223.25 241.28L223.73 247.78Z",
        fill: "url(#paint22_linear_1375_254)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M242.06 221.301C243.52 228.401 244.04 235.671 243.59 242.911C240.38 246.491 236.39 249.291 231.93 251.091C229.68 252.051 227.27 252.581 224.83 252.661C221.02 252.661 215.86 251.551 215.63 249.581C215.4 247.611 220.15 245.131 223.53 244.211C224.6 243.931 225.7 243.721 226.8 243.591C230.67 242.881 234.34 241.361 237.59 239.141L238.56 222.471L242.06 221.301Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M221.15 276.251C221.47 274.871 221.98 273.541 222.66 272.291C223.26 272.471 223.86 272.631 224.47 272.751C225.15 272.881 225.68 272.941 225.96 272.971C227.56 273.201 230.62 273.571 238.85 274.191C239.41 274.901 239.92 275.641 240.39 276.411C241.91 278.831 243.01 281.491 243.66 284.271C248.95 305.941 252.92 327.921 255.56 350.071C254.73 351.201 253.64 352.111 252.38 352.721C251.74 352.981 251.77 353.441 250.57 353.561C249.9 350.951 248.83 346.991 247.24 342.231C245.11 335.681 244.04 333.651 243.03 329.671C241.81 324.751 241.34 319.671 241.64 314.611C240.08 311.781 238.47 308.921 236.83 306.031C235.07 302.871 233.36 299.741 231.7 296.631C232.02 301.721 232.22 307.021 232.26 312.521C232.34 323.281 231.82 334.051 230.69 344.751C230.19 345.131 229.6 345.381 228.98 345.471C228.36 345.561 227.72 345.491 227.13 345.271C226.17 345.011 225.31 344.491 224.63 343.761C223.23 334.291 223.1 324.671 224.25 315.161C222.75 310.941 221.63 306.581 220.92 302.161C220.92 302.161 218.39 291.731 219.81 282.401C220.07 280.871 220.88 277.411 221.15 276.251Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M268.65 358.511L264.2 357.111C259.58 355.651 256.21 351.651 255.58 346.841C255.47 345.981 254.81 342.391 254.54 340.831C253.37 340.591 252.17 340.561 250.99 340.741C249.37 341.011 247.84 341.691 246.54 342.701C247.56 344.981 248.39 347.341 249 349.761C249.63 352.311 250.03 354.921 250.2 357.541C250.27 358.561 250.28 359.411 250.28 359.961H254.67L255.4 359.141L256.51 359.921H267.62L268.65 358.511Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M224.02 338.271C226.42 336.701 229.53 336.701 231.93 338.271C231.67 339.421 231.48 340.581 231.37 341.751C231.14 344.341 231.01 345.821 231.93 346.621C232.7 347.201 233.71 347.371 234.63 347.091L235.19 347.311C232.9 350.101 231.18 352.221 230.14 353.651C229.74 354.241 229.18 354.701 228.53 354.971C227.77 355.311 226.89 355.271 226.17 354.851C225.69 354.491 225.37 353.951 225.28 353.351L224.02 338.271Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M232.7 232.201C233.05 234.221 234.12 236.051 235.71 237.331L234.67 238.441L233.84 243.131C232.78 243.581 231.65 243.861 230.51 243.991C229.01 244.151 227.05 244.361 226.24 243.261C225.82 242.551 225.67 241.711 225.83 240.901C225.88 240.241 225.99 239.591 226.15 238.951C226.55 237.931 227.13 236.991 227.87 236.181C228.64 235.041 229.6 234.041 230.7 233.221C231.32 232.811 231.99 232.461 232.7 232.201Z",
        fill: "#ECC19C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M259.84 247.77C253.29 252 246.02 255.01 238.4 256.66C238.81 263.15 240.14 269.55 242.37 275.67C235.67 278.91 227.99 279.49 220.87 277.3C221.04 271.51 220.17 265.73 218.3 260.24C217.36 257.49 216.17 254.84 214.75 252.3C215.78 251.33 216.9 250.45 218.08 249.67C218.08 249.67 218.41 249.45 218.91 249.15C218.91 249.15 219.83 248.59 220.8 248.12C224.83 246.11 232.23 245.42 232.23 245.42C242.31 244.49 241.97 244.66 243.91 244.31C247.56 243.72 251.12 242.72 254.55 241.33L261.59 219.9L267.15 221.36C266.25 225.94 265.1 230.85 263.64 236.01C262.39 240.2 261.16 244.12 259.84 247.77Z",
        fill: "#505F79"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M217.32 236.312C214.31 241.772 212.22 241.482 211.67 244.772C211.19 247.702 212.2 251.852 215.45 253.592C219.13 255.572 223.16 253.132 223.39 252.992C224.98 251.952 226.21 250.442 226.91 248.672C228.76 244.342 226.07 242.362 228.02 239.132C228.79 237.842 229.56 237.572 232.4 233.882C233.02 233.182 233.41 232.312 233.51 231.382C233.54 230.312 233.18 229.262 232.5 228.432C230.84 226.372 227.91 226.482 227.02 226.532C225.19 226.622 223.42 227.262 221.95 228.362C219.36 230.322 219.59 232.202 217.32 236.312Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.7"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.7",
        d: "M239.45 173.381L284.65 173.591",
        stroke: "#0065FF",
        strokeWidth: "2.3634",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.7",
        d: "M236.36 180.891L281.55 181.101",
        stroke: "#0065FF",
        strokeWidth: "2.3634",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.7",
        d: "M233.48 187.881L268.15 188.041",
        stroke: "#0065FF",
        strokeWidth: "2.3634",
        strokeMiterlimit: "10"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint0_linear_1375_254",
        x1: "127.283",
        y1: "172.071",
        x2: "534.923",
        y2: "172.071",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.07",
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.36",
        stopColor: "#EEEFF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint1_linear_1375_254",
        x1: "131.217",
        y1: "334.842",
        x2: "435.36",
        y2: "30.71",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.7",
        stopColor: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint2_linear_1375_254",
        x1: "96.5282",
        y1: "344.156",
        x2: "419.294",
        y2: "21.4012",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.47",
        stopColor: "#CFD4DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#F7F8F9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint3_linear_1375_254",
        x1: "232.535",
        y1: "341.013",
        x2: "232.535",
        y2: "24.5389",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#EBECF0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.1",
        stopColor: "#EBECF0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint4_linear_1375_254",
        x1: "50.7816",
        y1: "355.938",
        x2: "400.121",
        y2: "6.59805",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.16",
        stopColor: "#F0F2F5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint5_linear_1375_254",
        x1: "31.8909",
        y1: "346.503",
        x2: "380.751",
        y2: "-2.35706",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.16",
        stopColor: "#F0F2F5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint6_linear_1375_254",
        x1: "318.272",
        y1: "36.6013",
        x2: "342.418",
        y2: "36.6013",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.37",
        stopColor: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.52",
        stopColor: "#E5E8EC",
        stopOpacity: "0.99"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.61",
        stopColor: "#E4E7EB",
        stopOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.68",
        stopColor: "#E3E6EA",
        stopOpacity: "0.89"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.74",
        stopColor: "#E1E4E9",
        stopOpacity: "0.81"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#DEE2E7",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.85",
        stopColor: "#DBDFE5",
        stopOpacity: "0.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.91",
        stopColor: "#D8DCE2",
        stopOpacity: "0.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.95",
        stopColor: "#D4D8DF",
        stopOpacity: "0.22"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#CFD4DB",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint7_linear_1375_254",
        x1: "216.641",
        y1: "36.6013",
        x2: "240.787",
        y2: "36.6013",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.37",
        stopColor: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.52",
        stopColor: "#E5E8EC",
        stopOpacity: "0.99"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.61",
        stopColor: "#E4E7EB",
        stopOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.68",
        stopColor: "#E3E6EA",
        stopOpacity: "0.89"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.74",
        stopColor: "#E1E4E9",
        stopOpacity: "0.81"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#DEE2E7",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.85",
        stopColor: "#DBDFE5",
        stopOpacity: "0.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.91",
        stopColor: "#D8DCE2",
        stopOpacity: "0.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.95",
        stopColor: "#D4D8DF",
        stopOpacity: "0.22"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#CFD4DB",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint8_linear_1375_254",
        x1: "115.027",
        y1: "36.6013",
        x2: "139.178",
        y2: "36.6013",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.37",
        stopColor: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.52",
        stopColor: "#E5E8EC",
        stopOpacity: "0.99"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.61",
        stopColor: "#E4E7EB",
        stopOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.68",
        stopColor: "#E3E6EA",
        stopOpacity: "0.89"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.74",
        stopColor: "#E1E4E9",
        stopOpacity: "0.81"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#DEE2E7",
        stopOpacity: "0.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.85",
        stopColor: "#DBDFE5",
        stopOpacity: "0.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.91",
        stopColor: "#D8DCE2",
        stopOpacity: "0.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.95",
        stopColor: "#D4D8DF",
        stopOpacity: "0.22"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#CFD4DB",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint9_linear_1375_254",
        x1: "46.5498",
        y1: "195.213",
        x2: "343.64",
        y2: "195.213",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.07",
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.36",
        stopColor: "#EEEFF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint10_linear_1375_254",
        x1: "123.802",
        y1: "234.803",
        x2: "182.51",
        y2: "234.803",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint11_linear_1375_254",
        x1: "316.721",
        y1: "124.824",
        x2: "356.442",
        y2: "124.824",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint12_linear_1375_254",
        x1: "179.368",
        y1: "240.263",
        x2: "208.086",
        y2: "236.093",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.07",
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.36",
        stopColor: "#EEEFF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint13_linear_1375_254",
        x1: "306.2",
        y1: "172.145",
        x2: "326.795",
        y2: "192.56",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.07",
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.36",
        stopColor: "#EEEFF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint14_linear_1375_254",
        x1: "286.567",
        y1: "114.064",
        x2: "304.848",
        y2: "114.064",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.07",
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.36",
        stopColor: "#EEEFF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint15_linear_1375_254",
        x1: "305.397",
        y1: "112.221",
        x2: "323.225",
        y2: "116.301",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.07",
        stopColor: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.36",
        stopColor: "#EEEFF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint16_linear_1375_254",
        x1: "269.507",
        y1: "227.611",
        x2: "269.507",
        y2: "152.644",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC",
        stopOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.46",
        stopColor: "#7A869A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint17_linear_1375_254",
        x1: "254.269",
        y1: "218.408",
        x2: "254.269",
        y2: "152.655",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.02",
        stopColor: "#0569FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.15",
        stopColor: "#1F7BFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.3",
        stopColor: "#3389FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.46",
        stopColor: "#4192FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.66",
        stopColor: "#4A98FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#4C9AFF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint18_linear_1375_254",
        x1: "215.295",
        y1: "143.453",
        x2: "249.73",
        y2: "143.453",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.12",
        stopColor: "#EBECEF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.26",
        stopColor: "#E2E4E7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.46",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint19_linear_1375_254",
        x1: "419.513",
        y1: "295.016",
        x2: "434.695",
        y2: "334.395",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.37",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.76",
        stopColor: "#4C9AFF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint20_linear_1375_254",
        x1: "400.309",
        y1: "351.338",
        x2: "400.309",
        y2: "272.103",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint21_linear_1375_254",
        x1: "391.632",
        y1: "279.526",
        x2: "391.632",
        y2: "189.922",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint22_linear_1375_254",
        x1: "231.595",
        y1: "243.221",
        x2: "223.248",
        y2: "243.221",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.38",
        stopColor: "#F1DBCB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#EFC7B0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_1375_254"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "569.18",
        height: "371.12",
        fill: "white",
        transform: "translate(0 0.380859)"
    }))));
};

});

parcelRegister("b3zjN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c745003ce3dfda1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9c745003ce3dfda1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addSchedule: {
        id: 'eoc-schedule.ui.list.add-schedule',
        defaultMessage: 'Add schedule',
        description: 'A button to create schedule.'
    },
    yourTeamSchedulesAppear: {
        id: 'eoc-schedule.ui.list.your-team-schedules-appear',
        defaultMessage: "Your team\u2019s schedules will appear here",
        description: 'Description for where schedules will appear .'
    },
    startBuildingSchedules: {
        id: 'eoc-schedule.ui.list.start-building-schedules',
        defaultMessage: 'Start building schedules to make sure somone is always on the call and responding to alerts.',
        description: 'Description of what schedule are used for.'
    },
    readMoreAboutSchedules: {
        id: 'eoc-schedule.ui.list.read-more-about-schedules',
        defaultMessage: 'Read more about on-call schedules',
        description: 'A link to read more about schedules.'
    },
    seeOnCallOnceAdmin: {
        id: 'eoc-schedule.ui.list.see-on-call-once-admin',
        defaultMessage: 'See who is on call in your team and when. Once your admin creates a schedule, it will appear here.',
        description: 'Explanation of what is the section used for and why can`t add schedule.'
    }
});

});

parcelRegister("36xgB", function(module, exports) {

$parcel$export(module.exports, "RevertOverride", () => $75145610135c5b59$export$11d1ea2721e3373d);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $jkGAf = parcelRequire("jkGAf");

var $9It5A = parcelRequire("9It5A");

var $9No0l = parcelRequire("9No0l");
const $75145610135c5b59$export$11d1ea2721e3373d = ({ onClose: onClose, alias: alias })=>{
    const intlApi = (0, $koVbs.default)();
    const [{ revertOverrideLoading: revertOverrideLoading }, { revertOverrideAction: revertOverrideAction }] = (0, $9It5A.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ()=>{
            revertOverrideAction({
                alias: alias
            });
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, intlApi.formatMessage((0, $9No0l.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, intlApi.formatMessage((0, $9No0l.messages).explanation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: onClose
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            autoFocus: true,
            appearance: "primary",
            isLoading: revertOverrideLoading,
            type: "submit"
        }, intlApi.formatMessage((0, $jkGAf.messages).remove))))));
};

});
parcelRegister("9No0l", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b253453e255bc567$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b253453e255bc567$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc-schedule.ui.list.revert-override.title',
        defaultMessage: 'Remove override?',
        description: 'Title for revert override modal.'
    },
    explanation: {
        id: 'eoc-schedule.ui.list.revert-override.explanation',
        defaultMessage: 'This will remove the override and restore the previous participant for the selected shift.',
        description: 'Explanation for revert override implications.'
    }
});

});


parcelRegister("4B2j7", function(module, exports) {

$parcel$export(module.exports, "Schedule", () => $5eb885b5bd7b2ff6$export$a74e4df6c6355a42);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $kIROY = parcelRequire("kIROY");

var $8J1d6 = parcelRequire("8J1d6");

var $8BDSK = parcelRequire("8BDSK");
var $ck74K = parcelRequire("ck74K");
var $jOikx = parcelRequire("jOikx");
var $pQkjl = parcelRequire("pQkjl");
var $4lizm = parcelRequire("4lizm");
var $5s9eT = parcelRequire("5s9eT");
var $cKHxL = parcelRequire("cKHxL");

var $eDnUx = parcelRequire("eDnUx");

var $9T6pk = parcelRequire("9T6pk");

var $dTe1P = parcelRequire("dTe1P");

var $4XJMJ = parcelRequire("4XJMJ");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $8MK6n = parcelRequire("8MK6n");

var $5verT = parcelRequire("5verT");

var $lCzwW = parcelRequire("lCzwW");

var $8aZjF = parcelRequire("8aZjF");

var $cey6J = parcelRequire("cey6J");

var $8rqUL = parcelRequire("8rqUL");

var $bcYv4 = parcelRequire("bcYv4");

var $eNzGG = parcelRequire("eNzGG");

var $1dNuT = parcelRequire("1dNuT");
const $5eb885b5bd7b2ff6$export$a74e4df6c6355a42 = ({ index: index })=>{
    const intlApi = (0, $koVbs.default)();
    const [{ selectedView: selectedView, currentDate: currentDate, timelineType: timelineType, timelineData: timelineData, calendarData: calendarData, schedule: schedule, getTimelineLoading: getTimelineLoading }] = (0, $9It5A.useStore)();
    const { preferedLayers: preferedLayers, layers: layers } = (0, $eDnUx.useLayers)({
        withForwarding: !(0, $lCzwW.isEmpty)(timelineData?.forwardingLayers)
    });
    const [{ nowEpoch: nowEpoch, startEpoch: startEpoch, endEpoch: endEpoch, startOffset: startOffset }] = (0, $3NQti.useTimelineEpoch)();
    const { onScheduleReady: onScheduleReady } = (0, $dTe1P.useActions)();
    const { isCollapsed: isCollapsed } = (0, $9T6pk.useCollapseUiPreference)({
        id: schedule.id
    });
    const { displayDensity: displayDensity } = (0, $9T6pk.useSectionUiPreferences)();
    const { toggleShowAllLayers: toggleShowAllLayers, showAllLayers: showAllLayers } = (0, $9T6pk.useLayersUiPreference)({
        id: schedule.id
    });
    const { isLoading: isResponderNamesLoading } = (0, $4XJMJ.useNamesLoading)();
    const isScheduleLoading = (0, $5uXOq.useMemo)(()=>getTimelineLoading || isResponderNamesLoading, [
        getTimelineLoading,
        isResponderNamesLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isScheduleLoading === false) onScheduleReady(schedule.id);
    }, [
        isScheduleLoading,
        onScheduleReady,
        schedule.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8J1d6.RuleCard), {
        value: schedule.id,
        title: schedule.name,
        headingAs: "h3",
        droppableId: "schedules",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cey6J.Header), {
            index: index
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNzGG.TimeZone), null, (0, $jOikx.formatTimezone)({
            name: schedule.timezone,
            offset: schedule.utcTimeOffsetMillis,
            variant: 'long'
        })),
        gap: `${10}px`,
        contentSpacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNzGG.Container), null, !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8aZjF.Controls), null), !isCollapsed && selectedView === (0, $5s9eT.NavigationMode).Timeline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, preferedLayers.map((layer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: `fragment-${layer.value}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNzGG.LayerName), null, layer.label), isScheduleLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKHxL.TimelineLoading), {
            variant: "full",
            size: displayDensity !== 'comfort' ? 'medium' : 'large',
            numberOfDays: (0, $5verT.getNumberOfDays)({
                timelineType: timelineType,
                currentDate: currentDate
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $pQkjl.Layer), {
            nowEpoch: nowEpoch,
            startEpoch: startEpoch,
            endEpoch: endEpoch,
            offset: startOffset,
            size: displayDensity !== 'comfort' ? 'medium' : 'large',
            variant: "full",
            rotationSlot: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIROY.default), null, (width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8MK6n.Container), {
                    key: `timeline-${layer.value}-${schedule.id}`,
                    scope: `timeline-${layer.value}-${schedule.id}`,
                    nowEpoch: nowEpoch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcYv4.RotationList), {
                    width: width ? width - ((0, $4lizm.SIDE_HEADER_WIDTH) + (0, $4lizm.LINE_WIDTH)) : 0,
                    nowEpoch: nowEpoch,
                    startEpoch: startEpoch,
                    endEpoch: endEpoch,
                    rotations: timelineData?.[layer.value] ?? [],
                    schedule: schedule,
                    layer: layer
                })))
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNzGG.ExpandViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "link",
        onClick: ()=>toggleShowAllLayers()
    }, intlApi.formatMessage(showAllLayers ? (0, $8rqUL.messages).showLessLayers : (0, $8rqUL.messages).showAllLayers)))), !isCollapsed && selectedView === (0, $5s9eT.NavigationMode).Calendar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNzGG.CalendarWrapper), null, isScheduleLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ck74K.CalendarLoading), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BDSK.Calendar), {
        nowEpoch: nowEpoch,
        startEpoch: startEpoch,
        offset: startOffset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kIROY.default), null, (width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8MK6n.Container), {
            key: `calendar-${layers.final.value}-${schedule.id}`,
            scope: `calendar-${layers.final.value}-${schedule.id}`,
            nowEpoch: nowEpoch
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dNuT.WeekList), {
            width: width ?? 0,
            nowEpoch: nowEpoch,
            offset: startOffset,
            weeks: calendarData?.finalWeeks ?? [],
            schedule: schedule,
            layer: layers.final
        })))))));
};

});
parcelRegister("8MK6n", function(module, exports) {

$parcel$export(module.exports, "Container", () => $7e0095db63bc329f$export$42a852a2b6b56249);
$parcel$export(module.exports, "useStore", () => $7e0095db63bc329f$export$6ccbb43953eebf8);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $5pvrp = parcelRequire("5pvrp");

var $7z7eo = parcelRequire("7z7eo");
const $7e0095db63bc329f$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $7z7eo.initialState,
    actions: $5pvrp.actions
});
const $7e0095db63bc329f$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($7e0095db63bc329f$export$6f57813fe9f31bf9);
const $7e0095db63bc329f$export$60959659b2c22881 = (0, $51nlc.createSubscriber)($7e0095db63bc329f$export$6f57813fe9f31bf9);
const $7e0095db63bc329f$export$6ccbb43953eebf8 = (0, $3sQ5x.createHook)($7e0095db63bc329f$export$6f57813fe9f31bf9);
const $7e0095db63bc329f$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($7e0095db63bc329f$export$6f57813fe9f31bf9);

});
parcelRegister("5pvrp", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dab0cdefd510645f$export$e324594224ef24da);

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5s9eT = parcelRequire("5s9eT");

var $kCCbe = parcelRequire("kCCbe");

var $3wjxB = parcelRequire("3wjxB");

var $5verT = parcelRequire("5verT");

var $g012e = parcelRequire("g012e");
const $dab0cdefd510645f$var$act = (action)=>({ setState: setState, getState: getState })=>{
        const status = getState().status;
        (0, $hmVmJ.assert)(status in (0, $g012e.ACTION_TRANSITION) && action in (0, $g012e.ACTION_TRANSITION)[status], new (0, $dH6Pi.AssertionError)('eoc-schedule', 'period-store: illegal state transition'));
        const nextStatus = (0, $g012e.ACTION_TRANSITION)[status][action];
        setState({
            status: nextStatus
        });
    };
/**
 * Clicks a period detail item
 * @param target Period detail item to click
 * @returns Whether the item was clicked
 */ const $dab0cdefd510645f$var$click = (target)=>({ setState: setState, getState: getState }, { nowEpoch: nowEpoch })=>{
        const { startEpoch: startEpoch, endEpoch: endEpoch, type: type } = target;
        const state = getState();
        // TODO: pass nowEpoch to shift store
        const nowLocation = (0, $5verT.getNowLocation)(startEpoch, endEpoch, nowEpoch);
        // If current card is target
        if ([
            (0, $kCCbe.ShiftStatus).Single,
            (0, $kCCbe.ShiftStatus).SingleOverriden,
            (0, $kCCbe.ShiftStatus).SingleViewOnly,
            (0, $kCCbe.ShiftStatus).SingleQuickOverride
        ].includes(state.status) && state.cards[0].id === target.id) {
            setState({
                status: (0, $kCCbe.ShiftStatus).Default,
                cards: []
            });
            return false;
        }
        // All past items or forwarding items are single view only
        if (nowLocation === (0, $3wjxB.NowLocation).After || type === (0, $5s9eT.PeriodType).Forwarding) {
            setState({
                status: (0, $kCCbe.ShiftStatus).SingleViewOnly,
                cards: [
                    target
                ]
            });
            return true;
        }
        // All overriden items that are not past are single overriden
        if (type === (0, $5s9eT.PeriodType).Override) {
            setState({
                status: (0, $kCCbe.ShiftStatus).SingleOverriden,
                cards: [
                    target
                ]
            });
            return true;
        }
        // All other items are single
        setState({
            status: (0, $kCCbe.ShiftStatus).Single,
            cards: [
                target
            ]
        });
        return true;
    };
/**
 * Selects a period detail item
 * @param target Period detail item to select
 * @returns Whether the item was Selected
 */ const $dab0cdefd510645f$var$select = (target)=>({ getState: getState, setState: setState }, { nowEpoch: nowEpoch })=>{
        const { startEpoch: startEpoch, endEpoch: endEpoch, type: type } = target;
        const state = getState();
        // TODO: pass nowEpoch to shift store
        const nowLocation = (0, $5verT.getNowLocation)(startEpoch, endEpoch, nowEpoch);
        // All past items, forwarding items, and overriden items are not selectable
        if (nowLocation === (0, $3wjxB.NowLocation).After || type === (0, $5s9eT.PeriodType).Forwarding || type === (0, $5s9eT.PeriodType).Override) return false;
        // Selected item already exists within cards then it should be removed
        if (state.cards.some((card)=>card.id === target.id)) {
            setState({
                status: state.cards.length > 1 ? state.status : (0, $kCCbe.ShiftStatus).Default,
                cards: state.cards.filter((card)=>card.id !== target.id)
            });
            return true;
        }
        // All other items are added to the selection
        setState({
            status: (0, $g012e.SELECT_TRANSITION)[state.status],
            cards: [
                ...state.cards,
                target
            ]
        });
        return true;
    };
const $dab0cdefd510645f$var$clear = ()=>({ setState: setState })=>{
        setState({
            status: (0, $kCCbe.ShiftStatus).Default,
            cards: []
        });
    };
const $dab0cdefd510645f$export$e324594224ef24da = {
    act: $dab0cdefd510645f$var$act,
    click: $dab0cdefd510645f$var$click,
    select: $dab0cdefd510645f$var$select,
    clear: $dab0cdefd510645f$var$clear
};

});
parcelRegister("g012e", function(module, exports) {

$parcel$export(module.exports, "ACTION_TRANSITION", () => $da75c4ab54787bf3$export$b441e7e6f35f61a8);
$parcel$export(module.exports, "SELECT_TRANSITION", () => $da75c4ab54787bf3$export$5292e32ac09cc88f);

var $kCCbe = parcelRequire("kCCbe");
const $da75c4ab54787bf3$export$b441e7e6f35f61a8 = {
    [(0, $kCCbe.ShiftStatus).Multi]: {
        [(0, $kCCbe.ShiftAction).AddOverride]: (0, $kCCbe.ShiftStatus).MultiQuickOverride
    },
    [(0, $kCCbe.ShiftStatus).MultiQuickOverride]: {
        [(0, $kCCbe.ShiftAction).Cancel]: (0, $kCCbe.ShiftStatus).Multi
    },
    [(0, $kCCbe.ShiftStatus).Single]: {
        [(0, $kCCbe.ShiftAction).AddOverride]: (0, $kCCbe.ShiftStatus).SingleQuickOverride
    },
    [(0, $kCCbe.ShiftStatus).SingleQuickOverride]: {
        [(0, $kCCbe.ShiftAction).Cancel]: (0, $kCCbe.ShiftStatus).Single
    }
};
const $da75c4ab54787bf3$export$5292e32ac09cc88f = {
    [(0, $kCCbe.ShiftStatus).Default]: (0, $kCCbe.ShiftStatus).Multi,
    [(0, $kCCbe.ShiftStatus).Multi]: (0, $kCCbe.ShiftStatus).Multi,
    [(0, $kCCbe.ShiftStatus).MultiQuickOverride]: (0, $kCCbe.ShiftStatus).MultiQuickOverride,
    [(0, $kCCbe.ShiftStatus).Single]: (0, $kCCbe.ShiftStatus).Multi,
    [(0, $kCCbe.ShiftStatus).SingleQuickOverride]: (0, $kCCbe.ShiftStatus).MultiQuickOverride
};

});


parcelRegister("7z7eo", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f15218ef08118c7d$export$d4c72bab9d6cc13a);

var $kCCbe = parcelRequire("kCCbe");
const $f15218ef08118c7d$export$d4c72bab9d6cc13a = {
    cards: [],
    status: (0, $kCCbe.ShiftStatus).Default
};

});


parcelRegister("8aZjF", function(module, exports) {

$parcel$export(module.exports, "Controls", () => $7d67fbcd3862d7ce$export$c7c44baae9d9f25f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $h8yj2 = parcelRequire("h8yj2");

var $jkGAf = parcelRequire("jkGAf");

var $1Ntyt = parcelRequire("1Ntyt");

var $d41OH = parcelRequire("d41OH");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $fcXSU = parcelRequire("fcXSU");

var $4TcVT = parcelRequire("4TcVT");
const $7d67fbcd3862d7ce$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'auto'
});
const $7d67fbcd3862d7ce$export$c7c44baae9d9f25f = ()=>{
    const intlApi = (0, $koVbs.default)();
    const [{ timelineType: timelineType, selectedView: selectedView, schedule: schedule }, { setTimelineTypeAction: setTimelineTypeAction, setSelectedViewAction: setSelectedViewAction, previousPeriodAction: previousPeriodAction, nextPeriodAction: nextPeriodAction, todayAction: todayAction }] = (0, $9It5A.useStore)();
    const [{ startEpoch: startEpoch, endEpoch: endEpoch, nowEpoch: nowEpoch, startOffset: startOffset, endOffset: endOffset, nowOffset: nowOffset }] = (0, $3NQti.useTimelineEpoch)();
    const [{ isLoading: isTimelineLoading }] = (0, $3NQti.useTimelineLoading)();
    const { openTakeOnCall: openTakeOnCall, openAddOverride: openAddOverride } = (0, $d41OH.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4TcVT.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        id: `${schedule.id}-add-override`,
        isLoading: isTimelineLoading,
        "aria-label": intlApi.formatMessage((0, $fcXSU.messages).addOverrideFor, {
            scheduleName: schedule.name
        }),
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'addOverride');
            openAddOverride({
                schedule: schedule,
                id: `${schedule.id}-add-override`
            });
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).addOverride)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d67fbcd3862d7ce$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        id: `${schedule.id}-take-on-call`,
        "aria-label": intlApi.formatMessage((0, $fcXSU.messages).takeOnCallFor, {
            scheduleName: schedule.name
        }),
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'takeOnCall');
            openTakeOnCall({
                schedule: schedule,
                id: `${schedule.id}-take-on-call`
            });
        }
    }, intlApi.formatMessage((0, $fcXSU.messages).takeOnCall))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Ntyt.DateNavigation), {
        endEpoch: endEpoch,
        isLoading: isTimelineLoading,
        nextPeriod: nextPeriodAction,
        nowEpoch: nowEpoch,
        onTimelineTypeChange: setTimelineTypeAction,
        onToday: todayAction,
        onViewChange: setSelectedViewAction,
        previousPeriod: previousPeriodAction,
        selectedTimelineType: timelineType,
        selectedView: selectedView,
        startEpoch: startEpoch,
        startOffset: startOffset,
        endOffset: endOffset,
        nowOffset: nowOffset,
        scheduleName: schedule.name
    }));
};

});
parcelRegister("fcXSU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3e6861334b46008e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3e6861334b46008e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    takeOnCall: {
        id: 'eoc-schedule.ui.list.schedule.controls.take-on-call',
        defaultMessage: 'Take on-call',
        description: 'Take on-call button.'
    },
    addOverrideFor: {
        id: 'eoc-schedule.ui.list.schedule.controls.add-override-for',
        defaultMessage: 'Add override for schedule {scheduleName}',
        description: 'Label for Add override for schedule button.'
    },
    takeOnCallFor: {
        id: 'eoc-schedule.ui.list.schedule.controls.take-on-call-for',
        defaultMessage: 'Take on-call for schedule {scheduleName}',
        description: 'Label for Take on-call for schedule button.'
    }
});

});

parcelRegister("4TcVT", function(module, exports) {

$parcel$export(module.exports, "Container", () => $70b8f0f68534fa87$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
const $70b8f0f68534fa87$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "enk39g30"
})({
    alignItems: 'center',
    display: 'flex',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"}`
});

});


parcelRegister("cey6J", function(module, exports) {

$parcel$export(module.exports, "Header", () => $7685105c20a601a8$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $lj8SI = parcelRequire("lj8SI");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");

var $h8yj2 = parcelRequire("h8yj2");

var $dY87H = parcelRequire("dY87H");

var $hem2I = parcelRequire("hem2I");

var $9YkY7 = parcelRequire("9YkY7");
var $5sA4Z = parcelRequire("5sA4Z");

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");

var $eDnUx = parcelRequire("eDnUx");

var $d41OH = parcelRequire("d41OH");

var $9T6pk = parcelRequire("9T6pk");

var $4XJMJ = parcelRequire("4XJMJ");

var $3NQti = parcelRequire("3NQti");

var $6RRyp = parcelRequire("6RRyp");

var $fFw4x = parcelRequire("fFw4x");

var $dxbEy = parcelRequire("dxbEy");
const $7685105c20a601a8$export$8b251419efc915eb = ({ index: index })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intlApi = (0, $koVbs.default)();
    const [schedule] = (0, $3NQti.useSchedule)();
    const [hasDeleted] = (0, $3NQti.useHasDeleted)();
    const { openEditMode: openEditMode, openDeleteSchedule: openDeleteSchedule, openCloneSchedule: openCloneSchedule } = (0, $d41OH.useActions)();
    const { isLoading: isExporting, exportTimeline: exportTimeline } = (0, $4XJMJ.useExportTimelineService)(schedule.id);
    const { partialUpdate: updateEnabled, isLoading: isEnabledLoading } = (0, $eDnUx.usePartialUpdateScheduleService)(schedule.id, 'enabled');
    const { isCollapsed: isCollapsed, toggleCollapsePreference: toggleCollapsePreference } = (0, $9T6pk.useCollapseUiPreference)({
        id: schedule.id
    });
    const { completeTask: completeTask } = (0, $4XJMJ.useCompleteTask)();
    const { data: scheduleRights } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const isSettingsLoading = isEnabledLoading || isExporting;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxbEy.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        columnGap: 1,
        justifyContent: "center"
    }, hasDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, intlApi.formatMessage((0, $9YkY7.messages).missingResponder)), !schedule.enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "moved"
    }, intlApi.formatMessage((0, $9YkY7.messages).off))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sA4Z.Wrap), {
                within: (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                        name: (0, $aSTVt.SPOTLIGHT_NAMES).firstScheduleActions
                    }, e),
                when: index === 0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInlineStart: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                id: schedule.id,
                isLoading: isSettingsLoading,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                label: intlApi.formatMessage((0, $fFw4x.messages).moreActionsForSchedule, {
                    scheduleName: schedule.name
                }),
                ref: triggerRef
            })))
    }, scheduleRights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'editSchedule');
            openEditMode({
                schedule: schedule,
                id: [
                    schedule.id,
                    'create-schedule-button'
                ]
            });
            completeTask();
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).edit)), scheduleRights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'cloneSchedule');
            openCloneSchedule({
                schedule: schedule,
                id: [
                    schedule.id,
                    'create-schedule-button'
                ]
            });
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'exportSchedule');
            exportTimeline();
        }
    }, intlApi.formatMessage((0, $fFw4x.messages).export)), schedule.enabled && scheduleRights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'disableSchedule');
            updateEnabled(false);
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).turnOff)), !schedule.enabled && scheduleRights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'enableSchedule');
            updateEnabled(true);
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).turnOn)), scheduleRights.hasDeleteRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'deleteSchedule');
            openDeleteSchedule({
                schedule: schedule,
                id: [
                    schedule.id,
                    'create-schedule-button'
                ]
            });
        }
    }, intlApi.formatMessage((0, $jkGAf.messages).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: toggleCollapsePreference
    }, isCollapsed ? intlApi.formatMessage((0, $fFw4x.messages).expand) : intlApi.formatMessage((0, $fFw4x.messages).collapse)))));
};

});
parcelRegister("fFw4x", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5371dcbcad162502$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5371dcbcad162502$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dragAndDropSchedule: {
        id: 'eoc-schedule.ui.list.schedule.header.drag-and-drop-schedule',
        defaultMessage: 'Drag and drop your schedule',
        description: 'An icon for dragging and dropping a schedule to change order.'
    },
    moreActionsForSchedule: {
        id: 'eoc-schedule.ui.list.schedule.header.more-actions-for-schedule',
        defaultMessage: 'More actions for schedule {scheduleName}',
        description: 'Schedule settings button.'
    },
    export: {
        id: 'eoc-schedule.ui.list.schedule.header.export',
        defaultMessage: 'Export',
        description: 'Button for exporting schedule.'
    },
    collapse: {
        id: 'eoc-schedule.ui.list.schedule.header.collapse',
        defaultMessage: 'Collapse',
        description: 'Label of collapse button'
    },
    expand: {
        id: 'eoc-schedule.ui.list.schedule.header.expand',
        defaultMessage: 'Expand',
        description: 'Label of expand button'
    }
});

});

parcelRegister("dxbEy", function(module, exports) {

$parcel$export(module.exports, "Container", () => $47728c11c8dc1749$export$42a852a2b6b56249);

var $bWGt6 = parcelRequire("bWGt6");
function $47728c11c8dc1749$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $47728c11c8dc1749$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ebh9vag0"
})({
    name: "127nx2r",
    styles: "flex:1 1 auto;display:flex;align-items:center;min-width:max-content"
});

});


parcelRegister("8rqUL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f0d9788b4a104360$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f0d9788b4a104360$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    showAllLayers: {
        id: 'eoc-schedule.ui.list.schedule.show-all-layers',
        defaultMessage: 'Show all layers',
        description: 'Button to show all layers of schedule.'
    },
    showLessLayers: {
        id: 'eoc-schedule.ui.list.schedule.show-less-layers',
        defaultMessage: 'Show less layers',
        description: 'Button to show less layers of schedule.'
    }
});

});

parcelRegister("bcYv4", function(module, exports) {

$parcel$export(module.exports, "RotationList", () => $c00fc3b959ca89d8$export$1a518033514482d5);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $i07hd = parcelRequire("i07hd");
var $3FhTI = parcelRequire("3FhTI");
var $5s9eT = parcelRequire("5s9eT");
var $dAkvd = parcelRequire("dAkvd");
var $jH8Xl = parcelRequire("jH8Xl");
var $5sA4Z = parcelRequire("5sA4Z");

var $aSTVt = parcelRequire("aSTVt");

var $9T6pk = parcelRequire("9T6pk");

var $hHWTd = parcelRequire("hHWTd");

var $7qhgx = parcelRequire("7qhgx");
const $c00fc3b959ca89d8$export$1a518033514482d5 = (props)=>{
    const { rotations: rotations, layer: layer, schedule: schedule, ...rest } = props;
    const { displayDensity: displayDensity } = (0, $9T6pk.useSectionUiPreferences)();
    const timeline = rest;
    const itemTable = (0, $5uXOq.useMemo)(()=>(0, $i07hd.fromRotationsToItemTable)(rotations), [
        rotations
    ]);
    const { tabbed: tabbed, focusRefs: focusRefs, onContainerKeyDown: onContainerKeyDown, makeOnClick: makeOnClick, makeOnHover: makeOnHover, makeOnClose: makeOnClose, makeOnCross: makeOnCross, activeSpotlight: activeSpotlight, activeShift: activeShift, selectedShifts: selectedShifts } = (0, $hHWTd.useShift)({
        schedule: schedule,
        items: itemTable,
        now: timeline.nowEpoch
    });
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // NOTE: might be re add later
        // role="table"
        // aria-label={layer.label}
        // aria-roledescription={intlApi.formatMessage(
        //   scheduleCommonMessages.timelineLayer,
        // )}
        onKeyDown: onContainerKeyDown
    }, rotations.map((rotation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAkvd.Rotation), {
            key: rotation.id,
            name: rotation.name,
            variant: "full",
            size: displayDensity !== 'comfort' ? 'medium' : 'large'
        }, rotation.periods.map((period)=>{
            const detail = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, period, {
                rotation: rotation
            });
            const onClick = makeOnClick(detail);
            const onHover = makeOnHover(detail);
            const onClose = makeOnClose(detail);
            const onCross = makeOnCross(detail);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
                key: period.id,
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qhgx.ActiveCard), {
                        onClose: onCross
                    }),
                isOpen: activeShift === period.id,
                onClose: onClose,
                placement: "bottom",
                zIndex: (0, $k5uoT.layers).navigation() + 1,
                trigger: ({ ref: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sA4Z.Wrap), {
                        within: (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                                name: (0, $aSTVt.SPOTLIGHT_NAMES).shiftTile
                            }, e),
                        when: activeSpotlight === period.id
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH8Xl.SimpleShiftTile), {
                        ref: (0, $3FhTI.mergeRefs)(triggerRef, focusRefs[period.id]),
                        onMouseEnter: onHover,
                        onClick: onClick,
                        period: period,
                        outerTimeFrame: timeline,
                        isSelected: selectedShifts[period.id],
                        isTabbable: tabbed?.id === period.id,
                        size: displayDensity !== 'comfort' ? 'medium' : 'large',
                        hasOverrideBorder: period.type === (0, $5s9eT.PeriodType).Override || period.type === (0, $5s9eT.PeriodType).Forwarding
                    }))
            });
        })))));
};

});
parcelRegister("hHWTd", function(module, exports) {

$parcel$export(module.exports, "useShift", () => $9c1189b5a5f1c1ab$export$909698cbccfc8fac);

var $5uXOq = parcelRequire("5uXOq");

var $bZWhc = parcelRequire("bZWhc");

var $cY2yS = parcelRequire("cY2yS");

var $aSTVt = parcelRequire("aSTVt");

var $bISE6 = parcelRequire("bISE6");

var $8MK6n = parcelRequire("8MK6n");
const $9c1189b5a5f1c1ab$var$focus = (refs)=>{
    while(Array.isArray(refs) && refs.length > 0){
        const ref = refs.shift();
        if (ref && ref.current && document.body.contains(ref.current)) {
            ref.current.focus();
            break;
        }
    }
};
const $9c1189b5a5f1c1ab$export$909698cbccfc8fac = ({ schedule: schedule, items: items, now: now })=>{
    const [isModalOpen] = (0, $bISE6.useShiftRelatedModalOpen)(schedule);
    const [isSpotlightTriggered, { trigger: trigger }] = (0, $cY2yS.useSpotlightTrigger)((0, $aSTVt.SPOTLIGHT_TOURS).shiftTile);
    const [{ cards: cards }, { click: click, select: select, clear: clear }] = (0, $8MK6n.useStore)();
    const { tab: tab, tabbed: tabbed, focusRefs: focusRefs, onContainerKeyDown: onContainerKeyDown } = (0, $bZWhc.useShiftFocus)(items, now);
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)();
    const activeShift = (0, $5uXOq.useMemo)(()=>{
        return cards.length >= 1 ? cards[cards.length - 1].id : undefined;
    }, [
        cards
    ]);
    const selectedShifts = (0, $5uXOq.useMemo)(()=>{
        return cards.reduce((acc, card)=>{
            acc[card.id] = true;
            return acc;
        }, {});
    }, [
        cards
    ]);
    const makeOnHover = (0, $5uXOq.useCallback)((card)=>()=>{
            // if spotlight tour hasn't rendered before, then it is the first and only valid target
            if (!isSpotlightTriggered) {
                setActiveSpotlight(card.id);
                trigger((0, $aSTVt.SPOTLIGHT_TOURS).shiftTile);
            }
        }, [
        isSpotlightTriggered,
        trigger
    ]);
    const makeOnClick = (0, $5uXOq.useCallback)((card)=>(e)=>{
            if (e.ctrlKey || e.metaKey) {
                if (select(card)) tab(card.id);
            } else if (click(card)) tab(card.id);
        }, [
        click,
        select,
        tab
    ]);
    // FIX: Find a workaround for this.
    // Problem is that updates occur in batches, so when we click on to some other shift,
    // first we get the click action, then we get the clear action. But as the clear action
    // is the final one, it overrides the click action.
    const makeOnClose = (0, $5uXOq.useCallback)((card)=>(e)=>{
            if (e.target instanceof HTMLElement) {
                const target = e.target.closest('[data-shift-id]');
                if (target && Object.values(focusRefs).some((ref)=>ref.current === target)) return;
            }
            if (isModalOpen) return;
            clear();
            window.setTimeout((refs)=>{
                $9c1189b5a5f1c1ab$var$focus(refs);
            }, 0, [
                focusRefs[card.id],
                {
                    current: document.getElementById(schedule.id)
                }
            ]);
        }, [
        clear,
        focusRefs,
        isModalOpen,
        schedule.id
    ]);
    const makeOnCross = (0, $5uXOq.useCallback)((card)=>()=>{
            clear();
            window.setTimeout((refs)=>{
                $9c1189b5a5f1c1ab$var$focus(refs);
            }, 0, [
                focusRefs[card.id],
                {
                    current: document.getElementById(schedule.id)
                }
            ]);
        }, [
        clear,
        focusRefs,
        schedule.id
    ]);
    return {
        tabbed: tabbed,
        focusRefs: focusRefs,
        onContainerKeyDown: onContainerKeyDown,
        makeOnClick: makeOnClick,
        makeOnHover: makeOnHover,
        makeOnClose: /** @description On implicit close, on other item click, on esc. etc. */ makeOnClose,
        makeOnCross: /** @description On explicit close, cross press etc. */ makeOnCross,
        activeSpotlight: activeSpotlight,
        activeShift: activeShift,
        selectedShifts: selectedShifts
    };
};

});
parcelRegister("cY2yS", function(module, exports) {

$parcel$export(module.exports, "useSpotlightTrigger", () => $b7a0e6fa60aec58b$export$a719dd02ee17ec0e);

var $3sQ5x = parcelRequire("3sQ5x");

var $j0DLp = parcelRequire("j0DLp");

var $1Uu4d = parcelRequire("1Uu4d");
const $b7a0e6fa60aec58b$export$a719dd02ee17ec0e = (0, $3sQ5x.createHook)((0, $j0DLp.store), {
    selector: (0, $1Uu4d.selectors).getTriggerStatus
});

});
parcelRegister("1Uu4d", function(module, exports) {

$parcel$export(module.exports, "selectors", () => $826a414323a7a57c$export$e1252723db1c541);

var $6dDSs = parcelRequire("6dDSs");
const $826a414323a7a57c$var$getTriggerStatus = (0, $6dDSs.createSelector)((state, _)=>state.spotlights, (_, id)=>id, (spotlights, id)=>{
    return spotlights?.[id] ?? false;
});
const $826a414323a7a57c$export$e1252723db1c541 = {
    getTriggerStatus: $826a414323a7a57c$var$getTriggerStatus
};

});


parcelRegister("bISE6", function(module, exports) {

$parcel$export(module.exports, "useShiftRelatedModalOpen", () => $6b55201045868df3$export$e38c7632594ffdae);

var $3sQ5x = parcelRequire("3sQ5x");

var $d41OH = parcelRequire("d41OH");

var $1jTdq = parcelRequire("1jTdq");
const $6b55201045868df3$export$e38c7632594ffdae = (0, $3sQ5x.createHook)((0, $d41OH.store), {
    selector: (0, $1jTdq.selectors).getShiftRelatedModalOpen
});

});
parcelRegister("1jTdq", function(module, exports) {

$parcel$export(module.exports, "selectors", () => $62c6cb43115ec6b6$export$e1252723db1c541);

var $6dDSs = parcelRequire("6dDSs");

var $lNHZW = parcelRequire("lNHZW");
const $62c6cb43115ec6b6$var$getShiftRelatedModalOpen = (0, $6dDSs.createSelector)((state, _)=>state.isAddOverrideOpen, (state, _)=>state.isRevertOverrideOpen, (state, _)=>state.activeSchedule, (state, _)=>state.overrideVariant, (_, schedule)=>schedule, (isAddOverrideOpen, isRevertOverrideOpen, activeSchedule, overrideVariant, schedule)=>{
    if (schedule?.id !== activeSchedule?.id) return false;
    if (isRevertOverrideOpen) return true;
    if (isAddOverrideOpen) {
        if (overrideVariant === (0, $lNHZW.OverrideVariant).Edit || overrideVariant === (0, $lNHZW.OverrideVariant).Customize) return true;
    }
    return false;
});
const $62c6cb43115ec6b6$export$e1252723db1c541 = {
    getShiftRelatedModalOpen: $62c6cb43115ec6b6$var$getShiftRelatedModalOpen
};

});



parcelRegister("7qhgx", function(module, exports) {

$parcel$export(module.exports, "ActiveCard", () => $69b8167faeda6c55$export$e5d1c95aa388eac5);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $hem2I = parcelRequire("hem2I");

var $cR6iS = parcelRequire("cR6iS");

var $kCCbe = parcelRequire("kCCbe");

var $6PbwB = parcelRequire("6PbwB");

var $3b8Xg = parcelRequire("3b8Xg");

var $b4Wih = parcelRequire("b4Wih");

var $9xaCz = parcelRequire("9xaCz");

var $6AEWc = parcelRequire("6AEWc");

var $d41OH = parcelRequire("d41OH");

var $9It5A = parcelRequire("9It5A");

var $3NQti = parcelRequire("3NQti");

var $8MK6n = parcelRequire("8MK6n");

var $6RRyp = parcelRequire("6RRyp");

var $cWVZo = parcelRequire("cWVZo");
const $69b8167faeda6c55$export$e5d1c95aa388eac5 = (props)=>{
    const { onClose: onClose } = props;
    const { data: scheduleRights } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const [{ cards: cards, status: status }, { act: act }] = (0, $8MK6n.useStore)();
    const [outer] = (0, $3NQti.useTimelineEpoch)();
    const [schedule] = (0, $3NQti.useSchedule)();
    const { openCustomizeOverride: openCustomizeOverride, openEditOverride: openEditOverride, openRevertOverride: openRevertOverride } = (0, $d41OH.useActions)();
    const { addOverrideAction: addOverrideAction, addOverrideBulkAction: addOverrideBulkAction, getOverrideAction: getOverrideAction } = (0, $9It5A.useActions)();
    const single = cards[0];
    if (status === (0, $kCCbe.ShiftStatus).SingleViewOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR6iS.SingleViewShiftCard), {
        cards: cards,
        onClose: onClose
    });
    if (status === (0, $kCCbe.ShiftStatus).Single) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b4Wih.SingleShiftCard), {
        cards: cards,
        onClose: onClose,
        onQuickOverride: ()=>act((0, $kCCbe.ShiftAction).AddOverride)
    });
    if (status === (0, $kCCbe.ShiftStatus).SingleQuickOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6AEWc.SingleQuickOverrideShiftCard), {
        cards: [
            {
                ...single,
                ...(0, $cWVZo.normalizeRange)(single, outer)
            }
        ],
        onClose: onClose,
        onCancel: ()=>act((0, $kCCbe.ShiftAction).Cancel),
        isDisabled: !scheduleRights.hasEditRight,
        onAddOverride: async (autoCompleteItem)=>{
            const responder = {
                id: autoCompleteItem.atlassianIdentifier,
                type: autoCompleteItem.type
            };
            const range = (0, $cWVZo.normalizeRange)(single, outer);
            await addOverrideAction({
                startTime: (0, $cWVZo.makeTime)(range.startEpoch, range.startOffset),
                endTime: (0, $cWVZo.makeTime)(range.endEpoch, range.endOffset),
                timezone: schedule.timezone,
                rotationIds: [
                    single.rotation.id
                ],
                responder: responder
            });
            onClose();
        },
        onCustomize: (autoCompleteItem)=>{
            const responder = autoCompleteItem ? {
                id: autoCompleteItem.value,
                type: autoCompleteItem.type
            } : undefined;
            const range = (0, $cWVZo.normalizeRange)(single, outer);
            const override = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, range, {
                rotations: [
                    single.rotation
                ],
                responder: responder
            });
            const context = {
                scheduleId: schedule.id
            };
            openCustomizeOverride({
                override: override,
                context: context,
                id: [
                    'customize-override-button',
                    schedule.id
                ]
            });
        }
    });
    if (status === (0, $kCCbe.ShiftStatus).SingleOverriden) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xaCz.SingleOverridenShiftCard), {
        cards: cards,
        onClose: onClose,
        onRevert: async ()=>{
            const object = await getOverrideAction({
                alias: single.alias
            });
            const { startTimeUtcMillis: startEpoch, endTimeUtcMillis: endEpoch, startOffsetMillis: startOffset, endOffsetMillis: endOffset, rotationIds: rotationIds, responder: responder } = object;
            const range = (0, $cWVZo.normalizeRange)({
                startEpoch: startEpoch,
                endEpoch: endEpoch,
                startOffset: startOffset,
                endOffset: endOffset
            }, outer);
            const override = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, range, {
                alias: single.alias,
                rotations: rotationIds.map((value)=>({
                        id: value
                    })),
                responder: responder
            });
            const context = {
                scheduleId: schedule.id
            };
            openRevertOverride({
                override: override,
                context: context,
                id: [
                    'revert-override-button',
                    schedule.id
                ]
            });
        },
        onEdit: async ()=>{
            const object = await getOverrideAction({
                alias: single.alias
            });
            const { startTimeUtcMillis: startEpoch, endTimeUtcMillis: endEpoch, startOffsetMillis: startOffset, endOffsetMillis: endOffset, rotationIds: rotationIds, responder: responder } = object;
            const range = (0, $cWVZo.normalizeRange)({
                startEpoch: startEpoch,
                endEpoch: endEpoch,
                startOffset: startOffset,
                endOffset: endOffset
            }, outer);
            const override = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, range, {
                alias: single.alias,
                rotations: rotationIds.map((value)=>({
                        id: value
                    })),
                responder: responder
            });
            const context = {
                scheduleId: schedule.id
            };
            openEditOverride({
                override: override,
                context: context,
                id: [
                    'edit-override-button',
                    schedule.id
                ]
            });
        }
    });
    if (status === (0, $kCCbe.ShiftStatus).Multi) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PbwB.MultiShiftCard), {
        cards: cards,
        onClose: onClose,
        onQuickOverride: ()=>act((0, $kCCbe.ShiftAction).AddOverride)
    });
    if (status === (0, $kCCbe.ShiftStatus).MultiQuickOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3b8Xg.MultiQuickOverrideShiftCard), {
        cards: cards,
        onClose: onClose,
        onCancel: ()=>act((0, $kCCbe.ShiftAction).Cancel),
        isDisabled: !scheduleRights.hasEditRight,
        onAddOverride: async (autoCompleteItem)=>{
            const responder = {
                id: autoCompleteItem.atlassianIdentifier,
                type: autoCompleteItem.type
            };
            await addOverrideBulkAction({
                overrides: cards.map((period)=>{
                    const range = (0, $cWVZo.normalizeRange)(period, outer);
                    return {
                        startTime: (0, $cWVZo.makeTime)(range.startEpoch, range.startOffset),
                        endTime: (0, $cWVZo.makeTime)(range.endEpoch, range.endOffset),
                        timezone: schedule.timezone,
                        rotationIds: [
                            period.rotation.id
                        ],
                        responder: responder
                    };
                })
            });
            onClose();
        }
    });
    return null;
};

});
parcelRegister("6PbwB", function(module, exports) {

$parcel$export(module.exports, "MultiShiftCard", () => $410df507bfd23921$export$f151893de9425621);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $l1N8i = parcelRequire("l1N8i");

var $luBm6 = parcelRequire("luBm6");

var $6UXEc = parcelRequire("6UXEc");

var $h8yj2 = parcelRequire("h8yj2");

var $legSc = parcelRequire("legSc");
var $80MT9 = parcelRequire("80MT9");
var $lejk3 = parcelRequire("lejk3");

var $jkGAf = parcelRequire("jkGAf");

var $9Ss6R = parcelRequire("9Ss6R");
const $410df507bfd23921$export$f151893de9425621 = ({ cards: cards, onClose: onClose, onQuickOverride: onQuickOverride })=>{
    const intlApi = (0, $koVbs.default)();
    const responders = (0, $5uXOq.useMemo)(()=>Object.values(cards.reduce((acc, { responder: responder })=>acc[responder.id] ? acc : {
                ...acc,
                [responder.id]: responder
            }, {})), [
        cards
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $legSc.Card), {
        role: "dialog",
        "aria-labelledby": "shift-card-title",
        controls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CloseButton), {
            onClick: onClose
        }),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            id: "shift-card-title",
            as: "h5",
            size: "xxsmall"
        }, intlApi.formatMessage((0, $jkGAf.messages).selectionCount, {
            count: cards.length
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, responders.map((responder)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ss6R.ResponderTag), {
                responder: responder,
                key: responder.id
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lejk3.Footer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.OverrideButton), {
            onClick: (_, analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'bulkOverride');
                onQuickOverride();
            }
        })))
    });
};

});
parcelRegister("6UXEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2d1dcb54418fac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2c2d1dcb54418fac$var$baseStyles = null;
const $2c2d1dcb54418fac$var$justifyStartStyles = null;
const $2c2d1dcb54418fac$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $2c2d1dcb54418fac$var$TagGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ])
    }, children);
});
var $2c2d1dcb54418fac$export$2e2bcd8739ae039 = $2c2d1dcb54418fac$var$TagGroup;

});

parcelRegister("lejk3", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $66c6d3c0fa43964b$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $66c6d3c0fa43964b$var$flexStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $66c6d3c0fa43964b$export$a06f1c675e846f6f = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "end",
        columnGap: "space.050",
        xcss: $66c6d3c0fa43964b$var$flexStyles
    }, children);

});

parcelRegister("9Ss6R", function(module, exports) {

$parcel$export(module.exports, "ResponderTag", () => $4406b8db44b9b897$export$960eb9c07861828c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $9laXL = parcelRequire("9laXL");

var $8k22Y = parcelRequire("8k22Y");
var $fXc9u = parcelRequire("fXc9u");

var $cP0uo = parcelRequire("cP0uo");

var $cNMw5 = parcelRequire("cNMw5");
const $4406b8db44b9b897$export$960eb9c07861828c = ({ responder: responder })=>{
    const intlApi = (0, $koVbs.default)();
    const [user] = (0, $fXc9u.useResponderNames)((0, $cP0uo.filterNoOne)([
        responder
    ]));
    // TODO: handle error and loading. See: TARDIS-7446
    const { name: name } = (0, $cNMw5.getResponder)(responder, user, intlApi);
    const isNoOne = responder.type === 'noone';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9laXL.default), {
        text: name,
        appearance: "rounded",
        isRemovable: false,
        elemBefore: isNoOne ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
            appearance: "circle",
            size: "xsmall",
            responder: user
        })
    });
};

});
parcelRegister("9laXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63a49f20b6f0a05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $c543i = parcelRequire("c543i");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $35XSW = parcelRequire("35XSW");
var $lM16U = parcelRequire("lM16U");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");

var $2hnSR = parcelRequire("2hnSR");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");

var $frUcV = parcelRequire("frUcV");
var $d63a49f20b6f0a05$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($d63a49f20b6f0a05$var$TagStatus || {});
const $d63a49f20b6f0a05$var$packageName = "platform-pkg";
const $d63a49f20b6f0a05$var$packageVersion = "0.0.0-use.local";
const $d63a49f20b6f0a05$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $d63a49f20b6f0a05$var$removingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        boxShadow: `0 0 0 2px transparent`,
        outline: 'none'
    }
});
const $d63a49f20b6f0a05$var$RemovableTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $d63a49f20b6f0a05$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $eGmKJ.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $5uXOq.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $5uXOq.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $c543i.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $d63a49f20b6f0a05$var$packageName,
            packageVersion: $d63a49f20b6f0a05$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $5uXOq.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $5uXOq.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $5uXOq.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $5uXOq.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $frUcV.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [(0, $e6s40.cssVar).color.background.hover]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalHoverBackgroundColors,
        // Tag background color on press
        [(0, $e6s40.cssVar).color.background.active]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalActiveBackgroundColors,
        // The tag text on hover of remove button
        [(0, $e6s40.cssVar).color.text.default]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalTextColors,
        // 'elemBefore' text on press of remove button
        [(0, $e6s40.cssVar).color.text.active]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalTextColors,
        // The tag link text on hover of remove button
        [(0, $e6s40.cssVar).color.text.link]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalTextColors
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $35XSW.default), null, !(status === "removed") && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lM16U.default), null, (motion)=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5oSQr.default), {
            ref: (0, $5JjdN.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            css: [
                status === "removing" && $d63a49f20b6f0a05$var$removingStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aXLIT.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $d63a49f20b6f0a05$var$RemovableTag = /*#__PURE__*/ (0, $5uXOq.memo)($d63a49f20b6f0a05$var$RemovableTagComponent);
var $d63a49f20b6f0a05$export$2e2bcd8739ae039 = $d63a49f20b6f0a05$var$RemovableTag;

});
parcelRegister("lM16U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c624c149830103aa$export$2e2bcd8739ae039);


var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $35XSW = parcelRequire("35XSW");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $c624c149830103aa$var$ShrinkOut = ({ children: children, duration: duration = (0, $lObw7.smallDurationMs), onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    const exiting = (0, $35XSW.useExitingPersistence)();
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    const setTimeout = (0, $bh8Xz.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $fsENI.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: (0, $eba99f58997c09b3$export$929e5a82286172a6),
                        transitionDuration: `${duration}ms`,
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, duration);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $c624c149830103aa$export$2e2bcd8739ae039 = $c624c149830103aa$var$ShrinkOut;

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("e6s40", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $1dd8b7ac532261be$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $1dd8b7ac532261be$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $1dd8b7ac532261be$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $1dd8b7ac532261be$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $1dd8b7ac532261be$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $1dd8b7ac532261be$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $1dd8b7ac532261be$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $1dd8b7ac532261be$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $1dd8b7ac532261be$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $1dd8b7ac532261be$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $1dd8b7ac532261be$var$gridSizeValue = (0, $k5uoT.gridSize)();
const $1dd8b7ac532261be$var$borderRadiusValue = (0, $k5uoT.borderRadius)();
const $1dd8b7ac532261be$var$tagHeightUnitless = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$var$tagHeightUnitless}px`})`;
const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$var$tagHeightUnitless; // button should be square
const $1dd8b7ac532261be$var$maxWidthUnitless = 25 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$var$maxWidthUnitless - $1dd8b7ac532261be$var$tagHeightUnitless;
const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $5b444d8505b9cc3c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $e6s40 = parcelRequire("e6s40");
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
    default: (0, $e6s40.defaultBorderRadius),
    rounded: (0, $e6s40.defaultRoundedBorderRadius)
};
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};

});

parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");

var $2hnSR = parcelRequire("2hnSR");
function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $e6s40.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.default})`,
    cursor: 'default'
});
const $db35d9df42c66ff0$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $e6s40.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.active})`
    }
});
const $db35d9df42c66ff0$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $e6s40.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $db35d9df42c66ff0$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$2hnSR.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`
    }
});
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $2hnSR.textColors['standardLink'] : $2hnSR.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
            isInteractive && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.borderColor]: $2hnSR.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.default]: $2hnSR.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.hover]: $2hnSR.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.active]: $2hnSR.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.default]: $2hnSR.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.focusRing]: $2hnSR.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.default]: $2hnSR.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.hover]: $2hnSR.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).borderRadius]: $2hnSR.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});

parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b11e671062d0fc5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $VSDnB.fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $e6s40.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $c46b06918fbe54e8$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $c46b06918fbe54e8$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $c46b06918fbe54e8$var$hasAfterStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.textPaddingRight)
});
const $c46b06918fbe54e8$var$hasAfterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $e6s40.textMarginLeft)
});
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $f8Sb3.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});

parcelRegister("frUcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $625906158e0f3c21$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $e6s40 = parcelRequire("e6s40");
const $625906158e0f3c21$var$removeButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '16px',
    width: '16px',
    margin: 'space.0',
    padding: 'space.0',
    insetInlineEnd: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    borderRadius: 'border.radius.050',
    color: 'color.text',
    cursor: 'pointer',
    pointerEvents: 'auto',
    marginInlineStart: 'space.negative.025',
    marginInlineEnd: 'space.negative.025',
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $625906158e0f3c21$var$removeButtonStylesOld = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '16px',
    margin: 'space.0',
    padding: 'space.0',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    // Once legacy theming is dropped, this can be changed to 'border.radius'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    // Once legacy theming is dropped, this can be changed to 'inherit'
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.removeButton.default})`,
    cursor: 'pointer',
    pointerEvents: 'auto',
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':hover': {
        // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.removeButton.hover})`
    }
});
const $625906158e0f3c21$var$removeButtonStylesOldIcon = (0, $8CUq3.xcss)({
    insetInlineEnd: 'space.0'
});
const $625906158e0f3c21$var$removeButtonStylesNewIcon = (0, $8CUq3.xcss)({
    insetInlineEnd: 'space.025'
});
const $625906158e0f3c21$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $625906158e0f3c21$var$removeButtonStyles : $625906158e0f3c21$var$removeButtonStylesOld,
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $625906158e0f3c21$var$removeButtonStylesNewIcon : $625906158e0f3c21$var$removeButtonStylesOldIcon
        ],
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$625906158e0f3c21$export$2e2bcd8739ae039 = $625906158e0f3c21$var$RemoveButton;

});




parcelRegister("3b8Xg", function(module, exports) {

$parcel$export(module.exports, "MultiQuickOverrideShiftCard", () => $ccfd3dde724d11f6$export$36f90957520105aa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $efXp3 = parcelRequire("efXp3");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $6UXEc = parcelRequire("6UXEc");

var $80MT9 = parcelRequire("80MT9");
var $legSc = parcelRequire("legSc");
var $lejk3 = parcelRequire("lejk3");
var $gvIUe = parcelRequire("gvIUe");

var $1bRoC = parcelRequire("1bRoC");

var $jkGAf = parcelRequire("jkGAf");

var $7FgKX = parcelRequire("7FgKX");

var $9Ss6R = parcelRequire("9Ss6R");
const $ccfd3dde724d11f6$var$formStyles = (0, $8CUq3.xcss)({
    margin: '0',
    marginTop: 'space.negative.200'
});
const $ccfd3dde724d11f6$export$36f90957520105aa = ({ cards: cards, onClose: onClose, onCancel: onCancel, onAddOverride: onAddOverride, isDisabled: isDisabled })=>{
    const intlApi = (0, $koVbs.default)();
    const current = (0, $1bRoC.useCurrentUser)();
    const { isLoading: isAddOverrideLoading, call: addOverride } = (0, $gvIUe.useCallPromise)(onAddOverride);
    const responders = (0, $5uXOq.useMemo)(()=>Object.values(cards.reduce((acc, { responder: responder })=>acc[responder.id] ? acc : {
                ...acc,
                [responder.id]: responder
            }, {})), [
        cards
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $legSc.Card), {
        role: "dialog",
        "aria-labelledby": "shift-card-title",
        "aria-describedby": "shift-card-description",
        controls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CloseButton), {
            onClick: onClose
        }),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            id: "shift-card-title",
            as: "h2",
            size: "xsmall"
        }, intlApi.formatMessage((0, $jkGAf.messages).quickOverrideTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            id: "shift-card-description",
            as: "h3",
            size: "xxsmall"
        }, intlApi.formatMessage((0, $jkGAf.messages).selectionCount, {
            count: cards.length
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, responders.map((responder)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ss6R.ResponderTag), {
                responder: responder,
                key: responder.id
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
            onSubmit: ({ responder: responder })=>addOverride(responder)
        }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "form",
                ...formProps,
                xcss: $ccfd3dde724d11f6$var$formStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FgKX.OverridenWith), {
                isLoading: current.isLoading,
                isDisabled: isDisabled,
                defaultValue: current.user
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lejk3.Footer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CancelButton), {
                onClick: onCancel
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.OverrideButton), {
                isLoading: isAddOverrideLoading,
                type: "submit"
            }))))))
    });
};

});
parcelRegister("gvIUe", function(module, exports) {

$parcel$export(module.exports, "useCallPromise", () => $304e6ab6aec81f7f$export$f196b4e879708afe);

var $5uXOq = parcelRequire("5uXOq");
const $304e6ab6aec81f7f$export$f196b4e879708afe = (fn)=>{
    const [isError, setIsError] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const call = (0, $5uXOq.useCallback)(async (args)=>{
        try {
            setIsLoading(true);
            await fn(args);
        } catch (e) {
            setIsError(true);
        } finally{
            setIsLoading(false);
        }
    }, [
        fn
    ]);
    return {
        isError: isError,
        isLoading: isLoading,
        call: call
    };
};

});

parcelRegister("7FgKX", function(module, exports) {

$parcel$export(module.exports, "OverridenWith", () => $314b4ab2dd46e082$export$cfe316c30f372b03);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7O4UO = parcelRequire("7O4UO");

var $6yUsV = parcelRequire("6yUsV");

var $cgL5K = parcelRequire("cgL5K");

var $6TYWC = parcelRequire("6TYWC");

var $5XoGW = parcelRequire("5XoGW");

var $k4umG = parcelRequire("k4umG");

var $3ogs7 = parcelRequire("3ogs7");

var $gEBgl = parcelRequire("gEBgl");

var $d1ARh = parcelRequire("d1ARh");
const $314b4ab2dd46e082$export$cfe316c30f372b03 = ({ isLoading: isLoading, ...rest })=>{
    const intlApi = (0, $koVbs.default)();
    const isRequiredValidator = (0, $5XoGW.useValidators)([
        (0, $5XoGW.isRequired)()
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        ...rest,
        id: "responder",
        name: "responder",
        validate: isRequiredValidator
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
            variant: "inline",
            htmlFor: "responder",
            label: intlApi.formatMessage((0, $d1ARh.messages).overrideWith)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ogs7.AutoCompleteWithNoOne), {
            ...fieldProps,
            ...(0, $gEBgl.extraSelectProps),
            ...isLoading && {
                isLoading: true
            },
            ...error && {
                isError: true
            },
            spacing: "compact",
            appearance: "subtle",
            endpoints: [
                (0, $6TYWC.getUsers)
            ]
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
            appearance: "error",
            iconLabel: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, error)))));
};

});
parcelRegister("gEBgl", function(module, exports) {

$parcel$export(module.exports, "extraSelectProps", () => $dfe5c697aa06bb2d$export$73e1250c6e127a13);
// SEE: https://atlaskit.atlassian.com/packages/design-system/select/example/select-in-modal-dialog
const $dfe5c697aa06bb2d$export$73e1250c6e127a13 = {
    menuPortalTarget: document.body,
    styles: {
        menuPortal: (base)=>({
                ...base,
                zIndex: 9999
            }),
        container: (base)=>({
                ...base,
                flex: `1 1 auto`,
                marginLeft: `${"var(--ds-space-negative-075, -6px)"}`
            })
    }
};

});

parcelRegister("d1ARh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $acf7fe968df13501$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $acf7fe968df13501$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    overrideWith: {
        id: 'eoc-schedule.common.ui.shift-card.overridden-with.override-with',
        defaultMessage: 'Override with',
        description: 'Label for overridden with.'
    }
});

});



parcelRegister("b4Wih", function(module, exports) {

$parcel$export(module.exports, "SingleShiftCard", () => $e2bc6efbbb99e906$export$817792e24c7d076e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $luBm6 = parcelRequire("luBm6");

var $legSc = parcelRequire("legSc");
var $80MT9 = parcelRequire("80MT9");
var $9YkY7 = parcelRequire("9YkY7");
var $3yAjd = parcelRequire("3yAjd");
var $ez1ft = parcelRequire("ez1ft");
var $5jHhH = parcelRequire("5jHhH");
var $lejk3 = parcelRequire("lejk3");
var $k4umG = parcelRequire("k4umG");
const $e2bc6efbbb99e906$export$817792e24c7d076e = ({ cards: cards, onClose: onClose, onQuickOverride: onQuickOverride })=>{
    const intlApi = (0, $koVbs.default)();
    const singleCard = cards[0];
    const { rotation: rotation, ...period } = singleCard;
    const { responder: responder } = period;
    const isDeleted = responder.deleted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $legSc.Card), {
        role: "dialog",
        "aria-labelledby": "shift-card-title",
        controls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CloseButton), {
            onClick: onClose
        }),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yAjd.Contact), {
            id: "shift-card-title",
            responder: responder
        }), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jHhH.DeletedWarning), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "start",
            epoch: period.startEpoch + period.startOffset,
            isTrueTime: period.isTrueStartTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "end",
            epoch: period.endEpoch + period.endOffset,
            isTrueTime: period.isTrueEndTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
            variant: "inline",
            label: intlApi.formatMessage((0, $9YkY7.messages).rotation)
        }, rotation.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lejk3.Footer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.OverrideButton), {
            onClick: onQuickOverride
        })))
    });
};

});

parcelRegister("9xaCz", function(module, exports) {

$parcel$export(module.exports, "SingleOverridenShiftCard", () => $08ac9969d6e5b7f3$export$dd139e334972e2aa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $luBm6 = parcelRequire("luBm6");

var $h8yj2 = parcelRequire("h8yj2");

var $legSc = parcelRequire("legSc");
var $80MT9 = parcelRequire("80MT9");
var $9YkY7 = parcelRequire("9YkY7");
var $3yAjd = parcelRequire("3yAjd");
var $ez1ft = parcelRequire("ez1ft");
var $5jHhH = parcelRequire("5jHhH");
var $k4umG = parcelRequire("k4umG");
var $gvIUe = parcelRequire("gvIUe");
const $08ac9969d6e5b7f3$export$dd139e334972e2aa = ({ cards: cards, onClose: onClose, onEdit: onEdit, onRevert: onRevert })=>{
    const intlApi = (0, $koVbs.default)();
    const { isLoading: isEditLoading, call: edit } = (0, $gvIUe.useCallPromise)(onEdit);
    const { isLoading: isRevertLoading, call: revert } = (0, $gvIUe.useCallPromise)(onRevert);
    const singleCard = cards[0];
    const { rotation: rotation, ...period } = singleCard;
    const { responder: responder } = period;
    const isDeleted = responder.deleted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $legSc.Card), {
        role: "dialog",
        "aria-labelledby": "shift-card-title",
        controls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.EditOverrideButton), {
            id: "edit-override-button",
            isLoading: isEditLoading,
            onClick: ()=>{
                edit();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.RevertOverrideButton), {
            id: "revert-override-button",
            isLoading: isRevertLoading,
            onClick: (_, analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'removeOverride');
                revert();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CloseButton), {
            onClick: onClose
        })),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yAjd.Contact), {
            id: "shift-card-title",
            responder: responder
        }), isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jHhH.DeletedWarning), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "start",
            epoch: period.startEpoch + period.startOffset,
            isTrueTime: period.isTrueStartTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "end",
            epoch: period.endEpoch + period.endOffset,
            isTrueTime: period.isTrueEndTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
            variant: "inline",
            label: intlApi.formatMessage((0, $9YkY7.messages).rotation)
        }, rotation.name)))
    });
};

});

parcelRegister("6AEWc", function(module, exports) {

$parcel$export(module.exports, "SingleQuickOverrideShiftCard", () => $7c0b77423355d210$export$708348591a16c9b0);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $efXp3 = parcelRequire("efXp3");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $80MT9 = parcelRequire("80MT9");
var $legSc = parcelRequire("legSc");
var $9YkY7 = parcelRequire("9YkY7");
var $ez1ft = parcelRequire("ez1ft");
var $lejk3 = parcelRequire("lejk3");
var $lMhXb = parcelRequire("lMhXb");
var $k4umG = parcelRequire("k4umG");
var $gvIUe = parcelRequire("gvIUe");

var $1bRoC = parcelRequire("1bRoC");

var $jkGAf = parcelRequire("jkGAf");

var $7FgKX = parcelRequire("7FgKX");
const $7c0b77423355d210$var$formStyles = (0, $8CUq3.xcss)({
    margin: '0',
    marginTop: 'space.negative.200'
});
const $7c0b77423355d210$export$708348591a16c9b0 = ({ cards: cards, onClose: onClose, onCancel: onCancel, onCustomize: onCustomize, onAddOverride: onAddOverride, isDisabled: isDisabled })=>{
    const intlApi = (0, $koVbs.default)();
    const { isLoading: isAddOverrideLoading, call: addOverride } = (0, $gvIUe.useCallPromise)(onAddOverride);
    const current = (0, $1bRoC.useCurrentUser)();
    const singleCard = cards[0];
    const { rotation: rotation, ...period } = singleCard;
    const { responder: responder } = period;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $legSc.Card), {
        role: "dialog",
        "aria-labelledby": "shift-card-title",
        controls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CloseButton), {
            onClick: onClose
        }),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            id: "shift-card-title",
            as: "h2",
            size: "xsmall"
        }, intlApi.formatMessage((0, $jkGAf.messages).quickOverrideTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "start",
            epoch: period.startEpoch + period.startOffset,
            isTrueTime: period.isTrueStartTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ez1ft.DateTime), {
            variant: "end",
            epoch: period.endEpoch + period.endOffset,
            isTrueTime: period.isTrueEndTime
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4umG.Row), {
            variant: "inline",
            label: intlApi.formatMessage((0, $9YkY7.messages).rotation)
        }, rotation.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMhXb.ReadonlyUser), {
            variant: "shiftParticipant",
            responder: responder
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
            onSubmit: ({ responder: responder })=>addOverride(responder)
        }, ({ formProps: formProps, getState: getState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "form",
                ...formProps,
                xcss: $7c0b77423355d210$var$formStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                space: "space.200",
                alignInline: "start"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FgKX.OverridenWith), {
                isLoading: current.isLoading,
                isDisabled: isDisabled,
                defaultValue: current.user
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.EditDetailsButton), {
                id: "customize-override-button",
                onClick: ()=>{
                    const { values: { responder: responder }, dirty: dirty } = getState();
                    // NOTE: if is not modified, the responder is JSM user. (those must be ignored)
                    // else it is guaranteed that responder is RequestedResponder (with OpsGenie ID)
                    onCustomize(dirty && responder ? responder : undefined);
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lejk3.Footer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.CancelButton), {
                onClick: onCancel
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80MT9.OverrideButton), {
                isLoading: isAddOverrideLoading,
                type: "submit"
            }))))))
    });
};

});

parcelRegister("cWVZo", function(module, exports) {

$parcel$export(module.exports, "normalizeRange", () => $7c19c651e94be03a$export$769559576d90a89c);
$parcel$export(module.exports, "makeTime", () => $7c19c651e94be03a$export$7e22707943b1c100);

var $jOikx = parcelRequire("jOikx");

var $csGzA = parcelRequire("csGzA");
/**
 * Normalize the range of the period within the bounds of the outer range.
 */ const $7c19c651e94be03a$export$769559576d90a89c = (period, outer)=>{
    const { startEpoch: startEpoch, endEpoch: endEpoch, endOffset: endOffset } = period;
    const { nowEpoch: nowEpoch, nowOffset: nowOffset } = outer;
    if (nowEpoch > startEpoch) return {
        startEpoch: nowEpoch,
        startOffset: nowOffset,
        endEpoch: endEpoch,
        endOffset: endOffset
    };
    return period;
};
const $7c19c651e94be03a$export$7e22707943b1c100 = (epoch, offset)=>{
    return (0, $csGzA.partitionDate)((0, $jOikx.conversion).toLocal(epoch, offset));
};

});



parcelRegister("eNzGG", function(module, exports) {

$parcel$export(module.exports, "ExpandViewContainer", () => $378ca94e2b4c4823$export$e141b3b452e3316e);
$parcel$export(module.exports, "TimeZone", () => $378ca94e2b4c4823$export$184da83e119591ea);
$parcel$export(module.exports, "LayerName", () => $378ca94e2b4c4823$export$3b1c31f03926e321);
$parcel$export(module.exports, "CalendarWrapper", () => $378ca94e2b4c4823$export$83ab9905f75b2566);
$parcel$export(module.exports, "Container", () => $378ca94e2b4c4823$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aSTVt = parcelRequire("aSTVt");

var $bWGt6 = parcelRequire("bWGt6");
function $378ca94e2b4c4823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $378ca94e2b4c4823$export$e141b3b452e3316e = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e12jow2w4"
})({
    name: "cy0hyj",
    styles: "display:flex;justify-content:flex-end;padding-block-start:var(--ds-space-200, 16px);padding-inline:var(--ds-space-100, 8px);padding-bottom:var(--ds-space-050, 8px)"
});
const $378ca94e2b4c4823$export$184da83e119591ea = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e12jow2w3"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
    marginLeft: "var(--ds-space-100, 8px)",
    whiteSpace: 'nowrap'
});
const $378ca94e2b4c4823$export$3b1c31f03926e321 = /*#__PURE__*/ (0, $bWGt6.default)("h4", {
    target: "e12jow2w2"
})({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-250, 20px)",
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $aSTVt.LAYER_HEIGHT),
    padding: `0 0 ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-200, 16px)"}`
});
const $378ca94e2b4c4823$export$83ab9905f75b2566 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e12jow2w1"
})({
    padding: `0 ${"var(--ds-space-100, 8px)"}`
});
const $378ca94e2b4c4823$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e12jow2w0"
})({
    padding: `0 0 ${"var(--ds-space-150, 12px)"} 0`
});

});

parcelRegister("1dNuT", function(module, exports) {

$parcel$export(module.exports, "WeekList", () => $1d0cb2c9094fa9a9$export$468ed64885c1e535);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $i07hd = parcelRequire("i07hd");
var $3FhTI = parcelRequire("3FhTI");
var $5s9eT = parcelRequire("5s9eT");
var $dAkvd = parcelRequire("dAkvd");
var $jH8Xl = parcelRequire("jH8Xl");
var $9w5KV = parcelRequire("9w5KV");
var $5sA4Z = parcelRequire("5sA4Z");

var $aSTVt = parcelRequire("aSTVt");

var $hHWTd = parcelRequire("hHWTd");

var $7qhgx = parcelRequire("7qhgx");
const $1d0cb2c9094fa9a9$export$468ed64885c1e535 = (props)=>{
    const { weeks: weeks, nowEpoch: nowEpoch, offset: offset, schedule: schedule, width: width } = props;
    const itemTable = (0, $5uXOq.useMemo)(()=>{
        return (0, $i07hd.fromWeeksToItemTable)(weeks);
    }, [
        weeks
    ]);
    const { tabbed: tabbed, focusRefs: focusRefs, onContainerKeyDown: onContainerKeyDown, makeOnClick: makeOnClick, makeOnHover: makeOnHover, makeOnClose: makeOnClose, makeOnCross: makeOnCross, activeSpotlight: activeSpotlight, activeShift: activeShift, selectedShifts: selectedShifts } = (0, $hHWTd.useShift)({
        schedule: schedule,
        items: itemTable,
        now: nowEpoch
    });
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // NOTE: might be re add later
        // role="table"
        // aria-label={layer.label}
        // aria-roledescription={intlApi.formatMessage(
        //   scheduleCommonMessages.calendarLayer,
        // )}
        onKeyDown: onContainerKeyDown
    }, weeks.map(({ startEpoch: startEpoch, endEpoch: endEpoch, rotations: rotations })=>{
        const week = {
            startEpoch: startEpoch,
            endEpoch: endEpoch,
            nowEpoch: nowEpoch,
            width: width
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9w5KV.Week), {
            key: `week-${startEpoch}-${endEpoch}`,
            startEpoch: startEpoch,
            endEpoch: endEpoch,
            nowEpoch: nowEpoch,
            offset: offset,
            rotationSlot: rotations.map((rotation, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAkvd.Rotation), {
                    key: index,
                    isFirstLastSame: true,
                    variant: "compact",
                    name: rotation.name,
                    size: "small"
                }, rotation.periods.map((period)=>{
                    const detail = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, period, {
                        rotation: rotation
                    });
                    const onClick = makeOnClick(detail);
                    const onHover = makeOnHover(detail);
                    const onClose = makeOnClose(detail);
                    const onCross = makeOnCross(detail);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
                        key: period.id,
                        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7qhgx.ActiveCard), {
                                onClose: onCross
                            }),
                        isOpen: activeShift === period.id,
                        onClose: onClose,
                        placement: "bottom",
                        zIndex: (0, $k5uoT.layers).navigation() + 1,
                        trigger: ({ ref: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sA4Z.Wrap), {
                                within: (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                                        name: (0, $aSTVt.SPOTLIGHT_NAMES).shiftTile
                                    }, e),
                                when: activeSpotlight === period.id
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jH8Xl.SimpleShiftTile), {
                                ref: (0, $3FhTI.mergeRefs)(triggerRef, focusRefs[period.id]),
                                onMouseEnter: onHover,
                                onClick: onClick,
                                period: period,
                                outerTimeFrame: week,
                                isSelected: selectedShifts[period.id],
                                isTabbable: tabbed?.id === period.id,
                                size: "small",
                                hasOverrideBorder: period.type === (0, $5s9eT.PeriodType).Override || period.type === (0, $5s9eT.PeriodType).Forwarding
                            }))
                    });
                })))
        });
    })));
};

});


parcelRegister("h40Qo", function(module, exports) {

$parcel$export(module.exports, "ScheduleContainer", () => $749ec54ad89c7816$export$6cd213d2de550bd3);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $749ec54ad89c7816$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $749ec54ad89c7816$export$6cd213d2de550bd3 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ek7y34g0"
})({
    name: "1ene8e5",
    styles: "display:flex;flex-direction:column;row-gap:var(--ds-space-150, 12px)"
});

});

parcelRegister("jVWA4", function(module, exports) {

$parcel$export(module.exports, "TakeOnCall", () => $100eb9a41b08c599$export$b99128a903d273f7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $jkGAf = parcelRequire("jkGAf");

var $g3AjQ = parcelRequire("g3AjQ");

var $9It5A = parcelRequire("9It5A");

var $1bRoC = parcelRequire("1bRoC");

var $lqDaZ = parcelRequire("lqDaZ");
const $100eb9a41b08c599$export$b99128a903d273f7 = ({ onClose: onClose })=>{
    const intlApi = (0, $koVbs.default)();
    const [{ takeOnCallLoading: takeOnCallLoading }, { takeOnCallAction: takeOnCallAction }] = (0, $9It5A.useStore)();
    const current = (0, $1bRoC.useCurrentUser)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: ()=>{
            takeOnCallAction({
                accountId: current.user.atlassianIdentifier
            });
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, intlApi.formatMessage((0, $lqDaZ.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, intlApi.formatMessage((0, $lqDaZ.messages).explanation, {
            bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3AjQ.Bold), null, str)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: onClose
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            autoFocus: true,
            appearance: "primary",
            isLoading: takeOnCallLoading,
            type: "submit"
        }, intlApi.formatMessage((0, $jkGAf.messages).overrideButton))))));
};

});
parcelRegister("lqDaZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $44e8a9e864acf498$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $44e8a9e864acf498$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc-schedule.ui.list.take-on-call.title',
        defaultMessage: 'Take on-call',
        description: 'Title for take on-call modal.'
    },
    explanation: {
        id: 'eoc-schedule.ui.list.take-on-call.explanation',
        defaultMessage: "You're overriding all rotations and you'll be the only on-call participant on this schedule for <bold>one hour</bold>.",
        description: 'Explanation for take on-call usage.'
    }
});

});



parcelRegister("3S1hY", function(module, exports) {

$parcel$export(module.exports, "Section", () => $99d1d66f207d80b2$export$6e2c8f0811a474ce);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $faod6 = parcelRequire("faod6");

var $ky7e4 = parcelRequire("ky7e4");

var $8jMCF = parcelRequire("8jMCF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $agcXw = parcelRequire("agcXw");
var $h8yj2 = parcelRequire("h8yj2");

var $dY87H = parcelRequire("dY87H");

var $c9zAO = parcelRequire("c9zAO");

var $hem2I = parcelRequire("hem2I");

var $d41OH = parcelRequire("d41OH");

var $lNHZW = parcelRequire("lNHZW");

var $9T6pk = parcelRequire("9T6pk");

var $6RRyp = parcelRequire("6RRyp");

var $limys = parcelRequire("limys");

var $gLEUF = parcelRequire("gLEUF");

var $kf4Ca = parcelRequire("kf4Ca");

var $cUgCB = parcelRequire("cUgCB");
const $99d1d66f207d80b2$var$addButtonStyles = (0, $8CUq3.xcss)({
    margin: '0',
    marginRight: 'space.100'
});
// TODO: use eoc-section -> currently causes problems when used with dropdown as action component
const $99d1d66f207d80b2$export$6e2c8f0811a474ce = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intlApi = (0, $koVbs.default)();
    const { displayDensity: displayDensity, scheduleOrder: scheduleOrder, schedulesCollapsed: schedulesCollapsed, partialUpdate: updateSectionPreferences } = (0, $9T6pk.useSectionUiPreferences)();
    const { openCreateSchedule: openCreateSchedule } = (0, $d41OH.useActions)();
    const { data: schedules } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { data: scheduleRights } = (0, $hem2I.default)((0, $6RRyp.getScheduleRightsResource));
    const count = (0, $5uXOq.useMemo)(()=>schedules && schedules.schedules?.length > 0 ? schedules.schedules?.length : undefined, [
        schedules
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Forcing to expand if there is no schedule
        if (!count && schedulesCollapsed) updateSectionPreferences({
            key: 'schedulesCollapsed',
            value: false
        });
    }, [
        count,
        schedulesCollapsed,
        updateSectionPreferences
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gLEUF.Header), {
        isOpen: !schedulesCollapsed,
        onOpenChange: (isOpen)=>{
            updateSectionPreferences({
                key: 'schedulesCollapsed',
                value: !isOpen
            });
        },
        title: intlApi.formatMessage((0, $kf4Ca.messages).schedules),
        count: count,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, scheduleRights?.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                schedulesCollapsed ? undefined : $99d1d66f207d80b2$var$addButtonStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: intlApi.formatMessage((0, $kf4Ca.messages).createSchedule),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: intlApi.formatMessage((0, $kf4Ca.messages).createNewSchedule),
            id: "create-schedule-button",
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($faod6))),
            onClick: (_, analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'addSchedule');
                openCreateSchedule({
                    id: 'create-schedule-button'
                });
            }
        }))), !schedulesCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: intlApi.formatMessage((0, $kf4Ca.messages).preferences),
                    position: "bottom"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                    label: intlApi.formatMessage((0, $kf4Ca.messages).preferences),
                    ...props,
                    onClick: (e)=>{
                        props.onClick?.(e);
                    },
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))),
                    ref: triggerRef
                }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
            title: intlApi.formatMessage((0, $kf4Ca.messages).displayDensity)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'slimPreference');
                updateSectionPreferences({
                    key: 'displayDensity',
                    value: 'slim'
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUgCB.ViewOptionText), null, intlApi.formatMessage((0, $kf4Ca.messages).slim)), displayDensity === 'slim' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            spacing: "spacious",
            label: "Checked",
            color: `var(--ds-icon-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'comfortPreference');
                updateSectionPreferences({
                    key: 'displayDensity',
                    value: 'comfort'
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUgCB.ViewOptionText), null, intlApi.formatMessage((0, $kf4Ca.messages).comfort)), displayDensity === 'comfort' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            spacing: "spacious",
            label: "Checked",
            color: `var(--ds-icon-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
            title: intlApi.formatMessage((0, $kf4Ca.messages).scheduleOrder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'finalPreference');
                updateSectionPreferences({
                    key: 'scheduleOrder',
                    value: 'finalSchedule'
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUgCB.ViewOptionText), null, intlApi.formatMessage((0, $kf4Ca.messages).finalScheduleOnTop)), scheduleOrder === 'finalSchedule' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            spacing: "spacious",
            label: "Checked",
            color: `var(--ds-icon-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>{
                const event = createAnalyticsEvent({});
                (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'basePreference');
                updateSectionPreferences({
                    key: 'scheduleOrder',
                    value: 'baseSchedule'
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUgCB.ViewOptionText), null, intlApi.formatMessage((0, $kf4Ca.messages).baseScheduleOnTop)), scheduleOrder === 'baseSchedule' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            spacing: "spacious",
            label: "Checked",
            color: `var(--ds-icon-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }))))))
    }), !schedulesCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUgCB.Container), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d41OH.Subscriber), null, ({ isCreateScheduleOpen: isCreateScheduleOpen, activeSchedule: activeSchedule, createVariant: createVariant }, { focusSource: focusSource })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9zAO.default), {
            // TODO: add close on escape
            isOpen: isCreateScheduleOpen,
            returnFocus: ()=>{
                focusSource();
                return false;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $limys.CreateSchedule), {
            baseSchedule: activeSchedule,
            variant: createVariant ?? (0, $lNHZW.CreateVariant).Create
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $agcXw.FireScreenAnalytics), {
        componentName: "schedules"
    }));
};

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::960f6ce03e4c8754204f0c1f72e1b16b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});

parcelRegister("8jMCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0471165b1411c9e3d53c4e3bf136cbc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e5d086aacc57a4$var$_react = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $60e5d086aacc57a4$var$_customize = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("4QAwn")));

var $60e5d086aacc57a4$var$_preferences = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5KZxU")));
function $60e5d086aacc57a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e5d086aacc57a4$var$CustomizeIcon = (props)=>/*#__PURE__*/ $60e5d086aacc57a4$var$_react.default.createElement($60e5d086aacc57a4$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $60e5d086aacc57a4$var$_preferences.default
    }, props));
$60e5d086aacc57a4$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $60e5d086aacc57a4$var$_default = module.exports.default = $60e5d086aacc57a4$var$CustomizeIcon;

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0c649661159dc6f72b79c281c90c29e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("5KZxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>/*#__PURE__*/ $4310fd5ff8fcaeb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $4310fd5ff8fcaeb0$var$_customize.default
    }));
$4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;

});


parcelRegister("limys", function(module, exports) {

$parcel$export(module.exports, "CreateSchedule", () => $db5ca9846f8bbfec$export$e9cbc8d4db45bf2a);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $8jRgk = parcelRequire("8jRgk");

var $l1N8i = parcelRequire("l1N8i");

var $kY99m = parcelRequire("kY99m");

var $h8yj2 = parcelRequire("h8yj2");

var $5XoGW = parcelRequire("5XoGW");

var $5s9eT = parcelRequire("5s9eT");
var $ksSWS = parcelRequire("ksSWS");

var $aSTVt = parcelRequire("aSTVt");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $d41OH = parcelRequire("d41OH");

var $lNHZW = parcelRequire("lNHZW");

var $9T6pk = parcelRequire("9T6pk");

var $a1xHf = parcelRequire("a1xHf");

var $6b2or = parcelRequire("6b2or");

var $hwoWq = parcelRequire("hwoWq");

var $7fuyt = parcelRequire("7fuyt");
const $db5ca9846f8bbfec$export$e9cbc8d4db45bf2a = ({ baseSchedule: baseSchedule, variant: variant })=>{
    const intlApi = (0, $koVbs.default)();
    const { closePageModal: closePageModal } = (0, $d41OH.useActions)();
    const { createSchedule: createSchedule, isLoading: createScheduleLoading } = (0, $a1xHf.useCreateScheduleService)();
    const { cloneSchedule: cloneSchedule, isLoading: cloneScheduleLoading } = (0, $a1xHf.useCloneScheduleService)();
    const nameValidator = (0, $5XoGW.useValidators)([
        (0, $5XoGW.isRequired)(),
        (0, $5XoGW.isMaxCharacterCount)((0, $aSTVt.SCHEDULE_NAME_MAX_LENGTH))
    ]);
    const { schedulesCollapsed: schedulesCollapsed, partialUpdate: updateSectionPreferences } = (0, $9T6pk.useSectionUiPreferences)();
    const defaultValues = (0, $7fuyt.useDefaultValues)({
        base: baseSchedule,
        variant: variant
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwoWq.FlexWrapper), {
        alignItems: "center",
        flex: "1 1 auto",
        flexDirection: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "large"
    }, intlApi.formatMessage((0, $6b2or.messages).createSchedule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: (values)=>{
            if (variant === (0, $lNHZW.CreateVariant).Create) {
                if (schedulesCollapsed) updateSectionPreferences({
                    key: 'schedulesCollapsed',
                    value: false
                });
                createSchedule({
                    description: values.description,
                    name: values.name,
                    timezone: values.timezone.value
                });
            } else if (variant === (0, $lNHZW.CreateVariant).Clone) cloneSchedule({
                description: values.description ?? '',
                name: values.name,
                timezone: values.timezone.value,
                enabled: baseSchedule.enabled,
                id: baseSchedule.id
            });
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwoWq.StyledForm), formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: intlApi.formatMessage((0, $6b2or.messages).scheduleName),
            name: "name",
            isRequired: true,
            validate: nameValidator,
            defaultValue: defaultValues.name
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), fieldProps), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: intlApi.formatMessage((0, $6b2or.messages).description),
            name: "description",
            defaultValue: defaultValues.description
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), fieldProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            defaultValue: defaultValues.timezone,
            label: intlApi.formatMessage((0, $6b2or.messages).timezone),
            name: "timezone"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ksSWS.TimezoneSelect), {
                ...(0, $5s9eT.EXTRA_SELECT_PROPS),
                ...fieldProps
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jRgk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: ()=>closePageModal((0, $kCCbe.PageModalType).CreateSchedule)
        }, intlApi.formatMessage((0, $jkGAf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            isLoading: createScheduleLoading || cloneScheduleLoading,
            type: "submit",
            onClick: (_, analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'addScheduleInModal');
            }
        }, intlApi.formatMessage((0, $6b2or.messages).create)))))));
};

});
parcelRegister("a1xHf", function(module, exports) {

$parcel$export(module.exports, "useCreateScheduleService", () => $33f7ca86f656f21d$export$1b0b0102bf19bd3b);
$parcel$export(module.exports, "useCloneScheduleService", () => $33f7ca86f656f21d$export$9f2d7908b5f05409);

var $5uXOq = parcelRequire("5uXOq");

var $3NMrl = parcelRequire("3NMrl");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $jkGAf = parcelRequire("jkGAf");

var $kCCbe = parcelRequire("kCCbe");

var $d41OH = parcelRequire("d41OH");

var $c0fyU = parcelRequire("c0fyU");

var $6RRyp = parcelRequire("6RRyp");

var $aHP8W = parcelRequire("aHP8W");

var $4ZcP9 = parcelRequire("4ZcP9");
const $33f7ca86f656f21d$export$1b0b0102bf19bd3b = ()=>{
    const { update: updateSchedulesResource } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { openEditMode: openEditMode, closePageModal: closePageModal } = (0, $d41OH.useActions)();
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const teamId = (0, $aHP8W.useTeamId)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const createSchedule = (0, $5uXOq.useCallback)(async ({ name: name, timezone: timezone, description: description })=>{
        try {
            setIsLoading(true);
            const response = await (0, $c0fyU.endpoints).createSchedule({
                name: name,
                timezone: timezone,
                description: description,
                teamId: teamId
            });
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'schedule created', response.id);
            const schedule = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(response, [
                'id',
                'name',
                'description',
                'timezone',
                'enabled',
                'utcTimeOffsetMillis'
            ]);
            updateSchedulesResource((prev)=>{
                return {
                    schedules: [
                        ...prev?.schedules ?? [],
                        schedule
                    ]
                };
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $4ZcP9.messages).createScheduleSuccessTitle),
                isAutoDismiss: true
            });
            closePageModal((0, $kCCbe.PageModalType).CreateSchedule);
            openEditMode({
                schedule: schedule,
                replace: true,
                id: [
                    schedule.id,
                    'create-schedule-button'
                ]
            });
        } catch (error) {
            defaultCatch({
                id: 'useCreateScheduleService-createSchedule',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $4ZcP9.messages).createScheduleErrorTitle)
                    });
                }
            }, error);
            throw error;
        } finally{
            setIsLoading(false);
        }
    }, [
        teamId,
        updateSchedulesResource,
        flagApi,
        intlApi,
        closePageModal,
        openEditMode,
        defaultCatch,
        createAnalyticsEvent
    ]);
    return {
        createSchedule: createSchedule,
        isLoading: isLoading
    };
};
const $33f7ca86f656f21d$export$9f2d7908b5f05409 = ()=>{
    const { update: updateSchedulesResource } = (0, $hem2I.default)((0, $6RRyp.getSchedulesResource));
    const { openEditMode: openEditMode, closePageModal: closePageModal } = (0, $d41OH.useActions)();
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const teamId = (0, $aHP8W.useTeamId)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const cloneSchedule = (0, $5uXOq.useCallback)(async ({ id: scheduleId, name: name, enabled: enabled, timezone: timezone, description: description })=>{
        try {
            setIsLoading(true);
            const response = await (0, $c0fyU.endpoints).cloneSchedule({
                name: name,
                enabled: enabled,
                timezone: timezone,
                description: description,
                scheduleId: scheduleId,
                teamId: teamId
            });
            // REFACTOR: Should we continue this usage elsewhere
            const schedule = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(response, [
                'id',
                'name',
                'description',
                'timezone',
                'enabled',
                'utcTimeOffsetMillis'
            ]);
            updateSchedulesResource((prev)=>{
                return {
                    schedules: [
                        ...prev?.schedules ?? [],
                        schedule
                    ]
                };
            });
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $4ZcP9.messages).cloneScheduleSuccessTitle),
                isAutoDismiss: true
            });
            closePageModal((0, $kCCbe.PageModalType).CreateSchedule);
            openEditMode({
                schedule: schedule,
                replace: true,
                id: [
                    schedule.id,
                    'create-schedule-button'
                ]
            });
        } catch (error) {
            defaultCatch({
                id: 'useCloneScheduleService-cloneSchedule',
                httpErrorHandler: (err)=>{
                    if (err.message) flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: err.message,
                        title: intlApi.formatMessage((0, $jkGAf.messages).error)
                    });
                    else flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        title: intlApi.formatMessage((0, $4ZcP9.messages).cloneScheduleErrorTitle)
                    });
                }
            }, error);
        } finally{
            setIsLoading(false);
        }
    }, [
        defaultCatch,
        flagApi,
        intlApi,
        openEditMode,
        closePageModal,
        teamId,
        updateSchedulesResource
    ]);
    return {
        cloneSchedule: cloneSchedule,
        isLoading: isLoading
    };
};

});
parcelRegister("4ZcP9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $48eed2f0fef44cdc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $48eed2f0fef44cdc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    createScheduleErrorTitle: {
        id: 'eoc-schedule.controllers.section.create-schedule-error-title',
        defaultMessage: "We couldn't create your schedule.",
        description: 'This message indicates that our back-end services did not respond when creating schedule.'
    },
    createScheduleSuccessTitle: {
        id: 'eoc-schedule.controllers.section.create-schedule-error-title',
        defaultMessage: "You've added a new schedule.",
        description: 'This message indicates schedule is successfully created.'
    },
    cloneScheduleErrorTitle: {
        id: 'eoc-schedule.controllers.section.clone-schedule-error-title',
        defaultMessage: "We couldn't duplicated your schedule.",
        description: 'This message indicates that our back-end services did not respond when duplicating schedule.'
    },
    cloneScheduleSuccessTitle: {
        id: 'eoc-schedule.controllers.section.clone-schedule-success-title',
        defaultMessage: "You've duplicated the schedule.",
        description: 'This message indicates schedule is successfully duplicated.'
    }
});

});


parcelRegister("6b2or", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bfc52e4709c6cb1b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bfc52e4709c6cb1b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    createSchedule: {
        id: 'eoc-schedule.ui.section.create-schedule.create-schedule',
        defaultMessage: 'Create schedule',
        description: 'Create a new schedule title.'
    },
    scheduleName: {
        id: 'eoc-schedule.ui.section.create-schedule.schedule-name',
        defaultMessage: 'Schedule name',
        description: 'Text field label for schedule name.'
    },
    description: {
        id: 'eoc-schedule.ui.section.create-schedule.description',
        defaultMessage: 'Description',
        description: 'Text field label for schedule description.'
    },
    create: {
        id: 'eoc-schedule.ui.section.create-schedule.create',
        defaultMessage: 'Create',
        description: 'A create button for create schedule.'
    },
    timezone: {
        id: 'eoc-schedule.ui.section.create-schedule.timezone',
        defaultMessage: 'Timezone',
        description: 'Text field label for schedule timezone.'
    },
    copyOf: {
        id: 'eoc-schedule.ui.section.create-schedule.copy-of',
        defaultMessage: 'Copy of {scheduleName}',
        description: 'Automatically generated cloned schedule name. Ex. Copy of Paid Schedule'
    }
});

});

parcelRegister("hwoWq", function(module, exports) {

$parcel$export(module.exports, "StyledForm", () => $37e6f65f535396bf$export$71655785c758526a);
$parcel$export(module.exports, "FlexWrapper", () => $37e6f65f535396bf$export$245cfede9308c835);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");

var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $37e6f65f535396bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $37e6f65f535396bf$export$71655785c758526a = /*#__PURE__*/ (0, $bWGt6.default)("form", {
    target: "e5c3lub1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $k5uoT.gridSize)() * 58}px`
});
const $37e6f65f535396bf$export$245cfede9308c835 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e5c3lub0"
})({
    name: "18u1d43",
    styles: "padding-top:var(--ds-space-300, 24px)"
});

});

parcelRegister("7fuyt", function(module, exports) {

$parcel$export(module.exports, "useDefaultValues", () => $52e5541abf03e344$export$7df8a7696a8980e2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fdFPq = parcelRequire("fdFPq");

var $lNHZW = parcelRequire("lNHZW");

var $6b2or = parcelRequire("6b2or");
const $52e5541abf03e344$var$generateName = (base, intlApi)=>{
    return intlApi.formatMessage((0, $6b2or.messages).copyOf, {
        scheduleName: base
    });
};
const $52e5541abf03e344$export$7df8a7696a8980e2 = ({ variant: variant, base: base })=>{
    const intlApi = (0, $koVbs.default)();
    const { getTimezoneOption: getTimezoneOption } = (0, $fdFPq.useTimezoneOptions)();
    const defaults = (0, $5uXOq.useMemo)(()=>{
        switch(variant){
            case (0, $lNHZW.CreateVariant).Create:
                return {
                    name: '',
                    description: '',
                    timezone: getTimezoneOption()
                };
            case (0, $lNHZW.CreateVariant).Clone:
                return {
                    name: $52e5541abf03e344$var$generateName(base.name, intlApi),
                    description: base.description,
                    timezone: getTimezoneOption({
                        timeZone: base.timezone
                    })
                };
        }
    }, [
        base,
        getTimezoneOption,
        intlApi,
        variant
    ]);
    return defaults;
};

});


parcelRegister("gLEUF", function(module, exports) {

$parcel$export(module.exports, "Header", () => $e22076289ff48ec7$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $16T6Y = parcelRequire("16T6Y");

var $l1N8i = parcelRequire("l1N8i");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $h8yj2 = parcelRequire("h8yj2");

var $dY87H = parcelRequire("dY87H");

var $lGpim = parcelRequire("lGpim");

var $a2BUW = parcelRequire("a2BUW");
const $e22076289ff48ec7$export$8b251419efc915eb = ({ actions: actions, isOpen: isOpen, onOpenChange: onOpenChange, title: title, count: count })=>{
    const intlApi = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onToggleCollapse = (0, $5uXOq.useCallback)(()=>{
        // Not allowing collapse if there is no schedule
        if (count) {
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', `schedules${isOpen ? 'Closed' : 'Opened'}`);
            onOpenChange(!isOpen);
        }
    }, [
        count,
        createAnalyticsEvent,
        isOpen,
        onOpenChange
    ]);
    const isDisabled = !count;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2BUW.Clickable), {
        isDisabled: isDisabled,
        onClick: onToggleCollapse,
        tabIndex: 0,
        // For A11Y
        "aria-expanded": isOpen,
        "aria-disabled": isDisabled,
        "aria-label": intlApi.formatMessage((0, $lGpim.messages).schedulesCount, {
            count: count
        }),
        role: "button",
        onKeyDown: (e)=>{
            if (onToggleCollapse && (e.key === 'Enter' || e.key === ' ')) onToggleCollapse();
        }
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        spacing: "spacious",
        testId: "opened-section-chevron",
        label: ""
    }), !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        color: "currentColor",
        spacing: "spacious",
        testId: "closed-section-chevron",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2BUW.TitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "medium"
    }, title), count && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, count))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2BUW.ClickableArea), {
        isDisabled: !count,
        onClick: onToggleCollapse
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
        alignItems: "center",
        justifyContent: "flex-end"
    }, actions));
};

});
parcelRegister("lGpim", function(module, exports) {

$parcel$export(module.exports, "messages", () => $433020ef5a2d2863$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $433020ef5a2d2863$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    schedulesCount: {
        id: 'eoc-schedule.ui.section.schedules-count',
        defaultMessage: 'Schedules, {count} schedules',
        description: 'Schedules count label.'
    }
});

});

parcelRegister("a2BUW", function(module, exports) {

$parcel$export(module.exports, "TitleContainer", () => $b177bc6f7c45e662$export$35e09ba17cc51c69);
$parcel$export(module.exports, "Clickable", () => $b177bc6f7c45e662$export$2f51d37476d4c437);
$parcel$export(module.exports, "ClickableArea", () => $b177bc6f7c45e662$export$90ec0a6e761de91b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $b177bc6f7c45e662$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b177bc6f7c45e662$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1a659s02"
})({
    name: "3h8lt",
    styles: "align-items:center;column-gap:var(--ds-space-100, 8px);display:flex;margin-top:0;min-width:0"
});
const $b177bc6f7c45e662$export$2f51d37476d4c437 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1a659s01"
})("align-items:center;column-gap:var(--ds-space-100, 8px);cursor:pointer;display:flex;min-width:0;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isDisabled: isDisabled })=>isDisabled && `
    color: ${`var(--ds-text-disabled, ${0, $829f609a65d26a98$export$fbae4efaa892d883})`};
    cursor: not-allowed;
    `);
const $b177bc6f7c45e662$export$90ec0a6e761de91b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1a659s00"
})({
    cursor: 'pointer',
    flex: '1 1 auto',
    height: "var(--ds-space-300, 24px)",
    margin: `0 ${"var(--ds-space-100, 8px)"} 0 0`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isDisabled: isDisabled })=>isDisabled && `
    color: ${`var(--ds-text-disabled, ${0, $829f609a65d26a98$export$fbae4efaa892d883})`};
    cursor: not-allowed;
    `);

});


parcelRegister("kf4Ca", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fd38503de505ac97$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fd38503de505ac97$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    schedules: {
        id: 'eoc-schedule.ui.section.schedules',
        defaultMessage: 'Schedules',
        description: 'Schedules message.'
    },
    createSchedule: {
        id: 'eoc-schedule.ui.section.create-schedule',
        defaultMessage: 'Create schedule',
        description: 'Tooltip of an icon to add new schedule.'
    },
    createNewSchedule: {
        id: 'eoc-schedule.ui.section.create-new-schedule',
        defaultMessage: 'Create a new schedule',
        description: 'Label for icon to add new schedule.'
    },
    preferences: {
        id: 'eoc-schedule.ui.section.preferences',
        defaultMessage: 'Preferences for schedules',
        description: 'An icon for schedule preferences.'
    },
    displayDensity: {
        id: 'eoc-schedule.ui.section.display-density',
        defaultMessage: 'Display density',
        description: 'Display density options of schedules.'
    },
    slim: {
        id: 'eoc-schedule.ui.section.slim',
        defaultMessage: 'Slim',
        description: 'Slim view option for schedule cards.'
    },
    comfort: {
        id: 'eoc-schedule.ui.section.comfort',
        defaultMessage: 'Comfort',
        description: 'Comfort view option for schedule cards.'
    },
    layout: {
        id: 'eoc-schedule.ui.section.layout',
        defaultMessage: 'Layout',
        description: 'Layout options of schedules.'
    },
    scheduleOrder: {
        id: 'eoc-schedule.ui.section.schedule-order',
        defaultMessage: 'Schedule order',
        description: 'Schedule order view options.'
    },
    finalScheduleOnTop: {
        id: 'eoc-schedule.ui.section.final-schedule-on-top',
        defaultMessage: 'Final schedule on top',
        description: 'Display final schedule on top view option.'
    },
    baseScheduleOnTop: {
        id: 'eoc-schedule.ui.section.base-schedule-on-top',
        defaultMessage: 'Base schedule on top',
        description: 'Display base schedule on top view option.'
    },
    gaps: {
        id: 'eoc-schedule.ui.section.gaps',
        defaultMessage: 'Gaps',
        description: 'Gaps view option for schedule.'
    },
    showGaps: {
        id: 'eoc-schedule.ui.section.show-gaps',
        defaultMessage: 'Show gaps',
        description: 'Show schedule gaps.'
    }
});

});

parcelRegister("cUgCB", function(module, exports) {

$parcel$export(module.exports, "ViewOptionText", () => $2e8f94ecb340bbdc$export$6cc836c3bc73690e);
$parcel$export(module.exports, "Container", () => $2e8f94ecb340bbdc$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $2e8f94ecb340bbdc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e8f94ecb340bbdc$export$6cc836c3bc73690e = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e17vbox01"
})({
    name: "1c2crol",
    styles: "margin-right:var(--ds-space-150, 12px)"
});
const $2e8f94ecb340bbdc$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e17vbox00"
})({
    name: "hhsg8d",
    styles: "display:flex;margin-top:var(--ds-space-150, 12px);flex-direction:column"
});

});



parcelRegister("1Nrg3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $da5114ef5b50cadc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $da5114ef5b50cadc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    onCall: {
        id: 'eoc-on-call.ui.page.on-call',
        defaultMessage: 'On-call',
        description: 'On call page title.'
    },
    teams: {
        id: 'eoc-on-call.ui.page.teams',
        defaultMessage: 'Teams',
        description: 'The text will be displayed on the breadcrumb for Team list navigation'
    }
});

});



parcelRegister("c4MCf", function(module, exports) {

$parcel$export(module.exports, "SpotlightTrigger", () => $85ecd6db921db13e$export$f12767f21e70382e);

var $5uXOq = parcelRequire("5uXOq");

var $cY2yS = parcelRequire("cY2yS");
const $85ecd6db921db13e$export$f12767f21e70382e = ({ id: id, children: children })=>{
    const [isTriggered] = (0, $cY2yS.useSpotlightTrigger)(id);
    return isTriggered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : null;
};

});

parcelRegister("2WDJ4", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $cd75cd51f8698b39$export$8a0b5f75aa4dc446);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $74BDp = parcelRequire("74BDp");
var $aI12f = parcelRequire("aI12f");

var $85qyr = parcelRequire("85qyr");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $3HwlS = parcelRequire("3HwlS");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");
const $cd75cd51f8698b39$var$addSearchPayload = (event)=>{
    try {
        const searchPayload = (0, $85qyr.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) // eslint-disable-next-line no-param-reassign
        event.payload.attributes = {
            ...event.payload.attributes,
            ...searchPayload
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('observability.analytics-providers-eoc.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
const $cd75cd51f8698b39$var$sendAnalyticsEvent = (event)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.sendEvent(event));
};
// A custom listener to send events from analyticsBridge channel. Using the analytics bridge on AFE code
// creates events in this channel, which we can then listen here and send.
const $cd75cd51f8698b39$var$EocAnalyticsListener = ({ children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)('serviceDesk');
    }, []);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        onEvent: (event)=>{
            // Mimic the behaviour on JFE, is this really necessary?
            const enrichedEvent = $cd75cd51f8698b39$var$addSearchPayload(event);
            $cd75cd51f8698b39$var$sendAnalyticsEvent((0, $lhVtI.getEvent)(enrichedEvent));
        },
        channel: "analyticsBridge"
    }, children);
};
const $cd75cd51f8698b39$export$8a0b5f75aa4dc446 = ({ children: children, packageName: packageName, teamName: teamName, config: config })=>{
    const flagService = (0, $pa9q9.useFlagService)();
    const isNewNavigation = (0, $3HwlS.getWillShowNav4)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74BDp.GlobalContextContainer), {
        config: {
            ...config,
            isNewNavigation: isNewNavigation
        },
        flagService: flagService,
        reporter: ({ id: id, error: reporterError })=>{
            const error = (0, $aI12f.isHTTPError)(reporterError) ? new (0, $jJZqs.default)(reporterError.response.status, reporterError.message, reporterError.response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, reporterError.response) : reporterError;
            (0, $jcw0u.default)({
                meta: {
                    id: id,
                    packageName: packageName,
                    teamName: teamName
                },
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd75cd51f8698b39$var$EocAnalyticsListener, null, children));
};

});

parcelRegister("dF4Di", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateWrapper", () => $33187c8ccf842c7e$export$808758a1c9216c53);

var $5uXOq = parcelRequire("5uXOq");

var $beRD7 = parcelRequire("beRD7");

var $8J6rn = parcelRequire("8J6rn");

var $13f5b = parcelRequire("13f5b");
const $33187c8ccf842c7e$export$808758a1c9216c53 = ({ children: children, loadingComponent: loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13f5b.ConsolidatedStateLoading), null), errorComponent: errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null) })=>{
    const { shouldUseJSM: shouldUseJSM, loading: loading, error: error } = (0, $8J6rn.useOgTenantInfo)();
    if (loading) return loadingComponent;
    if (error || !shouldUseJSM) return errorComponent;
    return children;
};

});
parcelRegister("13f5b", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateLoading", () => $b14022075e056ba2$export$bde5b6095281f205);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $eZJjh = parcelRequire("eZJjh");
const $b14022075e056ba2$export$bde5b6095281f205 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));

});


parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("kB0io", function(module, exports) {

$parcel$export(module.exports, "onCallLinks", () => $3bf12ca87a82bebc$export$69d5e3115c2e8c7b);
const $3bf12ca87a82bebc$export$69d5e3115c2e8c7b = {
    'on-call-schedules-empty-state': {
        iphId: '7KkB6nTIcLcVRC2T39y2xI',
        sacUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/how-do-on-call-schedules-work-in-operations/'
    }
};

});

parcelRegister("6Zx3E", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1c6f1ef0d13090e8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1c6f1ef0d13090e8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "eoc-on-call.title",
        "defaultMessage": "On Call - Operations"
    }
});

});

parcelRegister("fqpSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $417fe1a345fcf3a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $994MI = parcelRequire("994MI");

var $1QiBP = parcelRequire("1QiBP");


var $aSTVt = parcelRequire("aSTVt");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $1YWbH = parcelRequire("1YWbH");

var $fLcmv = parcelRequire("fLcmv");
const $417fe1a345fcf3a2$var$EditRotationTour = ({ stop: stop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const start = ()=>setActiveSpotlight(0);
    const next = ()=>setActiveSpotlight((activeSpotlight || 0) + 1);
    const back = ()=>setActiveSpotlight((activeSpotlight || 1) - 1);
    const end = ()=>setActiveSpotlight(null);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, []);
    const dismiss = ()=>{
        end();
        if (stop) stop();
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dismissButton'
        });
        (0, $8zOmE.fireUIAnalytics)(event);
    };
    const complete = ()=>{
        end();
        const event = createAnalyticsEvent({
            actionSubject: 'okButton',
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(event);
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "1/2",
                actions: [
                    {
                        onClick: next,
                        text: formatMessage((0, $1YWbH.commonMessages).next)
                    },
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).dismiss),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $fLcmv.messages).manageParticipantsTimings),
                target: (0, $aSTVt.SPOTLIGHT_NAMES).editRotationForm,
                key: (0, $aSTVt.SPOTLIGHT_NAMES).editRotationForm,
                dialogPlacement: "right top",
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.edit-rotation.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $fLcmv.messages).shiftParticipantsWillRotate)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "2/2",
                actions: [
                    {
                        onClick: complete,
                        text: formatMessage((0, $1YWbH.commonMessages).ok)
                    },
                    {
                        onClick: back,
                        text: formatMessage((0, $1YWbH.commonMessages).back),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $fLcmv.messages).previewScheduleChanges),
                target: (0, $aSTVt.SPOTLIGHT_NAMES).editModeSchedule,
                key: (0, $aSTVt.SPOTLIGHT_NAMES).editModeSchedule,
                targetRadius: 3,
                dialogPlacement: "right top",
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.edit-rotation.jira-spotlight.1",
                messageType: "engagement"
            }, formatMessage((0, $fLcmv.messages).previewAllowsToSeeChanges))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};
var $417fe1a345fcf3a2$export$2e2bcd8739ae039 = (0, $994MI.default)({
    source: 'OpsEditRotationSpotlightModal',
    tags: [
        'spotlight',
        'edit-rotation-spotlight'
    ]
})($417fe1a345fcf3a2$var$EditRotationTour);

});
parcelRegister("1YWbH", function(module, exports) {

$parcel$export(module.exports, "commonMessages", () => $df4189121b162b68$export$822cdd78febe6c96);

var $7VHMR = parcelRequire("7VHMR");
const $df4189121b162b68$export$822cdd78febe6c96 = (0, $7VHMR.defineMessages)({
    dismiss: {
        "id": "eoc-on-call.common.dismiss",
        "defaultMessage": "Dismiss"
    },
    learnMore: {
        "id": "eoc-on-call.common.learn-more",
        "defaultMessage": "Learn More"
    },
    next: {
        "id": "eoc-on-call.common.next",
        "defaultMessage": "Next"
    },
    ok: {
        "id": "eoc-on-call.common.ok",
        "defaultMessage": "OK"
    },
    back: {
        "id": "eoc-on-call.common.back",
        "defaultMessage": "Back"
    }
});

});

parcelRegister("fLcmv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cc7bf6c153ec3d00$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $cc7bf6c153ec3d00$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    manageParticipantsTimings: {
        "id": "eoc-on-call.tours.edit-rotation.manage-participants-timings",
        "defaultMessage": "Manage participants and timings"
    },
    shiftParticipantsWillRotate: {
        "id": "eoc-on-call.tours.edit-rotation.shift-participants-will-rotate",
        "defaultMessage": "Each people, team and escalation policy on this rotation is a shift participant. These will rotate with the time restrictions you provide."
    },
    previewScheduleChanges: {
        "id": "eoc-on-call.tours.edit-rotation.preview-schedule-changes",
        "defaultMessage": "Preview schedule changes before finalizing"
    },
    previewAllowsToSeeChanges: {
        "id": "eoc-on-call.tours.edit-rotation.preview-allows-to-see-changes",
        "defaultMessage": "The preview allows you to see how changes will impact the schedule, ensuring accurate coverage and avoiding conflicts."
    }
});

});


parcelRegister("faEY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fb38cc9e6021fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $994MI = parcelRequire("994MI");

var $1QiBP = parcelRequire("1QiBP");


var $cBr4z = parcelRequire("cBr4z");
var $ffQsw = parcelRequire("ffQsw");
var $aSTVt = parcelRequire("aSTVt");

var $cbdUv = parcelRequire("cbdUv");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $1YWbH = parcelRequire("1YWbH");

var $bNvwZ = parcelRequire("bNvwZ");

var $bpDU5 = parcelRequire("bpDU5");
const $80fb38cc9e6021fc$var$OnCallTour = ({ stop: stop })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isNewNavigation = (0, $3HwlS.getWillShowNav4)();
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(true);
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const start = ()=>{
        setActiveSpotlight(0);
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'spotlight'
        });
        (0, $8zOmE.fireScreenAnalytics)(analyticsEvent);
    };
    const next = ()=>{
        const current = (activeSpotlight || 0) + 1;
        setActiveSpotlight(current);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'nextButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            activeSpotlight: current + 1
        });
    };
    const back = ()=>{
        const current = (activeSpotlight || 1) - 1;
        setActiveSpotlight(current);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'backButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            activeSpotlight: current + 1
        });
    };
    const end = ()=>{
        setActiveSpotlight(null);
        if (stop) stop();
    };
    const dismiss = ()=>{
        end();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dismissButton'
        });
        const current = activeSpotlight || 0;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            activeSpotlight: current + 1
        });
    };
    const complete = ()=>{
        end();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'okButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    };
    const learnMore = ()=>{
        end();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'learnMoreButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "1/4",
                actions: [
                    {
                        onClick: next,
                        text: formatMessage((0, $1YWbH.commonMessages).next)
                    },
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).dismiss),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $bNvwZ.messages).sidebarTitle),
                target: (0, $cbdUv.SPOTLIGHT_NAMES).sidebarItems,
                key: (0, $cbdUv.SPOTLIGHT_NAMES).sidebarItems,
                dialogPlacement: isNewNavigation ? 'bottom left' : 'right top',
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.get-started.jira-spotlight",
                messageType: "transactional"
            }, formatMessage((0, $bNvwZ.messages).sidebarDescription)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "2/4",
                actions: [
                    {
                        onClick: next,
                        text: formatMessage((0, $1YWbH.commonMessages).next)
                    },
                    {
                        onClick: back,
                        text: formatMessage((0, $1YWbH.commonMessages).back),
                        appearance: 'subtle'
                    },
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).dismiss),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $bNvwZ.messages).routingRuleTitle),
                target: (0, $ffQsw.SPOTLIGHT_NAMES).lastEntity,
                key: (0, $ffQsw.SPOTLIGHT_NAMES).lastEntity,
                targetRadius: 3,
                messageId: "eoc-on-call.ui.tours.get-started.jira-spotlight.1",
                messageType: "transactional"
            }, formatMessage((0, $bNvwZ.messages).routingRuleDescription)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "3/4",
                actions: [
                    {
                        onClick: next,
                        text: formatMessage((0, $1YWbH.commonMessages).next)
                    },
                    {
                        onClick: back,
                        text: formatMessage((0, $1YWbH.commonMessages).back),
                        appearance: 'subtle'
                    },
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).dismiss),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $bNvwZ.messages).escalationPoliciesTitle),
                target: (0, $cBr4z.SPOTLIGHT_NAMES).firstEntity,
                key: (0, $cBr4z.SPOTLIGHT_NAMES).firstEntity,
                targetRadius: 3,
                messageId: "eoc-on-call.ui.tours.get-started.jira-spotlight.2",
                messageType: "transactional"
            }, formatMessage((0, $bNvwZ.messages).escalationPoliciesDescription)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "4/4",
                actions: [
                    {
                        onClick: complete,
                        text: formatMessage((0, $1YWbH.commonMessages).ok)
                    },
                    {
                        onClick: back,
                        text: formatMessage((0, $1YWbH.commonMessages).back),
                        appearance: 'subtle'
                    },
                    {
                        onClick: learnMore,
                        text: formatMessage((0, $1YWbH.commonMessages).learnMore),
                        appearance: 'subtle',
                        href: 'https://operations-help.atlassian.net/wiki/spaces/OPSHELP/pages/8290305/How+do+on-call+schedules+work+in+operations',
                        target: '_blank'
                    }
                ],
                heading: formatMessage((0, $bNvwZ.messages).scheduleTitle),
                target: (0, $aSTVt.SPOTLIGHT_NAMES).firstSchedule,
                key: (0, $aSTVt.SPOTLIGHT_NAMES).firstSchedule,
                targetRadius: 3,
                messageId: "eoc-on-call.ui.tours.get-started.jira-spotlight.3",
                messageType: "transactional"
            }, formatMessage((0, $bNvwZ.messages).scheduleDescription))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bpDU5.default), {
        isActive: isModalOpen,
        onStart: ()=>{
            start();
            setIsModalOpen(false);
        },
        onCancel: ()=>{
            end();
            setIsModalOpen(false);
        }
    }), renderActiveSpotlight());
};
var $80fb38cc9e6021fc$export$2e2bcd8739ae039 = (0, $994MI.default)({
    source: 'OpsDashboardSpotlightModal',
    tags: [
        'spotlight',
        'ops-dashboard'
    ]
})($80fb38cc9e6021fc$var$OnCallTour);

});
parcelRegister("cbdUv", function(module, exports) {

$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $dd972e7c34532966$export$a7c923252528b255);
const $dd972e7c34532966$export$a7c923252528b255 = {
    sidebarItems: 'eoc-team-dashboard_sidebar_items'
};

});

parcelRegister("bNvwZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ffb132b9eb86153c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ffb132b9eb86153c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sidebarTitle: {
        "id": "eoc-on-call.tours.get-started.sidebar-title",
        "defaultMessage": "Manage your team\u2019s operations"
    },
    sidebarDescription: {
        "id": "eoc-on-call.tours.get-started.sidebar-description",
        "defaultMessage": "This is where you'll find all the essential tools to manage your operations. Explore your team alerts, on-call schedules, integrations, and other configurations to set up your team for success."
    },
    routingRuleTitle: {
        "id": "eoc-on-call.tours.get-started.routing-rule-title",
        "defaultMessage": "Customize alert routes"
    },
    routingRuleDescription: {
        "id": "eoc-on-call.tours.get-started.routing-rule-description",
        "defaultMessage": "Improve alert response times by redirecting alerts to a more suitable escalation policy or schedule."
    },
    escalationPoliciesTitle: {
        "id": "eoc-on-call.tours.get-started.escalation-policies-title",
        "defaultMessage": "Select the next person to escalate the alert"
    },
    escalationPoliciesDescription: {
        "id": "eoc-on-call.tours.get-started.escalation-policies-description",
        "defaultMessage": "Set up rules if the alert doesn\u2019t get the necessary attention. Notify other people or an entire team and never miss a critical alert."
    },
    scheduleTitle: {
        "id": "eoc-on-call.tours.get-started.schedule-title",
        "defaultMessage": "Build flexible schedules for responsive teams"
    },
    scheduleDescription: {
        "id": "eoc-on-call.tours.get-started.schedule-description",
        "defaultMessage": "Create customized on-call scenarios with flexible rotation features. Ensure your team stays responsive and prepared at all times."
    }
});

});

parcelRegister("bpDU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfdb473014089206$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $994MI = parcelRequire("994MI");

var $evqT3 = parcelRequire("evqT3");
var $i8Qvm = parcelRequire("i8Qvm");

var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSPJO = parcelRequire("cSPJO");

var $7qlyt = parcelRequire("7qlyt");
const $cfdb473014089206$var$WelcomeModal = ({ isActive: isActive = true, onStart: onStart, onCancel: onCancel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleCancel = ()=>{
        onCancel();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'exploreButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    };
    const handleStart = ()=>{
        onStart();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'startButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evqT3.default), {
        actions: [
            {
                onClick: handleCancel,
                text: formatMessage((0, $7qlyt.default).explore),
                appearance: 'subtle'
            },
            {
                onClick: handleStart,
                text: formatMessage((0, $7qlyt.default).tour),
                appearance: 'primary'
            }
        ],
        heading: formatMessage((0, $7qlyt.default).title),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cSPJO))),
        key: "welcome"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $7qlyt.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
var $cfdb473014089206$export$2e2bcd8739ae039 = (0, $994MI.default)({
    source: 'OpsDashboardWelcomeModal'
})($cfdb473014089206$var$WelcomeModal);

});
parcelRegister("cSPJO", function(module, exports) {
module.exports = new URL("welcome.dfe59987.png", import.meta.url).toString();

});

parcelRegister("7qlyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc481454585a7bb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $edc481454585a7bb$var$commonMessages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "eoc-on-call.tours.get-started.welcome-modal.title-nonfinal",
        "defaultMessage": "Get started with your team\u2019s operation"
    },
    description: {
        "id": "eoc-on-call.tours.get-started.welcome-modal.description-nonfinal",
        "defaultMessage": "Congratulations! Your team is now fully equipped to respond to critical alerts. Check out your on-call schedule to review shift assignments, explore available integrations, and customize your operations to tailor it to your team's needs."
    },
    explore: {
        "id": "eoc-on-call.tours.get-started.welcome-modal.explore",
        "defaultMessage": "I\u2019ll explore myself"
    },
    tour: {
        "id": "eoc-on-call.tours.get-started.welcome-modal.tour",
        "defaultMessage": "Show me how"
    }
});
var $edc481454585a7bb$export$2e2bcd8739ae039 = $edc481454585a7bb$var$commonMessages;

});



parcelRegister("7mFD7", function(module, exports) {

$parcel$export(module.exports, "ListRotationTour", () => $647023b57598609e$export$55ad43e9ed88721c);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");


var $aSTVt = parcelRequire("aSTVt");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $1YWbH = parcelRequire("1YWbH");

var $ioeFX = parcelRequire("ioeFX");
const $647023b57598609e$export$55ad43e9ed88721c = ({ stop: stop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const start = ()=>setActiveSpotlight(0);
    const end = ()=>setActiveSpotlight(null);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, []);
    const dismiss = ()=>{
        end();
        if (stop) stop();
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actions: [
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).ok)
                    }
                ],
                heading: formatMessage((0, $ioeFX.messages).rotationsBuildSchedules),
                target: (0, $aSTVt.SPOTLIGHT_NAMES).firstListRotationItem,
                key: (0, $aSTVt.SPOTLIGHT_NAMES).firstListRotationItem,
                dialogPlacement: "right top",
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.list-rotation.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $ioeFX.messages).chooseToRotateShiftsMeetTeamsNeed))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};

});
parcelRegister("ioeFX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bbd81428f3c551ec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bbd81428f3c551ec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rotationsBuildSchedules: {
        "id": "eoc-on-call.tours.list-rotation.rotations-build-schedules",
        "defaultMessage": "Rotations build on-call schedules"
    },
    chooseToRotateShiftsMeetTeamsNeed: {
        "id": "eoc-on-call.tours.list-rotation.choose-to-rotate-shifts-meet-teams-need",
        "defaultMessage": "Choose to rotate shifts daily, weekly, or customize to meet your team's needs and ensure maximum coverage for alert response."
    }
});

});


parcelRegister("9H0Tc", function(module, exports) {

$parcel$export(module.exports, "RoutingRuleTour", () => $b4fbe3ee24789e83$export$328ef1b7a834513d);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");


var $ffQsw = parcelRequire("ffQsw");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $1YWbH = parcelRequire("1YWbH");

var $2Af8l = parcelRequire("2Af8l");
const $b4fbe3ee24789e83$export$328ef1b7a834513d = ({ stop: stop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const start = ()=>setActiveSpotlight(0);
    const next = ()=>setActiveSpotlight((activeSpotlight || 0) + 1);
    const back = ()=>setActiveSpotlight((activeSpotlight || 1) - 1);
    const end = ()=>setActiveSpotlight(null);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, []);
    const dismiss = ()=>{
        end();
        if (stop) stop();
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "1/2",
                actions: [
                    {
                        onClick: next,
                        text: formatMessage((0, $1YWbH.commonMessages).next)
                    },
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).dismiss),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $2Af8l.messages).filterAlertsTitle),
                target: (0, $ffQsw.SPOTLIGHT_NAMES).alertFilters,
                key: (0, $ffQsw.SPOTLIGHT_NAMES).alertFilters,
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.routing-rule.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $2Af8l.messages).filterAlertsDescription)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "2/2",
                actions: [
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).ok)
                    },
                    {
                        onClick: back,
                        text: formatMessage((0, $1YWbH.commonMessages).back),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $2Af8l.messages).timeRestrictionsTitle),
                target: (0, $ffQsw.SPOTLIGHT_NAMES).timeSlots,
                key: (0, $ffQsw.SPOTLIGHT_NAMES).timeSlots,
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.routing-rule.jira-spotlight.1",
                messageType: "engagement"
            }, formatMessage((0, $2Af8l.messages).timeRestrictionsDescription))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};

});
parcelRegister("2Af8l", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4708a8ec586ec33b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4708a8ec586ec33b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    filterAlertsTitle: {
        "id": "eoc-on-call.tours.routing-rule.filter-alerts-title",
        "defaultMessage": "Streamline routing"
    },
    filterAlertsDescription: {
        "id": "eoc-on-call.tours.routing-rule.filter-alerts-description",
        "defaultMessage": "Conditions make it easy to streamline routing for specific alerts. If you set no conditions, all the alerts will be routed."
    },
    timeRestrictionsTitle: {
        "id": "eoc-on-call.tours.routing-rule.time-restrictions-title",
        "defaultMessage": "Define time restrictions"
    },
    timeRestrictionsDescription: {
        "id": "eoc-on-call.tours.routing-rule.time-restrictions-description",
        "defaultMessage": "With time interval restrictions included in the rule, your alerts will be routed at the right time. Set up time restrictions for your business hours and off-hours, for instance."
    }
});

});


parcelRegister("2iuw3", function(module, exports) {

$parcel$export(module.exports, "ScheduleActionsTour", () => $be16fbc50d3a8d3e$export$a1f021922e3ddc1a);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");


var $aSTVt = parcelRequire("aSTVt");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $1YWbH = parcelRequire("1YWbH");

var $4feLY = parcelRequire("4feLY");
const $be16fbc50d3a8d3e$export$a1f021922e3ddc1a = ({ stop: stop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const start = ()=>setActiveSpotlight(0);
    const end = ()=>setActiveSpotlight(null);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, []);
    const dismiss = ()=>{
        end();
        if (stop) stop();
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actions: [
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).ok)
                    }
                ],
                heading: formatMessage((0, $4feLY.messages).scheduleActionsCloser),
                target: (0, $aSTVt.SPOTLIGHT_NAMES).firstScheduleActions,
                key: (0, $aSTVt.SPOTLIGHT_NAMES).firstScheduleActions,
                dialogPlacement: "bottom right",
                targetRadius: 6,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.schedule-actions.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $4feLY.messages).findAllScheduleManagement))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};

});
parcelRegister("4feLY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $81c99ef7795da743$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $81c99ef7795da743$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    scheduleActionsCloser: {
        "id": "eoc-on-call.tours.schedule-actions.schedule-actions-closer",
        "defaultMessage": "Schedule actions are closer"
    },
    findAllScheduleManagement: {
        "id": "eoc-on-call.tours.schedule-actions.find-all-schedule-management",
        "defaultMessage": "Find all schedule management actions in the actions menu. Quickly access your rotations by editing the schedule."
    }
});

});


parcelRegister("ksftx", function(module, exports) {

$parcel$export(module.exports, "ShiftTileTour", () => $ad3b36f80bd3eec9$export$7e135242500d18fe);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");


var $aSTVt = parcelRequire("aSTVt");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $1YWbH = parcelRequire("1YWbH");

var $cT389 = parcelRequire("cT389");
const $ad3b36f80bd3eec9$export$7e135242500d18fe = ({ stop: stop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const start = ()=>setActiveSpotlight(0);
    const end = ()=>setActiveSpotlight(null);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, []);
    const dismiss = ()=>{
        end();
        if (stop) stop();
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actions: [
                    {
                        onClick: dismiss,
                        text: formatMessage((0, $1YWbH.commonMessages).ok)
                    }
                ],
                heading: formatMessage((0, $cT389.messages).selectAnyShift),
                target: (0, $aSTVt.SPOTLIGHT_NAMES).shiftTile,
                key: (0, $aSTVt.SPOTLIGHT_NAMES).shiftTile,
                dialogPlacement: "top center",
                targetRadius: 6,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                messageId: "eoc-on-call.ui.tours.shift-tile.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $cT389.messages).viewSummaryOfShift))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};

});
parcelRegister("cT389", function(module, exports) {

$parcel$export(module.exports, "messages", () => $48306f27e437e264$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $48306f27e437e264$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    selectAnyShift: {
        "id": "eoc-on-call.tours.shift-tile.select-any-shift",
        "defaultMessage": "Select any shift to view more"
    },
    viewSummaryOfShift: {
        "id": "eoc-on-call.tours.shift-tile.view-summary-of-shift",
        "defaultMessage": "View a summary of the shift and its participants. You can also add an override if necessary."
    }
});

});




//# sourceMappingURL=async-jira-eoc-on-call.f812b5ff.js.map
